import AmberwoodSplash from './components/amberwood/AmberwoodSplash';
import AmberwoodResearchBanner, { amberwoodBannerBedrooms } from './components/amberwood/AmberwoodResearchBanner';
import { isAmberwoodBannerSnoozed, snoozeAmberwoodBanner } from './components/amberwood/amberwoodVisits';
import AgentAchievementsDialog from './dialogs/admin/AgentAchievementsDialog';
import React, { useState, useEffect, useMemo, useCallback, useRef, Fragment } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  FormControl,
  Autocomplete,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Pagination,
  CircularProgress,
  LinearProgress,
  Alert,
  Grid,
  Card,
  CardContent,
  Chip,
  IconButton,
  Popover,
  ToggleButton,
  ToggleButtonGroup,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tabs,
  Tab,
  Fab,
  Badge,
  Avatar,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Menu,
  Switch,
  Slider,
  Select,
  MenuItem,
  InputLabel,
  useMediaQuery,
  Collapse,
  Backdrop,
} from '@mui/material';
// Leaflet imports moved to ProjectMap component
import {
  Menu as MenuIcon,
  FilterList as FilterIcon,
  AutoAwesomeMosaic as AutoAwesomeMosaicIcon,
  ViewInAr as ViewInArIcon,
  HighlightAlt as HighlightAltIcon,
  FlightTakeoff as FlightTakeoffIcon,
  WbSunny as WbSunnyIcon,
  ThumbUp as ThumbUpIcon,
  LocalOffer as LocalOfferIcon,
  IosShare as IosShareIcon,
  ViewModule as ViewModuleIcon,
  TableRows as TableRowsIcon,
  Close as CloseIcon,
  AutoAwesome as AutoAwesomeIcon,
  Image as ImageIcon,
  HelpOutline as HelpOutlineIcon,
  ExpandMore as ExpandMoreIcon,
  LocationOn as LocationOnIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  ShoppingCart as ShoppingCartIcon,
  Bookmark as BookmarkIcon,
  Edit as EditIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Visibility as VisibilityIcon,
  Add as AddIcon,
  Tune as TuneIcon,
  Layers as LayersIcon,
  Percent as PercentIcon,
  TravelExplore as TravelExploreIcon,
  Search as SearchIcon,
  Bed as BedIcon,
  Thermostat as ThermostatIcon,
  Apartment as ApartmentIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  Download as DownloadIcon,
  People as PeopleIcon,
  Equalizer as EqualizerIcon,
  ForwardToInbox as ForwardToInboxIcon,
  Link as LinkIcon,
  Sync as SyncIcon,
  Info as InfoIcon,
  PictureAsPdf as PictureAsPdfIcon,
  ArrowDropDown as ArrowDropDownIcon,
  RotateLeft as RotateLeftIcon,
  RotateRight as RotateRightIcon,
  Flip as FlipIcon,
  EmojiEvents as EmojiEventsIcon,
  Map as MapIcon,
  AccountBalance as AccountBalanceIcon,
  VerifiedUser as VerifiedUserIcon,
  School as SchoolIcon,
  FactCheck as FactCheckIcon,
  QueryStats as QueryStatsIcon,
  Groups as GroupsIcon,
  Campaign as CampaignIcon,
  Chat as ChatIcon,
  PhoneInTalk as PhoneInTalkIcon,
  EventNote as EventNoteIcon,
  ScheduleRounded as ScheduleRoundedIcon,
  TrendingDown as TrendingDownIcon,
  TrendingUp as TrendingUpIcon,
  Savings as SavingsIcon,
  Podcasts as PodcastsIcon,
  VideoLibrary as VideoLibraryIcon,
  OndemandVideo as OndemandVideoIcon,
  VpnKey as VpnKeyIcon,
} from '@mui/icons-material';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { api, signedFetch, ComparableUnit, ReferenceUnit, ProjectDetails, TowerViewUnit, TopViewingReferenceUnit, SitePlanData, AmenitiesResponse, PriceHistoryResponse, ClientProfile, ClientChoiceUnit, ProjectMembersResponse, ProjectMemberInfo, ShortlistItem, ProjectSheetConfigItem, ProjectUnitOption, BestByUnitTypeResponse, MasterToolSearchFilters, MasterToolUnit, TopViewingSitePlan, ProjectCategoryOption, MasterToolProjectResult, AdminUserAccess, CurrentUser, ProjectFactsheet, ProjectBrochure, ProjectEdmFile, ProjectEbookFile, PriceMatrixSimulationResponse, PriceMatrixSimulationUnit, ThumbsupUnit, PricePromoUnit, PricePromoRevealState, PricePromoWatchlist, PricePromoWatchlistInput, AnticipatePricePromo, AnticipatePricePromoInput, AnticipatePricePromoInterestInput, DistrictOption, ProjectFileConfig, ProjectMediaItem, RegistrationEventSummary, ProjectCommissionStructure, SuperShowcase, SuperShowcaseHotspot, SuperShowcaseRegion, LiveQueueSummary } from './services/api';
import { DownloadFileRow, type DownloadFileRowProps } from './components/file/fileVisuals';
import { buildBestByUnitTypeFromTowerUnits } from './components/siteplan/bestByUnitTypeFromTowerUnits';
import {
  getLatestValidViewedThumbsupUnit,
  persistThumbsupViewedHistory,
  readThumbsupViewedHistory,
  saveViewedThumbsupUnit,
} from './thumbsupLastViewed';
import { ThumbsupHowItWorksBanner, ThumbsupHowItWorksOverlay } from './components/thumbsup/ThumbsupHowItWorks';
import type { RevealOrigin } from './components/thumbsup/ThumbsupHowItWorks';
import { calculateOutlay } from '../utils/stampDutyRates';
import { getDevCea } from './services/auth';
import {
  initAnalytics,
  setAnalyticsCea,
  logMainPageViewed,
  logMenuClick,
  logRegisterForTrainingClick,
  logComparableSearch,
  logProjectResearchTabViewed,
  logProjectResearchSearchSubmitted,
  logProjectResearchSearchResults,
  logProjectResearchResultProject,
  logProjectResearchViewModeChanged,
  logProjectResearchProjectExpanded,
  logProjectResearchSortChanged,
  logProjectResearchFilterChanged,
  logProjectResearchExport,
  logProjectViewed,
  logReferenceUnitSet,
  logCompareAdd,
  logFloorPlanOpened,
  logFloorPlan3dOpened,
  logFloorPlanComparisonOpened,
  logShortlistAdd,
  logShortlistRemove,
  logTowerViewOpened,
  logSitePlanOpened,
  logSitePlanComparisonOpened,
  logThumbsupUnitsOpened,
  logThumbsupUnitSelected,
  logPricePromoUnitsOpened,
  logPricePromoUnitSelected,
  logPricePromoChartOpened,
  logSuperShowcaseOpened,
  logSuperShowcaseViewed,
  logSuperShowcaseHotspotClicked,
  logSuperShowcaseShared,
} from './services/analytics';
import { useTheme } from '../theme/ThemeProvider';
import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  BarChart,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend as RechartsLegend,
  ResponsiveContainer,
} from 'recharts';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { generatePDFReport } from '../utils/pdfGenerator';
import { generateProjectReport, ProjectReportData, TowerViewGridCell } from '../utils/projectReportGenerator';
import { generateFloorPlanComparisonPdf } from '../utils/floorPlanComparisonPdf';
import { generateUnitFloorPlanPdf } from '../utils/unitFloorPlanPdf';
import { searchProjects } from './utils/projectSearch';
import { exportProjectResearchPdf } from '../utils/projectResearchPdfExport';
import { isUnitStatusNotReleased } from '../utils/formatting';
import html2canvas from 'html2canvas';
import { ProjectMap, DemandSupplyPanel, DemandSupplyMap } from './components/map';
import { ProjectDetailsTab, SelectedDemandSupplyTypes } from '../types';
import { CART_FAB_GLOW_SX, NewBadge, TAB_NEW_BADGE_SX } from './components/common';
import { DemandSupplyResponse } from './services/api';
import { AppHeader } from './components/header';
import { SidebarNavigation, NavigationGroup } from './components/sidebar';
import { AnalyticsDashboardDialog, ProjectEssentialsAnalyticsDialog, ManageEventsDialog, CommunicationTrackingDialog, ManageSiteMapDialog, ManageShareLinksDialog, ManageSuperShowcaseDialog, Manage3dSitemapDialog, ManageDroneViewDialog, ManageFloorPlanNorthDialog } from './dialogs/admin';
import TrainerManageEventsDialog from './dialogs/admin/TrainerManageEventsDialog';
import ShareExternalUserFab from './components/share/ShareExternalUserFab';
import SuperPickerChatFab from './components/chat/SuperPickerChatFab';
import LiveQueuePill from './components/live-queue/LiveQueuePill';
import ProjectVerificationDialog from './dialogs/others/ProjectVerificationDialog';
import ProjectActionDialog from './dialogs/others/ProjectActionDialog';
import ManageProjectMessagesDialog from './dialogs/others/ManageProjectMessagesDialog';
import MyPodcastsDialog from './dialogs/others/MyPodcastsDialog';
import ManagePodcastVideosDialog from './dialogs/admin/ManagePodcastVideosDialog';
import LeaderVerificationDialog from './dialogs/others/LeaderVerificationDialog';
import AcceleratorGrantAccessDialog from './dialogs/others/AcceleratorGrantAccessDialog';
import CpdAnalyticsDialog from './dialogs/others/CpdAnalyticsDialog';
import TeamCpdDialog from './dialogs/others/TeamCpdDialog';
import LeaderStatisticsDialog from './dialogs/statistics/LeaderStatisticsDialog';
import ProjectHeadStatisticsDialog from './dialogs/statistics/ProjectHeadStatisticsDialog';
import DistinctiveDialog from './dialogs/others/DistinctiveDialog';
import CommissionStructureDialog from './dialogs/others/CommissionStructureDialog';
import ManageConnectorScheduleDialog from './dialogs/others/ManageConnectorScheduleDialog';
import EventRegistrationDialog from '../common/dialogs/EventRegistrationDialog';
import { getAttendanceCoordinatesWithRetry } from '../common/utils/attendanceGeolocation';
import { SuccessCloserTab } from './components/success-closer';
import { MySharableLinksTab } from './components/share-links';
import MarketingMaterialsTab from './components/marketing/MarketingMaterialsTab';
import PodcastVideosTab from './components/podcast/PodcastVideosTab';
import { MapResearchTab } from './components/map-research';
import { BestPricePromoShareDialog, BinocularsIcon, PricePromoPriceButton, PricePromoEarlyAccessOverlay, PricePromoShareTab, PricePromoTableView, PricePromoWatchlistDialog, getWatchlistMatches, getWatchlistsWithNewMatches, toBestPricePromoRows, formatSavingCompact } from './components/price-promo';
import type { PricePromoWatchlistDialogTab } from './components/price-promo';
import { SuperShowcaseDialog, RegionMarketComparisonDialog } from './components/showcase';
import { Sitemap3dDialog } from './components/sitemap3d';
import { getLinkUrl, getProjectResearchConfig } from './components/showcase/showcaseActions';
import { SituationMapTab } from './components/situation-map';
import { ReferenceUnitCard } from './components/reference';
import { InputSection } from './components/input';
import { TopViewingSitePlanDetail } from './components/siteplan';
import SitePlanCardThumbnail from './components/siteplan/SitePlanCardThumbnail';
import SitePlanTutorial, { SITE_PLAN_TUTORIAL_STORAGE_KEY } from './components/siteplan/SitePlanTutorial';
import { useTouchClick, useIsMobile } from './components/siteplan/TopViewingSitePlanDetail/mobile-hooks';
import { focusCompareSitePlanMarker, getCompareSitePlanMarkerElementId } from './components/siteplan/compareSitePlanAutoFocus';
import type { CompareSitePlanZoomToElement } from './components/siteplan/compareSitePlanAutoFocus';
import { captureComparePanel, loadSitePlanImageDataUrl, renderSitePlanWithMarker } from './components/siteplan/compareSitePlanPdfCapture';
import {
  formatOnemapLocationLabel,
  parseOnemapCoordinates,
  searchOnemapLocations,
  type OneMapSearchResult,
} from './utils/onemapLocationSearch';
import { DrawableFloorPlan, DrawingToolbar } from './components/floorplan';
import type { DrawToolbarState, DrawingStatesMap, Stroke } from './components/floorplan';
// Formatting functions are defined locally in this file
import '../App.css';

const SolarFloorPlan = React.lazy(() => import('./components/floorplan/SolarFloorPlan'));

const PROJECT_VIEW_COLUMN_KEYS = ['projectName', 'projectCategory', 'district', 'region', 'distance', 'districtLocation', 'nearestMrt', 'walkingTimeToMrt', 'tenure', 'developer', 'totalUnits', 'soldUnits', 'completedDate', 'br1avail', 'br1price', 'br1psf', 'br2avail', 'br2price', 'br2psf', 'br3avail', 'br3price', 'br3psf', 'br4avail', 'br4price', 'br4psf', 'br5avail', 'br5price', 'br5psf', 'phavail', 'phprice', 'phpsf'] as const;
const PROJECT_VIEW_PRE_MATCHED_INDEX = 2; // Matched columns insert after projectCategory
const PROJECT_VIEW_NUMERIC_COLUMNS = new Set(['distance', 'totalUnits', 'soldUnits', 'walkingTimeToMrt', 'br1avail', 'br1price', 'br1psf', 'br2avail', 'br2price', 'br2psf', 'br3avail', 'br3price', 'br3psf', 'br4avail', 'br4price', 'br4psf', 'br5avail', 'br5price', 'br5psf', 'phavail', 'phprice', 'phpsf']);
const MASTER_TOOL_PROJECT_VIEW_COLUMN_KEYS = ['projectName', 'projectCategory', 'referenceDistanceKm', 'developer', 'totalUnits', 'soldUnits', 'districtLocation', 'district', 'region', 'nearestMrt', 'walkingTimeToMrt', 'tenure', 'topDate', 'completedDate', 'br1avail', 'br1price', 'br1psf', 'br2avail', 'br2price', 'br2psf', 'br3avail', 'br3price', 'br3psf', 'br4avail', 'br4price', 'br4psf', 'br5avail', 'br5price', 'br5psf', 'phavail', 'phprice', 'phpsf'] as const;
const MASTER_TOOL_PROJECT_MATCHED_COLUMN_KEYS = ['matchedTotal', 'matchedBr1', 'matchedBr2', 'matchedBr3', 'matchedBr4', 'matchedBr5', 'matchedPh'] as const;
const MASTER_TOOL_PROJECT_MATCHED_FROM_COLUMN_KEYS = ['matchedBr1From', 'matchedBr2From', 'matchedBr3From', 'matchedBr4From', 'matchedBr5From', 'matchedPhFrom'] as const;
const MASTER_TOOL_PROJECT_DEFAULT_HIDDEN_COLUMNS = new Set<string>(MASTER_TOOL_PROJECT_MATCHED_FROM_COLUMN_KEYS);
const MASTER_TOOL_PROJECT_FILTER_SORT_COLUMN_KEYS = [
  ...MASTER_TOOL_PROJECT_VIEW_COLUMN_KEYS,
  ...MASTER_TOOL_PROJECT_MATCHED_COLUMN_KEYS,
  ...MASTER_TOOL_PROJECT_MATCHED_FROM_COLUMN_KEYS,
] as const;
const MASTER_TOOL_MATCHED_BR_BUCKETS = ['br1', 'br2', 'br3', 'br4', 'br5', 'ph'] as const;
const MASTER_TOOL_MATCHED_FROM_COLUMN_BY_BUCKET: Record<typeof MASTER_TOOL_MATCHED_BR_BUCKETS[number], typeof MASTER_TOOL_PROJECT_MATCHED_FROM_COLUMN_KEYS[number]> = {
  br1: 'matchedBr1From',
  br2: 'matchedBr2From',
  br3: 'matchedBr3From',
  br4: 'matchedBr4From',
  br5: 'matchedBr5From',
  ph: 'matchedPhFrom',
};
const MASTER_TOOL_MATCHED_COUNT_COLUMN_BY_BUCKET: Record<typeof MASTER_TOOL_MATCHED_BR_BUCKETS[number], typeof MASTER_TOOL_PROJECT_MATCHED_COLUMN_KEYS[number]> = {
  br1: 'matchedBr1',
  br2: 'matchedBr2',
  br3: 'matchedBr3',
  br4: 'matchedBr4',
  br5: 'matchedBr5',
  ph: 'matchedPh',
};
const formatMasterToolMatchedFromPrice = (price: number | null | undefined): string => (
  price != null && Number(price) > 0 ? `$${Number(price).toLocaleString()}` : '-'
);
const MASTER_TOOL_UNIT_COLUMN_KEYS = ['projectName', 'projectCategory', 'unitNumber', 'blockNumber', 'floor', 'stack', 'bedroom', 'bathroom', 'areaSqft', 'price', 'dps', 'psf', 'outlay', 'installment', 'district', 'districtLocation', 'region', 'nearestMrt', 'walkingTimeToMrt', 'tenure', 'topYear'] as const;
const MASTER_TOOL_PROJECT_DETAILS_COLUMN_KEYS = ['projectName', 'projectCategory', 'developer', 'totalUnits', 'soldUnits', 'districtLocation', 'district', 'region', 'nearestMrt', 'walkingTimeToMrt', 'tenure', 'topDate', 'completedDate'] as const;
/** Project Research PDF: max rows per export; above these limits, export is blocked. */
const PDF_EXPORT_MAX_RECORDS_BY_VIEW = {
  project: 1200,
  unit: 50,
} as const;
/** Above this count, user must confirm and is limited to one such PDF export per calendar day (localStorage). */
const PDF_EXPORT_LARGE_THRESHOLD = 1000;
const PDF_LARGE_EXPORT_DATE_STORAGE_KEY = 'superPicker_projectResearch_pdfLargeExportDate_v1';
/** Price Promo update identities acknowledged by clicking the compact sidebar tag. */
const PRICE_PROMO_UPDATE_ACK_STORAGE_KEY = 'superPicker_pricePromoUpdate_acknowledged_v1';
/** Anticipate price promo ids the agent has read — JSON number[]; unseen ids drive the sidebar notification. */
const ANTICIPATE_PRICE_PROMO_SEEN_STORAGE_KEY = 'superPicker_anticipatePricePromo_seenIds_v1';

function loadAcknowledgedPricePromoUpdates(): Set<string> {
  try {
    const raw = localStorage.getItem(PRICE_PROMO_UPDATE_ACK_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []);
  } catch {
    return new Set();
  }
}

function persistAcknowledgedPricePromoUpdates(keys: string[]): void {
  try {
    localStorage.setItem(PRICE_PROMO_UPDATE_ACK_STORAGE_KEY, JSON.stringify(keys));
  } catch {
    /* best effort */
  }
}

function loadAnticipateSeenIds(): Set<number> {
  try {
    const raw = localStorage.getItem(ANTICIPATE_PRICE_PROMO_SEEN_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.filter((v) => Number.isInteger(v)) : []);
  } catch {
    return new Set();
  }
}

function persistAnticipateSeenIds(ids: Set<number>): void {
  try {
    localStorage.setItem(ANTICIPATE_PRICE_PROMO_SEEN_STORAGE_KEY, JSON.stringify(Array.from(ids)));
  } catch {
    /* best effort */
  }
}
/** Hide Project Research Export CSV (feature off). */
const SHOW_PROJECT_RESEARCH_EXPORT_CSV = false;

/**
 * Amberwood at Holland splash and its admin replay tab — paused for now, kept for an
 * upcoming relaunch. Flip to true to bring both back. (The Project Research banner is separate.)
 */
const SHOW_AMBERWOOD_SPLASH = true;
type MasterToolProjectExpandBucket = 'total' | 'br1' | 'br2' | 'br3' | 'br4' | 'br5' | 'ph';
type MasterToolExpandUnitRow = MasterToolUnit & {
  computedFloor: number | null;
  computedStack: number | null;
  outlay: number;
  installment: number;
};

const MASTER_TOOL_PROJECT_VIEW_NUMERIC_COLUMNS = new Set<string>([
  ...[...MASTER_TOOL_PROJECT_VIEW_COLUMN_KEYS, ...MASTER_TOOL_PROJECT_MATCHED_COLUMN_KEYS].filter((key) => (
    key === 'totalUnits' ||
    key === 'soldUnits' ||
    key === 'referenceDistanceKm' ||
    key === 'walkingTimeToMrt' ||
    key === 'topDate' ||
    key === 'br1avail' ||
    key === 'br1price' ||
    key === 'br1psf' ||
    key === 'br2avail' ||
    key === 'br2price' ||
    key === 'br2psf' ||
    key === 'br3avail' ||
    key === 'br3price' ||
    key === 'br3psf' ||
    key === 'br4avail' ||
    key === 'br4price' ||
    key === 'br4psf' ||
    key === 'br5avail' ||
    key === 'br5price' ||
    key === 'br5psf' ||
    key === 'phavail' ||
    key === 'phprice' ||
    key === 'phpsf' ||
    key === 'matchedTotal' ||
    key === 'matchedBr1' ||
    key === 'matchedBr2' ||
    key === 'matchedBr3' ||
    key === 'matchedBr4' ||
    key === 'matchedBr5' ||
    key === 'matchedPh'
  )),
  ...MASTER_TOOL_PROJECT_MATCHED_FROM_COLUMN_KEYS,
]);
const PROJECT_VIEW_DISTRICT_OPTIONS = Array.from({ length: 28 }, (_, i) => `District ${i + 1}`);
const TOP_VIEWING_SITE_PLANS_TAB = 'topSitePlans';
const MARKETING_MATERIALS_TAB = 'marketing-materials';
const PODCAST_VIDEOS_TAB = 'podcast-videos';
const INSTITUTION_POWER_IMAGE_URL =
  'https://firebasestorage.googleapis.com/v0/b/transformation-office.firebasestorage.app/o/misc%2Fhuttons-institution-power.PNG?alt=media&token=4c9def41-f9a6-4564-8590-3b712c0cb47c';
const MY_SHARABLE_LINKS_TAB = 'my-sharable-links';
/** `?redirect=` values for My Shareable Links; the old "sharable" spelling stays for links already sent out. */
const SHAREABLE_REDIRECTS = ['shareable', 'sharable', 'shareable-links', 'sharable-links'];
/** The redirects that also roll the launch page down. */
const SHAREABLE_INTRO_REDIRECTS = ['shareable-links', 'sharable-links'];
/** `?tab=` slug for each top-menu tab, so the URL follows the menu and survives reloads. */
const TOOL_TAB_URL_SLUGS: Record<string, string> = {
  [TOP_VIEWING_SITE_PLANS_TAB]: 'site-plans',
  master: 'project-research',
  'map-research': 'good-deals-map',
  'success-closer': 'success-closer',
  [MY_SHARABLE_LINKS_TAB]: 'sharable',
  generic: 'find-units',
  [MARKETING_MATERIALS_TAB]: 'project-essentials',
  [PODCAST_VIDEOS_TAB]: 'podcast-videos',
};
const toolTabFromUrlSlug = (slug: string | null): string | null =>
  Object.keys(TOOL_TAB_URL_SLUGS).find((id) => TOOL_TAB_URL_SLUGS[id] === slug) ?? null;
const MASTER_TOOL_TABLE_FILTER_DEBOUNCE_MS = 350;
/** Debounce min/max text in Top Viewing comparable column filters so typing (e.g. 1140) does not apply partial values (114). */
const TOP_VIEWING_COMP_RANGE_DEBOUNCE_MS = 350;
const SHOW_TOP_VIEWING_PDF_EXPORT_FAB = false;
const PRICE_MATRIX_SIMULATION_STORAGE_PREFIX = 'superPicker:priceMatrixSimulation';
type ManageUsersTab = 'pending' | 'approved' | 'rejected_rejoined' | 'rejected_never';

type PriceMatrixSimulationSession = {
  projectId: string;
  sheetId: string;
  sheetUrl: string | null;
  sheetName?: string | null;
  units: PriceMatrixSimulationUnit[];
  matchedUnits: number;
  unmatchedUnits: string[];
  statusOverrides: Record<string, string | null>;
  updatedAt: string;
  syncEnabled: boolean;
};

const getPriceMatrixSimulationStorageKey = (ceaNumber: string, projectId: string) =>
  `${PRICE_MATRIX_SIMULATION_STORAGE_PREFIX}:${ceaNumber}:${projectId}`;

const useDebouncedValue = <T,>(value: T, delay: number = 300): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      window.clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
};

type ColumnVisibilityState = Record<string, boolean>;

interface ColumnVisibilityMenuProps {
  anchorEl: HTMLElement | null;
  columns: readonly string[];
  getLabel: (column: string) => string;
  isColumnChecked?: (column: string) => boolean;
  onClose: () => void;
  onOpen: (event: React.MouseEvent<HTMLElement>) => void;
  onPresetSelect?: () => void;
  presetLabel?: string;
  presetChecked?: boolean;
  onReset: () => void;
  onToggle: (column: string) => void;
  visibility: ColumnVisibilityState;
}

const ColumnVisibilityMenu: React.FC<ColumnVisibilityMenuProps> = ({
  anchorEl,
  columns,
  getLabel,
  isColumnChecked,
  onClose,
  onOpen,
  onPresetSelect,
  presetLabel,
  presetChecked,
  onReset,
  onToggle,
  visibility,
}) => (
  <>
    <Button size="small" variant="outlined" onClick={onOpen}>
      Columns
    </Button>
    <Menu
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Box sx={{ minWidth: 220, px: 1.5, py: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            Show Columns
          </Typography>
          <Button size="small" onClick={onReset}>
            Reset
          </Button>
        </Box>
        <Divider sx={{ mb: 1 }} />
        <FormGroup>
          {onPresetSelect && presetLabel && (
            <FormControlLabel
              control={(
                <Checkbox
                  size="small"
                  checked={Boolean(presetChecked)}
                  onChange={() => onPresetSelect()}
                />
              )}
              label={<Typography variant="body2" sx={{ fontWeight: 600 }}>{presetLabel}</Typography>}
              sx={{ my: 0.25 }}
            />
          )}
          {columns.map((column) => (
            <FormControlLabel
              key={column}
              control={(
                <Checkbox
                  size="small"
                  checked={isColumnChecked ? isColumnChecked(column) : visibility[column] !== false}
                  onChange={() => onToggle(column)}
                />
              )}
              label={<Typography variant="body2">{getLabel(column)}</Typography>}
              sx={{ my: 0.25 }}
            />
          ))}
        </FormGroup>
      </Box>
    </Menu>
  </>
);

const CompareSitePlanAutoFocus: React.FC<{
  enabled: boolean;
  markerElementId: string;
  focusKey: string;
  zoomToElement: CompareSitePlanZoomToElement;
}> = ({ enabled, markerElementId, focusKey, zoomToElement }) => {
  const zoomToElementRef = useRef(zoomToElement);

  useEffect(() => {
    zoomToElementRef.current = zoomToElement;
  }, [zoomToElement]);

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;
    let firstFrame = 0;
    let secondFrame = 0;

    firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(() => {
        if (!cancelled) {
          focusCompareSitePlanMarker(markerElementId, zoomToElementRef.current);
        }
      });
    });

    return () => {
      cancelled = true;
      window.cancelAnimationFrame(firstFrame);
      window.cancelAnimationFrame(secondFrame);
    };
  }, [enabled, markerElementId, focusKey]);

  return null;
};

/** Second footer line on every price-promo share image / sheet. */
const PROMO_AGENCY_LINE = 'Huttons Asia Pte Ltd · L3008899K';
export function SuperPickerApp() {
  const { currentTheme, setTheme } = useTheme();
  const isMobile = useIsMobile();
  const [projects, setProjects] = useState<string[]>([]);
  // Direct project/event links and embedded views retain their uninterrupted entry flow.
  const [allowAmberwoodSplash] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return !['projectId', 'ecoPropId', 'ecopropid', 'redirect', 'eventId', 'from'].some((key) => params.has(key));
  });
  const [amberwoodReplayToken, setAmberwoodReplayToken] = useState(0);
  const referenceUnitCardRef = useRef<HTMLDivElement>(null);
  const choiceTabsRef = useRef<HTMLDivElement>(null);
  
  // Sidebar state
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [activeNavItem, setActiveNavItem] = useState<string>('interests');
  
  // Tab navigation state (needed before tab state management)
  const [activeTabId, setActiveTabId] = useState<string>(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('redirect') === 'my-transactions') return 'success-closer';
    // ?redirect=shareable opens My Shareable Links (?redirect=shareable-links also rolls its launch
    // page down); external users are bounced back to Site Plans by the access guard once the session loads.
    if (SHAREABLE_REDIRECTS.includes(params.get('redirect') ?? '')) return MY_SHARABLE_LINKS_TAB;
    // htns.sg/super-picker?projectId=xxxx (forwarded through SSO) opens Site Plans by default
    return toolTabFromUrlSlug(params.get('tab')) ?? TOP_VIEWING_SITE_PLANS_TAB;
  });

  // ?redirect=shareable-links lands on My Shareable Links with the launch page already rolling
  // down (a lone `redirect` value survives SSO forwarding; an extra param does not).
  // One-shot: cleared once the tab has played it.
  const [sharableIntroAutoOpen, setSharableIntroAutoOpen] = useState(
    () => SHAREABLE_INTRO_REDIRECTS.includes(new URLSearchParams(window.location.search).get('redirect') ?? ''),
  );

  // Deep-link: htns.sg/super-picker?projectId=xxxx → open project detail after site plans load
  const [deepLinkProjectId, setDeepLinkProjectId] = useState<string | null>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('projectId')?.trim() || null;
  });
  // Opened from Project Essential "View in Super Picker" — hide chrome and return there.
  const [fromProjectEssential] = useState<boolean>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('from') === 'project-essential';
  });
  const [deepLinkEcoPropId] = useState<string | null>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('ecoPropId')?.trim() || params.get('ecopropid')?.trim() || null;
  });

  // Detect redirect=my-transactions from EDM link to auto-open transactions dialog
  const [autoOpenTransactions] = useState<boolean>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect') === 'my-transactions';
  });

  const [autoOpenTrainingReviews] = useState<boolean>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect') === 'training-reviews';
  });

  // EDM deep-link: ?redirect=training&eventId=XXX opens the training dialog
  // and auto-opens the inner Confirm Registration / Training Details dialog
  // for the matching event. The dialog will auto-toggle "Show Other Trainings"
  // if the event isn't in the user's primary category, so project-specific
  // training events surface correctly without a separate dialog.
  const [autoOpenTrainingEventId] = useState<string | null>(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('redirect') !== 'training') return null;
    return (params.get('eventId') || '').trim() || null;
  });

  // Detect redirect=project-verification-all to auto-open Project Verification on the All Projects tab
  const [autoOpenProjectVerificationAll] = useState<boolean>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect') === 'project-verification-all';
  });

  // Detect redirect=project-verification to auto-open Project Verification on the My Projects tab
  const [autoOpenProjectVerificationMine] = useState<boolean>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect') === 'project-verification';
  });

  // Detect redirect=price-promo from EDM link to auto-open the Price Promo Units dialog
  const [autoOpenPricePromo] = useState<boolean>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect') === 'price-promo';
  });

  // Detect redirect=cpd to auto-open the CPD Analytics dialog.
  // It is admin-only; non-admins get no effect and land on Site Plans as usual.
  const [autoOpenCpdAnalytics] = useState<boolean>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect') === 'cpd';
  });

  // Detect redirect=anticipate-blinker — prefer P2510001 (3BR → 2BR), else a
  // random project/unit as the Anticipate Blinker Unit.
  const [autoOpenAnticipateBlinker] = useState<boolean>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirect') === 'anticipate-blinker';
  });
  
  // Tab-specific state management
  interface TabState {
    selectedProject: string;
    unitNumber: string;
    projectUnits: ProjectUnitOption[];
    projectUnitsLoading: boolean;
    projectDetails: ProjectDetails | null;
    projectDetailsLoading: boolean;
    projectSectionExpanded: boolean;
    loading: boolean;
    error: string | null;
    referenceUnit: ReferenceUnit | null;
    comparableUnits: ComparableUnit[];
    originalComparableUnits: ComparableUnit[];
    areaTolerancePercent: number;
  }

  const [tabStates, setTabStates] = useState<Map<string, TabState>>(new Map());
  
  // Helper to get default tab state
  const getDefaultTabState = useCallback((): TabState => ({
    selectedProject: '',
    unitNumber: '',
    projectUnits: [],
    projectUnitsLoading: false,
    projectDetails: null,
    projectDetailsLoading: false,
    projectSectionExpanded: false,
    loading: false,
    error: null,
    referenceUnit: null,
    comparableUnits: [],
    originalComparableUnits: [],
    areaTolerancePercent: 0,
  }), []);

  // Helper to update tab state
  const updateTabState = useCallback((tabId: string, updates: Partial<TabState>) => {
    setTabStates((prev) => {
      const newMap = new Map(prev);
      const currentState = newMap.get(tabId) || getDefaultTabState();
      newMap.set(tabId, { ...currentState, ...updates });
      return newMap;
    });
  }, [getDefaultTabState]);

  // Current tab state (memoized to react to activeTabId and tabStates changes)
  const currentTabState = useMemo(() => {
    return tabStates.get(activeTabId) || getDefaultTabState();
  }, [activeTabId, tabStates, getDefaultTabState]);
  const selectedProject = currentTabState.selectedProject;
  const unitNumber = currentTabState.unitNumber;
  const projectUnits = currentTabState.projectUnits;
  const projectUnitsLoading = currentTabState.projectUnitsLoading;
  const projectDetails = currentTabState.projectDetails;
  const projectDetailsLoading = currentTabState.projectDetailsLoading;
  const projectSectionExpanded = currentTabState.projectSectionExpanded;
  const loading = currentTabState.loading;
  const error = currentTabState.error;
  const referenceUnit = currentTabState.referenceUnit;
  const comparableUnits = currentTabState.comparableUnits;
  const originalComparableUnits = currentTabState.originalComparableUnits;
  const areaTolerancePercent = currentTabState.areaTolerancePercent ?? 0;

  // Setters that update current tab state
  const setSelectedProject = (value: string) => updateTabState(activeTabId, { selectedProject: value });
  const setUnitNumber = (value: string) => updateTabState(activeTabId, { unitNumber: value });
  const setProjectUnits = (value: ProjectUnitOption[]) => updateTabState(activeTabId, { projectUnits: value });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setProjectUnitsLoading = (value: boolean) => updateTabState(activeTabId, { projectUnitsLoading: value });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setProjectDetails = (value: ProjectDetails | null) => updateTabState(activeTabId, { projectDetails: value });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setProjectDetailsLoading = (value: boolean) => updateTabState(activeTabId, { projectDetailsLoading: value });
  const setProjectSectionExpanded = (value: boolean) => updateTabState(activeTabId, { projectSectionExpanded: value });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setLoading = (value: boolean) => updateTabState(activeTabId, { loading: value });
  const setError = (value: string | null) => updateTabState(activeTabId, { error: value });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setReferenceUnit = (value: ReferenceUnit | null) => updateTabState(activeTabId, { referenceUnit: value });
  const setComparableUnits = useCallback((value: ComparableUnit[]) => updateTabState(activeTabId, { comparableUnits: value }), [activeTabId, updateTabState]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setOriginalComparableUnits = (value: ComparableUnit[]) => updateTabState(activeTabId, { originalComparableUnits: value });
  
  // Financial parameters
  const [loanToValue, setLoanToValue] = useState<number>(75);
  const [loanToValueInput, setLoanToValueInput] = useState<string>('75');
  const [tenureYears, setTenureYears] = useState<number>(30);
  const [tenureYearsInput, setTenureYearsInput] = useState<string>('30');
  const [interestRate, setInterestRate] = useState<number>(1.55);
  const [interestRateInput, setInterestRateInput] = useState<string>('1.55');

  // Helper function to parse unit number into floor and stack.
  // Ground-floor terrace houses often use FloorNumber "G" with unit numbers like
  // "#68" (no hyphen). Treat G as floor 1 and rewrite those to "#01-68" / "01-68".
  const parseUnitNumber = (
    unitNumber: string,
    floorNumber?: string | null,
  ): { floor: number | null; stack: number | null; floorLabel: string | null } => {
    let normalized = String(unitNumber ?? '').trim();
    const floorRaw = String(floorNumber ?? '').trim().toUpperCase();
    if (floorRaw === 'G' && normalized && !normalized.includes('-')) {
      const hasHash = normalized.startsWith('#');
      const rest = (hasHash ? normalized.slice(1) : normalized).trim();
      if (rest) {
        normalized = `${hasHash ? '#' : ''}01-${rest}`;
      }
    }
    // Match patterns like #09-01, 09-01, #B1-01, or B01-01.
    const match = normalized.match(/#?\s*(B?)(\d+)-(\d+)/i);
    if (match) {
      const isBasement = match[1].toUpperCase() === 'B';
      const parsedFloor = parseInt(match[2], 10);
      return {
        floor: isBasement ? -parsedFloor : parsedFloor,
        stack: parseInt(match[3], 10),
        floorLabel: isBasement ? `B${parsedFloor}` : String(parsedFloor),
      };
    }
    return { floor: null, stack: null, floorLabel: null };
  };

  const formatTowerFloorLabel = (floor: number): string => (
    floor < 0 ? `B${Math.abs(floor)}` : floor.toString().padStart(2, '0')
  );

  // Helper function to format block number display
  const formatBlockNumber = (blockNumber: string | null): string => {
    if (!blockNumber) return 'N/A';
    // Check if block number is only digits
    if (/^\d+$/.test(blockNumber.trim())) {
      return `Block ${blockNumber}`;
    }
    // Otherwise return as-is
    return blockNumber;
  };

  // Stable identity on purpose: this feeds the dependency array of several
  // heavy site-plan memos, which never memoised while it was re-created here on
  // every render.
  const normalizeStackKey = useCallback((stack: string | number | null | undefined): string => {
    if (stack == null) return '';
    const raw = String(stack).trim();
    if (!raw) return '';
    return /^\d+$/.test(raw) ? raw.padStart(2, '0') : raw;
  }, []);
  const STACK_FILTER_ODD_VALUE = 'ODD';
  const STACK_FILTER_EVEN_VALUE = 'EVEN';
  const normalizeStackFilterValue = (value: string | number | null | undefined): string => {
    const raw = String(value ?? '').trim().toUpperCase();
    if (raw === STACK_FILTER_ODD_VALUE || raw === STACK_FILTER_EVEN_VALUE) return raw;
    return normalizeStackKey(value);
  };
  const matchesSelectedStackKey = (selectedFilters: string[], stackKey: string | null | undefined): boolean => {
    if (selectedFilters.length === 0) return true;
    const rawKey = String(stackKey ?? '').trim();
    if (!rawKey) return false;

    const compositeMatch = rawKey.match(/^(\d+)-(\d+)$/);
    const normalizedStack = compositeMatch ? normalizeStackKey(compositeMatch[2]) : normalizeStackKey(rawKey);
    if (!normalizedStack) return false;
    const compositeKey = compositeMatch ? `${compositeMatch[1]}-${normalizedStack}` : null;
    const stackNum = Number(normalizedStack);

    return selectedFilters.some((selected) => {
      const normalizedSelected = normalizeStackFilterValue(selected);
      if (!normalizedSelected) return false;
      if (normalizedSelected === STACK_FILTER_ODD_VALUE) {
        return Number.isFinite(stackNum) && stackNum % 2 === 1;
      }
      if (normalizedSelected === STACK_FILTER_EVEN_VALUE) {
        return Number.isFinite(stackNum) && stackNum % 2 === 0;
      }
      return normalizedSelected === normalizedStack || (compositeKey != null && normalizedSelected === compositeKey);
    });
  };

  const normalizeBedroomValue = useCallback((value: unknown): number | null => {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (value == null) return null;
    const raw = String(value).trim().toLowerCase();
    if (!raw) return null;
    const match = raw.match(/\d+/);
    return match ? Number(match[0]) : null;
  }, []);
  const PENTHOUSE_FILTER_VALUE = -1;
  const ANY_FILTER_VALUE = 'any';
  const TOWER_VIEW_BEDROOM_COLORS_DARK: Record<number, string> = {
    1: '#1976d2',
    2: '#388e3c',
    3: '#00838f',
    4: '#6a1b9a',
    5: '#00897b',
    [PENTHOUSE_FILTER_VALUE]: '#f9a825',
  };
  const TOWER_VIEW_BEDROOM_COLORS_LIGHT: Record<number, string> = {
    1: '#90caf9',
    2: '#a5d6a7',
    3: '#80deea',
    4: '#ce93d8',
    5: '#4db6ac',
    [PENTHOUSE_FILTER_VALUE]: '#ffe082',
  };
  const getTowerViewBedroomColor = (bedroom: number | null): string => {
    const isLightTheme = currentTheme === 'light';
    const palette = isLightTheme ? TOWER_VIEW_BEDROOM_COLORS_LIGHT : TOWER_VIEW_BEDROOM_COLORS_DARK;
    return bedroom != null && bedroom in palette ? palette[bedroom] : (isLightTheme ? '#cfd8dc' : '#546e7a');
  };
  const isPenthouseText = (value: unknown): boolean => {
    const raw = String(value ?? '').trim().toLowerCase();
    if (!raw) return false;
    return raw.includes('penthouse') || raw.includes('penthhouse') || /\bph\b/.test(raw) || raw.endsWith('ph');
  };
  const isPenthouseUnit = (unit: { unitTypeDescription?: string | null; unitType?: string | null }): boolean =>
    isPenthouseText(unit.unitTypeDescription) || isPenthouseText(unit.unitType);
  const matchesBedroomSelection = (bedroom: number | null, unitIsPenthouse: boolean, bedroomFilter: number[]): boolean => {
    if (bedroomFilter.length === 0) return true;
    return bedroomFilter.some((filterValue) => {
      if (filterValue === PENTHOUSE_FILTER_VALUE) return unitIsPenthouse;
      return !unitIsPenthouse && bedroom != null && bedroom === filterValue;
    });
  };

  // BSD & Outlay now imported from ../utils/stampDutyRates

  const calculateInstallment = (price: number, loanToValueRatio: number, tenure: number, rate: number): number => {
    if (price <= 0 || loanToValueRatio <= 0 || tenure <= 0) return 0;
    const principal = price * loanToValueRatio;
    const monthlyRate = rate / 12;
    const numberOfPayments = tenure * 12;

    if (monthlyRate === 0) {
      return principal / numberOfPayments;
    }

    return (
      (principal * (monthlyRate * Math.pow(1 + monthlyRate, numberOfPayments))) /
      (Math.pow(1 + monthlyRate, numberOfPayments) - 1)
    );
  };

  // Sorting and filtering state
  type SortDirection = 'default' | 'asc' | 'desc';
  type ColumnKey = 'projectName' | 'unitNumber' | 'blockNumber' | 'floor' | 'stack' | 'bedroom' | 'bathroom' | 'areaSqft' | 'price' | 'psf' | 'dps' | 'outlay' | 'installment' | 'distance';
  type MasterToolUnitColumnKey = 'projectName' | 'projectCategory' | 'unitNumber' | 'blockNumber' | 'district' | 'region' | 'districtLocation' | 'nearestMrt' | 'walkingTimeToMrt' | 'tenure' | 'topYear' | 'floor' | 'stack' | 'bedroom' | 'bathroom' | 'areaSqft' | 'price' | 'dps' | 'psf' | 'outlay' | 'installment';
  type MasterToolUnitRangeKey = 'floor' | 'stack' | 'bedroom' | 'bathroom' | 'areaSqft' | 'price' | 'dps' | 'psf' | 'outlay' | 'installment' | 'walkingTimeToMrt' | 'topYear';
  type MasterToolProjectViewColumnKey = typeof MASTER_TOOL_PROJECT_VIEW_COLUMN_KEYS[number];
  type MasterToolProjectMatchedColumnKey = typeof MASTER_TOOL_PROJECT_MATCHED_COLUMN_KEYS[number];
  type MasterToolProjectMatchedFromColumnKey = typeof MASTER_TOOL_PROJECT_MATCHED_FROM_COLUMN_KEYS[number];
  type MasterToolProjectFilterSortColumnKey = MasterToolProjectViewColumnKey | MasterToolProjectMatchedColumnKey | MasterToolProjectMatchedFromColumnKey;
  type MasterToolProjectCategoryFilterKey = 'projectName' | 'projectCategory' | 'district' | 'region' | 'nearestMrt' | 'tenure';
  type TopViewingColumnKey = 'projectName' | 'blockNumber' | 'floor' | 'stack' | 'unitTypeDescription' | 'bedroom' | 'bathroom' | 'areaSqft' | 'price' | 'dps' | 'psf' | 'outlay' | 'installment' | 'distance';

  const [sortConfig, setSortConfig] = useState<{ column: ColumnKey | null; direction: SortDirection }>({
    column: 'unitNumber',
    direction: 'desc',
  });
  const [filters, setFilters] = useState<Record<ColumnKey, string | string[]>>({
    projectName: [], // Changed to array for multi-select
    unitNumber: '',
    blockNumber: '',
    floor: '',
    stack: '',
    bedroom: '',
    bathroom: '',
    areaSqft: '',
    price: '',
    psf: '',
    dps: '',
    installment: '',
    outlay: '',
    distance: '',
  });
  // Range filters for floor, stack, and numeric fields (min/max)
  const [rangeFilters, setRangeFilters] = useState<{
    floor: { min: string; max: string };
    stack: { min: string; max: string };
    bedroom: { min: string; max: string };
    bathroom: { min: string; max: string };
    areaSqft: { min: string; max: string };
    price: { min: string; max: string };
    psf: { min: string; max: string };
    dps: { min: string; max: string };
    outlay: { min: string; max: string };
    installment: { min: string; max: string };
    distance: { min: string; max: string };
  }>({
    floor: { min: '', max: '' },
    stack: { min: '', max: '' },
    bedroom: { min: '', max: '' },
    bathroom: { min: '', max: '' },
    areaSqft: { min: '', max: '' },
    price: { min: '', max: '' },
    psf: { min: '', max: '' },
    dps: { min: '', max: '' },
    outlay: { min: '', max: '' },
    installment: { min: '', max: '' },
    distance: { min: '', max: '' },
  });
  const [popoverAnchor, setPopoverAnchor] = useState<{ element: HTMLElement; column: ColumnKey } | null>(null);
  const [thumbsUpFilterActive, setThumbsUpFilterActive] = useState<boolean>(false);
  const [thumbsUpLegendAnchor, setThumbsUpLegendAnchor] = useState<HTMLElement | null>(null);
  const [outlayInfoAnchor, setOutlayInfoAnchor] = useState<HTMLElement | null>(null);
  const [installmentInfoAnchor, setInstallmentInfoAnchor] = useState<HTMLElement | null>(null);
  /** Best-matched comparable table: tap outlay/installment to show row formula (same pattern as Top Viewing available units). */
  const [comparableUnitFormulaAnchor, setComparableUnitFormulaAnchor] = useState<{
    element: HTMLElement;
    content: React.ReactNode;
  } | null>(null);
  const [npsDpsInfoDialog, setNpsDpsInfoDialog] = useState<'nps' | 'dps' | null>(null);

  // View mode state: 'unit' | 'bestPxBedroom' | 'project'
  const [viewMode, setViewMode] = useState<'unit' | 'bestPxBedroom' | 'project'>('unit');
  const [projectDetailsMap, setProjectDetailsMap] = useState<Map<string, ProjectDetails>>(new Map());
  const [liveQueueSummary, setLiveQueueSummary] = useState<LiveQueueSummary | null>(null);
  // Project view column filters: keyed by column id, value is filter text (case-insensitive match)
  const [projectViewFilters, setProjectViewFilters] = useState<Record<string, string>>({});
  // Project view min/max filters for numeric columns (Unit View style)
  const [projectViewRangeFilters, setProjectViewRangeFilters] = useState<Record<string, { min: string; max: string }>>({});
  const [projectViewPopoverAnchor, setProjectViewPopoverAnchor] = useState<{ element: HTMLElement; column: string } | null>(null);
  const [projectViewDistrictFilter, setProjectViewDistrictFilter] = useState<string[]>([]);
  const [projectViewSortConfig, setProjectViewSortConfig] = useState<{ column: string | null; direction: SortDirection }>({
    column: null,
    direction: 'default',
  });
  const [bestByUnitTypeData, setBestByUnitTypeData] = useState<BestByUnitTypeResponse | null>(null);
  const [bestByUnitTypeLoading, setBestByUnitTypeLoading] = useState(false);
  const [bestPxBedroomSitePlan, setBestPxBedroomSitePlan] = useState<SitePlanData | null>(null);
  /** Aligns with ProjectSheet.ShowPsfInTowerViewInd (via best-by-unit-type API). */
  const bestPxShowPsfColumns = bestByUnitTypeData?.showPsfInTowerView !== false;

  // Master Tool state
  const [masterToolFilters, setMasterToolFilters] = useState<MasterToolSearchFilters>({ priceMin: '1' });
  /** Bumped to run a Project Research search that was pre-filled elsewhere. */
  const [masterToolAutoSearchNonce, setMasterToolAutoSearchNonce] = useState<number>(0);
  /** 3BR/5BR sizes the last Project Research search covered — drives the Amberwood banner. */
  const [masterToolAmberwoodBedrooms, setMasterToolAmberwoodBedrooms] = useState<number[]>([]);
  const [amberwoodBannerDismissed, setAmberwoodBannerDismissed] = useState(false);
  const [masterToolLocationInput, setMasterToolLocationInput] = useState('');
  const [masterToolLocationOptions, setMasterToolLocationOptions] = useState<OneMapSearchResult[]>([]);
  const [masterToolLocationSearching, setMasterToolLocationSearching] = useState(false);
  const [masterToolSelectedLocation, setMasterToolSelectedLocation] = useState<OneMapSearchResult | null>(null);
  const [masterToolProjectCategoryList, setMasterToolProjectCategoryList] = useState<ProjectCategoryOption[]>([]);
  const [masterToolDistrictOptions, setMasterToolDistrictOptions] = useState<DistrictOption[]>([]);
  const getDistrictFilterOptionLabel = useCallback((districtValue: string): string => {
    const rawValue = (districtValue ?? '').trim();
    if (!rawValue) return rawValue;
    const valueDigitsMatch = rawValue.match(/\d{1,2}/);
    const valueDigits = valueDigitsMatch ? valueDigitsMatch[0] : rawValue;
    const displayCode = `D${valueDigits.padStart(2, '0')}`;

    const matched = masterToolDistrictOptions.find((district) => {
      const no = String(district.no ?? '').trim();
      const noDigitsMatch = no.match(/\d{1,2}/);
      const noDigits = noDigitsMatch ? noDigitsMatch[0] : '';

      const name = (district.name ?? district.generalLocation ?? '').trim();
      const nameDigitsMatch = name.match(/D?\s*(\d{1,2})/i);
      const nameDigits = nameDigitsMatch ? nameDigitsMatch[1] : '';

      return valueDigits === noDigits || valueDigits === nameDigits;
    });

    const rawName = (matched?.name ?? matched?.generalLocation ?? '').trim();
    if (!rawName) return displayCode;

    const cleanedName = rawName.replace(/^\s*D{0,2}0*\d+\s*-\s*/i, '').trim();
    return `${displayCode} - ${cleanedName || rawName}`;
  }, [masterToolDistrictOptions]);
  const excludedMasterToolProjectCategories = useMemo(
    () => new Set(['commercial', 'industrial', 'condotel']),
    []
  );
  const [masterToolResults, setMasterToolResults] = useState<MasterToolProjectResult[]>([]);
  const [masterToolUnits, setMasterToolUnits] = useState<MasterToolUnit[]>([]);
  const [masterToolTotalMatchedUnits, setMasterToolTotalMatchedUnits] = useState<number>(0);
  const [masterToolUnitPage, setMasterToolUnitPage] = useState<number>(1);
  const [masterToolProjectPage, setMasterToolProjectPage] = useState<number>(1);
  const [selectedMasterToolProjectKeys, setSelectedMasterToolProjectKeys] = useState<Set<string>>(() => new Set());
  const [masterToolLoading, setMasterToolLoading] = useState<boolean>(false);
  const [masterToolViewMode, setMasterToolViewMode] = useState<'project' | 'unit'>('project');
  const [masterToolProjectSortConfig, setMasterToolProjectSortConfig] = useState<{ column: MasterToolProjectFilterSortColumnKey | null; direction: SortDirection }>({
    column: null,
    direction: 'default',
  });
  const [masterToolProjectViewFilters, setMasterToolProjectViewFilters] = useState<Record<string, string>>({});
  const [masterToolProjectViewRangeFilters, setMasterToolProjectViewRangeFilters] = useState<Record<string, { min: string; max: string }>>({});
  const [masterToolProjectCategoryFilters, setMasterToolProjectCategoryFilters] = useState<Record<MasterToolProjectCategoryFilterKey, string[]>>({
    projectName: [],
    projectCategory: [],
    district: [],
    region: [],
    nearestMrt: [],
    tenure: [],
  });
  const [masterToolPopoverAnchor, setMasterToolPopoverAnchor] = useState<{ element: HTMLElement; column: string } | null>(null);
  const [masterToolProjectColumnsAnchor, setMasterToolProjectColumnsAnchor] = useState<HTMLElement | null>(null);
  const [masterToolProjectColumnVisibility, setMasterToolProjectColumnVisibility] = useState<ColumnVisibilityState>({});
  const [masterToolUnitSortConfig, setMasterToolUnitSortConfig] = useState<{ column: MasterToolUnitColumnKey | null; direction: SortDirection }>({
    column: null,
    direction: 'default',
  });
  const [masterToolUnitFilters, setMasterToolUnitFilters] = useState<Record<MasterToolUnitColumnKey, string | string[]>>({
    projectName: [],
    projectCategory: [],
    unitNumber: '',
    blockNumber: '',
    district: [],
    region: [],
    districtLocation: [],
    nearestMrt: [],
    walkingTimeToMrt: '',
    tenure: [],
    topYear: '',
    floor: '',
    stack: '',
    bedroom: '',
    bathroom: '',
    areaSqft: '',
    price: '',
    dps: '',
    psf: '',
    outlay: '',
    installment: '',
  });
  const [masterToolUnitRangeFilters, setMasterToolUnitRangeFilters] = useState<Record<MasterToolUnitRangeKey, { min: string; max: string }>>({
    floor: { min: '', max: '' },
    stack: { min: '', max: '' },
    bedroom: { min: '', max: '' },
    bathroom: { min: '', max: '' },
    areaSqft: { min: '', max: '' },
    price: { min: '', max: '' },
    dps: { min: '', max: '' },
    psf: { min: '', max: '' },
    outlay: { min: '', max: '' },
    installment: { min: '', max: '' },
    walkingTimeToMrt: { min: '', max: '' },
    topYear: { min: '', max: '' },
  });
  const debouncedMasterToolProjectViewFilters = useDebouncedValue(
    masterToolProjectViewFilters,
    MASTER_TOOL_TABLE_FILTER_DEBOUNCE_MS
  );
  const debouncedMasterToolProjectViewRangeFilters = useDebouncedValue(
    masterToolProjectViewRangeFilters,
    MASTER_TOOL_TABLE_FILTER_DEBOUNCE_MS
  );
  const debouncedMasterToolUnitFilters = useDebouncedValue(
    masterToolUnitFilters,
    MASTER_TOOL_TABLE_FILTER_DEBOUNCE_MS
  );
  const debouncedMasterToolUnitRangeFilters = useDebouncedValue(
    masterToolUnitRangeFilters,
    MASTER_TOOL_TABLE_FILTER_DEBOUNCE_MS
  );
  const [masterToolUnitPopoverAnchor, setMasterToolUnitPopoverAnchor] = useState<{ element: HTMLElement; column: MasterToolUnitColumnKey } | null>(null);
  const [masterToolUnitColumnsAnchor, setMasterToolUnitColumnsAnchor] = useState<HTMLElement | null>(null);
  const [masterToolUnitColumnVisibility, setMasterToolUnitColumnVisibility] = useState<ColumnVisibilityState>({});
  const [masterToolUnitRowMenuAnchor, setMasterToolUnitRowMenuAnchor] = useState<{
    unit: MasterToolUnit & { outlay: number; installment: number };
    position: { top: number; left: number };
  } | null>(null);
  const [masterToolProjectExpand, setMasterToolProjectExpand] = useState<{
    projectName: string;
    bucket: MasterToolProjectExpandBucket;
  } | null>(null);
  const [masterToolProjectExpandUnits, setMasterToolProjectExpandUnits] = useState<MasterToolExpandUnitRow[]>([]);
  const [masterToolProjectExpandLoading, setMasterToolProjectExpandLoading] = useState(false);
  const [masterToolProjectExpandError, setMasterToolProjectExpandError] = useState<string | null>(null);
  const [masterToolPdfWarningOpen, setMasterToolPdfWarningOpen] = useState(false);
  const [masterToolPdfWarningColumnCount, setMasterToolPdfWarningColumnCount] = useState(0);
  const [masterToolPendingPdfExportMode, setMasterToolPendingPdfExportMode] = useState<'project' | 'unit' | null>(null);
  const [masterToolPdfExportOverMaxOpen, setMasterToolPdfExportOverMaxOpen] = useState(false);
  const [masterToolPdfExportLargeConfirmOpen, setMasterToolPdfExportLargeConfirmOpen] = useState(false);
  const [masterToolPdfExportDailyUsedOpen, setMasterToolPdfExportDailyUsedOpen] = useState(false);

  // Top Viewing Site Plans tab state
  const [topViewingSitePlans, setTopViewingSitePlans] = useState<TopViewingSitePlan[]>([]);
  const [topViewingSitePlansLoading, setTopViewingSitePlansLoading] = useState<boolean>(false);
  const [topViewingSitePlansError, setTopViewingSitePlansError] = useState<string | null>(null);
  const [selectedTopViewingSitePlan, setSelectedTopViewingSitePlan] = useState<string | null>(null);
  const [commissionStructureOpen, setCommissionStructureOpen] = useState<boolean>(false);
  const deepLinkConsumedRef = useRef(false);
  const anticipateBlinkerDeepLinkConsumedRef = useRef(false);
  /** Lets the earlier showcase hotspot handler call the blinker opener defined below. */
  const openRandomAnticipateBlinkerUnitRef = useRef<() => Promise<void>>(async () => {});
  /** Lets the earlier showcase hotspot handler open a random Super Ratio project. */
  const openRandomSuperRatioRef = useRef<() => Promise<void>>(async () => {});
  const topViewingSitePlansFetchAttemptedRef = useRef(false);
  const [sitePlanTutorialOpen, setSitePlanTutorialOpen] = useState(false);
  const sitePlanTutorialStatus = React.useMemo<'not-started' | 'in-progress' | 'completed'>(() => {
    try {
      const saved = localStorage.getItem(SITE_PLAN_TUTORIAL_STORAGE_KEY);
      if (saved) {
        const p = JSON.parse(saved);
        if (p.completed) return 'completed';
        if (p.started) return 'in-progress';
      }
    } catch { /* ignore */ }
    return 'not-started';
  }, [sitePlanTutorialOpen]);
  const [topViewingSitePlanSearch, setTopViewingSitePlanSearch] = useState<string>('');
  const [topViewingSitePlanSearchDebounced, setTopViewingSitePlanSearchDebounced] = useState<string>('');
  const [topViewingSitePlanPage, setTopViewingSitePlanPage] = useState<number>(1);
  const [topViewingSitePlanContentLoading, setTopViewingSitePlanContentLoading] = useState<boolean>(false);
  const [topViewingTowerZoom, setTopViewingTowerZoom] = useState<number>(1);
  const TOP_VIEWING_TOWER_DISPLAY_DEFAULT: Array<'bedroom' | 'price' | 'psf' | 'size'> = ['bedroom', 'price', 'psf', 'size'];
  const createDefaultTopViewingAvailableUnitFilters = () => ({
    projectName: '',
    blockNumber: '',
    floorMin: '',
    floorMax: '',
    stackMin: '',
    stackMax: '',
    stackSelected: [] as string[],
    unitTypeDescriptionSelected: [] as string[],
    bedroomMin: '',
    bedroomMax: '',
    bathroomMin: '',
    bathroomMax: '',
    areaMin: '',
    areaMax: '',
    priceMin: '',
    priceMax: '',
    dpsMin: '',
    dpsMax: '',
    psfMin: '',
    psfMax: '',
    outlayMin: '',
    outlayMax: '',
    installmentMin: '',
    installmentMax: '',
  });
  const [topViewingTowerDisplayOptions, setTopViewingTowerDisplayOptions] = useState<Array<'bedroom' | 'price' | 'psf' | 'size'>>(TOP_VIEWING_TOWER_DISPLAY_DEFAULT);
  /** Mirrors ProjectSheet.ShowPsfInTowerViewInd for the active top-viewing project (PSF column default in Available / Best Match tables). */
  const [topViewingShowPsfColumnByDefault, setTopViewingShowPsfColumnByDefault] = useState(true);
  const [topViewingTowerBedroomColor, setTopViewingTowerBedroomColor] = useState<boolean>(false);
  const [topViewingSortConfig, setTopViewingSortConfig] = useState<{ column: TopViewingColumnKey | null; direction: SortDirection }>({
    column: null,
    direction: 'default',
  });
  const [topViewingPopoverAnchor, setTopViewingPopoverAnchor] = useState<{ element: HTMLElement; column: TopViewingColumnKey } | null>(null);
  const [topViewingAvailableUnitFilters, setTopViewingAvailableUnitFilters] = useState(createDefaultTopViewingAvailableUnitFilters);
  const [topViewingUnitMenuAnchor, setTopViewingUnitMenuAnchor] = useState<{ element: HTMLElement; unit: TowerViewUnit | ComparableUnit; mouseX: number; mouseY: number } | null>(null);
  const [topViewingFloorPlanOpen, setTopViewingFloorPlanOpen] = useState<boolean>(false);
  const [topViewingFloorPlanUrl, setTopViewingFloorPlanUrl] = useState<string | null>(null);
  const [topViewingFloorPlanLoading, setTopViewingFloorPlanLoading] = useState<boolean>(false);
  const [topViewingFloorPlanUnit, setTopViewingFloorPlanUnit] = useState<TowerViewUnit | ComparableUnit | null>(null);
  const [topViewingReferenceUnit, setTopViewingReferenceUnit] = useState<TopViewingReferenceUnit | null>(null);
  const [topViewingBlinkerChoiceUnit, setTopViewingBlinkerChoiceUnit] = useState<TopViewingReferenceUnit | null>(null);
  const [topViewingBlinkerMinTolerance, setTopViewingBlinkerMinTolerance] = useState<number>(-20);
  const [topViewingBlinkerTolerance, setTopViewingBlinkerTolerance] = useState<number>(1);
  const [topViewingBlinkerMinPriceOverride, setTopViewingBlinkerMinPriceOverride] = useState<number | null>(null);
  const [topViewingBlinkerMaxPriceOverride, setTopViewingBlinkerMaxPriceOverride] = useState<number | null>(null);
  const [topViewingBlinkerSuperUpgrade, setTopViewingBlinkerSuperUpgrade] = useState<boolean>(false);
  const [topViewingComparableUnits, setTopViewingComparableUnits] = useState<ComparableUnit[]>([]);
  const [topViewingComparableUnitsLoading, setTopViewingComparableUnitsLoading] = useState<boolean>(false);
  const [topViewingAreaTolerance, setTopViewingAreaTolerance] = useState<number>(0);
  const [topViewingToleranceSliderValue, setTopViewingToleranceSliderValue] = useState<number>(0);
  const [topViewingToleranceModalOpen, setTopViewingToleranceModalOpen] = useState<boolean>(false);
  const [topViewingComparableSectionOpen, setTopViewingComparableSectionOpen] = useState<boolean>(true);
  const [topViewingBudgetSectionOpen, setTopViewingBudgetSectionOpen] = useState<boolean>(false);
  const [topViewingBudgetTolerance, setTopViewingBudgetTolerance] = useState<number>(5);
  const [topViewingBudgetSliderValue, setTopViewingBudgetSliderValue] = useState<number>(5);
  const [topViewingBudgetUnits, setTopViewingBudgetUnits] = useState<TowerViewUnit[]>([]);
  const [topViewingBudgetUnitsLoading, setTopViewingBudgetUnitsLoading] = useState<boolean>(false);
  const [topViewingBudgetUnitsError, setTopViewingBudgetUnitsError] = useState<string | null>(null);
  const [topViewingBudgetViewMode, setTopViewingBudgetViewMode] = useState<'unit' | 'project'>('unit');
  const [topViewingBudgetShowReferenceProjectUnits, setTopViewingBudgetShowReferenceProjectUnits] = useState<boolean>(false);
  type TopViewingBudgetRegionTab = 'ALL' | 'NEARBY' | 'CCR' | 'OCR' | 'RCR' | 'SUPER';
  type TopViewingBudgetTextFilters = {
    projectName: string;
    blockNumber: string;
    unitNumber: string;
    district: string;
    region: string;
    tenure: string;
    completedDate: string;
    nearestMrt: string;
  };
  type TopViewingBudgetExclusionFilters = {
    projectName: string[];
    projectCategory: string[];
    tenure: string[];
    region: string[];
    nearestMrt: string[];
    district: string[];
  };
  type TopViewingBudgetRangeFilters = {
    floor: { min: string; max: string };
    stack: { min: string; max: string };
    bedroom: { min: string; max: string };
    bathroom: { min: string; max: string };
    areaSqft: { min: string; max: string };
    price: { min: string; max: string };
    dps: { min: string; max: string };
    psf: { min: string; max: string };
    outlay: { min: string; max: string };
    installment: { min: string; max: string };
    distance: { min: string; max: string };
    walkingTimeToMrt: { min: string; max: string };
  };
  const createDefaultTopViewingBudgetFilters = (): TopViewingBudgetTextFilters => ({
    projectName: '',
    blockNumber: '',
    unitNumber: '',
    district: '',
    region: '',
    tenure: '',
    completedDate: '',
    nearestMrt: '',
  });
  const createDefaultTopViewingBudgetExclusionFilters = (): TopViewingBudgetExclusionFilters => ({
    projectName: [],
    projectCategory: [],
    tenure: [],
    region: [],
    nearestMrt: [],
    district: [],
  });
  const createDefaultTopViewingBudgetRangeFilters = (): TopViewingBudgetRangeFilters => ({
    floor: { min: '', max: '' },
    stack: { min: '', max: '' },
    bedroom: { min: '', max: '' },
    bathroom: { min: '', max: '' },
    areaSqft: { min: '', max: '' },
    price: { min: '', max: '' },
    dps: { min: '', max: '' },
    psf: { min: '', max: '' },
    outlay: { min: '', max: '' },
    installment: { min: '', max: '' },
    distance: { min: '', max: '' },
    walkingTimeToMrt: { min: '', max: '' },
  });
  const [topViewingBudgetRegionTab, setTopViewingBudgetRegionTab] = useState<TopViewingBudgetRegionTab>('CCR');
  const topViewingBudgetAutoRegionRef = useRef<string | null>(null);
  const [topViewingBudgetPopoverAnchor, setTopViewingBudgetPopoverAnchor] = useState<{ element: HTMLElement; column: string } | null>(null);
  const [topViewingBudgetSortConfig, setTopViewingBudgetSortConfig] = useState<{ column: string | null; direction: SortDirection }>({
    column: null,
    direction: 'default',
  });
  const [topViewingBudgetFilters, setTopViewingBudgetFilters] = useState<TopViewingBudgetTextFilters>(createDefaultTopViewingBudgetFilters);
  const [topViewingBudgetExclusionFilters, setTopViewingBudgetExclusionFilters] = useState<TopViewingBudgetExclusionFilters>(createDefaultTopViewingBudgetExclusionFilters);
  const [topViewingBudgetRangeFilters, setTopViewingBudgetRangeFilters] = useState<TopViewingBudgetRangeFilters>(createDefaultTopViewingBudgetRangeFilters);
  const [topViewingBudgetSearchRange, setTopViewingBudgetSearchRange] = useState<{ min: string; max: string }>({
    min: '',
    max: '',
  });
  const [topViewingBudgetDebouncedSearchRange, setTopViewingBudgetDebouncedSearchRange] = useState<{ min: string; max: string }>({
    min: '',
    max: '',
  });
  const [topViewingBudgetFiltersByRegion, setTopViewingBudgetFiltersByRegion] = useState<Record<TopViewingBudgetRegionTab, TopViewingBudgetTextFilters>>({
    ALL: createDefaultTopViewingBudgetFilters(),
    NEARBY: createDefaultTopViewingBudgetFilters(),
    CCR: createDefaultTopViewingBudgetFilters(),
    OCR: createDefaultTopViewingBudgetFilters(),
    RCR: createDefaultTopViewingBudgetFilters(),
    SUPER: createDefaultTopViewingBudgetFilters(),
  });
  const [topViewingBudgetRangeFiltersByRegion, setTopViewingBudgetRangeFiltersByRegion] = useState<Record<TopViewingBudgetRegionTab, TopViewingBudgetRangeFilters>>({
    ALL: createDefaultTopViewingBudgetRangeFilters(),
    NEARBY: createDefaultTopViewingBudgetRangeFilters(),
    CCR: createDefaultTopViewingBudgetRangeFilters(),
    OCR: createDefaultTopViewingBudgetRangeFilters(),
    RCR: createDefaultTopViewingBudgetRangeFilters(),
    SUPER: createDefaultTopViewingBudgetRangeFilters(),
  });
  const [topViewingBudgetNearbyRadiusKm, setTopViewingBudgetNearbyRadiusKm] = useState<number>(2);
  const topViewingBudgetPrevRegionTabRef = useRef<TopViewingBudgetRegionTab>('CCR');
  const [comparableSectionOpen, setComparableSectionOpen] = useState<boolean>(true);
  type TopViewingCompColumnKey = 'projectName' | 'projectCategory' | 'blockNumber' | 'floor' | 'stack' | 'unitTypeDescription' | 'bedroom' | 'bathroom' | 'areaSqft' | 'price' | 'psf' | 'dps' | 'outlay' | 'installment' | 'distance';
  type TopViewingCompFilters = {
    projectName: string[];
    projectCategory: string[];
    blockNumber: string;
    unitTypeDescription: string[];
  };
  type TopViewingCompRangeFilters = {
    floor: { min: string; max: string };
    stack: { min: string; max: string };
    bedroom: { min: string; max: string };
    bathroom: { min: string; max: string };
    areaSqft: { min: string; max: string };
    price: { min: string; max: string };
    psf: { min: string; max: string };
    dps: { min: string; max: string };
    outlay: { min: string; max: string };
    installment: { min: string; max: string };
    distance: { min: string; max: string };
  };
  const createDefaultTopViewingCompFilters = (): TopViewingCompFilters => ({
    projectName: [],
    projectCategory: [],
    blockNumber: '',
    unitTypeDescription: [],
  });
  const createDefaultTopViewingCompRangeFilters = (): TopViewingCompRangeFilters => ({
    floor: { min: '', max: '' },
    stack: { min: '', max: '' },
    bedroom: { min: '', max: '' },
    bathroom: { min: '', max: '' },
    areaSqft: { min: '', max: '' },
    price: { min: '', max: '' },
    psf: { min: '', max: '' },
    dps: { min: '', max: '' },
    outlay: { min: '', max: '' },
    installment: { min: '', max: '' },
    distance: { min: '', max: '' },
  });
  const [topViewingCompPopoverAnchor, setTopViewingCompPopoverAnchor] = useState<{ element: HTMLElement; column: TopViewingCompColumnKey } | null>(null);
  const [topViewingCompFilters, setTopViewingCompFilters] = useState<TopViewingCompFilters>(createDefaultTopViewingCompFilters);
  const [topViewingCompRangeFilters, setTopViewingCompRangeFilters] = useState<TopViewingCompRangeFilters>(createDefaultTopViewingCompRangeFilters);
  const debouncedTopViewingCompRangeFilters = useDebouncedValue(topViewingCompRangeFilters, TOP_VIEWING_COMP_RANGE_DEBOUNCE_MS);
  const [topViewingFloorPlansToCompare, setTopViewingFloorPlansToCompare] = useState<Array<{
    unit: ComparableUnit | ReferenceUnit;
    imageUrl: string;
  }>>([]);
  const [topViewingThumbsUpFilterActive, setTopViewingThumbsUpFilterActive] = useState<boolean>(false);
  const [topViewingCompSortConfig, setTopViewingCompSortConfig] = useState<{
    column: TopViewingCompColumnKey | null;
    direction: 'asc' | 'desc' | null;
  }>({ column: null, direction: null });
  const [topViewingAvailableUnitsViewMode, setTopViewingAvailableUnitsViewMode] = useState<'availableUnits' | 'bestPxBedroom' | 'bestPsfBedroom'>('availableUnits');
  const [topViewingCompViewMode, setTopViewingCompViewMode] = useState<'unit' | 'project'>('unit');
  const [topViewingBestByUnitTypeData, setTopViewingBestByUnitTypeData] = useState<BestByUnitTypeResponse | null>(null);
  const [topViewingBestByUnitTypeLoading, setTopViewingBestByUnitTypeLoading] = useState(false);
  const [exportingPdf, setExportingPdf] = useState(false);
  const [isPdfCapturingTowerView, setIsPdfCapturingTowerView] = useState(false);
  const [topViewingBestPxBedroomSitePlan, setTopViewingBestPxBedroomSitePlan] = useState<SitePlanData | null>(null);
  const [topViewingThumbsUpLegendAnchor, setTopViewingThumbsUpLegendAnchor] = useState<HTMLElement | null>(null);
  const [topViewingOutlayInfoAnchor, setTopViewingOutlayInfoAnchor] = useState<HTMLElement | null>(null);
  const [topViewingInstallmentInfoAnchor, setTopViewingInstallmentInfoAnchor] = useState<HTMLElement | null>(null);
  const topViewingComparableSectionRef = useRef<HTMLDivElement>(null);
  const topViewingTowerViewSectionRef = useRef<HTMLDivElement>(null);
  const topViewingLastFetchedProjectsRef = useRef<string>('');
  const topViewingBudgetLastQueryKeyRef = useRef<string>('');
  const topViewingBudgetLastFetchedProjectsRef = useRef<string>('');
  const getUnitReferenceDisabledReason = useCallback((
    unit?: {
      unitStatus?: string | null;
      status?: string | null;
      price?: number | null;
      priceNps?: number | null;
      priceDps?: number | null;
    } | null
  ): { main: string; sub?: string } | null => {
    if (!unit) return { main: 'Set as Reference Unit' };
    const status = (unit.unitStatus ?? unit.status ?? '').toString().toLowerCase();
    if (status === 'sold') {
      return { main: 'Set as Reference Unit', sub: '*Sold units cannot set as reference' };
    }
    if (isUnitStatusNotReleased(status)) {
      return { main: 'Set as Reference Unit', sub: '*Not released units cannot set as reference' };
    }
    const primaryPrice = Number(unit.priceNps ?? unit.price ?? 0);
    const alternatePrice = Number(unit.priceDps ?? 0);
    const hasPrice =
      (Number.isFinite(primaryPrice) && primaryPrice > 0) ||
      (Number.isFinite(alternatePrice) && alternatePrice > 0);
    if (!hasPrice) {
      return { main: 'Set as Reference Unit', sub: '*Price required to set as reference' };
    }
    return null;
  }, []);
  const getUnitBlinkerDisabledReason = useCallback((
    unit?: {
      unitStatus?: string | null;
      status?: string | null;
      price?: number | null;
      priceNps?: number | null;
      priceDps?: number | null;
    } | null
  ): { main: string; sub?: string } | null => {
    const reason = getUnitReferenceDisabledReason(unit);
    if (!reason) return null;
    return {
      main: 'Set as Anticipate Blinker Unit',
      sub: reason.sub?.replace('set as reference', 'set as anticipate blinker unit'),
    };
  }, [getUnitReferenceDisabledReason]);

  // Project details tabs and amenities state
  const [projectDetailsTab, setProjectDetailsTab] = useState<ProjectDetailsTab>('details');
  const [amenitiesRadius, setAmenitiesRadius] = useState<number>(1000); // Default 1km
  const [amenitiesData, setAmenitiesData] = useState<AmenitiesResponse | null>(null);
  const [budgetAmenityDistances, setBudgetAmenityDistances] = useState<
    Map<string, { schoolMeters: number | null; mrtMeters: number | null }>
  >(new Map());
  const [amenitiesLoading, setAmenitiesLoading] = useState<boolean>(false);
  const [demandSupplyRadius, setDemandSupplyRadius] = useState<number>(5000); // Default 5km
  // Inner edge of the Super Ratio scan ring; 0 = scan from the centre outwards.
  const [demandSupplyMinRadius, setDemandSupplyMinRadius] = useState<number>(0);
  // Whole-island Super Ratio scan — both radius bounds are ignored while on.
  const [demandSupplyNationwide, setDemandSupplyNationwide] = useState<boolean>(false);
  const [demandSupplyData, setDemandSupplyData] = useState<DemandSupplyResponse | null>(null);
  const [demandSupplyLoading, setDemandSupplyLoading] = useState<boolean>(false);
  const [selectedDemandSupplyTypes, setSelectedDemandSupplyTypes] = useState<SelectedDemandSupplyTypes>({
    hdbBtoMop: true,
    hdbResaleMop: true,
    // Condo/EC coming off SSD dwarfs the other series, so it starts off and the
    // user opts in.
    condoSsd: false,
    newLaunch: true,
    gls: true,
  });
  const [projectMembers, setProjectMembers] = useState<ProjectMembersResponse | null>(null);
  const [projectMembersLoading, setProjectMembersLoading] = useState<boolean>(false);
  const [successCloserSearch, setSuccessCloserSearch] = useState<string>('');
  const [highlightCea, setHighlightCea] = useState<string | null>(null);
  const [filesFactsheetData, setFilesFactsheetData] = useState<ProjectFactsheet | null>(null);
  const [filesBrochureData, setFilesBrochureData] = useState<ProjectBrochure | null>(null);
  // EDMs / eBooks tied to the current project via the EDMProject /
  // ProjectLauncherProject join tables. Fetched alongside factsheet
  // + brochure when the Files tab opens and rendered as
  // `DownloadFileRow`s under their own section headings.
  const [filesEdms, setFilesEdms] = useState<ProjectEdmFile[]>([]);
  const [filesEbooks, setFilesEbooks] = useState<ProjectEbookFile[]>([]);
  const [filesLoading, setFilesLoading] = useState<boolean>(false);
  const [selectedAmenityTypes, setSelectedAmenityTypes] = useState<{
    mrtLrt: boolean;
    schools: boolean;
    preschools: boolean;
    supermarkets: boolean;
  }>({
    mrtLrt: true,
    schools: true,
    preschools: true,
    supermarkets: true,
  });
  
  // Tower view modal state
  const TOWER_VIEW_ALL_TAB = '__all__';
  const [towerViewOpen, setTowerViewOpen] = useState<boolean>(false);
  const [selectedUnitForTowerView, setSelectedUnitForTowerView] = useState<ComparableUnit | ReferenceUnit | null>(null);
  const [selectedBlock, setSelectedBlock] = useState<string | null>(null);
  const [towerZoom, setTowerZoom] = useState<number>(1);
  const [towerViewUnits, setTowerViewUnits] = useState<TowerViewUnit[]>([]);
  const [towerViewDialogUnits, setTowerViewDialogUnits] = useState<TowerViewUnit[]>([]);
  const [towerViewUnitsLoading, setTowerViewUnitsLoading] = useState<boolean>(false);
  const topViewingHasUnitPrices = useMemo(
    () => towerViewUnits.some((unit) => Number.isFinite(unit.price) && unit.price > 0),
    [towerViewUnits]
  );
  const isTopViewingIndicativeBeforeLaunch = useMemo(
    () => Boolean(
      topViewingReferenceUnit?.referenceSource === 'indicative'
        || (projectDetails
          && !projectDetails.liveStatusEnabled
          && !topViewingHasUnitPrices
          && projectDetails.indicativePrices)
    ),
    [projectDetails, topViewingHasUnitPrices, topViewingReferenceUnit?.referenceSource]
  );
  const [towerViewDialogUnitTypes, setTowerViewDialogUnitTypes] = useState<string[]>([]);
  const [towerViewDialogSitePlanData, setTowerViewDialogSitePlanData] = useState<SitePlanData | null>(null);
  const [towerViewIsolatedFromMain, setTowerViewIsolatedFromMain] = useState<boolean>(false);
  const [towerViewSiteMapMenuOpen, setTowerViewSiteMapMenuOpen] = useState<boolean>(false);
  const towerZoomContainerRef = useRef<HTMLDivElement>(null);
  const towerViewOpenRef = useRef(false);
  const towerViewProjectNameRef = useRef<string | null>(null);
  const towerViewProjectIdRef = useRef<string | null>(null);
  const towerViewOpenRequestRef = useRef(0);
  const projectIdByNameRef = useRef<Map<string, string>>(new Map());
  const projectLiveByNameRef = useRef<Map<string, boolean>>(new Map());
  const towerViewJustRefreshedRef = useRef(false);
  // All tab display options: multi-select dropdown (bedroom, price, psf, size) - match top viewing site plan
  const TOWER_VIEW_DISPLAY_OPTIONS = ['bedroom', 'price', 'psf', 'size'] as const;
  type TowerViewDisplayOption = typeof TOWER_VIEW_DISPLAY_OPTIONS[number];
  const [towerViewAllDisplayOptions, setTowerViewAllDisplayOptions] = useState<TowerViewDisplayOption[]>([...TOWER_VIEW_DISPLAY_OPTIONS]);
  // All tab map mode: status (availability) vs interest (choice-unit heat map)
  const [towerViewAllMapMode, setTowerViewAllMapMode] = useState<'status' | 'interest'>('status');
  const [towerViewBedroomColor, setTowerViewBedroomColor] = useState<boolean>(false);
  // Bedroom / unit type filter (multi-select: empty array = show all)
  const [towerViewUnitTypes, setTowerViewUnitTypes] = useState<string[]>([]);
  const [towerViewBedroomFilter, setTowerViewBedroomFilter] = useState<number[]>([]);
  const [towerViewUnitTypeFilter, setTowerViewUnitTypeFilter] = useState<string[]>([]);

  // Tower view main tab mode (tower vs site map)
  const [towerViewMainTab, setTowerViewMainTab] = useState<'tower' | 'sitemap'>('tower');

  // Tower view floor plan dialog state
  const [towerViewFloorPlanOpen, setTowerViewFloorPlanOpen] = useState<boolean>(false);
  const [selectedTowerViewUnitForFloorPlan, setSelectedTowerViewUnitForFloorPlan] = useState<TowerViewUnit | ComparableUnit | null>(null);
  const [towerViewFloorPlanRefreshing, setTowerViewFloorPlanRefreshing] = useState<boolean>(false);
  const towerViewFloorPlanOpenRequestRef = useRef(0);
  
  // Floor plan modal state
  const [floorPlanOpen, setFloorPlanOpen] = useState<boolean>(false);
  const [selectedUnitForFloorPlan, setSelectedUnitForFloorPlan] = useState<ComparableUnit | ReferenceUnit | null>(null);
  const [floorPlanRefreshing, setFloorPlanRefreshing] = useState<boolean>(false);
  const floorPlanOpenRequestRef = useRef(0);
  
  // Floor plan comparison state
  const [floorPlanCompareOpen, setFloorPlanCompareOpen] = useState<boolean>(false);
  const [compareFloorPlanZoom, setCompareFloorPlanZoom] = useState<number>(1);
  const [compareDialogSource, setCompareDialogSource] = useState<'generic' | 'topViewing'>('generic');
  const compareDragIndexRef = useRef<number | null>(null);
  const [compareDragActiveIndex, setCompareDragActiveIndex] = useState<number | null>(null);
  const [compareDragOverIndex, setCompareDragOverIndex] = useState<number | null>(null);
  const compareDragImageRef = useRef<HTMLDivElement | null>(null);
  const [compareExpandedView, setCompareExpandedView] = useState<boolean>(false);
  const [compareFocusedUnitId, setCompareFocusedUnitId] = useState<number | null>(null);
  const [compareVisualizerMode, setCompareVisualizerMode] = useState<'floorplan' | 'siteplan'>('floorplan');
  const [compareQuickReferenceOpen, setCompareQuickReferenceOpen] = useState<boolean>(true);
  const [compareShowSitePlanPoints, setCompareShowSitePlanPoints] = useState<boolean>(true);
  const [compareSitePlansByProject, setCompareSitePlansByProject] = useState<Map<string, SitePlanData | null>>(new Map());
  const [compareSitePlansLoading, setCompareSitePlansLoading] = useState<boolean>(false);
  const [floorPlansToCompare, setFloorPlansToCompare] = useState<Array<{
    unit: ComparableUnit | ReferenceUnit;
    imageUrl: string;
  }>>([]);

  // Drawing annotation state for floor plan comparison
  const [drawToolbarState, setDrawToolbarState] = useState<DrawToolbarState>({
    isDrawMode: false,
    activeColor: '#FF0000',
    lineWidth: 4,
    activeTool: 'pen',
  });
  const [drawingStates, setDrawingStates] = useState<DrawingStatesMap>({});
  const [compareFloorPlanRotations, setCompareFloorPlanRotations] = useState<Record<number, number>>({});
  const [compareSitePlanRotations, setCompareSitePlanRotations] = useState<Record<number, number>>({});
  const [compareFloorPlanFlips, setCompareFloorPlanFlips] = useState<Record<number, boolean>>({});
  const [compareSitePlanFlips, setCompareSitePlanFlips] = useState<Record<number, boolean>>({});
  const [compareExportMenuAnchor, setCompareExportMenuAnchor] = useState<HTMLElement | null>(null);
  const [compareExportingPdf, setCompareExportingPdf] = useState<boolean>(false);


  // Site plan modal state
  const [sitePlanOpen, setSitePlanOpen] = useState<boolean>(false);
  const [sitePlanData, setSitePlanData] = useState<SitePlanData | null>(null);
  const [sitePlanLoading, setSitePlanLoading] = useState<boolean>(false);
  const [sitePlanAvailability, setSitePlanAvailability] = useState<Map<string, boolean>>(new Map());
  const [towerViewOpenedFromSitePlan, setTowerViewOpenedFromSitePlan] = useState<boolean>(false);
  const [sitePlanShowPoints, setSitePlanShowPoints] = useState<boolean>(true);
  const [sitePlanMenuOpen, setSitePlanMenuOpen] = useState<boolean>(false);
  const [sitePlanBedroomFilter, setSitePlanBedroomFilter] = useState<number[]>([]);
  const [sitePlanStackFilter, setSitePlanStackFilter] = useState<string[]>([]);
  const [sitePlanStackBedrooms, setSitePlanStackBedrooms] = useState<Map<string, number>>(new Map());
  const [sitePlanUnitTypeFilter, setSitePlanUnitTypeFilter] = useState<number[]>([]);
  const [sitePlanUnitTypes, setSitePlanUnitTypes] = useState<Array<{ id: number; unitType?: string; description?: string; unitTypeCode?: string; bedroom?: number; size?: number }>>([]);
  const [sitePlanUnitTypeStacks, setSitePlanUnitTypeStacks] = useState<{ [key: string]: string[] }>({});
  const [sitePlanBlinkingStacks, setSitePlanBlinkingStacks] = useState<Set<string>>(new Set());
  const [sitePlanShowHeatMap, setSitePlanShowHeatMap] = useState<boolean>(true);
  const [sitePlanStackSoldPercentages, setSitePlanStackSoldPercentages] = useState<Map<string, number>>(new Map());
  const isMobileSitePlan = useMediaQuery('(max-width:768px)');
  const isMobileViewport = useMediaQuery('(max-width:599.95px)');
  const isTabletViewport = useMediaQuery('(min-width:600px) and (max-width:1199.95px)');
  // Quick Reference: side panel on tablet landscape + desktop; bottom bar on phone and tablet portrait.
  const compareQuickRefSideBySide = useMediaQuery('(min-width:600px) and (orientation: landscape), (min-width:1200px)');
  const masterToolPageSize = isMobileViewport ? 20 : isTabletViewport ? 50 : 100;
  const sitePlanDotSize = isMobileSitePlan ? 14 : 28;
  const sitePlanDotBorder = isMobileSitePlan ? '1px solid var(--color-white)' : '2px solid var(--color-white)';
  const sitePlanDotShadow = isMobileSitePlan ? '0 1px 2px rgba(var(--color-shadow-rgb), 0.25)' : '0 2px 4px rgba(var(--color-shadow-rgb), 0.3)';
  const sitePlanDotFontSize = isMobileSitePlan ? '0.45rem' : '0.65rem';
  const [stackAnalysisOpen, setStackAnalysisOpen] = useState<boolean>(false);
  const [stackAnalysisLoading, setStackAnalysisLoading] = useState<boolean>(false);
  const [stackAnalysisData, setStackAnalysisData] = useState<any>(null);
  const [stackAnalysisUnitMenuAnchor, setStackAnalysisUnitMenuAnchor] = useState<{ element: HTMLElement; unit: any } | null>(null);
  const [stackAnalysisSetReferenceLoading, setStackAnalysisSetReferenceLoading] = useState<boolean>(false);
  const stackAnalysisOpenRef = useRef<boolean>(false);
  const stackAnalysisDataRef = useRef<any>(null);
  const activeTabIdRef = useRef<string>(activeTabId);
  const selectedProjectRef = useRef<string>(selectedProject);
  const currentViewingProjectNameRef = useRef<string | null>(null);
  const resolveProjectIdByNameRef = useRef<(projectName: string) => Promise<string | null>>(async () => null);
  const updateTabStateRef = useRef(updateTabState);
  const normalizeStackKeyRef = useRef(normalizeStackKey);
  const towerViewIsolatedFromMainRef = useRef<boolean>(towerViewIsolatedFromMain);

  type TabVisualState = {
    sitePlanData: SitePlanData | null;
    towerViewUnits: TowerViewUnit[];
    towerViewUnitTypes: string[];
    sitePlanStackBedrooms: Map<string, number>;
    sitePlanUnitTypes: Array<{ id: number; unitType?: string; description?: string; unitTypeCode?: string; bedroom?: number; size?: number }>;
    sitePlanUnitTypeStacks: { [key: string]: string[] };
    sitePlanStackSoldPercentages: Map<string, number>;
  };
  const [tabVisualStates, setTabVisualStates] = useState<Map<string, TabVisualState>>(new Map());
  const previousTabIdRef = useRef<string>(activeTabId);
  useEffect(() => {
    const previousTabId = previousTabIdRef.current;
    if (previousTabId === activeTabId) return;

    // Persist visuals of the tab we are leaving.
    setTabVisualStates((prev) => {
      const next = new Map(prev);
      next.set(previousTabId, {
        sitePlanData,
        towerViewUnits,
        towerViewUnitTypes,
        sitePlanStackBedrooms,
        sitePlanUnitTypes,
        sitePlanUnitTypeStacks,
        sitePlanStackSoldPercentages,
      });
      return next;
    });

    // Restore visuals for the tab we are entering.
    const targetVisualState = tabVisualStates.get(activeTabId);
    setSitePlanData(targetVisualState?.sitePlanData ?? null);
    setTowerViewUnits(targetVisualState?.towerViewUnits ?? []);
    setTowerViewUnitTypes(targetVisualState?.towerViewUnitTypes ?? []);
    setSitePlanStackBedrooms(targetVisualState?.sitePlanStackBedrooms ?? new Map());
    setSitePlanUnitTypes(targetVisualState?.sitePlanUnitTypes ?? []);
    setSitePlanUnitTypeStacks(targetVisualState?.sitePlanUnitTypeStacks ?? {});
    setSitePlanStackSoldPercentages(targetVisualState?.sitePlanStackSoldPercentages ?? new Map());

    previousTabIdRef.current = activeTabId;
  }, [activeTabId, sitePlanData, towerViewUnits, towerViewUnitTypes, sitePlanStackBedrooms, sitePlanUnitTypes, sitePlanUnitTypeStacks, sitePlanStackSoldPercentages, tabVisualStates]);

  // Effect to handle blinking animation when filters change
  useEffect(() => {
    const areSetsEqual = (a: Set<string>, b: Set<string>): boolean => {
      if (a.size !== b.size) return false;
      return Array.from(a).every((value) => b.has(value));
    };

    if (sitePlanBedroomFilter.length === 0 && sitePlanUnitTypeFilter.length === 0 && sitePlanStackFilter.length === 0) {
      setSitePlanBlinkingStacks((prev) => (prev.size === 0 ? prev : new Set()));
      return;
    }

    const bedroomMatchingStacks = new Set<string>();
    const unitTypeMatchingStacks = new Set<string>();
    const allAvailableStacks = new Set<string>();

    sitePlanStackBedrooms.forEach((_, stack) => {
      const normalized = normalizeStackKey(stack);
      if (normalized) allAvailableStacks.add(normalized);
      const compositeMatch = String(stack).trim().match(/^(\d+)-(\d+)$/);
      if (compositeMatch) {
        allAvailableStacks.add(`${compositeMatch[1]}-${normalizeStackKey(compositeMatch[2])}`);
      }
    });

    sitePlanData?.blocks?.forEach((block) => {
      const normalized = normalizeStackKey(block.stack);
      if (normalized) allAvailableStacks.add(normalized);
      const blockNum = (block.blockNumber || '').replace(/\D/g, '');
      if (blockNum && normalized) allAvailableStacks.add(`${blockNum}-${normalized}`);
    });

    // Find stacks that match the selected bedroom types
    if (sitePlanBedroomFilter.length > 0) {
      const penthouseStackKeys = new Set<string>();
      towerViewUnits.forEach((unit) => {
        if (!isPenthouseUnit(unit)) return;
        const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
        if (parsed.stack == null) return;
        const normalizedStack = normalizeStackKey(parsed.stack);
        if (normalizedStack) penthouseStackKeys.add(normalizedStack);
        const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
        if (blockNum && normalizedStack) penthouseStackKeys.add(`${blockNum}-${normalizedStack}`);
      });

      // Primary source: explicit stack->bedroom mapping from backend.
      sitePlanStackBedrooms.forEach((bedroom, stack) => {
        const normalizedStack = normalizeStackKey(stack);
        const normalizedBedroom = normalizeBedroomValue(bedroom);
        const matchesBedroom = sitePlanBedroomFilter.some((filterValue) => {
          if (filterValue === PENTHOUSE_FILTER_VALUE) return false;
          return !penthouseStackKeys.has(normalizedStack) && normalizedBedroom != null && normalizedBedroom === filterValue;
        });
        if (matchesBedroom) {
          bedroomMatchingStacks.add(normalizedStack);
        }
      });

      // Fallback source: derive stack->bedroom from tower-view units when mapping is incomplete.
      towerViewUnits.forEach((unit) => {
        const normalizedBedroom = normalizeBedroomValue(unit.bedroom);
        const unitIsPenthouse = isPenthouseUnit(unit);
        const matchesBedroom = sitePlanBedroomFilter.some((filterValue) => {
          if (filterValue === PENTHOUSE_FILTER_VALUE) return unitIsPenthouse;
          return !unitIsPenthouse && normalizedBedroom != null && normalizedBedroom === filterValue;
        });
        if (!matchesBedroom) {
          return;
        }
        const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
        if (parsed.stack != null) {
          const normalizedStack = normalizeStackKey(parsed.stack);
          bedroomMatchingStacks.add(normalizedStack);
          allAvailableStacks.add(normalizedStack);
          // For multi-block projects, site plan may use block-stack composite (e.g. "53-12")
          const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
          if (blockNum) {
            const compositeKey = `${blockNum}-${normalizedStack}`;
            bedroomMatchingStacks.add(compositeKey);
            allAvailableStacks.add(compositeKey);
          }
        }
      });
    }

    // Find stacks that match the selected unit types (by ProjectUnitTypeId)
    if (sitePlanUnitTypeFilter.length > 0) {
      // Primary source: Use unit-type-stacks mapping from backend (maps description -> stacks)
      // Convert selected IDs to descriptions/unitTypes first (try both for lookup)
      const filterIds = new Set(sitePlanUnitTypeFilter.map((id) => Number(id)));
      sitePlanUnitTypes.forEach((ut) => {
        if (!filterIds.has(Number(ut.id))) return;
        const stacksFromDesc = sitePlanUnitTypeStacks[ut.description || ''] || [];
        const utTypes = (ut as unknown as { unitTypes?: string[] })?.unitTypes;
        const typeKeys = Array.isArray(utTypes) && utTypes.length > 0
          ? utTypes
          : (ut.unitType && ut.unitType !== ut.description ? [ut.unitType] : []);
        const stacksFromTypes = typeKeys.flatMap((t) => sitePlanUnitTypeStacks[t] || []);
        const stacks = stacksFromDesc.length > 0 ? stacksFromDesc : Array.from(new Set(stacksFromTypes));
        stacks.forEach((stack) => {
          unitTypeMatchingStacks.add(normalizeStackKey(stack));
        });
      });

      // Fallback source: Check units directly by projectUnitTypeId (in case mapping is incomplete)
      towerViewUnits.forEach((unit) => {
        const unitTypeId = unit.projectUnitTypeId != null ? Number(unit.projectUnitTypeId) : null;
        if (unitTypeId != null && filterIds.has(unitTypeId)) {
          const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
          if (parsed.stack != null) {
            const normalizedStack = normalizeStackKey(parsed.stack);
            unitTypeMatchingStacks.add(normalizedStack);
            allAvailableStacks.add(normalizedStack);
            const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
            if (blockNum) {
              const compositeKey = `${blockNum}-${normalizedStack}`;
              unitTypeMatchingStacks.add(compositeKey);
              allAvailableStacks.add(compositeKey);
            }
          }
        }
      });
    }

    towerViewUnits.forEach((unit) => {
      const parsed = parseUnitNumber(unit.unitNumber);
      if (parsed.stack == null) return;
      const normalizedStack = normalizeStackKey(parsed.stack);
      if (!normalizedStack) return;
      allAvailableStacks.add(normalizedStack);
      const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
      if (blockNum) {
        allAvailableStacks.add(`${blockNum}-${normalizedStack}`);
      }
    });

    // When multiple filters active: intersection. Otherwise use the single filter's set.
    let matchingStacks = new Set<string>();
    if (sitePlanBedroomFilter.length > 0 && sitePlanUnitTypeFilter.length > 0) {
      bedroomMatchingStacks.forEach((key) => {
        if (unitTypeMatchingStacks.has(key)) matchingStacks.add(key);
      });
    } else if (sitePlanBedroomFilter.length > 0) {
      bedroomMatchingStacks.forEach((key) => matchingStacks.add(key));
    } else if (sitePlanUnitTypeFilter.length > 0) {
      unitTypeMatchingStacks.forEach((key) => matchingStacks.add(key));
    }

    // Apply stack filter: intersect with stackFilterSet when active
    if (sitePlanStackFilter.length > 0) {
      const stackMatchedKeys = new Set<string>();
      allAvailableStacks.forEach((key) => {
        if (matchesSelectedStackKey(sitePlanStackFilter, key)) {
          stackMatchedKeys.add(key);
        }
      });
      if (matchingStacks.size === 0) {
        matchingStacks = stackMatchedKeys;
      } else {
        const intersected = new Set<string>();
        matchingStacks.forEach((key) => {
          if (stackMatchedKeys.has(key)) intersected.add(key);
        });
        matchingStacks = intersected;
      }
    }

    setSitePlanBlinkingStacks((prev) => (areSetsEqual(prev, matchingStacks) ? prev : matchingStacks));
  }, [sitePlanBedroomFilter, sitePlanData?.blocks, sitePlanStackBedrooms, sitePlanStackFilter, sitePlanUnitTypeFilter, sitePlanUnitTypeStacks, sitePlanUnitTypes, towerViewUnits, normalizeStackKey, matchesSelectedStackKey, normalizeBedroomValue, isPenthouseUnit]);

  // Expand unit type filter to include all IDs that share the same description.
  // One description (e.g. "3 Bedroom Plus") can map to multiple unit types (C5, C6).
  // Prefer backend ids[] when available; else derive from displayed units.
  const sitePlanUnitTypeFilterExpanded = useMemo(() => {
    if (sitePlanUnitTypeFilter.length === 0) return [];
    const expandedIds = new Set<number>();
    sitePlanUnitTypeFilter.forEach((selectedId) => {
      const ut = sitePlanUnitTypes.find((u) => u.id === selectedId);
      const ids = (ut as { ids?: number[] })?.ids;
      if (Array.isArray(ids) && ids.length > 0) {
        ids.forEach((id) => expandedIds.add(Number(id)));
      } else {
        expandedIds.add(Number(selectedId));
      }
    });
    if (expandedIds.size > 0) return Array.from(expandedIds);
    const selectedDescriptionsNormalized = new Set(
      sitePlanUnitTypes
        .filter((ut) => sitePlanUnitTypeFilter.includes(ut.id))
        .flatMap((ut) => [ut.description?.trim(), ut.unitType?.trim()].filter((d): d is string => !!d))
        .map((d) => d.toLowerCase())
    );
    if (selectedDescriptionsNormalized.size === 0) return sitePlanUnitTypeFilter;
    sitePlanUnitTypeFilter.forEach((id) => expandedIds.add(Number(id)));
    const addMatchingUnits = (units: TowerViewUnit[]) => {
      units.forEach((unit) => {
        if (unit.projectUnitTypeId == null) return;
        const unitDesc = (unit.unitTypeDescription || '').trim()
          || sitePlanUnitTypes.find((ut) => ut.id === unit.projectUnitTypeId)?.description?.trim()
          || '';
        const unitType = (unit.unitType || '').trim();
        const unitDescNorm = unitDesc.toLowerCase();
        const unitTypeNorm = unitType.toLowerCase();
        const matches =
          (unitDescNorm && selectedDescriptionsNormalized.has(unitDescNorm)) ||
          (unitTypeNorm && selectedDescriptionsNormalized.has(unitTypeNorm));
        if (matches) expandedIds.add(Number(unit.projectUnitTypeId));
      });
    };
    addMatchingUnits(towerViewUnits);
    addMatchingUnits(towerViewDialogUnits);
    return Array.from(expandedIds);
  }, [sitePlanUnitTypeFilter, sitePlanUnitTypes, towerViewUnits, towerViewDialogUnits]);

  // Unit type strings (C5, C6, etc.) for expanded ids - used when projectUnitTypeId is null.
  // sitePlanUnitTypes only has one row per description, so id 11061 has no row; we derive from units.
  // Prefer ut.unitTypes (all codes for this description) when present; else fall back to ut.unitType.
  const sitePlanUnitTypeFilterExpandedUnitTypes = useMemo(() => {
    const s = new Set<string>();
    sitePlanUnitTypeFilterExpanded.forEach((id) => {
      const ut = sitePlanUnitTypes.find((u) => u.id === id) as { unitType?: string; unitTypes?: string[] } | undefined;
      const codes = Array.isArray(ut?.unitTypes) && (ut?.unitTypes?.length ?? 0) > 0
        ? ut?.unitTypes ?? []
        : (ut?.unitType?.trim() ? [ut.unitType.trim()] : []);
      codes.forEach((c) => { if (c?.trim()) s.add(c.trim()); });
    });
    [...towerViewUnits, ...towerViewDialogUnits].forEach((u) => {
      if (
        u.projectUnitTypeId != null &&
        sitePlanUnitTypeFilterExpanded.includes(u.projectUnitTypeId) &&
        u.unitType?.trim()
      ) {
        s.add(u.unitType.trim());
      }
    });
    return s;
  }, [sitePlanUnitTypeFilterExpanded, sitePlanUnitTypes, towerViewUnits, towerViewDialogUnits]);

  // Stack filter options: only unique stack numbers for the currently displayed site plan project.
  const sitePlanStacksOptions = useMemo(() => {
    const keys = new Set<string>();
    const hasBedroomFilter = sitePlanBedroomFilter.length > 0;
    const hasUnitTypeFilter = sitePlanUnitTypeFilter.length > 0;
    const selectedUnitTypes = hasUnitTypeFilter
      ? sitePlanUnitTypeFilterExpanded
        .map((id) => sitePlanUnitTypes.find((ut) => ut.id === id))
        .filter((ut): ut is NonNullable<typeof ut> => ut != null)
      : [];
    const currentSitePlanProject =
      selectedTopViewingSitePlan || projectDetails?.name || selectedProject || referenceUnit?.projectName || '';
    const unitsToUse = currentSitePlanProject
      ? [...towerViewUnits, ...towerViewDialogUnits].filter((u) => (u.projectName || '') === currentSitePlanProject)
      : [...towerViewUnits, ...towerViewDialogUnits];
    const filteredUnits = unitsToUse.filter((unit) => {
      const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
      const normalizedStack = parsed.stack != null ? normalizeStackKey(parsed.stack) : null;
      const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
      const compositeStack = blockNum && normalizedStack ? `${blockNum}-${normalizedStack}` : null;
      const stackBedroom =
        (compositeStack ? sitePlanStackBedrooms.get(compositeStack) : null)
        ?? (normalizedStack ? sitePlanStackBedrooms.get(normalizedStack) : null)
        ?? null;

      const unitBedroom = normalizeBedroomValue(unit.bedroom);
      const stackBedroomValue = normalizeBedroomValue(stackBedroom);
      const unitIsPenthouse = isPenthouseUnit(unit);

      const matchesBedroom = !hasBedroomFilter || sitePlanBedroomFilter.some((filterValue) => {
        if (filterValue === PENTHOUSE_FILTER_VALUE) return unitIsPenthouse;
        return !unitIsPenthouse && ((unitBedroom != null && unitBedroom === filterValue) || (stackBedroomValue != null && stackBedroomValue === filterValue));
      });
      if (!matchesBedroom) return false;

      if (!hasUnitTypeFilter) return true;

      if (unit.projectUnitTypeId != null && sitePlanUnitTypeFilterExpanded.includes(unit.projectUnitTypeId)) {
        return true;
      }

      if (unit.unitType?.trim()) {
        return (
          selectedUnitTypes.some((ut) => ut.unitType === unit.unitType || ut.description === unit.unitType) ||
          sitePlanUnitTypeFilterExpandedUnitTypes.has(unit.unitType.trim())
        );
      }

      return false;
    });

    filteredUnits.forEach((unit) => {
      const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
      if (parsed.stack != null) {
        const norm = normalizeStackKey(parsed.stack);
        if (norm) keys.add(norm);
      }
    });
    if (keys.size === 0 && !hasBedroomFilter && !hasUnitTypeFilter) {
      sitePlanStackBedrooms.forEach((_, stack) => {
        const norm = normalizeStackKey(stack);
        if (norm) keys.add(norm);
      });
      sitePlanData?.blocks?.forEach((block) => {
        if (block.stack) {
          const norm = normalizeStackKey(block.stack);
          if (norm) keys.add(norm);
        }
      });
    }
    const numericStacks = Array.from(keys).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
    return numericStacks.length > 0
      ? [STACK_FILTER_ODD_VALUE, STACK_FILTER_EVEN_VALUE, ...numericStacks]
      : numericStacks;
  }, [
    towerViewUnits,
    towerViewDialogUnits,
    selectedTopViewingSitePlan,
    selectedProject,
    projectDetails?.name,
    referenceUnit?.projectName,
    sitePlanBedroomFilter,
    sitePlanStackBedrooms,
    sitePlanUnitTypeFilter,
    sitePlanUnitTypeFilterExpanded,
    sitePlanUnitTypeFilterExpandedUnitTypes,
    sitePlanUnitTypes,
    sitePlanData?.blocks,
    normalizeStackKey,
    STACK_FILTER_EVEN_VALUE,
    STACK_FILTER_ODD_VALUE,
    normalizeBedroomValue,
    isPenthouseUnit,
    parseUnitNumber,
  ]);

  useEffect(() => {
    if (sitePlanStackFilter.length === 0) return;
    const availableStacks = new Set(sitePlanStacksOptions.map((stack) => normalizeStackFilterValue(stack)).filter(Boolean));
    const nextFilter = sitePlanStackFilter.filter((stack) => availableStacks.has(normalizeStackFilterValue(stack)));
    if (nextFilter.length !== sitePlanStackFilter.length) {
      setSitePlanStackFilter(nextFilter);
    }
  }, [sitePlanStackFilter, sitePlanStacksOptions, normalizeStackFilterValue]);

  // Helper function to convert sold percentage to heat map color (green to red)
  const getHeatMapColor = useCallback((percentage: number): string => {
    // Clamp percentage between 0 and 100
    const clampedPercentage = Math.max(0, Math.min(100, percentage));

    // Calculate RGB values
    // Green (low sold) = rgb(0, 255, 0)
    // Red (high sold) = rgb(255, 0, 0)
    // Interpolate between them based on percentage
    const red = Math.round((clampedPercentage / 100) * 255);
    const green = Math.round(((100 - clampedPercentage) / 100) * 255);
    const blue = 0;

    return `rgb(${red}, ${green}, ${blue})`;
  }, []);

  const shouldHideNonMatchingSitePlanStack = useCallback((stack: string | number | null | undefined, blockNumber?: string | null): boolean => {
    // Always hide non-matching stacks when filters are active (both mobile and desktop)
    if (sitePlanBedroomFilter.length === 0 && sitePlanUnitTypeFilter.length === 0 && sitePlanStackFilter.length === 0) return false;

    const normalizedStack = normalizeStackKey(stack);
    if (!normalizedStack) return true;

    // When filters are active, hide if stack is not in blinking set (supports block-stack composite)
    const blockNum = (blockNumber || '').replace(/\D/g, '');
    const compositeKey = blockNum ? `${blockNum}-${normalizedStack}` : null;
    const isInBlinkingSet = sitePlanBlinkingStacks.has(normalizedStack) ||
      (compositeKey != null && sitePlanBlinkingStacks.has(compositeKey));
    return !isInBlinkingSet;
  }, [sitePlanBedroomFilter, sitePlanUnitTypeFilter, sitePlanBlinkingStacks]);

  // AI Summary modal state
  const [aiSummaryOpen, setAiSummaryOpen] = useState<boolean>(false);
  
  // Price history chart state
  const [priceChartOpen, setPriceChartOpen] = useState<boolean>(false);
  const [priceChartLoading, setPriceChartLoading] = useState<boolean>(false);
  const [priceChartData, setPriceChartData] = useState<PriceHistoryResponse | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_priceChartUnitId, setPriceChartUnitId] = useState<number | null>(null);
  const [priceChartType, setPriceChartType] = useState<'price' | 'psf'>('price');
  // Which tab of the Price History dialog is active: the price/psf chart or the
  // "Share" designer. Kept separate from priceChartType so the chart keeps its
  // own price/psf toggle semantics.
  const [priceDialogTab, setPriceDialogTab] = useState<'price' | 'psf' | 'share'>('price');
  // Bedroom count for the charted unit — not carried by PriceHistoryResponse, so
  // it is threaded in from the call site for the Share templates.
  const [priceChartBedroom, setPriceChartBedroom] = useState<number | null>(null);
  const [pricePromoInfoOpen, setPricePromoInfoOpen] = useState<boolean>(false);
  const [aiSummaryReport, setAiSummaryReport] = useState<string | null>(null);
  const [aiSummaryData, setAiSummaryData] = useState<{
    stats: any;
    radarData: any[];
    barData: any[];
    comparisonData: any[];
  } | null>(null);
  const [userInfo, setUserInfo] = useState<{ Name?: string; Mobile?: string; Email?: string; CEANumber?: string; Photo?: string } | null>(null);
  const [userRole, setUserRole] = useState<string>('');
  const [userRoles, setUserRoles] = useState<string[]>([]);
  const [userSessionLoaded, setUserSessionLoaded] = useState(false);
  // True when the user is a Project Verification responsible party (Head/Deputy
  // Head of Project, or the IC of a project without one) on at least one
  // active, visible project — i.e. /api/project-verification/my-projects
  // returns rows. Gates the "Others -> Project Verification" entry.
  const [hasVerifiableProjects, setHasVerifiableProjects] = useState<boolean>(false);
  const [projectActionOpen, setProjectActionOpen] = useState(false);
  // Who Project Action is for: admins, project leads, and anyone holding calls.
  // Resolved once on session load so the 10k-odd agents with nothing assigned
  // never see the entry.
  const [projectActionAccess, setProjectActionAccess] = useState({
    isAdmin: false,
    leadsProjects: false,
    hasTasks: false,
  });
  const normalizedUserRoles = useMemo(() => {
    const roles = userRoles.length > 0 ? userRoles : [userRole];
    return new Set(roles.map((role) => role.trim().toUpperCase()).filter(Boolean));
  }, [userRole, userRoles]);
  const hasUserRole = useCallback((role: string) => normalizedUserRoles.has(role), [normalizedUserRoles]);
  const isAdminUser = hasUserRole('ADMIN');

  // Project Essentials Analytics — admins, plus holders of the dedicated
  // ESSENTIAL-ANALYTICS role (an active TransformationAppUserAccess row with
  // App='SUPER_PICKER' and Role='ESSENTIAL-ANALYTICS'; those rows are what
  // populate `roles` on the session). Mirrored server-side by
  // requireAdminOrEssentialAnalytics on the PE analytics admin routes.
  const canAccessProjectEssentialsAnalytics =
    isAdminUser || hasUserRole('ESSENTIAL-ANALYTICS');
  // Super Connector schedule setup is restricted to a single CEA for now
  // (enforced server-side by requireConnectorScheduleAdmin). Client gate is
  // cosmetic — it only decides whether the admin nav item is shown.
  const canManageConnectorSchedule =
    (userInfo?.CEANumber || '').trim().toUpperCase() === 'HT260114';
  const isProjectDeptUser = hasUserRole('PROJECT-DEPT');
  const isAcceleratorUser = hasUserRole('ACCELERATOR');
  const isExternalUser = hasUserRole('EXTERNAL');
  // Manage Videos — admins, plus holders of the dedicated VIDEO-APPROVER role
  // (App='SUPER_PICKER', Role='VIDEO-APPROVER'). Mirrored server-side by
  // requireAdminOrVideoApprover on verify/reject.
  const isVideoApprover = hasUserRole('VIDEO-APPROVER');
  const canManageVideos = isAdminUser || isVideoApprover;
  // VIDEO-UPLOADER — dedicated grant for My Videos + Add Video (no approve queue).
  const isVideoUploader = hasUserRole('VIDEO-UPLOADER');
  // My Videos (submitter management) — admins, accelerators, project ICs,
  // and VIDEO-UPLOADER.
  const canAccessMyVideos =
    isAdminUser || isAcceleratorUser || hasVerifiableProjects || isVideoUploader;
  // Shows the sidebar's `Project Head` group: project leads (Head / Deputy Head,
  // or the IC of a project with neither), admins and Project Dept.
  const isProjectHeadUser =
    isAdminUser || isProjectDeptUser || hasVerifiableProjects || projectActionAccess.leadsProjects;
  // Nearby Deals is available to every authenticated internal user (mirrored
  // server-side by `canAccessNearbyDeal` in /api/users/me). EXTERNAL sessions
  // are excluded like the rest of the internal-only deal views.
  const canAccessNearbyDeal = userSessionLoaded && userInfo !== null && !isExternalUser;
  // Super Ratio (demand/supply) is available to every authenticated user.
  const canAccessSuperRatio = userSessionLoaded && userInfo !== null;
  // Commission Structure dialog — admins plus holders of the
  // dedicated COMM-STRUCTURE role (an active TransformationAppUserAccess row
  // with App='SUPER_PICKER' and Role='COMM-STRUCTURE'; those rows are what
  // populate `roles` on the session). Mirrored server-side by
  // requireAdminOrCommissionStructure on /api/projects/commission-structure.
  // Only admins see the "Matched EcoProp" column — see the `isAdmin` prop on
  // the dialog, and the endpoint omits the `ecoProp*` fields for everyone else.
  const canAccessCommissionStructure =
    isAdminUser || hasUserRole('COMM-STRUCTURE');
  // Super Showcase menu — every authenticated user. /api/super-showcase/showcases
  // serves non-admins published showcases only. Authoring stays admin-only
  // (Manage Super Showcase).
  const canAccessSuperShowcase = userSessionLoaded && userInfo !== null;
  // Super Map tab — admins, ACCELERATORs, plus holders of the dedicated
  // SUPER-MAP role (an active TransformationAppUserAccess row with
  // App='SUPER_PICKER' and Role='SUPER-MAP'; those rows are what populate
  // `roles` on the session).
  const canAccessSuperMap = isAdminUser || isAcceleratorUser || hasUserRole('SUPER-MAP');
  // Site-plan 3D (massing) and 3DS (Solar Explorer) are open to every user.
  // The per-project lockdown in TopViewingSitePlanDetail still narrows both to
  // ADMIN and PROJECT-DEPT on restricted projects, and the 3D Map surface
  // inside them stays admin-only (`canViewMap`). The north read is opened
  // server-side to match — see requireAdminOrSitePlan3dSun.
  const canAccessSitePlan3dSun = true;
  const canAccessSitePlan3d = true;
  // 3D Sitemap menu — admin-only, reads included. Every endpoint under
  // /api/picker-3d-sitemap is on `requireAdmin`, so this gate is not the only
  // thing standing between an agent and the module.
  const canAccessSitemap3d = isAdminUser;
  // Both per-unit floor plan 3D modes are admin-only, and deliberately do NOT
  // follow the site-plan grants: everyone opens the site plan in 3D, never the
  // floor plan. Server-side, `/api/units/:id/floor-plan-solar`
  // is on `requireAdmin` while the site-plan north read honours the wider set —
  // see requireAdminOrSitePlan3dSun.
  const canAccessFloorPlan3d = isAdminUser;
  const canAccessFloorPlan3dSun = isAdminUser;
  // Floor plan 2D | 3D | 3DS — a selection without the matching grant resolves
  // to 2D. Shared by both floor plan dialogs.
  const [floorPlanViewModeSelection, setFloorPlanViewMode] = useState<'2d' | '3d' | '3ds'>('2d');
  const floorPlanViewMode: '2d' | '3d' | '3ds' =
    (floorPlanViewModeSelection === '3d' && canAccessFloorPlan3d)
      || (floorPlanViewModeSelection === '3ds' && canAccessFloorPlan3dSun)
      ? floorPlanViewModeSelection
      : '2d';
  const selectFloorPlanViewMode = useCallback((mode: '2d' | '3d' | '3ds', unit: { id: number; projectName: string; unitNumber: string } | null) => {
    setFloorPlanViewMode(mode);
    if (mode !== '2d' && unit) {
      logFloorPlan3dOpened({ projectName: unit.projectName, unitNumber: unit.unitNumber, unitId: unit.id, source: 'floor_plan_dialog',
        ceaNumber: userInfo?.CEANumber || getDevCea(), mode });
    }
  }, [userInfo?.CEANumber]);
  const floorPlanUnitLabel = (unit: { blockNumber?: string | null; unitNumber: string; unitType?: string | null; unitTypeDescription?: string | null }) =>
    [unit.blockNumber ? `Blk ${String(unit.blockNumber).replace(/^blk\s*/i, '')}` : null, unit.unitNumber,
      unit.unitType ? `Type ${unit.unitType}` : unit.unitTypeDescription || null].filter(Boolean).join(' · ');
  // Price Promo and all of its views/tools are available to every authenticated user.
  const canAccessPricePromo = userSessionLoaded && userInfo !== null;
  const canUsePricePromoShareTools = canAccessPricePromo;
  // The Price Promo Watchlist menu (Watchlist + Anticipate tabs) is open to every
  // authenticated user. The endpoints stay scoped
  // server-side: watchlists are per-agent, and only admins and a project's
  // responsible party (Head/Deputy Head, or the IC when there is neither) can
  // create or edit an Anticipate promo — everyone else reads it and registers
  // interest.
  const canAccessPricePromoWatchlist = canAccessPricePromo;
  const canAccessSuccessCloser = !isExternalUser;
  const canAccessSharableLinks = !isExternalUser;

  // Attendance deep link auto-marking state.
  // Marks attendance with the QR JWT from the deep link once the user session
  // is ready; the backend rejects expired tokens.
  const [attendanceMarkState, setAttendanceMarkState] = useState<{
    open: boolean;
    loading: boolean;
    successMessage: string | null;
    error: string | null;
    token: string;
    eventId: string;
  } | null>(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('redirect') !== 'mark-attendance') return null;
    const token = (params.get('attendanceToken') || params.get('token') || '').trim();
    const eventId = (params.get('eventId') || '').trim();
    if (!token || !eventId) return null;
    return {
      open: true,
      loading: false,
      successMessage: null,
      error: null,
      token,
      eventId,
    };
  });

  const [targetEventDetails, setTargetEventDetails] = useState<RegistrationEventSummary | null>(null);

  const formatEventDateRange = useCallback((startStr: string, endStr: string) => {
    const start = new Date(startStr);
    const end = new Date(endStr);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return '';
    
    const dateOptions: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    };
    
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    
    const sameDay = start.toDateString() === end.toDateString();
    
    if (sameDay) {
      return `${start.toLocaleDateString('en-SG', dateOptions)} (${start.toLocaleTimeString('en-SG', timeOptions)} - ${end.toLocaleTimeString('en-SG', timeOptions)})`;
    }
    return `${start.toLocaleDateString('en-SG', dateOptions)} ${start.toLocaleTimeString('en-SG', timeOptions)} - ${end.toLocaleDateString('en-SG', dateOptions)} ${end.toLocaleTimeString('en-SG', timeOptions)}`;
  }, []);

  const clearAttendanceMarkDialog = useCallback(() => {
    setAttendanceMarkState(null);
  }, []);

  const triggerAutoAttendance = useCallback(async (token: string, eventId: string) => {
    setAttendanceMarkState((prev) => prev ? { ...prev, loading: true, error: null, successMessage: null } : null);
    
    // Try to load event details first
    let locationRequired = false;
    try {
      const events = await api.getRegistrationEvents('all');
      let found = events.find((ev) => ev.id === eventId) || null;
      if (!found) {
        const registered = await api.getRegisteredTrainingEvents('all');
        found = registered.find((ev) => ev.id === eventId) || null;
      }
      if (found) {
        setTargetEventDetails(found);
        locationRequired = found.locationRequired === true;
      }
    } catch (e) {
      console.error('Failed to pre-fetch event details:', e);
    }

    try {
      let latitude: number = 0;
      let longitude: number = 0;
      if (locationRequired) {
      try {
        const coords = await getAttendanceCoordinatesWithRetry();
        latitude = coords.latitude;
        longitude = coords.longitude;
      } catch (err) {
        throw new Error(
          'Location access is required to mark attendance. Please enable location services/permissions and try again.'
        );
        }
      }
      
      const result = await api.markTrainingAttendance(
        eventId,
        token,
        latitude,
        longitude,
      );
      
      let successMessage: string;
      if (result.isClockOut) {
        successMessage = result.newlyMarked
          ? 'You have successfully clocked out. You can close this tab.'
          : 'You have already clocked out. You can close this tab.';
      } else {
        successMessage = result.newlyMarked
          ? 'You have successfully marked your attendance. You can close this tab.'
          : 'You have already marked your attendance. You can close this tab.';
      }
      
      setAttendanceMarkState((prev) => prev ? { ...prev, loading: false, successMessage, error: null } : null);
    } catch (err) {
      const apiErr = err as Error & { code?: string };
      const isExpiredQr = apiErr?.code === 'TOKEN_EXPIRED';
      const errorMessage = isExpiredQr
        ? 'This QR has expired. Please scan the latest QR code again.'
        : err instanceof Error
          ? err.message
          : 'Failed to mark attendance.';
      setAttendanceMarkState((prev) =>
        prev
          ? {
              ...prev,
              loading: false,
              error: errorMessage,
            }
          : null
      );
    }
  }, []);

  useEffect(() => {
    if (!userSessionLoaded || !attendanceMarkState) return;
    // Auto-trigger on initial load once user session is available
    if (
      attendanceMarkState.open &&
      !attendanceMarkState.loading &&
      !attendanceMarkState.successMessage &&
      !attendanceMarkState.error
    ) {
      void triggerAutoAttendance(attendanceMarkState.token, attendanceMarkState.eventId);
    }
  }, [userSessionLoaded, attendanceMarkState, triggerAutoAttendance]);
  const handleTopViewingSetReferenceFromMenu = useCallback((unit: TowerViewUnit | ComparableUnit) => {
    if (isExternalUser) {
      setTopViewingUnitMenuAnchor(null);
      return;
    }
    if (getUnitReferenceDisabledReason(unit)) {
      setTopViewingUnitMenuAnchor(null);
      return;
    }
    setTopViewingReferenceUnit(unit);
    logReferenceUnitSet({
      projectName: unit.projectName,
      unitNumber: unit.unitNumber,
      unitId: unit.id,
      source: 'top_viewing_unit_menu',
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });
    setTopViewingUnitMenuAnchor(null);
    setTopViewingCompFilters({ projectName: [], projectCategory: [], blockNumber: '', unitTypeDescription: [] });
    setTopViewingCompRangeFilters({
      floor: { min: '', max: '' },
      stack: { min: '', max: '' },
      bedroom: { min: '', max: '' },
      bathroom: { min: '', max: '' },
      areaSqft: { min: '', max: '' },
      price: { min: '', max: '' },
      psf: { min: '', max: '' },
      dps: { min: '', max: '' },
      outlay: { min: '', max: '' },
      installment: { min: '', max: '' },
      distance: { min: '', max: '' },
    });
    setTopViewingCompSortConfig({ column: null, direction: null });
    setTopViewingThumbsUpFilterActive(false);
    setTimeout(() => {
      topViewingComparableSectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  }, [getUnitReferenceDisabledReason, isExternalUser, userInfo?.CEANumber]);
  const handleTopViewingSetBlinkerChoiceFromMenu = useCallback((unit: TowerViewUnit | ComparableUnit) => {
    if (isExternalUser) {
      setTopViewingUnitMenuAnchor(null);
      return;
    }
    if (getUnitBlinkerDisabledReason(unit)) {
      setTopViewingUnitMenuAnchor(null);
      return;
    }
    setTopViewingBlinkerChoiceUnit(unit);
    setTopViewingUnitMenuAnchor(null);
  }, [getUnitBlinkerDisabledReason, isExternalUser]);
  const [priceMatrixSimulationSessions, setPriceMatrixSimulationSessions] = useState<Map<string, PriceMatrixSimulationSession>>(new Map());
  const [priceMatrixSimulationLoadingProjectId, setPriceMatrixSimulationLoadingProjectId] = useState<string | null>(null);
  const [priceMatrixSimulationRefreshingProjectId, setPriceMatrixSimulationRefreshingProjectId] = useState<string | null>(null);
  const [priceMatrixSimulationError, setPriceMatrixSimulationError] = useState<string | null>(null);
  const previousPriceMatrixSimulationProjectIdRef = useRef<string | null>(null);

  const persistPriceMatrixSimulationSession = useCallback((session: PriceMatrixSimulationSession) => {
    const ceaNumber = userInfo?.CEANumber?.trim();
    if (!isAdminUser && ceaNumber) {
      try {
        localStorage.setItem(
          getPriceMatrixSimulationStorageKey(ceaNumber, session.projectId),
          JSON.stringify(session)
        );
      } catch (error) {
        console.warn('Failed to persist price matrix simulation session:', error);
      }
    }
    setPriceMatrixSimulationSessions((prev) => {
      const next = new Map(prev);
      next.set(session.projectId, session);
      return next;
    });
  }, [isAdminUser, userInfo?.CEANumber]);

  const clearPriceMatrixSimulationSession = useCallback((projectId: string) => {
    const ceaNumber = userInfo?.CEANumber?.trim();
    if (!isAdminUser && ceaNumber) {
      try {
        localStorage.removeItem(getPriceMatrixSimulationStorageKey(ceaNumber, projectId));
      } catch (error) {
        console.warn('Failed to clear price matrix simulation session:', error);
      }
    }
    setPriceMatrixSimulationSessions((prev) => {
      if (!prev.has(projectId)) {
        return prev;
      }
      const next = new Map(prev);
      next.delete(projectId);
      return next;
    });
  }, [isAdminUser, userInfo?.CEANumber]);

  const clearAllPriceMatrixSimulationSessions = useCallback(() => {
    const ceaNumber = userInfo?.CEANumber?.trim();
    if (!isAdminUser && ceaNumber) {
      try {
        const storagePrefix = `${PRICE_MATRIX_SIMULATION_STORAGE_PREFIX}:${ceaNumber}:`;
        for (let index = localStorage.length - 1; index >= 0; index -= 1) {
          const key = localStorage.key(index);
          if (key?.startsWith(storagePrefix)) {
            localStorage.removeItem(key);
          }
        }
      } catch (error) {
        console.warn('Failed to clear price matrix simulation sessions:', error);
      }
    }
    setPriceMatrixSimulationSessions(new Map());
  }, [isAdminUser, userInfo?.CEANumber]);

  const buildPriceMatrixSimulationSession = useCallback((
    projectId: string,
    data: PriceMatrixSimulationResponse,
    existingSession?: PriceMatrixSimulationSession | null,
    overrides?: Partial<Pick<PriceMatrixSimulationSession, 'syncEnabled'>>
  ): PriceMatrixSimulationSession => {
    const units = Array.isArray(data.units) ? data.units : [];
    return {
      projectId,
      sheetId: data.sheetId,
      sheetUrl: data.sheetUrl ?? null,
      sheetName: data.sheetName ?? null,
      units,
      matchedUnits: data.matchedUnits ?? 0,
      unmatchedUnits: Array.isArray(data.unmatchedUnits) ? data.unmatchedUnits : [],
      statusOverrides: Object.fromEntries(
        units
          .filter((unit) => typeof unit.unitId === 'number')
          .map((unit) => [String(unit.unitId), unit.status ?? null])
      ),
      updatedAt: data.updatedAt ?? new Date().toISOString(),
      syncEnabled: overrides?.syncEnabled ?? existingSession?.syncEnabled ?? true,
    };
  }, [isAdminUser]);
  const activePriceMatrixSimulationProjectId = projectDetails?.id ?? null;
  const activePriceMatrixSimulationSession = useMemo(
    () => (activePriceMatrixSimulationProjectId
      ? (priceMatrixSimulationSessions.get(activePriceMatrixSimulationProjectId) ?? null)
      : null),
    [activePriceMatrixSimulationProjectId, priceMatrixSimulationSessions]
  );

  useEffect(() => {
    setPriceMatrixSimulationError(null);
  }, [activePriceMatrixSimulationProjectId]);

  useEffect(() => {
    const previousProjectId = previousPriceMatrixSimulationProjectIdRef.current;
    if (previousProjectId && previousProjectId !== activePriceMatrixSimulationProjectId) {
      clearPriceMatrixSimulationSession(previousProjectId);
      setPriceMatrixSimulationError(null);
    }
    previousPriceMatrixSimulationProjectIdRef.current = activePriceMatrixSimulationProjectId;
  }, [activePriceMatrixSimulationProjectId, clearPriceMatrixSimulationSession]);

  // Admin: Manage Users state
  const [manageUsersOpen, setManageUsersOpen] = useState<boolean>(false);
  const [manageUsersLoading, setManageUsersLoading] = useState<boolean>(false);
  const [manageUsersError, setManageUsersError] = useState<string | null>(null);
  const [manageUsersSuccess, setManageUsersSuccess] = useState<string | null>(null);
  const [manageUsersList, setManageUsersList] = useState<AdminUserAccess[]>([]);
  const [manageUsersTab, setManageUsersTab] = useState<ManageUsersTab>('pending');
  const [manageUsersQuery, setManageUsersQuery] = useState<string>('');
  const [manageUsersPage, setManageUsersPage] = useState<number>(0);
  const [manageUsersRowsPerPage, setManageUsersRowsPerPage] = useState<number>(25);
  const [manageUsersAddCea, setManageUsersAddCea] = useState<string>('');
  const [manageUsersAddRole, setManageUsersAddRole] = useState<string>('AGENT');
  const [manageUsersAdding, setManageUsersAdding] = useState<boolean>(false);
  const [manageUsersRevokingCea, setManageUsersRevokingCea] = useState<string | null>(null);
  const [manageUsersLoggingOutCea, setManageUsersLoggingOutCea] = useState<string | null>(null);
  const [manageUsersReviewingCea, setManageUsersReviewingCea] = useState<string | null>(null);
  const [manageUsersScreenshotUser, setManageUsersScreenshotUser] = useState<AdminUserAccess | null>(null);
  const [agentAchievementsOpen, setAgentAchievementsOpen] = useState(false);
  const [analyticsDashboardOpen, setAnalyticsDashboardOpen] = useState<boolean>(false);
  const [projectEssentialsAnalyticsOpen, setProjectEssentialsAnalyticsOpen] = useState<boolean>(false);
  const [communicationTrackingOpen, setCommunicationTrackingOpen] = useState<boolean>(false);
  const [categorizeEventsOpen, setCategorizeEventsOpen] = useState<boolean>(false);
  const [trainerManageEventsOpen, setTrainerManageEventsOpen] = useState<boolean>(false);
  const [isTrainingTrainer, setIsTrainingTrainer] = useState<boolean>(false);
  const [eventRegistrationOpen, setEventRegistrationOpen] = useState<boolean>(false);
  const [manageSiteMapOpen, setManageSiteMapOpen] = useState<boolean>(false);
  const [manageSiteMapInitialProject, setManageSiteMapInitialProject] = useState<string>('');
  // "Manage Share Links" admin dialog — owns its own open/close state.
  // Lazy fetch happens inside the dialog whenever `open` flips true.
  const [manageShareLinksOpen, setManageShareLinksOpen] = useState<boolean>(false);
  // "My Share Links" client-side variant — same dialog, `mode='mine'`.
  // Available to every non-external agent under the Clients sidebar group.
  const [myShareLinksOpen, setMyShareLinksOpen] = useState<boolean>(false);
  const [projectVerificationOpen, setProjectVerificationOpen] = useState<boolean>(false);
  const [projectVerificationInitialTab, setProjectVerificationInitialTab] = useState<'mine' | 'all'>('mine');
  const [manageProjectMessagesOpen, setManageProjectMessagesOpen] = useState<boolean>(false);
  const [myPodcastsOpen, setMyPodcastsOpen] = useState<boolean>(false);
  // Admin-only "Manage Podcast Videos" dialog — gates verification of
  // user-submitted podcast videos. Owns its own open/close state.
  const [managePodcastVideosOpen, setManagePodcastVideosOpen] = useState<boolean>(false);
  // Project Essential (Marketing Materials tab + embedded iframe) mirrors
  // backend PE auth: any logged-in internal agent. External users keep their
  // scoped share-link surfaces only.
  const canAccessProjectMaterials =
    userSessionLoaded && userInfo !== null && !isExternalUser;
  // "Leader Verifications" — eligible district directors; access flag comes
  // from /api/users/me.
  const [leaderVerificationOpen, setLeaderVerificationOpen] = useState<boolean>(false);
  // "Accelerator → Feature Release" — Super Accelerators (ACCELERATOR role only) give other
  // agents early access to unreleased features. Mirrored server-side by
  // requireAccelerator on /api/accelerator-grants.
  const [acceleratorGrantOpen, setAcceleratorGrantOpen] = useState<boolean>(false);
  const [leaderVerificationInitialTab, setLeaderVerificationInitialTab] = useState<'mine' | 'leaders'>('mine');
  const [canAccessLeaderVerification, setCanAccessLeaderVerification] = useState<boolean>(false);
  // "CPD Analytics" — admin-only dashboard, its own entry under Leader Verifications.
  const [cpdAnalyticsOpen, setCpdAnalyticsOpen] = useState<boolean>(false);
  // "Team CPD Status" — the same CPD picture scoped to one district director's team.
  // Access flag comes from /api/users/me (admins + eligible designations).
  const [teamCpdOpen, setTeamCpdOpen] = useState<boolean>(false);
  const [canAccessTeamCpd, setCanAccessTeamCpd] = useState<boolean>(false);
  // "Leader → Statistics" — share-link analytics over the leader's whole downline.
  // Access flag comes from /api/users/me (admins + eligible designations).
  const [leaderStatisticsOpen, setLeaderStatisticsOpen] = useState<boolean>(false);
  const [canAccessTeamStatistics, setCanAccessTeamStatistics] = useState<boolean>(false);
  // "Project Head → Statistics" — share-link analytics for a project the user heads.
  const [projectHeadStatisticsOpen, setProjectHeadStatisticsOpen] = useState<boolean>(false);
  // "Distinctives" — shareable EDM gallery under Others.
  const [distinctiveOpen, setDistinctiveOpen] = useState<boolean>(false);
  // Admin: Super Connector weekly schedule setup (CEA HT260114 only).
  const [manageConnectorScheduleOpen, setManageConnectorScheduleOpen] = useState<boolean>(false);

  useEffect(() => {
    if (autoOpenTrainingReviews) {
      setActiveNavItem('register-for-training');
      setEventRegistrationOpen(true);
    }
  }, [autoOpenTrainingReviews]);

  useEffect(() => {
    if (autoOpenTrainingEventId) {
      setActiveNavItem('register-for-training');
      setEventRegistrationOpen(true);
    }
  }, [autoOpenTrainingEventId]);

  // Clients dashboard state
  const [clients, setClients] = useState<ClientProfile[]>([]);
  const [clientsIndex, setClientsIndex] = useState<Map<string, ClientProfile>>(new Map());
  const [clientsLoading, setClientsLoading] = useState<boolean>(false);
  const [clientsError, setClientsError] = useState<string | null>(null);
  const [clientsDrawerOpen, setClientsDrawerOpen] = useState<boolean>(false);
  const [clientsPage, setClientsPage] = useState<number>(0);
  const [clientsPageSize, setClientsPageSize] = useState<number>(10);
  const [clientsTotal, setClientsTotal] = useState<number>(0);
  const [clientsSearch, setClientsSearch] = useState<string>('');
  const [clientsSearchDebounced, setClientsSearchDebounced] = useState<string>('');
  const [clientsProjectFilter, setClientsProjectFilter] = useState<string>('');
  const [clientEditOpen, setClientEditOpen] = useState<boolean>(false);
  const [clientEditTarget, setClientEditTarget] = useState<ClientProfile | null>(null);
  const [clientEditSaving, setClientEditSaving] = useState<boolean>(false);
  const [clientEditError, setClientEditError] = useState<string | null>(null);
  const [clientEditForm, setClientEditForm] = useState<{
    name: string;
    phone: string;
    notes: string;
    pickerChoices: string[];
  }>({
    name: '',
    phone: '',
    notes: '',
    pickerChoices: ['', '', ''],
  });
  const [clientEditUnits, setClientEditUnits] = useState<string[]>([]);
  const [clientEditUnitsLoading, setClientEditUnitsLoading] = useState<boolean>(false);
  const [clientCreateOpen, setClientCreateOpen] = useState<boolean>(false);
  const [clientCreateForm, setClientCreateForm] = useState<{
    projectId: string;
    name: string;
    phone: string;
    notes: string;
    eoiNo: string;
    ballotNo: string;
    queueNo: string;
    pickerChoices: string[];
  }>({
    projectId: '',
    name: '',
    phone: '',
    notes: '',
    eoiNo: '',
    ballotNo: '',
    queueNo: '',
    pickerChoices: ['', '', ''],
  });
  const [clientCreateUnits, setClientCreateUnits] = useState<string[]>([]);
  const [clientCreateUnitsLoading, setClientCreateUnitsLoading] = useState<boolean>(false);
  const [clientCreateSaving, setClientCreateSaving] = useState<boolean>(false);
  const [clientCreateError, setClientCreateError] = useState<string | null>(null);
  const [sheetHeaderStyle, setSheetHeaderStyle] = useState<{ left: number; width: number } | null>(null);
  const [pickerHeaderStyle, setPickerHeaderStyle] = useState<{ left: number; width: number } | null>(null);
  const [shortlistItems, setShortlistItems] = useState<ShortlistItem[]>([]);
  const [shortlistDialogOpen, setShortlistDialogOpen] = useState<boolean>(false);
  const [shortlistLoading, setShortlistLoading] = useState<boolean>(false);
  const [shortlistError, setShortlistError] = useState<string | null>(null);
  const [shortlistUpdatingUnitId, setShortlistUpdatingUnitId] = useState<number | null>(null);
  const [shortlistRemarkOpen, setShortlistRemarkOpen] = useState<boolean>(false);
  const [shortlistRemarkText, setShortlistRemarkText] = useState<string>('');
  const [shortlistRemarkUnitId, setShortlistRemarkUnitId] = useState<number | null>(null);
  const [shortlistRemarkUnitLabel, setShortlistRemarkUnitLabel] = useState<string>('');
  const [shortlistRemarkUnitFloorplan, setShortlistRemarkUnitFloorplan] = useState<string | null>(null);
  const [shortlistRemarkMode, setShortlistRemarkMode] = useState<'add' | 'edit'>('add');
  const [shortlistRemarkItemId, setShortlistRemarkItemId] = useState<number | null>(null);
  const [shortlistDeleteConfirmOpen, setShortlistDeleteConfirmOpen] = useState<boolean>(false);
  const [shortlistDeleteTarget, setShortlistDeleteTarget] = useState<ShortlistItem | null>(null);
  const [thumbsupUnits, setThumbsupUnits] = useState<ThumbsupUnit[]>([]);
  const [thumbsupDialogOpen, setThumbsupDialogOpen] = useState<boolean>(false);
  const [thumbsupLoading, setThumbsupLoading] = useState<boolean>(false);
  const [thumbsupError, setThumbsupError] = useState<string | null>(null);
  const [thumbsupProjectSearch, setThumbsupProjectSearch] = useState<string>('');
  const [thumbsupBedroomFilter, setThumbsupBedroomFilter] = useState<number[]>([]);
  const [thumbsupViewedHistory, setThumbsupViewedHistory] = useState(() => readThumbsupViewedHistory());
  const [thumbsupIntroOpen, setThumbsupIntroOpen] = useState<boolean>(false);
  const [thumbsupIntroOrigin, setThumbsupIntroOrigin] = useState<RevealOrigin | null>(null);
  const [pricePromoUnits, setPricePromoUnits] = useState<PricePromoUnit[]>([]);
  const [pricePromoDialogOpen, setPricePromoDialogOpen] = useState<boolean>(false);
  const [pricePromoViewMode, setPricePromoViewMode] = useState<'tab' | 'table'>('tab');
  const [pricePromoLoading, setPricePromoLoading] = useState<boolean>(false);
  const [pricePromoError, setPricePromoError] = useState<string | null>(null);
  const [pricePromoProjectSearch, setPricePromoProjectSearch] = useState<string>('');
  const [pricePromoBedroomFilter, setPricePromoBedroomFilter] = useState<number[]>([]);
  const [pricePromoPhOnly, setPricePromoPhOnly] = useState(false);
  // "Best Price Promo" share sheet — one A4 page listing each project's deepest promo.
  const [bestPricePromoOpen, setBestPricePromoOpen] = useState(false);
  // Daily "reveal" budget for the masked Price Promo table view (non-admin only).
  const [pricePromoRevealState, setPricePromoRevealState] = useState<PricePromoRevealState | null>(null);
  const pricePromoRevealedUnitIds = useMemo(
    () => new Set(pricePromoRevealState?.revealedUnitIds ?? []),
    [pricePromoRevealState],
  );
  const [pricePromoLatestExpanded, setPricePromoLatestExpanded] = useState<boolean>(false);
  const [pricePromoTopSavingExpanded, setPricePromoTopSavingExpanded] = useState<boolean>(false);
  const [pricePromoTopSavingGroupExpanded, setPricePromoTopSavingGroupExpanded] = useState<Set<string>>(new Set());
  const [pricePromoAllExpanded, setPricePromoAllExpanded] = useState<boolean>(false);

  // Price Promo Watchlist: per-client alerts matched against the price promo feed.
  const [pricePromoWatchlists, setPricePromoWatchlists] = useState<PricePromoWatchlist[]>([]);
  const [pricePromoWatchlistDialogOpen, setPricePromoWatchlistDialogOpen] = useState<boolean>(false);
  const [pricePromoWatchlistLoading, setPricePromoWatchlistLoading] = useState<boolean>(false);
  const [pricePromoWatchlistError, setPricePromoWatchlistError] = useState<string | null>(null);
  const [pricePromoWatchlistTab, setPricePromoWatchlistTab] = useState<PricePromoWatchlistDialogTab>('watchlist');
  const [acknowledgedPricePromoUpdates, setAcknowledgedPricePromoUpdates] = useState<Set<string>>(
    loadAcknowledgedPricePromoUpdates,
  );

  // Super Showcase: admin-curated interactive images. Clicking a mapped area
  // opens the Super Picker function it points at (Price Promo, Thumbsup, or a
  // pre-filled Project Research search).
  const [superShowcases, setSuperShowcases] = useState<SuperShowcase[]>([]);
  const [superShowcasesLoading, setSuperShowcasesLoading] = useState<boolean>(false);
  const [superShowcasesError, setSuperShowcasesError] = useState<string | null>(null);
  const [superShowcaseDialogOpen, setSuperShowcaseDialogOpen] = useState<boolean>(false);
  /** Set once the first showcase list request has settled (deep link waits on it). */
  const [superShowcasesFetched, setSuperShowcasesFetched] = useState<boolean>(false);
  // Share link: htns.sg/super-picker?redirect=showcase&id=N opens that showcase.
  const [deepLinkShowcaseId, setDeepLinkShowcaseId] = useState<number | null>(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('redirect') !== 'showcase') return null;
    const id = Number(params.get('id'));
    return Number.isInteger(id) && id > 0 ? id : null;
  });
  const [initialShowcaseId, setInitialShowcaseId] = useState<number | null>(null);
  const clearInitialShowcaseId = useCallback(() => setInitialShowcaseId(null), []);
  const [regionMarket, setRegionMarket] = useState<SuperShowcaseRegion | null>(null);
  const [sitemap3dDialogOpen, setSitemap3dDialogOpen] = useState<boolean>(false);
  const [institutionPowerOpen, setInstitutionPowerOpen] = useState<boolean>(false);
  const [manage3dSitemapOpen, setManage3dSitemapOpen] = useState<boolean>(false);
  // Admin-only "Manage Drone View" — the aerial tour URL behind the site plan's Drone mode.
  const [manageDroneViewOpen, setManageDroneViewOpen] = useState<boolean>(false);
  const [manageSuperShowcaseOpen, setManageSuperShowcaseOpen] = useState<boolean>(false);
  // Admin-only "Manage Floor Plan North" dialog — per-project floor plan calibration for the 3D / 3DS floor plan viewer.
  const [manageFloorPlanNorthOpen, setManageFloorPlanNorthOpen] = useState<boolean>(false);
  /** True while Super Showcase is showing the Project Research results card. */
  const [superShowcaseResultsOpen, setSuperShowcaseResultsOpen] = useState<boolean>(false);

  // Anticipate Price Promo: upcoming promos teased by project heads.
  const [anticipatePromos, setAnticipatePromos] = useState<AnticipatePricePromo[]>([]);
  const [anticipatePromosLoading, setAnticipatePromosLoading] = useState<boolean>(false);
  const [anticipatePromosError, setAnticipatePromosError] = useState<string | null>(null);
  const [anticipateCanCreate, setAnticipateCanCreate] = useState<boolean>(false);
  const [anticipateManageableProjects, setAnticipateManageableProjects] = useState<Array<{ projectId: string; projectName: string }>>([]);
  const [anticipateSeenIds, setAnticipateSeenIds] = useState<Set<number>>(loadAnticipateSeenIds);
  const [heatBarInfoOpen, setHeatBarInfoOpen] = useState<boolean>(false);
  const [sizeToleranceModalOpen, setSizeToleranceModalOpen] = useState<boolean>(false);
  const [sizeToleranceSliderValue, setSizeToleranceSliderValue] = useState<number>(0);
  const [financialParametersOpen, setFinancialParametersOpen] = useState<boolean>(false);
  const [disclaimerOpen, setDisclaimerOpen] = useState<boolean>(false);
  const [disclaimerTimestamp, setDisclaimerTimestamp] = useState<Date>(() => new Date());
  const [sheetSettingsItems, setSheetSettingsItems] = useState<ProjectSheetConfigItem[]>([]);
  const [sheetSettingsLoading, setSheetSettingsLoading] = useState<boolean>(false);
  const [sheetSettingsError, setSheetSettingsError] = useState<string | null>(null);
  const [sheetSettingsSavingId, setSheetSettingsSavingId] = useState<string | null>(null);
  const [sheetSettingsImportingId, setSheetSettingsImportingId] = useState<string | null>(null);
  const [projectSyncSettingsOpen, setProjectSyncSettingsOpen] = useState<boolean>(false);
  const activeNavigationDialogOpen: boolean | undefined = ({
    'commission-structure': commissionStructureOpen,
    'thumbsup-units': thumbsupDialogOpen,
    'price-promo': pricePromoDialogOpen,
    'price-promo-watchlist': pricePromoWatchlistDialogOpen,
    'super-showcase': superShowcaseDialogOpen,
    'shortlisted-units': shortlistDialogOpen,
    'my-share-links': myShareLinksOpen,
    'financial-parameters': financialParametersOpen,
    'sync-clients': projectSyncSettingsOpen,
    'manage-users': manageUsersOpen,
    'manage-site-map': manageSiteMapOpen,
    'agent-achievements': agentAchievementsOpen,
    'analytics-dashboard': analyticsDashboardOpen,
    'project-essentials-analytics': projectEssentialsAnalyticsOpen,
    'communication-tracking': communicationTrackingOpen,
    'categorize-events': categorizeEventsOpen,
    'manage-share-links': manageShareLinksOpen,
    'manage-podcast-videos': managePodcastVideosOpen,
    'manage-super-showcase': manageSuperShowcaseOpen,
    'manage-floor-plan-north': manageFloorPlanNorthOpen,
    'manage-connector-schedule': manageConnectorScheduleOpen,
    'project-verification': projectVerificationOpen,
    'project-head-statistics': projectHeadStatisticsOpen,
    'my-podcasts': myPodcastsOpen,
    'leader-verifications': leaderVerificationOpen,
    'leader-statistics': leaderStatisticsOpen,
    'cpd-analytics': cpdAnalyticsOpen,
    distinctive: distinctiveOpen,
    'register-for-training': eventRegistrationOpen,
    'trainer-manage-events': trainerManageEventsOpen,
  } as Record<string, boolean>)[activeNavItem];

  // Dialog-backed navigation items are temporary overlays. Once whichever
  // overlay owns the current highlight closes, restore the page underneath.
  useEffect(() => {
    if (activeNavigationDialogOpen === false) {
      setActiveNavItem(activeTabId);
    }
  }, [activeNavigationDialogOpen, activeNavItem, activeTabId]);
  const [projectSyncSettingsItems, setProjectSyncSettingsItems] = useState<ProjectSheetConfigItem[]>([]);
  const [projectSyncSettingsLoading, setProjectSyncSettingsLoading] = useState<boolean>(false);
  const [projectSyncSettingsError, setProjectSyncSettingsError] = useState<string | null>(null);
  const [projectSyncSettingsSavingId, setProjectSyncSettingsSavingId] = useState<string | null>(null);
  const [projectSyncSettingsImportingId, setProjectSyncSettingsImportingId] = useState<string | null>(null);
  const [projectSyncSettingsImportingPriceId, setProjectSyncSettingsImportingPriceId] = useState<string | null>(null);
  const [projectSyncSettingsImportingMasterId, setProjectSyncSettingsImportingMasterId] = useState<string | null>(null);
  const [projectSyncSettingsImportingIndexId, setProjectSyncSettingsImportingIndexId] = useState<string | null>(null);
  const [projectSyncSettingsLiveStatusSavingId, setProjectSyncSettingsLiveStatusSavingId] = useState<string | null>(null);
  const [projectSyncSettingsUpcomingSavingId, setProjectSyncSettingsUpcomingSavingId] = useState<string | null>(null);
  const [projectSyncSettingsShowPricePromoSavingId, setProjectSyncSettingsShowPricePromoSavingId] = useState<string | null>(null);
  const [projectSyncSettingsShowFacingSavingId, setProjectSyncSettingsShowFacingSavingId] = useState<string | null>(null);
  const [projectSyncSettingsShowPsfInTowerViewSavingId, setProjectSyncSettingsShowPsfInTowerViewSavingId] = useState<string | null>(null);
  const [projectSyncSettingsShowPriceInTowerViewSavingId, setProjectSyncSettingsShowPriceInTowerViewSavingId] = useState<string | null>(null);
  const [projectSyncSettingsShowVVIPPriceSavingId, setProjectSyncSettingsShowVVIPPriceSavingId] = useState<string | null>(null);
  const [projectSyncSettingsQuery, setProjectSyncSettingsQuery] = useState<string>('');
  const [projectSyncSettingsPage, setProjectSyncSettingsPage] = useState<number>(0);
  const [projectSyncSettingsRowsPerPage, setProjectSyncSettingsRowsPerPage] = useState<number>(50);
  const [projectSyncSheetIds, setProjectSyncSheetIds] = useState<Map<string, string>>(new Map());
  const [projectSyncPriceMatrixSheetIds, setProjectSyncPriceMatrixSheetIds] = useState<Map<string, string>>(new Map());
  const [projectSyncIndexSheetIds, setProjectSyncIndexSheetIds] = useState<Map<string, string>>(new Map());
  const [projectSyncUpcoming, setProjectSyncUpcoming] = useState<Map<string, boolean>>(new Map());
  const [projectSyncUpcomingSeq, setProjectSyncUpcomingSeq] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    if (!financialParametersOpen) return;
    setLoanToValueInput(String(loanToValue));
    setInterestRateInput(String(interestRate));
    setTenureYearsInput(String(tenureYears));
  }, [financialParametersOpen, interestRate, tenureYears, loanToValue]);

  // Update disclaimer timestamp when project/tab/data changes or when disclaimer dialog opens
  useEffect(() => {
    setDisclaimerTimestamp(new Date());
  }, [selectedProject, activeTabId, projectDetails?.name, disclaimerOpen]);
  const [choiceUnitTabIndex, setChoiceUnitTabIndex] = useState<number>(0);
  const [clientTabs, setClientTabs] = useState<Array<{
    id: string;
    label: string;
    clientId: string;
    projectName?: string;
    unitNumber?: string;
    unitId?: number | null;
  }>>([]);
  const [activeClientId, setActiveClientId] = useState<string | null>(null);
  
  // LLM Settings state
  const [llmSettingsAnchor, setLlmSettingsAnchor] = useState<HTMLElement | null>(null);
  const [selectedLLMs, setSelectedLLMs] = useState<string[]>(['LLM']); // Default to LLM
  const projectFilterOptions = useMemo(() => createFilterOptions<string>(), []);
  const projectFilterValues = Array.isArray(filters.projectName) ? filters.projectName : [];
  // Project names from the comparable units result (for filter dropdown; not all projects)
  const comparableResultProjectNames = useMemo(
    () => Array.from(new Set(originalComparableUnits.map((u) => u.projectName).filter(Boolean))).sort(),
    [originalComparableUnits]
  );
  const sitePlanProjectName = projectDetails?.name || selectedProject || referenceUnit?.projectName || '';
  const shouldShowSitePlanButton = Boolean(sitePlanProjectName) &&
    sitePlanAvailability.get(sitePlanProjectName) !== false;
  const towerProjectName = selectedUnitForTowerView?.projectName || referenceUnit?.projectName;
  const towerProjectDetails = towerProjectName
    ? (projectDetails?.name === towerProjectName
      ? projectDetails
      : projectDetailsMap.get(towerProjectName))
    : null;
  const compareDialogFloorPlans = compareDialogSource === 'topViewing' ? topViewingFloorPlansToCompare : floorPlansToCompare;
  const compareTripleColumnFit = compareDialogFloorPlans.length === 3;
  useEffect(() => {
    if (compareDialogFloorPlans.length === 0) {
      setCompareFocusedUnitId(null);
      setCompareExpandedView(false);
      return;
    }
    if (compareFocusedUnitId == null || !compareDialogFloorPlans.some((fp) => fp.unit.id === compareFocusedUnitId)) {
      setCompareFocusedUnitId(compareDialogFloorPlans[0].unit.id);
    }
  }, [compareDialogFloorPlans, compareFocusedUnitId]);
  const buildCompareStackKeys = (stackValue: string | number | null | undefined, blockValue?: string | null): Set<string> => {
    const keys = new Set<string>();
    if (stackValue == null) return keys;
    const raw = String(stackValue).trim();
    if (!raw) return keys;

    keys.add(raw);
    const normalizedRaw = normalizeStackKey(raw);
    if (normalizedRaw) keys.add(normalizedRaw);

    if (raw.includes('-')) {
      const parts = raw.split('-').map((part) => part.trim()).filter(Boolean);
      const tail = parts[parts.length - 1];
      if (tail) {
        keys.add(tail);
        const normalizedTail = normalizeStackKey(tail);
        if (normalizedTail) keys.add(normalizedTail);
      }
    }

    const blockDigits = (blockValue || '').replace(/\D/g, '');
    if (blockDigits) {
      Array.from(keys).forEach((key) => {
        keys.add(`${blockDigits}-${key}`);
      });
    }

    return keys;
  };
  const getCompareSitePlanMarker = (sitePlan: SitePlanData | null | undefined, unit: ComparableUnit | ReferenceUnit) => {
    if (!sitePlan) return null;

    const parsed = parseUnitNumber(unit.unitNumber || '');
    if (parsed.stack == null) return null;

    const unitBlockDigits = (unit.blockNumber || '').replace(/\D/g, '');
    const unitKeys = buildCompareStackKeys(parsed.stack, unit.blockNumber);
    if (unitKeys.size === 0) return null;

    const stacks = sitePlan.blocks.filter((block) => block.stack != null && String(block.stack).trim() !== '');
    const doesMatch = (block: SitePlanData['blocks'][number]) => {
      const blockKeys = buildCompareStackKeys(block.stack, block.blockNumber);
      return Array.from(blockKeys).some((key) => unitKeys.has(key));
    };

    const preferredMatch = stacks.find((block) => {
      if (!doesMatch(block)) return false;
      if (!unitBlockDigits) return false;
      const blockDigits = (block.blockNumber || '').replace(/\D/g, '');
      return blockDigits === unitBlockDigits;
    });
    const match = preferredMatch ?? stacks.find(doesMatch);
    if (!match) return null;

    const bounds = sitePlan.bounds;
    const left = bounds ? bounds.x + (match.x / 100) * bounds.width : match.x;
    const top = bounds ? bounds.y + (match.y / 100) * bounds.height : match.y;
    const width = bounds ? (match.width / 100) * bounds.width : match.width;
    const height = bounds ? (match.height / 100) * bounds.height : match.height;

    return {
      left,
      top,
      width,
      height,
      label: normalizeStackKey(parsed.stack),
    };
  };

  const moveCompareFloorPlan = useCallback((fromIndex: number, toIndex: number, _animate: boolean = true) => {
    if (fromIndex === toIndex) return;
    const moveInList = <T,>(list: T[]) => {
      const next = [...list];
      const [item] = next.splice(fromIndex, 1);
      next.splice(toIndex, 0, item);
      return next;
    };
    if (compareDialogSource === 'topViewing') {
      setTopViewingFloorPlansToCompare((prev) => moveInList(prev));
    } else {
      setFloorPlansToCompare((prev) => moveInList(prev));
    }
  }, [compareDialogSource, setTopViewingFloorPlansToCompare, setFloorPlansToCompare]);

  const getCompareColumnSx = useCallback((index: number) => {
    const isActive = compareDragActiveIndex === index;
    const isOver = compareDragOverIndex === index;
    let transform = 'translateX(0px)';
    if (isOver && compareDragActiveIndex != null && compareDragActiveIndex !== index) {
      transform = `translateX(${compareDragActiveIndex < index ? -6 : 6}px)`;
    }
    return {
      transition: 'transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease',
      transform,
      opacity: isActive ? 0.6 : 1,
      boxShadow: isActive ? '0 8px 18px rgba(0,0,0,0.25)' : 'none',
      zIndex: 1,
      outline: isOver && !isActive ? '1px dashed rgba(var(--color-text-rgb), 0.35)' : 'none',
      outlineOffset: 2,
    } as const;
  }, [compareDragActiveIndex, compareDragOverIndex]);
  const getPhotoUrl = (photo?: string | null) => {
    if (!photo) return undefined;
    if (/^https?:\/\//i.test(photo)) return photo;
    const photoPath = photo.startsWith('/') ? photo.slice(1) : photo;
    return `https://portal.huttonsgroup.com/${photoPath}`;
  };
  const rawLiveUpdatesApiUrl = process.env.REACT_APP_API_URL || '/';
  const liveUpdatesApiRoot = rawLiveUpdatesApiUrl.replace(/\/+$/, '');
  const useHostedApiProxy = liveUpdatesApiRoot === '' || liveUpdatesApiRoot === '/';
  const liveUpdatesFunctionBase = useHostedApiProxy
    ? ''
    : (liveUpdatesApiRoot.endsWith('/api') ? liveUpdatesApiRoot : `${liveUpdatesApiRoot}/api`);
  const liveUpdatesApiBaseUrl = useHostedApiProxy ? '/api' : `${liveUpdatesFunctionBase}/api`;
  const shortlistByUnitId = useMemo(() => {
    const map = new Map<number, ShortlistItem>();
    shortlistItems.forEach((item) => {
      if (item.unitId !== null && item.unitId !== undefined) {
        map.set(item.unitId, item);
      }
    });
    return map;
  }, [shortlistItems]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isReferenceShortlisted = useMemo(
    () => (referenceUnit ? shortlistByUnitId.has(referenceUnit.id) : false),
    [referenceUnit, shortlistByUnitId],
  );

  // Initialize generic tab state on mount
  useEffect(() => {
    if (!tabStates.has('generic')) {
      setTabStates((prev) => new Map(prev).set('generic', getDefaultTabState()));
    }
  }, [tabStates, getDefaultTabState]);

  useEffect(() => {
    initAnalytics();
  }, []);
  const trackedMainPageCeaRef = useRef<string | null>(null);
  useEffect(() => {
    const ceaNumber = (userInfo?.CEANumber || getDevCea() || '').trim();
    setAnalyticsCea(ceaNumber);
    if (!ceaNumber || trackedMainPageCeaRef.current === ceaNumber) {
      return;
    }
    logMainPageViewed(ceaNumber);
    trackedMainPageCeaRef.current = ceaNumber;
  }, [userInfo]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projectList = await api.getProjects();
        setProjects(projectList);
      } catch (err) {
        console.error('Failed to fetch projects:', err);
      }
    };
    fetchProjects();
  }, []);

  useEffect(() => {
    const fetchProjectCategories = async () => {
      try {
        const categories = await api.getProjectCategories();
        setMasterToolProjectCategoryList(
          categories.filter((category) => {
            const name = (category.name ?? '').trim().toLowerCase();
            return name === '' || !excludedMasterToolProjectCategories.has(name);
          })
        );
      } catch (err) {
        console.error('Failed to fetch project categories:', err);
      }
    };
    fetchProjectCategories();
  }, [excludedMasterToolProjectCategories]);

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const districts = await api.getDistricts();
        setMasterToolDistrictOptions(districts);
      } catch (err) {
        console.error('Failed to fetch districts:', err);
      }
    };
    fetchDistricts();
  }, []);

  useEffect(() => {
    if (masterToolProjectCategoryList.length === 0) return;
    const allowedCategoryIds = new Set(masterToolProjectCategoryList.map((item) => item.id));
    setMasterToolFilters((prev) => {
      const selected = prev.projectCategories ?? [];
      if (selected.length === 0) return prev;
      const filtered = selected.filter((id) => allowedCategoryIds.has(id));
      if (filtered.length === selected.length) return prev;
      return { ...prev, projectCategories: filtered };
    });
  }, [masterToolProjectCategoryList]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        setClientsLoading(true);
        setClientsError(null);
        const response = await api.getClients({
          search: clientsSearchDebounced.trim() || undefined,
          projectName: clientsProjectFilter || undefined,
          page: clientsPage + 1,
          pageSize: clientsPageSize,
        });
        const normalized = response.clients.map((client) => ({
          ...client,
          choiceUnits: [...(client.choiceUnits || [])].sort((a, b) => (a.seq ?? 0) - (b.seq ?? 0)),
        }));
        setClients(normalized);
        setClientsTotal(response.total ?? normalized.length);
        setClientsIndex((prev) => {
          const next = new Map(prev);
          normalized.forEach((client) => next.set(client.id, client));
          return next;
        });
      } catch (err) {
        setClientsError(err instanceof Error ? err.message : 'Failed to fetch clients');
      } finally {
        setClientsLoading(false);
      }
    };

    // Only fetch when dialog is open to avoid unnecessary API calls
    if (clientsDrawerOpen) {
      fetchClients();
    }
  }, [clientsDrawerOpen, clientsSearchDebounced, clientsProjectFilter, clientsPage, clientsPageSize]);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setClientsSearchDebounced(clientsSearch);
      setClientsPage(0);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [clientsSearch]);

  const fetchShortlist = useCallback(async () => {
    try {
      setShortlistLoading(true);
      setShortlistError(null);
      const items = await api.getShortlist();
      setShortlistItems(items);
    } catch (err) {
      setShortlistError(err instanceof Error ? err.message : 'Failed to fetch shortlist');
    } finally {
      setShortlistLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchShortlist();
  }, [fetchShortlist]);

  useEffect(() => {
    if (shortlistDialogOpen) {
      fetchShortlist();
    }
  }, [shortlistDialogOpen, fetchShortlist]);

  const fetchThumbsupUnits = useCallback(async () => {
    try {
      setThumbsupLoading(true);
      setThumbsupError(null);
      const items = await api.getThumbsupUnits();
      setThumbsupUnits(items);
    } catch (err) {
      setThumbsupError(err instanceof Error ? err.message : 'Failed to fetch thumbsup units');
    } finally {
      setThumbsupLoading(false);
    }
  }, []);

  useEffect(() => {
    if (thumbsupDialogOpen) {
      fetchThumbsupUnits();
    } else {
      setThumbsupIntroOpen(false);
    }
  }, [thumbsupDialogOpen, fetchThumbsupUnits]);

  // Background fetch so the Nearby Deal section has thumbsup data without opening the dialog.
  useEffect(() => {
    if (canAccessNearbyDeal && !isExternalUser) {
      fetchThumbsupUnits();
    }
  }, [canAccessNearbyDeal, isExternalUser, fetchThumbsupUnits]);

  const fetchPricePromoUnits = useCallback(async () => {
    try {
      setPricePromoLoading(true);
      setPricePromoError(null);
      const items = await api.getPricePromoUnits();
      setPricePromoUnits(items);
    } catch (err) {
      setPricePromoError(err instanceof Error ? err.message : 'Failed to fetch price promo units');
    } finally {
      setPricePromoLoading(false);
    }
  }, []);

  useEffect(() => {
    if (pricePromoDialogOpen) {
      fetchPricePromoUnits();
    }
  }, [pricePromoDialogOpen, fetchPricePromoUnits]);

  // Load today's reveal budget when a non-admin opens the dialog (admins never
  // need it — they see the table fully unmasked). Refetch on each open so the
  // count reflects reveals spent on other devices/sessions.
  useEffect(() => {
    if (!pricePromoDialogOpen || isAdminUser || !canAccessPricePromo) return;
    let cancelled = false;
    api.getPricePromoReveals()
      .then((state) => { if (!cancelled) setPricePromoRevealState(state); })
      .catch((error) => { console.error('Failed to load price promo reveal budget:', error); });
    return () => { cancelled = true; };
  }, [pricePromoDialogOpen, isAdminUser, canAccessPricePromo]);

  // Reveal one masked Price Promo row. The server enforces the daily cap and
  // returns the authoritative budget (allowed=false, without charging, once the
  // cap is hit); we mirror that state so the badge + masking stay in sync.
  const handlePricePromoReveal = useCallback(async (unit: PricePromoUnit) => {
    if (isAdminUser) return;
    if (pricePromoRevealedUnitIds.has(unit.id)) return;
    try {
      const result = await api.recordPricePromoReveal(unit.id);
      setPricePromoRevealState(result);
    } catch (error) {
      console.error('Failed to record price promo reveal:', error);
    }
  }, [isAdminUser, pricePromoRevealedUnitIds]);

  // Background fetch for anyone with Price Promo access, plus Nearby Deal users
  // so the Nearby Deal price-promo tab has data without opening the main dialog.
  useEffect(() => {
    if (canAccessPricePromo || canAccessNearbyDeal) {
      fetchPricePromoUnits();
    }
  }, [canAccessPricePromo, canAccessNearbyDeal, fetchPricePromoUnits]);

  // Map Research deal filters need the market-wide feeds; load lazily when the tab opens.
  useEffect(() => {
    if (activeTabId !== 'map-research' || !canAccessSuperMap) return;
    if (!isExternalUser && thumbsupUnits.length === 0) {
      fetchThumbsupUnits();
    }
    if ((canAccessPricePromo || canAccessNearbyDeal) && pricePromoUnits.length === 0) {
      fetchPricePromoUnits();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTabId, canAccessSuperMap, isExternalUser, canAccessPricePromo, canAccessNearbyDeal, fetchThumbsupUnits, fetchPricePromoUnits]);


  const hasRecentPricePromo = useMemo(() => {
    const cutoff = Date.now() - 14 * 24 * 60 * 60 * 1000;
    for (const u of pricePromoUnits) {
      if (!u.priceChangeAt) continue;
      const t = new Date(u.priceChangeAt).getTime();
      if (Number.isFinite(t) && t >= cutoff) return true;
    }
    return false;
  }, [pricePromoUnits]);

  // ── Price Promo Watchlist ────────────────────────────────────────────────
  const fetchPricePromoWatchlists = useCallback(async () => {
    try {
      setPricePromoWatchlistLoading(true);
      setPricePromoWatchlistError(null);
      const items = await api.getPricePromoWatchlists();
      setPricePromoWatchlists(items);
    } catch (err) {
      setPricePromoWatchlistError(err instanceof Error ? err.message : 'Failed to fetch watchlists');
    } finally {
      setPricePromoWatchlistLoading(false);
    }
  }, []);

  useEffect(() => {
    if (canAccessPricePromoWatchlist) {
      fetchPricePromoWatchlists();
    }
  }, [canAccessPricePromoWatchlist, fetchPricePromoWatchlists]);

  const pricePromoWatchlistsWithNewMatches = useMemo(
    () => getWatchlistsWithNewMatches(pricePromoUnits, pricePromoWatchlists),
    [pricePromoUnits, pricePromoWatchlists],
  );

  const pricePromoWatchlistNewMatchIds = useMemo(
    () => new Set(pricePromoWatchlistsWithNewMatches.map((w) => w.id)),
    [pricePromoWatchlistsWithNewMatches],
  );

  const handlePricePromoWatchlistCreate = useCallback(async (input: PricePromoWatchlistInput) => {
    const item = await api.createPricePromoWatchlist(input);
    setPricePromoWatchlists((prev) => [item, ...prev]);
  }, []);

  const handlePricePromoWatchlistUpdate = useCallback(async (id: number, input: PricePromoWatchlistInput) => {
    const item = await api.updatePricePromoWatchlist(id, input);
    setPricePromoWatchlists((prev) => prev.map((w) => (w.id === id ? item : w)));
  }, []);

  const handlePricePromoWatchlistDelete = useCallback(async (id: number) => {
    await api.deletePricePromoWatchlist(id);
    setPricePromoWatchlists((prev) => prev.filter((w) => w.id !== id));
  }, []);

  const handlePricePromoWatchlistSeen = useCallback((id: number) => {
    // Optimistically clear the "new match" indicators; the server persists it.
    setPricePromoWatchlists((prev) => prev.map((w) => (
      w.id === id ? { ...w, lastViewedAt: new Date().toISOString() } : w
    )));
    api.markPricePromoWatchlistSeen(id)
      .then((item) => {
        setPricePromoWatchlists((prev) => prev.map((w) => (w.id === id ? item : w)));
      })
      .catch((err) => console.error('Failed to mark watchlist seen:', err));
  }, []);

  // ── Anticipate Price Promo ───────────────────────────────────────────────
  const fetchAnticipatePromos = useCallback(async () => {
    try {
      setAnticipatePromosLoading(true);
      setAnticipatePromosError(null);
      const data = await api.getAnticipatePricePromos();
      setAnticipatePromos(data.items);
      setAnticipateCanCreate(data.canCreate);
      setAnticipateManageableProjects(data.manageableProjects);
    } catch (err) {
      setAnticipatePromosError(err instanceof Error ? err.message : 'Failed to fetch anticipate price promos');
    } finally {
      setAnticipatePromosLoading(false);
    }
  }, []);

  useEffect(() => {
    if (canAccessPricePromoWatchlist) {
      fetchAnticipatePromos();
    }
  }, [canAccessPricePromoWatchlist, fetchAnticipatePromos]);

  const unseenAnticipateIds = useMemo(() => {
    const unseen = new Set<number>();
    for (const promo of anticipatePromos) {
      if (!anticipateSeenIds.has(promo.id)) unseen.add(promo.id);
    }
    return unseen;
  }, [anticipatePromos, anticipateSeenIds]);

  // Each identity changes when a new watchlist match or Anticipate promo arrives.
  // A click acknowledges only the identities currently on screen, so a later
  // update automatically brings the compact sidebar tag back.
  const currentPricePromoUpdateKeys = useMemo(() => {
    const watchlistKeys = pricePromoWatchlistsWithNewMatches.map((watchlist) => {
      const result = getWatchlistMatches(pricePromoUnits, watchlist);
      const newest = result.matches[0];
      return [
        'watchlist',
        watchlist.id,
        result.newMatchCount,
        newest?.id ?? '',
        newest?.priceChangeAt ?? '',
      ].join(':');
    });
    const anticipateKeys = Array.from(unseenAnticipateIds, (id) => `anticipate:${id}`);
    return [...watchlistKeys, ...anticipateKeys].sort();
  }, [pricePromoUnits, pricePromoWatchlistsWithNewMatches, unseenAnticipateIds]);

  // Unread updates only tag the sidebar item ("New Updates"); they never open the sidebar.
  const hasUnacknowledgedPricePromoUpdates = currentPricePromoUpdateKeys
    .some((key) => !acknowledgedPricePromoUpdates.has(key));

  const acknowledgeCurrentPricePromoUpdates = useCallback(() => {
    const acknowledged = new Set(currentPricePromoUpdateKeys);
    setAcknowledgedPricePromoUpdates(acknowledged);
    persistAcknowledgedPricePromoUpdates(currentPricePromoUpdateKeys);
  }, [currentPricePromoUpdateKeys]);

  /** The agent has read the Anticipate tab: everything currently listed is seen. */
  const handleAnticipateViewed = useCallback(() => {
    setAnticipateSeenIds((prev) => {
      if (anticipatePromos.every((p) => prev.has(p.id))) return prev;
      const next = new Set(prev);
      anticipatePromos.forEach((p) => next.add(p.id));
      persistAnticipateSeenIds(next);
      return next;
    });
  }, [anticipatePromos]);

  const handleAnticipateCreate = useCallback(async (input: AnticipatePricePromoInput) => {
    const item = await api.createAnticipatePricePromo(input);
    setAnticipatePromos((prev) => [item, ...prev]);
    // The creator shouldn't be nudged about their own post.
    setAnticipateSeenIds((prev) => {
      const next = new Set(prev);
      next.add(item.id);
      persistAnticipateSeenIds(next);
      return next;
    });
  }, []);

  const handleAnticipateUpdate = useCallback(async (id: number, input: { price: number; description: string }) => {
    const item = await api.updateAnticipatePricePromo(id, input);
    setAnticipatePromos((prev) => prev.map((p) => (p.id === id ? item : p)));
  }, []);

  const handleAnticipateTakeDown = useCallback(async (id: number) => {
    await api.deleteAnticipatePricePromo(id);
    setAnticipatePromos((prev) => prev.filter((p) => p.id !== id));
  }, []);

  const handleAnticipateRegisterInterest = useCallback(async (id: number, input: AnticipatePricePromoInterestInput) => {
    const { interestCount } = await api.registerAnticipatePricePromoInterest(id, input);
    setAnticipatePromos((prev) => prev.map((p) => (
      p.id === id ? { ...p, interestCount, myInterestRegistered: true } : p
    )));
  }, []);

  const handleFetchAnticipateInterests = useCallback(
    (id: number) => api.getAnticipatePricePromoInterests(id),
    [],
  );

  useEffect(() => {
    if (!projectSyncSettingsOpen) {
      return;
    }

    // Reset pagination when dialog opens
    setProjectSyncSettingsPage(0);
    setProjectSyncSettingsQuery('');

    const fetchProjectSyncSettings = async () => {
      try {
        setProjectSyncSettingsLoading(true);
        setProjectSyncSettingsError(null);
        const items = await api.getSheetConfig();
        setProjectSyncSettingsItems(items);
        // Initialize sheet IDs map
        const sheetIdsMap = new Map<string, string>();
        const priceMatrixSheetIdsMap = new Map<string, string>();
        const indexSheetIdsMap = new Map<string, string>();
        const upcomingMap = new Map<string, boolean>();
        const upcomingSeqMap = new Map<string, string>();
        items.forEach((item) => {
          if (item.sheetId) {
            sheetIdsMap.set(item.projectId, item.sheetId);
          }
          if (item.priceMatrixSheetId) {
            priceMatrixSheetIdsMap.set(item.projectId, item.priceMatrixSheetId);
          }
          if (item.indexSheetId) {
            indexSheetIdsMap.set(item.projectId, item.indexSheetId);
          }
          upcomingMap.set(item.projectId, item.upcoming === true);
          upcomingSeqMap.set(item.projectId, item.upcomingSeq != null ? String(item.upcomingSeq) : '');
        });
        setProjectSyncSheetIds(sheetIdsMap);
        setProjectSyncPriceMatrixSheetIds(priceMatrixSheetIdsMap);
        setProjectSyncIndexSheetIds(indexSheetIdsMap);
        setProjectSyncUpcoming(upcomingMap);
        setProjectSyncUpcomingSeq(upcomingSeqMap);
      } catch (err) {
        setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to fetch project sync settings');
      } finally {
        setProjectSyncSettingsLoading(false);
      }
    };

    fetchProjectSyncSettings();
  }, [projectSyncSettingsOpen]);

  // Memoize filtered and paginated items to avoid recalculating on every render
  const filteredAndPaginatedItems = useMemo(() => {
    const query = projectSyncSettingsQuery.trim().toLowerCase();
    const filtered = query
      ? projectSyncSettingsItems.filter((item) => {
          const name = `${item.projectName || ''} ${item.projectId}`.toLowerCase();
          return name.includes(query);
        })
      : projectSyncSettingsItems;
    const paginated = filtered.slice(
      projectSyncSettingsPage * projectSyncSettingsRowsPerPage,
      projectSyncSettingsPage * projectSyncSettingsRowsPerPage + projectSyncSettingsRowsPerPage
    );
    return { filtered, paginated };
  }, [projectSyncSettingsItems, projectSyncSettingsQuery, projectSyncSettingsPage, projectSyncSettingsRowsPerPage]);

  // Manage Users: fetch users when dialog opens
  const fetchManageUsers = useCallback(async () => {
    setManageUsersLoading(true);
    setManageUsersError(null);
    try {
      const data = await api.getAdminUsers();
      setManageUsersList(data.users);
    } catch (err) {
      setManageUsersError(err instanceof Error ? err.message : 'Failed to fetch users');
    } finally {
      setManageUsersLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!manageUsersOpen) return;
    setManageUsersTab('pending');
    setManageUsersPage(0);
    fetchManageUsers();
  }, [manageUsersOpen, fetchManageUsers]);

  useEffect(() => {
    if (!isAdminUser) return;
    fetchManageUsers();
  }, [fetchManageUsers, isAdminUser]);

  const manageUsersBuckets = useMemo(() => {
    const buckets: Record<ManageUsersTab, AdminUserAccess[]> = {
      pending: [],
      approved: [],
      rejected_rejoined: [],
      rejected_never: [],
    };

    // Collect CEA numbers that have an approved record
    const approvedCeaNumbers = new Set(
      manageUsersList
        .filter((u) => u.reviewStatus === 'approved')
        .map((u) => u.ceaNumber)
    );

    manageUsersList.forEach((user) => {
      if (user.reviewStatus === 'approved') {
        buckets.approved.push(user);
      } else if (user.reviewStatus === 'rejected') {
        if (approvedCeaNumbers.has(user.ceaNumber)) {
          buckets.rejected_rejoined.push(user);
        } else {
          buckets.rejected_never.push(user);
        }
      } else {
        buckets.pending.push(user);
      }
    });

    return buckets;
  }, [manageUsersList]);

  const filteredManageUsers = useMemo(() => {
    const query = manageUsersQuery.trim().toLowerCase();
    const visibleUsers = manageUsersBuckets[manageUsersTab];
    const filtered = query
      ? visibleUsers.filter((u) => {
          const text = `${u.ceaNumber} ${u.name || ''} ${u.email || ''}`.toLowerCase();
          return text.includes(query);
        })
      : visibleUsers;
    const paginated = filtered.slice(
      manageUsersPage * manageUsersRowsPerPage,
      manageUsersPage * manageUsersRowsPerPage + manageUsersRowsPerPage
    );
    return { filtered, paginated };
  }, [manageUsersBuckets, manageUsersPage, manageUsersQuery, manageUsersRowsPerPage, manageUsersTab]);

  const handleAddUser = useCallback(async () => {
    const cea = manageUsersAddCea.trim();
    if (!cea) return;
    setManageUsersAdding(true);
    setManageUsersError(null);
    setManageUsersSuccess(null);
    try {
      const data = await api.addAdminUser(cea, manageUsersAddRole);
      setManageUsersList((prev) => [data.user, ...prev]);
      setManageUsersAddCea('');
      setManageUsersSuccess(`User ${cea} added successfully`);
    } catch (err) {
      setManageUsersError(err instanceof Error ? err.message : 'Failed to add user');
    } finally {
      setManageUsersAdding(false);
    }
  }, [manageUsersAddCea, manageUsersAddRole]);

  const handleRevokeUser = useCallback(async (ceaNumber: string) => {
    setManageUsersRevokingCea(ceaNumber);
    setManageUsersError(null);
    setManageUsersSuccess(null);
    try {
      await api.revokeAdminUser(ceaNumber);
      setManageUsersList((prev) => prev.filter((u) => u.ceaNumber !== ceaNumber));
      setManageUsersSuccess(`Access revoked for ${ceaNumber}`);
    } catch (err) {
      setManageUsersError(err instanceof Error ? err.message : 'Failed to revoke user');
    } finally {
      setManageUsersRevokingCea(null);
    }
  }, []);

  const handleLogoutUser = useCallback(async (ceaNumber: string) => {
    setManageUsersLoggingOutCea(ceaNumber);
    setManageUsersError(null);
    setManageUsersSuccess(null);
    try {
      const result = await api.logoutAdminUser(ceaNumber);
      setManageUsersSuccess(`Logged out ${ceaNumber} (${result.sessionsRevoked} session${result.sessionsRevoked !== 1 ? 's' : ''} revoked)`);
    } catch (err) {
      setManageUsersError(err instanceof Error ? err.message : 'Failed to logout user');
    } finally {
      setManageUsersLoggingOutCea(null);
    }
  }, []);

  const handleReviewUser = useCallback(async (ceaNumber: string, approved: boolean) => {
    setManageUsersReviewingCea(ceaNumber);
    setManageUsersError(null);
    setManageUsersSuccess(null);
    try {
      const result = await api.reviewAdminUser(ceaNumber, approved);
      setManageUsersList((prev) =>
        prev.map((u) => (
          u.ceaNumber === ceaNumber
            ? {
                ...u,
                reviewedAt: result.user.reviewedAt,
                defunctAt: result.user.defunctAt,
                reviewStatus: result.user.reviewStatus,
                updatedAt: result.user.updatedAt,
              }
            : u
        ))
      );
      if (!approved) {
        setManageUsersTab('rejected_never');
        setManageUsersPage(0);
      }
      setManageUsersSuccess(approved ? `Access approved for ${ceaNumber}` : `Access rejected for ${ceaNumber}`);
    } catch (err) {
      setManageUsersError(err instanceof Error ? err.message : 'Failed to review user');
    } finally {
      setManageUsersReviewingCea(null);
    }
  }, []);

  const handleSheetIdSave = useCallback(async (projectId: string, sheetId: string | null) => {
    try {
      setSheetSettingsSavingId(projectId);
      const updated = await api.updateSheetConfig(projectId, sheetId);
      setSheetSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId
            ? { ...item, sheetId: updated.sheetId ?? null, importChoiceUnitAt: updated.importChoiceUnitAt ?? item.importChoiceUnitAt }
            : item
        )
      );
    } catch (err) {
      setSheetSettingsError(err instanceof Error ? err.message : 'Failed to update sheet settings');
    } finally {
      setSheetSettingsSavingId(null);
    }
  }, []);

  const handleSheetImport = useCallback(async (projectId: string) => {
    try {
      setSheetSettingsImportingId(projectId);
      const result = await api.importSheetClients(projectId);
      setSheetSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId
            ? { ...item, importChoiceUnitAt: result.importChoiceUnitAt ?? item.importChoiceUnitAt ?? null }
            : item
        )
      );
    } catch (err) {
      setSheetSettingsError(err instanceof Error ? err.message : 'Failed to import sheet clients');
    } finally {
      setSheetSettingsImportingId(null);
    }
  }, []);

  const handleProjectSyncSheetConfigSave = useCallback(async (
    projectId: string,
    sheetId: string | null,
    priceMatrixSheetId: string | null,
    indexSheetId: string | null
  ) => {
    try {
      setProjectSyncSettingsSavingId(projectId);
      const updated = await api.updateSheetConfig(projectId, sheetId, priceMatrixSheetId, indexSheetId);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId
            ? {
                ...item,
                sheetId: updated.sheetId ?? null,
                priceMatrixSheetId: updated.priceMatrixSheetId ?? null,
                indexSheetId: updated.indexSheetId ?? null,
                importChoiceUnitAt: updated.importChoiceUnitAt ?? item.importChoiceUnitAt,
              }
            : item
        )
      );
      setProjectSyncSheetIds((prev) => {
        const next = new Map(prev);
        next.set(projectId, updated.sheetId || '');
        return next;
      });
      setProjectSyncPriceMatrixSheetIds((prev) => {
        const next = new Map(prev);
        next.set(projectId, updated.priceMatrixSheetId || '');
        return next;
      });
      setProjectSyncIndexSheetIds((prev) => {
        const next = new Map(prev);
        next.set(projectId, updated.indexSheetId || '');
        return next;
      });
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to update sheet settings');
    } finally {
      setProjectSyncSettingsSavingId(null);
    }
  }, []);

  const handleProjectSyncImport = useCallback(async (projectId: string) => {
    try {
      setProjectSyncSettingsImportingId(projectId);
      const result = await api.importSheetClients(projectId);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId
            ? { ...item, importChoiceUnitAt: result.importChoiceUnitAt ?? item.importChoiceUnitAt ?? null }
            : item
        )
      );
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to import sheet clients');
    } finally {
      setProjectSyncSettingsImportingId(null);
    }
  }, []);

  const handleProjectSyncLiveStatusToggle = useCallback(async (projectId: string, liveStatus: boolean) => {
    try {
      setProjectSyncSettingsLiveStatusSavingId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.updateSheetLiveStatus(projectId, liveStatus);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId ? { ...item, liveStatus: result.liveStatus } : item
        )
      );
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to update live status');
    } finally {
      setProjectSyncSettingsLiveStatusSavingId(null);
    }
  }, []);

  const handleProjectSyncShowPricePromoToggle = useCallback(async (projectId: string, showPricePromo: boolean) => {
    try {
      setProjectSyncSettingsShowPricePromoSavingId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.updateSheetShowPricePromo(projectId, showPricePromo);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId ? { ...item, showPricePromo: result.showPricePromo } : item
        )
      );
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to update show price promo');
    } finally {
      setProjectSyncSettingsShowPricePromoSavingId(null);
    }
  }, []);

  const handleProjectSyncShowFacingToggle = useCallback(async (projectId: string, showFacing: boolean) => {
    try {
      setProjectSyncSettingsShowFacingSavingId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.updateSheetShowFacing(projectId, showFacing);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId ? { ...item, showFacing: result.showFacing } : item
        )
      );
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to update show facing');
    } finally {
      setProjectSyncSettingsShowFacingSavingId(null);
    }
  }, []);

  const handleProjectSyncShowPsfInTowerViewToggle = useCallback(async (projectId: string, showPsfInTowerView: boolean) => {
    try {
      setProjectSyncSettingsShowPsfInTowerViewSavingId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.updateSheetShowPsfInTowerView(projectId, showPsfInTowerView);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId ? { ...item, showPsfInTowerView: result.showPsfInTowerView } : item
        )
      );
      if (projectDetails?.id === projectId) {
        setTopViewingShowPsfColumnByDefault(result.showPsfInTowerView !== false);
      }
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to update show PSF in tower view');
    } finally {
      setProjectSyncSettingsShowPsfInTowerViewSavingId(null);
    }
  }, [projectDetails?.id]);

  const handleProjectSyncShowPriceInTowerViewToggle = useCallback(async (projectId: string, showPriceInTowerView: boolean) => {
    try {
      setProjectSyncSettingsShowPriceInTowerViewSavingId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.updateSheetShowPriceInTowerView(projectId, showPriceInTowerView);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId ? { ...item, showPriceInTowerView: result.showPriceInTowerView } : item
        )
      );
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to update show price in tower view');
    } finally {
      setProjectSyncSettingsShowPriceInTowerViewSavingId(null);
    }
  }, []);

  const handleProjectSyncShowVVIPPriceToggle = useCallback(async (projectId: string, showVVIPPrice: boolean) => {
    try {
      setProjectSyncSettingsShowVVIPPriceSavingId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.updateSheetShowVVIPPrice(projectId, showVVIPPrice);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId ? { ...item, showVVIPPrice: result.showVVIPPrice } : item
        )
      );
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to update show VVIP price');
    } finally {
      setProjectSyncSettingsShowVVIPPriceSavingId(null);
    }
  }, []);

  const handleProjectSyncImportPrice = useCallback(async (projectId: string) => {
    try {
      setProjectSyncSettingsImportingPriceId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.importSheetPrice(projectId);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId
            ? { ...item, importPriceAt: result.importPriceAt ?? item.importPriceAt ?? null }
            : item
        )
      );
      setProjectSyncSettingsError(
        result.failed > 0
          ? `Import Price: ${result.imported} imported, ${result.failed} failed.`
          : `Import Price: ${result.imported} imported.`
      );
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to import sheet price');
    } finally {
      setProjectSyncSettingsImportingPriceId(null);
    }
  }, []);

  const handleProjectSyncImportMaster = useCallback(async (projectId: string) => {
    try {
      setProjectSyncSettingsImportingMasterId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.importSheetMaster(projectId);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId
            ? { ...item, importMasterAt: result.importMasterAt ?? item.importMasterAt ?? null }
            : item
        )
      );
      setProjectSyncSettingsError(
        result.failed > 0
          ? `Import Master Sheet: ${result.imported} imported, ${result.failed} failed.`
          : `Import Master Sheet: ${result.imported} imported.`
      );
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to import master sheet');
    } finally {
      setProjectSyncSettingsImportingMasterId(null);
    }
  }, []);

  const handleProjectSyncImportIndex = useCallback(async (projectId: string) => {
    try {
      setProjectSyncSettingsImportingIndexId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.importSheetIndex(projectId);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId
            ? { ...item, importIndexAt: result.importIndexAt ?? item.importIndexAt ?? null }
            : item
        )
      );
      const txInserted = result.transactionsInserted ?? 0;
      const txReplaced = result.transactionsReplacedFromMaster ?? 0;
      setProjectSyncSettingsError(
        result.failed > 0
          ? `Import Index Sheet: ${result.imported} imported, ${result.failed} failed. Transactions: ${txInserted} new, ${txReplaced} replaced from master.`
          : `Import Index Sheet: ${result.imported} imported. Transactions: ${txInserted} new, ${txReplaced} replaced from master.`
      );
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to import index sheet');
    } finally {
      setProjectSyncSettingsImportingIndexId(null);
    }
  }, []);

  const handleProjectSyncUpcomingSave = useCallback(async (projectId: string, upcoming: boolean, upcomingSeq: number | null) => {
    try {
      setProjectSyncSettingsUpcomingSavingId(projectId);
      setProjectSyncSettingsError(null);
      const result = await api.updateSheetUpcoming(projectId, upcoming, upcomingSeq);
      setProjectSyncSettingsItems((prev) =>
        prev.map((item) =>
          item.projectId === projectId ? { ...item, upcoming: result.upcoming, upcomingSeq: result.upcomingSeq } : item
        )
      );
      setProjectSyncUpcoming((prev) => {
        const next = new Map(prev);
        next.set(projectId, result.upcoming);
        return next;
      });
      setProjectSyncUpcomingSeq((prev) => {
        const next = new Map(prev);
        next.set(projectId, result.upcomingSeq != null ? String(result.upcomingSeq) : '');
        return next;
      });
    } catch (err) {
      setProjectSyncSettingsError(err instanceof Error ? err.message : 'Failed to update upcoming settings');
    } finally {
      setProjectSyncSettingsUpcomingSavingId(null);
    }
  }, []);

  const resolveProjectIdByName = useCallback(async (projectName: string): Promise<string | null> => {
    const detailsFromMap = projectDetailsMap.get(projectName);
    if (detailsFromMap?.name && detailsFromMap.id) {
      const nextIdMap = new Map(projectIdByNameRef.current);
      nextIdMap.set(detailsFromMap.name, detailsFromMap.id);
      projectIdByNameRef.current = nextIdMap;

      const nextLiveMap = new Map(projectLiveByNameRef.current);
      nextLiveMap.set(detailsFromMap.name, detailsFromMap.liveStatusEnabled === true);
      projectLiveByNameRef.current = nextLiveMap;
    }

    const cached = detailsFromMap?.id || projectIdByNameRef.current.get(projectName);
    if (cached) return cached;
    try {
      const config = await api.getProjectConfig();
      const nextMap = new Map(projectIdByNameRef.current);
      const nextLiveMap = new Map(projectLiveByNameRef.current);
      config.forEach((item) => {
        if (item.projectName && item.projectId) {
          nextMap.set(item.projectName, item.projectId);
          nextLiveMap.set(item.projectName, item.liveUpdate === true);
        }
      });
      projectIdByNameRef.current = nextMap;
      projectLiveByNameRef.current = nextLiveMap;
      return nextMap.get(projectName) ?? null;
    } catch (err) {
      console.error('Failed to resolve project id from project name:', err);
      return null;
    }
  }, [projectDetailsMap]);

  const resolveProjectIdsByName = useCallback(async (projectNames: string[]): Promise<string[]> => {
    const uniqueNames = Array.from(new Set(projectNames.filter(Boolean)));
    const resolved = await Promise.all(uniqueNames.map((name) => resolveProjectIdByName(name)));
    return resolved.filter((id): id is string => Boolean(id));
  }, [resolveProjectIdByName]);

  const fetchSitePlan = useCallback(async (projectName: string, projectId?: string | null) => {
    const resolvedProjectId = projectId ?? await resolveProjectIdByName(projectName);
    if (!resolvedProjectId) {
      throw new Error(`Unable to resolve project id for ${projectName}`);
    }
    const sitePlan = await api.getSitePlan(resolvedProjectId);
    return { sitePlan, projectId: resolvedProjectId };
  }, [resolveProjectIdByName]);

  useEffect(() => {
    if (!floorPlanCompareOpen || compareVisualizerMode !== 'siteplan') return;

    const projectNames = Array.from(new Set(
      compareDialogFloorPlans
        .map((fp) => fp.unit.projectName)
        .filter((name): name is string => Boolean(name && name.trim()))
    ));
    const missingProjectNames = projectNames.filter((projectName) => !compareSitePlansByProject.has(projectName));
    if (missingProjectNames.length === 0) return;

    let isCancelled = false;
    setCompareSitePlansLoading(true);

    Promise.all(
      missingProjectNames.map(async (projectName) => {
        try {
          const { sitePlan } = await fetchSitePlan(projectName);
          return { projectName, sitePlan };
        } catch (err) {
          console.error(`Failed to fetch compare site plan for ${projectName}:`, err);
          return { projectName, sitePlan: null as SitePlanData | null };
        }
      })
    )
      .then((results) => {
        if (isCancelled) return;
        setCompareSitePlansByProject((prev) => {
          const next = new Map(prev);
          results.forEach(({ projectName, sitePlan }) => {
            next.set(projectName, sitePlan);
          });
          return next;
        });
      })
      .finally(() => {
        if (!isCancelled) {
          setCompareSitePlansLoading(false);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [floorPlanCompareOpen, compareVisualizerMode, compareDialogFloorPlans, compareSitePlansByProject, fetchSitePlan]);

  // Fetch all tower-view units for a project
  const fetchTowerViewUnits = useCallback(async (projectName: string, projectId?: string | null) => {
    const resolvedProjectId = projectId ?? await resolveProjectIdByName(projectName);
    if (!resolvedProjectId) {
      throw new Error(`Unable to resolve project id for ${projectName}`);
    }
    towerViewProjectIdRef.current = resolvedProjectId;
    const { units, unitTypes, showPsfInTowerView, showPriceInTowerView } = await api.getTowerViewUnits(resolvedProjectId);
    return { units, unitTypes, projectId: resolvedProjectId, showPsfInTowerView, showPriceInTowerView };
  }, [resolveProjectIdByName]);

  // Load site plan plus supporting maps used by tower view overlays/filters
  const fetchBestByUnitType = useCallback(async (projectName: string, projectId?: string | null) => {
    const resolvedProjectId = projectId ?? await resolveProjectIdByName(projectName);
    if (!resolvedProjectId) {
      throw new Error(`Unable to resolve project id for ${projectName}`);
    }
    return api.getBestByUnitType(resolvedProjectId);
  }, [resolveProjectIdByName]);

  // Load site plan data and supporting maps (stack bedrooms, unit types, etc.) for a project
  const loadSitePlanContext = useCallback(async (
    projectName: string,
    projectId?: string | null,
    options?: { force?: boolean },
  ) => {
    const shouldForce = options?.force === true;
    // Short-circuit if we already have data for this project and no refresh is requested.
    if (!shouldForce) {
      const alreadyFetched = sitePlanAvailability.has(projectName);
      if (alreadyFetched) {
        // Project has no site plan image — no need to re-fetch
        if (!sitePlanAvailability.get(projectName)) return;
        // Site plan already loaded for this project
        const alreadyLoaded = sitePlanData?.imageUrl && sitePlanProjectName === projectName;
        if (alreadyLoaded) return;
      }
    }

    const { sitePlan, projectId: resolvedProjectId } = await fetchSitePlan(projectName, projectId);
    setSitePlanData(sitePlan);
    setSitePlanAvailability(prev => {
      const next = new Map(prev);
      next.set(projectName, Boolean(sitePlan?.imageUrl));
      return next;
    });

    try {
      const details = await api.getProjectDetails(resolvedProjectId);
      const detailsName = details?.name;
      if (detailsName) {
        setProjectDetailsMap((prev) => {
          const next = new Map(prev);
          next.set(detailsName, details);
          return next;
        });
      }
    } catch (err) {
      console.error('Failed to fetch project details for site plan context:', err);
    }

    try {
      const stackBedroomsData = await api.getStackBedrooms(resolvedProjectId);
      const bedroomMap = new Map<string, number>();
      Object.entries(stackBedroomsData.stackBedrooms).forEach(([stack, bedroom]) => {
        const normalizedStack = normalizeStackKey(stack);
        const normalizedBedroom = normalizeBedroomValue(bedroom);
        if (normalizedStack && normalizedBedroom != null) {
          bedroomMap.set(normalizedStack, normalizedBedroom);
        }
      });
      setSitePlanStackBedrooms(bedroomMap);
    } catch (err) {
      console.error('Failed to fetch stack bedrooms:', err);
      setSitePlanStackBedrooms(new Map());
    }

    try {
      const unitTypesData = await api.getUnitTypes(resolvedProjectId);
      setSitePlanUnitTypes(unitTypesData.unitTypes);
    } catch (err) {
      console.error('Failed to fetch unit types:', err);
      setSitePlanUnitTypes([]);
    }

    try {
      const unitTypeStacksData = await api.getUnitTypeStacks(resolvedProjectId);
      const normalizedUnitTypeStacks = Object.fromEntries(
        Object.entries(unitTypeStacksData.unitTypeStacks || {}).map(([unitType, stacks]) => [
          unitType,
          (stacks || []).map((stack) => normalizeStackKey(stack)).filter(Boolean),
        ]),
      );
      setSitePlanUnitTypeStacks(normalizedUnitTypeStacks);
    } catch (err) {
      console.error('Failed to fetch unit type stacks:', err);
      setSitePlanUnitTypeStacks({});
    }

    try {
      const stackSoldData = await api.getStackSoldPercentages(resolvedProjectId);
      const soldMap = new Map<string, number>();
      Object.entries(stackSoldData.stackSoldPercentages).forEach(([stack, percentage]) => {
        const normalizedStack = normalizeStackKey(stack);
        soldMap.set(stack, percentage);
        if (normalizedStack) {
          soldMap.set(normalizedStack, percentage);
        }
      });
      setSitePlanStackSoldPercentages(soldMap);
    } catch (err) {
      console.error('Failed to fetch stack sold percentages:', err);
      setSitePlanStackSoldPercentages(new Map());
    }
  }, [fetchSitePlan, normalizeStackKey, normalizeBedroomValue, sitePlanAvailability, sitePlanData?.imageUrl, sitePlanProjectName]);

  // Auto-load site plan and tower view data as soon as a project is chosen in the Generic tab,
  // so the map/tower/available units sections don't stay empty before a unit search runs.
  const lastAutoLoadedProjectRef = useRef<string | null>(null);
  // Stable refs so the effect doesn't re-run when these callbacks recreate due to unrelated state changes
  const loadSitePlanContextRef = useRef(loadSitePlanContext);
  loadSitePlanContextRef.current = loadSitePlanContext;
  const fetchTowerViewUnitsRef = useRef(fetchTowerViewUnits);
  fetchTowerViewUnitsRef.current = fetchTowerViewUnits;
  useEffect(() => {
    if (activeTabId !== 'generic') return;
    if (!selectedProject) return;
    if (lastAutoLoadedProjectRef.current === selectedProject) return;

    let cancelled = false;
    const loadProjectVisuals = async () => {
      try {
        setSitePlanLoading(true);
        await loadSitePlanContextRef.current(selectedProject);
        if (cancelled) return;
        const { units, unitTypes } = await fetchTowerViewUnitsRef.current(selectedProject);
        if (cancelled) return;
        setTowerViewUnits(units);
        setTowerViewUnitTypes(unitTypes);
        // Only mark as loaded after a successful fetch
        lastAutoLoadedProjectRef.current = selectedProject;
      } catch (err) {
        console.error('Failed to preload site plan/tower view for selected project:', err);
        if (!cancelled) {
          setTowerViewUnits([]);
          setTowerViewUnitTypes([]);
        }
      } finally {
        // Always clear the loading state, even if the effect was cancelled.
        setSitePlanLoading(false);
      }
    };

    loadProjectVisuals();
    return () => {
      cancelled = true;
      setSitePlanLoading(false);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTabId, selectedProject]);

  const currentViewingProjectName = useMemo(() => {
    if (towerViewOpen) {
      return selectedUnitForTowerView?.projectName || referenceUnit?.projectName || selectedProject || null;
    }
    return (
      selectedProject ||
      referenceUnit?.projectName ||
      topViewingReferenceUnit?.projectName ||
      selectedTopViewingSitePlan ||
      null
    );
  }, [
    towerViewOpen,
    selectedUnitForTowerView,
    referenceUnit,
    selectedProject,
    topViewingReferenceUnit,
    selectedTopViewingSitePlan,
  ]);
  const currentViewingProjectLiveFromDetails = useMemo(() => {
    if (!currentViewingProjectName) return false;
    const details = projectDetails?.name === currentViewingProjectName
      ? projectDetails
      : projectDetailsMap.get(currentViewingProjectName);
    return details?.liveStatusEnabled === true;
  }, [currentViewingProjectName, projectDetails, projectDetailsMap]);
  const liveQueueProjectName = useMemo(() => {
    if (activeTabId === TOP_VIEWING_SITE_PLANS_TAB && selectedTopViewingSitePlan) {
      return selectedTopViewingSitePlan;
    }
    if (towerViewOpen) {
      return selectedUnitForTowerView?.projectName || referenceUnit?.projectName || null;
    }
    return null;
  }, [activeTabId, referenceUnit?.projectName, selectedTopViewingSitePlan, selectedUnitForTowerView?.projectName, towerViewOpen]);
  // Keep the live refresh stream active for the selected project details view
  // as well, so the Live Update timestamp reacts to queue-only webhooks.
  const liveRefreshProjectName = currentViewingProjectName || liveQueueProjectName;
  useEffect(() => {
    let cancelled = false;
    setLiveQueueSummary(null);
    if (!liveRefreshProjectName) return () => { cancelled = true; };
    void resolveProjectIdByName(liveRefreshProjectName)
      .then((projectId) => projectId ? api.getLiveQueueSummary(projectId) : null)
      .then((summary) => {
        if (!cancelled) setLiveQueueSummary(summary);
      })
      .catch(() => {
        if (!cancelled) setLiveQueueSummary(null);
      });
    return () => { cancelled = true; };
  }, [liveRefreshProjectName, resolveProjectIdByName]);
  useEffect(() => {
    activeTabIdRef.current = activeTabId;
    selectedProjectRef.current = selectedProject;
    currentViewingProjectNameRef.current = currentViewingProjectName;
    resolveProjectIdByNameRef.current = resolveProjectIdByName;
    updateTabStateRef.current = updateTabState;
    normalizeStackKeyRef.current = normalizeStackKey;
    towerViewIsolatedFromMainRef.current = towerViewIsolatedFromMain;
  }, [
    activeTabId,
    currentViewingProjectName,
    normalizeStackKey,
    resolveProjectIdByName,
    selectedProject,
    towerViewIsolatedFromMain,
    updateTabState,
  ]);
  useEffect(() => {
    stackAnalysisOpenRef.current = stackAnalysisOpen;
    stackAnalysisDataRef.current = stackAnalysisData;
  }, [stackAnalysisData, stackAnalysisOpen]);

  useEffect(() => {
    if (!liveRefreshProjectName) {
      return;
    }

    let stream: EventSource | null = null;
    let disposed = false;

    const closeStream = () => {
      if (stream) {
        stream.close();
        stream = null;
      }
    };

    const refreshProjectData = async (projectId: string) => {
      try {
        const stackAnalysisTarget =
          stackAnalysisOpenRef.current
            ? stackAnalysisDataRef.current
            : null;
        const shouldRefreshStackAnalysis = Boolean(
          stackAnalysisTarget?.stackNumber
          && (
            stackAnalysisTarget?.projectId === projectId
            || stackAnalysisTarget?.projectName === currentViewingProjectNameRef.current
          )
        );
        const [towerData, details, latestUnits, stackSoldData, latestStackAnalysis, queueSummary] = await Promise.all([
          api.getTowerViewUnits(projectId),
          api.getProjectDetails(projectId).catch(() => null),
          selectedProjectRef.current === currentViewingProjectNameRef.current
            ? api.getProjectUnits(projectId).catch(() => null)
            : Promise.resolve(null),
          api.getStackSoldPercentages(projectId).catch(() => null),
          shouldRefreshStackAnalysis
            ? api.getStackAnalysis(projectId, String(stackAnalysisTarget.stackNumber)).catch(() => null)
            : Promise.resolve(null),
          api.getLiveQueueSummary(projectId).catch(() => null),
        ]);
        if (disposed) {
          return;
        }

        if (stackSoldData) {
          const soldMap = new Map<string, number>();
          Object.entries(stackSoldData.stackSoldPercentages || {}).forEach(([stack, percentage]) => {
            const normalizedStack = normalizeStackKeyRef.current(stack);
            soldMap.set(stack, percentage);
            if (normalizedStack) {
              soldMap.set(normalizedStack, percentage);
            }
          });
          setSitePlanStackSoldPercentages(soldMap);
        }

        towerViewJustRefreshedRef.current = true;
        setTowerViewUnits(towerData.units);
        setTowerViewUnitTypes(towerData.unitTypes);

        if (towerViewOpenRef.current && towerViewIsolatedFromMainRef.current) {
          setTowerViewDialogUnits(towerData.units);
          setTowerViewDialogUnitTypes(towerData.unitTypes);
        }

        if (details) {
          const detailsName = details.name;
          if (detailsName) {
            setProjectDetailsMap((prev) => {
              const next = new Map(prev);
              next.set(detailsName, details);
              return next;
            });
            const nextLiveMap = new Map(projectLiveByNameRef.current);
            nextLiveMap.set(detailsName, details.liveStatusEnabled === true);
            projectLiveByNameRef.current = nextLiveMap;
          }
          if (selectedProjectRef.current === currentViewingProjectNameRef.current) {
            updateTabStateRef.current(activeTabIdRef.current, { projectDetails: details });
          }
        }

        if (queueSummary) {
          setLiveQueueSummary(queueSummary);
        }

        if (latestUnits && selectedProjectRef.current === currentViewingProjectNameRef.current) {
          updateTabStateRef.current(activeTabIdRef.current, { projectUnits: latestUnits });
        }

        if (latestStackAnalysis && stackAnalysisOpenRef.current) {
          setStackAnalysisData(latestStackAnalysis);
        }
      } catch (error) {
        console.error('Failed to refresh project data from live stream:', error);
      }
    };

    const refreshSimulationSession = async (projectId: string) => {
      const activeSimulationProjectId = activePriceMatrixSimulationProjectId?.trim().toLowerCase();
      if (!activePriceMatrixSimulationSession || !activeSimulationProjectId || activeSimulationProjectId !== projectId.trim().toLowerCase()) {
        return;
      }
      if (!isAdminUser && !activePriceMatrixSimulationSession.syncEnabled) {
        return;
      }
      try {
        const response = await api.loadPriceMatrixSimulation(projectId);
        if (disposed) {
          return;
        }
        persistPriceMatrixSimulationSession(
          buildPriceMatrixSimulationSession(projectId, response, activePriceMatrixSimulationSession)
        );
      } catch (error) {
        console.error('Failed to refresh price matrix simulation from live stream:', error);
      }
    };

    const connect = async () => {
      if (disposed || stream) {
        return;
      }

      const projectId = await resolveProjectIdByNameRef.current(liveRefreshProjectName);
      if (disposed || !projectId) {
        return;
      }

      const isLiveProject =
        projectLiveByNameRef.current.get(liveRefreshProjectName) === true || currentViewingProjectLiveFromDetails;
      const hasActiveSimulationSession =
        Boolean(activePriceMatrixSimulationSession)
        && activePriceMatrixSimulationProjectId?.trim().toLowerCase() === projectId.trim().toLowerCase()
        && (isAdminUser || Boolean(activePriceMatrixSimulationSession?.syncEnabled));
      if (!isLiveProject && !hasActiveSimulationSession) {
        return;
      }

      towerViewProjectIdRef.current = projectId;
      const sseBase = process.env.REACT_APP_SSE_URL || '';
      const streamUrl = sseBase
        ? new URL(`${sseBase}/api/sheets/live/stream`)
        : new URL(`${liveUpdatesApiBaseUrl}/sheets/live/stream`, window.location.origin);
      streamUrl.searchParams.set('projectId', projectId);
      const newStream = new EventSource(streamUrl.toString());
      stream = newStream;

      newStream.addEventListener('project-refresh', (event) => {
        void (async () => {
          try {
            const payload = JSON.parse((event as MessageEvent).data) as { projectId?: string; source?: string };
            const payloadProjectId = (payload.projectId ?? '').trim().toLowerCase();
            if (!payloadProjectId || payloadProjectId !== projectId.trim().toLowerCase()) {
              return;
            }
            await refreshProjectData(projectId);
            if (payload.source === 'simulation-grid') {
              await refreshSimulationSession(projectId);
            }
          } catch {
            // ignore malformed events
          }
        })();
      });

      newStream.addEventListener('error', (event) => {
        const source = event.currentTarget as EventSource | null;
        if (source?.readyState === EventSource.OPEN) {
          // Browser emits transient error events during automatic reconnect.
          return;
        }
        console.error('Live project stream error', event);
      });
    };

    const handleBeforeUnload = () => closeStream();
    window.addEventListener('beforeunload', handleBeforeUnload);
    void connect();

    return () => {
      disposed = true;
      window.removeEventListener('beforeunload', handleBeforeUnload);
      closeStream();
    };
  }, [
    activePriceMatrixSimulationProjectId,
    activePriceMatrixSimulationSession,
    buildPriceMatrixSimulationSession,
    liveRefreshProjectName,
    currentViewingProjectLiveFromDetails,
    isAdminUser,
    liveUpdatesApiBaseUrl,
    persistPriceMatrixSimulationSession,
  ]);

  useEffect(() => {
    towerViewOpenRef.current = towerViewOpen;
    towerViewProjectNameRef.current = selectedUnitForTowerView?.projectName || referenceUnit?.projectName || null;
  }, [towerViewOpen, selectedUnitForTowerView, referenceUnit]);

  useEffect(() => {
    const fetchProjectUnits = async () => {
      const currentProject = currentTabState.selectedProject;
      if (!currentProject) {
        updateTabState(activeTabId, { projectUnits: [], projectUnitsLoading: false });
        return;
      }

      try {
        updateTabState(activeTabId, { projectUnitsLoading: true });
        const projectId = await resolveProjectIdByName(currentProject);
        if (!projectId) {
          updateTabState(activeTabId, {
            error: `Unable to resolve project id for ${currentProject}`,
            projectUnitsLoading: false,
          });
          return;
        }
        const units = await api.getProjectUnits(projectId);
        updateTabState(activeTabId, { projectUnits: units, projectUnitsLoading: false });
      } catch (err) {
        updateTabState(activeTabId, {
          error: err instanceof Error ? err.message : 'Failed to fetch project units',
          projectUnitsLoading: false,
        });
      }
    };

    fetchProjectUnits();
  }, [activeTabId, currentTabState.selectedProject, resolveProjectIdByName, updateTabState]);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      const currentProject = currentTabState.selectedProject;
      if (!currentProject) {
        updateTabState(activeTabId, { projectDetails: null, projectSectionExpanded: false });
        return;
      }

      try {
        updateTabState(activeTabId, { projectDetailsLoading: true });
        const projectId = await resolveProjectIdByName(currentProject);
        if (!projectId) {
          updateTabState(activeTabId, {
            error: `Unable to resolve project id for ${currentProject}`,
            projectDetails: null,
            projectDetailsLoading: false,
          });
          return;
        }
        const details = await api.getProjectDetails(projectId);
        updateTabState(activeTabId, {
          projectDetails: details,
          projectDetailsLoading: false,
          ...(isExternalUser ? { projectSectionExpanded: true } : {}),
        });
      } catch (err) {
        updateTabState(activeTabId, {
          error: err instanceof Error ? err.message : 'Failed to fetch project details',
          projectDetails: null,
          projectDetailsLoading: false,
        });
      }
    };

    fetchProjectDetails();
  }, [activeTabId, currentTabState.selectedProject, isExternalUser, resolveProjectIdByName, updateTabState]);

  // User session bootstrap (/sso is handled by LoginApp).
  useEffect(() => {
    api.getCurrentUser()
      .then((user: CurrentUser) => {
        setUserInfo({
          Name: user.Name,
          Mobile: user.Mobile,
          Email: user.Email,
          CEANumber: user.CEANumber,
          Photo: user.Photo,
        });
        if (user.role) {
          setUserRole(user.role);
        }
        setUserRoles(Array.isArray(user.roles) ? user.roles : []);
        setCanAccessLeaderVerification(user.canAccessLeaderVerification === true);
        setCanAccessTeamCpd(user.canAccessTeamCpd === true);
        setCanAccessTeamStatistics(user.canAccessTeamStatistics === true);
      })
      .catch((err) => {
        console.error('Failed to fetch current user:', err);
      })
      .finally(() => {
        setUserSessionLoaded(true);
      });
  }, []);

  // Detect if the user leads any projects so the "Others → Project Verification" entry can show.
  useEffect(() => {
    if (!userSessionLoaded || isExternalUser) {
      setHasVerifiableProjects(false);
      return;
    }
    let cancelled = false;
    api.getMyProjectVerifications()
      .then((response) => {
        if (cancelled) return;
        setHasVerifiableProjects(response.projects.length > 0);
      })
      .catch(() => {
        if (cancelled) return;
        setHasVerifiableProjects(false);
      });
    return () => {
      cancelled = true;
    };
  }, [userSessionLoaded, isExternalUser]);

  // Detect whether the user has anything to do in Project Action.
  useEffect(() => {
    if (!userSessionLoaded || isExternalUser) {
      setProjectActionAccess({ isAdmin: false, leadsProjects: false, hasTasks: false });
      return;
    }
    let cancelled = false;
    api
      .getProjectActionAccess()
      .then((access) => {
        if (!cancelled) setProjectActionAccess(access);
      })
      .catch(() => {
        if (!cancelled) setProjectActionAccess({ isAdmin: false, leadsProjects: false, hasTasks: false });
      });
    return () => {
      cancelled = true;
    };
  }, [userSessionLoaded, isExternalUser]);

  // Detect trainer assignment so "Others → Manage Events" can show.
  useEffect(() => {
    if (!userSessionLoaded || isExternalUser) {
      setIsTrainingTrainer(false);
      return;
    }
    let cancelled = false;
    api
      .getTrainerStatus()
      .then(({ isTrainer }) => {
        if (cancelled) return;
        setIsTrainingTrainer(isTrainer === true);
      })
      .catch(() => {
        if (cancelled) return;
        setIsTrainingTrainer(false);
      });
    return () => {
      cancelled = true;
    };
  }, [userSessionLoaded, isExternalUser]);

  // Auto-open Project Verification dialog on All Projects tab when redirect=project-verification-all
  useEffect(() => {
    if (!userSessionLoaded || !autoOpenProjectVerificationAll) return;
    setProjectVerificationInitialTab('all');
    setProjectVerificationOpen(true);
  }, [userSessionLoaded, autoOpenProjectVerificationAll]);

  // Auto-open Project Verification dialog on My Projects tab when redirect=project-verification
  useEffect(() => {
    if (!userSessionLoaded || !autoOpenProjectVerificationMine) return;
    setActiveNavItem('project-verification');
    setProjectVerificationInitialTab('mine');
    setProjectVerificationOpen(true);
  }, [userSessionLoaded, autoOpenProjectVerificationMine]);

  // Auto-open Price Promo Units dialog when redirect=price-promo
  useEffect(() => {
    if (!userSessionLoaded || !autoOpenPricePromo) return;
    logPricePromoUnitsOpened({
      source: 'redirect',
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });
    setActiveNavItem('price-promo');
    setPricePromoDialogOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSessionLoaded, autoOpenPricePromo]);

  // Auto-open the CPD Analytics dialog when redirect=cpd (admins only)
  useEffect(() => {
    if (!userSessionLoaded || !autoOpenCpdAnalytics || !isAdminUser) return;
    setActiveNavItem('cpd-analytics');
    setCpdAnalyticsOpen(true);
  }, [userSessionLoaded, autoOpenCpdAnalytics, isAdminUser]);

  useEffect(() => {
    if (!userSessionLoaded) return;
    if (activeTabId === 'success-closer' && !canAccessSuccessCloser) {
      setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
    }
    if (activeTabId === MY_SHARABLE_LINKS_TAB && !canAccessSharableLinks) {
      setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
    }
  }, [userSessionLoaded, activeTabId, canAccessSuccessCloser, canAccessSharableLinks]);

  useEffect(() => {
    if (!userSessionLoaded) return;
    if (activeTabId === 'map-research' && !canAccessSuperMap) {
      setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
    }
    if (activeTabId === MARKETING_MATERIALS_TAB && !canAccessProjectMaterials) {
      setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
    }
  }, [userSessionLoaded, activeTabId, canAccessProjectMaterials]);

  useEffect(() => {
    if (!isExternalUser) return;
    if (projectDetailsTab === 'members') {
      setProjectDetailsTab('details');
    }
  }, [isExternalUser, projectDetailsTab]);

  // Super Ratio is its own project-details tab; fall back to Details if the
  // grant is missing (or goes away mid-session) so the tab can't be stranded.
  useEffect(() => {
    if (!canAccessSuperRatio && projectDetailsTab === 'superRatio') {
      setProjectDetailsTab('details');
    }
  }, [canAccessSuperRatio, projectDetailsTab]);

  useEffect(() => {
    if (!isExternalUser) return;
    if (activeTabId === 'generic') {
      setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
      setActiveClientId(null);
    }
  }, [activeTabId, isExternalUser]);

  useEffect(() => {
    const projectName = selectedProject || projectDetails?.name;
    if (!projectName) return;
    if (sitePlanAvailability.has(projectName)) return;

    let canceled = false;

    const checkSitePlan = async () => {
      try {
          const { sitePlan } = await fetchSitePlan(projectName);
        if (canceled) return;
        setSitePlanAvailability(prev => {
          const next = new Map(prev);
          next.set(projectName, Boolean(sitePlan?.imageUrl));
          return next;
        });
      } catch (err) {
        console.error('Failed to check site plan availability:', err);
      }
    };

    checkSitePlan();

    return () => {
      canceled = true;
    };
  }, [fetchSitePlan, projectDetails?.name, selectedProject, sitePlanAvailability]);

  const mapReferenceToComparableUnit = useCallback((unit: ReferenceUnit): ComparableUnit => ({
    id: unit.id,
    projectName: unit.projectName,
    region: unit.region ?? null,
    unitNumber: unit.unitNumber,
    blockNumber: unit.blockNumber ?? null,
    bedroom: unit.bedroom,
    bathroom: unit.bathroom,
    areaSqft: unit.areaSqft,
    price: unit.price,
    priceDiff: 0,
    priceDiffPercent: 0,
    psf: unit.psf,
    psfDiff: 0,
    psfDiffPercent: 0,
    outlay: unit.outlay ?? 0,
    outlayDiff: 0,
    installment: unit.installment ?? 0,
    installmentDiff: 0,
    unitStatus: unit.unitStatus ?? null,
    floorplan: unit.floorplan ?? null,
  }), []);

  const handleSearchWithParams = useCallback(async (
    projectName: string,
    unit: string,
    targetTabId?: string,
    unitId?: number | null,
    areaToleranceOverride?: number,
    analyticsSource: string = 'comparable_search',
  ) => {
    const tabId = targetTabId || activeTabId;
    const currentState = tabStates.get(tabId) || getDefaultTabState();
    const tolerance = areaToleranceOverride ?? currentState.areaTolerancePercent ?? 0;

    if (areaToleranceOverride !== undefined) {
      updateTabState(tabId, { areaTolerancePercent: areaToleranceOverride });
    }

    if (!projectName || !unit.trim()) {
      updateTabState(tabId, { error: 'Please select a project and enter a unit number' });
      return;
    }

    if (projectName !== currentState.selectedProject) {
      updateTabState(tabId, { selectedProject: projectName });
    }
    if (unit !== currentState.unitNumber) {
      updateTabState(tabId, { unitNumber: unit });
    }

    updateTabState(tabId, {
      loading: true,
      error: null,
      referenceUnit: null,
      comparableUnits: [],
    });
    if (tabId === 'generic') {
      setTopViewingComparableUnitsLoading(true);
      setTopViewingComparableUnits([]);
      setTopViewingReferenceUnit(null);
      setTopViewingBlinkerChoiceUnit(null);
      setTopViewingBlinkerMinTolerance(-20);
      setTopViewingBlinkerTolerance(1);
      setTopViewingBlinkerMinPriceOverride(null);
      setTopViewingBlinkerMaxPriceOverride(null);
    }

    try {
      const projectId = await resolveProjectIdByName(projectName);
      if (!projectId) {
        updateTabState(tabId, {
          error: `Unable to resolve project id for ${projectName}`,
          loading: false,
        });
        if (tabId === 'generic') {
          setTopViewingComparableUnitsLoading(false);
        }
        return;
      }

      const data = await api.getComparableUnits(
        projectId,
        unit.trim(),
        loanToValue / 100,
        tenureYears,
        interestRate / 100,
        unitId ?? undefined,
        tolerance
      );
      const referencePrice = data.referenceUnit.price ?? 0;
      const normalizedReferenceOutlay = calculateOutlay(referencePrice, loanToValue / 100);
      const normalizedReferenceInstallment = calculateInstallment(
        referencePrice,
        loanToValue / 100,
        tenureYears,
        interestRate / 100
      );
      const normalizedReferenceUnit: ReferenceUnit = {
        ...data.referenceUnit,
        outlay: normalizedReferenceOutlay,
        installment: normalizedReferenceInstallment,
      };

      // Filter out units with $0 price and normalize outlay/installment to use current formulas.
      const filteredUnits = data.comparableUnits
        .filter((unit) => unit.price > 0)
        .map((unit) => {
          const normalizedOutlay = calculateOutlay(unit.price, loanToValue / 100);
          const normalizedInstallment = calculateInstallment(
            unit.price,
            loanToValue / 100,
            tenureYears,
            interestRate / 100
          );
          return {
            ...unit,
            outlay: normalizedOutlay,
            installment: normalizedInstallment,
            outlayDiff: normalizedOutlay - normalizedReferenceOutlay,
            installmentDiff: normalizedInstallment - normalizedReferenceInstallment,
          };
        });

      const refProjectName = (normalizedReferenceUnit.projectName ?? '').trim();
      const scopedComparableUnits = refProjectName
        ? filteredUnits.filter((u) => u.projectName === refProjectName)
        : filteredUnits;

      updateTabState(tabId, {
        referenceUnit: normalizedReferenceUnit,
        comparableUnits: scopedComparableUnits,
        originalComparableUnits: scopedComparableUnits,
        loading: false,
        areaTolerancePercent: tolerance,
      });
      logComparableSearch(projectName, unit.trim(), userInfo?.CEANumber || getDevCea());
      logProjectViewed(projectName, analyticsSource, userInfo?.CEANumber || getDevCea(), projectId);
      logReferenceUnitSet({
        projectName: normalizedReferenceUnit.projectName,
        projectId,
        unitNumber: normalizedReferenceUnit.unitNumber,
        unitId: normalizedReferenceUnit.id,
        source: analyticsSource,
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });

      // Fetch project details for all unique projects to get their locations for distance calculation
      const uniqueProjectNames = Array.from(new Set([
        normalizedReferenceUnit.projectName,
        ...scopedComparableUnits.map((u) => u.projectName),
      ])).filter(Boolean);
      
      if (uniqueProjectNames.length > 0) {
        try {
          const projectIds = await resolveProjectIdsByName(uniqueProjectNames);
          if (projectIds.length === 0) return;
          const projectDetailsList = await api.getBulkProjectDetails(projectIds);
          const projectDetailsMapNew = new Map<string, ProjectDetails>();
          projectDetailsList.forEach(details => {
            if (details.name) {
              projectDetailsMapNew.set(details.name, details);
            }
          });
          setProjectDetailsMap(prevMap => {
            const merged = new Map(prevMap);
            projectDetailsMapNew.forEach((value, key) => merged.set(key, value));
            return merged;
          });
        } catch (err) {
          console.error('Failed to fetch project details for distance calculation:', err);
        }
      }
      
      // Reset other filters and sorting when new data is loaded; best-matched list stays on the reference project only
      setFilters({
        projectName: normalizedReferenceUnit.projectName
          ? [normalizedReferenceUnit.projectName]
          : [],
        unitNumber: '',
        blockNumber: '',
        floor: '',
        stack: '',
        bedroom: '',
        bathroom: '',
        areaSqft: '',
        price: '',
        psf: '',
        dps: '',
        outlay: '',
        installment: '',
        distance: '',
      });
      setRangeFilters({
        floor: { min: '', max: '' },
        stack: { min: '', max: '' },
        bedroom: { min: '', max: '' },
        bathroom: { min: '', max: '' },
        areaSqft: { min: '', max: '' },
        price: { min: '', max: '' },
        psf: { min: '', max: '' },
        dps: { min: '', max: '' },
        outlay: { min: '', max: '' },
        installment: { min: '', max: '' },
        distance: { min: '', max: '' },
      });
      setSortConfig({ column: null, direction: 'default' });
      setThumbsUpFilterActive(false);
      setRangeFilters(prev => ({
        ...prev,
        distance: { min: '', max: '' }, // Reset distance filter
      }));
      if (tabId === 'generic') {
        setTopViewingReferenceUnit(mapReferenceToComparableUnit(normalizedReferenceUnit));
        setTopViewingComparableUnits(scopedComparableUnits);
        setTopViewingComparableUnitsLoading(false);
        setTopViewingAvailableUnitsViewMode('availableUnits');
        setTopViewingCompViewMode('unit');
        setTopViewingCompFilters({
          projectName: normalizedReferenceUnit.projectName
            ? [normalizedReferenceUnit.projectName]
            : [],
          projectCategory: [],
          blockNumber: '',
          unitTypeDescription: [],
        });
        setTopViewingCompRangeFilters({
          floor: { min: '', max: '' },
          stack: { min: '', max: '' },
          bedroom: { min: '', max: '' },
          bathroom: { min: '', max: '' },
          areaSqft: { min: '', max: '' },
          price: { min: '', max: '' },
          psf: { min: '', max: '' },
          dps: { min: '', max: '' },
          outlay: { min: '', max: '' },
          installment: { min: '', max: '' },
          distance: { min: '', max: '' },
        });
        setTopViewingCompSortConfig({ column: null, direction: null });
        setTopViewingThumbsUpFilterActive(false);
        setTopViewingComparableSectionOpen(true);
        setTopViewingAreaTolerance(tolerance);
        setTopViewingToleranceSliderValue(tolerance);
        try {
          setTopViewingSitePlanContentLoading(true);
          setTopViewingSitePlansError(null);
          setSelectedTopViewingSitePlan(projectName);
          setSitePlanBedroomFilter([]);
          setSitePlanUnitTypeFilter([]);
          setSitePlanBlinkingStacks(new Set());
          setSelectedBlock(TOWER_VIEW_ALL_TAB);
          setTopViewingShowPsfColumnByDefault(true);
          await loadSitePlanContext(projectName, projectId);
          const { units: allUnits, unitTypes, showPsfInTowerView, showPriceInTowerView } = await fetchTowerViewUnits(projectName, projectId);
          setTowerViewUnits(allUnits);
          setTowerViewUnitTypes(unitTypes);
          setTopViewingTowerDisplayOptions(TOP_VIEWING_TOWER_DISPLAY_DEFAULT.filter((o) =>
            (o !== 'psf' || showPsfInTowerView !== false) && (o !== 'price' || showPriceInTowerView !== false)));
          setTopViewingShowPsfColumnByDefault(showPsfInTowerView !== false);
        } catch (err) {
          console.error('Failed to load site plan/tower view for generic search:', err);
          setTopViewingSitePlansError('Failed to load site plan/tower view data.');
          setTowerViewUnits([]);
          setTowerViewUnitTypes([]);
          setTopViewingTowerDisplayOptions([...TOP_VIEWING_TOWER_DISPLAY_DEFAULT]);
          setTopViewingShowPsfColumnByDefault(true);
        } finally {
          setTopViewingSitePlanContentLoading(false);
        }
      }
    } catch (err) {
      updateTabState(tabId, {
        error: err instanceof Error ? err.message : 'Failed to fetch comparable units',
        loading: false,
      });
      if (tabId === 'generic') {
        setTopViewingComparableUnitsLoading(false);
      }
    }
  }, [
    activeTabId,
    tabStates,
    getDefaultTabState,
    updateTabState,
    loanToValue,
    tenureYears,
    interestRate,
    setProjectDetailsMap,
    setFilters,
    setRangeFilters,
    setSortConfig,
    setThumbsUpFilterActive,
    userInfo,
    resolveProjectIdByName,
    resolveProjectIdsByName,
    mapReferenceToComparableUnit,
    setTopViewingComparableUnitsLoading,
    setTopViewingComparableUnits,
    setTopViewingReferenceUnit,
    setTopViewingFloorPlansToCompare,
    setTopViewingCompViewMode,
    setTopViewingCompFilters,
    setTopViewingCompRangeFilters,
    setTopViewingCompSortConfig,
    setTopViewingThumbsUpFilterActive,
    setTopViewingComparableSectionOpen,
    setTopViewingAreaTolerance,
    setTopViewingToleranceSliderValue,
    setTopViewingSitePlanContentLoading,
    setTopViewingSitePlansError,
    setSelectedTopViewingSitePlan,
    setSitePlanBedroomFilter,
    setSitePlanUnitTypeFilter,
    setSitePlanBlinkingStacks,
    setSelectedBlock,
    fetchTowerViewUnits,
    setTowerViewUnits,
    setTowerViewUnitTypes,
    setTopViewingTowerDisplayOptions,
    setTopViewingShowPsfColumnByDefault,
    loadSitePlanContext,
  ]);

  const buildComparableUnitFromShortlist = useCallback((item: ShortlistItem): ComparableUnit | null => {
    if (!item.unitId || !item.projectName || !item.unitNumber) {
      return null;
    }
    const areaSqft = item.areaSqft ?? 0;
    const price = item.price ?? 0;
    const psf = item.psf ?? (areaSqft ? price / areaSqft : 0);
    return {
      id: item.unitId,
      projectName: item.projectName,
      unitNumber: item.unitNumber,
      blockNumber: item.blockNumber ?? null,
      bedroom: item.bedroom ?? 0,
      bathroom: item.bathroom ?? 0,
      areaSqft,
      price,
      priceDiff: 0,
      priceDiffPercent: 0,
      psf,
      psfDiff: 0,
      psfDiffPercent: 0,
      outlay: 0,
      outlayDiff: 0,
      installment: 0,
      installmentDiff: 0,
      unitStatus: item.unitStatus ?? null,
      floorplan: item.floorplan ?? null,
    };
  }, []);

  const handleSearch = async () => {
    if (!selectedProject || !unitNumber.trim()) {
      setError('Please select a project and enter a unit number');
      return;
    }
    await handleSearchWithParams(selectedProject, unitNumber.trim());
  };

  const getUnitStatusColor = (status?: string | null) => {
    const normalized = status?.toLowerCase() || '';
    if (['sold', 'unavailable'].includes(normalized)) {
      return 'error';
    }
    if (['reserved', 'pending'].includes(normalized)) {
      return 'warning';
    }
    if (['available'].includes(normalized)) {
      return 'success';
    }
    return 'default';
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getClientInitials = (name: string): string => {
    return name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .toUpperCase();
  };

  const getProjectAbbreviation = (projectName: string): string => {
    return projectName
      .split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase();
  };

  const openClientEditor = (client: ClientProfile) => {
    const pickerChoices = [3, 4, 5].map((seq) => {
      const choice = client.choiceUnits?.find((unit) => unit.seq === seq && unit.type === 'PICKER');
      return choice?.unitNumber ?? '';
    });
    setClientEditTarget(client);
    setClientEditForm({
      name: client.name || '',
      phone: client.phone || '',
      notes: client.notes || '',
      pickerChoices,
    });
    setClientEditError(null);
    setClientEditOpen(true);
  };

  // Fetch units when editing client with projectId
  useEffect(() => {
    const fetchUnits = async () => {
      if (!clientEditTarget?.projectId) {
        setClientEditUnits([]);
        return;
      }
      try {
        setClientEditUnitsLoading(true);
        const units = await api.getProjectUnits(clientEditTarget.projectId);
        setClientEditUnits(units.map((unit) => unit.unitNumber).filter(Boolean));
      } catch (err) {
        console.error('Failed to fetch units:', err);
        setClientEditUnits([]);
      } finally {
        setClientEditUnitsLoading(false);
      }
    };
    if (clientEditOpen && clientEditTarget) {
      fetchUnits();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientEditOpen, clientEditTarget?.projectId]);

  // Fetch units when creating client with projectId
  useEffect(() => {
    const fetchUnits = async () => {
      if (!clientCreateForm.projectId) {
        setClientCreateUnits([]);
        return;
      }
      try {
        setClientCreateUnitsLoading(true);
        const units = await api.getProjectUnits(clientCreateForm.projectId);
        setClientCreateUnits(units.map((unit) => unit.unitNumber).filter(Boolean));
      } catch (err) {
        console.error('Failed to fetch units:', err);
        setClientCreateUnits([]);
      } finally {
        setClientCreateUnitsLoading(false);
      }
    };
    if (clientCreateOpen && clientCreateForm.projectId) {
      fetchUnits();
    }
  }, [clientCreateOpen, clientCreateForm.projectId]);

  const closeClientEditor = () => {
    setClientEditOpen(false);
    setClientEditTarget(null);
    setClientEditError(null);
  };

  const openClientCreator = () => {
    setClientCreateForm({
      projectId: '',
      name: '',
      phone: '',
      notes: '',
      eoiNo: '',
      ballotNo: '',
      queueNo: '',
      pickerChoices: ['', '', ''],
    });
    setClientCreateError(null);
    setClientCreateOpen(true);
  };

  const closeClientCreator = () => {
    setClientCreateOpen(false);
    setClientCreateForm({
      projectId: '',
      name: '',
      phone: '',
      notes: '',
      eoiNo: '',
      ballotNo: '',
      queueNo: '',
      pickerChoices: ['', '', ''],
    });
    setClientCreateError(null);
  };

  const handleSaveClientCreate = async () => {
    if (!clientCreateForm.projectId) {
      setClientCreateError('Project is required');
      return;
    }
    try {
      setClientCreateSaving(true);
      setClientCreateError(null);
      const created = await api.createClient({
        projectId: clientCreateForm.projectId,
        name: clientCreateForm.name.trim() || null,
        phone: clientCreateForm.phone.trim() || null,
        notes: clientCreateForm.notes.trim() || null,
        eoiNo: clientCreateForm.eoiNo.trim() || null,
        ballotNo: clientCreateForm.ballotNo.trim() || null,
        queueNo: clientCreateForm.queueNo.trim() || null,
        pickerChoices: clientCreateForm.pickerChoices.map((unitNumber) => ({
          unitNumber: unitNumber.trim() || null,
        })),
      });
      const normalized = {
        ...created,
        choiceUnits: [...(created.choiceUnits || [])].sort((a, b) => (a.seq ?? 0) - (b.seq ?? 0)),
      };
      setClients((prev) => [...prev, normalized]);
      setClientsIndex((prev) => {
        const next = new Map(prev);
        next.set(normalized.id, normalized);
        return next;
      });
      setClientsTotal((prev) => prev + 1);
      closeClientCreator();
    } catch (err) {
      setClientCreateError(err instanceof Error ? err.message : 'Failed to create client');
    } finally {
      setClientCreateSaving(false);
    }
  };

  const handleSaveClientEdit = async () => {
    if (!clientEditTarget) {
      return;
    }
    try {
      setClientEditSaving(true);
      setClientEditError(null);
      const updated = await api.updateClient(clientEditTarget.id, {
        name: clientEditForm.name.trim() || null,
        phone: clientEditForm.phone.trim() || null,
        notes: clientEditForm.notes.trim() || null,
        pickerChoices: clientEditForm.pickerChoices.map((unitNumber) => ({
          unitNumber: unitNumber.trim() || null,
        })),
      });
      const normalized = {
        ...updated,
        choiceUnits: [...(updated.choiceUnits || [])].sort((a, b) => (a.seq ?? 0) - (b.seq ?? 0)),
      };

      setClients((prev) =>
        prev.map((client) => (client.id === normalized.id ? { ...normalized } : client))
      );
      setClientsIndex((prev) => {
        const next = new Map(prev);
        next.set(normalized.id, normalized);
        return next;
      });
      if (activeClientId === normalized.id) {
        setActiveClientId(normalized.id);
      }
      setClientEditOpen(false);
      setClientEditTarget(null);
    } catch (err) {
      setClientEditError(err instanceof Error ? err.message : 'Failed to update client');
    } finally {
      setClientEditSaving(false);
    }
  };

  const openClientTab = async (client: ClientProfile, unit?: ClientChoiceUnit) => {
    const baseTabId = `client:${client.id}`;
    const projectName = unit?.projectName || client.projectName || client.choiceUnits?.[0]?.projectName || 'Unknown';
    const projectAbbrev = getProjectAbbreviation(projectName);
    const clientFullName = client.name.toUpperCase();
    const label = `${projectAbbrev} - ${clientFullName}`;

    // Check if we're already on this client's tab
    const isAlreadyOnClientTab = activeTabId === baseTabId || activeTabId.startsWith(`${baseTabId}:`);

    if (isAlreadyOnClientTab && unit?.projectName && unit.unitNumber) {
      // Already on client tab, just update the reference unit (use UnitId when available)
      await handleSearchWithParams(unit.projectName, unit.unitNumber, baseTabId, unit.unitId);
      return;
    }

    // Not on client tab, open/switch to client tab
    setClientTabs((prev) => {
      const exists = prev.some((tab) => tab.id === baseTabId);
      if (exists) {
        return prev;
      }
      return [
        ...prev,
        {
          id: baseTabId,
          label,
          clientId: client.id,
          projectName: unit?.projectName || client.projectName || client.choiceUnits?.[0]?.projectName || undefined,
          unitNumber: unit?.unitNumber,
          unitId: unit?.unitId ?? undefined,
        },
      ];
    });

    setActiveTabId(baseTabId);
    setActiveClientId(client.id);

    if (unit?.projectName && unit.unitNumber) {
      // Pass baseTabId and unitId (from ProjectUserQueueChoice) so reference unit loads by UnitId when available
      await handleSearchWithParams(unit.projectName, unit.unitNumber, baseTabId, unit.unitId);
    }
  };

  const closeClientTab = (tabId: string) => {
    setClientTabs((prev) => prev.filter((tab) => tab.id !== tabId));
    // Clean up tab state
    setTabStates((prev) => {
      const newMap = new Map(prev);
      newMap.delete(tabId);
      return newMap;
    });
    if (activeTabId === tabId) {
      setActiveTabId(isExternalUser ? TOP_VIEWING_SITE_PLANS_TAB : 'generic');
      setActiveClientId(null);
    }
  };

  const openShortlistRemarkDialog = useCallback((payload: {
    mode: 'add' | 'edit';
    unitId?: number | null;
    itemId?: number | null;
    label: string;
    floorplan?: string | null;
    remark?: string | null;
  }) => {
    setShortlistRemarkMode(payload.mode);
    setShortlistRemarkUnitId(payload.unitId ?? null);
    setShortlistRemarkItemId(payload.itemId ?? null);
    setShortlistRemarkUnitLabel(payload.label);
    setShortlistRemarkUnitFloorplan(payload.floorplan ?? null);
    setShortlistRemarkText(payload.remark ?? '');
    setShortlistRemarkOpen(true);
  }, []);

  const resetShortlistRemarkDialog = useCallback(() => {
    setShortlistRemarkOpen(false);
    setShortlistRemarkText('');
    setShortlistRemarkUnitId(null);
    setShortlistRemarkItemId(null);
    setShortlistRemarkMode('add');
    setShortlistRemarkUnitLabel('');
    setShortlistRemarkUnitFloorplan(null);
  }, []);

  const handleRemoveShortlistItem = useCallback(async (item: ShortlistItem) => {
    if (shortlistUpdatingUnitId === item.unitId) {
      return;
    }
    setShortlistUpdatingUnitId(item.unitId ?? null);
    try {
      await api.removeShortlist(item.id);
      setShortlistItems((prev) => prev.filter((existing) => existing.id !== item.id));
      logShortlistRemove({
        projectName: item.projectName,
        projectId: item.projectId,
        unitNumber: item.unitNumber,
        unitId: item.unitId,
        source: 'shortlist_remove',
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });
    } catch (err) {
      setShortlistError(err instanceof Error ? err.message : 'Failed to remove shortlist');
    } finally {
      setShortlistUpdatingUnitId(null);
    }
  }, [shortlistUpdatingUnitId, userInfo?.CEANumber]);

  const handleConfirmShortlistRemark = useCallback(async () => {
    if (shortlistRemarkMode === 'add' && !shortlistRemarkUnitId) {
      return;
    }
    if (shortlistRemarkMode === 'edit' && !shortlistRemarkItemId) {
      return;
    }
    if (shortlistUpdatingUnitId === shortlistRemarkUnitId) {
      return;
    }
    setShortlistUpdatingUnitId(shortlistRemarkUnitId);
    try {
      const remarkValue = shortlistRemarkText.trim();
      if (shortlistRemarkMode === 'add') {
        if (!shortlistRemarkUnitId) return;
        const created = await api.addShortlist({
          unitId: shortlistRemarkUnitId,
          remark: remarkValue.length > 0 ? remarkValue : undefined,
        });
        setShortlistItems((prev) => [created, ...prev.filter((item) => item.id !== created.id)]);
        logShortlistAdd({
          projectName: created.projectName,
          projectId: created.projectId,
          unitNumber: created.unitNumber,
          unitId: created.unitId,
          source: 'shortlist_add',
          ceaNumber: userInfo?.CEANumber || getDevCea(),
        });
        resetShortlistRemarkDialog();
      } else {
        if (!shortlistRemarkItemId) return;
        const updated = await api.updateShortlistRemark(
          shortlistRemarkItemId,
          remarkValue.length > 0 ? remarkValue : null,
        );
        setShortlistItems((prev) =>
          prev.map((item) => (item.id === updated.id ? updated : item))
        );
        resetShortlistRemarkDialog();
      }
    } catch (err) {
      setShortlistError(err instanceof Error ? err.message : 'Failed to update shortlist item');
    } finally {
      setShortlistUpdatingUnitId(null);
    }
  }, [
    resetShortlistRemarkDialog,
    shortlistRemarkItemId,
    shortlistRemarkMode,
    shortlistRemarkText,
    shortlistRemarkUnitId,
    shortlistUpdatingUnitId,
    userInfo?.CEANumber,
  ]);

  const handleShortlistAction = useCallback((payload: {
    unitId: number;
    label: string;
    floorplan?: string | null;
  }) => {
    const existing = shortlistByUnitId.get(payload.unitId);
    if (existing) {
      handleRemoveShortlistItem(existing);
      return;
    }
    if (shortlistItems.length >= 10) {
      setShortlistError('Shortlist limit reached (max 10).');
      setShortlistDialogOpen(true);
      return;
    }
    openShortlistRemarkDialog({
      mode: 'add',
      unitId: payload.unitId,
      label: payload.label,
      floorplan: payload.floorplan,
    });
  }, [handleRemoveShortlistItem, openShortlistRemarkDialog, shortlistByUnitId, shortlistItems.length]);

  const handleRequestShortlistDelete = useCallback((item: ShortlistItem) => {
    setShortlistDeleteTarget(item);
    setShortlistDeleteConfirmOpen(true);
  }, []);

  const handleConfirmShortlistDelete = useCallback(async () => {
    if (!shortlistDeleteTarget) {
      return;
    }
    await handleRemoveShortlistItem(shortlistDeleteTarget);
    setShortlistDeleteConfirmOpen(false);
    setShortlistDeleteTarget(null);
  }, [handleRemoveShortlistItem, shortlistDeleteTarget]);

  const handleCancelShortlistDelete = useCallback(() => {
    setShortlistDeleteConfirmOpen(false);
    setShortlistDeleteTarget(null);
  }, []);

  const handleTabChange = async (_event: React.SyntheticEvent, newValue: string) => {
    if (isExternalUser && newValue === 'generic') {
      return;
    }
    if (newValue === 'success-closer' && !canAccessSuccessCloser) {
      return;
    }
    if (newValue === MY_SHARABLE_LINKS_TAB && !canAccessSharableLinks) {
      return;
    }
    if (newValue === 'map-research' && !canAccessSuperMap) {
      return;
    }
    if (newValue === MARKETING_MATERIALS_TAB && !canAccessProjectMaterials) {
      return;
    }
    const currentCea = userInfo?.CEANumber || getDevCea();
    const tabLabel = newValue === 'generic'
      ? 'Find Comparable Tool'
      : newValue === 'master'
      ? 'Project Research'
      : newValue === 'map-research'
      ? 'Good Deals Map'
      : newValue === TOP_VIEWING_SITE_PLANS_TAB
      ? 'Top Viewing Site Plans'
      : newValue === MY_SHARABLE_LINKS_TAB
      ? 'My Shareable Links'
      : (clientTabs.find((t) => t.id === newValue)?.label ?? newValue);
    logMenuClick(`Tab: ${tabLabel}`, currentCea);
    if (newValue === 'master') {
      logProjectResearchTabViewed(selectedProject || null, currentCea);
    }
    setActiveTabId(newValue);

    // Keep selected site plan when switching tabs so returning to Top Viewing preserves view

    if (newValue === 'generic' || newValue === 'master' || newValue === 'map-research' || newValue === TOP_VIEWING_SITE_PLANS_TAB || newValue === MY_SHARABLE_LINKS_TAB) {
      setActiveClientId(null);
      return;
    }

    const tab = clientTabs.find((item) => item.id === newValue);
    if (tab) {
      setActiveClientId(tab.clientId);
      if (tab.projectName && tab.unitNumber) {
        // Pass unitId when tab has it so reference unit loads by UnitId from ProjectUserQueueChoice
        await handleSearchWithParams(tab.projectName, tab.unitNumber, newValue, tab.unitId);
      }
    }
  };

  type MasterToolUnitWithComputed = MasterToolUnit & {
    computedFloor: number | null;
    computedStack: number | null;
    outlay: number;
    installment: number;
  };

  const masterToolUnitsWithComputed = useMemo((): MasterToolUnitWithComputed[] => {
    return masterToolUnits.map((unit) => {
      const parsed = parseUnitNumber(unit.unitNumber);
      const outlay = calculateOutlay(unit.price, loanToValue / 100);
      const installment = calculateInstallment(
        unit.price,
        loanToValue / 100,
        tenureYears,
        interestRate / 100
      );
      return {
        ...unit,
        computedFloor: unit.computedFloor ?? parsed.floor,
        computedStack: unit.computedStack ?? parsed.stack,
        outlay,
        installment,
      };
    });
  }, [masterToolUnits, loanToValue, tenureYears, interestRate]);

  const getMasterToolProjectDistrictLocation = useCallback((project: ProjectDetails): string => {
    if (project.districtLocation) return project.districtLocation;
    const parts = [project.area, project.district].filter(Boolean);
    return parts.length > 0 ? parts.join(' / ') : '';
  }, []);

  const getMasterToolProjectCellTextValue = useCallback((
    project: MasterToolProjectResult,
    key: MasterToolProjectFilterSortColumnKey
  ): string => {
    const formatCurrencyValue = (value: number): string => `$${Number(value).toLocaleString()}`;
    switch (key) {
      case 'projectName':
        return project.name ?? '';
      case 'projectCategory':
        return project.projectCategory ?? '';
      case 'developer':
        return project.developer ?? '';
      case 'totalUnits':
        return project.totalUnits != null ? String(project.totalUnits) : '';
      case 'soldUnits':
        return project.soldUnits != null ? String(project.soldUnits) : '';
      case 'referenceDistanceKm':
        return project.distanceFromReferenceKm != null
          ? `${Number(project.distanceFromReferenceKm).toFixed(2)} km`
          : '';
      case 'districtLocation':
        return getMasterToolProjectDistrictLocation(project);
      case 'district':
        return project.district ?? '';
      case 'region':
        return project.area ?? '';
      case 'nearestMrt':
        return project.nearestMrt ?? '';
      case 'walkingTimeToMrt':
        return project.walkingTimeToMrt != null ? String(project.walkingTimeToMrt) : '';
      case 'tenure':
        return project.tenure ?? '';
      case 'topDate':
        return project.topDate != null ? String(project.topDate) : '';
      case 'completedDate':
        return project.completedDate
          ? new Date(project.completedDate).toLocaleDateString('en-SG', { year: 'numeric', month: 'short', day: 'numeric' })
          : '';
      case 'matchedTotal':
        return String(Number(project.matchedUnitCount ?? 0));
      case 'matchedBr1':
        return String(Number(project.matchedByBedroom?.br1 ?? 0));
      case 'matchedBr2':
        return String(Number(project.matchedByBedroom?.br2 ?? 0));
      case 'matchedBr3':
        return String(Number(project.matchedByBedroom?.br3 ?? 0));
      case 'matchedBr4':
        return String(Number(project.matchedByBedroom?.br4 ?? 0));
      case 'matchedBr5':
        return String(Number(project.matchedByBedroom?.br5 ?? 0));
      case 'matchedPh':
        return String(Number(project.matchedByBedroom?.ph ?? 0));
      case 'matchedBr1From':
        return project.matchedLowestPriceByBedroom?.br1 != null
          ? formatCurrencyValue(project.matchedLowestPriceByBedroom.br1)
          : '';
      case 'matchedBr2From':
        return project.matchedLowestPriceByBedroom?.br2 != null
          ? formatCurrencyValue(project.matchedLowestPriceByBedroom.br2)
          : '';
      case 'matchedBr3From':
        return project.matchedLowestPriceByBedroom?.br3 != null
          ? formatCurrencyValue(project.matchedLowestPriceByBedroom.br3)
          : '';
      case 'matchedBr4From':
        return project.matchedLowestPriceByBedroom?.br4 != null
          ? formatCurrencyValue(project.matchedLowestPriceByBedroom.br4)
          : '';
      case 'matchedBr5From':
        return project.matchedLowestPriceByBedroom?.br5 != null
          ? formatCurrencyValue(project.matchedLowestPriceByBedroom.br5)
          : '';
      case 'matchedPhFrom':
        return project.matchedLowestPriceByBedroom?.ph != null
          ? formatCurrencyValue(project.matchedLowestPriceByBedroom.ph)
          : '';
      default: {
        const brMatch = key.match(/^(br[1-5]|ph)(avail|price|psf)$/);
        if (!brMatch) return '';
        const brKey = brMatch[1] as 'br1' | 'br2' | 'br3' | 'br4' | 'br5' | 'ph';
        const metric = brMatch[2];
        const bedroomStats = project[brKey];
        if (!bedroomStats) return '';
        if (metric === 'avail') return bedroomStats.availableUnits != null ? String(bedroomStats.availableUnits) : '';
        if (metric === 'price') return bedroomStats.fromPrice != null ? formatCurrencyValue(bedroomStats.fromPrice) : '';
        return bedroomStats.fromPsf != null ? formatCurrencyValue(bedroomStats.fromPsf) : '';
      }
    }
  }, [getMasterToolProjectDistrictLocation]);

  const getMasterToolProjectCellNumericValue = useCallback((
    project: MasterToolProjectResult,
    key: MasterToolProjectFilterSortColumnKey
  ): number | null => {
    const parseNumberish = (value: unknown): number | null => {
      if (value == null) return null;
      if (typeof value === 'number' && Number.isFinite(value)) return value;
      const normalized = String(value).replace(/,/g, '').replace(/[^0-9.-]/g, '');
      if (!normalized) return null;
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : null;
    };

    switch (key) {
      case 'totalUnits':
        return parseNumberish(project.totalUnits);
      case 'soldUnits':
        return parseNumberish(project.soldUnits);
      case 'referenceDistanceKm':
        return parseNumberish(project.distanceFromReferenceKm);
      case 'walkingTimeToMrt':
        return parseNumberish(project.walkingTimeToMrt);
      case 'topDate':
        return parseNumberish(project.topDate);
      case 'matchedTotal':
        return parseNumberish(project.matchedUnitCount);
      case 'matchedBr1':
        return parseNumberish(project.matchedByBedroom?.br1);
      case 'matchedBr2':
        return parseNumberish(project.matchedByBedroom?.br2);
      case 'matchedBr3':
        return parseNumberish(project.matchedByBedroom?.br3);
      case 'matchedBr4':
        return parseNumberish(project.matchedByBedroom?.br4);
      case 'matchedBr5':
        return parseNumberish(project.matchedByBedroom?.br5);
      case 'matchedPh':
        return parseNumberish(project.matchedByBedroom?.ph);
      case 'matchedBr1From':
        return parseNumberish(project.matchedLowestPriceByBedroom?.br1);
      case 'matchedBr2From':
        return parseNumberish(project.matchedLowestPriceByBedroom?.br2);
      case 'matchedBr3From':
        return parseNumberish(project.matchedLowestPriceByBedroom?.br3);
      case 'matchedBr4From':
        return parseNumberish(project.matchedLowestPriceByBedroom?.br4);
      case 'matchedBr5From':
        return parseNumberish(project.matchedLowestPriceByBedroom?.br5);
      case 'matchedPhFrom':
        return parseNumberish(project.matchedLowestPriceByBedroom?.ph);
      default: {
        const brMatch = key.match(/^(br[1-5]|ph)(avail|price|psf)$/);
        if (!brMatch) return null;
        const brKey = brMatch[1] as 'br1' | 'br2' | 'br3' | 'br4' | 'br5' | 'ph';
        const metric = brMatch[2];
        const bedroomStats = project[brKey];
        if (!bedroomStats) return null;
        if (metric === 'avail') return parseNumberish(bedroomStats.availableUnits);
        if (metric === 'price') return parseNumberish(bedroomStats.fromPrice);
        return parseNumberish(bedroomStats.fromPsf);
      }
    }
  }, []);

  const masterToolProjectCategoryOptions = useMemo(() => {
    const projectName = new Set<string>();
    const projectCategory = new Set<string>();
    const district = new Set<string>();
    const region = new Set<string>();
    const nearestMrt = new Set<string>();
    const tenure = new Set<string>();

    masterToolResults.forEach((project) => {
      const normalizedName = (project.name ?? '').trim();
      const normalizedCategory = (project.projectCategory ?? '').trim();
      const normalizedDistrict = (project.district ?? '').trim();
      const normalizedRegion = (project.area ?? '').trim();
      const normalizedMrt = (project.nearestMrt ?? '').trim();
      const normalizedTenure = (project.tenure ?? '').trim();

      if (normalizedName) projectName.add(normalizedName);
      if (normalizedCategory) projectCategory.add(normalizedCategory);
      if (normalizedDistrict && !/^district\s+/i.test(normalizedDistrict)) district.add(normalizedDistrict);
      if (normalizedRegion) region.add(normalizedRegion);
      if (normalizedMrt) nearestMrt.add(normalizedMrt);
      if (normalizedTenure) tenure.add(normalizedTenure);
    });

    return {
      projectName: Array.from(projectName).sort((a, b) => a.localeCompare(b)),
      projectCategory: Array.from(projectCategory).sort((a, b) => a.localeCompare(b)),
      district: Array.from(district).sort((a, b) => a.localeCompare(b)),
      region: Array.from(region).sort((a, b) => a.localeCompare(b)),
      nearestMrt: Array.from(nearestMrt).sort((a, b) => a.localeCompare(b)),
      tenure: Array.from(tenure).sort((a, b) => a.localeCompare(b)),
    };
  }, [masterToolResults]);

  const masterToolProjectCategorySelections = useMemo(() => {
    const selected = masterToolFilters.projectCategories ?? [];
    if (selected.length === 0) return [];
    const byId = new Map(masterToolProjectCategoryList.map((item) => [item.id, item]));
    return selected
      .map((id) => byId.get(id))
      .filter((item): item is ProjectCategoryOption => Boolean(item));
  }, [masterToolFilters.projectCategories, masterToolProjectCategoryList]);

  useEffect(() => {
    const q = masterToolLocationInput.trim();
    if (!q) {
      setMasterToolLocationOptions([]);
      return;
    }
    let cancelled = false;
    setMasterToolLocationSearching(true);
    const timer = setTimeout(async () => {
      try {
        const results = await searchOnemapLocations(q);
        if (!cancelled) setMasterToolLocationOptions(results);
      } catch {
        if (!cancelled) setMasterToolLocationOptions([]);
      } finally {
        if (!cancelled) setMasterToolLocationSearching(false);
      }
    }, 300);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [masterToolLocationInput]);

  const clearMasterToolLocationFilters = useCallback(() => {
    setMasterToolLocationInput('');
    setMasterToolLocationOptions([]);
    setMasterToolSelectedLocation(null);
    setMasterToolFilters((f) => {
      const { locationLat, locationLng, locationLabel, radiusKm, ...rest } = f;
      return rest;
    });
  }, []);

  const masterToolProjectRowsForDisplay = useMemo(() => {
    const parseFilterNumber = (value: string): number | null => {
      const normalized = value.trim().replace(/,/g, '').replace(/[^0-9.-]/g, '');
      if (!normalized) return null;
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const filtered = masterToolResults.filter((project) => {
      const projectCategoryValues: Record<MasterToolProjectCategoryFilterKey, string> = {
        projectName: (project.name ?? '').trim(),
        projectCategory: (project.projectCategory ?? '').trim(),
        district: (project.district ?? '').trim(),
        region: (project.area ?? '').trim(),
        nearestMrt: (project.nearestMrt ?? '').trim(),
        tenure: (project.tenure ?? '').trim(),
      };

      const categoryPass = (Object.keys(projectCategoryValues) as MasterToolProjectCategoryFilterKey[]).every((key) => {
        const selected = masterToolProjectCategoryFilters[key];
        if (selected.length === 0) return true;
        const value = projectCategoryValues[key];
        return value !== '' && selected.includes(value);
      });
      if (!categoryPass) return false;

      return MASTER_TOOL_PROJECT_FILTER_SORT_COLUMN_KEYS.every((key) => {
        if (MASTER_TOOL_PROJECT_VIEW_NUMERIC_COLUMNS.has(key)) {
          const range = debouncedMasterToolProjectViewRangeFilters[key] ?? { min: '', max: '' };
          const min = parseFilterNumber(range.min);
          const max = parseFilterNumber(range.max);
          if (min == null && max == null) return true;
          const numericValue = getMasterToolProjectCellNumericValue(project, key);
          if (numericValue == null) return false;
          if (min != null && numericValue < min) return false;
          if (max != null && numericValue > max) return false;
          return true;
        }
        const textFilter = (debouncedMasterToolProjectViewFilters[key] ?? '').trim().toLowerCase();
        if (!textFilter) return true;
        return getMasterToolProjectCellTextValue(project, key).toLowerCase().includes(textFilter);
      });
    });

    if (!masterToolProjectSortConfig.column || masterToolProjectSortConfig.direction === 'default') {
      return filtered;
    }

    const sorted = [...filtered].sort((a, b) => {
      const column = masterToolProjectSortConfig.column!;
      if (MASTER_TOOL_PROJECT_VIEW_NUMERIC_COLUMNS.has(column)) {
        const aValue = getMasterToolProjectCellNumericValue(a, column);
        const bValue = getMasterToolProjectCellNumericValue(b, column);
        if (aValue == null && bValue == null) return 0;
        if (aValue == null) return 1;
        if (bValue == null) return -1;
        return aValue - bValue;
      }
      const aValue = getMasterToolProjectCellTextValue(a, column);
      const bValue = getMasterToolProjectCellTextValue(b, column);
      return aValue.localeCompare(bValue, undefined, { sensitivity: 'base' });
    });

    return masterToolProjectSortConfig.direction === 'asc' ? sorted : sorted.reverse();
  }, [
    getMasterToolProjectCellNumericValue,
    getMasterToolProjectCellTextValue,
    debouncedMasterToolProjectViewFilters,
    debouncedMasterToolProjectViewRangeFilters,
    masterToolProjectCategoryFilters,
    masterToolProjectSortConfig,
    masterToolResults,
  ]);

  const masterToolProjectScopedNames = useMemo(() => {
    if (masterToolResults.length === 0) return null;
    const scoped = Array.from(
      new Set(
        masterToolProjectRowsForDisplay
          .map((project) => (project.name ?? '').trim())
          .filter(Boolean)
      )
    );
    return scoped.length === masterToolResults.length ? null : scoped;
  }, [masterToolProjectRowsForDisplay, masterToolResults.length]);

  const getMasterToolProjectSelectionKey = useCallback((project: MasterToolProjectResult): string => {
    return (project.id ?? '').trim() || (project.name ?? '').trim();
  }, []);

  const selectedMasterToolProjectRowsForExport = useMemo(() => {
    return masterToolProjectRowsForDisplay.filter((project) => {
      const key = getMasterToolProjectSelectionKey(project);
      return key !== '' && selectedMasterToolProjectKeys.has(key);
    });
  }, [getMasterToolProjectSelectionKey, masterToolProjectRowsForDisplay, selectedMasterToolProjectKeys]);

  const visibleMasterToolProjectSelectionKeys = useMemo(() => {
    return masterToolProjectRowsForDisplay
      .map((project) => getMasterToolProjectSelectionKey(project))
      .filter((key) => key !== '');
  }, [getMasterToolProjectSelectionKey, masterToolProjectRowsForDisplay]);

  const selectedVisibleMasterToolProjectCount = useMemo(() => {
    return visibleMasterToolProjectSelectionKeys.filter((key) => selectedMasterToolProjectKeys.has(key)).length;
  }, [selectedMasterToolProjectKeys, visibleMasterToolProjectSelectionKeys]);

  useEffect(() => {
    setSelectedMasterToolProjectKeys(new Set(visibleMasterToolProjectSelectionKeys));
  }, [visibleMasterToolProjectSelectionKeys]);

  const areAllVisibleMasterToolProjectsSelected = visibleMasterToolProjectSelectionKeys.length > 0
    && selectedVisibleMasterToolProjectCount === visibleMasterToolProjectSelectionKeys.length;

  const areSomeVisibleMasterToolProjectsSelected = selectedVisibleMasterToolProjectCount > 0
    && selectedVisibleMasterToolProjectCount < visibleMasterToolProjectSelectionKeys.length;

  const handleToggleMasterToolProjectSelection = useCallback((project: MasterToolProjectResult) => {
    const key = getMasterToolProjectSelectionKey(project);
    if (!key) return;
    setSelectedMasterToolProjectKeys((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }, [getMasterToolProjectSelectionKey]);

  const handleToggleAllVisibleMasterToolProjectSelection = useCallback(() => {
    setSelectedMasterToolProjectKeys((prev) => {
      const next = new Set(prev);
      if (areAllVisibleMasterToolProjectsSelected) {
        visibleMasterToolProjectSelectionKeys.forEach((key) => next.delete(key));
      } else {
        visibleMasterToolProjectSelectionKeys.forEach((key) => next.add(key));
      }
      return next;
    });
  }, [areAllVisibleMasterToolProjectsSelected, visibleMasterToolProjectSelectionKeys]);

  const getEffectiveMasterToolUnitFilters = useCallback((): Record<MasterToolUnitColumnKey, string | string[]> => {
    if (!masterToolProjectScopedNames) {
      return debouncedMasterToolUnitFilters;
    }

    const scopedSet = new Set(masterToolProjectScopedNames.map((name) => name.trim()).filter(Boolean));
    const unitProjectNames = Array.isArray(debouncedMasterToolUnitFilters.projectName)
      ? debouncedMasterToolUnitFilters.projectName.map((name) => name.trim()).filter(Boolean)
      : [];

    const scopedProjectNames =
      unitProjectNames.length === 0
        ? Array.from(scopedSet)
        : unitProjectNames.filter((name) => scopedSet.has(name));

    return {
      ...debouncedMasterToolUnitFilters,
      projectName: scopedProjectNames,
    };
  }, [debouncedMasterToolUnitFilters, masterToolProjectScopedNames]);

  const handleMasterToolSearch = useCallback(async () => {
    const hasReferenceLocation = Boolean(
      (masterToolFilters.locationLat ?? '').trim()
      && (masterToolFilters.locationLng ?? '').trim()
    );
    const radiusValue = Number(masterToolFilters.radiusKm ?? '');
    const hasValidRadius = Number.isFinite(radiusValue) && radiusValue > 0;
    if (hasReferenceLocation && !hasValidRadius) {
      setError('Please enter a valid Radius (km) before searching.');
      return;
    }

    const defaultProjectCategoryFilters: Record<MasterToolProjectCategoryFilterKey, string[]> = {
      projectName: [],
      projectCategory: [],
      district: [],
      region: [],
      nearestMrt: [],
      tenure: [],
    };
    const defaultUnitFilters: Record<MasterToolUnitColumnKey, string | string[]> = {
      projectName: [],
      projectCategory: [],
      unitNumber: '',
      blockNumber: '',
      district: [],
      region: [],
      districtLocation: [],
      nearestMrt: [],
      walkingTimeToMrt: '',
      tenure: [],
      topYear: '',
      floor: '',
      stack: '',
      bedroom: '',
      bathroom: '',
      areaSqft: '',
      price: '',
      dps: '',
      psf: '',
      outlay: '',
      installment: '',
    };
    const defaultUnitRangeFilters: Record<MasterToolUnitRangeKey, { min: string; max: string }> = {
      floor: { min: '', max: '' },
      stack: { min: '', max: '' },
      bedroom: { min: '', max: '' },
      bathroom: { min: '', max: '' },
      areaSqft: { min: '', max: '' },
      price: { min: '', max: '' },
      dps: { min: '', max: '' },
      psf: { min: '', max: '' },
      outlay: { min: '', max: '' },
      installment: { min: '', max: '' },
      walkingTimeToMrt: { min: '', max: '' },
      topYear: { min: '', max: '' },
    };

    // Every new search starts clean: clear current table filters/sort from previous result set.
    setMasterToolProjectSortConfig({ column: null, direction: 'default' });
    setMasterToolProjectViewFilters({});
    setMasterToolProjectViewRangeFilters({});
    setMasterToolProjectCategoryFilters(defaultProjectCategoryFilters);
    setMasterToolUnitSortConfig({ column: null, direction: 'default' });
    setMasterToolUnitFilters(defaultUnitFilters);
    setMasterToolUnitRangeFilters(defaultUnitRangeFilters);
    setMasterToolPopoverAnchor(null);
    setMasterToolUnitPopoverAnchor(null);
    setMasterToolProjectPage(1);
    setMasterToolUnitPage(1);

    const searchId = `project_research_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const currentCea = userInfo?.CEANumber || getDevCea();
    logProjectResearchSearchSubmitted({
      searchId,
      viewMode: masterToolViewMode,
      filters: masterToolFilters,
      ceaNumber: currentCea,
    });
    setMasterToolAmberwoodBedrooms(amberwoodBannerBedrooms(masterToolFilters.bedroomMin, masterToolFilters.bedroomMax, masterToolFilters.phOnly));

    setMasterToolLoading(true);
    try {
      const projectResult = await api.searchProjects(masterToolFilters);
      setMasterToolResults(projectResult.projects);
      setMasterToolTotalMatchedUnits(projectResult.totalMatchedUnits);
      let loadedUnitCount = 0;
      if (masterToolViewMode === 'unit') {
        const unitResult = await api.searchUnits({
          filters: masterToolFilters,
          page: 1,
          pageSize: masterToolPageSize,
          unitFilters: defaultUnitFilters,
          unitRangeFilters: defaultUnitRangeFilters,
          loanToValue,
          tenureYears,
          interestRate,
        });
        setMasterToolUnits(unitResult.items);
        loadedUnitCount = unitResult.items.length;
      } else {
        setMasterToolUnits([]);
      }
      const resultProjectNames = projectResult.projects
        .map((project) => (project.name ?? '').trim())
        .filter(Boolean);
      logProjectResearchSearchResults({
        searchId,
        viewMode: masterToolViewMode,
        projectCount: projectResult.totalProjects ?? projectResult.projects.length,
        totalMatchedUnits: projectResult.totalMatchedUnits,
        loadedUnitCount,
        projectNames: resultProjectNames,
        ceaNumber: currentCea,
      });
      projectResult.projects.forEach((project, index) => {
        logProjectResearchResultProject({
          searchId,
          rank: index + 1,
          projectId: project.id,
          projectName: project.name,
          projectCategory: project.projectCategory,
          district: project.district,
          region: project.area,
          tenure: project.tenure,
          matchedUnitCount: project.matchedUnitCount ?? null,
          distanceFromReferenceKm: project.distanceFromReferenceKm ?? null,
          ceaNumber: currentCea,
        });
      });
    } catch (error) {
      console.error('Master Tool search failed:', error);
      setMasterToolResults([]);
      setMasterToolUnits([]);
      setMasterToolTotalMatchedUnits(0);
    } finally {
      setMasterToolLoading(false);
    }
  }, [
    interestRate,
    loanToValue,
    masterToolFilters,
    masterToolPageSize,
    masterToolViewMode,
    setError,
    tenureYears,
    userInfo?.CEANumber,
  ]);

  // ── Project Research auto-search ────────────────────────────────────────
  // Super Showcase hands the master tool a ready-made set of criteria, then
  // bumps `masterToolAutoSearchNonce`. The search runs one render later through
  // a ref, so it sees the new filters without re-firing on every filter edit.
  const masterToolSearchRef = useRef(handleMasterToolSearch);
  useEffect(() => {
    masterToolSearchRef.current = handleMasterToolSearch;
  }, [handleMasterToolSearch]);

  useEffect(() => {
    if (masterToolAutoSearchNonce === 0) return;
    masterToolSearchRef.current();
  }, [masterToolAutoSearchNonce]);

  const fetchMasterToolUnits = useCallback(async (page: number) => {
    if (masterToolResults.length === 0) {
      setMasterToolUnits([]);
      return;
    }
    const effectiveUnitFilters = getEffectiveMasterToolUnitFilters();
    if (masterToolProjectScopedNames && (effectiveUnitFilters.projectName as string[]).length === 0) {
      setMasterToolUnits([]);
      setMasterToolTotalMatchedUnits(0);
      setMasterToolUnitPage(1);
      return;
    }
    setMasterToolLoading(true);
    try {
      const result = await api.searchUnits({
        filters: masterToolFilters,
        page,
        pageSize: masterToolPageSize,
        sortBy: masterToolUnitSortConfig.column ?? undefined,
        sortDir: masterToolUnitSortConfig.direction === 'default' ? undefined : masterToolUnitSortConfig.direction,
        unitFilters: effectiveUnitFilters,
        unitRangeFilters: debouncedMasterToolUnitRangeFilters,
        loanToValue,
        tenureYears,
        interestRate,
      });
      setMasterToolUnits(result.items);
      setMasterToolUnitPage(result.page);
      setMasterToolTotalMatchedUnits(result.totalUnits);
    } catch (error) {
      console.error('Master Tool unit fetch failed:', error);
      setMasterToolUnits([]);
    } finally {
      setMasterToolLoading(false);
    }
  }, [
    getEffectiveMasterToolUnitFilters,
    interestRate,
    loanToValue,
    masterToolFilters,
    masterToolPageSize,
    masterToolProjectScopedNames,
    masterToolResults.length,
    masterToolUnitSortConfig.column,
    masterToolUnitSortConfig.direction,
    tenureYears,
    debouncedMasterToolUnitRangeFilters,
  ]);

  /**
   * True while the Project Research results card is on screen — either on its
   * own tab or rendered inside Super Showcase. Everything the card needs
   * (unit pages, project expansion, unit-click behaviour) keys off this rather
   * than `activeTabId`, so the two surfaces behave identically.
   */
  const isProjectResearchContext = superShowcaseResultsOpen || activeTabId === 'master';

  useEffect(() => {
    if (!isProjectResearchContext || masterToolViewMode !== 'unit') return;
    if (masterToolResults.length === 0) return;
    fetchMasterToolUnits(masterToolUnitPage);
  }, [
    isProjectResearchContext,
    fetchMasterToolUnits,
    masterToolPageSize,
    masterToolResults.length,
    masterToolUnitPage,
    masterToolUnitSortConfig.column,
    masterToolUnitSortConfig.direction,
    masterToolViewMode,
    debouncedMasterToolUnitFilters,
    debouncedMasterToolUnitRangeFilters,
  ]);

  const pagedMasterToolProjectRows = useMemo(() => {
    const startIndex = (masterToolProjectPage - 1) * masterToolPageSize;
    return masterToolProjectRowsForDisplay.slice(startIndex, startIndex + masterToolPageSize);
  }, [masterToolPageSize, masterToolProjectPage, masterToolProjectRowsForDisplay]);

  useEffect(() => {
    setMasterToolProjectPage(1);
  }, [
    masterToolPageSize,
    masterToolProjectSortConfig,
    masterToolProjectCategoryFilters,
    masterToolProjectViewFilters,
    masterToolProjectViewRangeFilters,
  ]);

  useEffect(() => {
    setMasterToolUnitPage(1);
  }, [masterToolPageSize]);

  const masterToolUnitProjectDetailsById = useMemo(() => {
    const detailsById = new Map<string, ProjectDetails>();
    masterToolResults.forEach((project) => {
      const normalizedId = (project.id ?? '').trim();
      if (normalizedId) detailsById.set(normalizedId, project);
    });
    return detailsById;
  }, [masterToolResults]);

  const masterToolUnitProjectDetailsByName = useMemo(() => {
    const detailsByName = new Map<string, ProjectDetails>();
    masterToolResults.forEach((project) => {
      const normalizedName = (project.name ?? '').trim();
      if (normalizedName) detailsByName.set(normalizedName, project);
    });
    return detailsByName;
  }, [masterToolResults]);

  const getMasterToolUnitProjectDetails = useCallback((unit: MasterToolUnitWithComputed): ProjectDetails | undefined => {
    return (
      (unit.projectId ? masterToolUnitProjectDetailsById.get(unit.projectId.trim()) : undefined) ||
      masterToolUnitProjectDetailsByName.get((unit.projectName ?? '').trim())
    );
  }, [masterToolUnitProjectDetailsById, masterToolUnitProjectDetailsByName]);

  const getMasterToolUnitProjectMeta = useCallback((
    unit: MasterToolUnitWithComputed,
    key: 'projectCategory' | 'district' | 'region' | 'districtLocation' | 'nearestMrt' | 'walkingTimeToMrt' | 'tenure' | 'topYear'
  ): string => {
    const details = getMasterToolUnitProjectDetails(unit);
    if (!details) return '';
    switch (key) {
      case 'projectCategory':
        return details.projectCategory ?? '';
      case 'district':
        return details.district ?? '';
      case 'region':
        return details.area ?? '';
      case 'districtLocation':
        return details.districtLocation || ([details.area, details.district].filter(Boolean).join(' / ')) || '';
      case 'nearestMrt':
        return details.nearestMrt ?? '';
      case 'walkingTimeToMrt':
        return details.walkingTimeToMrt != null ? String(details.walkingTimeToMrt) : '';
      case 'tenure':
        return details.tenure ?? '';
      case 'topYear':
        return details.topDate != null ? String(details.topDate) : '';
      default:
        return '';
    }
  }, [getMasterToolUnitProjectDetails]);

  const toMasterToolUnitWithComputed = useCallback((unit: MasterToolUnit): MasterToolUnitWithComputed => {
    const parsed = parseUnitNumber(unit.unitNumber);
    return {
      ...unit,
      computedFloor: unit.computedFloor ?? parsed.floor,
      computedStack: unit.computedStack ?? parsed.stack,
      outlay: calculateOutlay(unit.price, loanToValue / 100),
      installment: calculateInstallment(unit.price, loanToValue / 100, tenureYears, interestRate / 100),
    };
  }, [calculateInstallment, calculateOutlay, interestRate, loanToValue, parseUnitNumber, tenureYears]);

  const unitMatchesMasterToolExpandBucket = useCallback(
    (unit: MasterToolExpandUnitRow, bucket: Exclude<MasterToolProjectExpandBucket, 'total'>) => {
      const unitType = String(unit.unitTypeDescription ?? '').toLowerCase();
      const isPh = unitType.includes('penthouse') || unitType.includes('ph');
      if (bucket === 'ph') return isPh;
      if (isPh) return false;
      const br = normalizeBedroomValue(unit.bedroom);
      const want = { br1: 1, br2: 2, br3: 3, br4: 4, br5: 5 }[bucket];
      return br === want;
    },
    [normalizeBedroomValue],
  );

  const handleMasterToolProjectExpandClick = useCallback(
    (e: React.MouseEvent, projectName: string, bucket: MasterToolProjectExpandBucket, count: number) => {
      e.stopPropagation();
      if (count <= 0) return;
      logProjectResearchProjectExpanded({
        projectName,
        bucket,
        count,
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });
      setMasterToolProjectExpand((prev) =>
        (prev?.projectName === projectName && prev?.bucket === bucket ? null : { projectName, bucket }),
      );
    },
    [userInfo?.CEANumber],
  );

  useEffect(() => {
    if (!masterToolProjectExpand || !isProjectResearchContext || masterToolViewMode !== 'project') {
      setMasterToolProjectExpandUnits([]);
      setMasterToolProjectExpandLoading(false);
      setMasterToolProjectExpandError(null);
      return;
    }
    const { projectName } = masterToolProjectExpand;
    let cancelled = false;
    setMasterToolProjectExpandUnits([]);
    setMasterToolProjectExpandLoading(true);
    setMasterToolProjectExpandError(null);
    (async () => {
      try {
        const pageSize = Math.max(masterToolPageSize, 200);
        const collected: MasterToolUnit[] = [];
        let page = 1;
        let total = 0;
        const unitFilters = {
          ...debouncedMasterToolUnitFilters,
          projectName: [projectName.trim()],
        };
        do {
          const result = await api.searchUnits({
            filters: masterToolFilters,
            page,
            pageSize,
            unitFilters,
            unitRangeFilters: debouncedMasterToolUnitRangeFilters,
            loanToValue,
            tenureYears,
            interestRate,
          });
          total = result.totalUnits;
          collected.push(...result.items);
          if (result.items.length === 0) break;
          page += 1;
        } while (collected.length < total);
        if (cancelled) return;
        setMasterToolProjectExpandUnits(
          collected.map((unit) => {
            const parsed = parseUnitNumber(unit.unitNumber);
            return {
              ...unit,
              computedFloor: unit.computedFloor ?? parsed.floor,
              computedStack: unit.computedStack ?? parsed.stack,
              outlay: calculateOutlay(unit.price, loanToValue / 100),
              installment: calculateInstallment(unit.price, loanToValue / 100, tenureYears, interestRate / 100),
            };
          }),
        );
      } catch (err) {
        if (!cancelled) {
          setMasterToolProjectExpandUnits([]);
          setMasterToolProjectExpandError(err instanceof Error ? err.message : 'Failed to load units');
        }
      } finally {
        if (!cancelled) setMasterToolProjectExpandLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [
    masterToolProjectExpand,
    isProjectResearchContext,
    masterToolViewMode,
    masterToolFilters,
    debouncedMasterToolUnitFilters,
    debouncedMasterToolUnitRangeFilters,
    masterToolPageSize,
    loanToValue,
    tenureYears,
    interestRate,
  ]);

  const masterToolProjectExpandFilteredUnits = useMemo(() => {
    if (!masterToolProjectExpand) return [];
    if (masterToolProjectExpand.bucket === 'total') return masterToolProjectExpandUnits;
    const bucket = masterToolProjectExpand.bucket;
    return masterToolProjectExpandUnits.filter((u) => unitMatchesMasterToolExpandBucket(u, bucket));
  }, [masterToolProjectExpand, masterToolProjectExpandUnits, unitMatchesMasterToolExpandBucket]);

  useEffect(() => {
    setMasterToolProjectExpand(null);
  }, [masterToolProjectPage, masterToolResults, masterToolViewMode]);

  const escapeCsvValue = useCallback((value: string | number | null | undefined) => {
    const stringValue = value == null ? '' : String(value);
    if (/["\n,]/.test(stringValue)) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  }, []);

  const submitCsvDownload = useCallback(async (csv: string, filename: string) => {
    try {
      const response = await signedFetch(api.buildCsvDownloadUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ csv, filename }),
      });
      if (!response.ok) {
        console.error('Failed to prepare CSV download');
        return;
      }
      const { url } = await response.json() as { token: string; url: string };
      // Setting window.location.href to a URL that responds with Content-Disposition: attachment
      // triggers a file download without navigating away — works in both browsers and webviews.
      window.location.href = url;
    } catch (error) {
      console.error('CSV download failed:', error);
    }
  }, []);

  const downloadCsvFile = useCallback((filename: string, rows: string[][]) => {
    const csv = rows.map((row) => row.map(escapeCsvValue).join(',')).join('\n');
    submitCsvDownload(csv, filename);
  }, [escapeCsvValue, submitCsvDownload]);

  const getMasterToolProjectCsvValue = useCallback((
    project: MasterToolProjectResult,
    column: MasterToolProjectFilterSortColumnKey,
    matched: { total: number; br1: number; br2: number; br3: number; br4: number; br5: number; ph: number }
  ): string | number => {
    switch (column) {
      case 'projectName':
        return project.name ?? '-';
      case 'projectCategory':
        return project.projectCategory ?? '-';
      case 'matchedTotal':
        return matched.total;
      case 'matchedBr1':
        return matched.br1 || '-';
      case 'matchedBr2':
        return matched.br2 || '-';
      case 'matchedBr3':
        return matched.br3 || '-';
      case 'matchedBr4':
        return matched.br4 || '-';
      case 'matchedBr5':
        return matched.br5 || '-';
      case 'matchedPh':
        return matched.ph || '-';
      case 'matchedBr1From':
        return project.matchedLowestPriceByBedroom?.br1 != null ? Number(project.matchedLowestPriceByBedroom.br1).toLocaleString() : '-';
      case 'matchedBr2From':
        return project.matchedLowestPriceByBedroom?.br2 != null ? Number(project.matchedLowestPriceByBedroom.br2).toLocaleString() : '-';
      case 'matchedBr3From':
        return project.matchedLowestPriceByBedroom?.br3 != null ? Number(project.matchedLowestPriceByBedroom.br3).toLocaleString() : '-';
      case 'matchedBr4From':
        return project.matchedLowestPriceByBedroom?.br4 != null ? Number(project.matchedLowestPriceByBedroom.br4).toLocaleString() : '-';
      case 'matchedBr5From':
        return project.matchedLowestPriceByBedroom?.br5 != null ? Number(project.matchedLowestPriceByBedroom.br5).toLocaleString() : '-';
      case 'matchedPhFrom':
        return project.matchedLowestPriceByBedroom?.ph != null ? Number(project.matchedLowestPriceByBedroom.ph).toLocaleString() : '-';
      case 'developer':
        return project.developer ?? '-';
      case 'totalUnits':
        return project.totalUnits ?? '-';
      case 'soldUnits':
        return project.soldUnits ?? '-';
      case 'referenceDistanceKm':
        return project.distanceFromReferenceKm != null
          ? `${Number(project.distanceFromReferenceKm).toFixed(2)} km`
          : '-';
      case 'districtLocation':
        return project.districtLocation || (project.area || project.district ? [project.area, project.district].filter(Boolean).join(' / ') : '') || '-';
      case 'district':
        return project.district ?? '-';
      case 'region':
        return project.area ?? '-';
      case 'nearestMrt':
        return project.nearestMrt ?? '-';
      case 'walkingTimeToMrt':
        return project.walkingTimeToMrt != null ? `${project.walkingTimeToMrt} min` : '-';
      case 'tenure':
        return project.tenure ?? '-';
      case 'topDate':
        return project.topDate ?? '-';
      case 'completedDate':
        return project.completedDate ? new Date(project.completedDate).toLocaleDateString('en-SG', { year: 'numeric', month: 'short' }) : '-';
      default: {
        // br2avail / br2price strip 5 chars; br2psf / phpsf strip 3. Using -5 for *psf broke lookup (e.g. br2psf -> "b").
        let statsKey: 'br1' | 'br2' | 'br3' | 'br4' | 'br5' | 'ph';
        if (column.endsWith('avail')) {
          statsKey = column.slice(0, -5) as typeof statsKey;
        } else if (column.endsWith('price')) {
          statsKey = column.slice(0, -5) as typeof statsKey;
        } else if (column.endsWith('psf')) {
          statsKey = column.slice(0, -3) as typeof statsKey;
        } else {
          return '-';
        }
        const stats = project[statsKey];
        if (column.endsWith('avail')) return stats?.availableUnits ?? '-';
        if (column.endsWith('price')) return stats?.fromPrice != null ? Number(stats.fromPrice).toLocaleString() : '-';
        if (column.endsWith('psf')) return stats?.fromPsf != null ? Number(stats.fromPsf).toLocaleString() : '-';
        return '-';
      }
    }
  }, []);

  const getMasterToolUnitCsvValue = useCallback((unit: MasterToolUnitWithComputed, column: MasterToolUnitColumnKey): string | number => {
    const projectDetails = getMasterToolUnitProjectDetails(unit);
    const isExecutiveCondoUnit = projectDetails?.projectCategoryId === 'C1803'
      || (projectDetails?.projectCategory ?? '').toLowerCase().includes('executive condo');
    const formatCurrencyValue = (value: number) => `$${Number(value).toLocaleString()}`;
    const formatNumberValue = (value: number) => Number(value).toLocaleString();
    switch (column) {
      case 'projectName':
        return unit.projectName ?? '-';
      case 'projectCategory':
        return getMasterToolUnitProjectMeta(unit, 'projectCategory') || '-';
      case 'unitNumber':
        return unit.unitNumber ?? '-';
      case 'blockNumber':
        return formatBlockNumber(unit.blockNumber ?? null);
      case 'floor':
        return unit.computedFloor ?? '-';
      case 'stack':
        return unit.computedStack ?? '-';
      case 'bedroom':
        return unit.bedroom ?? '-';
      case 'bathroom':
        return unit.bathroom ?? '-';
      case 'areaSqft':
        return unit.areaSqft > 0 ? formatNumberValue(unit.areaSqft) : '-';
      case 'price':
        return unit.price > 0 ? formatCurrencyValue(unit.price) : '-';
      case 'dps':
        return isExecutiveCondoUnit && unit.priceDps && unit.priceDps > 0 ? formatCurrencyValue(unit.priceDps) : '-';
      case 'psf':
        return unit.psf > 0 ? formatCurrencyValue(unit.psf) : '-';
      case 'outlay':
        return unit.outlay > 0 ? formatCurrencyValue(unit.outlay) : '-';
      case 'installment':
        return unit.installment > 0 ? formatCurrencyValue(unit.installment) : '-';
      case 'district':
        return getMasterToolUnitProjectMeta(unit, 'district') || '-';
      case 'districtLocation':
        return getMasterToolUnitProjectMeta(unit, 'districtLocation') || '-';
      case 'region':
        return getMasterToolUnitProjectMeta(unit, 'region') || '-';
      case 'nearestMrt':
        return getMasterToolUnitProjectMeta(unit, 'nearestMrt') || '-';
      case 'walkingTimeToMrt': {
        const value = getMasterToolUnitProjectMeta(unit, 'walkingTimeToMrt');
        return value ? `${value} min` : '-';
      }
      case 'tenure':
        return getMasterToolUnitProjectMeta(unit, 'tenure') || '-';
      case 'topYear':
        return getMasterToolUnitProjectMeta(unit, 'topYear') || '-';
      default:
        return '-';
    }
  }, [formatBlockNumber, getMasterToolUnitProjectDetails, getMasterToolUnitProjectMeta]);

  const masterToolUnitCategoryOptions = useMemo(() => {
    const projectName = new Set<string>();
    const projectCategory = new Set<string>();
    const district = new Set<string>();
    const region = new Set<string>();
    const districtLocation = new Set<string>();
    const nearestMrt = new Set<string>();
    const tenure = new Set<string>();
    masterToolResults.forEach((project) => {
      const name = (project.name ?? '').trim();
      const category = (project.projectCategory ?? '').trim();
      const districtValue = (project.district ?? '').trim();
      const regionValue = (project.area ?? '').trim();
      const districtLocationValue = (project.districtLocation || [project.area, project.district].filter(Boolean).join(' / ') || '').trim();
      const nearestMrtValue = (project.nearestMrt ?? '').trim();
      const tenureValue = (project.tenure ?? '').trim();
      if (name) projectName.add(name);
      if (category) projectCategory.add(category);
      if (districtValue && !/^district\s+/i.test(districtValue)) district.add(districtValue);
      if (regionValue) region.add(regionValue);
      if (districtLocationValue) districtLocation.add(districtLocationValue);
      if (nearestMrtValue) nearestMrt.add(nearestMrtValue);
      if (tenureValue) tenure.add(tenureValue);
    });
    return {
      projectName: Array.from(projectName).sort((a, b) => a.localeCompare(b)),
      projectCategory: Array.from(projectCategory).sort((a, b) => a.localeCompare(b)),
      district: Array.from(district).sort((a, b) => a.localeCompare(b)),
      region: Array.from(region).sort((a, b) => a.localeCompare(b)),
      districtLocation: Array.from(districtLocation).sort((a, b) => a.localeCompare(b)),
      nearestMrt: Array.from(nearestMrt).sort((a, b) => a.localeCompare(b)),
      tenure: Array.from(tenure).sort((a, b) => a.localeCompare(b)),
    };
  }, [masterToolResults]);

  const hasMasterToolProjectFiltersActive = useMemo(() => {
    const categoryActive = Object.values(masterToolProjectCategoryFilters).some((values) => values.length > 0);
    const textActive = Object.values(masterToolProjectViewFilters).some((value) => (value ?? '').trim() !== '');
    const rangeActive = Object.values(masterToolProjectViewRangeFilters).some((range) => (range?.min ?? '').trim() !== '' || (range?.max ?? '').trim() !== '');
    return categoryActive || textActive || rangeActive;
  }, [masterToolProjectCategoryFilters, masterToolProjectViewFilters, masterToolProjectViewRangeFilters]);

  const filteredMasterToolUnits = useMemo(() => {
    return masterToolUnitsWithComputed;
  }, [masterToolUnitsWithComputed]);

  const hasMasterToolExecutiveCondo = useMemo(() => {
    return masterToolResults.some((project) => {
      if (project.projectCategoryId === 'C1803') return true;
      return (project.projectCategory ?? '').toLowerCase().includes('executive condo');
    });
  }, [masterToolResults]);

  const masterToolMatchedCountByProject = useMemo(() => {
    const countsByProject = new Map<string, { total: number; br1: number; br2: number; br3: number; br4: number; br5: number; ph: number }>();
    masterToolResults.forEach((project) => {
      const projectName = (project.name ?? '').trim();
      if (!projectName) return;
      const matched = project.matchedByBedroom ?? { br1: 0, br2: 0, br3: 0, br4: 0, br5: 0, ph: 0 };
      countsByProject.set(projectName, {
        total: Number(project.matchedUnitCount ?? 0),
        br1: Number(matched.br1 ?? 0),
        br2: Number(matched.br2 ?? 0),
        br3: Number(matched.br3 ?? 0),
        br4: Number(matched.br4 ?? 0),
        br5: Number(matched.br5 ?? 0),
        ph: Number(matched.ph ?? 0),
      });
    });
    return countsByProject;
  }, [masterToolResults]);

  const masterToolMatchedVisibleBrColumns = useMemo(() => {
    const result = { br1: false, br2: false, br3: false, br4: false, br5: false, ph: false };
    masterToolMatchedCountByProject.forEach((counts) => {
      if (counts.br1 > 0) result.br1 = true;
      if (counts.br2 > 0) result.br2 = true;
      if (counts.br3 > 0) result.br3 = true;
      if (counts.br4 > 0) result.br4 = true;
      if (counts.br5 > 0) result.br5 = true;
      if (counts.ph > 0) result.ph = true;
    });
    return result;
  }, [masterToolMatchedCountByProject]);

  const masterToolScopedMatchedUnits = useMemo(() => {
    if (masterToolProjectRowsForDisplay.length === 0) return 0;
    return masterToolProjectRowsForDisplay.reduce((sum, project) => sum + Number(project.matchedUnitCount ?? 0), 0);
  }, [masterToolProjectRowsForDisplay]);

  const masterToolUnitViewCount = useMemo(() => {
    return masterToolViewMode === 'project' ? masterToolScopedMatchedUnits : masterToolTotalMatchedUnits;
  }, [masterToolScopedMatchedUnits, masterToolTotalMatchedUnits, masterToolViewMode]);

  const hasMasterToolReferenceLocation = useMemo(() => (
    Boolean((masterToolFilters.locationLat ?? '').trim() && (masterToolFilters.locationLng ?? '').trim())
  ), [masterToolFilters.locationLat, masterToolFilters.locationLng]);
  const isMasterToolRadiusMissing = useMemo(() => (
    hasMasterToolReferenceLocation && !(masterToolFilters.radiusKm ?? '').trim()
  ), [hasMasterToolReferenceLocation, masterToolFilters.radiusKm]);

  const masterToolProjectColumnsForMenu = useMemo(() => {
    const matchedColumns: MasterToolProjectFilterSortColumnKey[] = ['matchedTotal'];
    MASTER_TOOL_MATCHED_BR_BUCKETS.forEach((bucket) => {
      if (!masterToolMatchedVisibleBrColumns[bucket]) return;
      matchedColumns.push(MASTER_TOOL_MATCHED_COUNT_COLUMN_BY_BUCKET[bucket]);
      matchedColumns.push(MASTER_TOOL_MATCHED_FROM_COLUMN_BY_BUCKET[bucket]);
    });
    return [
      'projectName',
      'projectCategory',
      ...matchedColumns,
      ...MASTER_TOOL_PROJECT_VIEW_COLUMN_KEYS.filter((column) => (
        column !== 'projectName'
        && column !== 'projectCategory'
        && (column !== 'referenceDistanceKm' || hasMasterToolReferenceLocation)
      )),
    ] as MasterToolProjectFilterSortColumnKey[];
  }, [hasMasterToolReferenceLocation, masterToolMatchedVisibleBrColumns]);

  const masterToolUnitColumnsForMenu = useMemo(() => (
    hasMasterToolExecutiveCondo
      ? [...MASTER_TOOL_UNIT_COLUMN_KEYS]
      : MASTER_TOOL_UNIT_COLUMN_KEYS.filter((column) => column !== 'dps')
  ), [hasMasterToolExecutiveCondo]);

  const isMasterToolProjectColumnVisible = useCallback(
    (column: MasterToolProjectFilterSortColumnKey) => {
      const stored = masterToolProjectColumnVisibility[column];
      if (stored === true) return true;
      if (stored === false) return false;
      return !MASTER_TOOL_PROJECT_DEFAULT_HIDDEN_COLUMNS.has(column);
    },
    [masterToolProjectColumnVisibility]
  );

  const masterToolProjectMatchedTableColumnCount = useMemo(() => {
    let count = Object.values(masterToolMatchedVisibleBrColumns).filter(Boolean).length;
    MASTER_TOOL_MATCHED_BR_BUCKETS.forEach((bucket) => {
      if (!masterToolMatchedVisibleBrColumns[bucket]) return;
      if (isMasterToolProjectColumnVisible(MASTER_TOOL_MATCHED_FROM_COLUMN_BY_BUCKET[bucket])) {
        count += 1;
      }
    });
    return count;
  }, [isMasterToolProjectColumnVisible, masterToolMatchedVisibleBrColumns]);

  const isMasterToolUnitColumnVisible = useCallback(
    (column: MasterToolUnitColumnKey) => masterToolUnitColumnVisibility[column] !== false,
    [masterToolUnitColumnVisibility]
  );

  const toggleMasterToolProjectColumn = useCallback((column: string) => {
    setMasterToolProjectColumnVisibility((prev) => {
      const defaultHidden = MASTER_TOOL_PROJECT_DEFAULT_HIDDEN_COLUMNS.has(column);
      const currentlyVisible = prev[column] !== undefined
        ? prev[column] === true
        : !defaultHidden;
      return { ...prev, [column]: !currentlyVisible };
    });
  }, []);

  const toggleMasterToolUnitColumn = useCallback((column: string) => {
    setMasterToolUnitColumnVisibility((prev) => ({ ...prev, [column]: prev[column] === false }));
  }, []);

  const applyMasterToolProjectDetailsColumns = useCallback(() => {
    const detailsColumnSet = new Set<string>(MASTER_TOOL_PROJECT_DETAILS_COLUMN_KEYS);
    setMasterToolProjectColumnVisibility(
      masterToolProjectColumnsForMenu.reduce<ColumnVisibilityState>((acc, column) => {
        acc[column] = detailsColumnSet.has(column);
        return acc;
      }, {})
    );
  }, [masterToolProjectColumnsForMenu]);

  const isMasterToolProjectDetailsOnlySelected = useMemo(() => {
    const detailsColumnSet = new Set<string>(MASTER_TOOL_PROJECT_DETAILS_COLUMN_KEYS);
    return masterToolProjectColumnsForMenu.every((column) => {
      const isVisible = isMasterToolProjectColumnVisible(column);
      return detailsColumnSet.has(column) ? isVisible : !isVisible;
    });
  }, [isMasterToolProjectColumnVisible, masterToolProjectColumnsForMenu]);

  const resetMasterToolProjectColumns = useCallback(() => {
    setMasterToolProjectColumnVisibility({});
  }, []);

  const resetMasterToolUnitColumns = useCallback(() => {
    setMasterToolUnitColumnVisibility({});
  }, []);

  const masterToolProjectTableVisibilitySx = useMemo(() => (
    masterToolProjectColumnsForMenu.reduce<Record<string, object>>((acc, column) => {
      if (isMasterToolProjectColumnVisible(column)) return acc;
      acc[`& [data-column="${column}"]`] = { display: 'none' };
      acc[`& col[data-column="${column}"]`] = { display: 'none' };
      return acc;
    }, {})
  ), [isMasterToolProjectColumnVisible, masterToolProjectColumnsForMenu]);

  const masterToolUnitTableVisibilitySx = useMemo(() => (
    masterToolUnitColumnsForMenu.reduce<Record<string, object>>((acc, column) => {
      if (isMasterToolUnitColumnVisible(column)) return acc;
      acc[`& [data-column="${column}"]`] = { display: 'none' };
      return acc;
    }, {})
  ), [isMasterToolUnitColumnVisible, masterToolUnitColumnsForMenu]);

  const handleMasterToolViewModeChange = useCallback(async (_: React.MouseEvent<HTMLElement>, newMode: 'project' | 'unit' | null) => {
    if (newMode === null) return;
    logProjectResearchViewModeChanged({
      viewMode: newMode,
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });
    setMasterToolViewMode(newMode);
    if (newMode === 'unit') {
      setMasterToolUnitPage(1);
    }
  }, [userInfo?.CEANumber]);

  const activeClient = useMemo(() => {
    if (!activeClientId) {
      return null;
    }
    return clientsIndex.get(activeClientId) || clients.find((client) => client.id === activeClientId) || null;
  }, [activeClientId, clients, clientsIndex]);

  const showTopViewingDetailInGeneric = !activeClient && activeTabId === 'generic' && Boolean(selectedProject);
  const topViewingDetailEntrySignature = useMemo(() => {
    if (activeTabId === TOP_VIEWING_SITE_PLANS_TAB) {
      return selectedTopViewingSitePlan ? `top:${selectedTopViewingSitePlan}` : null;
    }
    if (showTopViewingDetailInGeneric) {
      return selectedProject ? `generic:${selectedProject}` : null;
    }
    return null;
  }, [activeTabId, selectedProject, selectedTopViewingSitePlan, showTopViewingDetailInGeneric]);
  const topViewingDetailEntrySignatureRef = useRef<string | null>(null);
  const genericTopViewingSitePlans = useMemo(() => {
    if (activeTabId !== 'generic' || activeClient) return [];
    // Find Units only lists names. The detail view keys its ID-scoped calls
    // (3DS floor groups and north angle, factsheet, drone view, …) off
    // `projectId`, so give the selected project its real ID once loaded.
    const detailsKey = projectDetails?.name?.trim().toUpperCase();
    return projects.map((name) => ({
      projectId: projectDetails?.id && detailsKey === name.trim().toUpperCase() ? projectDetails.id : name,
      projectName: name,
      coordinateCount: 0,
    })) as TopViewingSitePlan[];
  }, [activeTabId, activeClient, projects, projectDetails?.id, projectDetails?.name]);
  const genericSelectedTopViewingSitePlan = selectedProject || null;
  const handleGenericTopViewingSelect = useCallback((projectName: string) => {
    if (!projectName) return;
    logProjectViewed(projectName, 'generic_top_viewing_select', userInfo?.CEANumber || getDevCea());
    setSelectedProject(projectName);
    setUnitNumber('');
    setProjectUnits([]);
    setReferenceUnit(null);
    lastAutoLoadedProjectRef.current = null;
  }, [setReferenceUnit, userInfo?.CEANumber]);
  const setGenericSelectedTopViewingSitePlan = useCallback((_plan: string | null) => {}, []);

  useEffect(() => {
    setChoiceUnitTabIndex(0);
    setSheetHeaderStyle(null);
    setPickerHeaderStyle(null);
  }, [activeClientId]);

  // Measure tab positions to position header chips
  useEffect(() => {
    if (!activeClient || !activeClient.choiceUnits?.length) {
      setSheetHeaderStyle(null);
      setPickerHeaderStyle(null);
      return;
    }

    const measureTabs = () => {
      if (!choiceTabsRef.current) return;
      const tabsContainer = choiceTabsRef.current.querySelector('.MuiTabs-root') as HTMLElement;
      if (!tabsContainer) return;

      const sheetIndices: number[] = [];
      const pickerIndices: number[] = [];
      activeClient.choiceUnits.forEach((unit, index) => {
        if (unit.type === 'SHEET') {
          sheetIndices.push(index);
        } else if (unit.type === 'PICKER') {
          pickerIndices.push(index);
        }
      });

      const tabs = tabsContainer.querySelectorAll('.MuiTab-root');
      if (tabs.length === 0) return;

      // Calculate sheet header position and width
      if (sheetIndices.length > 0) {
        const firstSheetTab = tabs[sheetIndices[0]] as HTMLElement;
        const lastSheetTab = tabs[sheetIndices[sheetIndices.length - 1]] as HTMLElement;
        if (firstSheetTab && lastSheetTab) {
          const containerRect = tabsContainer.getBoundingClientRect();
          const firstRect = firstSheetTab.getBoundingClientRect();
          const lastRect = lastSheetTab.getBoundingClientRect();
          const left = firstRect.left - containerRect.left;
          const width = (lastRect.right - containerRect.left) - left;
          setSheetHeaderStyle({ left, width });
        }
      }

      // Calculate picker header position and width
      if (pickerIndices.length > 0) {
        const firstPickerTab = tabs[pickerIndices[0]] as HTMLElement;
        const lastPickerTab = tabs[pickerIndices[pickerIndices.length - 1]] as HTMLElement;
        if (firstPickerTab && lastPickerTab) {
          const containerRect = tabsContainer.getBoundingClientRect();
          const firstRect = firstPickerTab.getBoundingClientRect();
          const lastRect = lastPickerTab.getBoundingClientRect();
          const left = firstRect.left - containerRect.left;
          const width = (lastRect.right - containerRect.left) - left;
          setPickerHeaderStyle({ left, width });
        }
      }
    };

    // Measure after a short delay to ensure tabs are rendered
    const timeoutId = setTimeout(measureTabs, 100);
    // Also measure on window resize
    window.addEventListener('resize', measureTabs);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', measureTabs);
    };
  }, [activeClient, choiceUnitTabIndex]);

  // Auto-scroll to Choice tabs when data loads after clicking a Choice tab
  const prevReferenceUnitIdRef = useRef<string | null>(null);
  useEffect(() => {
    // Scroll if referenceUnit changed (different unit loaded) and we're on a client tab
    const currentUnitId = referenceUnit ? `${referenceUnit.projectName}-${referenceUnit.unitNumber}` : null;
    const unitChanged = prevReferenceUnitIdRef.current !== currentUnitId && currentUnitId !== null;
    prevReferenceUnitIdRef.current = currentUnitId;
    
    if (unitChanged && choiceTabsRef.current && activeClient) {
      // Small delay to ensure DOM is fully updated
      const timeoutId = setTimeout(() => {
        choiceTabsRef.current?.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [referenceUnit, activeClient]);

  const toolTabs = useMemo(() => {
    return [
      { id: TOP_VIEWING_SITE_PLANS_TAB, label: 'Site Plans' },
      { id: 'master', label: 'Project Research' },
      ...(canAccessSuperMap ? [{ id: 'map-research', label: 'Good Deals Map' }] : []),
      ...(canAccessSuccessCloser ? [{ id: 'success-closer', label: 'Success Closer' }] : []),
      ...(canAccessSharableLinks ? [{ id: MY_SHARABLE_LINKS_TAB, label: 'My Shareable Links' }] : []),
      ...(isExternalUser ? [] : [{ id: 'generic', label: 'Find Units' }]),
      ...(canAccessProjectMaterials ? [{ id: MARKETING_MATERIALS_TAB, label: 'Project Essentials' }] : []),
      { id: PODCAST_VIDEOS_TAB, label: 'Podcast Videos' },

      ...clientTabs.map((tab) => ({ id: tab.id, label: tab.label })),
    ];
  }, [clientTabs, canAccessSuccessCloser, canAccessSharableLinks, canAccessSuperMap, isExternalUser, canAccessProjectMaterials]);

  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('en-SG', {
      style: 'currency',
      currency: 'SGD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const formatNumber = (value: number, decimals: number = 0): string => {
    return new Intl.NumberFormat('en-SG', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(value);
  };

  const formatThumbsupUnitSqft = (sqft: number | string | null | undefined): string => {
    if (sqft == null || sqft === '') return '—';
    const n = typeof sqft === 'string' ? parseFloat(sqft) : sqft;
    if (!Number.isFinite(n) || n <= 0) return '—';
    return `${formatNumber(n)} sqft`;
  };

  const buildThumbsupGroups = useCallback((units: ThumbsupUnit[]) => {
    const map = new Map<string, { projectId: string; projectName: string; isLive: number; units: ThumbsupUnit[] }>();
    for (const u of units) {
      const key = u.ProjectId;
      if (!map.has(key)) {
        map.set(key, { projectId: key, projectName: u.projectName, isLive: u.isLive, units: [] });
      }
      map.get(key)!.units.push(u);
    }
    for (const g of Array.from(map.values())) {
      g.units.sort(
        (a: ThumbsupUnit, b: ThumbsupUnit) =>
          b.thumbsupCount - a.thumbsupCount ||
          String(a.UnitNumber).localeCompare(String(b.UnitNumber), undefined, { numeric: true }),
      );
    }
    return Array.from(map.values()).sort((a, b) => a.projectName.localeCompare(b.projectName));
  }, []);

  // Unfiltered project groups — shared by the Nearby Deal section and aliases.
  const thumbsupGroupsByProject = useMemo(
    () => buildThumbsupGroups(thumbsupUnits),
    [thumbsupUnits, buildThumbsupGroups],
  );

  const thumbsupBedroomOptions = useMemo(() => {
    const set = new Set<number>();
    for (const u of thumbsupUnits) {
      if (typeof u.bedroomNumber === 'number' && u.bedroomNumber > 0) {
        set.add(u.bedroomNumber);
      }
    }
    return Array.from(set).sort((a, b) => a - b);
  }, [thumbsupUnits]);

  const thumbsupFilteredUnits = useMemo(() => {
    if (thumbsupBedroomFilter.length === 0) return thumbsupUnits;
    return thumbsupUnits.filter((u) => typeof u.bedroomNumber === 'number' && thumbsupBedroomFilter.includes(u.bedroomNumber));
  }, [thumbsupUnits, thumbsupBedroomFilter]);

  // Bedroom- and search-filtered groups used by the Thumbsup Units modal list.
  const thumbsupFilteredProjectGroups = useMemo(() => {
    const q = thumbsupProjectSearch.trim().toLowerCase();
    const groups = buildThumbsupGroups(thumbsupFilteredUnits);
    return q ? groups.filter((g) => g.projectName.toLowerCase().includes(q)) : groups;
  }, [thumbsupFilteredUnits, thumbsupProjectSearch, buildThumbsupGroups]);

  const latestViewedThumbsupUnit = useMemo(
    () => getLatestValidViewedThumbsupUnit(thumbsupViewedHistory, thumbsupUnits),
    [thumbsupViewedHistory, thumbsupUnits],
  );

  const parsePricePromoStackNum = (unitNumber: string): number => {
    const m = String(unitNumber).match(/#?\d+-(\d+)/);
    return m ? parseInt(m[1], 10) : Number.MAX_SAFE_INTEGER;
  };

  const pricePromoChangeAtMs = (u: PricePromoUnit): number => {
    if (!u.priceChangeAt) return 0;
    const t = new Date(u.priceChangeAt).getTime();
    return Number.isFinite(t) ? t : 0;
  };

  const formatPricePromoDate = (iso: string | null | undefined): string => {
    if (!iso) return '';
    const d = new Date(iso);
    if (!Number.isFinite(d.getTime())) return '';
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  // Most-negative priceChange unit per (project, block, stack, bedroom).
  const pricePromoBestByStackBedroom = useMemo(() => {
    const best = new Map<string, PricePromoUnit>();
    for (const u of pricePromoUnits) {
      const stack = (u.stackNumber && u.stackNumber.trim())
        ? u.stackNumber.trim()
        : String(parsePricePromoStackNum(u.UnitNumber));
      const key = `${u.ProjectId}__${(u.blockNumber || '').trim()}__${stack}__${u.bedroomNumber || 0}`;
      const cur = best.get(key);
      if (!cur || u.priceChange < cur.priceChange) best.set(key, u);
    }
    const ids = new Set<number>();
    Array.from(best.values()).forEach((v) => ids.add(v.id));
    return ids;
  }, [pricePromoUnits]);

  // All price-promo unit ids (not just best-of-stack) — used to flag any
  // price-promo unit, e.g. the selected reference unit.
  const pricePromoUnitIds = useMemo(() => {
    const ids = new Set<number>();
    for (const u of pricePromoUnits) ids.add(u.id);
    return ids;
  }, [pricePromoUnits]);

  const buildPricePromoGroups = useCallback((units: PricePromoUnit[]) => {
    const map = new Map<string, { projectId: string; projectName: string; isLive: number; latestAt: number; units: PricePromoUnit[] }>();
    for (const u of units) {
      const t = pricePromoChangeAtMs(u);
      let g = map.get(u.ProjectId);
      if (!g) {
        g = { projectId: u.ProjectId, projectName: u.projectName, isLive: u.isLive, latestAt: t, units: [] };
        map.set(u.ProjectId, g);
      }
      g.units.push(u);
      if (t > g.latestAt) g.latestAt = t;
    }
    for (const g of Array.from(map.values())) {
      g.units.sort((a, b) => pricePromoChangeAtMs(b) - pricePromoChangeAtMs(a));
    }
    return Array.from(map.values()).sort((a, b) => b.latestAt - a.latestAt);
  }, []);

  // Bedroom chips include penthouse units' bedroom counts (a 3BR penthouse
  // matches the 3BR chip); the separate "PH only" checkbox narrows to penthouses.
  const pricePromoBedroomOptions = useMemo(() => {
    const set = new Set<number>();
    for (const u of pricePromoUnits) {
      if (typeof u.bedroomNumber === 'number' && u.bedroomNumber > 0) {
        set.add(u.bedroomNumber);
      }
    }
    return Array.from(set).sort((a, b) => a - b);
  }, [pricePromoUnits]);

  const pricePromoHasPenthouse = useMemo(
    () => pricePromoUnits.some((u) => isPenthouseUnit(u)),
    [pricePromoUnits, isPenthouseUnit],
  );

  const pricePromoFilteredUnits = useMemo(() => {
    if (pricePromoBedroomFilter.length === 0 && !pricePromoPhOnly) return pricePromoUnits;
    return pricePromoUnits.filter((u) => {
      if (pricePromoPhOnly && !isPenthouseUnit(u)) return false;
      if (pricePromoBedroomFilter.length === 0) return true;
      return typeof u.bedroomNumber === 'number' && pricePromoBedroomFilter.includes(u.bedroomNumber);
    });
  }, [pricePromoUnits, pricePromoBedroomFilter, pricePromoPhOnly, isPenthouseUnit]);

  const pricePromoBedroomLabel = (u: PricePromoUnit): string =>
    isPenthouseUnit(u) ? `${u.bedroomNumber}BR (PH)` : `${u.bedroomNumber}BR`;

  const pricePromoLatestUnits = useMemo(() => {
    const cutoff = Date.now() - 14 * 24 * 60 * 60 * 1000;
    return pricePromoFilteredUnits.filter((u) => pricePromoChangeAtMs(u) >= cutoff);
  }, [pricePromoFilteredUnits]);

  const pricePromoLatestGroups = useMemo(() => {
    const q = pricePromoProjectSearch.trim().toLowerCase();
    const groups = buildPricePromoGroups(pricePromoLatestUnits);
    return q ? groups.filter((g) => g.projectName.toLowerCase().includes(q)) : groups;
  }, [pricePromoLatestUnits, pricePromoProjectSearch, buildPricePromoGroups]);

  const pricePromoAllGroups = useMemo(() => {
    const q = pricePromoProjectSearch.trim().toLowerCase();
    const groups = buildPricePromoGroups(pricePromoFilteredUnits);
    const filtered = q ? groups.filter((g) => g.projectName.toLowerCase().includes(q)) : groups;
    return [...filtered].sort((a, b) => a.projectName.localeCompare(b.projectName));
  }, [pricePromoFilteredUnits, pricePromoProjectSearch, buildPricePromoGroups]);

  // All price promo project groups, unfiltered — used by the Nearby Deal section.
  const pricePromoAllProjectGroups = useMemo(
    () => buildPricePromoGroups(pricePromoUnits),
    [pricePromoUnits, buildPricePromoGroups],
  );

  // Flat unit list for the Price Promo table view — scoped by the dialog's
  // project search + bedroom chips; the table's own per-column filters refine it.
  const pricePromoTableUnits = useMemo(() => {
    const q = pricePromoProjectSearch.trim().toLowerCase();
    return q
      ? pricePromoFilteredUnits.filter((u) => u.projectName.toLowerCase().includes(q))
      : pricePromoFilteredUnits;
  }, [pricePromoFilteredUnits, pricePromoProjectSearch]);

  const nearbyDealProjectAliasesById = useMemo(() => {
    const aliases = new Map<string, Set<string>>();
    const addAlias = (projectId: string | null | undefined, projectName: string | null | undefined) => {
      const id = String(projectId ?? '').trim();
      const name = String(projectName ?? '').trim();
      if (!id || !name) return;
      const names = aliases.get(id) ?? new Set<string>();
      names.add(name);
      aliases.set(id, names);
    };

    thumbsupGroupsByProject.forEach((group) => addAlias(group.projectId, group.projectName));
    pricePromoAllProjectGroups.forEach((group) => addAlias(group.projectId, group.projectName));
    return aliases;
  }, [pricePromoAllProjectGroups, thumbsupGroupsByProject]);

  const nearbyDealProjectIdsKey = useMemo(
    () => Array.from(nearbyDealProjectAliasesById.keys()).sort().join(','),
    [nearbyDealProjectAliasesById],
  );
  const nearbyDealDetailsInFlightKeyRef = useRef<string>('');

  useEffect(() => {
    if (!canAccessNearbyDeal) return;
    if (!nearbyDealProjectIdsKey) return;

    const projectIdsToFetch = Array.from(nearbyDealProjectAliasesById.entries())
      .filter(([, aliases]) => {
        for (const projectName of Array.from(aliases)) {
          const details = projectDetailsMap.get(projectName);
          if (details?.mapLatitude != null && details?.mapLongitude != null) {
            return false;
          }
        }
        return true;
      })
      .map(([projectId]) => projectId);

    const fetchKey = projectIdsToFetch.sort().join(',');
    if (!fetchKey || fetchKey === nearbyDealDetailsInFlightKeyRef.current) return;
    nearbyDealDetailsInFlightKeyRef.current = fetchKey;

    let cancelled = false;
    void (async () => {
      try {
        const details = await api.getBulkProjectDetails(projectIdsToFetch);
        if (cancelled) return;

        setProjectDetailsMap((prevMap) => {
          const merged = new Map(prevMap);
          details.forEach((projectDetailsItem) => {
            if (projectDetailsItem.name) {
              merged.set(projectDetailsItem.name, projectDetailsItem);
            }
            const projectId = projectDetailsItem.id ? String(projectDetailsItem.id).trim() : '';
            const aliases = projectId ? nearbyDealProjectAliasesById.get(projectId) : null;
            aliases?.forEach((alias) => merged.set(alias, projectDetailsItem));
          });
          return merged;
        });
      } catch (err) {
        nearbyDealDetailsInFlightKeyRef.current = '';
        console.error('Failed to fetch Nearby Deal project details:', err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [canAccessNearbyDeal, nearbyDealProjectAliasesById, nearbyDealProjectIdsKey, projectDetailsMap]);

  const pricePromoTopSavingUnits = useMemo(() => {
    const q = pricePromoProjectSearch.trim().toLowerCase();
    const filtered = q
      ? pricePromoFilteredUnits.filter((u) => u.projectName.toLowerCase().includes(q))
      : pricePromoFilteredUnits;
    return [...filtered].sort((a, b) => a.priceChange - b.priceChange).slice(0, 5);
  }, [pricePromoFilteredUnits, pricePromoProjectSearch]);

  const pricePromoTopSavingGroups = useMemo(() => {
    const q = pricePromoProjectSearch.trim().toLowerCase();
    const filtered = q
      ? pricePromoFilteredUnits.filter((u) => u.projectName.toLowerCase().includes(q))
      : pricePromoFilteredUnits;

    const groupMap = new Map<string, {
      key: string;
      projectName: string;
      ProjectId: string;
      priceChange: number;
      priceChangePercent: number;
      priceChangeAt: string | null;
      units: PricePromoUnit[];
    }>();

    for (const unit of filtered) {
      const key = `${unit.ProjectId}::${unit.priceChange}`;
      if (!groupMap.has(key)) {
        groupMap.set(key, {
          key,
          projectName: unit.projectName,
          ProjectId: unit.ProjectId,
          priceChange: unit.priceChange,
          priceChangePercent: unit.priceChangePercent,
          priceChangeAt: unit.priceChangeAt,
          units: [],
        });
      }
      groupMap.get(key)!.units.push(unit);
    }

    return Array.from(groupMap.values())
      .sort((a, b) => a.priceChange - b.priceChange)
      .slice(0, 5);
  }, [pricePromoFilteredUnits, pricePromoProjectSearch]);

  const pricePromoAutocompleteOptions = useMemo(() => {
    const seen = new Set<string>();
    const out: string[] = [];
    for (const u of pricePromoUnits) {
      if (u.projectName && !seen.has(u.projectName)) {
        seen.add(u.projectName);
        out.push(u.projectName);
      }
    }
    return out.sort();
  }, [pricePromoUnits]);

  const pricePromoTotalProjects = pricePromoAutocompleteOptions.length;

  // ── "Best Price Promo" share sheet ──────────────────────────────────────
  // One row per project — its deepest promo — over whatever the dialog is
  // currently showing (project search + bedroom / PH chips), so the shared
  // sheet always matches what the agent sees.
  const bestPricePromoRows = useMemo(
    () => toBestPricePromoRows(pricePromoTableUnits),
    [pricePromoTableUnits],
  );

  const bestPricePromoFilterNote = useMemo(() => {
    const parts: string[] = [];
    if (pricePromoProjectSearch.trim()) parts.push(`"${pricePromoProjectSearch.trim()}"`);
    if (pricePromoBedroomFilter.length > 0) {
      parts.push([...pricePromoBedroomFilter].sort((a, b) => a - b).map((b) => `${b}BR`).join(' / '));
    }
    if (pricePromoPhOnly) parts.push('Penthouse only');
    return parts.join(' · ');
  }, [pricePromoProjectSearch, pricePromoBedroomFilter, pricePromoPhOnly]);

  // Promo-sheet branding, identical to the price-promo image footer:
  //   line 1  Name: <agent> · CEA Registration Number: <CEA> · Contact Number: <mobile>
  //   line 2  Huttons Asia Pte Ltd · L3008899K
  const promoAgentLine = useMemo(() => {
    const agentName = (userInfo?.Name || '').trim();
    const agentCea = (userInfo?.CEANumber || '').trim();
    const agentMobile = (userInfo?.Mobile || '').trim();
    const agentEmail = (userInfo?.Email || '').trim();
    return [
      agentName ? `Name: ${agentName}` : '',
      agentCea ? `CEA Registration Number: ${agentCea}` : '',
      // Falls back to email when no mobile is on record — relabelled so an
      // address is never captioned as a phone number.
      agentMobile ? `Contact Number: ${agentMobile}` : agentEmail ? `Contact: ${agentEmail}` : '',
    ]
      .filter(Boolean)
      .join(' · ');
  }, [userInfo?.Name, userInfo?.CEANumber, userInfo?.Mobile, userInfo?.Email]);

  // ── Super Showcase ──────────────────────────────────────────────────────

  const fetchSuperShowcases = useCallback(async () => {
    setSuperShowcasesLoading(true);
    setSuperShowcasesError(null);
    try {
      setSuperShowcases(await api.getSuperShowcases());
    } catch (err) {
      console.error('Failed to load Super Showcase:', err);
      setSuperShowcases([]);
      setSuperShowcasesError(err instanceof Error ? err.message : 'Failed to load Super Showcase');
    } finally {
      setSuperShowcasesLoading(false);
      setSuperShowcasesFetched(true);
    }
  }, []);

  // Open the shared showcase once the list is in (the dialog falls back to the
  // gallery if it is unpublished or gone).
  useEffect(() => {
    if (deepLinkShowcaseId == null || !canAccessSuperShowcase || !superShowcasesFetched) return;
    logSuperShowcaseOpened({
      source: 'share_link',
      totalShowcases: superShowcases.length,
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });
    setActiveNavItem('super-showcase');
    setInitialShowcaseId(deepLinkShowcaseId);
    setSuperShowcaseDialogOpen(true);
    setDeepLinkShowcaseId(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deepLinkShowcaseId, canAccessSuperShowcase, superShowcasesFetched]);

  // Only sessions that can open the menu fetch it.
  useEffect(() => {
    if (!canAccessSuperShowcase) return;
    fetchSuperShowcases();
  }, [canAccessSuperShowcase, fetchSuperShowcases]);

  /**
   * Route a Super Showcase click to the function the admin mapped it to.
   * Price Promo and Thumbsup open their own dialogs, so the showcase closes
   * first; Anticipate Blinker closes the showcase and opens P2510001 with an
   * available 3BR (else 2BR) blinker unit, falling back to a random project;
   * Super Ratio closes the showcase and opens a random site plan on the Super
   * Ratio tab; Project Research renders its table inside the showcase instead;
   * a hyperlink opens in a new tab with the showcase left as it was.
   */
  const handleSuperShowcaseHotspot = useCallback((showcase: SuperShowcase, hotspot: SuperShowcaseHotspot) => {
    const currentCea = userInfo?.CEANumber || getDevCea();
    logSuperShowcaseHotspotClicked({
      showcaseId: showcase.id,
      showcaseTitle: showcase.title,
      hotspotLabel: hotspot.label,
      actionType: hotspot.actionType,
      ceaNumber: currentCea,
    });
    if (hotspot.actionType === 'REGION_MARKET_DATA') {
      const config = hotspot.actionConfig as { region?: SuperShowcaseRegion } | null;
      if (config?.region) setRegionMarket(config.region);
      return;
    }
    if (hotspot.actionType === 'PRICE_PROMO') {
      logPricePromoUnitsOpened({
        source: 'super_showcase',
        totalProjects: pricePromoTotalProjects,
        totalUnits: pricePromoUnits.length,
        latestCount: pricePromoLatestUnits.length,
        topSavingCount: pricePromoTopSavingUnits.length,
        hasRecentPromo: hasRecentPricePromo,
        ceaNumber: currentCea,
      });
      setSuperShowcaseDialogOpen(false);
      setActiveNavItem('price-promo');
      setPricePromoDialogOpen(true);
      return;
    }

    if (hotspot.actionType === 'THUMBSUP') {
      logThumbsupUnitsOpened({
        source: 'super_showcase',
        totalProjects: thumbsupGroupsByProject.length,
        totalUnits: thumbsupUnits.length,
        hasLastViewed: Boolean(latestViewedThumbsupUnit),
        ceaNumber: currentCea,
      });
      setSuperShowcaseDialogOpen(false);
      setActiveNavItem('thumbsup-units');
      setThumbsupDialogOpen(true);
      return;
    }

    if (hotspot.actionType === 'LINK') {
      // Runs straight off the agent's click, so the popup blocker lets it
      // through. `noopener` keeps the new tab off our `window.opener`.
      const url = getLinkUrl(hotspot);
      if (url) window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    if (hotspot.actionType === 'ANTICIPATE_BLINKER') {
      setSuperShowcaseDialogOpen(false);
      void openRandomAnticipateBlinkerUnitRef.current();
      return;
    }

    if (hotspot.actionType === 'SUPER_RATIO') {
      setSuperShowcaseDialogOpen(false);
      void openRandomSuperRatioRef.current();
      return;
    }

    // PROJECT_RESEARCH — pre-fill the master tool and run its search. The
    // showcase renders the very same results card in place, so the agent keeps
    // the picture instead of being taken to the Project Research tab.
    const config = getProjectResearchConfig(hotspot);
    setMasterToolFilters(config?.filters ?? { priceMin: '1' });
    setMasterToolViewMode(config?.viewMode === 'unit' ? 'unit' : 'project');
    setMasterToolAutoSearchNonce((nonce) => nonce + 1);
  }, [
    hasRecentPricePromo,
    latestViewedThumbsupUnit,
    pricePromoLatestUnits.length,
    pricePromoTopSavingUnits.length,
    pricePromoTotalProjects,
    pricePromoUnits.length,
    thumbsupGroupsByProject.length,
    thumbsupUnits.length,
    userInfo?.CEANumber,
  ]);

  const formatThousandsInput = (value: string): string => {
    const cleaned = value.replace(/[^\d.]/g, '');
    if (!cleaned) return '';
    const [intPart, decPart] = cleaned.split('.');
    const intFormatted = intPart ? Number(intPart).toLocaleString('en-US') : '';
    return decPart !== undefined ? `${intFormatted}.${decPart}` : intFormatted;
  };

  const compareRowConfig = useMemo(() => ([
    { label: 'Price', key: 'price' },
    { label: 'PSF', key: 'psf' },
    { label: 'Outlay', key: 'outlay' },
    { label: 'Installment', key: 'installment' },
    { label: 'Area', key: 'areaSqft' },
    { label: 'Bedroom', key: 'bedroom' },
    { label: 'Bathroom', key: 'bathroom' },
    { label: 'Block', key: 'block' },
    { label: 'Floor', key: 'floor' },
    { label: 'Stack', key: 'stack' },
  ] as const), []);

  const getCompareRowDisplayValue = useCallback((fp: { unit: any }, key: typeof compareRowConfig[number]['key']) => {
    const unit = fp.unit;
    const parsed = parseUnitNumber(unit.unitNumber);
    let value: string | number = '-';
    switch (key) {
      case 'price': value = unit.price ?? 0; break;
      case 'psf': value = unit.psf ?? (unit as any).pricePSF ?? (unit.price && unit.areaSqft ? unit.price / unit.areaSqft : (unit.price && (unit as any).size ? unit.price / (unit as any).size : 0)); break;
      case 'outlay': value = unit.price != null && unit.price > 0 ? calculateOutlay(unit.price, loanToValue / 100) : 0; break;
      case 'installment': value = unit.price != null && unit.price > 0 ? calculateInstallment(unit.price, loanToValue / 100, tenureYears, interestRate / 100) : 0; break;
      case 'areaSqft': value = unit.areaSqft ?? unit.size ?? 0; break;
      case 'bedroom': value = unit.bedroom ?? unit.bedroomNumber ?? 0; break;
      case 'bathroom': value = unit.bathroom ?? unit.bathroomNumber ?? 0; break;
      case 'block': value = unit.blockNumber || '-'; break;
      case 'floor': value = parsed.floor ?? '-'; break;
      case 'stack': value = parsed.stack ?? '-'; break;
      default: value = '-';
    }
    if (key === 'price' || key === 'psf' || key === 'outlay' || key === 'installment') {
      return typeof value === 'number' && value > 0 ? formatCurrency(value) : '-';
    }
    if (key === 'areaSqft') {
      return typeof value === 'number' && value > 0 ? `${formatNumber(value)} sqft` : '-';
    }
    return String(value);
  }, [calculateOutlay, calculateInstallment, formatCurrency, formatNumber, interestRate, loanToValue, tenureYears]);

  const cleanupCompareDragImage = useCallback(() => {
    if (compareDragImageRef.current) {
      try {
        document.body.removeChild(compareDragImageRef.current);
      } catch {
        // ignore
      }
      compareDragImageRef.current = null;
    }
  }, []);

  const buildCompareDragImage = useCallback((fp: { unit: any; imageUrl?: string | null }) => {
    cleanupCompareDragImage();
    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.top = '-9999px';
    container.style.left = '-9999px';
    container.style.width = '220px';
    container.style.padding = '10px';
    container.style.background = 'rgba(25, 30, 44, 0.95)';
    container.style.border = '1px solid rgba(255,255,255,0.2)';
    container.style.borderRadius = '8px';
    container.style.color = '#fff';
    container.style.fontFamily = 'inherit';
    container.style.boxShadow = '0 10px 30px rgba(0,0,0,0.35)';

    const title = document.createElement('div');
    title.style.fontSize = '12px';
    title.style.fontWeight = '600';
    title.style.textAlign = 'center';
    title.style.marginBottom = '6px';
    title.textContent = `${fp.unit.projectName} ${fp.unit.unitNumber}`;
    container.appendChild(title);

    const image = document.createElement('div');
    image.style.height = '90px';
    image.style.borderRadius = '6px';
    image.style.background = 'rgba(255,255,255,0.08)';
    image.style.marginBottom = '8px';
    image.style.display = 'flex';
    image.style.alignItems = 'center';
    image.style.justifyContent = 'center';
    if (fp.imageUrl) {
      image.style.backgroundImage = `url(${fp.imageUrl})`;
      image.style.backgroundSize = 'contain';
      image.style.backgroundRepeat = 'no-repeat';
      image.style.backgroundPosition = 'center';
    } else {
      image.textContent = 'No image';
      image.style.fontSize = '11px';
      image.style.color = 'rgba(255,255,255,0.7)';
    }
    container.appendChild(image);

    const list = document.createElement('div');
    list.style.display = 'flex';
    list.style.flexDirection = 'column';
    list.style.gap = '4px';
    compareRowConfig.forEach((row) => {
      const rowEl = document.createElement('div');
      rowEl.style.display = 'flex';
      rowEl.style.justifyContent = 'space-between';
      rowEl.style.fontSize = '10px';
      rowEl.style.color = 'rgba(255,255,255,0.85)';
      const label = document.createElement('span');
      label.textContent = row.label;
      const value = document.createElement('span');
      value.style.fontWeight = '600';
      value.textContent = getCompareRowDisplayValue(fp, row.key as typeof compareRowConfig[number]['key']);
      rowEl.appendChild(label);
      rowEl.appendChild(value);
      list.appendChild(rowEl);
    });
    container.appendChild(list);

    document.body.appendChild(container);
    compareDragImageRef.current = container;
    return container;
  }, [cleanupCompareDragImage, compareRowConfig, getCompareRowDisplayValue]);

  const getAreaRangeLabel = (areaSqft: number | null | undefined, tolerancePercent: number): string | null => {
    if (areaSqft == null || Number.isNaN(areaSqft)) {
      return null;
    }
    const tolerance = Math.max(0, tolerancePercent);
    const minArea = Math.round(areaSqft * (1 - tolerance / 100));
    const maxArea = Math.round(areaSqft * (1 + tolerance / 100));
    return `${formatNumber(minArea)} sqft - ${formatNumber(maxArea)} sqft`;
  };

  const getOutlayFormulaTooltip = (price: number, outlay: number): React.ReactNode => {
    if (price <= 0 || outlay <= 0) {
      return 'Outlay formula is not available.';
    }
    const downPaymentRatio = 1 - loanToValue / 100;
    const downPayment = price * downPaymentRatio;
    const inferredBsd = Math.max(0, outlay - downPayment);
    const usesSimpleOutlay = Math.abs(outlay - downPayment) < 1;
    const downPaymentPercent = Math.round(100 - loanToValue);

    return (
      <Box sx={{ p: 0.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Outlay formula
        </Typography>
        {usesSimpleOutlay ? (
          <>
            <Typography variant="body2">= Price x {downPaymentPercent}%</Typography>
            <Typography variant="body2">= {formatCurrency(price)} x {downPaymentPercent}%</Typography>
            <Typography variant="body2" sx={{ fontWeight: 700, mt: 0.5 }}>
              = {formatCurrency(outlay)}
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="body2">= Down Payment + BSD</Typography>
            <Typography variant="body2">= ({formatCurrency(price)} x {downPaymentPercent}%) + {formatCurrency(inferredBsd)}</Typography>
            <Typography variant="body2" sx={{ fontWeight: 700, mt: 0.5 }}>
              = {formatCurrency(outlay)}
            </Typography>
          </>
        )}
      </Box>
    );
  };

  const getInstallmentFormulaTooltip = (price: number, installment: number): React.ReactNode => {
    if (price <= 0 || installment <= 0) {
      return 'Installment formula is not available.';
    }

    const ltvRatio = loanToValue / 100;
    const monthlyRate = (interestRate / 100) / 12;
    const totalMonths = tenureYears * 12;
    const loanAmount = price * ltvRatio;

    return (
      <Box sx={{ p: 0.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Installment formula
        </Typography>
        <Typography variant="body2">= PMT(loan amount, monthly rate, tenure)</Typography>
        <Typography variant="body2">Loan = {formatCurrency(price)} x {formatNumber(loanToValue, 0)}% = {formatCurrency(loanAmount)}</Typography>
        <Typography variant="body2">Rate = {formatNumber(interestRate, 2)}% / 12 = {formatNumber(monthlyRate * 100, 4)}%</Typography>
        <Typography variant="body2">Tenure = {tenureYears} years ({totalMonths} months)</Typography>
        <Typography variant="body2" sx={{ fontWeight: 700, mt: 0.5 }}>
          = {formatCurrency(installment)}
        </Typography>
      </Box>
    );
  };

  const openComparableUnitFormulaPopover = useCallback((event: React.MouseEvent<HTMLElement>, content: React.ReactNode) => {
    event.stopPropagation();
    setComparableUnitFormulaAnchor({ element: event.currentTarget, content });
  }, []);

  const closeComparableUnitFormulaPopover = useCallback(() => {
    setComparableUnitFormulaAnchor(null);
  }, []);

  /** Map ProjectUnit.TransactedBy to shortform for tower view: Huttons→HTNS, Propnex→PN, Orangetee & Tie→OTT */
  const getTransactedByShortform = (transactedBy?: string | null): string => {
    if (!transactedBy || typeof transactedBy !== 'string') return '';
    const t = transactedBy.trim().toLowerCase();
    if (t.includes('hutton')) return 'HTNS';
    if (t.includes('propnex')) return 'PN';
    if (t.includes('orangetee') || t.includes('orange tee')) return 'OTT';
    return transactedBy;
  };

  const formatLiveStatusTimestamp = (value?: string | Date | null): string => {
    if (!value) {
      return 'N/A';
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      return 'N/A';
    }
    const pad = (num: number) => num.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  };

  const liveUpdateBannerDetails = useMemo(() => {
    const referenceProjectName = referenceUnit?.projectName;
    if (referenceProjectName) {
      const fromCurrent = projectDetails?.name === referenceProjectName ? projectDetails : null;
      if (fromCurrent?.liveStatusEnabled) {
        return fromCurrent;
      }
      const fromMap = projectDetailsMap.get(referenceProjectName);
      return fromMap?.liveStatusEnabled ? fromMap : null;
    }
    return projectDetails?.liveStatusEnabled ? projectDetails : null;
  }, [projectDetails, projectDetailsMap, referenceUnit]);
  const liveUpdateTimestamp = liveQueueSummary?.updatedAt ?? liveUpdateBannerDetails?.liveStatusUpdatedAt;

  const referenceProjectDetailsForCard = useMemo(() => {
    if (!referenceUnit) return null;
    if (projectDetails?.name === referenceUnit.projectName) return projectDetails;
    return projectDetailsMap.get(referenceUnit.projectName) ?? null;
  }, [projectDetails, projectDetailsMap, referenceUnit]);

  const liveUpdateIndicator = (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          bgcolor: 'var(--color-danger)',
          animation: 'pulseBlink 1s ease-in-out infinite',
          '@keyframes pulseBlink': {
            '0%': { opacity: 0.2, transform: 'scale(0.8)' },
            '50%': { opacity: 1, transform: 'scale(1.2)' },
            '100%': { opacity: 0.2, transform: 'scale(0.8)' },
          },
        }}
      />
      <Typography sx={{ color: 'var(--color-danger)', fontWeight: 700, whiteSpace: 'nowrap' }}>
        Live Update ←
      </Typography>
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          bgcolor: 'var(--color-danger)',
          animation: 'pulseBlink 1s ease-in-out infinite',
        }}
      />
    </Box>
  );

  // Calculate distance between two lat/lng points using Haversine formula (returns km)
  const calculateDistance = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
    const R = 6371; // Earth's radius in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  // Get distance from reference unit to a given project name
  const getDistanceFromReference = useCallback((projectName: string): number | null => {
    if (!referenceUnit) return null;
    
    const referenceProjectDetails = projectDetailsMap.get(referenceUnit.projectName);
    const unitProjectDetails = projectDetailsMap.get(projectName);
    
    if (!referenceProjectDetails?.mapLatitude || !referenceProjectDetails?.mapLongitude ||
        !unitProjectDetails?.mapLatitude || !unitProjectDetails?.mapLongitude) {
      return null;
    }
    
    return calculateDistance(
      referenceProjectDetails.mapLatitude!,
      referenceProjectDetails.mapLongitude!,
      unitProjectDetails.mapLatitude!,
      unitProjectDetails.mapLongitude!
    );
  }, [referenceUnit, projectDetailsMap]);

  const getDistanceFilteredProjectNames = useCallback((distanceFilter: { min: string; max: string }): string[] => {
    const min = distanceFilter.min.trim() !== '' ? parseFloat(distanceFilter.min) : null;
    const max = distanceFilter.max.trim() !== '' ? parseFloat(distanceFilter.max) : null;

    if (min === null && max === null) {
      return [...comparableResultProjectNames];
    }

    return comparableResultProjectNames.filter((projectName) => {
      const distance = getDistanceFromReference(projectName);
      if (distance === null) return false;
      if (min !== null && distance < min) return false;
      if (max !== null && distance > max) return false;
      return true;
    });
  }, [comparableResultProjectNames, getDistanceFromReference]);

  const syncProjectFilterWithDistance = useCallback((distanceFilter: { min: string; max: string }) => {
    const matchingProjectNames = getDistanceFilteredProjectNames(distanceFilter);
    setFilters((prev) => {
      const previousProjectNames = Array.isArray(prev.projectName) ? prev.projectName : [];
      const isSame =
        previousProjectNames.length === matchingProjectNames.length &&
        previousProjectNames.every((name, index) => name === matchingProjectNames[index]);
      if (isSame) return prev;
      return { ...prev, projectName: matchingProjectNames };
    });
  }, [getDistanceFilteredProjectNames, setFilters]);

  useEffect(() => {
    if (rangeFilters.distance.min.trim() === '' && rangeFilters.distance.max.trim() === '') return;
    syncProjectFilterWithDistance(rangeFilters.distance);
  }, [rangeFilters.distance, syncProjectFilterWithDistance]);

  const getPriceDiffColor = (diff: number): string => {
    if (diff > 0) return 'var(--color-price-increase)'; // Red for more expensive
    if (diff < 0) return 'var(--color-price-decrease)'; // Green for cheaper
    return 'var(--color-text-subtle)';
  };

  const getPriceChangeColor = (change: number | undefined): string => {
    if (change === undefined || change === null) return 'var(--color-text)'; // Black for no change/no data
    if (change < 0) return 'var(--color-price-decrease)'; // Green for price drop
    if (change > 0) return 'var(--color-price-increase)'; // Red for price increase
    return 'var(--color-text)'; // Black for no change
  };

  // Check if unit qualifies for thumbs up
  // 1. If lower floor: must have bigger size AND lower PSF AND lower price
  // 2. If higher floor: can have same size or bigger size, AND lower PSF AND lower price
  const qualifiesForThumbsUp = useCallback((unit: ComparableUnit): boolean => {
    if (!referenceUnit) return false;
    
    const unitParsed = parseUnitNumber(unit.unitNumber);
    const refParsed = parseUnitNumber(referenceUnit.unitNumber);
    
    // Always required: Lower PSF and lower price
    const hasLowerPSF = unit.psf > 0 && unit.psf < referenceUnit.psf;
    const hasLowerPrice = unit.price > 0 && unit.price < referenceUnit.price;
    
    if (!hasLowerPSF || !hasLowerPrice) return false;
    
    // Check floor comparison (if both have valid floors)
    const unitFloor = unitParsed.floor;
    const refFloor = refParsed.floor;
    
    if (unitFloor !== null && refFloor !== null) {
      if (unitFloor < refFloor) {
        // Lower floor: must have bigger size
        return unit.areaSqft > referenceUnit.areaSqft;
      } else if (unitFloor > refFloor) {
        // Higher floor: can have same size or bigger size
        return unit.areaSqft >= referenceUnit.areaSqft;
      } else {
        // Same floor: must have bigger size
        return unit.areaSqft > referenceUnit.areaSqft;
      }
    } else {
      // If floor info not available, just check for bigger size
      return unit.areaSqft > referenceUnit.areaSqft;
    }
  }, [referenceUnit]);

  // Apply filters and sorting
  const filteredAndSortedUnits = useMemo(() => {
    let filtered = [...originalComparableUnits];
    const refName = (referenceUnit?.projectName ?? '').trim();
    if (refName) {
      filtered = filtered.filter((u) => u.projectName === refName);
    }

    // Apply text filters
    Object.entries(filters).forEach(([key, value]) => {
      const columnKey = key as ColumnKey;
      
      // Skip floor and stack as they use range filters
      if (columnKey === 'floor' || columnKey === 'stack') return;
      
      // Handle projectName as array (multi-select)
      if (columnKey === 'projectName') {
        const projectNames = value as string[];
        if (projectNames.length === 0) return; // Empty array means show all
        filtered = filtered.filter((unit) => {
          return projectNames.includes(unit.projectName);
        });
        return;
      }
      
      // Handle other filters as strings
      const stringValue = value as string;
      if (stringValue.trim() === '') return;
      
      filtered = filtered.filter((unit) => {
        // Type-safe property access
        let unitValue: string | number | undefined;
        if (columnKey === 'unitNumber') {
          unitValue = unit.unitNumber;
        } else if (columnKey === 'blockNumber') {
          unitValue = unit.blockNumber || '';
        } else if (columnKey === 'bedroom') {
          unitValue = unit.bedroom;
        } else if (columnKey === 'bathroom') {
          unitValue = unit.bathroom;
        } else if (columnKey === 'areaSqft') {
          unitValue = unit.areaSqft;
        } else if (columnKey === 'price') {
          unitValue = unit.price;
        } else if (columnKey === 'psf') {
          unitValue = unit.psf;
        } else if (columnKey === 'outlay') {
          unitValue = unit.outlay;
        } else if (columnKey === 'installment') {
          unitValue = unit.installment;
        }

        if (unitValue === undefined) return true;
        
        if (typeof unitValue === 'string') {
          return unitValue.toLowerCase().includes(stringValue.toLowerCase());
        }
        if (typeof unitValue === 'number') {
          const numValue = parseFloat(stringValue);
          if (isNaN(numValue)) return true;
          return unitValue.toString().includes(stringValue);
        }
        return true;
      });
    });

    // Apply range filters for floor
    if (rangeFilters.floor.min.trim() !== '' || rangeFilters.floor.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const parsed = parseUnitNumber(unit.unitNumber);
        if (parsed.floor === null) return false;
        
        const min = rangeFilters.floor.min.trim() !== '' ? parseInt(rangeFilters.floor.min, 10) : null;
        const max = rangeFilters.floor.max.trim() !== '' ? parseInt(rangeFilters.floor.max, 10) : null;
        
        if (min !== null && parsed.floor < min) return false;
        if (max !== null && parsed.floor > max) return false;
        return true;
      });
    }

    // Apply range filters for stack
    if (rangeFilters.stack.min.trim() !== '' || rangeFilters.stack.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const parsed = parseUnitNumber(unit.unitNumber);
        if (parsed.stack === null) return false;
        
        const min = rangeFilters.stack.min.trim() !== '' ? parseInt(rangeFilters.stack.min, 10) : null;
        const max = rangeFilters.stack.max.trim() !== '' ? parseInt(rangeFilters.stack.max, 10) : null;
        
        if (min !== null && parsed.stack < min) return false;
        if (max !== null && parsed.stack > max) return false;
        return true;
      });
    }

    // Apply range filters for bedroom
    if (rangeFilters.bedroom.min.trim() !== '' || rangeFilters.bedroom.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const min = rangeFilters.bedroom.min.trim() !== '' ? parseInt(rangeFilters.bedroom.min, 10) : null;
        const max = rangeFilters.bedroom.max.trim() !== '' ? parseInt(rangeFilters.bedroom.max, 10) : null;
        
        if (min !== null && unit.bedroom < min) return false;
        if (max !== null && unit.bedroom > max) return false;
        return true;
      });
    }

    // Apply range filters for bathroom
    if (rangeFilters.bathroom.min.trim() !== '' || rangeFilters.bathroom.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const min = rangeFilters.bathroom.min.trim() !== '' ? parseInt(rangeFilters.bathroom.min, 10) : null;
        const max = rangeFilters.bathroom.max.trim() !== '' ? parseInt(rangeFilters.bathroom.max, 10) : null;
        
        if (min !== null && unit.bathroom < min) return false;
        if (max !== null && unit.bathroom > max) return false;
        return true;
      });
    }

    // Apply range filters for areaSqft
    if (rangeFilters.areaSqft.min.trim() !== '' || rangeFilters.areaSqft.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const min = rangeFilters.areaSqft.min.trim() !== '' ? parseFloat(rangeFilters.areaSqft.min) : null;
        const max = rangeFilters.areaSqft.max.trim() !== '' ? parseFloat(rangeFilters.areaSqft.max) : null;
        
        if (min !== null && unit.areaSqft < min) return false;
        if (max !== null && unit.areaSqft > max) return false;
        return true;
      });
    }

    // Apply range filters for price
    if (rangeFilters.price.min.trim() !== '' || rangeFilters.price.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const min = rangeFilters.price.min.trim() !== '' ? parseFloat(rangeFilters.price.min) : null;
        const max = rangeFilters.price.max.trim() !== '' ? parseFloat(rangeFilters.price.max) : null;
        
        if (min !== null && unit.price < min) return false;
        if (max !== null && unit.price > max) return false;
        return true;
      });
    }

    // Apply range filters for psf
    if (rangeFilters.psf.min.trim() !== '' || rangeFilters.psf.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const min = rangeFilters.psf.min.trim() !== '' ? parseFloat(rangeFilters.psf.min) : null;
        const max = rangeFilters.psf.max.trim() !== '' ? parseFloat(rangeFilters.psf.max) : null;
        
        if (min !== null && unit.psf < min) return false;
        if (max !== null && unit.psf > max) return false;
        return true;
      });
    }

    // Apply range filters for outlay
    if (rangeFilters.outlay.min.trim() !== '' || rangeFilters.outlay.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const min = rangeFilters.outlay.min.trim() !== '' ? parseFloat(rangeFilters.outlay.min) : null;
        const max = rangeFilters.outlay.max.trim() !== '' ? parseFloat(rangeFilters.outlay.max) : null;
        
        if (min !== null && unit.outlay < min) return false;
        if (max !== null && unit.outlay > max) return false;
        return true;
      });
    }

    // Apply range filters for installment
    if (rangeFilters.installment.min.trim() !== '' || rangeFilters.installment.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const min = rangeFilters.installment.min.trim() !== '' ? parseFloat(rangeFilters.installment.min) : null;
        const max = rangeFilters.installment.max.trim() !== '' ? parseFloat(rangeFilters.installment.max) : null;
        
        if (min !== null && unit.installment < min) return false;
        if (max !== null && unit.installment > max) return false;
        return true;
      });
    }

    // Apply distance filter
    if (rangeFilters.distance.min.trim() !== '' || rangeFilters.distance.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const distance = getDistanceFromReference(unit.projectName);
        if (distance === null) return false; // Exclude units without location data
        
        const min = rangeFilters.distance.min.trim() !== '' ? parseFloat(rangeFilters.distance.min) : null;
        const max = rangeFilters.distance.max.trim() !== '' ? parseFloat(rangeFilters.distance.max) : null;
        
        if (min !== null && distance < min) return false;
        if (max !== null && distance > max) return false;
        return true;
      });
    }

    // Pre-compute icon eligibility used by the thumbs-up filter.
    // Apply thumbs up filter (match what actually shows thumbs-up icon in table).
    if (thumbsUpFilterActive && referenceUnit) {
      filtered = filtered.filter((unit) => qualifiesForThumbsUp(unit));
    }

    // Apply sorting
    if (sortConfig.column && sortConfig.direction !== 'default') {
      filtered.sort((a, b) => {
        let aValue: any;
        let bValue: any;

        if (sortConfig.column === 'unitNumber') {
          aValue = a.unitNumber;
          bValue = b.unitNumber;
        } else if (sortConfig.column === 'floor' || sortConfig.column === 'stack') {
          const aParsed = parseUnitNumber(a.unitNumber);
          const bParsed = parseUnitNumber(b.unitNumber);
          aValue = sortConfig.column === 'floor' ? aParsed.floor : aParsed.stack;
          bValue = sortConfig.column === 'floor' ? bParsed.floor : bParsed.stack;

          // Handle null values
          if (aValue === null && bValue === null) return 0;
          if (aValue === null) return 1;
          if (bValue === null) return -1;
        } else if (sortConfig.column === 'blockNumber') {
          aValue = a.blockNumber || '';
          bValue = b.blockNumber || '';
        } else if (sortConfig.column === 'distance') {
          // Calculate distance from reference unit
          aValue = getDistanceFromReference(a.projectName);
          bValue = getDistanceFromReference(b.projectName);

          // Handle null values (units without location data)
          if (aValue === null && bValue === null) return 0;
          if (aValue === null) return 1;
          if (bValue === null) return -1;
        } else if (sortConfig.column === 'dps') {
          aValue = a.priceDps ?? 0;
          bValue = b.priceDps ?? 0;
        } else {
          aValue = a[sortConfig.column! as keyof ComparableUnit];
          bValue = b[sortConfig.column! as keyof ComparableUnit];
        }

        let comparison = 0;
        if (typeof aValue === 'string' && typeof bValue === 'string') {
          comparison = aValue.localeCompare(bValue);
        } else if (typeof aValue === 'number' && typeof bValue === 'number') {
          comparison = aValue - bValue;
        }

        const effectiveDirection =
          sortConfig.column === 'unitNumber'
            ? (sortConfig.direction === 'asc' ? 'desc' : sortConfig.direction === 'desc' ? 'asc' : sortConfig.direction)
            : sortConfig.direction;
        return effectiveDirection === 'asc' ? comparison : -comparison;
      });
    }

    return filtered;
  }, [originalComparableUnits, filters, rangeFilters, sortConfig, thumbsUpFilterActive, referenceUnit, qualifiesForThumbsUp, getDistanceFromReference]);

  // Get unique projects from currently displayed units (+ reference project as fallback)
  const uniqueProjectsFromUnits = useMemo(() => {
    const projectSet = new Set<string>();
    comparableUnits.forEach(unit => {
      if (unit.projectName) {
        projectSet.add(unit.projectName);
      }
    });
    if (referenceUnit?.projectName) {
      projectSet.add(referenceUnit.projectName);
    }
    return Array.from(projectSet);
  }, [comparableUnits, referenceUnit?.projectName]);

  // For project view: order by distance (nearest first), then by name for stable order
  const projectsForProjectView = useMemo(() => {
    return [...uniqueProjectsFromUnits].sort((a, b) => {
      const distA = getDistanceFromReference(a);
      const distB = getDistanceFromReference(b);
      if (distA != null && distB != null) return distA - distB;
      if (distA != null) return -1;
      if (distB != null) return 1;
      return a.localeCompare(b);
    });
  }, [uniqueProjectsFromUnits, getDistanceFromReference]);

  // Project view: filter rows by column filters (text substring) and range filters (min/max for numeric)
  const filteredProjectsForView = useMemo(() => {
    const getDistrictLocationStr = (d: ProjectDetails | undefined): string => {
      if (!d) return '';
      if (d.districtLocation) return d.districtLocation;
      const parts = [d.area, d.district].filter(Boolean);
      return parts.length ? parts.join(' / ') : '';
    };
    const getCellStr = (projectName: string, d: ProjectDetails | undefined, key: string): string => {
      switch (key) {
        case 'projectName': return projectName ?? '';
        case 'distance': const dist = getDistanceFromReference(projectName); return dist != null ? formatNumber(dist, 2) : '';
        case 'projectCategory': return d?.projectCategory ?? '';
        case 'developer': return d?.developer ?? '';
        case 'totalUnits': return d?.totalUnits != null ? String(d.totalUnits) : '';
        case 'soldUnits': return d?.soldUnits != null ? String(d.soldUnits) : '';
        case 'districtLocation': return getDistrictLocationStr(d);
        case 'district': return d?.district ?? '';
        case 'region': return d?.area ?? '';
        case 'nearestMrt': return d?.nearestMrt ?? '';
        case 'walkingTimeToMrt': return d?.walkingTimeToMrt != null ? String(d.walkingTimeToMrt) : '';
        case 'tenure': return d?.tenure ?? '';
        case 'completedDate': return d?.completedDate ? new Date(d.completedDate).toLocaleDateString('en-SG', { year: 'numeric', month: 'short', day: 'numeric' }) : '';
        default: {
          const brMatch = key.match(/^(br[1-5]|ph)(avail|price|psf)$/);
          if (brMatch) {
            const brKey = brMatch[1] as 'br1' | 'br2' | 'br3' | 'br4' | 'br5' | 'ph';
            const sub = brMatch[2];
            const brData = d?.[brKey];
            if (!brData) return '';
            if (sub === 'avail') return String(brData.availableUnits ?? '');
            if (sub === 'price') return brData.fromPrice != null ? formatCurrency(brData.fromPrice) : '';
            if (sub === 'psf') return brData.fromPsf != null ? formatCurrency(brData.fromPsf) : '';
          }
          return '';
        }
      }
    };
    const getCellNum = (projectName: string, d: ProjectDetails | undefined, key: string): number | null => {
      switch (key) {
        case 'distance': return getDistanceFromReference(projectName);
        case 'totalUnits': return d?.totalUnits != null ? Number(d.totalUnits) : null;
        case 'soldUnits': return d?.soldUnits != null ? d.soldUnits : null;
        case 'walkingTimeToMrt': return d?.walkingTimeToMrt ?? null;
        default: {
          const brMatch = key.match(/^(br[1-5]|ph)(avail|price|psf)$/);
          if (brMatch) {
            const brKey = brMatch[1] as 'br1' | 'br2' | 'br3' | 'br4' | 'br5' | 'ph';
            const sub = brMatch[2];
            const brData = d?.[brKey];
            if (!brData) return null;
            if (sub === 'avail') return brData.availableUnits ?? null;
            if (sub === 'price') return brData.fromPrice ?? null;
            if (sub === 'psf') return brData.fromPsf ?? null;
          }
          return null;
        }
      }
    };
    const filtered = projectsForProjectView.filter((projectName) => {
      const d = projectDetailsMap.get(projectName);
      return PROJECT_VIEW_COLUMN_KEYS.every((k) => {
        if (k === 'districtLocation') {
          if (projectViewDistrictFilter.length === 0) return true;
          const cellStr = getDistrictLocationStr(d).toLowerCase();
          return projectViewDistrictFilter.some((sel) => {
            const num = sel.replace(/^District\s+/i, '');
            return cellStr.includes(`d${num.padStart(2, '0')}`) || cellStr.includes(sel.toLowerCase()) || cellStr.includes(` ${num} `) || cellStr === num;
          });
        }
        if (PROJECT_VIEW_NUMERIC_COLUMNS.has(k)) {
          const range = projectViewRangeFilters[k] ?? { min: '', max: '' };
          if (range.min.trim() === '' && range.max.trim() === '') return true;
          const num = getCellNum(projectName, d, k);
          const minVal = range.min.trim() !== '' ? parseFloat(range.min) : null;
          const maxVal = range.max.trim() !== '' ? parseFloat(range.max) : null;
          if (minVal != null && (num === null || num < minVal)) return false;
          if (maxVal != null && (num === null || num > maxVal)) return false;
          return true;
        }
        const filterVal = (projectViewFilters[k] ?? '').trim();
        if (!filterVal) return true;
        return getCellStr(projectName, d, k).toLowerCase().includes(filterVal.toLowerCase());
      });
    });

    if (!projectViewSortConfig.column || projectViewSortConfig.direction === 'default') {
      return filtered;
    }

    const sortColumn = projectViewSortConfig.column;
    const sorted = [...filtered].sort((a, b) => {
      const detailsA = projectDetailsMap.get(a);
      const detailsB = projectDetailsMap.get(b);
      let comparison = 0;

      if (PROJECT_VIEW_NUMERIC_COLUMNS.has(sortColumn)) {
        const aValue = getCellNum(a, detailsA, sortColumn);
        const bValue = getCellNum(b, detailsB, sortColumn);
        if (aValue == null && bValue == null) comparison = 0;
        else if (aValue == null) comparison = 1;
        else if (bValue == null) comparison = -1;
        else comparison = aValue - bValue;
      } else if (sortColumn === 'completedDate') {
        const aTime = detailsA?.completedDate ? new Date(detailsA.completedDate).getTime() : null;
        const bTime = detailsB?.completedDate ? new Date(detailsB.completedDate).getTime() : null;
        if (aTime == null && bTime == null) comparison = 0;
        else if (aTime == null) comparison = 1;
        else if (bTime == null) comparison = -1;
        else comparison = aTime - bTime;
      } else {
        const aValue = getCellStr(a, detailsA, sortColumn).toLowerCase();
        const bValue = getCellStr(b, detailsB, sortColumn).toLowerCase();
        comparison = aValue.localeCompare(bValue, undefined, { numeric: true, sensitivity: 'base' });
      }

      if (comparison === 0) {
        comparison = a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
      }

      return projectViewSortConfig.direction === 'asc' ? comparison : -comparison;
    });

    return sorted;
  }, [projectsForProjectView, projectDetailsMap, projectViewFilters, projectViewRangeFilters, projectViewDistrictFilter, projectViewSortConfig, getDistanceFromReference, formatNumber, formatCurrency]);

  // Update displayed units when filtered/sorted
  useEffect(() => {
    setComparableUnits(filteredAndSortedUnits);
  }, [filteredAndSortedUnits, setComparableUnits]);

  // Fetch amenities function
  const fetchAmenities = useCallback(async (projectName: string, radius: number) => {
    try {
      setAmenitiesLoading(true);
      const projectId = await resolveProjectIdByName(projectName);
      if (!projectId) {
        throw new Error(`Unable to resolve project id for ${projectName}`);
      }
      const data = await api.getAmenities(projectId, radius);
      setAmenitiesData(data);
    } catch (err) {
      console.error('Failed to fetch amenities:', err);
      setAmenitiesData(null);
    } finally {
      setAmenitiesLoading(false);
    }
  }, [resolveProjectIdByName]);

  // Fetch demand/supply function
  // Both ends of the Super Ratio scan ring move together, so one committed
  // slider change updates both bounds and the auto-fetch effect refetches once.
  const handleDemandSupplyRadiusChange = useCallback((radius: number, minRadius: number) => {
    setDemandSupplyRadius(radius);
    setDemandSupplyMinRadius(minRadius);
  }, []);

  // Whole Singapore — the radius stays as it was, so unticking returns to it.
  const handleDemandSupplyNationwideChange = useCallback((nationwide: boolean) => {
    setDemandSupplyNationwide(nationwide);
  }, []);

  const fetchDemandSupply = useCallback(async (
    projectName: string,
    radius: number,
    minRadius = 0,
    nationwide = false,
  ) => {
    try {
      setDemandSupplyLoading(true);
      const projectId = await resolveProjectIdByName(projectName);
      if (!projectId) {
        throw new Error(`Unable to resolve project id for ${projectName}`);
      }
      const data = await api.getDemandSupply(projectId, radius, minRadius, nationwide);
      setDemandSupplyData(data);
    } catch (err) {
      console.error('Failed to fetch demand/supply data:', err);
      setDemandSupplyData(null);
    } finally {
      setDemandSupplyLoading(false);
    }
  }, [resolveProjectIdByName]);

  // Fetch project members function
  const fetchProjectMembers = useCallback(async (projectId: string) => {
    try {
      setProjectMembersLoading(true);
      const data = await api.getProjectMembers(projectId);
      setProjectMembers(data);
    } catch (err) {
      console.error('Failed to fetch project members:', err);
      setProjectMembers(null);
    } finally {
      setProjectMembersLoading(false);
    }
  }, []);

  // Handle tapping an agent in Project Members -> navigate to Success Closer, search by name, and highlight
  const handleProjectMemberTap = useCallback((member: ProjectMemberInfo) => {
    if (member.name) {
      setSuccessCloserSearch(member.name);
    }
    if (member.ceaNumber) {
      setHighlightCea(member.ceaNumber);
      // Clear highlight after animation
      setTimeout(() => setHighlightCea(null), 5000);
    }
    setActiveTabId('success-closer');
    setActiveClientId(null);
  }, []);

  // Auto-fetch amenities when project changes and the Amenities tab is active
  useEffect(() => {
    if (
      projectDetailsTab === 'amenities' &&
      projectDetails?.name &&
      projectDetails.mapLatitude &&
      projectDetails.mapLongitude
    ) {
      fetchAmenities(projectDetails.name, amenitiesRadius);
    }
  }, [projectDetails?.name, projectDetails?.mapLatitude, projectDetails?.mapLongitude, projectDetailsTab, amenitiesRadius, fetchAmenities]);

  // Auto-fetch demand/supply when project changes and the Super Ratio tab is active.
  // Wait for the authenticated session capability before fetching.
  useEffect(() => {
    if (
      canAccessSuperRatio &&
      projectDetailsTab === 'superRatio' &&
      projectDetails?.name &&
      projectDetails.mapLatitude &&
      projectDetails.mapLongitude
    ) {
      fetchDemandSupply(
        projectDetails.name,
        demandSupplyRadius,
        demandSupplyMinRadius,
        demandSupplyNationwide,
      );
    }
  }, [canAccessSuperRatio, projectDetails?.name, projectDetails?.mapLatitude, projectDetails?.mapLongitude, projectDetailsTab, demandSupplyRadius, demandSupplyMinRadius, demandSupplyNationwide, fetchDemandSupply]);

  // Auto-fetch project members when project changes and members tab is active
  useEffect(() => {
    if (isExternalUser) return;
    if (
      projectDetailsTab === 'members' &&
      projectDetails?.id
    ) {
      fetchProjectMembers(projectDetails.id);
    }
  }, [fetchProjectMembers, isExternalUser, projectDetails?.id, projectDetailsTab]);

  // Create a stable key from unique projects for comparison
  const uniqueProjectsKey = useMemo(() => {
    return [...projectsForProjectView].join(',');
  }, [projectsForProjectView]);

  // Track last fetched projects to prevent duplicate calls
  const lastFetchedProjectsRef = useRef<string>('');

  // Fetch project details for selected projects when in project view
  useEffect(() => {
    const fetchProjectDetailsForView = async () => {
      // Use projects currently shown in Project View (includes reference project fallback)
      const projectNames = viewMode === 'project' ? projectsForProjectView : [];
      
      // Skip if no projects or if we already fetched for these exact projects
      if (viewMode !== 'project' || projectNames.length === 0 || uniqueProjectsKey === lastFetchedProjectsRef.current) {
        return;
      }

      // Check which projects need to be fetched using the current map state
      // Use functional update to access current map without including it in dependencies
      let projectsToFetch: string[] = [];
      setProjectDetailsMap(prevMap => {
        projectsToFetch = projectNames.filter(projectName => {
          const existing = prevMap.get(projectName);
          // Fetch if not in map or if it's a placeholder (has name but no other data)
          return !existing || (existing.name === projectName && !existing.developer && !existing.totalUnits);
        });
        
        // Return unchanged map to avoid triggering re-render
        return prevMap;
      });
      
      if (projectsToFetch.length > 0) {
        // Mark as fetched before making the call
        lastFetchedProjectsRef.current = uniqueProjectsKey;
        
        try {
          const projectIds = await resolveProjectIdsByName(projectsToFetch);
          if (projectIds.length === 0) {
            return;
          }
          // Fetch all project details in one API call
          const projectDetails = await api.getBulkProjectDetails(projectIds);
          
          // Update the map with fetched details
          setProjectDetailsMap(prevMap => {
            const newMap = new Map(prevMap);
            projectDetails.forEach(details => {
              if (details.name) {
                newMap.set(details.name, details);
              }
            });
            return newMap;
          });
        } catch (err) {
          console.error('Failed to fetch project details:', err);
          // Set empty details as fallback for projects that failed
          setProjectDetailsMap(prevMap => {
            const newMap = new Map(prevMap);
            projectsToFetch.forEach(projectName => {
              if (!newMap.has(projectName)) {
                newMap.set(projectName, {
                  name: projectName,
                  developer: null,
                  tenure: null,
                  totalUnits: null,
                  completedDate: null,
                  area: null,
                  district: null,
                  address: null,
                  mapLongitude: null,
                  mapLatitude: null,
                });
              }
            });
            return newMap;
          });
        }
      } else {
        // No projects to fetch, but mark as processed
        lastFetchedProjectsRef.current = uniqueProjectsKey;
      }
    };

    fetchProjectDetailsForView();
  }, [projectsForProjectView, resolveProjectIdsByName, uniqueProjectsKey, viewMode]);

  // Fetch best-by-unit-type when Best PX BEDROOM TYPE view is selected
  useEffect(() => {
    if (viewMode !== 'bestPxBedroom' || !referenceUnit?.projectName) {
      setBestByUnitTypeData(null);
      return;
    }
    let cancelled = false;
    setBestByUnitTypeLoading(true);
    fetchBestByUnitType(referenceUnit.projectName)
      .then((data) => {
        if (!cancelled) setBestByUnitTypeData(data);
      })
      .catch(() => {
        if (!cancelled) setBestByUnitTypeData(null);
      })
      .finally(() => {
        if (!cancelled) setBestByUnitTypeLoading(false);
      });
    return () => { cancelled = true; };
  }, [fetchBestByUnitType, referenceUnit?.projectName, viewMode]);

  // Fetch site plan for Best PX BEDROOM TYPE view (right panel)
  useEffect(() => {
    if (viewMode !== 'bestPxBedroom' || !referenceUnit?.projectName) {
      setBestPxBedroomSitePlan(null);
      return;
    }
    let cancelled = false;
    fetchSitePlan(referenceUnit.projectName)
      .then(({ sitePlan }) => { if (!cancelled) setBestPxBedroomSitePlan(sitePlan); })
      .catch(() => { if (!cancelled) setBestPxBedroomSitePlan(null); });
    return () => { cancelled = true; };
  }, [fetchSitePlan, referenceUnit?.projectName, viewMode]);

  const handleSortChange = (column: ColumnKey, direction: SortDirection) => {
    setSortConfig({ column, direction });
    setPopoverAnchor(null);
  };

  const handleFilterChange = (column: ColumnKey, value: string | string[]) => {
    if (column === 'projectName' && referenceUnit?.projectName) {
      setFilters((prev) => ({ ...prev, projectName: [referenceUnit.projectName] }));
      return;
    }
    setFilters((prev) => ({ ...prev, [column]: value }));
  };

  const handleRangeFilterChange = (
    column: 'floor' | 'stack' | 'bedroom' | 'bathroom' | 'areaSqft' | 'price' | 'psf' | 'dps' | 'outlay' | 'installment' | 'distance',
    type: 'min' | 'max',
    value: string
  ) => {
    setRangeFilters((prev) => ({
      ...prev,
      [column]: {
        ...prev[column],
        [type]: value,
      },
    }));
  };

  const handleProjectDistanceFilterChange = (type: 'min' | 'max', value: string) => {
    const nextDistanceFilter = {
      ...rangeFilters.distance,
      [type]: value,
    };
    handleRangeFilterChange('distance', type, value);
    syncProjectFilterWithDistance(nextDistanceFilter);
  };

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>, column: ColumnKey) => {
    setPopoverAnchor({ element: event.currentTarget, column });
  };

  const handleClosePopover = () => {
    setPopoverAnchor(null);
  };

  const getColumnLabel = (column: ColumnKey): string => {
    const labels: Record<ColumnKey, string> = {
      projectName: 'Project Name',
      unitNumber: 'Unit #',
      blockNumber: 'Block',
      floor: 'Floor',
      stack: 'Stack',
      bedroom: 'Bed',
      bathroom: 'Bath',
      areaSqft: 'Area (sqft)',
      price: 'Price $',
      psf: 'PSF $',
      dps: 'DPS $',
      outlay: 'Outlay $',
      installment: 'Installment $',
      distance: 'Distance',
    };
    return labels[column];
  };

  const getCurrentSortDirection = (column: ColumnKey): SortDirection => {
    return sortConfig.column === column ? sortConfig.direction : 'default';
  };
  const getProjectViewSortDirection = (column: string): SortDirection => {
    if (projectViewSortConfig.column !== column) return 'default';
    return projectViewSortConfig.direction;
  };

  const hasActiveFilter = (column: ColumnKey): boolean => {
    if (column === 'blockNumber') {
      return (filters.blockNumber as string).trim() !== '';
    }
    if (column === 'floor') {
      return rangeFilters.floor.min.trim() !== '' || rangeFilters.floor.max.trim() !== '';
    }
    if (column === 'stack') {
      return rangeFilters.stack.min.trim() !== '' || rangeFilters.stack.max.trim() !== '';
    }
    if (column === 'bedroom') {
      return rangeFilters.bedroom.min.trim() !== '' || rangeFilters.bedroom.max.trim() !== '';
    }
    if (column === 'bathroom') {
      return rangeFilters.bathroom.min.trim() !== '' || rangeFilters.bathroom.max.trim() !== '';
    }
    if (column === 'areaSqft') {
      return rangeFilters.areaSqft.min.trim() !== '' || rangeFilters.areaSqft.max.trim() !== '';
    }
    if (column === 'price') {
      return rangeFilters.price.min.trim() !== '' || rangeFilters.price.max.trim() !== '';
    }
    if (column === 'psf') {
      return rangeFilters.psf.min.trim() !== '' || rangeFilters.psf.max.trim() !== '';
    }
    if (column === 'dps') {
      const dpsRange = rangeFilters.dps ?? { min: '', max: '' };
      return dpsRange.min.trim() !== '' || dpsRange.max.trim() !== '';
    }
    if (column === 'outlay') {
      return rangeFilters.outlay.min.trim() !== '' || rangeFilters.outlay.max.trim() !== '';
    }
    if (column === 'installment') {
      return rangeFilters.installment.min.trim() !== '' || rangeFilters.installment.max.trim() !== '';
    }
    if (column === 'distance') {
      return rangeFilters.distance.min.trim() !== '' || rangeFilters.distance.max.trim() !== '';
    }
    if (column === 'projectName') {
      if (referenceUnit?.projectName) {
        return false;
      }
      const projectNames = filters[column] as string[];
      return Array.isArray(projectNames) && projectNames.length > 0;
    }
    const value = filters[column] as string;
    return value.trim() !== '';
  };

  const getIconButtonSx = () => ({
    p: 0.5,
    color: 'var(--color-text-strong)',
    '&:hover': {
      backgroundColor: 'var(--color-surface-ghost-strong)',
      color: 'var(--color-accent)',
    },
  });

  const renderSortIndicatorIcon = (direction: SortDirection) => {
    if (direction === 'default') {
      return <MenuIcon fontSize="small" />;
    }
    return (
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
        {direction === 'asc'
          ? <ArrowUpwardIcon sx={{ fontSize: '0.85rem' }} />
          : <ArrowDownwardIcon sx={{ fontSize: '0.85rem' }} />}
        <MenuIcon fontSize="small" />
      </Box>
    );
  };

  const handleMasterToolUnitSortChange = (column: MasterToolUnitColumnKey, direction: SortDirection) => {
    logProjectResearchSortChanged({
      viewMode: 'unit',
      column,
      direction,
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });
    setMasterToolUnitSortConfig({ column, direction });
    setMasterToolUnitPage(1);
    setMasterToolUnitPopoverAnchor(null);
  };

  const handleMasterToolUnitFilterChange = (column: MasterToolUnitColumnKey, value: string | string[]) => {
    logProjectResearchFilterChanged({
      viewMode: 'unit',
      column,
      filterType: Array.isArray(value) ? 'category' : 'text',
      value,
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });
    setMasterToolUnitFilters((prev) => ({ ...prev, [column]: value }));
    setMasterToolUnitPage(1);
  };

  const handleMasterToolUnitRangeFilterChange = (
    column: MasterToolUnitRangeKey,
    type: 'min' | 'max',
    value: string
  ) => {
    logProjectResearchFilterChanged({
      viewMode: 'unit',
      column,
      filterType: 'range',
      bound: type,
      value,
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });
    setMasterToolUnitRangeFilters((prev) => ({
      ...prev,
      [column]: {
        ...prev[column],
        [type]: value,
      },
    }));
    setMasterToolUnitPage(1);
  };

  const handleMasterToolUnitOpenPopover = (event: React.MouseEvent<HTMLElement>, column: MasterToolUnitColumnKey) => {
    setMasterToolUnitPopoverAnchor({ element: event.currentTarget, column });
  };

  const handleMasterToolUnitClosePopover = () => {
    setMasterToolUnitPopoverAnchor(null);
  };

  const getMasterToolUnitColumnLabel = useCallback((column: MasterToolUnitColumnKey): string => {
    const labels: Record<MasterToolUnitColumnKey, string> = {
      projectName: 'Project Name',
      projectCategory: 'Project Category',
      unitNumber: 'Unit',
      blockNumber: 'Block',
      district: 'District',
      region: 'Region',
      districtLocation: 'District/Location',
      nearestMrt: 'Nearest MRT',
      walkingTimeToMrt: 'Walking Time',
      tenure: 'Tenure',
      topYear: 'TOP Year',
      floor: 'Floor',
      stack: 'Stack',
      bedroom: 'Bed',
      bathroom: 'Bath',
      areaSqft: 'Area (sqft)',
      price: hasMasterToolExecutiveCondo ? 'Price/NPS $' : 'Price $',
      dps: 'DPS $',
      psf: 'PSF $',
      outlay: 'Outlay $',
      installment: 'Installment $',
    };
    return labels[column];
  }, [hasMasterToolExecutiveCondo]);

  const getMasterToolUnitSortDirection = (column: MasterToolUnitColumnKey): SortDirection => {
    return masterToolUnitSortConfig.column === column ? masterToolUnitSortConfig.direction : 'default';
  };

  const hasMasterToolUnitActiveFilter = (column: MasterToolUnitColumnKey): boolean => {
    if (
      column === 'walkingTimeToMrt' ||
      column === 'topYear' ||
      column === 'floor' ||
      column === 'stack' ||
      column === 'bedroom' ||
      column === 'bathroom' ||
      column === 'areaSqft' ||
      column === 'price' ||
      column === 'dps' ||
      column === 'psf' ||
      column === 'outlay' ||
      column === 'installment'
    ) {
      const range = masterToolUnitRangeFilters[column];
      return range.min.trim() !== '' || range.max.trim() !== '';
    }
    if (
      column === 'projectName' ||
      column === 'projectCategory' ||
      column === 'district' ||
      column === 'region' ||
      column === 'districtLocation' ||
      column === 'nearestMrt' ||
      column === 'tenure'
    ) {
      const selectedValues = masterToolUnitFilters[column] as string[];
      return Array.isArray(selectedValues) && selectedValues.length > 0;
    }
    return (masterToolUnitFilters[column] as string).trim() !== '';
  };

  const getMasterToolUnitIconButtonSx = useCallback((column: MasterToolUnitColumnKey) => {
    const base = {
      p: 0.5,
      color: 'var(--color-text-strong)',
      '&:hover': {
        backgroundColor: 'var(--color-surface-ghost-strong)',
        color: 'var(--color-accent)',
      },
    };
    if (hasMasterToolUnitActiveFilter(column)) {
      return {
        ...base,
        color: 'var(--color-accent)',
        backgroundColor: 'rgba(var(--color-accent-rgb), 0.12)',
      };
    }
    return base;
  }, [hasMasterToolUnitActiveFilter]);

  const handleMasterToolProjectOpenPopover = (event: React.MouseEvent<HTMLElement>, column: MasterToolProjectFilterSortColumnKey) => {
    event.stopPropagation();
    setMasterToolPopoverAnchor({ element: event.currentTarget, column });
  };

  const handleMasterToolProjectClosePopover = () => {
    setMasterToolPopoverAnchor(null);
  };

  const getMasterToolProjectColumnLabel = useCallback((column: MasterToolProjectFilterSortColumnKey): string => {
    const labels: Record<MasterToolProjectFilterSortColumnKey, string> = {
      projectName: 'Project Name',
      projectCategory: 'Project Category',
      matchedTotal: 'Matched',
      matchedBr1: 'Matched 1BR',
      matchedBr2: 'Matched 2BR',
      matchedBr3: 'Matched 3BR',
      matchedBr4: 'Matched 4BR',
      matchedBr5: 'Matched 5BR',
      matchedPh: 'Matched PH',
      matchedBr1From: '1BR fr.',
      matchedBr2From: '2BR fr.',
      matchedBr3From: '3BR fr.',
      matchedBr4From: '4BR fr.',
      matchedBr5From: '5BR fr.',
      matchedPhFrom: 'PH fr.',
      referenceDistanceKm: 'Dist fr Ref. Loc',
      developer: 'Developer',
      totalUnits: 'Total Units',
      soldUnits: 'Sold Units',
      districtLocation: 'District/Location',
      district: 'District',
      region: 'Region',
      nearestMrt: 'Nearest MRT',
      walkingTimeToMrt: 'Walking Time',
      tenure: 'Tenure',
      topDate: 'TOP Year',
      completedDate: 'Completed Date',
      br1avail: '1BR Avail',
      br1price: '1BR Price',
      br1psf: '1BR Psf',
      br2avail: '2BR Avail',
      br2price: '2BR Price',
      br2psf: '2BR Psf',
      br3avail: '3BR Avail',
      br3price: '3BR Price',
      br3psf: '3BR Psf',
      br4avail: '4BR Avail',
      br4price: '4BR Price',
      br4psf: '4BR Psf',
      br5avail: '5BR Avail',
      br5price: '5BR Price',
      br5psf: '5BR Psf',
      phavail: 'PH Avail',
      phprice: 'PH Price',
      phpsf: 'PH Psf',
    };
    return labels[column];
  }, []);

  const getMasterToolProjectSortDirection = (column: MasterToolProjectFilterSortColumnKey): SortDirection => {
    return masterToolProjectSortConfig.column === column ? masterToolProjectSortConfig.direction : 'default';
  };

  const hasMasterToolProjectActiveFilter = useCallback((column: MasterToolProjectFilterSortColumnKey): boolean => {
    const categoryColumns: MasterToolProjectCategoryFilterKey[] = ['projectName', 'projectCategory', 'district', 'region', 'nearestMrt', 'tenure'];
    if (categoryColumns.includes(column as MasterToolProjectCategoryFilterKey)) {
      return (masterToolProjectCategoryFilters[column as MasterToolProjectCategoryFilterKey] ?? []).length > 0;
    }
    const textFilter = (masterToolProjectViewFilters[column] ?? '').trim();
    if (textFilter) return true;
    const range = masterToolProjectViewRangeFilters[column] ?? { min: '', max: '' };
    return (range.min ?? '').trim() !== '' || (range.max ?? '').trim() !== '';
  }, [masterToolProjectCategoryFilters, masterToolProjectViewFilters, masterToolProjectViewRangeFilters]);

  const getMasterToolProjectIconButtonSx = useCallback((column: MasterToolProjectFilterSortColumnKey) => {
    const base = {
      p: 0.5,
      color: 'var(--color-text-strong)',
      '&:hover': {
        backgroundColor: 'var(--color-surface-ghost-strong)',
        color: 'var(--color-accent)',
      },
    };
    if (hasMasterToolProjectActiveFilter(column)) {
      return {
        ...base,
        color: 'var(--color-accent)',
        backgroundColor: 'rgba(var(--color-accent-rgb), 0.12)',
      };
    }
    return base;
  }, [hasMasterToolProjectActiveFilter]);

  const hasMasterToolUnitFiltersActive = useMemo(() => {
    const categoryColumns: Array<MasterToolUnitColumnKey> = ['projectName', 'projectCategory', 'district', 'region', 'districtLocation', 'nearestMrt', 'tenure'];
    const categoryActive = categoryColumns.some((column) => {
      const selectedValues = masterToolUnitFilters[column] as string[];
      return Array.isArray(selectedValues) && selectedValues.length > 0;
    });
    const textColumns: Array<MasterToolUnitColumnKey> = ['unitNumber', 'blockNumber'];
    const textActive = textColumns.some((column) => ((masterToolUnitFilters[column] as string) ?? '').trim() !== '');
    const rangeActive = Object.values(masterToolUnitRangeFilters).some((range) => (range.min ?? '').trim() !== '' || (range.max ?? '').trim() !== '');
    return categoryActive || textActive || rangeActive;
  }, [masterToolUnitFilters, masterToolUnitRangeFilters]);

  const hasAnyMasterToolTableFilters = hasMasterToolProjectFiltersActive || hasMasterToolUnitFiltersActive;

  const masterToolProjectFilterSummaryParts = useMemo(() => {
    const parts: string[] = [];

    const categoryEntries: Array<{ key: MasterToolProjectCategoryFilterKey; label: string }> = [
      { key: 'projectName', label: 'Project' },
      { key: 'projectCategory', label: 'Category' },
      { key: 'district', label: 'District' },
      { key: 'region', label: 'Region' },
      { key: 'nearestMrt', label: 'MRT' },
      { key: 'tenure', label: 'Tenure' },
    ];
    categoryEntries.forEach(({ key, label }) => {
      const selected = masterToolProjectCategoryFilters[key] ?? [];
      if (selected.length === 0) return;
      const options = masterToolProjectCategoryOptions[key] ?? [];
      if (options.length > 0 && selected.length >= options.length) return;
      parts.push(`${label}: ${selected.join(', ')}`);
    });

    Object.entries(masterToolProjectViewFilters).forEach(([key, value]) => {
      const trimmed = (value ?? '').trim();
      if (!trimmed) return;
      if (!(MASTER_TOOL_PROJECT_FILTER_SORT_COLUMN_KEYS as readonly string[]).includes(key)) return;
      parts.push(`${getMasterToolProjectColumnLabel(key as MasterToolProjectFilterSortColumnKey)}: ${trimmed}`);
    });

    (Object.entries(masterToolProjectViewRangeFilters) as Array<[string, { min: string; max: string }]>).forEach(([key, range]) => {
      if (!(MASTER_TOOL_PROJECT_FILTER_SORT_COLUMN_KEYS as readonly string[]).includes(key)) return;
      const min = (range?.min ?? '').trim();
      const max = (range?.max ?? '').trim();
      if (!min && !max) return;
      const label = getMasterToolProjectColumnLabel(key as MasterToolProjectFilterSortColumnKey);
      if (min && max) parts.push(`${label}: ${min}-${max}`);
      else if (min) parts.push(`${label}: >=${min}`);
      else parts.push(`${label}: <=${max}`);
    });

    return parts;
  }, [
    getMasterToolProjectColumnLabel,
    masterToolProjectCategoryFilters,
    masterToolProjectCategoryOptions,
    masterToolProjectViewFilters,
    masterToolProjectViewRangeFilters,
  ]);

  const masterToolUnitFilterSummaryParts = useMemo(() => {
    const parts: string[] = [];

    const categoryColumns = ['projectName', 'projectCategory', 'district', 'region', 'districtLocation', 'nearestMrt', 'tenure'] as const;
    categoryColumns.forEach((column) => {
      const selected = masterToolUnitFilters[column] as string[];
      if (!Array.isArray(selected) || selected.length === 0) return;
      const options = masterToolUnitCategoryOptions[column] ?? [];
      if (options.length > 0 && selected.length >= options.length) return;
      parts.push(`${getMasterToolUnitColumnLabel(column)}: ${selected.join(', ')}`);
    });

    const textColumns = ['unitNumber', 'blockNumber'] as const;
    textColumns.forEach((column) => {
      const value = ((masterToolUnitFilters[column] as string) ?? '').trim();
      if (!value) return;
      parts.push(`${getMasterToolUnitColumnLabel(column)}: ${value}`);
    });

    (Object.entries(masterToolUnitRangeFilters) as Array<[MasterToolUnitRangeKey, { min: string; max: string }]>).forEach(([column, range]) => {
      const min = (range?.min ?? '').trim();
      const max = (range?.max ?? '').trim();
      if (!min && !max) return;
      const label = getMasterToolUnitColumnLabel(column);
      if (min && max) parts.push(`${label}: ${min}-${max}`);
      else if (min) parts.push(`${label}: >=${min}`);
      else parts.push(`${label}: <=${max}`);
    });

    return parts;
  }, [getMasterToolUnitColumnLabel, masterToolUnitCategoryOptions, masterToolUnitFilters, masterToolUnitRangeFilters]);

  const masterToolTableFilterSummaryParts = useMemo(() => {
    if (masterToolViewMode === 'project') {
      return masterToolProjectFilterSummaryParts;
    }
    if (masterToolProjectFilterSummaryParts.length === 0) {
      return masterToolUnitFilterSummaryParts;
    }
    return [
      ...masterToolProjectFilterSummaryParts.map((part) => `Project: ${part}`),
      ...masterToolUnitFilterSummaryParts,
    ];
  }, [masterToolProjectFilterSummaryParts, masterToolUnitFilterSummaryParts, masterToolViewMode]);

  const handleClearMasterToolTableFilters = useCallback(() => {
    setMasterToolProjectSortConfig({ column: null, direction: 'default' });
    setMasterToolProjectViewFilters({});
    setMasterToolProjectViewRangeFilters({});
    setMasterToolProjectCategoryFilters({
      projectName: [],
      projectCategory: [],
      district: [],
      region: [],
      nearestMrt: [],
      tenure: [],
    });
    setMasterToolUnitSortConfig({ column: null, direction: 'default' });
    setMasterToolUnitFilters({
      projectName: [],
      projectCategory: [],
      unitNumber: '',
      blockNumber: '',
      district: [],
      region: [],
      districtLocation: [],
      nearestMrt: [],
      walkingTimeToMrt: '',
      tenure: [],
      topYear: '',
      floor: '',
      stack: '',
      bedroom: '',
      bathroom: '',
      areaSqft: '',
      price: '',
      dps: '',
      psf: '',
      outlay: '',
      installment: '',
    });
    setMasterToolUnitRangeFilters({
      floor: { min: '', max: '' },
      stack: { min: '', max: '' },
      bedroom: { min: '', max: '' },
      bathroom: { min: '', max: '' },
      areaSqft: { min: '', max: '' },
      price: { min: '', max: '' },
      dps: { min: '', max: '' },
      psf: { min: '', max: '' },
      outlay: { min: '', max: '' },
      installment: { min: '', max: '' },
      walkingTimeToMrt: { min: '', max: '' },
      topYear: { min: '', max: '' },
    });
    setMasterToolProjectPage(1);
    setMasterToolUnitPage(1);
    setMasterToolPopoverAnchor(null);
    setMasterToolUnitPopoverAnchor(null);
  }, []);

  const handleExportMasterToolProjectCsv = useCallback(() => {
    const visibleColumns = masterToolProjectColumnsForMenu.filter(isMasterToolProjectColumnVisible);
    const rows: string[][] = [
      visibleColumns.map((column) => getMasterToolProjectColumnLabel(column)),
      ...masterToolProjectRowsForDisplay.map((project) => {
        const matched = masterToolMatchedCountByProject.get((project.name ?? '').trim()) ?? { total: 0, br1: 0, br2: 0, br3: 0, br4: 0, br5: 0, ph: 0 };
        return visibleColumns.map((column) => String(getMasterToolProjectCsvValue(project, column, matched)));
      }),
    ];
    downloadCsvFile(`project-research-project-view-${Date.now()}.csv`, rows);
  }, [
    downloadCsvFile,
    getMasterToolProjectColumnLabel,
    getMasterToolProjectCsvValue,
    isMasterToolProjectColumnVisible,
    masterToolMatchedCountByProject,
    masterToolProjectColumnsForMenu,
    masterToolProjectRowsForDisplay,
  ]);

  const handleExportMasterToolUnitCsv = useCallback(async () => {
    const visibleColumns = masterToolUnitColumnsForMenu.filter((column): column is MasterToolUnitColumnKey => isMasterToolUnitColumnVisible(column));
    const effectiveUnitFilters = getEffectiveMasterToolUnitFilters();
    const pageSize = Math.max(masterToolPageSize, 200);
    const collected: MasterToolUnit[] = [];
    let page = 1;
    let total = 0;

    do {
      const result = await api.searchUnits({
        filters: masterToolFilters,
        page,
        pageSize,
        sortBy: masterToolUnitSortConfig.column ?? undefined,
        sortDir: masterToolUnitSortConfig.direction === 'default' ? undefined : masterToolUnitSortConfig.direction,
        unitFilters: effectiveUnitFilters,
        unitRangeFilters: debouncedMasterToolUnitRangeFilters,
        loanToValue,
        tenureYears,
        interestRate,
      });
      total = result.totalUnits;
      collected.push(...result.items);
      if (result.items.length === 0) break;
      page += 1;
    } while (collected.length < total);

    const rows: string[][] = [
      visibleColumns.map((column) => getMasterToolUnitColumnLabel(column)),
      ...collected.map((unit) => {
        const computedUnit = toMasterToolUnitWithComputed(unit);
        return visibleColumns.map((column) => String(getMasterToolUnitCsvValue(computedUnit, column)));
      }),
    ];
    downloadCsvFile(`project-research-unit-view-${Date.now()}.csv`, rows);
  }, [
    debouncedMasterToolUnitRangeFilters,
    downloadCsvFile,
    getEffectiveMasterToolUnitFilters,
    getMasterToolUnitColumnLabel,
    getMasterToolUnitCsvValue,
    interestRate,
    isMasterToolUnitColumnVisible,
    loanToValue,
    masterToolFilters,
    masterToolPageSize,
    masterToolUnitColumnsForMenu,
    masterToolUnitSortConfig.column,
    masterToolUnitSortConfig.direction,
    tenureYears,
    toMasterToolUnitWithComputed,
  ]);

  const getMasterToolPdfRecordCount = useCallback((): number => {
    return masterToolViewMode === 'project'
      ? selectedMasterToolProjectRowsForExport.length
      : masterToolTotalMatchedUnits;
  }, [masterToolViewMode, selectedMasterToolProjectRowsForExport.length, masterToolTotalMatchedUnits]);

  const getMasterToolPdfMaxRecords = useCallback((): number => {
    return PDF_EXPORT_MAX_RECORDS_BY_VIEW[masterToolViewMode];
  }, [masterToolViewMode]);

  const handleExportMasterToolProjectPdf = useCallback(async () => {
    const visibleColumns = masterToolProjectColumnsForMenu.filter(isMasterToolProjectColumnVisible);
    const rows = selectedMasterToolProjectRowsForExport.map((project) => {
      const matched = masterToolMatchedCountByProject.get((project.name ?? '').trim()) ?? { total: 0, br1: 0, br2: 0, br3: 0, br4: 0, br5: 0, ph: 0 };
      return visibleColumns.map((column) => String(getMasterToolProjectCsvValue(project, column, matched)));
    });

    await exportProjectResearchPdf({
      userInfo,
      viewLabel: 'Project View',
      subject: '',
      columns: visibleColumns.map((column) => getMasterToolProjectColumnLabel(column)),
      rows,
      filterSummary: masterToolTableFilterSummaryParts,
      filename: `project-research-project-view-${Date.now()}.pdf`,
    });
  }, [
    getMasterToolProjectColumnLabel,
    getMasterToolProjectCsvValue,
    isMasterToolProjectColumnVisible,
    masterToolMatchedCountByProject,
    masterToolProjectColumnsForMenu,
    masterToolTableFilterSummaryParts,
    selectedMasterToolProjectRowsForExport,
    userInfo,
  ]);

  const handleExportMasterToolUnitPdf = useCallback(async () => {
    const visibleColumns = masterToolUnitColumnsForMenu.filter((column): column is MasterToolUnitColumnKey => isMasterToolUnitColumnVisible(column));
    const effectiveUnitFilters = getEffectiveMasterToolUnitFilters();
    const result = await api.searchUnits({
      filters: masterToolFilters,
      page: 1,
      pageSize: PDF_EXPORT_MAX_RECORDS_BY_VIEW.unit,
      sortBy: masterToolUnitSortConfig.column ?? undefined,
      sortDir: masterToolUnitSortConfig.direction === 'default' ? undefined : masterToolUnitSortConfig.direction,
      unitFilters: effectiveUnitFilters,
      unitRangeFilters: debouncedMasterToolUnitRangeFilters,
      loanToValue,
      tenureYears,
      interestRate,
    });

    await exportProjectResearchPdf({
      userInfo,
      viewLabel: 'Unit View',
      subject: '',
      columns: visibleColumns.map((column) => getMasterToolUnitColumnLabel(column)),
      rows: result.items.map((unit) => {
        const computedUnit = toMasterToolUnitWithComputed(unit);
        return visibleColumns.map((column) => String(getMasterToolUnitCsvValue(computedUnit, column)));
      }),
      filterSummary: masterToolTableFilterSummaryParts,
      filename: `project-research-unit-view-${Date.now()}.pdf`,
    });
  }, [
    debouncedMasterToolUnitRangeFilters,
    getEffectiveMasterToolUnitFilters,
    getMasterToolUnitColumnLabel,
    getMasterToolUnitCsvValue,
    interestRate,
    isMasterToolUnitColumnVisible,
    loanToValue,
    masterToolFilters,
    masterToolTableFilterSummaryParts,
    masterToolUnitColumnsForMenu,
    masterToolUnitSortConfig.column,
    masterToolUnitSortConfig.direction,
    tenureYears,
    toMasterToolUnitWithComputed,
    userInfo,
  ]);

  const handleExportMasterToolCsv = useCallback(async () => {
    const visibleColumnCount = masterToolViewMode === 'project'
      ? masterToolProjectColumnsForMenu.filter(isMasterToolProjectColumnVisible).length
      : masterToolUnitColumnsForMenu.filter((column): column is MasterToolUnitColumnKey => isMasterToolUnitColumnVisible(column)).length;
    logProjectResearchExport({
      format: 'csv',
      viewMode: masterToolViewMode,
      recordCount: getMasterToolPdfRecordCount(),
      visibleColumnCount,
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });
    if (masterToolViewMode === 'project') {
      try {
        handleExportMasterToolProjectCsv();
      } catch (error) {
        console.error('Master Tool CSV export failed:', error);
        alert('Failed to export CSV. Please try again.');
      }
      return;
    }
    setMasterToolLoading(true);
    try {
      await handleExportMasterToolUnitCsv();
    } catch (error) {
      console.error('Master Tool CSV export failed:', error);
      alert('Failed to export CSV. Please try again.');
    } finally {
      setMasterToolLoading(false);
    }
  }, [
    getMasterToolPdfRecordCount,
    handleExportMasterToolProjectCsv,
    handleExportMasterToolUnitCsv,
    isMasterToolProjectColumnVisible,
    isMasterToolUnitColumnVisible,
    masterToolProjectColumnsForMenu,
    masterToolUnitColumnsForMenu,
    masterToolViewMode,
    userInfo?.CEANumber,
  ]);

  const runMasterToolPdfExport = useCallback(async (mode: 'project' | 'unit') => {
    const visibleColumnCount = mode === 'project'
      ? masterToolProjectColumnsForMenu.filter(isMasterToolProjectColumnVisible).length
      : masterToolUnitColumnsForMenu.filter((column): column is MasterToolUnitColumnKey => isMasterToolUnitColumnVisible(column)).length;
    logProjectResearchExport({
      format: 'pdf',
      viewMode: mode,
      recordCount: mode === 'unit'
        ? Math.min(getMasterToolPdfRecordCount(), PDF_EXPORT_MAX_RECORDS_BY_VIEW.unit)
        : getMasterToolPdfRecordCount(),
      visibleColumnCount,
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });
    setMasterToolLoading(true);
    try {
      if (mode === 'project') {
        await handleExportMasterToolProjectPdf();
      } else {
        await handleExportMasterToolUnitPdf();
      }
    } catch (error) {
      console.error('Master Tool PDF export failed:', error);
      alert('Failed to export PDF. Please try again.');
    } finally {
      setMasterToolLoading(false);
    }
  }, [
    getMasterToolPdfRecordCount,
    handleExportMasterToolProjectPdf,
    handleExportMasterToolUnitPdf,
    isMasterToolProjectColumnVisible,
    isMasterToolUnitColumnVisible,
    masterToolProjectColumnsForMenu,
    masterToolUnitColumnsForMenu,
    userInfo?.CEANumber,
  ]);

  const continueMasterToolPdfExportAfterSizeChecks = useCallback(async () => {
    const exportMode: 'project' | 'unit' = masterToolViewMode;
    const visibleColumnCount = exportMode === 'project'
      ? masterToolProjectColumnsForMenu.filter(isMasterToolProjectColumnVisible).length
      : masterToolUnitColumnsForMenu.filter((column): column is MasterToolUnitColumnKey => isMasterToolUnitColumnVisible(column)).length;

    if (exportMode === 'project' || visibleColumnCount > 15) {
      setMasterToolPdfWarningColumnCount(visibleColumnCount);
      setMasterToolPendingPdfExportMode(exportMode);
      setMasterToolPdfWarningOpen(true);
      return;
    }
    await runMasterToolPdfExport(exportMode);
  }, [
    isMasterToolProjectColumnVisible,
    isMasterToolUnitColumnVisible,
    masterToolProjectColumnsForMenu,
    masterToolUnitColumnsForMenu,
    masterToolViewMode,
    runMasterToolPdfExport,
  ]);

  const handleConfirmLargePdfExport = useCallback(async () => {
    setMasterToolPdfExportLargeConfirmOpen(false);
    const recordCount = getMasterToolPdfRecordCount();

    if (recordCount > getMasterToolPdfMaxRecords()) {
      setMasterToolPdfExportOverMaxOpen(true);
      return;
    }
    if (recordCount <= PDF_EXPORT_LARGE_THRESHOLD) {
      await continueMasterToolPdfExportAfterSizeChecks();
      return;
    }

    const today = new Date().toISOString().slice(0, 10);
    try {
      if (localStorage.getItem(PDF_LARGE_EXPORT_DATE_STORAGE_KEY) === today) {
        setMasterToolPdfExportDailyUsedOpen(true);
        return;
      }
      localStorage.setItem(PDF_LARGE_EXPORT_DATE_STORAGE_KEY, today);
    } catch {
      /* still attempt export */
    }
    await continueMasterToolPdfExportAfterSizeChecks();
  }, [continueMasterToolPdfExportAfterSizeChecks, getMasterToolPdfMaxRecords, getMasterToolPdfRecordCount]);

  const handleExportMasterToolPdf = useCallback(async () => {
    const recordCount = getMasterToolPdfRecordCount();

    if (recordCount > getMasterToolPdfMaxRecords()) {
      setMasterToolPdfExportOverMaxOpen(true);
      return;
    }

    if (recordCount > PDF_EXPORT_LARGE_THRESHOLD) {
      const today = new Date().toISOString().slice(0, 10);
      try {
        if (localStorage.getItem(PDF_LARGE_EXPORT_DATE_STORAGE_KEY) === today) {
          setMasterToolPdfExportDailyUsedOpen(true);
          return;
        }
      } catch {
        /* ignore */
      }
      setMasterToolPdfExportLargeConfirmOpen(true);
      return;
    }

    await continueMasterToolPdfExportAfterSizeChecks();
  }, [continueMasterToolPdfExportAfterSizeChecks, getMasterToolPdfMaxRecords, getMasterToolPdfRecordCount]);

  const handleConfirmUnitPdfExportLimit = useCallback(async () => {
    setMasterToolPdfExportOverMaxOpen(false);
    await continueMasterToolPdfExportAfterSizeChecks();
  }, [continueMasterToolPdfExportAfterSizeChecks]);

  // Generate AI Summary Report
  const generateAISummary = () => {
    // Use comparableUnits which is what's actually displayed in the table
    if (!referenceUnit || comparableUnits.length === 0) return;

    // Use the exact same units as displayed in the table (comparableUnits)
    // This ensures the report matches exactly what the user sees
    const filteredUnits = comparableUnits;

    if (filteredUnits.length === 0) {
      alert('No comparable units found for analysis.');
      return;
    }


    const prices = filteredUnits.map(u => u.price).filter(p => p > 0);
    const psfValues = filteredUnits.map(u => u.psf).filter(p => p > 0);
    const outlays = filteredUnits.map(u => u.outlay).filter(o => o > 0);
    const installments = filteredUnits.map(u => u.installment).filter(i => i > 0);

    // Sort for median calculation
    const sortedPrices = [...prices].sort((a, b) => a - b);
    const sortedPSF = [...psfValues].sort((a, b) => a - b);
    const sortedOutlays = [...outlays].sort((a, b) => a - b);
    const sortedInstallments = [...installments].sort((a, b) => a - b);

    // Calculate statistics
    const refPrice = referenceUnit.price;
    const refPSF = referenceUnit.psf;
    const refOutlay = referenceUnit.outlay;
    const refInstallment = referenceUnit.installment;

    const minPrice = Math.min(...sortedPrices);
    const maxPrice = Math.max(...sortedPrices);
    const medianPrice = sortedPrices.length % 2 === 0
      ? (sortedPrices[sortedPrices.length / 2 - 1] + sortedPrices[sortedPrices.length / 2]) / 2
      : sortedPrices[Math.floor(sortedPrices.length / 2)];

    const minPSF = Math.min(...sortedPSF);
    const maxPSF = Math.max(...sortedPSF);
    const medianPSF = sortedPSF.length % 2 === 0
      ? (sortedPSF[sortedPSF.length / 2 - 1] + sortedPSF[sortedPSF.length / 2]) / 2
      : sortedPSF[Math.floor(sortedPSF.length / 2)];

    const minOutlay = Math.min(...sortedOutlays);
    const maxOutlay = Math.max(...sortedOutlays);
    const medianOutlay = sortedOutlays.length % 2 === 0
      ? (sortedOutlays[sortedOutlays.length / 2 - 1] + sortedOutlays[sortedOutlays.length / 2]) / 2
      : sortedOutlays[Math.floor(sortedOutlays.length / 2)];

    const minInstallment = Math.min(...sortedInstallments);
    const maxInstallment = Math.max(...sortedInstallments);
    const medianInstallment = sortedInstallments.length % 2 === 0
      ? (sortedInstallments[sortedInstallments.length / 2 - 1] + sortedInstallments[sortedInstallments.length / 2]) / 2
      : sortedInstallments[Math.floor(sortedInstallments.length / 2)];

    // Count comparisons (using filtered units)
    const moreExpensive = filteredUnits.filter(u => u.price > refPrice && u.price > 0).length;
    const lessExpensive = filteredUnits.filter(u => u.price < refPrice && u.price > 0).length;
    const samePrice = filteredUnits.filter(u => Math.abs(u.price - refPrice) < 100).length;

    // Price position analysis
    const pricePercentile = (sortedPrices.findIndex(p => p >= refPrice) / sortedPrices.length) * 100;
    const pricePosition = pricePercentile < 33 ? 'LOW' : pricePercentile < 67 ? 'MEDIAN' : 'HIGH';

    // Pros and Cons
    const pros: string[] = [];
    const cons: string[] = [];

    if (refPrice < medianPrice) {
      pros.push(`Price is ${formatCurrency(medianPrice - refPrice)} below the median, offering excellent value`);
    } else if (refPrice > medianPrice) {
      cons.push(`Price is ${formatCurrency(refPrice - medianPrice)} above the median market rate`);
    }

    if (refPSF < medianPSF) {
      pros.push(`Price per square foot (${formatCurrency(refPSF)}) is below median (${formatCurrency(medianPSF)}), indicating good value`);
    } else if (refPSF > medianPSF) {
      cons.push(`Price per square foot (${formatCurrency(refPSF)}) exceeds median (${formatCurrency(medianPSF)})`);
    }

    // Price comparison logic
    if (lessExpensive === 0 && moreExpensive > 0) {
      // Reference unit is the cheapest
      pros.push(`This is the cheapest option - ${moreExpensive} comparable units are more expensive`);
    } else if (moreExpensive === 0 && lessExpensive > 0) {
      // Reference unit is the most expensive
      cons.push(`This is the most expensive option - ${lessExpensive} comparable units are cheaper`);
    } else if (lessExpensive > moreExpensive && lessExpensive > 0) {
      pros.push(`More affordable than ${lessExpensive} comparable units (${moreExpensive} are more expensive)`);
    } else if (moreExpensive > lessExpensive && moreExpensive > 0) {
      cons.push(`More expensive than ${moreExpensive} comparable units (${lessExpensive} are cheaper)`);
    } else if (lessExpensive === moreExpensive && lessExpensive > 0) {
      pros.push(`Competitively priced - ${lessExpensive} units are cheaper and ${moreExpensive} units are more expensive`);
    }

    if (refOutlay < medianOutlay) {
      pros.push(`Lower total outlay (${formatCurrency(refOutlay)}) compared to median (${formatCurrency(medianOutlay)})`);
    }

    if (refInstallment < medianInstallment) {
      pros.push(`More affordable monthly installment (${formatCurrency(refInstallment)}) vs median (${formatCurrency(medianInstallment)})`);
    }

    const cheapestUnit = filteredUnits.find(u => u.price === minPrice);
    if (cheapestUnit && refPrice !== minPrice) {
      cons.push(`Not the cheapest option - ${cheapestUnit.unitNumber} is ${formatCurrency(minPrice - refPrice)} cheaper`);
    }

    if (pros.length === 0) {
      pros.push('Competitive pricing within the market range');
    }
    if (cons.length === 0) {
      cons.push('No significant concerns identified');
    }

    // Find thumbs up units: Lower price AND lower PSF, with higher floor
    const thumbsUpUnits = filteredUnits
      .filter(unit => {
        if (!referenceUnit) return false;
        
        const unitParsed = parseUnitNumber(unit.unitNumber);
        const refParsed = parseUnitNumber(referenceUnit.unitNumber);
        
        // Must have lower price AND lower PSF
        const hasLowerPrice = unit.price > 0 && unit.price < referenceUnit.price;
        const hasLowerPSF = unit.psf > 0 && unit.psf < referenceUnit.psf;
        
        // Must have higher floor
        const hasHigherFloor = unitParsed.floor !== null && 
                              refParsed.floor !== null && 
                              unitParsed.floor > refParsed.floor;
        
        return hasLowerPrice && hasLowerPSF && hasHigherFloor;
      })
      .map(unit => {
        const unitParsed = parseUnitNumber(unit.unitNumber);
        const refParsed = parseUnitNumber(referenceUnit.unitNumber);
        const reasons: string[] = [];
        
        if (unitParsed.floor !== null && refParsed.floor !== null) {
          reasons.push(`Higher floor (${unitParsed.floor} vs ${refParsed.floor})`);
        }
        reasons.push(`Lower price (${formatCurrency(unit.price)} vs ${formatCurrency(referenceUnit.price)})`);
        reasons.push(`Lower PSF (${formatCurrency(unit.psf)} vs ${formatCurrency(referenceUnit.psf)})`);
        
        return {
          unit,
          reasons,
          priceSavings: referenceUnit.price - unit.price,
          psfSavings: referenceUnit.psf - unit.psf,
        };
      });

    // Generate report
    const report = `# Expert Market Analysis Report
## Reference Unit: ${referenceUnit.projectName} ${referenceUnit.unitNumber}

---

## Executive Summary

This comprehensive analysis evaluates the reference unit against ${filteredUnits.length} comparable ${referenceUnit.bedroom}-bedroom units within the same project (${referenceUnit.projectName}), excluding sold units. The unit is positioned in the **${pricePosition}** price range relative to comparable properties.

---

## Price Analysis

### Market Position
- **Reference Unit Price:** ${formatCurrency(refPrice)}
- **Market Range:** ${formatCurrency(minPrice)} - ${formatCurrency(maxPrice)}
- **Median Price:** ${formatCurrency(medianPrice)}
- **Price Position:** ${pricePercentile.toFixed(1)}th percentile (${pricePosition} tier)

### Competitive Comparison
- **More Expensive Units:** ${moreExpensive} units (${((moreExpensive / filteredUnits.length) * 100).toFixed(1)}%)
- **Less Expensive Units:** ${lessExpensive} units (${((lessExpensive / filteredUnits.length) * 100).toFixed(1)}%)
- **Similar Price Range:** ${samePrice} units

### Price Per Square Foot Analysis
- **Reference Unit PSF:** ${formatCurrency(refPSF)}
- **Market Range:** ${formatCurrency(minPSF)} - ${formatCurrency(maxPSF)}
- **Median PSF:** ${formatCurrency(medianPSF)}
- **PSF Position:** ${refPSF < medianPSF ? 'Below' : refPSF > medianPSF ? 'Above' : 'At'} median

---

## Financial Analysis

### Total Outlay Comparison
- **Reference Unit:** ${formatCurrency(refOutlay)}
- **Market Range:** ${formatCurrency(minOutlay)} - ${formatCurrency(maxOutlay)}
- **Median Outlay:** ${formatCurrency(medianOutlay)}
- **Difference from Median:** ${refOutlay < medianOutlay ? formatCurrency(medianOutlay - refOutlay) + ' lower' : refOutlay > medianOutlay ? formatCurrency(refOutlay - medianOutlay) + ' higher' : 'At median'}

### Monthly Installment Analysis
- **Reference Unit:** ${formatCurrency(refInstallment)}
- **Market Range:** ${formatCurrency(minInstallment)} - ${formatCurrency(maxInstallment)}
- **Median Installment:** ${formatCurrency(medianInstallment)}
- **Affordability:** ${refInstallment < medianInstallment ? 'More affordable' : refInstallment > medianInstallment ? 'Higher than average' : 'At market rate'}

---

## Strengths (Pros)

${pros.map((pro, idx) => `${idx + 1}. ${pro}`).join('\n')}

---

## Considerations (Cons)

${cons.map((con, idx) => `${idx + 1}. ${con}`).join('\n')}

---

## 👍 Thumbs Up Units (Better Deals)

${thumbsUpUnits.length > 0 ? 
  `The following ${thumbsUpUnits.length} unit(s) offer better value compared to the reference unit (${referenceUnit.projectName} ${referenceUnit.unitNumber}):\n\n` +
  `**Reference Unit Details:**\n` +
  `- Unit: ${referenceUnit.unitNumber}\n` +
  `- Floor: ${parseUnitNumber(referenceUnit.unitNumber).floor !== null ? parseUnitNumber(referenceUnit.unitNumber).floor : 'N/A'}\n` +
  `- Size: ${formatNumber(referenceUnit.areaSqft)} sqft\n` +
  `- Price: ${formatCurrency(refPrice)}\n` +
  `- PSF: ${formatCurrency(refPSF)}\n\n` +
  thumbsUpUnits.map((item, idx) => {
    const unitParsed = parseUnitNumber(item.unit.unitNumber);
    return `${idx + 1}. **${item.unit.projectName} ${item.unit.unitNumber}**\n` +
      `   - Floor: ${unitParsed.floor !== null ? unitParsed.floor : 'N/A'}\n` +
      `   - Size: ${formatNumber(item.unit.areaSqft)} sqft\n` +
      `   - Price: ${formatCurrency(item.unit.price)} (${formatCurrency(item.priceSavings)} less than reference)\n` +
      `   - PSF: ${formatCurrency(item.unit.psf)} (${formatCurrency(item.psfSavings)} less than reference)\n` +
      `   - Why it's better: ${item.reasons.join(', ')}`;
  }).join('\n\n')
  : 
  `No units found that offer better value than the reference unit based on the criteria:\n` +
  `- Lower PSF AND lower price than reference\n` +
  `- Higher floor than reference\n\n` +
  `**Reference Unit Details:**\n` +
  `- Unit: ${referenceUnit.unitNumber}\n` +
  `- Floor: ${parseUnitNumber(referenceUnit.unitNumber).floor !== null ? parseUnitNumber(referenceUnit.unitNumber).floor : 'N/A'}\n` +
  `- Size: ${formatNumber(referenceUnit.areaSqft)} sqft\n` +
  `- Price: ${formatCurrency(refPrice)}\n` +
  `- PSF: ${formatCurrency(refPSF)}`
}

---

## Reference Unit & Thumbs Up Units Comparison Table

| Project | Floor | Stack | Bedroom | Bathroom | Area (sqft) | Price | PSF | Outlay | Installment |
|---------|-------|-------|---------|----------|-------------|-------|-----|--------|-------------|
| **${referenceUnit.projectName}** (Reference) | ${parseUnitNumber(referenceUnit.unitNumber).floor !== null ? parseUnitNumber(referenceUnit.unitNumber).floor : '-'} | ${parseUnitNumber(referenceUnit.unitNumber).stack !== null ? parseUnitNumber(referenceUnit.unitNumber).stack : '-'} | ${referenceUnit.bedroom} | ${referenceUnit.bathroom} | ${formatNumber(referenceUnit.areaSqft)} | ${formatCurrency(refPrice)} | ${formatCurrency(refPSF)} | ${formatCurrency(refOutlay)} | ${formatCurrency(refInstallment)} |
${thumbsUpUnits.length > 0 ? thumbsUpUnits.map((item) => {
  const unitParsed = parseUnitNumber(item.unit.unitNumber);
  return `| **${item.unit.projectName}** 👍 | ${unitParsed.floor !== null ? unitParsed.floor : '-'} | ${unitParsed.stack !== null ? unitParsed.stack : '-'} | ${item.unit.bedroom} | ${item.unit.bathroom} | ${formatNumber(item.unit.areaSqft)} | ${formatCurrency(item.unit.price)} | ${formatCurrency(item.unit.psf)} | ${formatCurrency(item.unit.outlay)} | ${formatCurrency(item.unit.installment)} |`;
}).join('\n') : '| *No thumbs up units found* | - | - | - | - | - | - | - | - | - |'}

---

## Expert Recommendations

${refPrice <= medianPrice ? 
  '✅ **STRONG VALUE PROPOSITION** - This unit offers competitive pricing relative to the market. The below-median price point presents an attractive opportunity for value-conscious buyers.' : 
  refPrice > medianPrice && lessExpensive > 0 ?
  '⚠️ **PREMIUM PRICING** - While priced above the median, this unit may offer superior location, views, or other premium features. Consider negotiating or comparing specific unit attributes.' :
  '📊 **MARKET ALIGNED** - Pricing is consistent with market expectations. Evaluate based on specific preferences and unit characteristics.'}

### Key Insights:
- ${refPrice < medianPrice ? 'Excellent value proposition with below-median pricing' : refPrice > medianPrice ? 'Premium pricing - verify value-add features justify the cost' : 'Competitively priced at market rate'}
- ${refPSF < medianPSF ? 'Attractive price per square foot ratio' : refPSF > medianPSF ? 'Higher PSF - assess unit quality and features' : 'PSF aligned with market standards'}
- ${lessExpensive > moreExpensive ? 'Competitive advantage: More affordable than majority of comparables' : moreExpensive > lessExpensive ? 'Consider exploring lower-priced alternatives' : 'Balanced market position'}

---

## Market Statistics Summary

| Metric | Low | Median | High | Reference Unit |
|--------|-----|--------|------|----------------|
| **Price** | ${formatCurrency(minPrice)} | ${formatCurrency(medianPrice)} | ${formatCurrency(maxPrice)} | ${formatCurrency(refPrice)} |
| **PSF** | ${formatCurrency(minPSF)} | ${formatCurrency(medianPSF)} | ${formatCurrency(maxPSF)} | ${formatCurrency(refPSF)} |
| **Outlay** | ${formatCurrency(minOutlay)} | ${formatCurrency(medianOutlay)} | ${formatCurrency(maxOutlay)} | ${formatCurrency(refOutlay)} |
| **Installment** | ${formatCurrency(minInstallment)} | ${formatCurrency(medianInstallment)} | ${formatCurrency(maxInstallment)} | ${formatCurrency(refInstallment)} |

---

---

## Disclaimer

*This is just an AI generated view, and does not represent a professional advisor view. Please consult your advisor accordingly.*

---

## LLM Information

*This report was generated using: ${selectedLLMs.map(llm => llm === 'LLM' ? 'LLM (Default)' : llm).join(', ')}*

---

*Report generated on ${new Date().toLocaleDateString('en-SG', { year: 'numeric', month: 'long', day: 'numeric' })}*
*Analysis based on ${filteredUnits.length} comparable units within the same project (excluding sold units)*`;

    // Prepare data for visualizations
    // Normalize values for radar chart (0-100 scale)
    const normalizeValue = (value: number, min: number, max: number) => {
      if (max === min) return 50;
      return ((value - min) / (max - min)) * 100;
    };

    const radarData = [
      {
        metric: 'Price',
        reference: normalizeValue(refPrice, minPrice, maxPrice),
        median: normalizeValue(medianPrice, minPrice, maxPrice),
        full: 100,
      },
      {
        metric: 'PSF',
        reference: normalizeValue(refPSF, minPSF, maxPSF),
        median: normalizeValue(medianPSF, minPSF, maxPSF),
        full: 100,
      },
      {
        metric: 'Outlay',
        reference: normalizeValue(refOutlay, minOutlay, maxOutlay),
        median: normalizeValue(medianOutlay, minOutlay, maxOutlay),
        full: 100,
      },
      {
        metric: 'Installment',
        reference: normalizeValue(refInstallment, minInstallment, maxInstallment),
        median: normalizeValue(medianInstallment, minInstallment, maxInstallment),
        full: 100,
      },
    ];

    const barData = [
      {
        name: 'Price',
        Low: minPrice,
        Median: medianPrice,
        High: maxPrice,
        Reference: refPrice,
      },
      {
        name: 'PSF',
        Low: minPSF,
        Median: medianPSF,
        High: maxPSF,
        Reference: refPSF,
      },
      {
        name: 'Outlay',
        Low: minOutlay,
        Median: medianOutlay,
        High: maxOutlay,
        Reference: refOutlay,
      },
      {
        name: 'Installment',
        Low: minInstallment,
        Median: medianInstallment,
        High: maxInstallment,
        Reference: refInstallment,
      },
    ];

    const comparisonData = [
      { name: 'More Expensive', value: moreExpensive, color: 'var(--color-danger)' },
      { name: 'Less Expensive', value: lessExpensive, color: 'var(--color-success)' },
      { name: 'Similar Price', value: samePrice, color: 'var(--color-info)' },
    ];

    setAiSummaryReport(report);
    setAiSummaryData({
      stats: {
        refPrice,
        refPSF,
        refOutlay,
        refInstallment,
        minPrice,
        maxPrice,
        medianPrice,
        minPSF,
        maxPSF,
        medianPSF,
        minOutlay,
        maxOutlay,
        medianOutlay,
        minInstallment,
        maxInstallment,
        medianInstallment,
        moreExpensive,
        lessExpensive,
        samePrice,
        pricePercentile,
        pricePosition,
        pros,
        cons,
        referenceUnit,
        totalComparables: filteredUnits.length,
        filteredUnits,
        selectedLLMs,
        thumbsUpUnits, // Add thumbs up units to the data
      },
      radarData,
      barData,
      comparisonData,
    });
    setAiSummaryOpen(true);
  };

  const handleCloseAISummary = () => {
    setAiSummaryOpen(false);
    setAiSummaryReport(null);
    setAiSummaryData(null);
  };

  const generateTopViewingAISummary = () => {
    if (!topViewingReferenceUnit || topViewingComparableUnits.length === 0) return;

    const refUnit = topViewingReferenceUnit;
    const filteredUnits = topViewingComparableUnits;

    if (filteredUnits.length === 0) {
      alert('No comparable units found for analysis.');
      return;
    }

    const refPrice = refUnit.price;
    const refPSF = refUnit.psf;
    const refOutlay = 'outlay' in refUnit && typeof (refUnit as any).outlay === 'number' ? (refUnit as any).outlay : calculateOutlay(refUnit.price, loanToValue / 100);
    const refInstallment = 'installment' in refUnit && typeof (refUnit as any).installment === 'number' ? (refUnit as any).installment : calculateInstallment(refUnit.price, loanToValue / 100, tenureYears, interestRate / 100);

    const prices = filteredUnits.map(u => u.price).filter(p => p > 0);
    const psfValues = filteredUnits.map(u => u.psf).filter(p => p > 0);
    const outlays = filteredUnits.map(u => u.outlay).filter(o => o > 0);
    const installments = filteredUnits.map(u => u.installment).filter(i => i > 0);

    const sortedPrices = [...prices].sort((a, b) => a - b);
    const sortedPSF = [...psfValues].sort((a, b) => a - b);
    const sortedOutlays = [...outlays].sort((a, b) => a - b);
    const sortedInstallments = [...installments].sort((a, b) => a - b);

    const minPrice = Math.min(...sortedPrices);
    const maxPrice = Math.max(...sortedPrices);
    const medianPrice = sortedPrices.length % 2 === 0
      ? (sortedPrices[sortedPrices.length / 2 - 1] + sortedPrices[sortedPrices.length / 2]) / 2
      : sortedPrices[Math.floor(sortedPrices.length / 2)];

    const minPSF = Math.min(...sortedPSF);
    const maxPSF = Math.max(...sortedPSF);
    const medianPSF = sortedPSF.length % 2 === 0
      ? (sortedPSF[sortedPSF.length / 2 - 1] + sortedPSF[sortedPSF.length / 2]) / 2
      : sortedPSF[Math.floor(sortedPSF.length / 2)];

    const minOutlay = Math.min(...sortedOutlays);
    const maxOutlay = Math.max(...sortedOutlays);
    const medianOutlay = sortedOutlays.length % 2 === 0
      ? (sortedOutlays[sortedOutlays.length / 2 - 1] + sortedOutlays[sortedOutlays.length / 2]) / 2
      : sortedOutlays[Math.floor(sortedOutlays.length / 2)];

    const minInstallment = Math.min(...sortedInstallments);
    const maxInstallment = Math.max(...sortedInstallments);
    const medianInstallment = sortedInstallments.length % 2 === 0
      ? (sortedInstallments[sortedInstallments.length / 2 - 1] + sortedInstallments[sortedInstallments.length / 2]) / 2
      : sortedInstallments[Math.floor(sortedInstallments.length / 2)];

    const moreExpensive = filteredUnits.filter(u => u.price > refPrice && u.price > 0).length;
    const lessExpensive = filteredUnits.filter(u => u.price < refPrice && u.price > 0).length;
    const samePrice = filteredUnits.filter(u => Math.abs(u.price - refPrice) < 100).length;

    const pricePercentile = (sortedPrices.findIndex(p => p >= refPrice) / sortedPrices.length) * 100;
    const pricePosition = pricePercentile < 33 ? 'LOW' : pricePercentile < 67 ? 'MEDIAN' : 'HIGH';

    const pros: string[] = [];
    const cons: string[] = [];

    if (refPrice < medianPrice) {
      pros.push(`Price is ${formatCurrency(medianPrice - refPrice)} below the median, offering excellent value`);
    } else if (refPrice > medianPrice) {
      cons.push(`Price is ${formatCurrency(refPrice - medianPrice)} above the median market rate`);
    }

    if (refPSF < medianPSF) {
      pros.push(`Price per square foot (${formatCurrency(refPSF)}) is below median (${formatCurrency(medianPSF)}), indicating good value`);
    } else if (refPSF > medianPSF) {
      cons.push(`Price per square foot (${formatCurrency(refPSF)}) exceeds median (${formatCurrency(medianPSF)})`);
    }

    if (lessExpensive === 0 && moreExpensive > 0) {
      pros.push(`This is the cheapest option - ${moreExpensive} comparable units are more expensive`);
    } else if (moreExpensive === 0 && lessExpensive > 0) {
      cons.push(`This is the most expensive option - ${lessExpensive} comparable units are cheaper`);
    } else if (lessExpensive > moreExpensive) {
      pros.push(`More affordable than ${lessExpensive} comparable units (${moreExpensive} are more expensive)`);
    } else if (moreExpensive > lessExpensive) {
      cons.push(`More expensive than ${moreExpensive} comparable units (${lessExpensive} are cheaper)`);
    } else if (lessExpensive === moreExpensive && lessExpensive > 0) {
      pros.push(`Competitively priced - ${lessExpensive} units are cheaper and ${moreExpensive} units are more expensive`);
    }

    if (refOutlay < medianOutlay) pros.push(`Lower total outlay (${formatCurrency(refOutlay)}) compared to median (${formatCurrency(medianOutlay)})`);
    if (refInstallment < medianInstallment) pros.push(`More affordable monthly installment (${formatCurrency(refInstallment)}) vs median (${formatCurrency(medianInstallment)})`);

    const cheapestUnit = filteredUnits.find(u => u.price === minPrice);
    if (cheapestUnit && refPrice !== minPrice) {
      cons.push(`Not the cheapest option - ${cheapestUnit.unitNumber} is ${formatCurrency(minPrice - refPrice)} cheaper`);
    }

    if (pros.length === 0) pros.push('Competitive pricing within the market range');
    if (cons.length === 0) cons.push('No significant concerns identified');

    const thumbsUpUnits = filteredUnits
      .filter(unit => {
        const unitParsed = parseUnitNumber(unit.unitNumber);
        const refParsed = parseUnitNumber(refUnit.unitNumber);
        return unit.price > 0 && unit.price < refPrice &&
               unit.psf > 0 && unit.psf < refPSF &&
               unitParsed.floor !== null && refParsed.floor !== null && unitParsed.floor > refParsed.floor;
      })
      .map(unit => {
        const unitParsed = parseUnitNumber(unit.unitNumber);
        const refParsed = parseUnitNumber(refUnit.unitNumber);
        const reasons: string[] = [];
        if (unitParsed.floor !== null && refParsed.floor !== null) reasons.push(`Higher floor (${unitParsed.floor} vs ${refParsed.floor})`);
        reasons.push(`Lower price (${formatCurrency(unit.price)} vs ${formatCurrency(refPrice)})`);
        reasons.push(`Lower PSF (${formatCurrency(unit.psf)} vs ${formatCurrency(refPSF)})`);
        return { unit, reasons, priceSavings: refPrice - unit.price, psfSavings: refPSF - unit.psf };
      });

    const report = `# Expert Market Analysis Report
## Reference Unit: ${refUnit.projectName} ${refUnit.unitNumber}

---

## Executive Summary

This comprehensive analysis evaluates the reference unit against ${filteredUnits.length} comparable ${refUnit.bedroom}-bedroom units. The unit is positioned in the **${pricePosition}** price range relative to comparable properties.

---

## Price Analysis

### Market Position
- **Reference Unit Price:** ${formatCurrency(refPrice)}
- **Market Range:** ${formatCurrency(minPrice)} - ${formatCurrency(maxPrice)}
- **Median Price:** ${formatCurrency(medianPrice)}
- **Price Position:** ${pricePercentile.toFixed(1)}th percentile (${pricePosition} tier)

### Competitive Comparison
- **More Expensive Units:** ${moreExpensive} units (${((moreExpensive / filteredUnits.length) * 100).toFixed(1)}%)
- **Less Expensive Units:** ${lessExpensive} units (${((lessExpensive / filteredUnits.length) * 100).toFixed(1)}%)
- **Similar Price Range:** ${samePrice} units

### Price Per Square Foot Analysis
- **Reference Unit PSF:** ${formatCurrency(refPSF)}
- **Market Range:** ${formatCurrency(minPSF)} - ${formatCurrency(maxPSF)}
- **Median PSF:** ${formatCurrency(medianPSF)}
- **PSF Position:** ${refPSF < medianPSF ? 'Below' : refPSF > medianPSF ? 'Above' : 'At'} median

---

## Financial Analysis

### Total Outlay Comparison
- **Reference Unit:** ${formatCurrency(refOutlay)}
- **Market Range:** ${formatCurrency(minOutlay)} - ${formatCurrency(maxOutlay)}
- **Median Outlay:** ${formatCurrency(medianOutlay)}

### Monthly Installment Analysis
- **Reference Unit:** ${formatCurrency(refInstallment)}
- **Market Range:** ${formatCurrency(minInstallment)} - ${formatCurrency(maxInstallment)}
- **Median Installment:** ${formatCurrency(medianInstallment)}

---

## Strengths (Pros)

${pros.map((pro, idx) => `${idx + 1}. ${pro}`).join('\n')}

---

## Considerations (Cons)

${cons.map((con, idx) => `${idx + 1}. ${con}`).join('\n')}

---

## 👍 Thumbs Up Units (Better Deals)

${thumbsUpUnits.length > 0 ?
  `The following ${thumbsUpUnits.length} unit(s) offer better value:\n\n` +
  thumbsUpUnits.map((item, idx) => {
    const unitParsed = parseUnitNumber(item.unit.unitNumber);
    return `${idx + 1}. **${item.unit.projectName} ${item.unit.unitNumber}**\n` +
      `   - Floor: ${unitParsed.floor ?? 'N/A'}\n` +
      `   - Price: ${formatCurrency(item.unit.price)} (${formatCurrency(item.priceSavings)} less)\n` +
      `   - PSF: ${formatCurrency(item.unit.psf)} (${formatCurrency(item.psfSavings)} less)\n` +
      `   - Why it's better: ${item.reasons.join(', ')}`;
  }).join('\n\n')
  : 'No units found that offer better value based on the criteria.'}

---

## Expert Recommendations

${refPrice <= medianPrice ?
  '✅ **STRONG VALUE PROPOSITION** - This unit offers competitive pricing relative to the market.' :
  '⚠️ **PREMIUM PRICING** - Priced above the median. Consider negotiating or comparing specific unit attributes.'}

---

## Disclaimer

*This is just an AI generated view, and does not represent a professional advisor view. Please consult your advisor accordingly.*

---

*Report generated on ${new Date().toLocaleDateString('en-SG', { year: 'numeric', month: 'long', day: 'numeric' })}*
*Analysis based on ${filteredUnits.length} comparable units*`;

    const normalizeValue = (value: number, min: number, max: number) => {
      if (max === min) return 50;
      return ((value - min) / (max - min)) * 100;
    };

    const radarData = [
      { metric: 'Price', reference: normalizeValue(refPrice, minPrice, maxPrice), median: normalizeValue(medianPrice, minPrice, maxPrice), full: 100 },
      { metric: 'PSF', reference: normalizeValue(refPSF, minPSF, maxPSF), median: normalizeValue(medianPSF, minPSF, maxPSF), full: 100 },
      { metric: 'Outlay', reference: normalizeValue(refOutlay, minOutlay, maxOutlay), median: normalizeValue(medianOutlay, minOutlay, maxOutlay), full: 100 },
      { metric: 'Installment', reference: normalizeValue(refInstallment, minInstallment, maxInstallment), median: normalizeValue(medianInstallment, minInstallment, maxInstallment), full: 100 },
    ];

    const barData = [
      { name: 'Price', Low: minPrice, Median: medianPrice, High: maxPrice, Reference: refPrice },
      { name: 'PSF', Low: minPSF, Median: medianPSF, High: maxPSF, Reference: refPSF },
      { name: 'Outlay', Low: minOutlay, Median: medianOutlay, High: maxOutlay, Reference: refOutlay },
      { name: 'Installment', Low: minInstallment, Median: medianInstallment, High: maxInstallment, Reference: refInstallment },
    ];

    const comparisonData = [
      { name: 'More Expensive', value: moreExpensive, color: 'var(--color-danger)' },
      { name: 'Less Expensive', value: lessExpensive, color: 'var(--color-success)' },
      { name: 'Similar Price', value: samePrice, color: 'var(--color-info)' },
    ];

    setAiSummaryReport(report);
    setAiSummaryData({
      stats: {
        refPrice, refPSF, refOutlay, refInstallment,
        minPrice, maxPrice, medianPrice,
        minPSF, maxPSF, medianPSF,
        minOutlay, maxOutlay, medianOutlay,
        minInstallment, maxInstallment, medianInstallment,
        moreExpensive, lessExpensive, samePrice,
        pricePercentile, pricePosition,
        pros, cons,
        referenceUnit: refUnit,
        totalComparables: filteredUnits.length,
        filteredUnits,
        selectedLLMs,
        thumbsUpUnits,
      },
      radarData,
      barData,
      comparisonData,
    });
    setAiSummaryOpen(true);
  };

  // Handle LLM selection
  const handleLLMChange = (llm: string) => {
    setSelectedLLMs((prev) => {
      if (prev.includes(llm)) {
        // If unchecking, ensure at least one LLM is selected
        const newSelection = prev.filter((l) => l !== llm);
        return newSelection.length > 0 ? newSelection : ['LLM'];
      } else {
        return [...prev, llm];
      }
    });
  };

  // Derive bedroom filter from project research search: min=3 -> >=3 BR, max=3 -> <=3 BR
  const derivedMasterToolBedroomFilter = useMemo((): number[] => {
    if (masterToolFilters.phOnly) return [PENTHOUSE_FILTER_VALUE];
    const min = masterToolFilters.bedroomMin ? parseInt(String(masterToolFilters.bedroomMin), 10) : NaN;
    const max = masterToolFilters.bedroomMax ? parseInt(String(masterToolFilters.bedroomMax), 10) : NaN;
    if (Number.isFinite(min) && Number.isFinite(max)) {
      const bedrooms: number[] = [];
      for (let b = Math.min(min, max); b <= Math.max(min, max); b++) bedrooms.push(b);
      return bedrooms;
    }
    if (Number.isFinite(min)) {
      // min only: >= min bedrooms (e.g. min=3 -> [3,4,5,...,10])
      const MAX_BEDROOM = 10;
      const bedrooms: number[] = [];
      for (let b = min; b <= MAX_BEDROOM; b++) bedrooms.push(b);
      return bedrooms;
    }
    if (Number.isFinite(max)) {
      // max only: <= max bedrooms (e.g. max=3 -> [1,2,3])
      const bedrooms: number[] = [];
      for (let b = 1; b <= max; b++) bedrooms.push(b);
      return bedrooms;
    }
    return [];
  }, [masterToolFilters.bedroomMin, masterToolFilters.bedroomMax, masterToolFilters.phOnly, PENTHOUSE_FILTER_VALUE]);

  // Handle tower view open
  const handleOpenTowerView = useCallback(async (unit: ComparableUnit | ReferenceUnit) => {
    logTowerViewOpened({
      projectName: unit.projectName || referenceUnit?.projectName,
      unitNumber: unit.unitNumber,
      unitId: (unit as ComparableUnit)?.id,
      source: isProjectResearchContext ? 'project_research' : activeTabId === TOP_VIEWING_SITE_PLANS_TAB ? 'top_viewing' : 'find_comparable',
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });

    const requestId = ++towerViewOpenRequestRef.current;
    // Use isolated popup (with siteplan) when opening from Top View Site Plans OR Project Research
    const shouldIsolatePopup = activeTabId === TOP_VIEWING_SITE_PLANS_TAB || isProjectResearchContext;
    const initialBedroomFilter = shouldIsolatePopup && isProjectResearchContext ? derivedMasterToolBedroomFilter : [];

    setSelectedUnitForTowerView(unit);
    setTowerViewOpen(true);
    setTowerViewOpenedFromSitePlan(false); // Reset flag when opening from other places
    setTowerViewIsolatedFromMain(shouldIsolatePopup);
    towerViewFloorPlanOpenRequestRef.current += 1;
    setTowerViewFloorPlanRefreshing(false);
    setTowerViewFloorPlanOpen(false);
    setSelectedTowerViewUnitForFloorPlan(null);
    setTowerViewBedroomFilter(initialBedroomFilter);
    setTowerViewUnitTypeFilter([]);
    setSelectedBlock(TOWER_VIEW_ALL_TAB);
    if (shouldIsolatePopup) {
      setTowerViewDialogSitePlanData(null);
    }
    // Navigate to the unit's block if available, otherwise show all blocks
    const projectName = unit.projectName || referenceUnit?.projectName;
    if (projectName) {
      try {
        setTowerViewUnitsLoading(true);
        const { units: allUnits, unitTypes, projectId: resolvedProjectId, showPsfInTowerView, showPriceInTowerView } = await fetchTowerViewUnits(projectName);
        if (requestId !== towerViewOpenRequestRef.current) return;

        // Set default Show PSF / Show price checkboxes based on project settings (on by default; off when turned off for project)
        setTowerViewAllDisplayOptions(TOWER_VIEW_DISPLAY_OPTIONS.filter((o) =>
          (o !== 'psf' || showPsfInTowerView !== false) && (o !== 'price' || showPriceInTowerView !== false)));

        if (shouldIsolatePopup) {
          setTowerViewDialogUnits(allUnits);
          setTowerViewDialogUnitTypes(unitTypes);
          // Trim initial bedroom filter to project's actual options (e.g. min 3BR + max 4BR project -> show 3BR, 4BR only)
          if (initialBedroomFilter.length > 0 && allUnits.length > 0) {
            const bedroomSet = new Set<number>();
            let hasPenthouse = false;
            allUnits.forEach((u: { bedroom?: unknown; unitTypeDescription?: string | null; unitType?: string | null }) => {
              const unitIsPenthouse = isPenthouseUnit(u as { unitTypeDescription?: string | null; unitType?: string | null });
              if (unitIsPenthouse) {
                hasPenthouse = true;
                return;
              }
              const bedroom = normalizeBedroomValue(u.bedroom);
              if (bedroom != null && bedroom > 0) bedroomSet.add(bedroom);
            });
            const projectOptions = [...Array.from(bedroomSet).sort((a, b) => a - b), ...(hasPenthouse ? [PENTHOUSE_FILTER_VALUE] : [])];
            const trimmed = initialBedroomFilter.filter((b) => projectOptions.includes(b));
            if (trimmed.length > 0) setTowerViewBedroomFilter(trimmed);
          }
          try {
            const { sitePlan } = await fetchSitePlan(projectName, resolvedProjectId);
            if (requestId !== towerViewOpenRequestRef.current) return;
            setTowerViewDialogSitePlanData(sitePlan);
          } catch (err) {
            if (requestId !== towerViewOpenRequestRef.current) return;
            console.error('Failed to fetch popup tower-view site plan:', err);
            setTowerViewDialogSitePlanData(null);
          }
        } else {
          setTowerViewUnits(allUnits);
          setTowerViewUnitTypes(unitTypes);
        }
      } catch (err) {
        console.error('Failed to fetch tower view units:', err);
        if (requestId !== towerViewOpenRequestRef.current) return;
        if (shouldIsolatePopup) {
          setTowerViewDialogUnits([]);
          setTowerViewDialogUnitTypes([]);
          setTowerViewDialogSitePlanData(null);
        } else {
          setTowerViewUnits([]);
        }
      } finally {
        if (requestId === towerViewOpenRequestRef.current) {
          setTowerViewUnitsLoading(false);
        }
      }
    }
  }, [activeTabId, isProjectResearchContext, derivedMasterToolBedroomFilter, fetchSitePlan, fetchTowerViewUnits, referenceUnit, userInfo?.CEANumber, normalizeBedroomValue, isPenthouseUnit, PENTHOUSE_FILTER_VALUE]);

  const refreshFloorPlanUnit = useCallback(async (
    unit: ComparableUnit | ReferenceUnit | TowerViewUnit,
  ): Promise<ComparableUnit | ReferenceUnit | TowerViewUnit> => {
    if (!unit?.id) {
      return unit;
    }

    try {
      const latestUnit = await api.getFloorPlanUnitDetails(unit.id);
      return { ...unit, ...latestUnit } as ComparableUnit | ReferenceUnit | TowerViewUnit;
    } catch (err) {
      console.error('Failed to refresh floor plan unit details:', err);
      return unit;
    }
  }, []);

  const handleOpenTowerViewFloorPlan = useCallback(async (unit: TowerViewUnit | ComparableUnit) => {
    logFloorPlanOpened({
      projectName: unit.projectName,
      unitNumber: unit.unitNumber,
      unitId: unit.id,
      source: 'tower_view',
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });

    const requestId = ++towerViewFloorPlanOpenRequestRef.current;
    setSelectedTowerViewUnitForFloorPlan(unit);
    setTowerViewFloorPlanRefreshing(true);
    setTowerViewFloorPlanOpen(true);

    const latestUnit = await refreshFloorPlanUnit(unit);
    if (requestId !== towerViewFloorPlanOpenRequestRef.current) {
      return;
    }

    setSelectedTowerViewUnitForFloorPlan(latestUnit as TowerViewUnit | ComparableUnit);
    setTowerViewFloorPlanRefreshing(false);
  }, [refreshFloorPlanUnit, userInfo?.CEANumber]);

  const handleCloseTowerViewFloorPlan = useCallback(() => {
    towerViewFloorPlanOpenRequestRef.current += 1;
    setTowerViewFloorPlanRefreshing(false);
    setTowerViewFloorPlanOpen(false);
    setSelectedTowerViewUnitForFloorPlan(null);
  }, []);

  const handleOpenFloorPlan = useCallback(async (unit: ComparableUnit | ReferenceUnit) => {
    logFloorPlanOpened({
      projectName: unit.projectName,
      unitNumber: unit.unitNumber,
      unitId: (unit as ComparableUnit)?.id,
      source: isProjectResearchContext ? 'project_research' : activeTabId === TOP_VIEWING_SITE_PLANS_TAB ? 'top_viewing' : 'find_comparable',
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });

    const requestId = ++floorPlanOpenRequestRef.current;
    setSelectedUnitForFloorPlan(unit);
    setFloorPlanRefreshing(true);
    setFloorPlanOpen(true);

    const latestUnit = await refreshFloorPlanUnit(unit);
    if (requestId !== floorPlanOpenRequestRef.current) {
      return;
    }

    setSelectedUnitForFloorPlan(latestUnit as ComparableUnit | ReferenceUnit);
    setFloorPlanRefreshing(false);
  }, [activeTabId, isProjectResearchContext, refreshFloorPlanUnit, userInfo?.CEANumber]);

  const renderMasterToolExpandUnitRowCells = useCallback(
    (unit: MasterToolExpandUnitRow) => {
      const projectDetails = getMasterToolUnitProjectDetails(unit);
      const isExecutiveCondoUnit = projectDetails?.projectCategoryId === 'C1803'
        || (projectDetails?.projectCategory ?? '').toLowerCase().includes('executive condo');
      const mappedUnit = { ...unit, priceDiff: 0, priceDiffPercent: 0, psfDiff: 0, psfDiffPercent: 0, outlay: unit.outlay, outlayDiff: 0, installment: unit.installment, installmentDiff: 0 } as ComparableUnit;
      return (
        <>
          <TableCell data-column="projectName" sx={{ fontWeight: 500, color: 'var(--color-text-strong)', position: 'sticky', left: 0, zIndex: 1, minWidth: 200, width: 200, borderRight: '1px solid rgba(var(--color-text-rgb), 0.1)', bgcolor: 'var(--color-surface)' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                <Typography variant="body2" sx={{ color: 'var(--color-text-strong)' }}>
                  {unit.projectName}
                </Typography>
                {referenceUnit && (referenceUnit.id === unit.id || (referenceUnit.projectName === unit.projectName && referenceUnit.unitNumber === unit.unitNumber)) && (
                  <Tooltip title="Reference unit" arrow placement="top">
                    <BookmarkIcon sx={{ fontSize: '0.9rem !important', color: '#1976d2', flexShrink: 0 }} />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenTowerView({ ...unit, priceDiff: 0, priceDiffPercent: 0, psfDiff: 0, psfDiffPercent: 0, outlay: unit.outlay, outlayDiff: 0, installment: unit.installment, installmentDiff: 0 } as ComparableUnit);
                  }}
                  sx={getIconButtonSx()}
                  title="View Tower View"
                >
                  <ViewModuleIcon fontSize="small" />
                </IconButton>
                {unit.floorplan && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenFloorPlan(mappedUnit);
                    }}
                    sx={{ ...getIconButtonSx(), color: 'primary.main' }}
                    title="View Floor Plan"
                  >
                    <ImageIcon fontSize="small" />
                  </IconButton>
                )}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShortlistAction({
                      unitId: unit.id,
                      label: `${unit.projectName} ${unit.unitNumber}`,
                      floorplan: unit.floorplan || null,
                    });
                  }}
                  disabled={shortlistUpdatingUnitId === unit.id}
                  sx={{
                    ...getIconButtonSx(),
                    color: shortlistByUnitId.has(unit.id) ? 'var(--color-warning-strong)' : 'var(--color-text-strong)',
                  }}
                  title={shortlistByUnitId.has(unit.id) ? 'Remove from shortlist' : 'Add to shortlist'}
                >
                  {shortlistByUnitId.has(unit.id) ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
                </IconButton>
              </Box>
            </Box>
          </TableCell>
          <TableCell data-column="projectCategory">{getMasterToolUnitProjectMeta(unit, 'projectCategory') || '-'}</TableCell>
          <TableCell data-column="unitNumber">{unit.unitNumber}</TableCell>
          <TableCell data-column="blockNumber" align="center">{formatBlockNumber(unit.blockNumber ?? null)}</TableCell>
          <TableCell data-column="floor" align="center">{unit.computedFloor ?? '-'}</TableCell>
          <TableCell data-column="stack" align="center">{unit.computedStack ?? '-'}</TableCell>
          <TableCell data-column="bedroom" align="center">{unit.bedroom}</TableCell>
          <TableCell data-column="bathroom" align="center">{unit.bathroom}</TableCell>
          <TableCell data-column="areaSqft" align="right">{unit.areaSqft > 0 ? formatNumber(unit.areaSqft) : '-'}</TableCell>
          <TableCell data-column="price" align="right">{unit.price > 0 ? formatCurrency(unit.price) : '-'}</TableCell>
          {hasMasterToolExecutiveCondo && (
            <TableCell data-column="dps" align="right">
              {isExecutiveCondoUnit && unit.priceDps && unit.priceDps > 0 ? formatCurrency(unit.priceDps) : '-'}
            </TableCell>
          )}
          <TableCell data-column="psf" align="right">{unit.psf > 0 ? formatCurrency(unit.psf) : '-'}</TableCell>
          <TableCell data-column="outlay" align="right">
            {unit.outlay > 0 ? (
              <Tooltip
                title={getOutlayFormulaTooltip(unit.price, unit.outlay)}
                arrow
                placement="top"
                enterTouchDelay={0}
                leaveTouchDelay={3500}
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: 'rgba(60, 60, 60, 0.95)',
                      maxWidth: 360,
                      border: '1px solid rgba(255,255,255,0.12)',
                      '& .MuiTypography-root': { color: '#fff' },
                    },
                  },
                }}
              >
                <Typography component="span" variant="body2" sx={{ cursor: 'help', textDecoration: 'underline dotted rgba(var(--color-text-rgb), 0.45)', textUnderlineOffset: 3 }}>
                  {formatCurrency(unit.outlay)}
                </Typography>
              </Tooltip>
            ) : '-'}
          </TableCell>
          <TableCell data-column="installment" align="right">
            {unit.installment > 0 ? (
              <Tooltip
                title={getInstallmentFormulaTooltip(unit.price, unit.installment)}
                arrow
                placement="top"
                enterTouchDelay={0}
                leaveTouchDelay={3500}
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: 'rgba(60, 60, 60, 0.95)',
                      maxWidth: 360,
                      border: '1px solid rgba(255,255,255,0.12)',
                      '& .MuiTypography-root': { color: '#fff' },
                    },
                  },
                }}
              >
                <Typography component="span" variant="body2" sx={{ cursor: 'help', textDecoration: 'underline dotted rgba(var(--color-text-rgb), 0.45)', textUnderlineOffset: 3 }}>
                  {formatCurrency(unit.installment)}
                </Typography>
              </Tooltip>
            ) : '-'}
          </TableCell>
          <TableCell data-column="district">{getMasterToolUnitProjectMeta(unit, 'district') || '-'}</TableCell>
          <TableCell data-column="districtLocation">{getMasterToolUnitProjectMeta(unit, 'districtLocation') || '-'}</TableCell>
          <TableCell data-column="region">{getMasterToolUnitProjectMeta(unit, 'region') || '-'}</TableCell>
          <TableCell data-column="nearestMrt">{getMasterToolUnitProjectMeta(unit, 'nearestMrt') || '-'}</TableCell>
          <TableCell data-column="walkingTimeToMrt" align="right">
            {getMasterToolUnitProjectMeta(unit, 'walkingTimeToMrt')
              ? `${getMasterToolUnitProjectMeta(unit, 'walkingTimeToMrt')} min`
              : '-'}
          </TableCell>
          <TableCell data-column="tenure">{getMasterToolUnitProjectMeta(unit, 'tenure') || '-'}</TableCell>
          <TableCell data-column="topYear" align="right">{getMasterToolUnitProjectMeta(unit, 'topYear') || '-'}</TableCell>
        </>
      );
    },
    [
      formatBlockNumber,
      formatCurrency,
      formatNumber,
      getIconButtonSx,
      getInstallmentFormulaTooltip,
      getMasterToolUnitProjectDetails,
      getMasterToolUnitProjectMeta,
      getOutlayFormulaTooltip,
      handleOpenFloorPlan,
      handleOpenTowerView,
      handleShortlistAction,
      hasMasterToolExecutiveCondo,
      referenceUnit,
      shortlistByUnitId,
      shortlistUpdatingUnitId,
    ],
  );

  const handleOpenPriceChart = async (
    unitId: number,
    type: 'price' | 'psf',
    showOnlyDrop: boolean = false,
    source: string = 'price_promo_price_drop',
    bedroom: number | null = null,
    // Tab the Price History dialog lands on. 'share' takes the agent straight to
    // the shareable promo designs, skipping the chart.
    initialTab: 'price' | 'psf' | 'share' = type,
  ) => {
    if (showOnlyDrop) {
      logPricePromoChartOpened({
        unitId,
        chartType: type,
        showOnlyDrop,
        source,
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });
    }
    setPriceChartUnitId(unitId);
    setPriceChartType(type);
    setPriceDialogTab(initialTab);
    setPriceChartBedroom(bedroom);
    setPriceChartOpen(true);

    try {
      setPriceChartLoading(true);
      const history = await api.getPriceHistory(unitId);

      // When opened from a price-promo context, mirror the backend promo rule
      // (see backend/src/routes/pricePromoUnits.ts): show the latest price plus
      // the most recent different-price prior entry whose date is at least 4
      // days before the latest. This keeps the chart's two endpoints aligned
      // with the price drop displayed in the promo card and avoids being misled
      // by recent accidental updates that get corrected within a few days.
      if (showOnlyDrop && history.history.length >= 2) {
        const STABLE_PRIOR_DAYS = 4;
        const sorted = [...history.history].sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
        );
        const latest = sorted[sorted.length - 1];
        const latestMs = new Date(latest.date).getTime();
        const cutoffMs = latestMs - STABLE_PRIOR_DAYS * 24 * 60 * 60 * 1000;
        let prior: typeof latest | null = null;
        for (let i = sorted.length - 2; i >= 0; i--) {
          const tMs = new Date(sorted[i].date).getTime();
          if (tMs <= cutoffMs && Number(sorted[i].price) !== Number(latest.price)) {
            prior = sorted[i];
            break;
          }
        }
        // When the unit qualifies as a promo from its history (a real prior drop
        // exists) and its OtherPrice1 "listed price" is set, non-zero and higher
        // than the latest price, measure the drop from that listed price instead.
        // The listed point has no real date, so it is flagged (isListedPrice) and
        // rendered as "Listed Date". It is dated just before the latest so the
        // date-based sorts in the chart/savings/share views keep it first.
        const otherPrice1 = history.otherPrice1 != null ? Number(history.otherPrice1) : null;
        const latestPrice = Number(latest.price);
        if (prior && otherPrice1 != null && otherPrice1 !== 0 && otherPrice1 > latestPrice) {
          const size = history.size != null ? Number(history.size) : null;
          const listedPSF = size && size > 0
            ? otherPrice1 / size
            : (prior.pricePSF ?? latest.pricePSF ?? 0);
          const listedPoint = {
            price: otherPrice1,
            pricePSF: listedPSF,
            date: new Date(new Date(latest.date).getTime() - 1).toISOString(),
            isListedPrice: true,
          };
          setPriceChartData({ ...history, history: [listedPoint, latest] });
        } else {
          setPriceChartData({
            ...history,
            history: prior ? [prior, latest] : [latest],
          });
        }
      } else {
        setPriceChartData(history);
      }
    } catch (err) {
      console.error('Failed to fetch price history:', err);
      setPriceChartData(null);
    } finally {
      setPriceChartLoading(false);
    }
  };

  const handleClosePriceChart = () => {
    setPriceChartOpen(false);
    setPriceChartData(null);
    setPriceChartUnitId(null);
    setPriceChartBedroom(null);
    setPriceDialogTab('price');
  };

  const handleCloseFloorPlan = useCallback(() => {
    floorPlanOpenRequestRef.current += 1;
    setFloorPlanRefreshing(false);
    setFloorPlanOpen(false);
    setSelectedUnitForFloorPlan(null);
  }, []);

  const handleAddToFloorPlanCompare = (unit: ComparableUnit | ReferenceUnit) => {
    if (isExternalUser) return;
    if (!unit.floorplan) return;
    
    // Check if already in comparison
    const exists = floorPlansToCompare.some(fp => fp.unit.id === unit.id);
    if (exists) {
      // Remove if already exists
      setFloorPlansToCompare(prev => prev.filter(fp => fp.unit.id !== unit.id));
      return;
    }
    
    // Add if less than 3 floor plans
    if (floorPlansToCompare.length < 3) {
      logCompareAdd({
        projectName: unit.projectName,
        unitNumber: unit.unitNumber,
        unitId: unit.id,
        source: 'generic_floor_plan_compare',
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });
      setFloorPlansToCompare(prev => [...prev, {
        unit,
        imageUrl: unit.floorplan!,
      }]);
    }
  };

  const handleRemoveFromFloorPlanCompare = (unitId: number) => {
    setFloorPlansToCompare(prev => prev.filter(fp => fp.unit.id !== unitId));
  };

  const handleOpenFloorPlanCompare = () => {
    if (floorPlansToCompare.length > 0) {
      const primaryUnit = floorPlansToCompare[0]?.unit;
      setCompareDialogSource('generic');
      setCompareExpandedView(false);
      setCompareVisualizerMode('floorplan');
      logFloorPlanComparisonOpened({
        projectName: primaryUnit?.projectName,
        unitNumber: primaryUnit?.unitNumber,
        unitId: primaryUnit?.id,
        source: 'generic_compare_dialog',
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });
      setFloorPlanCompareOpen(true);
    }
  };

  const handleOpenTopViewingFloorPlanCompare = () => {
    if (topViewingFloorPlansToCompare.length > 0) {
      const primaryUnit = topViewingFloorPlansToCompare[0]?.unit;
      setCompareDialogSource('topViewing');
      setCompareExpandedView(false);
      setCompareVisualizerMode('floorplan');
      logFloorPlanComparisonOpened({
        projectName: primaryUnit?.projectName,
        unitNumber: primaryUnit?.unitNumber,
        unitId: primaryUnit?.id,
        source: 'top_viewing_compare_dialog',
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });
      setFloorPlanCompareOpen(true);
    }
  };

  const handleCloseFloorPlanCompare = () => {
    setFloorPlanCompareOpen(false);
    setCompareFloorPlanZoom(1);
    setCompareExpandedView(false);
    setCompareFocusedUnitId(null);
    setCompareVisualizerMode('floorplan');
    setCompareFloorPlanRotations({});
    setCompareSitePlanRotations({});
    setCompareFloorPlanFlips({});
    setCompareSitePlanFlips({});
    setDrawToolbarState({ isDrawMode: false, activeColor: '#FF0000', lineWidth: 4, activeTool: 'pen' });
    setDrawingStates({});
  };

  const handleCompareVisualizerModeChange = useCallback((value: 'floorplan' | 'siteplan') => {
    const primaryUnit = compareDialogFloorPlans[0]?.unit;
    if (value === 'siteplan') {
      logSitePlanComparisonOpened({
        projectName: primaryUnit?.projectName,
        unitNumber: primaryUnit?.unitNumber,
        unitId: primaryUnit?.id,
        source: `${compareDialogSource}_compare_dialog`,
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });
    } else {
      logFloorPlanComparisonOpened({
        projectName: primaryUnit?.projectName,
        unitNumber: primaryUnit?.unitNumber,
        unitId: primaryUnit?.id,
        source: `${compareDialogSource}_compare_dialog`,
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });
    }
    setCompareVisualizerMode(value);
  }, [compareDialogFloorPlans, compareDialogSource, userInfo]);

  const exportComparePdf = async (kind: 'floorplan' | 'siteplan' | 'both') => {
    if (compareDialogFloorPlans.length === 0) return;
    setCompareExportMenuAnchor(null);
    setCompareExportingPdf(true);
    try {
      const captureFloorPlans = async (): Promise<Array<string | undefined> | undefined> => {
        // Panels are only on screen in expanded floor plan view; otherwise the
        // PDF embeds the raw floor plan images.
        if (compareVisualizerMode !== 'floorplan' || !compareExpandedView) return undefined;
        return Promise.all(compareDialogFloorPlans.map(async (_, i) => {
          const el = document.querySelector(`[data-pdf-capture="compare-floorplan-${i}"]`) as HTMLElement | null;
          if (!el) return undefined;
          try {
            return await captureComparePanel(el);
          } catch (err) {
            console.warn('Failed to capture compare floor plan:', err);
            return undefined;
          }
        }));
      };

      const captureSitePlans = async (): Promise<Array<string | undefined>> => {
        const projectNames = Array.from(new Set(compareDialogFloorPlans.map((fp) => fp.unit.projectName).filter(Boolean)));
        const sitePlans = new Map<string, { sitePlan: SitePlanData | null; dataUrl: string | null }>();
        await Promise.all(projectNames.map(async (projectName) => {
          try {
            const projectId = await resolveProjectIdByName(projectName);
            const sitePlan = compareSitePlansByProject.has(projectName)
              ? compareSitePlansByProject.get(projectName) ?? null
              : (await fetchSitePlan(projectName, projectId)).sitePlan;
            const dataUrl = sitePlan?.imageUrl ? await loadSitePlanImageDataUrl(sitePlan.imageUrl, projectId) : null;
            sitePlans.set(projectName, { sitePlan, dataUrl });
          } catch (err) {
            console.warn(`Failed to load site plan for PDF (${projectName}):`, err);
            sitePlans.set(projectName, { sitePlan: null, dataUrl: null });
          }
        }));

        const onScreen = compareVisualizerMode === 'siteplan';
        return Promise.all(compareDialogFloorPlans.map(async (fp, i) => {
          const entry = sitePlans.get(fp.unit.projectName);
          if (!entry?.sitePlan?.imageUrl || !entry.dataUrl) return undefined;
          const el = onScreen
            ? (document.querySelector(`[data-pdf-capture="compare-siteplan-${i}"]`) as HTMLElement | null)
            : null;
          if (el) {
            try {
              return await captureComparePanel(el, new Map([[entry.sitePlan.imageUrl, entry.dataUrl]]));
            } catch (err) {
              console.warn('Failed to capture compare site plan panel, drawing it instead:', err);
            }
          }
          try {
            return await renderSitePlanWithMarker(entry.dataUrl, getCompareSitePlanMarker(entry.sitePlan, fp.unit), {
              rotationDegrees: compareSitePlanRotations[fp.unit.id] ?? 0,
              flipHorizontal: compareSitePlanFlips[fp.unit.id] ?? false,
            });
          } catch (err) {
            console.warn('Failed to capture compare site plan:', err);
            return undefined;
          }
        }));
      };

      const floorPlanSection = async () => ({ title: 'FLOOR PLAN COMPARISON', screenshots: await captureFloorPlans() });
      // Site plan pages never fall back to the floor plan image.
      const sitePlanSection = async () => ({
        title: 'SITE PLAN COMPARISON',
        screenshots: await captureSitePlans(),
        fallbackImageUrls: compareDialogFloorPlans.map(() => null),
      });

      const sections = kind === 'floorplan'
        ? [await floorPlanSection()]
        : kind === 'siteplan'
          ? [await sitePlanSection()]
          : [await floorPlanSection(), await sitePlanSection()];
      const fileNamePrefix = kind === 'floorplan'
        ? 'Floor_Plan_Comparison'
        : kind === 'siteplan'
          ? 'Site_Plan_Comparison'
          : 'Floor_And_Site_Plan_Comparison';

      await generateFloorPlanComparisonPdf(compareDialogFloorPlans, userInfo, undefined, { sections, fileNamePrefix });
    } catch (err) {
      console.error('Failed to export plan comparison PDF:', err);
    } finally {
      setCompareExportingPdf(false);
    }
  };

  const handleRotateComparePlan = useCallback((unitId: number, mode: 'floorplan' | 'siteplan', direction: 'cw' | 'ccw') => {
    const setter = mode === 'floorplan' ? setCompareFloorPlanRotations : setCompareSitePlanRotations;
    setter(prev => {
      const current = (prev[unitId] ?? 0) + (direction === 'cw' ? 90 : -90);
      const normalized = ((current % 360) + 360) % 360;
      return { ...prev, [unitId]: normalized };
    });
  }, []);

  const handleFlipComparePlan = useCallback((unitId: number, mode: 'floorplan' | 'siteplan') => {
    const setter = mode === 'floorplan' ? setCompareFloorPlanFlips : setCompareSitePlanFlips;
    setter(prev => ({ ...prev, [unitId]: !prev[unitId] }));
  }, []);

  const getDrawingKey = useCallback((unitId: string | number) => {
    return `${compareVisualizerMode}:${unitId}`;
  }, [compareVisualizerMode]);

  const handleDrawStrokesChange = useCallback((unitId: string | number, strokes: Stroke[]) => {
    const key = getDrawingKey(unitId);
    setDrawingStates(prev => ({ ...prev, [key]: { strokes } }));
  }, [getDrawingKey]);

  const handleDrawUndo = useCallback(() => {
    if (!compareFocusedUnitId) return;
    const key = getDrawingKey(compareFocusedUnitId);
    setDrawingStates(prev => {
      const current = prev[key];
      if (!current || current.strokes.length === 0) return prev;
      return { ...prev, [key]: { strokes: current.strokes.slice(0, -1) } };
    });
  }, [compareFocusedUnitId, getDrawingKey]);

  const handleDrawClearAll = useCallback(() => {
    if (!compareFocusedUnitId) return;
    const key = getDrawingKey(compareFocusedUnitId);
    setDrawingStates(prev => ({ ...prev, [key]: { strokes: [] } }));
  }, [compareFocusedUnitId, getDrawingKey]);

  // Handle unit comparison - uses same state as floor plan comparison
  const handleAddToUnitCompare = (unit: ComparableUnit) => {
    if (isExternalUser) return;
    // Only add if unit has a floor plan
    if (!unit.floorplan) return;
    
    // Check if already in comparison
    const exists = floorPlansToCompare.some(fp => fp.unit.id === unit.id);
    if (exists) {
      // Remove if already exists
      setFloorPlansToCompare(prev => prev.filter(fp => fp.unit.id !== unit.id));
      return;
    }
    
    // Add if less than 3 units
    if (floorPlansToCompare.length < 3) {
      setFloorPlansToCompare(prev => [...prev, {
        unit,
        imageUrl: unit.floorplan!,
      }]);
    }
  };

  // Unused handler - kept for potential future use
  // const handleRemoveFromUnitCompare = (unitId: number) => {
  //   setFloorPlansToCompare(prev => prev.filter(fp => fp.unit.id !== unitId));
  // };

  const handleCloseTowerView = () => {
    towerViewOpenRequestRef.current += 1;
    towerViewFloorPlanOpenRequestRef.current += 1;
    const wasOpenedFromSitePlan = towerViewOpenedFromSitePlan;
    const shouldPreserveTopViewingData =
      activeTabId === TOP_VIEWING_SITE_PLANS_TAB && Boolean(selectedTopViewingSitePlan);

    setTowerViewOpen(false);
    setSelectedUnitForTowerView(null);
    setSelectedTowerViewUnitForFloorPlan(null);
    setTowerViewFloorPlanRefreshing(false);
    setTowerViewFloorPlanOpen(false);
    setSelectedBlock(null);
    setTowerZoom(1);
    setTowerViewBedroomFilter([]);
    setTowerViewUnitTypeFilter([]);
    setTowerViewIsolatedFromMain(false);
    setTowerViewDialogUnits([]);
    setTowerViewDialogUnitTypes([]);
    setTowerViewDialogSitePlanData(null);
    if (!shouldPreserveTopViewingData) {
      setTowerViewUnits([]);
      setTowerViewUnitTypes([]);
    }
    setTowerViewOpenedFromSitePlan(false);
    
    // If tower view was opened from site plan, reopen the site plan modal
    if (wasOpenedFromSitePlan) {
      setSitePlanOpen(true);
    }
  };

  // Handle site plan open
  const handleOpenSitePlan = async () => {
    const projectName = selectedProject || referenceUnit?.projectName;
    if (!projectName) return;

    try {
      setSitePlanLoading(true);
      setSitePlanOpen(false);
      await loadSitePlanContext(projectName);
      setSitePlanOpen(true);
      logSitePlanOpened(projectName, 'generic_site_plan', userInfo?.CEANumber || getDevCea());
      logProjectViewed(projectName, 'generic_site_plan', userInfo?.CEANumber || getDevCea());
    } catch (err) {
      console.error('Failed to fetch site plan:', err);
      setSitePlanData(null);
    } finally {
      setSitePlanLoading(false);
    }
  };

  const handleOpenSitePlanForProject = useCallback(async (projectName: string) => {
    if (!projectName) return;

    try {
      setSitePlanLoading(true);
      setSitePlanOpen(false);
      await loadSitePlanContext(projectName);
      setSitePlanOpen(true);
      logSitePlanOpened(projectName, 'project_site_plan', userInfo?.CEANumber || getDevCea());
      logProjectViewed(projectName, 'project_site_plan', userInfo?.CEANumber || getDevCea());
    } catch (err) {
      console.error('Failed to fetch site plan:', err);
      setSitePlanData(null);
    } finally {
      setSitePlanLoading(false);
    }
  }, [loadSitePlanContext, userInfo?.CEANumber]);

  const handleSitePlanCoordinatesSaved = useCallback(async (projectName: string) => {
    if (!projectName) return;

    setSitePlanAvailability((prev) => {
      if (!prev.has(projectName)) {
        return prev;
      }
      const next = new Map(prev);
      next.delete(projectName);
      return next;
    });

    const activeProjectName = selectedTopViewingSitePlan || selectedProject || referenceUnit?.projectName || '';
    if (activeProjectName !== projectName) {
      return;
    }

    try {
      setSitePlanLoading(true);
      const activeTopViewingProjectId = selectedTopViewingSitePlan === projectName
        ? topViewingSitePlans.find((plan) => plan.projectName === projectName)?.projectId
        : undefined;
      await loadSitePlanContext(projectName, activeTopViewingProjectId, { force: true });
    } catch (err) {
      console.error('Failed to reload site plan after saving coordinates:', err);
    } finally {
      setSitePlanLoading(false);
    }
  }, [loadSitePlanContext, referenceUnit?.projectName, selectedProject, selectedTopViewingSitePlan, topViewingSitePlans]);

  const handleSelectTopViewingSitePlan = useCallback(async (
    projectName: string,
    options?: { forceRefresh?: boolean },
  ) => {
    if (!projectName) return;

    try {
      const selectedProjectId = topViewingSitePlans.find((plan) => plan.projectName === projectName)?.projectId;
      const shouldForceRefresh = options?.forceRefresh === true || selectedTopViewingSitePlan === projectName;
      setTopViewingSitePlanContentLoading(true);
      setTopViewingSitePlansError(null);
      setSelectedTopViewingSitePlan(projectName);
      setTopViewingBlinkerChoiceUnit(null);
      setTopViewingBlinkerMinTolerance(-20);
      setTopViewingBlinkerTolerance(1);
      setTopViewingBlinkerMinPriceOverride(null);
      setTopViewingBlinkerMaxPriceOverride(null);
      updateTabState(TOP_VIEWING_SITE_PLANS_TAB, {
        selectedProject: projectName,
        unitNumber: '',
        projectUnits: [],
      });
      setSitePlanBedroomFilter([]);
      setSitePlanUnitTypeFilter([]);
      setSitePlanBlinkingStacks(new Set());
      setSelectedBlock(TOWER_VIEW_ALL_TAB);
      setTopViewingShowPsfColumnByDefault(true);

      await loadSitePlanContext(projectName, selectedProjectId, { force: shouldForceRefresh });
      logProjectViewed(projectName, 'top_viewing_select', userInfo?.CEANumber || getDevCea(), selectedProjectId);
      logSitePlanOpened(projectName, 'top_viewing_select', userInfo?.CEANumber || getDevCea(), selectedProjectId);

      try {
        const { units: allUnits, unitTypes, showPsfInTowerView, showPriceInTowerView } = await fetchTowerViewUnits(projectName, selectedProjectId);
        setTowerViewUnits(allUnits);
        setTowerViewUnitTypes(unitTypes);
        setTopViewingTowerDisplayOptions(TOP_VIEWING_TOWER_DISPLAY_DEFAULT.filter((o) =>
          (o !== 'psf' || showPsfInTowerView !== false) && (o !== 'price' || showPriceInTowerView !== false)));
        setTopViewingShowPsfColumnByDefault(showPsfInTowerView !== false);
      } catch (towerErr) {
        // Site plan / OneMap land-lot UI must still work when tower units fail (e.g. API error, no sheet).
        console.error('Failed to load tower view units (non-fatal for site plan):', towerErr);
        setTowerViewUnits([]);
        setTowerViewUnitTypes([]);
        setTopViewingTowerDisplayOptions([...TOP_VIEWING_TOWER_DISPLAY_DEFAULT]);
        setTopViewingShowPsfColumnByDefault(true);
      }
    } catch (err) {
      console.error('Failed to load top viewing site plan:', err);
      setTopViewingSitePlansError('Failed to load selected site plan details.');
      setTowerViewUnits([]);
      setTowerViewUnitTypes([]);
    } finally {
      setTopViewingSitePlanContentLoading(false);
    }
  }, [fetchTowerViewUnits, loadSitePlanContext, selectedTopViewingSitePlan, topViewingSitePlans, updateTabState, userInfo?.CEANumber]);

  // Amberwood at Holland campaign: the splash and the Project Research banner both open its site plan.
  const amberwoodSitePlan = useMemo(
    () => topViewingSitePlans.find((plan) => /amberwood/i.test(plan.projectName)),
    [topViewingSitePlans],
  );
  const openAmberwoodProject = useCallback(() => {
    if (!amberwoodSitePlan) return;
    setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
    void handleSelectTopViewingSitePlan(amberwoodSitePlan.projectName);
  }, [amberwoodSitePlan, handleSelectTopViewingSitePlan]);

  // The banner's × hides it for an agent for seven days; until then it shows on every 3BR/5BR
  // search. Admins (who check the campaign) only hide it until the page is reloaded.
  useEffect(() => {
    const cea = userInfo?.CEANumber;
    if (!cea) return;
    if (isAdminUser) { setAmberwoodBannerDismissed(false); return; }
    try { setAmberwoodBannerDismissed(isAmberwoodBannerSnoozed(window.localStorage, cea)); }
    catch { setAmberwoodBannerDismissed(false); }
  }, [isAdminUser, userInfo?.CEANumber]);
  const dismissAmberwoodBanner = useCallback(() => {
    setAmberwoodBannerDismissed(true);
    const cea = userInfo?.CEANumber;
    if (!cea || isAdminUser) return;
    try { snoozeAmberwoodBanner(window.localStorage, cea); }
    catch { /* Storage blocked: the banner stays hidden for this session only. */ }
  }, [isAdminUser, userInfo?.CEANumber]);

  const syncProjectIdUrlParam = useCallback((projectId: string | null) => {
    if (typeof window === 'undefined') return;
    const url = new URL(window.location.href);
    if (projectId) {
      url.searchParams.set('projectId', projectId);
    } else {
      url.searchParams.delete('projectId');
    }
    const next = `${url.pathname}${url.search}${url.hash}`;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (next !== current) {
      window.history.replaceState(window.history.state, '', next);
    }
  }, []);

  // Deep-link: /super-picker?ecoPropId=xxxx resolves VendorProject.Id to Project.Id.
  useEffect(() => {
    if (deepLinkProjectId || !deepLinkEcoPropId) return;

    let cancelled = false;
    const resolveEcoPropProjectId = async () => {
      try {
        const projectId = await api.resolveProjectIdByEcoPropId(deepLinkEcoPropId);
        if (!cancelled && projectId) {
          setDeepLinkProjectId(projectId);
          syncProjectIdUrlParam(projectId);
        }
      } catch (err) {
        console.error('Failed to resolve Ecoprop project id:', err);
      }
    };

    void resolveEcoPropProjectId();

    return () => {
      cancelled = true;
    };
  }, [deepLinkProjectId, deepLinkEcoPropId, syncProjectIdUrlParam]);

  // Deep-link: /super-picker?projectId=xxxx opens project detail directly
  useEffect(() => {
    // anticipate-blinker owns project selection when present
    if (autoOpenAnticipateBlinker) return;
    if (!deepLinkProjectId || deepLinkConsumedRef.current) return;
    const projectId = deepLinkProjectId;

    const plansReady =
      topViewingSitePlans.length > 0 || topViewingSitePlansFetchAttemptedRef.current;
    if (!plansReady || topViewingSitePlansLoading) return;

    const openDeepLinkedProject = async () => {
      deepLinkConsumedRef.current = true;
      const match = topViewingSitePlans.find((sp) => sp.projectId === projectId);
      if (match) {
        setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
        await handleSelectTopViewingSitePlan(match.projectName);
        return;
      }

      try {
        const details = await api.getProjectDetails(projectId);
        if (details?.name) {
          setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
          await handleSelectTopViewingSitePlan(details.name);
        }
      } catch (err) {
        console.error('Failed to open deep-linked project:', err);
      }
    };

    void openDeepLinkedProject();
  }, [
    autoOpenAnticipateBlinker,
    deepLinkProjectId,
    topViewingSitePlans,
    topViewingSitePlansLoading,
    handleSelectTopViewingSitePlan,
  ]);

  // Deep-link / showcase: prefer P2510001 (3BR → 2BR), then random project/unit.
  const ANTICIPATE_BLINKER_PROJECT_ID = 'P2510001';
  const openRandomAnticipateBlinkerUnit = useCallback(async () => {
    if (isExternalUser) {
      setTopViewingSitePlansError('Anticipate Blinker is not available for external users.');
      return;
    }

    const applyBlinkerChoice = async (projectName: string, choice: TowerViewUnit) => {
      await handleSelectTopViewingSitePlan(projectName);
      // Select clears blinker — set after load completes.
      setTopViewingBlinkerChoiceUnit(choice);
      // Wait for the site-plan detail (and All Blocks Tower View) to paint.
      window.setTimeout(() => {
        topViewingTowerViewSectionRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 200);
    };

    const pickRandom = <T,>(items: T[]): T => items[Math.floor(Math.random() * items.length)];

    const eligibleOnProject = (units: TowerViewUnit[], bedroom?: number) =>
      units.filter((unit) => {
        if (getUnitBlinkerDisabledReason(unit)) return false;
        if (bedroom == null) return true;
        return normalizeBedroomValue(unit.bedroom) === bedroom;
      });

    setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
    setTopViewingSitePlanContentLoading(true);
    setTopViewingSitePlansError(null);

    try {
      // Layer 1: fixed project P2510001 — prefer available 3BR, then 2BR.
      const match = topViewingSitePlans.find((plan) => plan.projectId === ANTICIPATE_BLINKER_PROJECT_ID);
      let preferredProjectName = match?.projectName ?? null;
      if (!preferredProjectName) {
        try {
          const details = await api.getProjectDetails(ANTICIPATE_BLINKER_PROJECT_ID);
          preferredProjectName = details?.name?.trim() || null;
        } catch (err) {
          console.error('Anticipate blinker: failed to resolve project P2510001:', err);
        }
      }

      if (preferredProjectName) {
        try {
          const { units } = await api.getTowerViewUnits(ANTICIPATE_BLINKER_PROJECT_ID);
          const threeBr = eligibleOnProject(units, 3);
          if (threeBr.length > 0) {
            await applyBlinkerChoice(preferredProjectName, pickRandom(threeBr));
            return;
          }
          const twoBr = eligibleOnProject(units, 2);
          if (twoBr.length > 0) {
            await applyBlinkerChoice(preferredProjectName, pickRandom(twoBr));
            return;
          }
        } catch (err) {
          console.error('Anticipate blinker: failed probing P2510001, falling back:', err);
        }
      }

      // Layer 2: random project + any eligible priced available unit.
      const plansWithId = topViewingSitePlans.filter(
        (plan) => Boolean(plan.projectId && plan.projectName) && plan.projectId !== ANTICIPATE_BLINKER_PROJECT_ID,
      );
      const pool = plansWithId.length > 0
        ? plansWithId
        : topViewingSitePlans.filter((plan) => Boolean(plan.projectId && plan.projectName));

      if (pool.length === 0) {
        setTopViewingSitePlansError('No site plans available for Anticipate Blinker.');
        return;
      }

      const shuffled = [...pool];
      for (let i = shuffled.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = shuffled[i];
        shuffled[i] = shuffled[j];
        shuffled[j] = tmp;
      }
      const candidates = shuffled.slice(0, Math.min(15, shuffled.length));

      for (const plan of candidates) {
        try {
          const { units } = await api.getTowerViewUnits(plan.projectId);
          const eligible = eligibleOnProject(units);
          if (eligible.length === 0) continue;
          await applyBlinkerChoice(plan.projectName, pickRandom(eligible));
          return;
        } catch (err) {
          console.error(`Anticipate blinker: failed probing ${plan.projectName}:`, err);
        }
      }

      setTopViewingSitePlansError(
        'Could not find a priced available unit for Anticipate Blinker. Try again or open a project manually.',
      );
    } catch (err) {
      console.error('Anticipate blinker: unexpected failure:', err);
      setTopViewingSitePlansError(
        'Could not open Anticipate Blinker. Try again or open a project manually.',
      );
    } finally {
      setTopViewingSitePlanContentLoading(false);
    }
  }, [
    isExternalUser,
    topViewingSitePlans,
    handleSelectTopViewingSitePlan,
    getUnitBlinkerDisabledReason,
    normalizeBedroomValue,
  ]);
  openRandomAnticipateBlinkerUnitRef.current = openRandomAnticipateBlinkerUnit;

  // Showcase: open a random site plan and land on the Super Ratio tab.
  const openRandomSuperRatio = useCallback(async () => {
    const plansWithId = topViewingSitePlans.filter((plan) => Boolean(plan.projectId && plan.projectName));
    if (plansWithId.length === 0) {
      setTopViewingSitePlansError('No site plans available for Super Ratio.');
      return;
    }

    // Prefer a project that can actually plot Super Ratio (has map coordinates).
    const mappable = plansWithId.filter(
      (plan) => typeof plan.mapLatitude === 'number' && typeof plan.mapLongitude === 'number',
    );
    const pool = mappable.length > 0 ? mappable : plansWithId;
    const plan = pool[Math.floor(Math.random() * pool.length)];

    setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
    setTopViewingSitePlanContentLoading(true);
    setTopViewingSitePlansError(null);
    try {
      await handleSelectTopViewingSitePlan(plan.projectName);
      // Opening a project resets the details tab to Details and collapses the
      // section. Re-apply after that so Super Ratio is what's showing.
      updateTabState(TOP_VIEWING_SITE_PLANS_TAB, { projectSectionExpanded: true });
      setProjectDetailsTab('superRatio');
      window.setTimeout(() => {
        document.querySelector('[data-tutorial="project-information"]')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 200);
    } catch (err) {
      console.error('Super Ratio showcase: failed to open project:', err);
      setTopViewingSitePlansError('Could not open Super Ratio. Try again or open a project manually.');
    } finally {
      setTopViewingSitePlanContentLoading(false);
    }
  }, [topViewingSitePlans, handleSelectTopViewingSitePlan, updateTabState]);
  openRandomSuperRatioRef.current = openRandomSuperRatio;

  useEffect(() => {
    if (!autoOpenAnticipateBlinker || anticipateBlinkerDeepLinkConsumedRef.current) return;
    if (!userSessionLoaded) return;

    const stripRedirectParam = () => {
      if (typeof window === 'undefined') return;
      const url = new URL(window.location.href);
      if (!url.searchParams.has('redirect')) return;
      url.searchParams.delete('redirect');
      const next = `${url.pathname}${url.search}${url.hash}`;
      const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      if (next !== current) {
        window.history.replaceState(window.history.state, '', next);
      }
    };

    // External users cannot set blinker units — consume and bail.
    if (isExternalUser) {
      anticipateBlinkerDeepLinkConsumedRef.current = true;
      deepLinkConsumedRef.current = true;
      stripRedirectParam();
      return;
    }

    const plansReady =
      topViewingSitePlans.length > 0 || topViewingSitePlansFetchAttemptedRef.current;
    if (!plansReady || topViewingSitePlansLoading) return;

    anticipateBlinkerDeepLinkConsumedRef.current = true;
    deepLinkConsumedRef.current = true;
    stripRedirectParam();
    void openRandomAnticipateBlinkerUnit();
  }, [
    autoOpenAnticipateBlinker,
    userSessionLoaded,
    isExternalUser,
    topViewingSitePlans,
    topViewingSitePlansLoading,
    openRandomAnticipateBlinkerUnit,
  ]);

  const handleBackToProjectEssential = useCallback(() => {
    const projectId = projectDetails?.id || deepLinkProjectId;
    const path = projectId
      ? `/project-essential/projects/${encodeURIComponent(projectId)}`
      : '/project-essential';
    // Prefer history.back() so we restore the original PE detail entry
    // (location.replace stacked a second PE detail and required two Backs).
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.location.replace(path);
  }, [projectDetails?.id, deepLinkProjectId]);

  const handleClearTopViewingSitePlan = useCallback(
    (plan: string | null) => {
      if (fromProjectEssential && plan == null) {
        handleBackToProjectEssential();
        return;
      }
      setSelectedTopViewingSitePlan(plan);
    },
    [fromProjectEssential, handleBackToProjectEssential, setSelectedTopViewingSitePlan],
  );

  // Map Research "View Full Research" — lands on the same project detail page the
  // ?projectId= deep link opens; the URL-sync effect below stamps ?projectId= for sharing.
  const handleMapResearchViewProject = useCallback(async (projectId: string) => {
    setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
    setActiveClientId(null);
    try {
      const match = topViewingSitePlans.find((sp) => sp.projectId === projectId);
      if (match) {
        await handleSelectTopViewingSitePlan(match.projectName);
        return;
      }
      const details = await api.getProjectDetails(projectId);
      if (details?.name) {
        await handleSelectTopViewingSitePlan(details.name);
      }
    } catch (err) {
      console.error('Failed to open project from Map Research:', err);
    }
  }, [topViewingSitePlans, handleSelectTopViewingSitePlan]);

  // Commission Structure dialog → project detail (same landing page as ?projectId=).
  const handleCommissionStructureViewProject = useCallback(async (row: ProjectCommissionStructure) => {
    setCommissionStructureOpen(false);
    // Drops the sidebar highlight off "Commission Structure" — the Site Plans
    // entry lights up from `activeTabId` instead.
    setActiveNavItem(TOP_VIEWING_SITE_PLANS_TAB);
    setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
    setActiveClientId(null);
    try {
      const projectName =
        topViewingSitePlans.find((sp) => sp.projectId === row.projectId)?.projectName
        || row.projectName;
      if (projectName) {
        await handleSelectTopViewingSitePlan(projectName);
        return;
      }
      const details = await api.getProjectDetails(row.projectId);
      if (details?.name) {
        await handleSelectTopViewingSitePlan(details.name);
      }
    } catch (err) {
      console.error('Failed to open project from Commission Structure:', err);
    }
  }, [topViewingSitePlans, handleSelectTopViewingSitePlan]);

  // Mirror the top-menu tab into `?tab=` so each tab has its own URL and Back /
  // Forward move between tabs. Client tabs are session-only and leave the URL alone.
  const tabUrlSyncedRef = useRef(false);
  const tabFromPopStateRef = useRef(false);
  const previousUrlTabRef = useRef(activeTabId);
  useEffect(() => {
    const previousTab = previousUrlTabRef.current;
    previousUrlTabRef.current = activeTabId;
    const fromPopState = tabFromPopStateRef.current;
    tabFromPopStateRef.current = false;
    const slug = TOOL_TAB_URL_SLUGS[activeTabId];
    if (!slug) return;
    const url = new URL(window.location.href);
    url.searchParams.set('tab', slug);
    // ?redirect=shareable(-links) only picks the opening tab (and, for -links, the one-shot
    // launch page); `tab` carries it from here, so a refresh does not replay the curtain.
    const redirect = url.searchParams.get('redirect');
    if (SHAREABLE_REDIRECTS.includes(redirect ?? '')) url.searchParams.delete('redirect');
    // projectId belongs to Site Plans; its sync effect restores it on return.
    // Leave an unconsumed deep link alone — it switches to Site Plans itself.
    if (activeTabId !== TOP_VIEWING_SITE_PLANS_TAB && (deepLinkConsumedRef.current || !deepLinkProjectId)) {
      url.searchParams.delete('projectId');
    }
    const next = `${url.pathname}${url.search}${url.hash}`;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (next === current) { tabUrlSyncedRef.current = true; return; }
    // Later tab clicks get a history entry. Replace instead for the landing URL,
    // Back / Forward, and the access guard bouncing off a tab the user cannot
    // open, so Back never lands on a tab that bounces again.
    const bounced = !toolTabs.some((t) => t.id === previousTab);
    if (tabUrlSyncedRef.current && !fromPopState && !bounced) window.history.pushState(window.history.state, '', next);
    else window.history.replaceState(window.history.state, '', next);
    tabUrlSyncedRef.current = true;
  }, [activeTabId, deepLinkProjectId]); // eslint-disable-line react-hooks/exhaustive-deps -- toolTabs is read, not a trigger
  useEffect(() => {
    const onPopState = () => {
      const tab = toolTabFromUrlSlug(new URLSearchParams(window.location.search).get('tab'));
      if (!tab || tab === previousUrlTabRef.current) return;
      tabFromPopStateRef.current = true;
      setActiveClientId(null);
      setActiveTabId(tab);
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  // Keep URL projectId in sync when viewing or leaving site plan project detail
  useEffect(() => {
    if (activeTabId !== TOP_VIEWING_SITE_PLANS_TAB) return;
    if (!deepLinkConsumedRef.current && deepLinkProjectId) return;

    if (!selectedTopViewingSitePlan) {
      syncProjectIdUrlParam(null);
      return;
    }

    const projectId =
      topViewingSitePlans.find((sp) => sp.projectName === selectedTopViewingSitePlan)?.projectId ??
      projectDetails?.id ??
      null;
    syncProjectIdUrlParam(projectId);
  }, [
    activeTabId,
    deepLinkProjectId,
    selectedTopViewingSitePlan,
    topViewingSitePlans,
    projectDetails?.id,
    syncProjectIdUrlParam,
  ]);

  const handleLoadPriceMatrixSimulation = useCallback(async (projectId: string) => {
    if (!projectId) return;
    try {
      setPriceMatrixSimulationLoadingProjectId(projectId);
      setPriceMatrixSimulationError(null);
      const response = await api.loadPriceMatrixSimulation(projectId);
      const existingSession = priceMatrixSimulationSessions.get(projectId) ?? null;
      persistPriceMatrixSimulationSession(buildPriceMatrixSimulationSession(projectId, response, existingSession));
    } catch (error) {
      setPriceMatrixSimulationError(error instanceof Error ? error.message : 'Failed to load price matrix simulation');
      throw error;
    } finally {
      setPriceMatrixSimulationLoadingProjectId(null);
    }
  }, [
    buildPriceMatrixSimulationSession,
    persistPriceMatrixSimulationSession,
    priceMatrixSimulationSessions,
  ]);

  const handleRefreshPriceMatrixSimulation = useCallback(async (projectId: string) => {
    if (!projectId) return;
    const existingSession = priceMatrixSimulationSessions.get(projectId);
    if (!existingSession?.sheetId) {
      setPriceMatrixSimulationError('Load Price Matrix first.');
      return;
    }

    try {
      setPriceMatrixSimulationRefreshingProjectId(projectId);
      setPriceMatrixSimulationError(null);
      const response = await api.refreshPriceMatrixSimulation(projectId);
      persistPriceMatrixSimulationSession(buildPriceMatrixSimulationSession(projectId, response, existingSession));
    } catch (error) {
      setPriceMatrixSimulationError(error instanceof Error ? error.message : 'Failed to refresh price matrix simulation');
      throw error;
    } finally {
      setPriceMatrixSimulationRefreshingProjectId(null);
    }
  }, [
    buildPriceMatrixSimulationSession,
    persistPriceMatrixSimulationSession,
    priceMatrixSimulationSessions,
  ]);

  const handleTogglePriceMatrixSimulationSync = useCallback(async (projectId: string, enabled: boolean) => {
    if (!projectId || isAdminUser) return;
    const existingSession = priceMatrixSimulationSessions.get(projectId);
    if (!existingSession) {
      setPriceMatrixSimulationError('Load Price Matrix first.');
      return;
    }
    try {
      setPriceMatrixSimulationError(null);
      if (!enabled) {
        persistPriceMatrixSimulationSession({
          ...existingSession,
          syncEnabled: false,
        });
        return;
      }
      setPriceMatrixSimulationRefreshingProjectId(projectId);
      const response = await api.loadPriceMatrixSimulation(projectId);
      persistPriceMatrixSimulationSession(buildPriceMatrixSimulationSession(projectId, response, existingSession, { syncEnabled: true }));
    } catch (error) {
      setPriceMatrixSimulationError(error instanceof Error ? error.message : 'Failed to sync price matrix simulation');
      throw error;
    } finally {
      setPriceMatrixSimulationRefreshingProjectId(null);
    }
  }, [
    buildPriceMatrixSimulationSession,
    isAdminUser,
    persistPriceMatrixSimulationSession,
    priceMatrixSimulationSessions,
  ]);

  const handleSetPriceMatrixSimulationStatus = useCallback(async (projectId: string, unitId: number, status: string | null) => {
    if (!projectId || !Number.isFinite(unitId)) return;
    const existingSession = priceMatrixSimulationSessions.get(projectId);
    if (!existingSession) {
      setPriceMatrixSimulationError('Load Price Matrix first.');
      return;
    }
    try {
      setPriceMatrixSimulationError(null);
      const result = await api.updatePriceMatrixSimulationStatuses(projectId, [{ unitId, status }]);
      const persistedUpdate = result.updates.find((update) => update.unitId === unitId);
      if (!persistedUpdate) {
        return;
      }
      const normalizedStatus = persistedUpdate.status;
      persistPriceMatrixSimulationSession({
        ...existingSession,
        units: existingSession.units.map((unit) => (
          unit.unitId === unitId
            ? { ...unit, status: normalizedStatus }
            : unit
        )),
        statusOverrides: {
          ...existingSession.statusOverrides,
          [String(unitId)]: normalizedStatus,
        },
        updatedAt: result.updatedAt,
      });
    } catch (error) {
      setPriceMatrixSimulationError(error instanceof Error ? error.message : 'Failed to update price matrix simulation status');
      throw error;
    }
  }, [persistPriceMatrixSimulationSession, priceMatrixSimulationSessions]);

  const handleCancelPriceMatrixSimulation = useCallback((projectId: string) => {
    if (!projectId) return;
    clearPriceMatrixSimulationSession(projectId);
    setPriceMatrixSimulationError(null);
  }, [clearPriceMatrixSimulationSession]);

  const handleApplyPriceMatrixSimulationStatuses = useCallback(async (
    projectId: string,
    updates: Array<{ unitId: number; status: string | null }>
  ) => {
    if (!projectId || updates.length === 0) return;
    const existingSession = priceMatrixSimulationSessions.get(projectId);
    if (!existingSession) {
      setPriceMatrixSimulationError('Load Price Matrix first.');
      return;
    }
    try {
      setPriceMatrixSimulationError(null);
      const result = await api.updatePriceMatrixSimulationStatuses(projectId, updates);
      if (result.updates.length === 0) {
        return;
      }
      const statusByUnitId = new Map<number, string>();
      result.updates.forEach((update) => {
        statusByUnitId.set(update.unitId, update.status);
      });
      persistPriceMatrixSimulationSession({
        ...existingSession,
        units: existingSession.units.map((unit) => {
          const nextStatus = statusByUnitId.get(unit.unitId);
          return nextStatus ? { ...unit, status: nextStatus } : unit;
        }),
        statusOverrides: {
          ...existingSession.statusOverrides,
          ...Object.fromEntries(result.updates.map((update) => [String(update.unitId), update.status])),
        },
        updatedAt: result.updatedAt,
      });
    } catch (error) {
      setPriceMatrixSimulationError(error instanceof Error ? error.message : 'Failed to update price matrix simulation statuses');
      throw error;
    }
  }, [persistPriceMatrixSimulationSession, priceMatrixSimulationSessions]);

  useEffect(() => {
    const inTopViewingContext = activeTabId === TOP_VIEWING_SITE_PLANS_TAB || showTopViewingDetailInGeneric;
    // Project Research needs the list too: its Amberwood banner opens a site plan from it.
    if (!inTopViewingContext && (activeTabId !== 'master' || topViewingSitePlansFetchAttemptedRef.current)) {
      return;
    }
    if (topViewingSitePlans.length > 0) {
      topViewingSitePlansFetchAttemptedRef.current = true;
      return;
    }

    const fetchTopViewingSitePlans = async () => {
      try {
        setTopViewingSitePlansLoading(true);
        setTopViewingSitePlansError(null);
        const sitePlans = await api.getTopViewingSitePlans();
        setTopViewingSitePlans(sitePlans);
      } catch (err) {
        setTopViewingSitePlansError(err instanceof Error ? err.message : 'Failed to fetch top viewing site plans');
      } finally {
        topViewingSitePlansFetchAttemptedRef.current = true;
        setTopViewingSitePlansLoading(false);
      }
    };

    fetchTopViewingSitePlans();
  }, [activeTabId, topViewingSitePlans]);

  // Project ids in the order the Site Plans tab lists them — the Commission
  // Structure dialog mirrors that scope and order.
  const topViewingSitePlanOrder = useMemo(
    () => topViewingSitePlans.map((plan) => plan.projectId),
    [topViewingSitePlans]
  );

  // Debounce site plan search
  useEffect(() => {
    const timer = setTimeout(() => {
      setTopViewingSitePlanSearchDebounced(topViewingSitePlanSearch);
      setTopViewingSitePlanPage(1);
    }, 300);
    return () => clearTimeout(timer);
  }, [topViewingSitePlanSearch]);

  const SITE_PLANS_PER_PAGE = 20;
  const topViewingHasWeeklySales = useMemo(
    () => topViewingSitePlans.some((sp) => !sp.upcoming && (sp.weeklySoldCount ?? 0) > 0),
    [topViewingSitePlans]
  );
  const topViewingSecondarySectionTitle = topViewingHasWeeklySales ? 'Top Selling This Week' : 'Site plan';

  const filteredTopViewingSitePlans = useMemo(() => {
    if (!topViewingSitePlanSearchDebounced) return topViewingSitePlans;
    return searchProjects(topViewingSitePlans, topViewingSitePlanSearchDebounced, (sp) => ({
      name: sp.projectName,
      district: sp.district ?? null,
      area: [sp.area, sp.region].filter(Boolean).join(' ') || null,
      address: sp.location ?? null,
    }));
  }, [topViewingSitePlans, topViewingSitePlanSearchDebounced]);

  const filteredUpcomingSitePlans = useMemo(
    () => filteredTopViewingSitePlans.filter((sp) => Boolean(sp.upcoming)),
    [filteredTopViewingSitePlans]
  );
  const filteredRegularSitePlans = useMemo(
    () => filteredTopViewingSitePlans.filter((sp) => !sp.upcoming),
    [filteredTopViewingSitePlans]
  );
  const paginatedRegularSitePlans = useMemo(() => {
    const start = (topViewingSitePlanPage - 1) * SITE_PLANS_PER_PAGE;
    return filteredRegularSitePlans.slice(start, start + SITE_PLANS_PER_PAGE);
  }, [filteredRegularSitePlans, topViewingSitePlanPage]);

  const totalSitePlanPages = Math.ceil(filteredRegularSitePlans.length / SITE_PLANS_PER_PAGE);

  const handleOpenStackAnalysis = useCallback(async (projectName: string, stackNumber: string, blockNumber?: string) => {
    if (!projectName || !stackNumber) return;

    try {
      setStackAnalysisLoading(true);
      setStackAnalysisOpen(true);
      const projectId = await resolveProjectIdByName(projectName);
      if (!projectId) {
        throw new Error(`Unable to resolve project id for ${projectName}`);
      }
      const normalizedStack = stackNumber.trim();
      const stackCandidates = [normalizedStack];
      if (/^\d+$/.test(normalizedStack)) {
        stackCandidates.push(normalizedStack.padStart(2, '0'));
        stackCandidates.push(String(Number(normalizedStack)));
      }

      let analysisData: Awaited<ReturnType<typeof api.getStackAnalysis>> | null = null;
      for (const candidate of Array.from(new Set(stackCandidates.filter(Boolean)))) {
        try {
          analysisData = await api.getStackAnalysis(projectId, candidate, blockNumber);
          break;
        } catch (error) {
          const message = error instanceof Error ? error.message.toLowerCase() : '';
          const isNoUnitsForStack = message.includes('no units found for this stack');
          if (!isNoUnitsForStack) {
            throw error;
          }
        }
      }

      if (!analysisData) {
        throw new Error('No units found for this stack');
      }
      setStackAnalysisData(analysisData);
    } catch (err) {
      console.error('Failed to fetch stack analysis:', err);
      setStackAnalysisData(null);
      setStackAnalysisOpen(false);
    } finally {
      setStackAnalysisLoading(false);
    }
  }, [resolveProjectIdByName]);

  const handleCloseStackAnalysis = useCallback(() => {
    setStackAnalysisOpen(false);
    setStackAnalysisData(null);
    setStackAnalysisUnitMenuAnchor(null);
  }, []);

  // Touch-optimized handlers for Stack Analysis Dialog
  const stackAnalysisCloseHandlers = useTouchClick(handleCloseStackAnalysis);

  const stackAnalysisSimulationPriceMap = useMemo(() => {
    const projectId = stackAnalysisData?.projectId;
    const session = projectId ? priceMatrixSimulationSessions.get(projectId) ?? null : null;
    if (!session?.units?.length) return new Map<number, { price: number; psf: number | null }>();
    const map = new Map<number, { price: number; psf: number | null }>();
    session.units.forEach((u) => {
      const price = u.price;
      if (Number.isFinite(u.unitId) && price != null && Number.isFinite(price) && price > 0) {
        map.set(u.unitId, { price, psf: Number.isFinite(u.psf) ? u.psf : null });
      }
    });
    return map;
  }, [stackAnalysisData?.projectId, priceMatrixSimulationSessions]);

  const stackAnalysisUnitsWithSimulation = useMemo(() => {
    if (!stackAnalysisData?.units) return [];
    const simMap = stackAnalysisSimulationPriceMap;
    return stackAnalysisData.units.map((unit: any) => {
      const sim = simMap.get(unit.id);
      const hasRealPrice = typeof unit.price === 'number' && Number.isFinite(unit.price) && unit.price > 0;
      if (hasRealPrice) return unit;
      if (!sim) return unit;
      return {
        ...unit,
        price: sim.price,
        pricePSF: sim.psf ?? (unit.size && unit.size > 0 ? sim.price / unit.size : null),
      };
    });
  }, [stackAnalysisData?.units, stackAnalysisSimulationPriceMap]);

  const stackAnalysisIsGuesstimated = useMemo(() => {
    const projectId = stackAnalysisData?.projectId;
    const session = projectId ? priceMatrixSimulationSessions.get(projectId) ?? null : null;
    if (!session || !stackAnalysisData?.units?.length) return false;
    return stackAnalysisData.units.some(
      (u: any) => {
        const hadNoRealPrice = typeof u.price !== 'number' || !Number.isFinite(u.price) || u.price <= 0;
        return hadNoRealPrice && stackAnalysisSimulationPriceMap.has(u.id);
      }
    );
  }, [stackAnalysisData?.projectId, stackAnalysisData?.units, priceMatrixSimulationSessions, stackAnalysisSimulationPriceMap]);

  // Touch-optimized handlers for Tower View Dialog
  const towerViewCloseHandlers = useTouchClick(handleCloseTowerView);

  // Touch-optimized handlers for Tower View Floor Plan Dialog
  const towerViewFloorPlanCloseHandlers = useTouchClick(handleCloseTowerViewFloorPlan);

  const buildReferenceUnitFromStackUnit = useCallback((unit: any): ReferenceUnit | null => {
    const projectName = unit?.projectName || stackAnalysisData?.projectName;
    if (!projectName || !unit?.unitNumber) return null;
    return {
      id: unit.id,
      projectName,
      unitNumber: unit.unitNumber,
      blockNumber: unit.blockNumber || null,
      bedroom: unit.bedroomNumber ?? unit.bedroom ?? 0,
      bathroom: unit.bathroomNumber ?? unit.bathroom ?? 0,
      areaSqft: unit.size ?? unit.areaSqft ?? 0,
      price: unit.price || 0,
      psf: unit.pricePSF || 0,
      outlay: 0,
      installment: 0,
      floorplan: unit.floorplan || null,
      unitStatus: unit.status || null,
    };
  }, [stackAnalysisData?.projectName]);

  const handleStackAnalysisViewFloorPlan = useCallback(() => {
    if (!stackAnalysisUnitMenuAnchor) return;
    const mappedUnit = buildReferenceUnitFromStackUnit(stackAnalysisUnitMenuAnchor.unit);
    setStackAnalysisUnitMenuAnchor(null);
    if (!mappedUnit) return;
    handleOpenFloorPlan(mappedUnit);
  }, [buildReferenceUnitFromStackUnit, stackAnalysisUnitMenuAnchor]);

  const handleStackAnalysisSetReferenceUnit = useCallback(async () => {
    if (!stackAnalysisUnitMenuAnchor) return;
    if (isExternalUser) {
      setStackAnalysisUnitMenuAnchor(null);
      return;
    }
    const selectedUnit = stackAnalysisUnitMenuAnchor.unit;
    if (getUnitReferenceDisabledReason(selectedUnit)) {
      setStackAnalysisUnitMenuAnchor(null);
      return;
    }
    const projectName = selectedUnit?.projectName || stackAnalysisData?.projectName;
    const selectedUnitNumber = selectedUnit?.unitNumber;
    if (!projectName || !selectedUnitNumber) {
      setStackAnalysisUnitMenuAnchor(null);
      return;
    }

    setStackAnalysisSetReferenceLoading(true);
    try {
      if (activeTabId === TOP_VIEWING_SITE_PLANS_TAB) {
        setTopViewingReferenceUnit({
          id: selectedUnit.id,
          projectName,
          unitNumber: selectedUnitNumber,
          blockNumber: selectedUnit.blockNumber || null,
          bedroom: selectedUnit.bedroomNumber || 0,
          bathroom: 0,
          areaSqft: selectedUnit.size || 0,
          price: selectedUnit.price || 0,
          psf: selectedUnit.pricePSF || 0,
          unitStatus: selectedUnit.status || null,
          floorplan: selectedUnit.floorplan || null,
        });
        logReferenceUnitSet({
          projectName,
          unitNumber: selectedUnitNumber,
          unitId: selectedUnit.id,
          source: 'stack_analysis_set_reference',
          ceaNumber: userInfo?.CEANumber || getDevCea(),
        });
        setStackAnalysisOpen(false);
        setTimeout(() => {
          topViewingComparableSectionRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }, 120);
      } else {
        await handleSearchWithParams(projectName, selectedUnitNumber, activeTabId, selectedUnit.id);
        setStackAnalysisOpen(false);
        setTimeout(() => {
          referenceUnitCardRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }, 180);
      }
    } finally {
      setStackAnalysisSetReferenceLoading(false);
      setStackAnalysisUnitMenuAnchor(null);
    }
  }, [activeTabId, getUnitReferenceDisabledReason, handleSearchWithParams, isExternalUser, stackAnalysisData?.projectName, stackAnalysisUnitMenuAnchor, topViewingComparableSectionRef, referenceUnitCardRef, userInfo?.CEANumber]);

  const handleOpenShortlistAction = useCallback(async (
    item: ShortlistItem,
    action: 'tower' | 'siteplan' | 'interest' | 'view'
  ) => {
    if (!item.projectName || !item.unitNumber) {
      setShortlistError('Missing project or unit number for this shortlist item.');
      return;
    }
    setShortlistDialogOpen(false);

    if (isExternalUser) {
      setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
      setActiveClientId(null);
    } else {
      setActiveTabId('generic');
      setActiveClientId(null);
      await handleSearchWithParams(item.projectName, item.unitNumber, 'generic');
    }

    if (action === 'tower') {
      const unit = buildComparableUnitFromShortlist(item);
      if (!unit) {
        setShortlistError('Unable to open tower view for this unit.');
        return;
      }
      await handleOpenTowerView(unit);
      return;
    }

    if (action === 'siteplan') {
      await handleOpenSitePlanForProject(item.projectName);
      return;
    }

    if (action === 'interest') {
      setHeatBarInfoOpen(true);
      return;
    }

    if (action === 'view') {
      return;
    }
  }, [buildComparableUnitFromShortlist, handleOpenSitePlanForProject, handleOpenTowerView, handleSearchWithParams, isExternalUser]);

  const handleThumbsupUnitClick = useCallback(async (item: ThumbsupUnit, source: string = 'thumbsup_units') => {
    if (!item.projectName || !item.UnitNumber) {
      setThumbsupError('Missing project or unit number.');
      return;
    }
    const currentCea = userInfo?.CEANumber || getDevCea();
    logThumbsupUnitSelected({
      projectName: item.projectName,
      projectId: item.ProjectId,
      unitNumber: item.UnitNumber,
      unitId: item.id,
      bedroomNumber: item.bedroomNumber,
      sizeSqft: item.size,
      thumbsupCount: item.thumbsupCount,
      isLive: item.isLive,
      source,
      ceaNumber: currentCea,
    });
    const nextHistory = saveViewedThumbsupUnit(item, thumbsupViewedHistory);
    setThumbsupViewedHistory(nextHistory);
    persistThumbsupViewedHistory(nextHistory);
    setThumbsupDialogOpen(false);
    setActiveTabId('generic');
    setActiveClientId(null);
    await handleSearchWithParams(item.projectName, item.UnitNumber, 'generic', item.id, undefined, source);
  }, [handleSearchWithParams, thumbsupViewedHistory, userInfo?.CEANumber]);

  const handlePricePromoUnitClick = useCallback(async (
    item: PricePromoUnit,
    source: string = 'price_promo_units',
    section?: string,
  ) => {
    if (!item.projectName || !item.UnitNumber) {
      setPricePromoError('Missing project or unit number.');
      return;
    }
    const currentCea = userInfo?.CEANumber || getDevCea();
    logPricePromoUnitSelected({
      projectName: item.projectName,
      projectId: item.ProjectId,
      unitNumber: item.UnitNumber,
      unitId: item.id,
      bedroomNumber: item.bedroomNumber,
      sizeSqft: item.size,
      price: item.price,
      pricePsf: item.pricePSF,
      priceChange: item.priceChange,
      priceChangePercent: item.priceChangePercent,
      priceChangeAt: item.priceChangeAt,
      isBestStackBedroom: pricePromoBestByStackBedroom.has(item.id),
      isLive: item.isLive,
      source,
      section,
      ceaNumber: currentCea,
    });
    setPricePromoDialogOpen(false);
    setActiveTabId('generic');
    setActiveClientId(null);
    await handleSearchWithParams(item.projectName, item.UnitNumber, 'generic', item.id, undefined, source);
  }, [handleSearchWithParams, pricePromoBestByStackBedroom, userInfo?.CEANumber]);

  const handleCloseSitePlan = () => {
    setSitePlanOpen(false);
    setSitePlanData(null);
  };

  // Touch-optimized handlers for Site Plan Dialog
  const sitePlanCloseHandlers = useTouchClick(handleCloseSitePlan);

  const unitMatchesSitePlanStackFilter = useCallback((unit: { unitNumber?: string | null; blockNumber?: string | null; floorNumber?: string | null }): boolean => {
    if (sitePlanStackFilter.length === 0) return true;
    const parsed = parseUnitNumber(unit.unitNumber || '', unit.floorNumber);
    if (parsed.stack == null) return false;
    const normalizedStack = normalizeStackKey(parsed.stack);
    if (!normalizedStack) return false;
    const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
    const compositeKey = blockNum ? `${blockNum}-${normalizedStack}` : null;
    return matchesSelectedStackKey(sitePlanStackFilter, normalizedStack)
      || (compositeKey != null && matchesSelectedStackKey(sitePlanStackFilter, compositeKey));
  }, [sitePlanStackFilter, parseUnitNumber, normalizeStackKey, matchesSelectedStackKey]);

  const unitMatchesSitePlanUnitTypeFilter = useCallback((unit: {
    projectUnitTypeId?: number | null;
    unitType?: string | null;
  }): boolean => {
    if (sitePlanUnitTypeFilterExpanded.length === 0) return true;
    if (unit.projectUnitTypeId != null && sitePlanUnitTypeFilterExpanded.includes(unit.projectUnitTypeId)) {
      return true;
    }
    if (unit.unitType) {
      const selectedUnitTypes = sitePlanUnitTypeFilterExpanded
        .map((id) => sitePlanUnitTypes.find((ut) => ut.id === id))
        .filter((ut): ut is NonNullable<typeof ut> => ut != null);
      return (
        selectedUnitTypes.some((ut) => ut.unitType === unit.unitType || ut.description === unit.unitType) ||
        sitePlanUnitTypeFilterExpandedUnitTypes.has(unit.unitType.trim())
      );
    }
    return false;
  }, [sitePlanUnitTypeFilterExpanded, sitePlanUnitTypeFilterExpandedUnitTypes, sitePlanUnitTypes]);

  const sitePlanBedroomFilterOptions = useMemo<number[]>(() => {
    const bedroomSet = new Set<number>();
    let hasPenthouse = false;
    towerViewUnits.forEach((unit) => {
      if (!unitMatchesSitePlanStackFilter(unit)) return;
      if (!unitMatchesSitePlanUnitTypeFilter(unit)) return;
      const unitIsPenthouse = isPenthouseUnit(unit);
      if (unitIsPenthouse) {
        hasPenthouse = true;
        return;
      }
      const bedroom = normalizeBedroomValue(unit.bedroom);
      if (bedroom != null && bedroom > 0) bedroomSet.add(bedroom);
    });
    const options = Array.from(bedroomSet).sort((a, b) => a - b);
    if (hasPenthouse) options.push(PENTHOUSE_FILTER_VALUE);
    return options;
  }, [towerViewUnits, unitMatchesSitePlanStackFilter, unitMatchesSitePlanUnitTypeFilter, normalizeBedroomValue, isPenthouseUnit, PENTHOUSE_FILTER_VALUE]);

  useEffect(() => {
    if (sitePlanBedroomFilter.length === 0) return;
    const allowed = new Set(sitePlanBedroomFilterOptions);
    const next = sitePlanBedroomFilter.filter((value) => allowed.has(value));
    if (next.length !== sitePlanBedroomFilter.length) {
      setSitePlanBedroomFilter(next);
    }
  }, [sitePlanBedroomFilterOptions, sitePlanBedroomFilter]);

  const sitePlanUnitTypesForBedroomFilter = useMemo(() => {
    const hasBedroomFilter = sitePlanBedroomFilter.length > 0;
    const hasStackFilter = sitePlanStackFilter.length > 0;
    if (!hasBedroomFilter && !hasStackFilter) return sitePlanUnitTypes;

    return sitePlanUnitTypes.filter((unitType) => {
      const unitTypeBedroom = normalizeBedroomValue(unitType.bedroom ?? unitType.description ?? unitType.unitType);
      // Check penthouse across description AND every code variant (e.g. C4, C4-PH share the same description).
      const allCodes = (unitType as { unitTypes?: string[] }).unitTypes ?? [];
      const unitTypeIsPenthouse =
        isPenthouseText(unitType.description) ||
        isPenthouseText(unitType.unitType) ||
        allCodes.some((code) => isPenthouseText(code));
      // Match against ALL grouped ids, not just unitType.id (which is only the first ID in the group).
      const allIds = new Set<number>(((unitType as { ids?: number[] }).ids ?? [unitType.id]).map((id) => Number(id)));
      const matchingUnits = towerViewUnits.filter(
        (unit) => unit.projectUnitTypeId != null && allIds.has(Number(unit.projectUnitTypeId)),
      );

      if (matchingUnits.length > 0) {
        return matchingUnits.some((unit) => {
          if (!unitMatchesSitePlanStackFilter(unit)) return false;
          const bedroom = normalizeBedroomValue(unit.bedroom);
          return matchesBedroomSelection(bedroom, isPenthouseUnit(unit), sitePlanBedroomFilter);
        });
      }

      // No live units for this catalogue row — only keep it when stack is unrestricted
      // (we can't prove the type exists on the selected stacks) and bedroom still matches.
      if (hasStackFilter) return false;
      return matchesBedroomSelection(unitTypeBedroom, unitTypeIsPenthouse, sitePlanBedroomFilter);
    });
  }, [sitePlanBedroomFilter, sitePlanStackFilter, sitePlanUnitTypes, towerViewUnits, unitMatchesSitePlanStackFilter, normalizeBedroomValue, isPenthouseUnit, matchesBedroomSelection]);

  useEffect(() => {
    const allowedIds = new Set(sitePlanUnitTypesForBedroomFilter.map((unitType) => unitType.id));
    setSitePlanUnitTypeFilter((prev) => prev.filter((id) => allowedIds.has(id)));
  }, [sitePlanUnitTypesForBedroomFilter]);

  // Update blinking stacks based on bedroom and unit type filters
  const updateBlinkingStacks = useCallback((bedroomFilter: number[], unitTypeFilter: string[]) => {
    if (bedroomFilter.length === 0 && unitTypeFilter.length === 0) {
      setSitePlanBlinkingStacks(new Set());
      return;
    }

    // Find all stacks that match the filters
    const matchingStacks = new Set<string>();

    // Check all units in tower view
    towerViewUnits.forEach(unit => {
      const normalizedBedroom = normalizeBedroomValue(unit.bedroom);
      const unitIsPenthouse = isPenthouseUnit(unit);
      const matchesBedroom = bedroomFilter.length === 0 || bedroomFilter.some((filterValue) => {
        if (filterValue === PENTHOUSE_FILTER_VALUE) return unitIsPenthouse;
        return !unitIsPenthouse && normalizedBedroom != null && normalizedBedroom === filterValue;
      });
      const matchesUnitType = unitTypeFilter.length === 0 || (unit.unitType && unitTypeFilter.includes(unit.unitType));

      if (matchesBedroom && matchesUnitType) {
        // Parse unit number to extract stack
        const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
        if (parsed.stack !== null) {
          matchingStacks.add(normalizeStackKey(parsed.stack));
          const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
          if (blockNum) {
            matchingStacks.add(`${blockNum}-${parsed.stack}`);
          }
        }
      }
    });

    setSitePlanBlinkingStacks(matchingStacks);
  }, [towerViewUnits, normalizeBedroomValue, isPenthouseUnit, PENTHOUSE_FILTER_VALUE]);

  // When tower view is isolated (e.g. from Project Research), update blinking stacks from dialog units
  useEffect(() => {
    if (!towerViewIsolatedFromMain) return;
    if (towerViewBedroomFilter.length === 0 && towerViewUnitTypeFilter.length === 0) {
      setSitePlanBlinkingStacks(new Set());
      return;
    }
    const matchingStacks = new Set<string>();
    towerViewDialogUnits.forEach((unit) => {
      const normalizedBedroom = normalizeBedroomValue(unit.bedroom);
      const unitIsPenthouse = isPenthouseUnit(unit);
      const matchesBedroom = towerViewBedroomFilter.length === 0 || towerViewBedroomFilter.some((filterValue) => {
        if (filterValue === PENTHOUSE_FILTER_VALUE) return unitIsPenthouse;
        return !unitIsPenthouse && normalizedBedroom != null && normalizedBedroom === filterValue;
      });
      const matchesUnitType = towerViewUnitTypeFilter.length === 0 || (unit.unitType && towerViewUnitTypeFilter.includes(unit.unitType));
      if (matchesBedroom && matchesUnitType) {
        const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
        if (parsed.stack !== null) {
          const stackKey = normalizeStackKey(parsed.stack);
          matchingStacks.add(stackKey);
          const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
          if (blockNum) matchingStacks.add(`${blockNum}-${stackKey}`);
        }
      }
    });
    setSitePlanBlinkingStacks(matchingStacks);
  }, [towerViewIsolatedFromMain, towerViewDialogUnits, towerViewBedroomFilter, towerViewUnitTypeFilter, normalizeBedroomValue, isPenthouseUnit, normalizeStackKey, parseUnitNumber, PENTHOUSE_FILTER_VALUE]);

  // Handle tower view open from site plan block click
  const handleOpenTowerViewFromBlock = async (blockNumber: string) => {
    const projectName = selectedProject || referenceUnit?.projectName;
    if (!projectName) return;

    // Set loading state and mark that tower view is being opened from site plan
    setTowerViewIsolatedFromMain(false);
    setTowerViewDialogUnits([]);
    setTowerViewDialogUnitTypes([]);
    setTowerViewDialogSitePlanData(null);
    setTowerViewUnitsLoading(true);
    setTowerViewOpenedFromSitePlan(true);

    try {
      const { units: allUnits, unitTypes } = await fetchTowerViewUnits(projectName);

      // Find first unit in the selected block
      const blockUnit = allUnits.find(u => u.blockNumber === blockNumber);
      
      if (blockUnit) {
        // Create a ComparableUnit-like object for the block
        const unitForTowerView: ComparableUnit = {
          id: blockUnit.id,
          projectName: blockUnit.projectName,
          unitNumber: blockUnit.unitNumber,
          blockNumber: blockUnit.blockNumber,
          bedroom: blockUnit.bedroom,
          bathroom: blockUnit.bathroom,
          areaSqft: blockUnit.areaSqft,
          price: blockUnit.price,
          priceDiff: 0,
          priceDiffPercent: 0,
          psf: blockUnit.psf,
          psfDiff: 0,
          psfDiffPercent: 0,
          outlay: 0,
          outlayDiff: 0,
          installment: 0,
          installmentDiff: 0,
          unitStatus: blockUnit.unitStatus,
        };
        
        setSelectedUnitForTowerView(unitForTowerView);
        setSelectedBlock(blockNumber);
        setTowerViewUnits(allUnits);
        setTowerViewUnitTypes(unitTypes);
        // Close site plan and open tower view after data is loaded
        setSitePlanOpen(false);
        setTowerViewOpen(true);
      } else {
        // If no block unit found, reset the flag
        setTowerViewOpenedFromSitePlan(false);
      }
    } catch (err) {
      console.error('Failed to fetch tower view units:', err);
      setTowerViewUnits([]);
      setTowerViewOpenedFromSitePlan(false);
    } finally {
      setTowerViewUnitsLoading(false);
    }
  };

  // Interest heat map: 0% white → 50% yellow → 100% red (for All tab interest map)
  const getInterestHeatColor = useCallback((percent: number) => {
    const p = Math.max(0, Math.min(1, percent));
    let r: number, g: number, b: number;
    if (p <= 0.5) {
      r = 255;
      g = 255;
      b = Math.round(255 * (1 - 2 * p));
    } else {
      r = 255;
      g = Math.round(255 * (2 - 2 * p));
      b = 0;
    }
    return `rgb(${r},${g},${b})`;
  }, []);

  // Mock interest % per unit (0–1) for heat map: 1–2 stacks hot (top=highest); rest random <50%, some 0%. Replace with ProjectUserQueueChoice-based data later.
  const getMockInterestPercent = useCallback((
    _unit: TowerViewUnit | ComparableUnit | null,
    floor: number,
    stack: number,
    floors: number[],
    stacks: number[],
    blockKey: string,
  ): number => {
    if (floors.length === 0 || stacks.length === 0) return 0;
    const minFloor = Math.min(...floors);
    const maxFloor = Math.max(...floors);
    const floorRange = maxFloor - minFloor || 1;
    const hotStack1 = stacks[0];
    const hotStack2 = stacks[Math.floor(stacks.length / 2)];
    const isHotStack = stack === hotStack1 || stack === hotStack2;
    if (isHotStack) {
      const floorFactor = (floor - minFloor) / floorRange;
      return Math.max(0, Math.min(1, 0.15 + 0.8 * floorFactor));
    }
    // Non-hot stacks: deterministic "random" 0–50%, with ~40% of cells at 0% so some stay white
    const seed = blockKey.split('').reduce((a, c) => a + c.charCodeAt(0), 0) + floor * 31 + stack * 17;
    const rand = ((seed * 9301 + 49297) % 233280) / 233280;
    if (rand < 0.4) return 0;
    return rand * 0.5;
  }, []);

  const buildTowerViewDataFromUnits = useCallback((
    unitsToUse: Array<TowerViewUnit | ComparableUnit>
  ): { blocks: Map<string, { floors: number[]; stacks: number[]; grid: Map<string, TowerViewUnit | ComparableUnit> }>; blockNumbers: string[] } => {
    if (unitsToUse.length === 0) {
      return { blocks: new Map<string, { floors: number[]; stacks: number[]; grid: Map<string, TowerViewUnit | ComparableUnit> }>(), blockNumbers: [] };
    }

    const blocksMap = new Map<string, { floors: number[]; stacks: number[]; grid: Map<string, TowerViewUnit | ComparableUnit> }>();
    const blockNumbersSet = new Set<string>();

    unitsToUse.forEach((unit) => {
      let blockNumber = unit.blockNumber;
      if (!blockNumber || blockNumber.trim() === '') {
        const unitNumMatch = unit.unitNumber.match(/[Bb]lk\s*(\d+)/i);
        blockNumber = unitNumMatch ? `Blk ${unitNumMatch[1]}` : 'Default';
      }

      blockNumbersSet.add(blockNumber);
      if (!blocksMap.has(blockNumber)) {
        blocksMap.set(blockNumber, { floors: [], stacks: [], grid: new Map() });
      }

      const blockData = blocksMap.get(blockNumber)!;
      const floorNumber = 'floorNumber' in unit ? unit.floorNumber : null;
      const parsed = parseUnitNumber(unit.unitNumber, floorNumber);
      if (parsed.floor !== null && parsed.stack !== null) {
        if (!blockData.floors.includes(parsed.floor)) blockData.floors.push(parsed.floor);
        if (!blockData.stacks.includes(parsed.stack)) blockData.stacks.push(parsed.stack);
        blockData.grid.set(`${parsed.floor}-${parsed.stack}`, unit);
      }
    });

    blocksMap.forEach((blockData) => {
      blockData.floors.sort((a, b) => b - a);
      blockData.stacks.sort((a, b) => a - b);
    });

    const blockNumbers = Array.from(blockNumbersSet).sort((a, b) => {
      const numA = parseInt(a.replace(/\D/g, ''), 10) || 0;
      const numB = parseInt(b.replace(/\D/g, ''), 10) || 0;
      if (numA !== numB) return numA - numB;
      return a.localeCompare(b);
    });

    const filteredBlockNumbers = blockNumbers.filter((block) => !(block === 'Default' && blockNumbers.length > 1));
    return { blocks: blocksMap, blockNumbers: filteredBlockNumbers };
  }, [parseUnitNumber]);

  const effectiveTowerViewUnits = useMemo(() => {
    if (!activePriceMatrixSimulationSession || towerViewUnits.length === 0) {
      return towerViewUnits;
    }
    const shouldApplySimulationStatuses = isAdminUser || activePriceMatrixSimulationSession.syncEnabled;
    const simulationUnitMap = new Map<number, PriceMatrixSimulationUnit>();
    activePriceMatrixSimulationSession.units.forEach((unit) => {
      simulationUnitMap.set(unit.unitId, unit);
    });

    return towerViewUnits.map((unit) => {
      const simulationUnit = simulationUnitMap.get(unit.id);
      const overrideStatus = shouldApplySimulationStatuses
        ? (activePriceMatrixSimulationSession.statusOverrides[String(unit.id)] ?? null)
        : null;
      if (!simulationUnit && !overrideStatus) {
        return unit;
      }
      const resolvedPrice =
        simulationUnit?.price
        ?? (
          simulationUnit?.psf != null
          && Number.isFinite(unit.areaSqft)
          && unit.areaSqft > 0
            ? simulationUnit.psf * unit.areaSqft
            : unit.price
        );
      const resolvedPsf =
        simulationUnit?.psf
        ?? (
          resolvedPrice != null
          && Number.isFinite(unit.areaSqft)
          && unit.areaSqft > 0
            ? resolvedPrice / unit.areaSqft
            : unit.psf
        );
      return {
        ...unit,
        price: Number.isFinite(resolvedPrice) ? resolvedPrice : unit.price,
        psf: Number.isFinite(resolvedPsf) ? resolvedPsf : unit.psf,
        unitStatus: shouldApplySimulationStatuses
          ? (overrideStatus ?? simulationUnit?.status ?? unit.unitStatus)
          : unit.unitStatus,
        unitStatusSource: shouldApplySimulationStatuses ? ('matrix' as const) : unit.unitStatusSource,
        unitStatusUpdatedAt: shouldApplySimulationStatuses ? activePriceMatrixSimulationSession.updatedAt : unit.unitStatusUpdatedAt,
      };
    });
  }, [activePriceMatrixSimulationSession, isAdminUser, towerViewUnits]);

  /** Guesstimation / price-matrix tower build for BEST PX BEDROOM TYPE (indicative projects only). */
  const topViewingGuesstimationBestByUnitType = useMemo((): BestByUnitTypeResponse | null => {
    if (!isTopViewingIndicativeBeforeLaunch) return null;
    if (
      !activePriceMatrixSimulationSession
      || !projectDetails?.id
      || activePriceMatrixSimulationSession.projectId !== projectDetails.id
    ) {
      return null;
    }
    const isEc = projectDetails.projectCategoryId === 'C1803';
    return buildBestByUnitTypeFromTowerUnits(
      effectiveTowerViewUnits,
      isEc,
      topViewingShowPsfColumnByDefault,
    );
  }, [
    isTopViewingIndicativeBeforeLaunch,
    activePriceMatrixSimulationSession,
    projectDetails?.id,
    projectDetails?.projectCategoryId,
    effectiveTowerViewUnits,
    topViewingShowPsfColumnByDefault,
  ]);

  /**
   * Prefer guesstimation price-guide data when present; otherwise fall back to database
   * (`/api/projects/best-by-unit-type`) so BEST PX BEDROOM TYPE is not empty.
   */
  const topViewingBestByUnitTypeForDisplay = useMemo((): BestByUnitTypeResponse | null => {
    if (!isTopViewingIndicativeBeforeLaunch) {
      return topViewingBestByUnitTypeData;
    }
    if (
      topViewingGuesstimationBestByUnitType
      && (topViewingGuesstimationBestByUnitType.unitTypes?.length ?? 0) > 0
    ) {
      return topViewingGuesstimationBestByUnitType;
    }
    return topViewingBestByUnitTypeData;
  }, [
    isTopViewingIndicativeBeforeLaunch,
    topViewingBestByUnitTypeData,
    topViewingGuesstimationBestByUnitType,
  ]);

  const topViewingBestByUnitTypeForDisplayLoading = useMemo(() => {
    if (!isTopViewingIndicativeBeforeLaunch) {
      return topViewingBestByUnitTypeLoading;
    }
    const hasGuesstimationRows =
      topViewingGuesstimationBestByUnitType != null
      && (topViewingGuesstimationBestByUnitType.unitTypes?.length ?? 0) > 0;
    if (hasGuesstimationRows) {
      return towerViewUnitsLoading && effectiveTowerViewUnits.length === 0;
    }
    return topViewingBestByUnitTypeLoading;
  }, [
    isTopViewingIndicativeBeforeLaunch,
    topViewingBestByUnitTypeLoading,
    topViewingGuesstimationBestByUnitType,
    towerViewUnitsLoading,
    effectiveTowerViewUnits.length,
  ]);

  const effectiveSitePlanStackSoldPercentages = useMemo(() => {
    if (!activePriceMatrixSimulationSession) {
      return sitePlanStackSoldPercentages;
    }
    const soldMap = new Map<string, number>();
    const stackCounts = new Map<string, { sold: number; total: number }>();
    effectiveTowerViewUnits.forEach((unit) => {
      const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
      if (parsed.stack == null) return;
      const stackKey = normalizeStackKey(parsed.stack);
      const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
      const compositeKey = blockNum ? `${blockNum}-${stackKey}` : null;
      const isSold = (unit.unitStatus || '').toString().toLowerCase() === 'sold';
      for (const key of [stackKey, compositeKey].filter(Boolean)) {
        const current = stackCounts.get(key!) ?? { sold: 0, total: 0 };
        current.total += 1;
        if (isSold) current.sold += 1;
        stackCounts.set(key!, current);
      }
    });
    stackCounts.forEach((count, key) => {
      soldMap.set(key, count.total > 0 ? Math.round((count.sold / count.total) * 100) : 0);
    });
    return soldMap;
  }, [activePriceMatrixSimulationSession, effectiveTowerViewUnits, normalizeStackKey, parseUnitNumber, sitePlanStackSoldPercentages]);

  // Organize units for tower view grouped by block
  const towerViewData = useMemo<{ blocks: Map<string, { floors: number[]; stacks: number[]; grid: Map<string, TowerViewUnit | ComparableUnit> }>; blockNumbers: string[] }>(() => {
    // Use towerViewUnits if available (all units), otherwise fallback to comparable units
    const unitsToUse = effectiveTowerViewUnits.length > 0
      ? effectiveTowerViewUnits
      : (() => {
          if (!referenceUnit) return [];
          
          // Convert reference unit and comparable units to TowerViewUnit format
          const referenceAsUnit: TowerViewUnit = {
            id: referenceUnit.id,
            projectName: referenceUnit.projectName,
            unitNumber: referenceUnit.unitNumber,
            blockNumber: referenceUnit.blockNumber || null,
            bedroom: referenceUnit.bedroom,
            bathroom: referenceUnit.bathroom,
            areaSqft: referenceUnit.areaSqft,
            price: referenceUnit.price,
            psf: referenceUnit.psf,
            unitStatus: referenceUnit.unitStatus ?? null,
          };
          
          const comparableAsUnits: TowerViewUnit[] = originalComparableUnits.map((unit) => ({
            id: unit.id,
            projectName: unit.projectName,
            unitNumber: unit.unitNumber,
            blockNumber: unit.blockNumber || null,
            bedroom: unit.bedroom,
            bathroom: unit.bathroom,
            areaSqft: unit.areaSqft,
            price: unit.price,
            psf: unit.psf,
            unitStatus: unit.unitStatus || null,
          }));
          
          return [...comparableAsUnits, referenceAsUnit];
        })();
    
    return buildTowerViewDataFromUnits(unitsToUse);
  }, [effectiveTowerViewUnits, originalComparableUnits, referenceUnit, buildTowerViewDataFromUnits]);
  const towerViewDialogData = useMemo(
    () => buildTowerViewDataFromUnits(towerViewDialogUnits),
    [buildTowerViewDataFromUnits, towerViewDialogUnits]
  );
  const towerViewDataForDialog = towerViewIsolatedFromMain ? towerViewDialogData : towerViewData;
  const towerViewUnitTypesForDialog = towerViewIsolatedFromMain ? towerViewDialogUnitTypes : towerViewUnitTypes;
  const towerViewSitePlanForDialog = towerViewIsolatedFromMain ? towerViewDialogSitePlanData : sitePlanData;
  const towerViewUnitsForDialog = towerViewIsolatedFromMain ? towerViewDialogUnits : effectiveTowerViewUnits;
  const towerViewSelectedStackKey = useMemo(() => {
    if (!selectedUnitForTowerView?.unitNumber) return null;
    const parsed = parseUnitNumber(selectedUnitForTowerView.unitNumber);
    if (parsed.stack == null) return null;
    return normalizeStackKey(parsed.stack);
  }, [selectedUnitForTowerView, parseUnitNumber, normalizeStackKey]);

  const towerViewUnitTypesForDialogFiltered = useMemo(() => {
    if (towerViewBedroomFilter.length === 0) return towerViewUnitTypesForDialog;
    const matchedTypes = new Set<string>();

    towerViewUnitsForDialog.forEach((unit) => {
      if (!unit.unitType) return;
      const unitBedroom = normalizeBedroomValue(unit.bedroom);
      if (matchesBedroomSelection(unitBedroom, isPenthouseUnit(unit), towerViewBedroomFilter)) {
        matchedTypes.add(unit.unitType);
      }
    });

    return towerViewUnitTypesForDialog.filter((type) => matchedTypes.has(type));
  }, [towerViewBedroomFilter, towerViewUnitTypesForDialog, towerViewUnitsForDialog, normalizeBedroomValue, isPenthouseUnit, matchesBedroomSelection]);

  useEffect(() => {
    const allowedTypes = new Set(towerViewUnitTypesForDialogFiltered);
    setTowerViewUnitTypeFilter((prev) => prev.filter((type) => allowedTypes.has(type)));
  }, [towerViewUnitTypesForDialogFiltered]);
  const towerViewBedroomFilterOptionsForDialog = useMemo<number[]>(() => {
    const bedroomSet = new Set<number>();
    let hasPenthouse = false;
    towerViewUnitsForDialog.forEach((unit) => {
      const unitIsPenthouse = isPenthouseUnit(unit);
      if (unitIsPenthouse) {
        hasPenthouse = true;
        return;
      }
      const bedroom = normalizeBedroomValue(unit.bedroom);
      if (bedroom != null && bedroom > 0) bedroomSet.add(bedroom);
    });
    const options = Array.from(bedroomSet).sort((a, b) => a - b);
    if (hasPenthouse) options.push(PENTHOUSE_FILTER_VALUE);
    return options;
  }, [towerViewUnitsForDialog, normalizeBedroomValue, isPenthouseUnit, PENTHOUSE_FILTER_VALUE]);
  const towerViewStackAnalysisProjectName = towerViewIsolatedFromMain
    ? (selectedUnitForTowerView?.projectName || '')
    : sitePlanProjectName;

  // When isolated (e.g. from Project Research), compute sold % from units since API isn't called
  const towerViewStackSoldPercentagesForDialog = useMemo(() => {
    if (!towerViewIsolatedFromMain) return effectiveSitePlanStackSoldPercentages;
    const soldMap = new Map<string, number>();
    const stackCounts = new Map<string, { sold: number; total: number }>();
    towerViewDialogUnits.forEach((unit) => {
      const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
      if (parsed.stack == null) return;
      const stackKey = normalizeStackKey(parsed.stack);
      const blockNum = (unit.blockNumber || '').replace(/\D/g, '');
      const compositeKey = blockNum ? `${blockNum}-${stackKey}` : null;
      const isSold = (unit.unitStatus || '').toString().toLowerCase() === 'sold';
      for (const key of [stackKey, compositeKey].filter(Boolean)) {
        const c = stackCounts.get(key!) || { sold: 0, total: 0 };
        c.total += 1;
        if (isSold) c.sold += 1;
        stackCounts.set(key!, c);
      }
    });
    stackCounts.forEach((count, key) => {
      soldMap.set(key, count.total > 0 ? Math.round((count.sold / count.total) * 100) : 0);
    });
    return soldMap;
  }, [towerViewIsolatedFromMain, towerViewDialogUnits, effectiveSitePlanStackSoldPercentages, parseUnitNumber, normalizeStackKey]);

  const topViewingFilteredAvailableUnits = useMemo(() => {
    const hasBedroomFilter = sitePlanBedroomFilter.length > 0;
    const hasUnitTypeFilter = sitePlanUnitTypeFilterExpanded.length > 0;
    const hasStackFilter = sitePlanStackFilter.length > 0;

    return effectiveTowerViewUnits.filter((unit) => {
      const status = (unit.unitStatus || '').toString().toLowerCase();
      // Exclude sold and not-released units from the Available Units list —
      // not-released units stay visible in the tower grid (without pricing)
      // but should not appear in the per-row available listing.
      if (status === 'sold' || isUnitStatusNotReleased(status)) {
        return false;
      }

      if (hasStackFilter && !unitMatchesSitePlanStackFilter(unit)) {
        return false;
      }

      // Match strictly on the unit's own bedroom count. We deliberately do NOT
      // fall back to the stack-level bedroom (`sitePlanStackBedrooms`): that map
      // stores the most-common bedroom per stack, so on vertically-mixed stacks
      // (e.g. 1-bed low floors + 2-bed above) it would drag genuinely 1-bed
      // units into the 2-bed filter.
      const unitBedroom = normalizeBedroomValue(unit.bedroom);
      const unitIsPenthouse = isPenthouseUnit(unit);
      const matchesBedroom = !hasBedroomFilter || sitePlanBedroomFilter.some((filterValue) => {
        if (filterValue === PENTHOUSE_FILTER_VALUE) return unitIsPenthouse;
        return !unitIsPenthouse && unitBedroom != null && unitBedroom === filterValue;
      });

      // Check unit type filter - use expanded filter so one description (e.g. "3 Bedroom Plus")
      // matches all unit types with that description (C5, C6, etc.)
      let matchesUnitType = !hasUnitTypeFilter;
      if (hasUnitTypeFilter && !matchesUnitType) {
        // Primary: Check by projectUnitTypeId
        if (unit.projectUnitTypeId != null && sitePlanUnitTypeFilterExpanded.includes(unit.projectUnitTypeId)) {
          matchesUnitType = true;
        }
        // Fallback: If projectUnitTypeId is null, check by unitType string.
        // sitePlanUnitTypes has one row per description, so id 11061 has no row; use expandedUnitTypes.
        else if (unit.unitType) {
          const selectedUnitTypes = sitePlanUnitTypeFilterExpanded
            .map(id => sitePlanUnitTypes.find(ut => ut.id === id))
            .filter((ut): ut is NonNullable<typeof ut> => ut != null);
          matchesUnitType =
            selectedUnitTypes.some(ut => ut.unitType === unit.unitType || ut.description === unit.unitType) ||
            sitePlanUnitTypeFilterExpandedUnitTypes.has(unit.unitType.trim());
        }
      }

      return matchesBedroom && matchesUnitType;
    });
  }, [effectiveTowerViewUnits, sitePlanBedroomFilter, sitePlanStackFilter, sitePlanUnitTypeFilterExpanded, sitePlanUnitTypeFilterExpandedUnitTypes, sitePlanUnitTypes, unitMatchesSitePlanStackFilter, normalizeBedroomValue, isPenthouseUnit, PENTHOUSE_FILTER_VALUE]);

  const topViewingBudgetRange = useMemo(() => {
    const referencePrice = topViewingReferenceUnit?.priceNps ?? topViewingReferenceUnit?.price;
    if (!topViewingReferenceUnit || referencePrice == null || !Number.isFinite(referencePrice) || referencePrice <= 0) {
      return null;
    }
    const percent = Math.max(0, topViewingBudgetTolerance);
    const base = referencePrice;
    const min = 1;
    const max = base * (1 + percent / 100);
    return { base, min, max, percent };
  }, [topViewingReferenceUnit, topViewingBudgetTolerance]);

  const topViewingBlinkerRange = useMemo(() => {
    const blinkerPrice = topViewingBlinkerChoiceUnit?.priceNps ?? topViewingBlinkerChoiceUnit?.price;
    if (!topViewingBlinkerChoiceUnit || blinkerPrice == null || !Number.isFinite(blinkerPrice) || blinkerPrice <= 0) {
      return null;
    }
    const minPercent = Math.min(0, Math.max(-50, topViewingBlinkerMinTolerance));
    const maxPercent = Math.max(0, Math.min(50, topViewingBlinkerTolerance));
    const base = blinkerPrice;
    const sliderMin = Math.max(0, base * (1 + minPercent / 100));
    const sliderMax = base * (1 + maxPercent / 100);
    const min = topViewingBlinkerMinPriceOverride != null && Number.isFinite(topViewingBlinkerMinPriceOverride)
      ? Math.max(0, topViewingBlinkerMinPriceOverride)
      : sliderMin;
    const max = topViewingBlinkerMaxPriceOverride != null && Number.isFinite(topViewingBlinkerMaxPriceOverride)
      ? Math.max(0, topViewingBlinkerMaxPriceOverride)
      : sliderMax;
    return { base, min, max, minPercent, maxPercent, percent: maxPercent };
  }, [
    topViewingBlinkerChoiceUnit,
    topViewingBlinkerMinTolerance,
    topViewingBlinkerTolerance,
    topViewingBlinkerMinPriceOverride,
    topViewingBlinkerMaxPriceOverride,
  ]);

  useEffect(() => {
    if (!topViewingBudgetRange) {
      setTopViewingBudgetSearchRange({ min: '', max: '' });
      setTopViewingBudgetDebouncedSearchRange({ min: '', max: '' });
      return;
    }

    const nextRange = {
      min: Math.round(Math.max(0, topViewingBudgetRange.min)).toLocaleString('en-US'),
      max: Math.round(Math.max(0, topViewingBudgetRange.max)).toLocaleString('en-US'),
    };
    setTopViewingBudgetSearchRange(nextRange);
    setTopViewingBudgetDebouncedSearchRange(nextRange);
  }, [topViewingBudgetRange]);

  const handleTopViewingBudgetSearchRangeChange = useCallback((bound: 'min' | 'max', value: string) => {
    setTopViewingBudgetSearchRange((prev) => ({
      ...prev,
      [bound]: value,
    }));
  }, []);

  const topViewingBudgetFetchRange = useMemo(() => {
    if (!topViewingBudgetRange) {
      return null;
    }
    const parseBudgetValue = (value: string): number | null => {
      const normalized = value.trim().replace(/,/g, '');
      if (!normalized) return null;
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const explicitMin = parseBudgetValue(topViewingBudgetDebouncedSearchRange.min);
    const explicitMax = parseBudgetValue(topViewingBudgetDebouncedSearchRange.max);
    const rangeMin = explicitMin ?? topViewingBudgetRange.min;
    const rangeMax = explicitMax ?? topViewingBudgetRange.max;
    const min = Math.max(0, Math.min(rangeMin, rangeMax));
    const max = Math.max(rangeMin, rangeMax);
    return { min, max };
  }, [topViewingBudgetRange, topViewingBudgetDebouncedSearchRange.min, topViewingBudgetDebouncedSearchRange.max]);

  const topViewingBudgetDetailedUnits = useMemo(() => {
    const referenceProjectName = topViewingReferenceUnit?.projectName?.trim().toLowerCase();
    return topViewingBudgetUnits
      .filter((unit) =>
        topViewingBudgetShowReferenceProjectUnits ||
        !referenceProjectName ||
        (unit.projectName ?? '').trim().toLowerCase() !== referenceProjectName
      )
      .map((unit) => {
        const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
        const isGroundFloor = String(unit.floorNumber ?? '').trim().toUpperCase() === 'G';
        const floor = isGroundFloor ? undefined : (parsed.floor ?? undefined);
        const stack = parsed.stack ?? undefined;
      const basePrice = unit.priceNps ?? unit.price ?? 0;
      const outlay = calculateOutlay(basePrice, loanToValue / 100);
      const installment = calculateInstallment(basePrice, loanToValue / 100, tenureYears, interestRate / 100);
      return {
        ...unit,
        floor,
        stack,
        psf: unit.psfNps ?? unit.psf ?? 0,
        outlay,
        installment,
      };
    });
  }, [
    topViewingBudgetUnits,
    loanToValue,
    tenureYears,
    interestRate,
    topViewingReferenceUnit?.projectName,
    topViewingBudgetShowReferenceProjectUnits,
  ]);

  const normalizeBudgetRegion = useCallback((value?: string | null): 'CCR' | 'OCR' | 'RCR' | null => {
    if (!value) return null;
    const upper = value.toString().trim().toUpperCase();
    if (upper.includes('CCR')) return 'CCR';
    if (upper.includes('OCR')) return 'OCR';
    if (upper.includes('RCR')) return 'RCR';
    return null;
  }, []);

  // Align budget region tab when the reference unit changes only — not when the user switches tabs
  // (including CCR). Previously, depending on `topViewingBudgetRegionTab` re-ran this after reset and
  // overwrote an explicit CCR selection with the reference unit's region (e.g. OCR).
  // Tower/selection units often omit `region`; fall back to ProjectDetails.area (same as project header).
  useEffect(() => {
    if (!topViewingReferenceUnit) return;
    const fromUnit = normalizeBudgetRegion(topViewingReferenceUnit.region);
    const details = projectDetailsMap.get(topViewingReferenceUnit.projectName);
    const fromProject = normalizeBudgetRegion(details?.area ?? null);
    const normalized = fromUnit ?? fromProject;
    if (!normalized) return;
    const key = `${topViewingReferenceUnit.projectName || ''}:${normalized}`;
    if (topViewingBudgetAutoRegionRef.current === key) return;
    topViewingBudgetAutoRegionRef.current = key;
    setTopViewingBudgetRegionTab((prev) => (prev === 'SUPER' ? prev : normalized));
  }, [normalizeBudgetRegion, projectDetailsMap, topViewingReferenceUnit]);

  useEffect(() => {
    if (topViewingBudgetPrevRegionTabRef.current === topViewingBudgetRegionTab) return;
    setTopViewingBudgetFilters({
      ...topViewingBudgetFiltersByRegion[topViewingBudgetRegionTab],
    });
    setTopViewingBudgetRangeFilters({
      ...topViewingBudgetRangeFiltersByRegion[topViewingBudgetRegionTab],
    });
    topViewingBudgetPrevRegionTabRef.current = topViewingBudgetRegionTab;
  }, [
    topViewingBudgetRegionTab,
    topViewingBudgetFiltersByRegion,
    topViewingBudgetRangeFiltersByRegion,
  ]);

  useEffect(() => {
    const debounceId = window.setTimeout(() => {
      setTopViewingBudgetDebouncedSearchRange({
        min: topViewingBudgetSearchRange.min,
        max: topViewingBudgetSearchRange.max,
      });
    }, 500);

    return () => {
      window.clearTimeout(debounceId);
    };
  }, [topViewingBudgetSearchRange.min, topViewingBudgetSearchRange.max]);

  const topViewingBudgetUnitsByRegion = useMemo(() => {
    if (topViewingBudgetRegionTab === 'ALL' || topViewingBudgetRegionTab === 'NEARBY' || topViewingBudgetRegionTab === 'SUPER') {
      return topViewingBudgetDetailedUnits;
    }
    return topViewingBudgetDetailedUnits.filter((unit) => normalizeBudgetRegion(unit.region) === topViewingBudgetRegionTab);
  }, [topViewingBudgetDetailedUnits, normalizeBudgetRegion, topViewingBudgetRegionTab]);

  const topViewingBudgetProjectsByRegion = useMemo(() => {
    const projectSet = new Set<string>();
    topViewingBudgetUnitsByRegion.forEach((unit) => {
      if (unit.projectName) {
        projectSet.add(unit.projectName);
      }
    });
    return Array.from(projectSet);
  }, [topViewingBudgetUnitsByRegion]);

  const topViewingBudgetUniqueFilterOptions = useMemo(() => {
    const projectNames = new Set<string>();
    const projectCategories = new Set<string>();
    const tenures = new Set<string>();
    const regions = new Set<string>();
    const nearestMrts = new Set<string>();
    const districts = new Set<string>();
    topViewingBudgetUnitsByRegion.forEach((unit) => {
      if (unit.projectName) projectNames.add(unit.projectName);
      const d = projectDetailsMap.get(unit.projectName);
      const cat = d?.projectCategory ?? '';
      if (cat) projectCategories.add(cat);
      const t = d?.tenure ?? '';
      if (t) tenures.add(t);
      const r = d?.area ?? '';
      if (r) regions.add(r);
      const m = d?.nearestMrt ?? '';
      if (m) nearestMrts.add(m);
      const dist = d?.district ?? '';
      if (dist) districts.add(dist);
    });
    return {
      projectName: Array.from(projectNames).sort(),
      projectCategory: Array.from(projectCategories).sort(),
      tenure: Array.from(tenures).sort(),
      region: Array.from(regions).sort(),
      nearestMrt: Array.from(nearestMrts).sort(),
      district: Array.from(districts).sort((a, b) => {
        const numA = parseInt(a.replace(/\D/g, ''), 10);
        const numB = parseInt(b.replace(/\D/g, ''), 10);
        return (numA || 0) - (numB || 0);
      }),
    };
  }, [topViewingBudgetUnitsByRegion, projectDetailsMap]);

  const topViewingBudgetProjectsKey = useMemo(() => {
    return topViewingBudgetProjectsByRegion.join(',');
  }, [topViewingBudgetProjectsByRegion]);

  // All unique project names from budget units (regardless of region tab) — used for
  // fetching project details so distance computation works on the NEARBY tab.
  const topViewingBudgetAllProjectNames = useMemo(() => {
    const projectSet = new Set<string>();
    topViewingBudgetDetailedUnits.forEach((unit) => {
      if (unit.projectName) projectSet.add(unit.projectName);
    });
    // Include reference project so its lat/lng is always available for distance calc
    if (topViewingReferenceUnit?.projectName) {
      projectSet.add(topViewingReferenceUnit.projectName);
    }
    return Array.from(projectSet);
  }, [topViewingBudgetDetailedUnits, topViewingReferenceUnit]);

  const topViewingBudgetAllProjectsKey = useMemo(() => {
    return topViewingBudgetAllProjectNames.join(',');
  }, [topViewingBudgetAllProjectNames]);

  const isBudgetProjectDetailsIncomplete = useCallback((details: ProjectDetails | undefined | null): boolean => {
    if (!details) return true;
    return (
      !details.projectCategory ||
      !details.developer ||
      details.totalUnits == null ||
      !details.tenure ||
      !details.area ||
      !details.district ||
      !details.nearestMrt ||
      details.walkingTimeToMrt == null
    );
  }, []);

  useEffect(() => {
    if (topViewingBudgetRegionTab !== 'SUPER') return;
    const projectIds = new Set<string>();
    topViewingBudgetDetailedUnits.forEach((unit) => {
      const details = projectDetailsMap.get(unit.projectName);
      if (details?.id) {
        projectIds.add(details.id);
      }
    });
    if (topViewingReferenceUnit) {
      const referenceDetails = projectDetailsMap.get(topViewingReferenceUnit.projectName);
      if (referenceDetails?.id) {
        projectIds.add(referenceDetails.id);
      }
    }
    const missingIds = Array.from(projectIds).filter((id) => !budgetAmenityDistances.has(id));
    if (missingIds.length === 0) return;

    let cancelled = false;
    const radiusMeters = 5000;

    const fetchAmenities = async () => {
      const results = await Promise.all(
        missingIds.map(async (projectId) => {
          try {
            const amenities = await api.getAmenities(projectId, radiusMeters);
            const schoolMeters = amenities.amenities.schools.length > 0
              ? Math.min(...amenities.amenities.schools.map((s) => s.distance))
              : null;
            const mrtMeters = amenities.amenities.mrtLrt.length > 0
              ? Math.min(...amenities.amenities.mrtLrt.map((m) => m.distance))
              : null;
            return [projectId, { schoolMeters, mrtMeters }] as const;
          } catch (error) {
            console.warn('Failed to fetch amenities for project', projectId, error);
            return [projectId, { schoolMeters: null, mrtMeters: null }] as const;
          }
        })
      );

      if (cancelled) return;
      setBudgetAmenityDistances((prev) => {
        const next = new Map(prev);
        results.forEach(([id, distances]) => next.set(id, distances));
        return next;
      });
    };

    fetchAmenities();
    return () => {
      cancelled = true;
    };
  }, [
    topViewingBudgetRegionTab,
    topViewingBudgetDetailedUnits,
    topViewingReferenceUnit,
    projectDetailsMap,
    budgetAmenityDistances
  ]);

  // Helper to get distance from TOP VIEWING reference unit to a given project
  const getTopViewingDistanceFromReference = useCallback((projectName: string): number | null => {
    if (!topViewingReferenceUnit) return null;

    const referenceProjectDetails = projectDetailsMap.get(topViewingReferenceUnit.projectName);
    const unitProjectDetails = projectDetailsMap.get(projectName);

    if (!referenceProjectDetails?.mapLatitude || !referenceProjectDetails?.mapLongitude ||
        !unitProjectDetails?.mapLatitude || !unitProjectDetails?.mapLongitude) {
      return null;
    }

    return calculateDistance(
      referenceProjectDetails.mapLatitude,
      referenceProjectDetails.mapLongitude,
      unitProjectDetails.mapLatitude,
      unitProjectDetails.mapLongitude
    );
  }, [topViewingReferenceUnit, projectDetailsMap]);

  const getBudgetAmenityDistances = useCallback(
    (projectName?: string | null): { schoolMeters: number | null; mrtMeters: number | null } => {
      if (!projectName) return { schoolMeters: null, mrtMeters: null };
      const details = projectDetailsMap.get(projectName);
      if (!details?.id) return { schoolMeters: null, mrtMeters: null };
      return budgetAmenityDistances.get(details.id) ?? { schoolMeters: null, mrtMeters: null };
    },
    [projectDetailsMap, budgetAmenityDistances]
  );

  const getTopViewingBudgetProjectDetails = useCallback((projectName: string): ProjectDetails | undefined => {
    const detailsFromMap = projectDetailsMap.get(projectName);
    const normalizedName = projectName.trim().toLowerCase();
    if (projectDetails?.name?.trim().toLowerCase() === normalizedName) {
      if (!detailsFromMap || isBudgetProjectDetailsIncomplete(detailsFromMap)) {
        return projectDetails;
      }
    }
    if (detailsFromMap) return detailsFromMap;
    if (projectDetails?.name?.trim().toLowerCase() === normalizedName) {
      return projectDetails;
    }
    return undefined;
  }, [isBudgetProjectDetailsIncomplete, projectDetails, projectDetailsMap]);

  const topViewingBudgetProjectsForView = useMemo(() => {
    return [...topViewingBudgetProjectsByRegion].sort((a, b) => {
      const distA = getTopViewingDistanceFromReference(a);
      const distB = getTopViewingDistanceFromReference(b);
      if (distA != null && distB != null) return distA - distB;
      if (distA != null) return -1;
      if (distB != null) return 1;
      return a.localeCompare(b);
    });
  }, [topViewingBudgetProjectsByRegion, getTopViewingDistanceFromReference]);

  const topViewingBudgetFilteredUnits = useMemo(() => {
    const toNum = (value: string): number | null => {
      const trimmed = value.trim();
      if (!trimmed) return null;
      const parsed = Number(trimmed);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const floorMin = toNum(topViewingBudgetRangeFilters.floor.min);
    const floorMax = toNum(topViewingBudgetRangeFilters.floor.max);
    const stackMin = toNum(topViewingBudgetRangeFilters.stack.min);
    const stackMax = toNum(topViewingBudgetRangeFilters.stack.max);
    const bedroomMin = toNum(topViewingBudgetRangeFilters.bedroom.min);
    const bedroomMax = toNum(topViewingBudgetRangeFilters.bedroom.max);
    const bathroomMin = toNum(topViewingBudgetRangeFilters.bathroom.min);
    const bathroomMax = toNum(topViewingBudgetRangeFilters.bathroom.max);
    const areaMin = toNum(topViewingBudgetRangeFilters.areaSqft.min);
    const areaMax = toNum(topViewingBudgetRangeFilters.areaSqft.max);
    const priceMin = toNum(topViewingBudgetRangeFilters.price.min);
    const priceMax = toNum(topViewingBudgetRangeFilters.price.max);
    const dpsMin = toNum(topViewingBudgetRangeFilters.dps.min);
    const dpsMax = toNum(topViewingBudgetRangeFilters.dps.max);
    const psfMin = toNum(topViewingBudgetRangeFilters.psf.min);
    const psfMax = toNum(topViewingBudgetRangeFilters.psf.max);
    const outlayMin = toNum(topViewingBudgetRangeFilters.outlay.min);
    const outlayMax = toNum(topViewingBudgetRangeFilters.outlay.max);
    const installmentMin = toNum(topViewingBudgetRangeFilters.installment.min);
    const installmentMax = toNum(topViewingBudgetRangeFilters.installment.max);
    const distanceMin = toNum(topViewingBudgetRangeFilters.distance.min);
    const distanceMax = toNum(topViewingBudgetRangeFilters.distance.max);
    const walkingTimeMin = toNum(topViewingBudgetRangeFilters.walkingTimeToMrt.min);
    const walkingTimeMax = toNum(topViewingBudgetRangeFilters.walkingTimeToMrt.max);

    const referenceFloor = topViewingReferenceUnit
      ? parseUnitNumber(topViewingReferenceUnit.unitNumber).floor
      : null;
    const referenceSize = topViewingReferenceUnit?.areaSqft ?? null;
    const referenceAmenities = getBudgetAmenityDistances(topViewingReferenceUnit?.projectName);

    return topViewingBudgetUnitsByRegion
      .map((unit) => {
        const unitAmenities = getBudgetAmenityDistances(unit.projectName);
        const reasons: string[] = [];

        if (referenceFloor != null && unit.floor != null && unit.floor > referenceFloor) {
          reasons.push('Higher floor');
        }
        if (referenceSize != null && unit.areaSqft > referenceSize) {
          reasons.push('Bigger size');
        }
        if (referenceAmenities.schoolMeters != null && unitAmenities.schoolMeters != null && unitAmenities.schoolMeters < referenceAmenities.schoolMeters) {
          reasons.push('Nearer school');
        }
        if (referenceAmenities.mrtMeters != null && unitAmenities.mrtMeters != null && unitAmenities.mrtMeters < referenceAmenities.mrtMeters) {
          reasons.push('Nearer MRT');
        }

        return {
          ...unit,
          distance: getTopViewingDistanceFromReference(unit.projectName),
          superScore: reasons.length,
          superReasons: reasons,
          nearestSchoolMeters: unitAmenities.schoolMeters,
          nearestMrtMeters: unitAmenities.mrtMeters,
        };
      })
      .filter((unit) => {
        const distance = unit.distance;
        const projectNameExcluded = topViewingBudgetExclusionFilters.projectName;
        const projectNamePass = projectNameExcluded.length === 0 || !projectNameExcluded.includes(unit.projectName);
        const blockPass = !topViewingBudgetFilters.blockNumber.trim()
          || (unit.blockNumber || '').toLowerCase().includes(topViewingBudgetFilters.blockNumber.trim().toLowerCase());
        const unitPass = !topViewingBudgetFilters.unitNumber.trim()
          || unit.unitNumber.toLowerCase().includes(topViewingBudgetFilters.unitNumber.trim().toLowerCase());
      const floorPass =
        (floorMin == null || (unit.floor != null && unit.floor >= floorMin)) &&
        (floorMax == null || (unit.floor != null && unit.floor <= floorMax));
      const stackPass =
        (stackMin == null || (unit.stack != null && unit.stack >= stackMin)) &&
        (stackMax == null || (unit.stack != null && unit.stack <= stackMax));
      const bedroomPass = (bedroomMin == null || unit.bedroom >= bedroomMin) && (bedroomMax == null || unit.bedroom <= bedroomMax);
      const bathroomPass = (bathroomMin == null || unit.bathroom >= bathroomMin) && (bathroomMax == null || unit.bathroom <= bathroomMax);
      const areaPass = (areaMin == null || unit.areaSqft >= areaMin) && (areaMax == null || unit.areaSqft <= areaMax);
      const pricePass = (priceMin == null || unit.price >= priceMin) && (priceMax == null || unit.price <= priceMax);
      const unitDps = unit.priceDps ?? 0;
      const dpsPass = (dpsMin == null || unitDps >= dpsMin) && (dpsMax == null || unitDps <= dpsMax);
        const psfPass = (psfMin == null || unit.psf >= psfMin) && (psfMax == null || unit.psf <= psfMax);
        const outlayPass = (outlayMin == null || unit.outlay >= outlayMin) && (outlayMax == null || unit.outlay <= outlayMax);
        const installmentPass = (installmentMin == null || unit.installment >= installmentMin) && (installmentMax == null || unit.installment <= installmentMax);
        const distancePass =
          (distanceMin == null || (distance != null && distance >= distanceMin)) &&
          (distanceMax == null || (distance != null && distance <= distanceMax));
        const d = projectDetailsMap.get(unit.projectName);
        const unitWalkingTime = d?.walkingTimeToMrt ?? null;
        const walkingTimePass =
          (walkingTimeMin == null || (unitWalkingTime != null && unitWalkingTime >= walkingTimeMin)) &&
          (walkingTimeMax == null || (unitWalkingTime != null && unitWalkingTime <= walkingTimeMax));
        const projectCategoryExcluded = topViewingBudgetExclusionFilters.projectCategory;
        const projectCategoryVal = d?.projectCategory ?? '';
        const projectCategoryPass = projectCategoryExcluded.length === 0 || !projectCategoryExcluded.includes(projectCategoryVal);
        const districtExcluded = topViewingBudgetExclusionFilters.district;
        const districtVal = d?.district ?? '';
        const districtPass = districtExcluded.length === 0 || !districtExcluded.includes(districtVal);
        const regionExcluded = topViewingBudgetExclusionFilters.region;
        const regionVal = d?.area ?? '';
        const regionPass = regionExcluded.length === 0 || !regionExcluded.includes(regionVal);
        const tenureExcluded = topViewingBudgetExclusionFilters.tenure;
        const tenureVal = d?.tenure ?? '';
        const tenurePass = tenureExcluded.length === 0 || !tenureExcluded.includes(tenureVal);
        const completedDatePass = !topViewingBudgetFilters.completedDate.trim()
          || (d?.completedDate ? new Date(d.completedDate).toLocaleDateString('en-SG', { year: 'numeric', month: 'short', day: 'numeric' }) : '').toLowerCase().includes(topViewingBudgetFilters.completedDate.trim().toLowerCase());
        const nearestMrtExcluded = topViewingBudgetExclusionFilters.nearestMrt;
        const nearestMrtVal = d?.nearestMrt ?? '';
        const nearestMrtPass = nearestMrtExcluded.length === 0 || !nearestMrtExcluded.includes(nearestMrtVal);
        const superPass = topViewingBudgetRegionTab !== 'SUPER' || (unit.superScore ?? 0) > 0;
        return projectNamePass && projectCategoryPass && blockPass && unitPass && floorPass && stackPass && bedroomPass && bathroomPass && areaPass && pricePass && dpsPass && psfPass && outlayPass && installmentPass && distancePass && walkingTimePass && districtPass && regionPass && tenurePass && completedDatePass && nearestMrtPass && superPass;
    });
  }, [
    topViewingBudgetUnitsByRegion,
    topViewingBudgetFilters,
    topViewingBudgetExclusionFilters,
    topViewingBudgetRangeFilters,
    getTopViewingDistanceFromReference,
    getBudgetAmenityDistances,
    topViewingReferenceUnit,
    topViewingBudgetRegionTab,
    projectDetailsMap,
  ]);

  const topViewingBudgetSortedUnits = useMemo(() => {
    const referenceProjectName = topViewingBudgetShowReferenceProjectUnits
      ? topViewingReferenceUnit?.projectName?.trim().toLowerCase()
      : '';
    const withReferenceProjectFirst = (units: typeof topViewingBudgetFilteredUnits) => {
      if (!referenceProjectName) return units;
      const referenceProjectUnits: typeof units = [];
      const otherUnits: typeof units = [];
      units.forEach((unit) => {
        if ((unit.projectName ?? '').trim().toLowerCase() === referenceProjectName) {
          referenceProjectUnits.push(unit);
        } else {
          otherUnits.push(unit);
        }
      });
      return referenceProjectUnits.length > 0 ? [...referenceProjectUnits, ...otherUnits] : units;
    };

    if (!topViewingBudgetSortConfig.column || topViewingBudgetSortConfig.direction === 'default') {
      if (topViewingBudgetRegionTab === 'SUPER') {
        const sorted = [...topViewingBudgetFilteredUnits].sort((a, b) => {
          const scoreA = a.superScore ?? 0;
          const scoreB = b.superScore ?? 0;
          if (scoreA !== scoreB) return scoreB - scoreA;
          return (a.price ?? 0) - (b.price ?? 0);
        });
        return withReferenceProjectFirst(sorted);
      }
      return withReferenceProjectFirst(topViewingBudgetFilteredUnits);
    }
    const projectDetailsCols = new Set(['district', 'region', 'tenure', 'completedDate', 'nearestMrt']);
    const getProjectDetailValue = (projectName: string, col: string): string => {
      const d = projectDetailsMap.get(projectName);
      if (!d) return '';
      switch (col) {
        case 'district': return d.district ?? '';
        case 'region': return d.area ?? '';
        case 'tenure': return d.tenure ?? '';
        case 'completedDate': return d.completedDate ? new Date(d.completedDate).toISOString() : '';
        case 'nearestMrt': return d.nearestMrt ?? '';
        default: return '';
      }
    };
    const sorted = [...topViewingBudgetFilteredUnits].sort((a, b) => {
      const col = topViewingBudgetSortConfig.column!;
      if (projectDetailsCols.has(col)) {
        const aVal = getProjectDetailValue(a.projectName, col);
        const bVal = getProjectDetailValue(b.projectName, col);
        return aVal.localeCompare(bVal);
      }
      if (col === 'dps') {
        const aVal = a.priceDps ?? 0;
        const bVal = b.priceDps ?? 0;
        return aVal - bVal;
      }
      const aVal = a[col as keyof typeof a];
      const bVal = b[col as keyof typeof b];
      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return 1;
      if (bVal == null) return -1;
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return aVal - bVal;
      }
      return String(aVal).localeCompare(String(bVal));
    });
    const sortedForDirection = topViewingBudgetSortConfig.direction === 'asc' ? sorted : sorted.reverse();
    return withReferenceProjectFirst(sortedForDirection);
  }, [
    topViewingBudgetFilteredUnits,
    topViewingBudgetRegionTab,
    topViewingBudgetShowReferenceProjectUnits,
    topViewingBudgetSortConfig,
    topViewingReferenceUnit?.projectName,
    projectDetailsMap,
  ]);

  const getBudgetProjectCellValue = useCallback((
    projectName: string,
    key: typeof PROJECT_VIEW_COLUMN_KEYS[number]
  ): string => {
    const d = getTopViewingBudgetProjectDetails(projectName);
    const getDistrictLocationStr = (details?: ProjectDetails): string => {
      if (!details) return '';
      if (details.districtLocation) return details.districtLocation;
      const parts = [details.area, details.district].filter(Boolean);
      return parts.length ? parts.join(' / ') : '';
    };
    switch (key) {
      case 'projectName':
        return projectName ?? '';
      case 'distance': {
        const dist = getTopViewingDistanceFromReference(projectName);
        return dist != null ? formatNumber(dist, 2) : '';
      }
      case 'projectCategory':
        return d?.projectCategory ?? '';
      case 'developer':
        return d?.developer ?? '';
      case 'totalUnits':
        return d?.totalUnits != null ? String(d.totalUnits) : '';
      case 'soldUnits':
        return d?.soldUnits != null ? String(d.soldUnits) : '';
      case 'districtLocation':
        return getDistrictLocationStr(d);
      case 'district':
        return d?.district ?? '';
      case 'region':
        return d?.area ?? '';
      case 'nearestMrt':
        return d?.nearestMrt ?? '';
      case 'walkingTimeToMrt':
        return d?.walkingTimeToMrt != null ? `${d.walkingTimeToMrt} min` : '';
      case 'tenure':
        return d?.tenure ?? '';
      case 'completedDate':
        return d?.completedDate ? new Date(d.completedDate).toLocaleDateString('en-SG', { year: 'numeric', month: 'short', day: 'numeric' }) : '';
      default: {
        const brMatch = key.match(/^(br[1-5]|ph)(avail|price|psf)$/);
        if (brMatch) {
          const brKey = brMatch[1] as 'br1' | 'br2' | 'br3' | 'br4' | 'br5' | 'ph';
          const sub = brMatch[2];
          const brData = d?.[brKey];
          if (!brData) return '';
          if (sub === 'avail') return String(brData.availableUnits ?? '');
          if (sub === 'price') return brData.fromPrice != null ? formatCurrency(brData.fromPrice) : '';
          if (sub === 'psf') return brData.fromPsf != null ? formatCurrency(brData.fromPsf) : '';
        }
        return '';
      }
    }
  }, [formatCurrency, formatNumber, getTopViewingBudgetProjectDetails, getTopViewingDistanceFromReference]);

  const handleTopViewingBudgetOpenPopover = (event: React.MouseEvent<HTMLElement>, column: string) => {
    event.stopPropagation();
    setTopViewingBudgetPopoverAnchor({ element: event.currentTarget, column });
  };

  const handleTopViewingBudgetClosePopover = () => {
    setTopViewingBudgetPopoverAnchor(null);
  };

  const handleTopViewingBudgetFilterChange = (column: keyof typeof topViewingBudgetFilters, value: string) => {
    setTopViewingBudgetFilters((prev) => ({ ...prev, [column]: value }));
    setTopViewingBudgetFiltersByRegion((prev) => ({
      ...prev,
      [topViewingBudgetRegionTab]: {
        ...prev[topViewingBudgetRegionTab],
        [column]: value,
      },
    }));
  };

  const handleTopViewingBudgetExclusionFilterChange = (column: string, value: string, excluded: boolean) => {
    const key = column as keyof TopViewingBudgetExclusionFilters;
    if (!['projectName', 'projectCategory', 'tenure', 'region', 'nearestMrt', 'district'].includes(column)) return;
    setTopViewingBudgetExclusionFilters((prev) => {
      const arr = prev[key] ?? [];
      const next = excluded ? [...arr, value] : arr.filter((v) => v !== value);
      return { ...prev, [key]: next };
    });
  };

  const handleTopViewingBudgetExclusionFilterSet = (column: string, excluded: string[]) => {
    const key = column as keyof TopViewingBudgetExclusionFilters;
    if (!['projectName', 'projectCategory', 'tenure', 'region', 'nearestMrt', 'district'].includes(column)) return;
    setTopViewingBudgetExclusionFilters((prev) => ({ ...prev, [key]: excluded }));
  };

  const handleTopViewingBudgetRangeFilterChange = (
    column: keyof typeof topViewingBudgetRangeFilters,
    bound: 'min' | 'max',
    value: string
  ) => {
    setTopViewingBudgetRangeFilters((prev) => ({
      ...prev,
      [column]: {
        ...prev[column],
        [bound]: value,
      },
    }));
    setTopViewingBudgetRangeFiltersByRegion((prev) => ({
      ...prev,
      [topViewingBudgetRegionTab]: {
        ...prev[topViewingBudgetRegionTab],
        [column]: {
          ...prev[topViewingBudgetRegionTab][column],
          [bound]: value,
        },
      },
    }));
  };

  const handleTopViewingBudgetSortChange = (column: string, direction: SortDirection) => {
    setTopViewingBudgetSortConfig({ column, direction });
  };

  const getTopViewingBudgetSortDirection = (column: string): SortDirection => {
    if (topViewingBudgetSortConfig.column !== column) return 'default';
    return topViewingBudgetSortConfig.direction;
  };

  const hasTopViewingBudgetActiveFilter = (column: string): boolean => {
    const exclusionCols = ['projectName', 'projectCategory', 'tenure', 'region', 'nearestMrt', 'district'] as const;
    if (exclusionCols.includes(column as any)) {
      const key = column === 'projectCategory' ? 'projectCategory' : column;
      const excluded = (topViewingBudgetExclusionFilters as Record<string, string[]>)[key] ?? [];
      return Array.isArray(excluded) && excluded.length > 0;
    }
    const textCols = ['blockNumber', 'unitNumber', 'completedDate'] as const;
    if (textCols.includes(column as any)) {
      const val = (topViewingBudgetFilters as Record<string, string>)[column] ?? '';
      return (val as string).trim() !== '';
    }
    const rangeCols = ['floor', 'stack', 'bedroom', 'bathroom', 'areaSqft', 'price', 'dps', 'psf', 'outlay', 'installment', 'distance', 'walkingTimeToMrt'] as const;
    if (rangeCols.includes(column as any)) {
      const range = (topViewingBudgetRangeFilters as Record<string, { min: string; max: string }>)[column];
      if (!range) return false;
      return (range.min ?? '').trim() !== '' || (range.max ?? '').trim() !== '';
    }
    return false;
  };

  const getTopViewingBudgetIconButtonSx = (column: string) => {
    const base = {
      p: 0.5,
      color: 'var(--color-text-strong)',
      '&:hover': {
        backgroundColor: 'var(--color-surface-ghost-strong)',
        color: 'var(--color-accent)',
      },
    };
    if (hasTopViewingBudgetActiveFilter(column)) {
      return { ...base, color: 'var(--color-accent)', bgcolor: 'rgba(255, 152, 0, 0.15)' };
    }
    return base;
  };

  const handleTopViewingBudgetClearFilters = () => {
    setTopViewingBudgetFilters(createDefaultTopViewingBudgetFilters());
    setTopViewingBudgetExclusionFilters(createDefaultTopViewingBudgetExclusionFilters());
    setTopViewingBudgetRangeFilters(createDefaultTopViewingBudgetRangeFilters());
    setTopViewingBudgetFiltersByRegion({
      ALL: createDefaultTopViewingBudgetFilters(),
      NEARBY: createDefaultTopViewingBudgetFilters(),
      CCR: createDefaultTopViewingBudgetFilters(),
      OCR: createDefaultTopViewingBudgetFilters(),
      RCR: createDefaultTopViewingBudgetFilters(),
      SUPER: createDefaultTopViewingBudgetFilters(),
    });
    setTopViewingBudgetRangeFiltersByRegion({
      ALL: createDefaultTopViewingBudgetRangeFilters(),
      NEARBY: createDefaultTopViewingBudgetRangeFilters(),
      CCR: createDefaultTopViewingBudgetRangeFilters(),
      OCR: createDefaultTopViewingBudgetRangeFilters(),
      RCR: createDefaultTopViewingBudgetRangeFilters(),
      SUPER: createDefaultTopViewingBudgetRangeFilters(),
    });
  };

  useEffect(() => {
    if (!topViewingDetailEntrySignature) {
      clearAllPriceMatrixSimulationSessions();
      setPriceMatrixSimulationError(null);
      topViewingDetailEntrySignatureRef.current = null;
      return;
    }
    if (topViewingDetailEntrySignatureRef.current === topViewingDetailEntrySignature) {
      return;
    }
    topViewingDetailEntrySignatureRef.current = topViewingDetailEntrySignature;
    clearAllPriceMatrixSimulationSessions();
    setPriceMatrixSimulationError(null);

    setProjectSectionExpanded(false);
    setProjectDetailsTab('details');
    setAmenitiesRadius(1000);
    setAmenitiesData(null);
    setProjectMembers(null);
    setSelectedAmenityTypes({
      mrtLrt: true,
      schools: true,
      preschools: true,
      supermarkets: true,
    });
    setDemandSupplyRadius(5000);
    setDemandSupplyMinRadius(0);
    setDemandSupplyData(null);
    setSelectedDemandSupplyTypes({
      hdbBtoMop: true,
      hdbResaleMop: true,
      condoSsd: false,
      newLaunch: true,
      gls: true,
    });

    setTopViewingTowerZoom(1);
    setTopViewingTowerDisplayOptions([...TOP_VIEWING_TOWER_DISPLAY_DEFAULT]);
    setTopViewingShowPsfColumnByDefault(true);
    setTopViewingSortConfig({ column: null, direction: 'default' });
    setTopViewingPopoverAnchor(null);
    setTopViewingAvailableUnitFilters(createDefaultTopViewingAvailableUnitFilters());
    setTopViewingUnitMenuAnchor(null);
    setTopViewingFloorPlanOpen(false);
    setTopViewingFloorPlanUrl(null);
    setTopViewingFloorPlanLoading(false);
    setTopViewingFloorPlanUnit(null);
    setTopViewingReferenceUnit(null);
    setTopViewingBlinkerChoiceUnit(null);
    setTopViewingBlinkerMinTolerance(-20);
    setTopViewingBlinkerTolerance(1);
    setTopViewingBlinkerMinPriceOverride(null);
    setTopViewingBlinkerMaxPriceOverride(null);
    setTopViewingAvailableUnitsViewMode('availableUnits');
    setTopViewingComparableUnits([]);
    setTopViewingComparableUnitsLoading(false);
    setTopViewingAreaTolerance(0);
    setTopViewingToleranceSliderValue(0);
    setTopViewingToleranceModalOpen(false);
    setTopViewingComparableSectionOpen(true);
    setTopViewingCompViewMode('unit');
    setTopViewingCompPopoverAnchor(null);
    setTopViewingCompFilters(createDefaultTopViewingCompFilters());
    setTopViewingCompRangeFilters(createDefaultTopViewingCompRangeFilters());
    // Keep compare basket when switching projects - allow cross-project comparison
    setTopViewingThumbsUpFilterActive(false);
    setTopViewingCompSortConfig({ column: null, direction: null });
    setTopViewingBestByUnitTypeData(null);
    setTopViewingBestByUnitTypeLoading(false);
    setTopViewingBestPxBedroomSitePlan(null);
    setTopViewingThumbsUpLegendAnchor(null);
    setTopViewingOutlayInfoAnchor(null);
    setTopViewingInstallmentInfoAnchor(null);

    setTopViewingBudgetSectionOpen(false);
    setTopViewingBudgetTolerance(5);
    setTopViewingBudgetSliderValue(5);
    setTopViewingBudgetUnits([]);
    setTopViewingBudgetUnitsLoading(false);
    setTopViewingBudgetUnitsError(null);
    setTopViewingBudgetViewMode('unit');
    setTopViewingBudgetShowReferenceProjectUnits(false);
    (() => {
      const projectName = topViewingDetailEntrySignature?.includes(':')
        ? topViewingDetailEntrySignature.replace(/^[^:]+:/, '').trim()
        : null;
      const details = projectName ? projectDetailsMap.get(projectName) : null;
      const area = details?.area?.toString().trim().toUpperCase() ?? '';
      const defaultTab: TopViewingBudgetRegionTab =
        area.includes('CCR') ? 'CCR' : area.includes('OCR') ? 'OCR' : area.includes('RCR') ? 'RCR' : 'CCR';
      setTopViewingBudgetRegionTab(defaultTab);
      topViewingBudgetAutoRegionRef.current = null;
      topViewingBudgetPrevRegionTabRef.current = defaultTab;
    })();
    setTopViewingBudgetPopoverAnchor(null);
    setTopViewingBudgetSortConfig({ column: null, direction: 'default' });
    setTopViewingBudgetFilters(createDefaultTopViewingBudgetFilters());
    setTopViewingBudgetExclusionFilters(createDefaultTopViewingBudgetExclusionFilters());
    setTopViewingBudgetRangeFilters(createDefaultTopViewingBudgetRangeFilters());
    setTopViewingBudgetSearchRange({ min: '', max: '' });
    setTopViewingBudgetDebouncedSearchRange({ min: '', max: '' });
    setTopViewingBudgetFiltersByRegion({
      ALL: createDefaultTopViewingBudgetFilters(),
      NEARBY: createDefaultTopViewingBudgetFilters(),
      CCR: createDefaultTopViewingBudgetFilters(),
      OCR: createDefaultTopViewingBudgetFilters(),
      RCR: createDefaultTopViewingBudgetFilters(),
      SUPER: createDefaultTopViewingBudgetFilters(),
    });
    setTopViewingBudgetRangeFiltersByRegion({
      ALL: createDefaultTopViewingBudgetRangeFilters(),
      NEARBY: createDefaultTopViewingBudgetRangeFilters(),
      CCR: createDefaultTopViewingBudgetRangeFilters(),
      OCR: createDefaultTopViewingBudgetRangeFilters(),
      RCR: createDefaultTopViewingBudgetRangeFilters(),
      SUPER: createDefaultTopViewingBudgetRangeFilters(),
    });

    topViewingLastFetchedProjectsRef.current = '';
    topViewingBudgetLastQueryKeyRef.current = '';
    topViewingBudgetLastFetchedProjectsRef.current = '';

    setSitePlanBedroomFilter([]);
    setSitePlanUnitTypeFilter([]);
    setSitePlanBlinkingStacks(new Set());
    setSitePlanMenuOpen(false);
    setSitePlanShowPoints(true);
    setSitePlanShowHeatMap(true);

    setSelectedBlock(TOWER_VIEW_ALL_TAB);
    setTowerViewAllDisplayOptions([...TOWER_VIEW_DISPLAY_OPTIONS]);
    setTowerViewAllMapMode('status');
    setTowerViewBedroomFilter([]);
    setTowerViewUnitTypeFilter([]);
    setTowerViewMainTab('tower');
    setTowerViewSiteMapMenuOpen(false);
    setTowerViewFloorPlanOpen(false);
    setSelectedTowerViewUnitForFloorPlan(null);
    setStackAnalysisOpen(false);
    setStackAnalysisData(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearAllPriceMatrixSimulationSessions, topViewingDetailEntrySignature]);

  const handleOpenBudgetInProjectResearch = useCallback((superMatch?: { bedroom: boolean; size: boolean; floor: boolean }) => {
    const normalizeNumeric = (value: string): string => value.trim().replace(/,/g, '');
    const includedValues = (options: string[], excluded: string[]): string[] => {
      if (excluded.length === 0) return [];
      return options.filter((option) => !excluded.includes(option));
    };

    const explicitPriceMin = normalizeNumeric(topViewingBudgetSearchRange.min);
    const explicitPriceMax = normalizeNumeric(topViewingBudgetSearchRange.max);
    const priceMin = explicitPriceMin || (topViewingBudgetRange ? String(Math.round(topViewingBudgetRange.min)) : '');
    const priceMax = explicitPriceMax || (topViewingBudgetRange ? String(Math.round(topViewingBudgetRange.max)) : '');

    const regionsFromExclusion = includedValues(
      topViewingBudgetUniqueFilterOptions.region,
      topViewingBudgetExclusionFilters.region
    );
    const regions = [...regionsFromExclusion];
    if (regions.length === 0 && topViewingBudgetRegionTab !== 'ALL' && topViewingBudgetRegionTab !== 'NEARBY') {
      regions.push(topViewingBudgetRegionTab);
    }

    const nextFilters: MasterToolSearchFilters = {
      priceMin,
      priceMax,
      psfMin: normalizeNumeric(topViewingBudgetRangeFilters.psf.min),
      psfMax: normalizeNumeric(topViewingBudgetRangeFilters.psf.max),
      sizeMin: normalizeNumeric(topViewingBudgetRangeFilters.areaSqft.min),
      sizeMax: normalizeNumeric(topViewingBudgetRangeFilters.areaSqft.max),
      floorMin: normalizeNumeric(topViewingBudgetRangeFilters.floor.min),
      floorMax: normalizeNumeric(topViewingBudgetRangeFilters.floor.max),
      bathMin: normalizeNumeric(topViewingBudgetRangeFilters.bathroom.min),
      bathMax: normalizeNumeric(topViewingBudgetRangeFilters.bathroom.max),
      bedroomMin: normalizeNumeric(topViewingBudgetRangeFilters.bedroom.min),
      bedroomMax: normalizeNumeric(topViewingBudgetRangeFilters.bedroom.max),
      districts: includedValues(
        topViewingBudgetUniqueFilterOptions.district,
        topViewingBudgetExclusionFilters.district
      ),
      regions,
      tenure: includedValues(
        topViewingBudgetUniqueFilterOptions.tenure,
        topViewingBudgetExclusionFilters.tenure
      ),
    };

    if (superMatch && topViewingReferenceUnit) {
      if (superMatch.bedroom) {
        const referenceBedroom = normalizeBedroomValue(topViewingReferenceUnit.bedroom);
        if (referenceBedroom != null) {
          nextFilters.bedroomMin = String(referenceBedroom);
          nextFilters.bedroomMax = '';
        }
      }
      if (superMatch.size) {
        const referenceAreaSqft = Number(topViewingReferenceUnit.areaSqft);
        if (Number.isFinite(referenceAreaSqft) && referenceAreaSqft > 0) {
          nextFilters.sizeMin = String(Math.round(referenceAreaSqft));
        }
      }
      if (superMatch.floor) {
        const referenceFloor = parseUnitNumber(topViewingReferenceUnit.unitNumber ?? '').floor;
        if (referenceFloor != null) {
          nextFilters.floorMin = String(referenceFloor);
        }
      }
    }

    setMasterToolFilters(nextFilters);
    setMasterToolViewMode('project');
    setActiveClientId(null);
    setActiveTabId('master');
  }, [
    topViewingBudgetRangeFilters,
    topViewingBudgetSearchRange,
    topViewingBudgetRange,
    topViewingBudgetUniqueFilterOptions,
    topViewingBudgetExclusionFilters,
    topViewingBudgetRegionTab,
    topViewingReferenceUnit,
  ]);

  // Fetch comparable units when reference unit is set
  useEffect(() => {
    if (
      !topViewingReferenceUnit
      || isTopViewingIndicativeBeforeLaunch
      || topViewingReferenceUnit.referenceSource === 'guesstimation'
    ) {
      setTopViewingComparableUnits([]);
      setTopViewingComparableUnitsLoading(false);
      return;
    }
    let cancelled = false;

    const fetchComparableUnits = async () => {
      setTopViewingComparableUnitsLoading(true);
      try {
        const projectId = await resolveProjectIdByName(topViewingReferenceUnit.projectName);
        if (!projectId) {
          setTopViewingComparableUnits([]);
          return;
        }

        const isIndicativeReference = topViewingReferenceUnit.referenceSource === 'indicative';
        const data = isIndicativeReference
          ? await api.getComparableUnitsIndicative(
              projectId,
              topViewingReferenceUnit.bedroom,
              topViewingReferenceUnit.price,
              topViewingReferenceUnit.indicativeSizeRange?.min,
              topViewingReferenceUnit.indicativeSizeRange?.max,
              0.75,
              30,
              0.03
            )
          : await api.getComparableUnits(
              projectId,
              topViewingReferenceUnit.unitNumber,
              0.75, // Default LTV 75%
              30, // Default tenure 30 years
              0.03, // Default interest rate 3%
              undefined,
              topViewingAreaTolerance
            );
        const filteredUnits = data.comparableUnits.filter((unit) => unit.price > 0);
        if (cancelled) return;
        const refPn = (topViewingReferenceUnit.projectName ?? '').trim();
        let scopedUnits = refPn ? filteredUnits.filter((u) => u.projectName === refPn) : filteredUnits;

        // API historically searched all projects; we only show the reference project. When that yields
        // no rows (or tower/API data differ), derive same-project matches from tower units already loaded.
        if (scopedUnits.length === 0 && effectiveTowerViewUnits.length > 0) {
          const ref = topViewingReferenceUnit;
          const refBed = normalizeBedroomValue(ref.bedroom);
          const refArea = ref.areaSqft ?? 0;
          const tol = Math.min(50, Math.max(0, topViewingAreaTolerance));
          if (refPn && refBed != null && refBed > 0 && refArea > 0) {
            const minA = refArea * (1 - tol / 100);
            const maxA = refArea * (1 + tol / 100);
            const refPrice = ref.priceNps ?? ref.price ?? 0;
            const refPsf = ref.psf ?? (refArea > 0 && refPrice > 0 ? refPrice / refArea : 0);
            const pnLower = refPn.toLowerCase();
            const normUn = (s: string) => s.replace(/^#/, '').trim().toLowerCase();
            const refUn = normUn(ref.unitNumber ?? '');

            const towerMatches = effectiveTowerViewUnits.filter((u) => {
              if ((u.projectName ?? '').trim().toLowerCase() !== pnLower) return false;
              if (u.id === ref.id) return false;
              if (normUn(u.unitNumber) === refUn) return false;
              if (normalizeBedroomValue(u.bedroom) !== refBed) return false;
              const area = u.areaSqft ?? 0;
              if (area < minA || area > maxA) return false;
              if (!(u.price > 0)) return false;
              if ((u.unitStatus || '').toLowerCase() === 'sold') return false;
              if (isUnitStatusNotReleased(u.unitStatus)) return false;
              return true;
            });

            if (towerMatches.length > 0) {
              scopedUnits = towerMatches.map((u) => {
                const price = u.price || 0;
                const areaSqft = u.areaSqft ?? 0;
                const psf = u.psf ?? (price && areaSqft ? price / areaSqft : 0);
                const outlay = calculateOutlay(price, loanToValue / 100);
                const installment = calculateInstallment(price, loanToValue / 100, tenureYears, interestRate / 100);
                return {
                  id: u.id,
                  projectName: u.projectName,
                  unitNumber: u.unitNumber,
                  blockNumber: u.blockNumber || null,
                  bedroom: u.bedroom,
                  bathroom: u.bathroom,
                  areaSqft,
                  price,
                  priceNps: u.priceNps ?? null,
                  priceDps: u.priceDps ?? null,
                  priceDiff: refPrice > 0 ? price - refPrice : 0,
                  priceDiffPercent: refPrice > 0 ? ((price - refPrice) / refPrice) * 100 : 0,
                  psf,
                  psfNps: u.psfNps ?? null,
                  psfDps: u.psfDps ?? null,
                  psfDiff: refPsf > 0 ? psf - refPsf : 0,
                  psfDiffPercent: refPsf > 0 ? ((psf - refPsf) / refPsf) * 100 : 0,
                  outlay,
                  outlayDiff: 0,
                  installment,
                  installmentDiff: 0,
                  unitStatus: u.unitStatus || null,
                  floorplan: u.floorplan || null,
                  unitTypeDescription: u.unitTypeDescription ?? u.unitType ?? null,
                };
              }).sort((a, b) => Math.abs(a.priceDiff) - Math.abs(b.priceDiff));
            }
          }
        }

        setTopViewingComparableUnits(scopedUnits);

        const uniqueProjectNames = Array.from(new Set([
          data.referenceUnit.projectName,
          ...scopedUnits.map((u) => u.projectName),
        ])).filter(Boolean);

        const projectsToFetch = uniqueProjectNames.filter((projectName) => {
          const existing = projectDetailsMap.get(projectName);
          return !existing || (existing.name === projectName && !existing.developer && !existing.totalUnits);
        });

        if (projectsToFetch.length > 0) {
          void (async () => {
            try {
              const projectIds = await resolveProjectIdsByName(projectsToFetch);
              if (projectIds.length === 0 || cancelled) {
                return;
              }
              const projectDetailsList = await api.getBulkProjectDetails(projectIds);
              if (cancelled) {
                return;
              }
              const projectDetailsMapNew = new Map<string, ProjectDetails>();
              projectDetailsList.forEach((details) => {
                if (details.name) {
                  projectDetailsMapNew.set(details.name, details);
                }
              });
              setProjectDetailsMap((prevMap) => {
                const merged = new Map(prevMap);
                projectDetailsMapNew.forEach((value, key) => merged.set(key, value));
                return merged;
              });
            } catch (err) {
              console.error('Failed to fetch top viewing project details for distance calculation:', err);
            }
          })();
        }
      } catch (error) {
        console.error('Error fetching comparable units:', error);
        if (!cancelled) {
          setTopViewingComparableUnits([]);
        }
      } finally {
        if (!cancelled) {
          setTopViewingComparableUnitsLoading(false);
        }
      }
    };

    fetchComparableUnits();
    return () => {
      cancelled = true;
    };
  }, [
    effectiveTowerViewUnits,
    interestRate,
    isTopViewingIndicativeBeforeLaunch,
    loanToValue,
    resolveProjectIdByName,
    tenureYears,
    topViewingAreaTolerance,
    topViewingReferenceUnit,
  ]);

  useEffect(() => {
    if (!topViewingReferenceUnit) {
      setTopViewingBudgetUnits([]);
      setTopViewingBudgetUnitsError(null);
    }
  }, [topViewingReferenceUnit]);

  useEffect(() => {
    if (topViewingBudgetSectionOpen) {
      setTopViewingBudgetSliderValue(topViewingBudgetTolerance);
    }
  }, [topViewingBudgetSectionOpen, topViewingBudgetTolerance]);

  useEffect(() => {
    const inTopViewingContext = activeTabId === TOP_VIEWING_SITE_PLANS_TAB || showTopViewingDetailInGeneric;
    if (!inTopViewingContext) {
      return;
    }
    if (!topViewingReferenceUnit || !topViewingBudgetFetchRange) {
      setTopViewingBudgetUnits([]);
      setTopViewingBudgetUnitsError(null);
      return;
    }

    let isActive = true;
    const fetchBudgetUnits = async () => {
      setTopViewingBudgetUnitsLoading(true);
      setTopViewingBudgetUnitsError(null);
      try {
        const queryKey = `all:${Math.round(topViewingBudgetFetchRange.min)}:${Math.round(topViewingBudgetFetchRange.max)}`;
        if (topViewingBudgetLastQueryKeyRef.current === queryKey && topViewingBudgetUnits.length > 0) {
          setTopViewingBudgetUnitsLoading(false);
          return;
        }

        const units = await api.getAvailableUnitsByBudget(
          topViewingBudgetFetchRange.min,
          topViewingBudgetFetchRange.max
        );
        if (!isActive) return;
        topViewingBudgetLastQueryKeyRef.current = queryKey;
        setTopViewingBudgetUnits(units);
      } catch (err) {
        if (!isActive) return;
        setTopViewingBudgetUnitsError(err instanceof Error ? err.message : 'Failed to fetch budget-matched units');
        setTopViewingBudgetUnits([]);
      } finally {
        if (isActive) setTopViewingBudgetUnitsLoading(false);
      }
    };

    fetchBudgetUnits();
    return () => {
      isActive = false;
    };
  }, [
    activeTabId,
    showTopViewingDetailInGeneric,
    topViewingBudgetSectionOpen,
    topViewingReferenceUnit,
    topViewingBudgetFetchRange,
    topViewingBudgetUnits.length,
  ]);

  useEffect(() => {
    const fetchBudgetProjectDetails = async () => {
      if (!topViewingBudgetSectionOpen || topViewingBudgetAllProjectNames.length === 0) {
        return;
      }

      const projectsToFetch = topViewingBudgetAllProjectNames.filter((projectName) => {
        const existing = getTopViewingBudgetProjectDetails(projectName);
        return isBudgetProjectDetailsIncomplete(existing);
      });
      const projectsToFetchKey = [
        topViewingBudgetAllProjectsKey,
        topViewingBudgetShowReferenceProjectUnits ? 'with-reference-project-units' : 'without-reference-project-units',
        projectsToFetch.join(','),
      ].join('|');

      if (
        projectsToFetch.length === 0 ||
        projectsToFetchKey === topViewingBudgetLastFetchedProjectsRef.current
      ) {
        return;
      }

      topViewingBudgetLastFetchedProjectsRef.current = projectsToFetchKey;
      try {
        const projectIds = await resolveProjectIdsByName(projectsToFetch);
        if (projectIds.length === 0) return;
        const details = await api.getBulkProjectDetails(projectIds);
        setProjectDetailsMap((prevMap) => {
          const merged = new Map(prevMap);
          details.forEach((d) => {
            if (d.name) merged.set(d.name, d);
          });
          return merged;
        });
      } catch (err) {
        console.error('Failed to fetch budget project details:', err);
      }
    };

    fetchBudgetProjectDetails();
  }, [
    topViewingBudgetSectionOpen,
    topViewingBudgetAllProjectNames,
    topViewingBudgetAllProjectsKey,
    topViewingBudgetShowReferenceProjectUnits,
    getTopViewingBudgetProjectDetails,
    isBudgetProjectDetailsIncomplete,
    resolveProjectIdsByName,
  ]);

  // Get unique project names from TOP VIEWING comparable units
  const topViewingComparableResultProjectNames = useMemo(() => {
    const projectNames = new Set<string>();
    topViewingComparableUnits.forEach(unit => projectNames.add(unit.projectName));
    return Array.from(projectNames).sort();
  }, [topViewingComparableUnits]);
  const topViewingComparableResultProjectCategories = useMemo(() => {
    const projectCategories = new Set<string>();
    topViewingComparableResultProjectNames.forEach((projectName) => {
      const category = (projectDetailsMap.get(projectName)?.projectCategory ?? '').trim();
      if (category) {
        projectCategories.add(category);
      }
    });
    return Array.from(projectCategories).sort((a, b) => a.localeCompare(b));
  }, [projectDetailsMap, topViewingComparableResultProjectNames]);
  const topViewingComparableResultUnitTypeDescriptions = useMemo(() => {
    const descriptions = new Set<string>();
    topViewingComparableUnits.forEach(unit => {
      if (unit.unitTypeDescription) descriptions.add(unit.unitTypeDescription);
    });
    return Array.from(descriptions).sort((a, b) => a.localeCompare(b));
  }, [topViewingComparableUnits]);

  // Keep TOP VIEWING best-matched project filter pinned to the reference project
  useEffect(() => {
    if (!topViewingReferenceUnit) return;
    const refName = topViewingReferenceUnit.projectName;
    if (!refName) return;
    setTopViewingCompFilters((prev) => {
      if (prev.projectName.length === 1 && prev.projectName[0] === refName) return prev;
      return { ...prev, projectName: [refName] };
    });
  }, [topViewingReferenceUnit?.projectName, topViewingReferenceUnit?.referenceSource, topViewingComparableUnits.length]);

  useEffect(() => {
    const activeTopViewingBestPxProjectName =
      topViewingReferenceUnit?.projectName ||
      selectedTopViewingSitePlan ||
      genericSelectedTopViewingSitePlan ||
      sitePlanProjectName;

    if (topViewingAvailableUnitsViewMode !== 'bestPxBedroom' || !activeTopViewingBestPxProjectName) {
      setTopViewingBestByUnitTypeData(null);
      setTopViewingBestByUnitTypeLoading(false);
      return;
    }
    let cancelled = false;
    setTopViewingBestByUnitTypeLoading(true);
    fetchBestByUnitType(activeTopViewingBestPxProjectName)
      .then((data) => {
        if (!cancelled) setTopViewingBestByUnitTypeData(data);
      })
      .catch(() => {
        if (!cancelled) setTopViewingBestByUnitTypeData(null);
      })
      .finally(() => {
        if (!cancelled) setTopViewingBestByUnitTypeLoading(false);
      });
    return () => { cancelled = true; };
  }, [fetchBestByUnitType, genericSelectedTopViewingSitePlan, selectedTopViewingSitePlan, sitePlanProjectName, topViewingAvailableUnitsViewMode, topViewingReferenceUnit?.projectName]);

  useEffect(() => {
    const activeTopViewingBestPxProjectName =
      topViewingReferenceUnit?.projectName ||
      selectedTopViewingSitePlan ||
      genericSelectedTopViewingSitePlan ||
      sitePlanProjectName;

    if (
      (topViewingAvailableUnitsViewMode !== 'bestPxBedroom' && topViewingAvailableUnitsViewMode !== 'bestPsfBedroom')
      || !activeTopViewingBestPxProjectName
      || isTopViewingIndicativeBeforeLaunch
    ) {
      setTopViewingBestPxBedroomSitePlan(null);
      return;
    }
    let cancelled = false;
    fetchSitePlan(activeTopViewingBestPxProjectName)
      .then(({ sitePlan }) => { if (!cancelled) setTopViewingBestPxBedroomSitePlan(sitePlan); })
      .catch(() => { if (!cancelled) setTopViewingBestPxBedroomSitePlan(null); });
    return () => { cancelled = true; };
  }, [fetchSitePlan, genericSelectedTopViewingSitePlan, isTopViewingIndicativeBeforeLaunch, selectedTopViewingSitePlan, sitePlanProjectName, topViewingAvailableUnitsViewMode, topViewingReferenceUnit?.projectName]);

  // Top Viewing Comparable Units filter handlers
  const handleTopViewingCompOpenPopover = (event: React.MouseEvent<HTMLElement>, column: TopViewingCompColumnKey) => {
    setTopViewingCompPopoverAnchor({ element: event.currentTarget, column });
  };

  const handleTopViewingCompClosePopover = () => {
    setTopViewingCompPopoverAnchor(null);
  };

  const getTopViewingCompColumnLabel = (column: TopViewingCompColumnKey): string => {
    const labels: Record<TopViewingCompColumnKey, string> = {
      projectName: 'Project Name',
      projectCategory: 'Project Category',
      blockNumber: 'Block',
      floor: 'Floor',
      stack: 'Stack',
      unitTypeDescription: 'Unit Type',
      bedroom: 'Bed',
      bathroom: 'Bath',
      areaSqft: 'Area (sqft)',
      price: 'Price $',
      psf: 'PSF $',
      dps: 'DPS $',
      outlay: 'Outlay $',
      installment: 'Installment $',
      distance: 'Distance',
    };
    return labels[column];
  };

  const hasTopViewingCompActiveFilter = (column: TopViewingCompColumnKey): boolean => {
    if (column === 'projectName') {
      const projectFilter = topViewingCompFilters.projectName;
      // Active if not showing all projects (i.e., length is less than all available or greater than 0)
      return projectFilter.length > 0 && projectFilter.length < topViewingComparableResultProjectNames.length;
    }
    if (column === 'projectCategory') {
      return topViewingCompFilters.projectCategory.length > 0;
    }
    if (column === 'blockNumber') {
      return topViewingCompFilters.blockNumber.trim() !== '';
    }
    if (column === 'unitTypeDescription') {
      return topViewingCompFilters.unitTypeDescription.length > 0;
    }
    const rangeColumn = column as keyof typeof debouncedTopViewingCompRangeFilters;
    if (rangeColumn in debouncedTopViewingCompRangeFilters) {
      return debouncedTopViewingCompRangeFilters[rangeColumn].min.trim() !== '' || debouncedTopViewingCompRangeFilters[rangeColumn].max.trim() !== '';
    }
    return false;
  };

  const handleTopViewingCompFilterChange = (column: 'projectName' | 'projectCategory' | 'blockNumber' | 'unitTypeDescription', value: string | string[]) => {
    if (column === 'projectName') {
      const refName = topViewingReferenceUnit?.projectName;
      if (refName) {
        setTopViewingCompFilters((prev) => ({ ...prev, projectName: [refName] }));
        return;
      }
      setTopViewingCompFilters({ ...topViewingCompFilters, projectName: value as string[] });
    } else if (column === 'projectCategory') {
      setTopViewingCompFilters({ ...topViewingCompFilters, projectCategory: value as string[] });
    } else if (column === 'unitTypeDescription') {
      setTopViewingCompFilters({ ...topViewingCompFilters, unitTypeDescription: value as string[] });
    } else {
      setTopViewingCompFilters({ ...topViewingCompFilters, blockNumber: value as string });
    }
  };

  const handleTopViewingCompRangeFilterChange = (
    column: keyof typeof topViewingCompRangeFilters,
    type: 'min' | 'max',
    value: string
  ) => {
    const currentRange = topViewingCompRangeFilters[column] ?? { min: '', max: '' };
    setTopViewingCompRangeFilters({
      ...topViewingCompRangeFilters,
      [column]: {
        ...currentRange,
        [type]: value,
      },
    });
  };

  const toTopViewingComparableUnit = useCallback((unit: TowerViewUnit | ComparableUnit | { id: number; projectName: string; unitNumber: string; blockNumber?: string | null; bedroom?: number; bedroomNumber?: number; bathroom?: number; bathroomNumber?: number; areaSqft?: number; size?: number | null; price?: number; psf?: number; unitStatus?: string | null; floorplan?: string | null }): ComparableUnit => {
    if ('priceDiff' in unit) {
      return unit as ComparableUnit;
    }
    const price = unit.price || 0;
    const bedroom = unit.bedroom ?? (unit as any).bedroomNumber ?? 0;
    const bathroom = unit.bathroom ?? (unit as any).bathroomNumber ?? 0;
    const areaSqft = unit.areaSqft ?? (unit as any).size ?? 0;
    return {
      id: unit.id,
      projectName: unit.projectName,
      unitNumber: unit.unitNumber,
      blockNumber: unit.blockNumber || null,
      bedroom,
      bathroom,
      areaSqft,
      price,
      priceDiff: 0,
      priceDiffPercent: 0,
      psf: unit.psf ?? (unit as any).pricePSF ?? (price && areaSqft ? price / areaSqft : 0),
      psfDiff: 0,
      psfDiffPercent: 0,
      outlay: calculateOutlay(price, loanToValue / 100),
      outlayDiff: 0,
      installment: calculateInstallment(price, loanToValue / 100, tenureYears, interestRate / 100),
      installmentDiff: 0,
      unitStatus: unit.unitStatus || null,
      floorplan: unit.floorplan || null,
    };
  }, [calculateInstallment, calculateOutlay, interestRate, loanToValue, tenureYears]);

  // Handler for adding/removing units from TOP VIEWING floor plan comparison
  const handleTopViewingAddToUnitCompare = (unit: TowerViewUnit | ComparableUnit) => {
    if (isExternalUser) return;
    const mappedUnit = toTopViewingComparableUnit(unit);
    const existingIndex = topViewingFloorPlansToCompare.findIndex(fp => fp.unit.id === mappedUnit.id);

    if (existingIndex >= 0) {
      // Remove from comparison
      setTopViewingFloorPlansToCompare(topViewingFloorPlansToCompare.filter((_, idx) => idx !== existingIndex));
    } else if (topViewingFloorPlansToCompare.length < 3 && mappedUnit.floorplan) {
      // Add to comparison (max 3 units)
      logCompareAdd({
        projectName: mappedUnit.projectName,
        unitNumber: mappedUnit.unitNumber,
        unitId: mappedUnit.id,
        source: 'top_viewing_floor_plan_compare',
        ceaNumber: userInfo?.CEANumber || getDevCea(),
      });
      setTopViewingFloorPlansToCompare([...topViewingFloorPlansToCompare, {
        unit: mappedUnit,
        imageUrl: mappedUnit.floorplan,
      }]);
    }
  };

  const handleTopViewingIndicativeReference = useCallback((params: {
    projectName: string;
    bedroom: number;
    price: number;
    sizeRange: { min: number; max: number };
    priceLabel?: string;
  }) => {
    const { projectName, bedroom, price, sizeRange, priceLabel } = params;
    if (!projectName || !Number.isFinite(price) || price <= 0) return;
    if (!sizeRange || !Number.isFinite(sizeRange.min) || !Number.isFinite(sizeRange.max)) return;

    const referenceArea = (sizeRange.min + sizeRange.max) / 2;
    const normalizedPriceLabel = (priceLabel ?? '').trim().toLowerCase();
    const directionalLabel = normalizedPriceLabel === 'from' || normalizedPriceLabel === 'low'
      ? 'From'
      : normalizedPriceLabel === 'to' || normalizedPriceLabel === 'high'
        ? 'To'
        : '';
    const referenceLabel = directionalLabel
      ? `${bedroom}Br Indicative PX ${directionalLabel}`
      : `${bedroom}Br Indicative PX`;
    const details = projectDetailsMap.get(projectName);

    setTopViewingReferenceUnit({
      id: -1,
      projectName,
      region: details?.area ?? null,
      unitNumber: referenceLabel,
      blockNumber: null,
      bedroom,
      bathroom: 0,
      areaSqft: referenceArea,
      price,
      psf: referenceArea > 0 ? price / referenceArea : 0,
      unitStatus: null,
      floorplan: null,
      referenceSource: 'indicative',
      indicativeSizeRange: { min: sizeRange.min, max: sizeRange.max },
    });
    logReferenceUnitSet({
      projectName,
      unitNumber: referenceLabel,
      unitId: -1,
      source: 'top_viewing_indicative_reference',
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });

    setTopViewingAvailableUnitsViewMode('availableUnits');
    setTopViewingCompViewMode('unit');
    setTopViewingCompFilters({ projectName: [], projectCategory: [], blockNumber: '', unitTypeDescription: [] });
    setTopViewingCompRangeFilters({
      floor: { min: '', max: '' },
      stack: { min: '', max: '' },
      bedroom: { min: '', max: '' },
      bathroom: { min: '', max: '' },
      areaSqft: { min: '', max: '' },
      price: { min: '', max: '' },
      psf: { min: '', max: '' },
      dps: { min: '', max: '' },
      outlay: { min: '', max: '' },
      installment: { min: '', max: '' },
      distance: { min: '', max: '' },
    });
    setTopViewingCompSortConfig({ column: null, direction: null });
    setTopViewingThumbsUpFilterActive(false);
    setTopViewingAreaTolerance(0);
    setTopViewingToleranceSliderValue(0);
    setTopViewingComparableSectionOpen(true);
    setTimeout(() => {
      topViewingComparableSectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 100);
  }, [
    projectDetailsMap,
    setTopViewingReferenceUnit,
    setTopViewingCompViewMode,
    setTopViewingCompFilters,
    setTopViewingCompRangeFilters,
    setTopViewingCompSortConfig,
    setTopViewingThumbsUpFilterActive,
    setTopViewingFloorPlansToCompare,
    setTopViewingAreaTolerance,
    setTopViewingToleranceSliderValue,
    setTopViewingComparableSectionOpen,
    topViewingComparableSectionRef,
    userInfo?.CEANumber,
  ]);

  const handleTopViewingGuesstimationReference = useCallback((params: {
    projectName: string;
    price: number;
    bedroom?: number;
    areaSqft?: number;
    sizeRange?: { min: number; max: number };
  }) => {
    const { projectName, price, bedroom, areaSqft, sizeRange } = params;
    if (!projectName || !Number.isFinite(price) || price <= 0) return;

    let referenceArea: number;
    let indicativeSizeRange: { min: number; max: number } | undefined;
    if (sizeRange && Number.isFinite(sizeRange.min) && Number.isFinite(sizeRange.max) && sizeRange.min > 0 && sizeRange.max > 0) {
      const mn = Math.min(sizeRange.min, sizeRange.max);
      const mx = Math.max(sizeRange.min, sizeRange.max);
      indicativeSizeRange = { min: mn, max: mx };
      referenceArea = (mn + mx) / 2;
    } else if (areaSqft != null && Number.isFinite(areaSqft) && areaSqft > 0) {
      referenceArea = areaSqft;
      indicativeSizeRange = { min: areaSqft, max: areaSqft };
    } else {
      const unitAreas = towerViewUnits
        .map((unit) => Number(unit.areaSqft ?? 0))
        .filter((area) => Number.isFinite(area) && area > 0)
        .sort((a, b) => a - b);
      const midIndex = Math.floor(unitAreas.length / 2);
      referenceArea = unitAreas.length === 0
        ? 0
        : unitAreas.length % 2 === 0
          ? (unitAreas[midIndex - 1] + unitAreas[midIndex]) / 2
          : unitAreas[midIndex];
    }
    const details = projectDetailsMap.get(projectName);

    setTopViewingReferenceUnit({
      id: -2,
      projectName,
      region: details?.area ?? null,
      unitNumber: 'Guess-timation Price',
      blockNumber: null,
      bedroom: bedroom ?? 0,
      bathroom: 0,
      areaSqft: referenceArea,
      price,
      psf: referenceArea > 0 ? price / referenceArea : 0,
      unitStatus: null,
      floorplan: null,
      referenceSource: 'guesstimation',
      ...(indicativeSizeRange ? { indicativeSizeRange } : {}),
    });
    logReferenceUnitSet({
      projectName,
      unitNumber: 'Guess-timation Price',
      unitId: -2,
      source: 'top_viewing_guesstimation_reference',
      ceaNumber: userInfo?.CEANumber || getDevCea(),
    });

    setTopViewingAvailableUnitsViewMode('availableUnits');
    setTopViewingCompViewMode('unit');
    setTopViewingCompFilters({ projectName: [], projectCategory: [], blockNumber: '', unitTypeDescription: [] });
    setTopViewingCompRangeFilters({
      floor: { min: '', max: '' },
      stack: { min: '', max: '' },
      bedroom: { min: '', max: '' },
      bathroom: { min: '', max: '' },
      areaSqft: { min: '', max: '' },
      price: { min: '', max: '' },
      psf: { min: '', max: '' },
      dps: { min: '', max: '' },
      outlay: { min: '', max: '' },
      installment: { min: '', max: '' },
      distance: { min: '', max: '' },
    });
    setTopViewingCompSortConfig({ column: null, direction: null });
    setTopViewingThumbsUpFilterActive(false);
    setTopViewingAreaTolerance(0);
    setTopViewingToleranceSliderValue(0);
    setTopViewingComparableSectionOpen(true);
    setTimeout(() => {
      topViewingComparableSectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 100);
  }, [
    towerViewUnits,
    projectDetailsMap,
    setTopViewingReferenceUnit,
    setTopViewingCompViewMode,
    setTopViewingCompFilters,
    setTopViewingCompRangeFilters,
    setTopViewingCompSortConfig,
    setTopViewingThumbsUpFilterActive,
    setTopViewingAreaTolerance,
    setTopViewingToleranceSliderValue,
    setTopViewingComparableSectionOpen,
    topViewingComparableSectionRef,
    userInfo?.CEANumber,
  ]);

  // Handler for sorting TOP VIEWING comparable units
  const handleTopViewingCompSort = (column: TopViewingCompColumnKey) => {
    setTopViewingCompSortConfig((prev) => {
      if (prev.column === column) {
        // Cycle through: null -> asc -> desc -> null
        if (prev.direction === null) {
          return { column, direction: 'asc' };
        } else if (prev.direction === 'asc') {
          return { column, direction: 'desc' };
        } else {
          return { column: null, direction: null };
        }
      } else {
        // Start with ascending for new column
        return { column, direction: 'asc' };
      }
    });
  };

  // Helper to check if TOP VIEWING unit qualifies for thumbs up
  const topViewingQualifiesForThumbsUp = useCallback((unit: ComparableUnit): boolean => {
    if (!topViewingReferenceUnit) return false;

    const unitParsed = parseUnitNumber(unit.unitNumber);
    const refParsed = parseUnitNumber(topViewingReferenceUnit.unitNumber);

    // Always required: Lower PSF and lower price
    const hasLowerPSF = unit.psf > 0 && unit.psf < topViewingReferenceUnit.psf;
    const hasLowerPrice = unit.price > 0 && unit.price < topViewingReferenceUnit.price;

    if (!hasLowerPSF || !hasLowerPrice) return false;

    // Check floor comparison (if both have valid floors)
    const unitFloor = unitParsed.floor;
    const refFloor = refParsed.floor;

    if (unitFloor !== null && refFloor !== null) {
      if (unitFloor < refFloor) {
        // Lower floor: must have bigger size
        return unit.areaSqft > topViewingReferenceUnit.areaSqft;
      } else if (unitFloor > refFloor) {
        // Higher floor: can have same size or bigger size
        return unit.areaSqft >= topViewingReferenceUnit.areaSqft;
      } else {
        // Same floor: must have bigger size
        return unit.areaSqft > topViewingReferenceUnit.areaSqft;
      }
    } else {
      // If floor info not available, just check for bigger size
      return unit.areaSqft > topViewingReferenceUnit.areaSqft;
    }
  }, [topViewingReferenceUnit]);

  /** Tower-derived comparables when price matrix simulation is active — must go through the same filters as API comparables. */
  const topViewingComparableUnitsFromPriceMatrix = useMemo((): ComparableUnit[] => {
    if (!activePriceMatrixSimulationSession || !topViewingReferenceUnit) return [];
    const refBedroom = normalizeBedroomValue(topViewingReferenceUnit.bedroom);
    const refPrice = topViewingReferenceUnit.price ?? 0;
    const refPsf = topViewingReferenceUnit.psf ?? 0;
    if (refBedroom == null || refBedroom <= 0) return [];
    const units: ComparableUnit[] = [];
    effectiveTowerViewUnits.forEach((unit) => {
      const bedroom = normalizeBedroomValue(unit.bedroom);
      if (bedroom !== refBedroom) return;
      const price = Number(unit.price);
      if (!Number.isFinite(price) || price <= 0) return;
      const status = (unit.unitStatus || '').toString().toLowerCase();
      if (status === 'sold' || isUnitStatusNotReleased(status)) return;
      if (topViewingReferenceUnit.id === unit.id) return;
      const areaSqft = unit.areaSqft ?? 0;
      const psf = areaSqft > 0 ? price / areaSqft : 0;
      units.push({
        id: unit.id,
        projectName: unit.projectName,
        region: unit.region ?? null,
        unitNumber: unit.unitNumber,
        blockNumber: unit.blockNumber ?? null,
        bedroom: unit.bedroom,
        bathroom: unit.bathroom,
        areaSqft,
        price,
        priceNps: unit.priceNps ?? null,
        priceDps: unit.priceDps ?? null,
        priceDiff: refPrice > 0 ? price - refPrice : 0,
        priceDiffPercent: refPrice > 0 ? ((price - refPrice) / refPrice) * 100 : 0,
        psf,
        psfNps: unit.psfNps ?? null,
        psfDps: unit.psfDps ?? null,
        psfDiff: refPsf > 0 ? psf - refPsf : 0,
        psfDiffPercent: refPsf > 0 ? ((psf - refPsf) / refPsf) * 100 : 0,
        outlay: 0,
        outlayDiff: 0,
        installment: 0,
        installmentDiff: 0,
        unitStatus: unit.unitStatus,
        unitStatusSource: unit.unitStatusSource,
        unitStatusUpdatedAt: unit.unitStatusUpdatedAt ?? null,
        floorplan: unit.floorplan ?? null,
        unitTypeDescription: unit.unitTypeDescription ?? null,
      });
    });
    units.sort((a, b) => Math.abs(a.priceDiff) - Math.abs(b.priceDiff));
    return units;
  }, [activePriceMatrixSimulationSession, effectiveTowerViewUnits, normalizeBedroomValue, topViewingReferenceUnit]);

  // Filtered comparable units with filter logic
  const topViewingFilteredComparableUnits = useMemo(() => {
    const toNum = (value: string): number | null => {
      const trimmed = value.trim();
      if (!trimmed) return null;
      const parsed = Number(trimmed);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const referenceOutlay = topViewingReferenceUnit ? calculateOutlay(topViewingReferenceUnit.price, loanToValue / 100) : 0;
    const referenceInstallment = topViewingReferenceUnit
      ? calculateInstallment(topViewingReferenceUnit.price, loanToValue / 100, tenureYears, interestRate / 100)
      : 0;

    const baseComparableUnits =
      activePriceMatrixSimulationSession && topViewingComparableUnitsFromPriceMatrix.length > 0
        ? topViewingComparableUnitsFromPriceMatrix
        : topViewingComparableUnits;

    const normalizedComparableUnits = baseComparableUnits.map((unit) => {
      const computedOutlay = calculateOutlay(unit.price, loanToValue / 100);
      const computedInstallment = calculateInstallment(unit.price, loanToValue / 100, tenureYears, interestRate / 100);
      return {
        ...unit,
        outlay: computedOutlay,
        installment: computedInstallment,
        outlayDiff: computedOutlay - referenceOutlay,
        installmentDiff: computedInstallment - referenceInstallment,
      };
    });

    const tvRefProject = (topViewingReferenceUnit?.projectName ?? '').trim();
    const scopedComparable = tvRefProject
      ? normalizedComparableUnits.filter((u) => u.projectName === tvRefProject)
      : normalizedComparableUnits;

    let filtered = scopedComparable.filter((unit) => {
      // Project name filter (multi-select array)
      if (topViewingCompFilters.projectName.length > 0) {
        if (!topViewingCompFilters.projectName.includes(unit.projectName)) {
          return false;
        }
      }

      if (topViewingCompFilters.projectCategory.length > 0) {
        const category = (projectDetailsMap.get(unit.projectName)?.projectCategory ?? '').trim();
        if (!category || !topViewingCompFilters.projectCategory.includes(category)) {
          return false;
        }
      }

      // Block number filter
      if (topViewingCompFilters.blockNumber.trim() !== '') {
        if (!unit.blockNumber || !unit.blockNumber.toLowerCase().includes(topViewingCompFilters.blockNumber.toLowerCase())) {
          return false;
        }
      }

      // Unit type description filter
      if (topViewingCompFilters.unitTypeDescription.length > 0) {
        if (!unit.unitTypeDescription || !topViewingCompFilters.unitTypeDescription.includes(unit.unitTypeDescription)) {
          return false;
        }
      }

      // Parse unit number for floor and stack
      const parsed = parseUnitNumber(unit.unitNumber);

      // Floor range filter
      const floorMin = toNum(debouncedTopViewingCompRangeFilters.floor.min);
      const floorMax = toNum(debouncedTopViewingCompRangeFilters.floor.max);
      if (parsed.floor !== null) {
        if (floorMin !== null && parsed.floor < floorMin) return false;
        if (floorMax !== null && parsed.floor > floorMax) return false;
      }

      // Stack range filter
      const stackMin = toNum(debouncedTopViewingCompRangeFilters.stack.min);
      const stackMax = toNum(debouncedTopViewingCompRangeFilters.stack.max);
      if (parsed.stack !== null) {
        if (stackMin !== null && parsed.stack < stackMin) return false;
        if (stackMax !== null && parsed.stack > stackMax) return false;
      }

      // Bedroom range filter
      const bedroomMin = toNum(debouncedTopViewingCompRangeFilters.bedroom.min);
      const bedroomMax = toNum(debouncedTopViewingCompRangeFilters.bedroom.max);
      if (bedroomMin !== null && unit.bedroom < bedroomMin) return false;
      if (bedroomMax !== null && unit.bedroom > bedroomMax) return false;

      // Bathroom range filter
      const bathroomMin = toNum(debouncedTopViewingCompRangeFilters.bathroom.min);
      const bathroomMax = toNum(debouncedTopViewingCompRangeFilters.bathroom.max);
      if (bathroomMin !== null && unit.bathroom < bathroomMin) return false;
      if (bathroomMax !== null && unit.bathroom > bathroomMax) return false;

      // Area range filter
      const areaMin = toNum(debouncedTopViewingCompRangeFilters.areaSqft.min);
      const areaMax = toNum(debouncedTopViewingCompRangeFilters.areaSqft.max);
      if (areaMin !== null && unit.areaSqft < areaMin) return false;
      if (areaMax !== null && unit.areaSqft > areaMax) return false;

      // Price range filter
      const priceMin = toNum(debouncedTopViewingCompRangeFilters.price.min);
      const priceMax = toNum(debouncedTopViewingCompRangeFilters.price.max);
      if (priceMin !== null && unit.price < priceMin) return false;
      if (priceMax !== null && unit.price > priceMax) return false;

      // PSF range filter
      const psfMin = toNum(debouncedTopViewingCompRangeFilters.psf.min);
      const psfMax = toNum(debouncedTopViewingCompRangeFilters.psf.max);
      if (psfMin !== null && unit.psf < psfMin) return false;
      if (psfMax !== null && unit.psf > psfMax) return false;

      // DPS range filter
      const dpsRange = debouncedTopViewingCompRangeFilters.dps ?? { min: '', max: '' };
      const dpsMin = toNum(dpsRange.min);
      const dpsMax = toNum(dpsRange.max);
      const unitDps = unit.priceDps ?? 0;
      if (dpsMin !== null && unitDps < dpsMin) return false;
      if (dpsMax !== null && unitDps > dpsMax) return false;

      // Outlay range filter
      const outlayMin = toNum(debouncedTopViewingCompRangeFilters.outlay.min);
      const outlayMax = toNum(debouncedTopViewingCompRangeFilters.outlay.max);
      if (outlayMin !== null && unit.outlay < outlayMin) return false;
      if (outlayMax !== null && unit.outlay > outlayMax) return false;

      // Installment range filter
      const installmentMin = toNum(debouncedTopViewingCompRangeFilters.installment.min);
      const installmentMax = toNum(debouncedTopViewingCompRangeFilters.installment.max);
      if (installmentMin !== null && unit.installment < installmentMin) return false;
      if (installmentMax !== null && unit.installment > installmentMax) return false;

      return true;
    });

    // Apply distance filter
    if (debouncedTopViewingCompRangeFilters.distance.min.trim() !== '' || debouncedTopViewingCompRangeFilters.distance.max.trim() !== '') {
      filtered = filtered.filter((unit) => {
        const distance = getTopViewingDistanceFromReference(unit.projectName);
        if (distance === null) return false; // Exclude units without location data

        const min = debouncedTopViewingCompRangeFilters.distance.min.trim() !== '' ? parseFloat(debouncedTopViewingCompRangeFilters.distance.min) : null;
        const max = debouncedTopViewingCompRangeFilters.distance.max.trim() !== '' ? parseFloat(debouncedTopViewingCompRangeFilters.distance.max) : null;

        if (min !== null && distance < min) return false;
        if (max !== null && distance > max) return false;
        return true;
      });
    }

    // Apply thumbs up filter (match what actually shows thumbs-up icon in table).
    if (topViewingThumbsUpFilterActive && topViewingReferenceUnit) {
      filtered = filtered.filter((unit) => topViewingQualifiesForThumbsUp(unit));
    }

    // Apply sorting
    if (topViewingCompSortConfig.column) {
      filtered = [...filtered].sort((a, b) => {
        let aValue: number | string | null = null;
        let bValue: number | string | null = null;

        const column = topViewingCompSortConfig.column!;

        if (column === 'projectName') {
          aValue = a.projectName;
          bValue = b.projectName;
        } else if (column === 'projectCategory') {
          aValue = (projectDetailsMap.get(a.projectName)?.projectCategory ?? '').trim();
          bValue = (projectDetailsMap.get(b.projectName)?.projectCategory ?? '').trim();
        } else if (column === 'blockNumber') {
          aValue = a.blockNumber || '';
          bValue = b.blockNumber || '';
        } else if (column === 'floor' || column === 'stack') {
          const aParsed = parseUnitNumber(a.unitNumber);
          const bParsed = parseUnitNumber(b.unitNumber);
          aValue = column === 'floor' ? aParsed.floor : aParsed.stack;
          bValue = column === 'floor' ? bParsed.floor : bParsed.stack;
        } else if (column === 'outlay') {
          aValue = a.outlay;
          bValue = b.outlay;
        } else if (column === 'installment') {
          aValue = a.installment;
          bValue = b.installment;
        } else if (column === 'dps') {
          aValue = a.priceDps ?? 0;
          bValue = b.priceDps ?? 0;
        } else if (column === 'distance') {
          aValue = getTopViewingDistanceFromReference(a.projectName);
          bValue = getTopViewingDistanceFromReference(b.projectName);
        } else {
          // For numeric columns directly on the unit
          aValue = a[column as keyof ComparableUnit] as number;
          bValue = b[column as keyof ComparableUnit] as number;
        }

        // Handle null values
        if (aValue === null && bValue === null) return 0;
        if (aValue === null) return 1;
        if (bValue === null) return -1;

        // Compare values
        const direction = topViewingCompSortConfig.direction === 'asc' ? 1 : -1;

        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return aValue.localeCompare(bValue) * direction;
        }

        return (aValue < bValue ? -1 : aValue > bValue ? 1 : 0) * direction;
      });
    }

    return filtered;
  }, [
    activePriceMatrixSimulationSession,
    calculateInstallment,
    calculateOutlay,
    interestRate,
    loanToValue,
    tenureYears,
    topViewingComparableUnits,
    topViewingComparableUnitsFromPriceMatrix,
    topViewingCompFilters,
    debouncedTopViewingCompRangeFilters,
    topViewingCompSortConfig,
    topViewingThumbsUpFilterActive,
    topViewingReferenceUnit,
    topViewingQualifiesForThumbsUp,
    getTopViewingDistanceFromReference,
    projectDetailsMap,
  ]);

  const topViewingUniqueProjectsFromComparableUnits = useMemo(() => {
    const projectSet = new Set<string>();
    topViewingFilteredComparableUnits.forEach((unit) => {
      if (unit.projectName) {
        projectSet.add(unit.projectName);
      }
    });
    if (topViewingReferenceUnit?.projectName) {
      projectSet.add(topViewingReferenceUnit.projectName);
    }
    return Array.from(projectSet);
  }, [topViewingFilteredComparableUnits, topViewingReferenceUnit?.projectName]);

  const topViewingProjectsForProjectView = useMemo(() => {
    return [...topViewingUniqueProjectsFromComparableUnits].sort((a, b) => {
      const distA = getTopViewingDistanceFromReference(a);
      const distB = getTopViewingDistanceFromReference(b);
      if (distA != null && distB != null) return distA - distB;
      if (distA != null) return -1;
      if (distB != null) return 1;
      return a.localeCompare(b);
    });
  }, [topViewingUniqueProjectsFromComparableUnits, getTopViewingDistanceFromReference]);

  const topViewingUniqueProjectsKey = useMemo(() => {
    return topViewingProjectsForProjectView.join(',');
  }, [topViewingProjectsForProjectView]);

  const topViewingFilteredProjectsForView = useMemo(() => {
    const getDistrictLocationStr = (d: ProjectDetails | undefined): string => {
      if (!d) return '';
      if (d.districtLocation) return d.districtLocation;
      const parts = [d.area, d.district].filter(Boolean);
      return parts.length ? parts.join(' / ') : '';
    };
    const getCellStr = (projectName: string, d: ProjectDetails | undefined, key: string): string => {
      switch (key) {
        case 'projectName': return projectName ?? '';
        case 'distance': {
          const dist = getTopViewingDistanceFromReference(projectName);
          return dist != null ? formatNumber(dist, 2) : '';
        }
        case 'projectCategory': return d?.projectCategory ?? '';
        case 'developer': return d?.developer ?? '';
        case 'totalUnits': return d?.totalUnits != null ? String(d.totalUnits) : '';
        case 'soldUnits': return d?.soldUnits != null ? String(d.soldUnits) : '';
        case 'districtLocation': return getDistrictLocationStr(d);
        case 'district': return d?.district ?? '';
        case 'region': return d?.area ?? '';
        case 'nearestMrt': return d?.nearestMrt ?? '';
        case 'walkingTimeToMrt': return d?.walkingTimeToMrt != null ? String(d.walkingTimeToMrt) : '';
        case 'tenure': return d?.tenure ?? '';
        case 'completedDate':
          return d?.completedDate
            ? new Date(d.completedDate).toLocaleDateString('en-SG', { year: 'numeric', month: 'short', day: 'numeric' })
            : '';
        default: {
          const brMatch = key.match(/^(br[1-5]|ph)(avail|price|psf)$/);
          if (brMatch) {
            const brKey = brMatch[1] as 'br1' | 'br2' | 'br3' | 'br4' | 'br5' | 'ph';
            const sub = brMatch[2];
            const brData = d?.[brKey];
            if (!brData) return '';
            if (sub === 'avail') return String(brData.availableUnits ?? '');
            if (sub === 'price') return brData.fromPrice != null ? formatCurrency(brData.fromPrice) : '';
            if (sub === 'psf') return brData.fromPsf != null ? formatCurrency(brData.fromPsf) : '';
          }
          return '';
        }
      }
    };
    const getCellNum = (projectName: string, d: ProjectDetails | undefined, key: string): number | null => {
      switch (key) {
        case 'distance': return getTopViewingDistanceFromReference(projectName);
        case 'totalUnits': return d?.totalUnits != null ? Number(d.totalUnits) : null;
        case 'soldUnits': return d?.soldUnits != null ? d.soldUnits : null;
        case 'walkingTimeToMrt': return d?.walkingTimeToMrt ?? null;
        default: {
          const brMatch = key.match(/^(br[1-5]|ph)(avail|price|psf)$/);
          if (brMatch) {
            const brKey = brMatch[1] as 'br1' | 'br2' | 'br3' | 'br4' | 'br5' | 'ph';
            const sub = brMatch[2];
            const brData = d?.[brKey];
            if (!brData) return null;
            if (sub === 'avail') return brData.availableUnits ?? null;
            if (sub === 'price') return brData.fromPrice ?? null;
            if (sub === 'psf') return brData.fromPsf ?? null;
          }
          return null;
        }
      }
    };
    return topViewingProjectsForProjectView.filter((projectName) => {
      const d = projectDetailsMap.get(projectName);
      return PROJECT_VIEW_COLUMN_KEYS.every((k) => {
        if (k === 'districtLocation') {
          if (projectViewDistrictFilter.length === 0) return true;
          const cellStr = getDistrictLocationStr(d).toLowerCase();
          return projectViewDistrictFilter.some((sel) => {
            const num = sel.replace(/^District\s+/i, '');
            return cellStr.includes(`d${num.padStart(2, '0')}`) || cellStr.includes(sel.toLowerCase()) || cellStr.includes(` ${num} `) || cellStr === num;
          });
        }
        if (PROJECT_VIEW_NUMERIC_COLUMNS.has(k)) {
          const range = projectViewRangeFilters[k] ?? { min: '', max: '' };
          if (range.min.trim() === '' && range.max.trim() === '') return true;
          const num = getCellNum(projectName, d, k);
          const minVal = range.min.trim() !== '' ? parseFloat(range.min) : null;
          const maxVal = range.max.trim() !== '' ? parseFloat(range.max) : null;
          if (minVal != null && (num === null || num < minVal)) return false;
          if (maxVal != null && (num === null || num > maxVal)) return false;
          return true;
        }
        const filterVal = (projectViewFilters[k] ?? '').trim();
        if (!filterVal) return true;
        return getCellStr(projectName, d, k).toLowerCase().includes(filterVal.toLowerCase());
      });
    });
  }, [
    topViewingProjectsForProjectView,
    projectDetailsMap,
    projectViewFilters,
    projectViewRangeFilters,
    projectViewDistrictFilter,
    getTopViewingDistanceFromReference,
    formatNumber,
    formatCurrency,
  ]);

  useEffect(() => {
    const fetchProjectDetailsForTopViewingProjectView = async () => {
      const projectNames = topViewingCompViewMode === 'project' ? topViewingProjectsForProjectView : [];
      if (
        topViewingCompViewMode !== 'project' ||
        projectNames.length === 0 ||
        topViewingUniqueProjectsKey === topViewingLastFetchedProjectsRef.current
      ) {
        return;
      }

      const projectsToFetch = projectNames.filter((projectName) => {
        const existing = projectDetailsMap.get(projectName);
        return !existing || (existing.name === projectName && !existing.developer && !existing.totalUnits);
      });

      if (projectsToFetch.length === 0) {
        topViewingLastFetchedProjectsRef.current = topViewingUniqueProjectsKey;
        return;
      }

      topViewingLastFetchedProjectsRef.current = topViewingUniqueProjectsKey;
      try {
        const projectIds = await resolveProjectIdsByName(projectsToFetch);
        if (projectIds.length === 0) {
          return;
        }
        const projectDetails = await api.getBulkProjectDetails(projectIds);
        setProjectDetailsMap((prevMap) => {
          const newMap = new Map(prevMap);
          projectDetails.forEach((details) => {
            if (details.name) {
              newMap.set(details.name, details);
            }
          });
          return newMap;
        });
      } catch (err) {
        console.error('Failed to fetch top viewing project details:', err);
      }
    };

    fetchProjectDetailsForTopViewingProjectView();
  }, [projectDetailsMap, resolveProjectIdsByName, topViewingCompViewMode, topViewingProjectsForProjectView, topViewingUniqueProjectsKey]);

  const topViewingDetailedAvailableUnits = useMemo(() => {
    const toNum = (value: string): number | null => {
      const trimmed = value.trim();
      if (!trimmed) return null;
      const parsed = Number(trimmed);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const floorMin = toNum(topViewingAvailableUnitFilters.floorMin);
    const floorMax = toNum(topViewingAvailableUnitFilters.floorMax);
    const stackMin = toNum(topViewingAvailableUnitFilters.stackMin);
    const stackMax = toNum(topViewingAvailableUnitFilters.stackMax);
    const bedroomMin = toNum(topViewingAvailableUnitFilters.bedroomMin);
    const bedroomMax = toNum(topViewingAvailableUnitFilters.bedroomMax);
    const bathroomMin = toNum(topViewingAvailableUnitFilters.bathroomMin);
    const bathroomMax = toNum(topViewingAvailableUnitFilters.bathroomMax);
    const areaMin = toNum(topViewingAvailableUnitFilters.areaMin);
    const areaMax = toNum(topViewingAvailableUnitFilters.areaMax);
    const priceMin = toNum(topViewingAvailableUnitFilters.priceMin);
    const priceMax = toNum(topViewingAvailableUnitFilters.priceMax);
    const dpsMin = toNum(topViewingAvailableUnitFilters.dpsMin);
    const dpsMax = toNum(topViewingAvailableUnitFilters.dpsMax);
    const psfMin = toNum(topViewingAvailableUnitFilters.psfMin);
    const psfMax = toNum(topViewingAvailableUnitFilters.psfMax);
    const outlayMin = toNum(topViewingAvailableUnitFilters.outlayMin);
    const outlayMax = toNum(topViewingAvailableUnitFilters.outlayMax);
    const installmentMin = toNum(topViewingAvailableUnitFilters.installmentMin);
    const installmentMax = toNum(topViewingAvailableUnitFilters.installmentMax);

    return topViewingFilteredAvailableUnits
      .map((unit) => {
        const parsed = parseUnitNumber(unit.unitNumber, unit.floorNumber);
        // Ground-floor ("G") units use floor 1 only for tower-grid placement;
        // Available Units / reports should display floor as "-".
        const isGroundFloor = String(unit.floorNumber ?? '').trim().toUpperCase() === 'G';
        const floor = isGroundFloor ? undefined : (parsed.floor ?? undefined);
        const stack = parsed.stack ?? undefined;
        const basePrice = unit.priceNps ?? unit.price ?? 0;
        const basePsf = unit.psfNps ?? unit.psf ?? 0;
        const dpsPrice = unit.priceDps ?? 0;
        const outlay = calculateOutlay(basePrice, loanToValue / 100);
        const installment = calculateInstallment(basePrice, loanToValue / 100, tenureYears, interestRate / 100);
        return {
          ...unit,
          floor,
          floorLabel: isGroundFloor ? null : parsed.floorLabel,
          stack,
          price: basePrice,
          dps: dpsPrice,
          psf: basePsf,
          outlay,
          installment,
          distance: 0,
        };
      })
      .filter((unit) => {
        const projectNamePass = !topViewingAvailableUnitFilters.projectName.trim()
          || unit.projectName.toLowerCase().includes(topViewingAvailableUnitFilters.projectName.trim().toLowerCase());
        const blockPass = !topViewingAvailableUnitFilters.blockNumber.trim()
          || (unit.blockNumber || '').toLowerCase().includes(topViewingAvailableUnitFilters.blockNumber.trim().toLowerCase());
        const floorPass =
          (floorMin == null || (unit.floor != null && unit.floor >= floorMin)) &&
          (floorMax == null || (unit.floor != null && unit.floor <= floorMax));
        const stackRangePass =
          (stackMin == null || (unit.stack != null && unit.stack >= stackMin)) &&
          (stackMax == null || (unit.stack != null && unit.stack <= stackMax));
        const stackSelectedPass = topViewingAvailableUnitFilters.stackSelected.length === 0
          || (unit.stack != null && topViewingAvailableUnitFilters.stackSelected.includes(String(unit.stack)));
        const stackPass = stackRangePass && stackSelectedPass;
        const unitTypeDescPass = topViewingAvailableUnitFilters.unitTypeDescriptionSelected.length === 0
          || topViewingAvailableUnitFilters.unitTypeDescriptionSelected.includes(unit.unitTypeDescription || '');
        const bedroomPass = (bedroomMin == null || unit.bedroom >= bedroomMin) && (bedroomMax == null || unit.bedroom <= bedroomMax);
        const bathroomPass = (bathroomMin == null || unit.bathroom >= bathroomMin) && (bathroomMax == null || unit.bathroom <= bathroomMax);
        const areaPass = (areaMin == null || unit.areaSqft >= areaMin) && (areaMax == null || unit.areaSqft <= areaMax);
        const pricePass = (priceMin == null || unit.price >= priceMin) && (priceMax == null || unit.price <= priceMax);
        const dpsPass = (dpsMin == null || unit.dps >= dpsMin) && (dpsMax == null || unit.dps <= dpsMax);
        const psfPass = (psfMin == null || unit.psf >= psfMin) && (psfMax == null || unit.psf <= psfMax);
        const outlayPass = (outlayMin == null || unit.outlay >= outlayMin) && (outlayMax == null || unit.outlay <= outlayMax);
        const installmentPass = (installmentMin == null || unit.installment >= installmentMin) && (installmentMax == null || unit.installment <= installmentMax);
        return projectNamePass && blockPass && floorPass && stackPass && unitTypeDescPass && bedroomPass && bathroomPass && areaPass && pricePass && dpsPass && psfPass && outlayPass && installmentPass;
      });
  }, [topViewingFilteredAvailableUnits, topViewingAvailableUnitFilters, loanToValue, tenureYears, interestRate, parseUnitNumber]);

  const topViewingSortedUnits = useMemo(() => {
    const compareByLevel = (
      a: (typeof topViewingDetailedAvailableUnits)[number],
      b: (typeof topViewingDetailedAvailableUnits)[number],
    ) => {
      const floorDiff = (a.floor ?? Number.MAX_SAFE_INTEGER) - (b.floor ?? Number.MAX_SAFE_INTEGER);
      if (floorDiff !== 0) return floorDiff;
      const stackDiff = (a.stack ?? Number.MAX_SAFE_INTEGER) - (b.stack ?? Number.MAX_SAFE_INTEGER);
      if (stackDiff !== 0) return stackDiff;
      return a.unitNumber.localeCompare(b.unitNumber, undefined, { numeric: true, sensitivity: 'base' });
    };

    if (!topViewingSortConfig.column || topViewingSortConfig.direction === 'default') {
      return [...topViewingDetailedAvailableUnits].sort(compareByLevel);
    }

    const sorted = [...topViewingDetailedAvailableUnits].sort((a, b) => {
      const col = topViewingSortConfig.column!;
      const aVal = col === 'floor' ? a.floor : a[col];
      const bVal = col === 'floor' ? b.floor : b[col];

      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return 1;
      if (bVal == null) return -1;

      if (typeof aVal === 'number' && typeof bVal === 'number') {
        const comparison = aVal - bVal;
        return comparison === 0 ? compareByLevel(a, b) : comparison;
      }

      const comparison = String(aVal).localeCompare(String(bVal), undefined, { numeric: true, sensitivity: 'base' });
      return comparison === 0 ? compareByLevel(a, b) : comparison;
    });

    return topViewingSortConfig.direction === 'asc' ? sorted : sorted.reverse();
  }, [topViewingDetailedAvailableUnits, topViewingSortConfig]);

  const handleTopViewingOpenPopover = (event: React.MouseEvent<HTMLElement>, column: TopViewingColumnKey) => {
    setTopViewingPopoverAnchor({ element: event.currentTarget, column });
  };

  const handleTopViewingClosePopover = () => {
    setTopViewingPopoverAnchor(null);
  };

  const getTopViewingSortDirection = (column: TopViewingColumnKey): SortDirection => {
    if (topViewingSortConfig.column !== column) return 'default';
    return topViewingSortConfig.direction;
  };

  const handleTopViewingSortChange = (column: TopViewingColumnKey, direction: SortDirection) => {
    setTopViewingSortConfig({ column, direction });
    setTopViewingPopoverAnchor(null);
  };

  const handleTopViewingFilterChange = (column: TopViewingColumnKey, value: string) => {
    if (column === 'projectName') {
      setTopViewingAvailableUnitFilters((prev) => ({ ...prev, projectName: value }));
      return;
    }
    if (column === 'blockNumber') {
      setTopViewingAvailableUnitFilters((prev) => ({ ...prev, blockNumber: value }));
    }
  };

  const handleTopViewingRangeFilterChange = (
    column: Extract<TopViewingColumnKey, 'floor' | 'stack' | 'bedroom' | 'bathroom' | 'areaSqft' | 'price' | 'dps' | 'psf' | 'outlay' | 'installment'>,
    bound: 'min' | 'max',
    value: string,
  ) => {
    const keyMap: Record<typeof column, { minKey: keyof typeof topViewingAvailableUnitFilters; maxKey: keyof typeof topViewingAvailableUnitFilters }> = {
      floor: { minKey: 'floorMin', maxKey: 'floorMax' },
      stack: { minKey: 'stackMin', maxKey: 'stackMax' },
      bedroom: { minKey: 'bedroomMin', maxKey: 'bedroomMax' },
      bathroom: { minKey: 'bathroomMin', maxKey: 'bathroomMax' },
      areaSqft: { minKey: 'areaMin', maxKey: 'areaMax' },
      price: { minKey: 'priceMin', maxKey: 'priceMax' },
      dps: { minKey: 'dpsMin', maxKey: 'dpsMax' },
      psf: { minKey: 'psfMin', maxKey: 'psfMax' },
      outlay: { minKey: 'outlayMin', maxKey: 'outlayMax' },
      installment: { minKey: 'installmentMin', maxKey: 'installmentMax' },
    };

    const { minKey, maxKey } = keyMap[column];
    setTopViewingAvailableUnitFilters((prev) => ({
      ...prev,
      [bound === 'min' ? minKey : maxKey]: value,
    }));
  };

  const hasTopViewingActiveFilter = (column: TopViewingColumnKey): boolean => {
    if (column === 'projectName') return topViewingAvailableUnitFilters.projectName.trim() !== '';
    if (column === 'blockNumber') return topViewingAvailableUnitFilters.blockNumber.trim() !== '';
    if (column === 'distance') return false;
    if (column === 'stack') {
      return topViewingAvailableUnitFilters.stackSelected.length > 0
        || topViewingAvailableUnitFilters.stackMin.trim() !== ''
        || topViewingAvailableUnitFilters.stackMax.trim() !== '';
    }
    if (column === 'unitTypeDescription') return topViewingAvailableUnitFilters.unitTypeDescriptionSelected.length > 0;

    const map: Record<string, { min: string; max: string }> = {
      floor: { min: topViewingAvailableUnitFilters.floorMin, max: topViewingAvailableUnitFilters.floorMax },
      bedroom: { min: topViewingAvailableUnitFilters.bedroomMin, max: topViewingAvailableUnitFilters.bedroomMax },
      bathroom: { min: topViewingAvailableUnitFilters.bathroomMin, max: topViewingAvailableUnitFilters.bathroomMax },
      areaSqft: { min: topViewingAvailableUnitFilters.areaMin, max: topViewingAvailableUnitFilters.areaMax },
      price: { min: topViewingAvailableUnitFilters.priceMin, max: topViewingAvailableUnitFilters.priceMax },
      dps: { min: topViewingAvailableUnitFilters.dpsMin, max: topViewingAvailableUnitFilters.dpsMax },
      psf: { min: topViewingAvailableUnitFilters.psfMin, max: topViewingAvailableUnitFilters.psfMax },
      outlay: { min: topViewingAvailableUnitFilters.outlayMin, max: topViewingAvailableUnitFilters.outlayMax },
      installment: { min: topViewingAvailableUnitFilters.installmentMin, max: topViewingAvailableUnitFilters.installmentMax },
    };
    const item = map[column];
    return Boolean(item && (item.min.trim() !== '' || item.max.trim() !== ''));
  };

  const handleExportProjectReport = useCallback(async () => {
    try {
      setExportingPdf(true);

      // Capture site map screenshot
      // Temporarily expand the site map container and use white bg for a clean PDF capture
      let siteMapScreenshot: string | null = null;
      let siteMapDimensions: { width: number; height: number } | null = null;
      const siteMapEl = document.querySelector('[data-pdf-capture="site-map"]') as HTMLElement | null;
      if (siteMapEl) {
        const prevHeight = siteMapEl.style.height;
        const prevOverflow = siteMapEl.style.overflow;
        try {
          siteMapEl.style.height = 'auto';
          siteMapEl.style.overflow = 'visible';
          const canvas = await html2canvas(siteMapEl, {
            backgroundColor: '#ffffff',
            scale: 2,
            useCORS: true,
            logging: false,
          });
          siteMapDimensions = { width: canvas.width, height: canvas.height };
          siteMapScreenshot = canvas.toDataURL('image/jpeg', 0.9);
        } catch (err) {
          console.warn('Failed to capture site map:', err);
        } finally {
          siteMapEl.style.height = prevHeight || '';
          siteMapEl.style.overflow = prevOverflow || '';
        }
      }

      // Capture amenities map screenshot (when project section is expanded)
      // Temporarily switch to amenities tab so the map shows markers + radius circle
      let amenitiesMapScreenshot: string | null = null;
      let amenitiesMapDimensions: { width: number; height: number } | null = null;
      if (projectSectionExpanded && amenitiesData) {
        const prevTab = projectDetailsTab;
        // Switch to amenities tab so map renders markers
        setProjectDetailsTab('amenities');
        // Wait for React re-render + Leaflet tiles/markers to settle
        await new Promise((resolve) => setTimeout(resolve, 2000));

        const amenitiesMapEl = document.querySelector('[data-pdf-capture="amenities-map"]') as HTMLElement | null;
        if (amenitiesMapEl) {
          // Hide the SVG overlay (radius circle) — it renders offset with html2canvas
          const svgOverlay = amenitiesMapEl.querySelector('.leaflet-overlay-pane') as HTMLElement | null;
          if (svgOverlay) svgOverlay.style.display = 'none';
          try {
            const canvas = await html2canvas(amenitiesMapEl, {
              backgroundColor: '#ffffff',
              scale: 2,
              useCORS: true,
              logging: false,
            });
            amenitiesMapDimensions = { width: canvas.width, height: canvas.height };
            amenitiesMapScreenshot = canvas.toDataURL('image/jpeg', 0.9);
          } catch (err) {
            console.warn('Failed to capture amenities map:', err);
          } finally {
            // Restore SVG overlay visibility
            if (svgOverlay) svgOverlay.style.display = '';
          }
        }

        // Restore previous tab
        setProjectDetailsTab(prevTab);
      }

      // Tower view: serialize grid data for PDF table (no screenshot, to avoid cutoff).
      //
      // Mirror the on-screen Tower View's stack-filter behaviour
      // (`TopViewingSitePlanDetail.tsx :: visibleStacks`): only render stacks
      // that contain at least one unit passing the active site-plan filters
      // (bedroom + unit type + stack). Cells inside the surviving stacks are
      // left intact, matching the live grid which keeps non-matching floors
      // visible within a kept stack. Whole blocks with zero matching stacks
      // are dropped from the PDF.
      let towerViewGridData: ProjectReportData['towerViewGridData'] = null;
      if (towerViewData.blockNumbers.length > 0) {
        const hasBedroomFilter = sitePlanBedroomFilter.length > 0;
        const hasUnitTypeFilter = sitePlanUnitTypeFilterExpanded.length > 0;
        const hasStackFilter = sitePlanStackFilter.length > 0;
        const hasAnyFilter = hasBedroomFilter || hasUnitTypeFilter || hasStackFilter;
        // Build a Set<unitNumber> of units that pass bedroom + unit-type
        // filters by reusing `topViewingFilteredAvailableUnits` (already
        // memoised with the exact filter logic the on-screen view uses).
        // For the PDF we want to keep SOLD units visible inside surviving
        // stacks, but `topViewingFilteredAvailableUnits` excludes them. We
        // therefore only use this set as a "matches bedroom+unit-type"
        // probe, applied per cell when computing visible stacks.
        const filteredKey = (u: { blockNumber?: string | null; unitNumber?: string | null }) =>
          `${(u.blockNumber || '').trim()}|${(u.unitNumber || '').trim()}`;
        const filteredUnitKeys = new Set(topViewingFilteredAvailableUnits.map(filteredKey));
        const blocks: Record<string, { floors: number[]; stacks: number[]; grid: Record<string, TowerViewGridCell> }> = {};
        const visibleBlockNumbers: string[] = [];
        towerViewData.blockNumbers.forEach((blockKey) => {
          const blockData = towerViewData.blocks.get(blockKey);
          if (!blockData) return;
          // Compute visible stacks for this block.
          let visibleStacks = blockData.stacks;
          if (hasAnyFilter) {
            visibleStacks = blockData.stacks.filter((stack) =>
              blockData.floors.some((floor) => {
                const cell = blockData.grid.get(`${floor}-${stack}`) as TowerViewUnit | ComparableUnit | undefined;
                if (!cell) return false;
                // Bedroom + unit-type → reuse the precomputed set, which
                // also handles SOLD exclusion. For the PDF we want SOLD
                // units to still anchor a stack as visible (mirrors the
                // on-screen Tower View which renders SOLD cells), so when
                // bedroom/unit-type filters are active we additionally
                // accept SOLD cells whose bedroom matches.
                if (hasBedroomFilter || hasUnitTypeFilter) {
                  if (filteredUnitKeys.has(filteredKey(cell as TowerViewUnit))) {
                    // pass — also need stack filter check below
                  } else {
                    return false;
                  }
                }
                if (hasStackFilter) {
                  const parsed = parseUnitNumber((cell as TowerViewUnit).unitNumber);
                  const normStack = parsed.stack != null ? normalizeStackKey(parsed.stack) : null;
                  if (!normStack) return false;
                  const blockNum = ((cell as TowerViewUnit).blockNumber || '').replace(/\D/g, '');
                  const compositeKey = blockNum ? `${blockNum}-${normStack}` : null;
                  const matches =
                    matchesSelectedStackKey(sitePlanStackFilter, normStack) ||
                    (compositeKey != null && matchesSelectedStackKey(sitePlanStackFilter, compositeKey));
                  if (!matches) return false;
                }
                return true;
              }),
            );
          }
          // Skip blocks where every stack was filtered out.
          if (visibleStacks.length === 0) return;
          const visibleStackSet = new Set(visibleStacks);
          const grid: Record<string, TowerViewGridCell> = {};
          blockData.grid.forEach((unit, key) => {
            // `key` is `${floor}-${stack}` — only keep cells in surviving stacks.
            const stackPart = Number(key.split('-')[1]);
            if (!visibleStackSet.has(stackPart)) return;
            const u = unit as TowerViewUnit;
            grid[key] = {
              unitNumber: u.unitNumber ?? '-',
              blockNumber: u.blockNumber ?? null,
              bedroom: u.bedroom ?? 0,
              unitStatus: u.unitStatus ?? null,
              floorNumber: u.floorNumber ?? null,
              priceNps: u.priceNps ?? u.price ?? null,
              priceDps: u.priceDps ?? null,
              areaSqft: u.areaSqft ?? null,
            };
          });
          blocks[blockKey] = { floors: blockData.floors, stacks: visibleStacks, grid };
          visibleBlockNumbers.push(blockKey);
        });
        if (visibleBlockNumbers.length > 0) {
          towerViewGridData = { blockNumbers: visibleBlockNumbers, blocks };
        }
      }

      const reportData: ProjectReportData = {
        userInfo,
        hasPriceMatrixSimulation: Boolean(activePriceMatrixSimulationSession),
        projectDetails,
        projectSectionExpanded,
        topViewingReferenceUnit,
        siteMapScreenshot,
        siteMapDimensions,
        sitePlanBedroomFilter,
        sitePlanShowPoints,
        amenitiesMapScreenshot,
        amenitiesMapDimensions,
        amenitiesData,
        amenitiesRadius,
        towerViewGridData,
        loanToValue,
        tenureYears,
        interestRate,
        availableUnitsVisible: topViewingAvailableUnitsViewMode === 'availableUnits',
        topViewingSortedUnits,
        isExecutiveCondo: projectDetails?.projectCategoryId === 'C1803',
        bestPxBedroomVisible: topViewingAvailableUnitsViewMode === 'bestPxBedroom',
        bestByUnitTypeData: topViewingBestByUnitTypeForDisplay,
        topViewingComparableSectionOpen,
        topViewingFilteredComparableUnits,
        topViewingBudgetSectionOpen,
        topViewingBudgetRegionTab,
        topViewingBudgetSortedUnits: topViewingBudgetRegionTab === 'NEARBY'
          ? topViewingBudgetSortedUnits.filter((u) => u.distance != null && u.distance <= topViewingBudgetNearbyRadiusKm)
          : topViewingBudgetSortedUnits,
        topViewingBudgetRange,
        topViewingBudgetRangeFilters,
        topViewingBudgetNearbyRadiusKm,
      };

      await generateProjectReport(reportData);
    } catch (error) {
      console.error('Failed to generate project report:', error);
      alert('Failed to generate PDF report. Please try again.');
    } finally {
      setExportingPdf(false);
    }
  }, [
    userInfo, projectDetails, projectSectionExpanded, topViewingReferenceUnit,
    activePriceMatrixSimulationSession,
    sitePlanBedroomFilter, sitePlanShowPoints, towerViewData,
    amenitiesData, amenitiesRadius, projectDetailsTab, setProjectDetailsTab,
    loanToValue, tenureYears, interestRate,
    topViewingAvailableUnitsViewMode,
    topViewingSortedUnits, topViewingBestByUnitTypeForDisplay,
    topViewingComparableSectionOpen, topViewingFilteredComparableUnits,
    topViewingBudgetSectionOpen, topViewingBudgetRegionTab,
    topViewingBudgetSortedUnits, topViewingBudgetRange,
    topViewingBudgetNearbyRadiusKm, topViewingBudgetRangeFilters,
  ]);

  // Auto-select block only on initial open; when data refreshes from live stream, keep current tab (ALL or block)
  useEffect(() => {
    if (towerViewOpen && towerViewDataForDialog.blockNumbers.length > 0 && selectedBlock === null) {
      // Initial open: set default block or first block
      if (selectedUnitForTowerView) {
        const blockNumber = selectedUnitForTowerView.blockNumber || towerViewDataForDialog.blockNumbers[0] || null;
        if (blockNumber && towerViewDataForDialog.blockNumbers.includes(blockNumber)) {
          setSelectedBlock(blockNumber);
        } else {
          setSelectedBlock(towerViewDataForDialog.blockNumbers[0]);
        }
      } else {
        setSelectedBlock(towerViewDataForDialog.blockNumbers[0]);
      }
    }
  }, [towerViewOpen, towerViewDataForDialog.blockNumbers, selectedUnitForTowerView, selectedBlock]);

  // Scroll to selected unit after block is selected and data is loaded (skip when we just refreshed via live stream)
  useEffect(() => {
    if (towerViewJustRefreshedRef.current) {
      towerViewJustRefreshedRef.current = false;
      return;
    }
    if (towerViewOpen && selectedUnitForTowerView && selectedBlock && towerViewDataForDialog.blocks.has(selectedBlock)) {
      const parsed = parseUnitNumber(selectedUnitForTowerView.unitNumber);
      if (parsed.floor !== null && parsed.stack !== null) {
        // Retry until the DOM element is available (handles async render + dialog animation)
        let attempts = 0;
        const maxAttempts = 20;
        const tryHighlight = () => {
          const element = document.getElementById(`tower-unit-${parsed.floor}-${parsed.stack}`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
            // Apply immediate yellow border + blinking animation
            element.style.outline = '3px solid #ffd600';
            element.style.outlineOffset = '2px';
            element.style.boxShadow = '0 0 12px 3px rgba(255, 214, 0, 0.7)';
            element.style.animation = 'blinkHighlight 0.8s ease-in-out infinite';
            setTimeout(() => {
              element.style.outline = '';
              element.style.outlineOffset = '';
              element.style.boxShadow = '';
              element.style.animation = '';
            }, 6000);
          } else if (attempts < maxAttempts) {
            attempts++;
            requestAnimationFrame(tryHighlight);
          }
        };
        // Start after a short delay to let React commit the render
        setTimeout(tryHighlight, 100);
      }
    }
  }, [towerViewOpen, selectedUnitForTowerView, selectedBlock, towerViewDataForDialog.blocks]);

  // Pinch zoom handler for mobile
  useEffect(() => {
    const container = towerZoomContainerRef.current;
    if (!container || !towerViewOpen) return;

    let lastDistance = 0;

    const handleTouchStart = (e: TouchEvent) => {
      if (e.touches.length === 2) {
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        lastDistance = Math.hypot(
          touch2.clientX - touch1.clientX,
          touch2.clientY - touch1.clientY
        );
      }
    };

    const handleTouchMove = (e: TouchEvent) => {
      if (e.touches.length === 2) {
        e.preventDefault();
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        const distance = Math.hypot(
          touch2.clientX - touch1.clientX,
          touch2.clientY - touch1.clientY
        );
        if (lastDistance > 0) {
          const scale = distance / lastDistance;
          setTowerZoom((prev) => {
            const newZoom = prev * scale;
            return Math.max(0.5, Math.min(2, newZoom));
          });
        }
        lastDistance = distance;
      }
    };

    container.addEventListener('touchstart', handleTouchStart);
    container.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      container.removeEventListener('touchstart', handleTouchStart);
      container.removeEventListener('touchmove', handleTouchMove);
    };
  }, [towerViewOpen, towerZoomContainerRef]);

  // Calculate navigation counts
  const clientInterestsCount = useMemo(() => {
    // Count all shortlist items as interests
    return shortlistItems.length;
  }, [shortlistItems]);

  const pendingManageUsersCount = useMemo(() => {
    return manageUsersList.filter((user) => !user.reviewedAt).length;
  }, [manageUsersList]);

  // Navigation groups
  const navigationGroups: NavigationGroup[] = useMemo(() => {
    // Project Actions sits under `Project Head` for project leads and admins, and
    // under `Others` for core-team members who only hold calls.
    const projectActionNavItem = {
      id: 'project-action',
      label: 'Project Actions',
      icon: <PhoneInTalkIcon />,
      active: activeNavItem === 'project-action',
      onClick: () => {
        setActiveNavItem('project-action');
        setProjectActionOpen(true);
      },
    };
    return [
    {
      id: 'tools',
      label: 'Tools',
      items: [
        {
          id: TOP_VIEWING_SITE_PLANS_TAB,
          label: 'Top Viewing Site Plans',
          icon: <LayersIcon />,
          active: activeTabId === TOP_VIEWING_SITE_PLANS_TAB,
          onClick: () => {
            setActiveTabId(TOP_VIEWING_SITE_PLANS_TAB);
            setActiveClientId(null);
            setSelectedTopViewingSitePlan(null);
          },
        },
        {
          id: 'master',
          label: 'Project Research',
          icon: <ApartmentIcon />,
          active: activeTabId === 'master',
          onClick: () => {
            const currentCea = userInfo?.CEANumber || getDevCea();
            logMenuClick('Project Research', currentCea);
            logProjectResearchTabViewed(selectedProject || null, currentCea);
            if (activeTabId === TOP_VIEWING_SITE_PLANS_TAB) {
              setSelectedTopViewingSitePlan(null);
            }
            setActiveTabId('master');
            setActiveClientId(null);
          },
        },
        ...(canAccessSuperMap
          ? [{
            id: 'map-research',
            label: 'Good Deals Map',
            icon: <TravelExploreIcon />,
            active: activeTabId === 'map-research',
            onClick: () => {
              const currentCea = userInfo?.CEANumber || getDevCea();
              logMenuClick('Good Deals Map', currentCea);
              if (activeTabId === TOP_VIEWING_SITE_PLANS_TAB) {
                setSelectedTopViewingSitePlan(null);
              }
              setActiveTabId('map-research');
              setActiveClientId(null);
            },
          }]
          : []),
        ...(canAccessSuccessCloser ? [{
          id: 'success-closer',
          label: 'Success Closer',
          icon: <EmojiEventsIcon />,
          active: activeTabId === 'success-closer',
          onClick: () => {
            setActiveTabId('success-closer');
            setActiveClientId(null);
          },
        }] : []),
        ...(canAccessSharableLinks ? [{
          id: MY_SHARABLE_LINKS_TAB,
          label: 'My Shareable Links',
          icon: <IosShareIcon />,
          active: activeTabId === MY_SHARABLE_LINKS_TAB,
          onClick: () => {
            logMenuClick('My Sharable Links', userInfo?.CEANumber || getDevCea());
            setActiveTabId(MY_SHARABLE_LINKS_TAB);
            setActiveClientId(null);
          },
        }] : []),
        ...(
          isExternalUser
            ? []
            : [{
              id: 'generic',
              label: 'Find Units',
              icon: <TuneIcon />,
              active: activeTabId === 'generic',
              onClick: () => {
                if (activeTabId === TOP_VIEWING_SITE_PLANS_TAB) {
                  setSelectedTopViewingSitePlan(null);
                }
                setActiveTabId('generic');
                setActiveClientId(null);
              },
            }]
        ),
        ...(canAccessProjectMaterials
          ? [{
            id: MARKETING_MATERIALS_TAB,
            label: 'Project Essentials',
            icon: <CampaignIcon />,
            active: activeTabId === MARKETING_MATERIALS_TAB,
            onClick: () => {
              if (activeTabId === TOP_VIEWING_SITE_PLANS_TAB) {
                setSelectedTopViewingSitePlan(null);
              }
              setActiveTabId(MARKETING_MATERIALS_TAB);
              setActiveClientId(null);
            },
          }]
          : []),
        {
          id: PODCAST_VIDEOS_TAB,
          label: 'Podcast Videos',
          icon: <PodcastsIcon />,
          active: activeTabId === PODCAST_VIDEOS_TAB,
          onClick: () => {
            if (activeTabId === TOP_VIEWING_SITE_PLANS_TAB) {
              setSelectedTopViewingSitePlan(null);
            }
            setActiveTabId(PODCAST_VIDEOS_TAB);
            setActiveClientId(null);
          },
        },
        ...(
          isExternalUser
            ? []
            : [{
              id: 'thumbsup-units',
              label: 'Thumbsup Units',
              icon: <ThumbUpIcon />,
              active: activeNavItem === 'thumbsup-units',
              onClick: () => {
                const currentCea = userInfo?.CEANumber || getDevCea();
                logThumbsupUnitsOpened({
                  source: 'sidebar',
                  totalProjects: thumbsupGroupsByProject.length,
                  totalUnits: thumbsupUnits.length,
                  hasLastViewed: Boolean(latestViewedThumbsupUnit),
                  ceaNumber: currentCea,
                });
                setActiveNavItem('thumbsup-units');
                setThumbsupDialogOpen(true);
              },
            }]
        ),
        {
                      id: 'price-promo',
                      label: 'Price Promo Units',
                      icon: <LocalOfferIcon />,
                      active: activeNavItem === 'price-promo',
                      pulse: hasRecentPricePromo,
                      onClick: () => {
                        const currentCea = userInfo?.CEANumber || getDevCea();
                        logPricePromoUnitsOpened({
                          source: 'sidebar',
                          totalProjects: pricePromoTotalProjects,
                          totalUnits: pricePromoUnits.length,
                          latestCount: pricePromoLatestUnits.length,
                          topSavingCount: pricePromoTopSavingUnits.length,
                          hasRecentPromo: hasRecentPricePromo,
                          ceaNumber: currentCea,
                        });
                        setActiveNavItem('price-promo');
                        setPricePromoDialogOpen(true);
                      },
        },
        ...(canAccessPricePromoWatchlist ? [{
          id: 'price-promo-watchlist',
          label: 'Price Promo Watchlist',
          icon: <BinocularsIcon />,
          active: activeNavItem === 'price-promo-watchlist',
          tag: hasUnacknowledgedPricePromoUpdates ? { label: 'New Updates' } : undefined,
          onClick: () => {
            const currentCea = userInfo?.CEANumber || getDevCea();
            logMenuClick('Price Promo Watchlist', currentCea);
            acknowledgeCurrentPricePromoUpdates();
            setActiveNavItem('price-promo-watchlist');
            // Land on Anticipate when that's what is nudging the agent.
            if (unseenAnticipateIds.size > 0 && pricePromoWatchlistsWithNewMatches.length === 0) {
              setPricePromoWatchlistTab('anticipate');
            }
            setPricePromoWatchlistDialogOpen(true);
          },
        }] : []),
        // Super Showcase — every authenticated user.
        ...(canAccessSuperShowcase ? [{
          id: 'super-showcase',
          label: 'Super Showcase',
          icon: <AutoAwesomeMosaicIcon />,
          active: activeNavItem === 'super-showcase',
                      onClick: () => {
                        const currentCea = userInfo?.CEANumber || getDevCea();
            logMenuClick('Super Showcase', currentCea);
            logSuperShowcaseOpened({
                          source: 'sidebar',
              totalShowcases: superShowcases.length,
                          ceaNumber: currentCea,
                        });
            setActiveNavItem('super-showcase');
            setSuperShowcaseDialogOpen(true);
                      },
        }] : []),
        // 3D Sitemap — the admin-curated site plans for projects outside the
        // Top Viewing list. Admin-only; the endpoints are on `requireAdmin` to
        // match.
        ...(canAccessSitemap3d ? [{
          id: 'sitemap-3d',
          label: '3D Sitemap',
          icon: <ViewInArIcon />,
          active: activeNavItem === 'sitemap-3d',
          onClick: () => {
            const currentCea = userInfo?.CEANumber || getDevCea();
            logMenuClick('3D Sitemap', currentCea);
            setActiveNavItem('sitemap-3d');
            setSitemap3dDialogOpen(true);
          },
        }] : []),
      ],
    },
    ...(isExternalUser ? [] : [{
      id: 'clients',
      label: 'Clients',
      items: [
        {
          id: 'shortlisted-units',
          label: 'Shortlisted Units',
          icon: <BookmarkIcon />,
          count: clientInterestsCount,
          active: activeNavItem === 'shortlisted-units',
          onClick: () => {
            setActiveNavItem('shortlisted-units');
            setShortlistDialogOpen(true);
          },
        },
        ...(isAdminUser ? [{
          id: 'my-share-links',
          label: 'My Picker Invites',
          icon: <LinkIcon />,
          active: activeNavItem === 'my-share-links',
          onClick: () => {
            setActiveNavItem('my-share-links');
            setMyShareLinksOpen(true);
          },
        }] : []),
      ],
    }]),
    {
      id: 'settings',
      label: 'Settings',
      items: [
        {
          id: 'financial-parameters',
          label: 'Financial Parameters',
          icon: <EqualizerIcon />,
          active: activeNavItem === 'financial-parameters',
          onClick: () => {
            setActiveNavItem('financial-parameters');
            setFinancialParametersOpen(true);
          },
        },
      ],
    },
    ...(isAdminUser ? [{
      id: 'admin',
      label: 'Admin',
      items: [
        {
          id: 'sync-clients',
          label: 'Project Sync',
          icon: <SyncIcon />,
          active: activeNavItem === 'sync-clients',
          onClick: () => {
            setActiveNavItem('sync-clients');
            setProjectSyncSettingsOpen(true);
          },
        },
        {
          id: 'manage-users',
          label: 'Manage Users',
          icon: <PeopleIcon />,
          count: pendingManageUsersCount > 0 ? pendingManageUsersCount : undefined,
          countVariant: 'alert' as const,
          active: activeNavItem === 'manage-users',
          onClick: () => {
            setActiveNavItem('manage-users');
            setManageUsersOpen(true);
          },
        },
        {
          id: 'manage-site-map',
          label: 'Manage Project',
          icon: <EditIcon />,
          active: activeNavItem === 'manage-site-map',
          onClick: () => {
            setActiveNavItem('manage-site-map');
            setManageSiteMapInitialProject('');
            setManageSiteMapOpen(true);
          },
        },
        {
          id: 'agent-achievements',
          label: 'Agent Achievements',
          icon: <EqualizerIcon />,
          active: activeNavItem === 'agent-achievements',
          onClick: () => {
            setActiveNavItem('agent-achievements');
            setAgentAchievementsOpen(true);
          },
        },
        {
          id: 'analytics-dashboard',
          label: 'Analytics Dashboard',
          icon: <EqualizerIcon />,
          active: activeNavItem === 'analytics-dashboard',
          onClick: () => {
            setActiveNavItem('analytics-dashboard');
            setAnalyticsDashboardOpen(true);
          },
        },
        {
          id: 'communication-tracking',
          label: 'Communication Tracking',
          icon: <ForwardToInboxIcon />,
          active: activeNavItem === 'communication-tracking',
          onClick: () => {
            setActiveNavItem('communication-tracking');
            setCommunicationTrackingOpen(true);
          },
        },
        {
          id: 'categorize-events',
          label: 'Manage Events',
          icon: <EventNoteIcon />,
          active: activeNavItem === 'categorize-events',
          onClick: () => {
            setActiveNavItem('categorize-events');
            setCategorizeEventsOpen(true);
          },
        },
        {
          id: 'manage-share-links',
          label: 'Manage Share Links',
          icon: <LinkIcon />,
          active: activeNavItem === 'manage-share-links',
          onClick: () => {
            setActiveNavItem('manage-share-links');
            setManageShareLinksOpen(true);
          },
        },
        {
          id: 'manage-super-showcase',
          label: 'Manage Super Showcase',
          icon: <HighlightAltIcon />,
          active: activeNavItem === 'manage-super-showcase',
          onClick: () => {
            setActiveNavItem('manage-super-showcase');
            setManageSuperShowcaseOpen(true);
          },
        },
        {
          id: 'manage-3d-sitemap',
          label: 'Manage 3D Sitemap',
          icon: <ViewInArIcon />,
          active: activeNavItem === 'manage-3d-sitemap',
          onClick: () => {
            setActiveNavItem('manage-3d-sitemap');
            setManage3dSitemapOpen(true);
          },
        },
        {
          id: 'manage-drone-view',
          label: 'Manage Drone View',
          icon: <FlightTakeoffIcon />,
          active: activeNavItem === 'manage-drone-view',
          onClick: () => {
            setActiveNavItem('manage-drone-view');
            setManageDroneViewOpen(true);
          },
        },
        {
          id: 'manage-floor-plan-north',
          label: 'Manage Floor Plan North',
          icon: <WbSunnyIcon />,
          active: activeNavItem === 'manage-floor-plan-north',
          onClick: () => {
            setActiveNavItem('manage-floor-plan-north');
            setManageFloorPlanNorthOpen(true);
          },
        },
        // Super Connector schedule setup — restricted to CEA HT260114 for now.
        ...(canManageConnectorSchedule ? [{
          id: 'manage-connector-schedule',
          label: 'Manage Connector Schedule',
          icon: <ScheduleRoundedIcon />,
          active: activeNavItem === 'manage-connector-schedule',
          onClick: () => {
            setActiveNavItem('manage-connector-schedule');
            setManageConnectorScheduleOpen(true);
          },
        }] : []),
      ],
    }] : []),
    // `Leader` — the leader-facing modules, kept together under Admin rather than
    // scattered through `Others`. The group is hidden unless at least one of its
    // entries is; each entry keeps its own guard, and the server has the final say
    // (canAccessLeaderVerification / canAccessTeamCpd / canAccessTeamStatistics on /api/users/me).
    ...((canAccessLeaderVerification || canAccessTeamCpd || canAccessTeamStatistics || isAdminUser) ? [{
      id: 'leader',
      label: 'Leader',
      items: [
        // Statistics — the leader's team (whole downline) through the admin
        // analytics; Shareable Links is its first tab. Admin-only for now: the
        // server sends canAccessTeamStatistics to admins only
        // (SHARE_LINK_STATISTICS_ADMIN_ONLY). Admins can pick any team.
        ...((canAccessTeamStatistics || isAdminUser) ? [{
          id: 'leader-statistics',
          label: 'Statistics',
          icon: <QueryStatsIcon />,
          active: activeNavItem === 'leader-statistics',
          onClick: () => {
            setActiveNavItem('leader-statistics');
            setLeaderStatisticsOpen(true);
          },
        }] : []),
        // Leader Verifications — eligible district directors (designation checked
        // server-side). Admins also see it so they can track who has taken each action.
        ...((canAccessLeaderVerification || isAdminUser) ? [{
          id: 'leader-verifications',
          label: 'Leader Verifications',
          icon: <FactCheckIcon />,
          active: activeNavItem === 'leader-verifications',
          onClick: () => {
            setActiveNavItem('leader-verifications');
            setLeaderVerificationInitialTab('mine');
            setLeaderVerificationOpen(true);
          },
        }] : []),
        // Team CPD Status — admin-only for now (the server's canAccessTeamCpd flag
        // decides; it also admits eligible district directors once Team CPD is
        // opened up, at which point each leader sees only their own team).
        ...((canAccessTeamCpd || isAdminUser) ? [{
          id: 'team-cpd',
          label: 'Team CPD Status',
          icon: <GroupsIcon />,
          active: activeNavItem === 'team-cpd',
          onClick: () => {
            setActiveNavItem('team-cpd');
            setTeamCpdOpen(true);
          },
        }] : []),
      ],
    }] : []),
    // `Accelerator` — Super Accelerators grant unreleased features (Good Deals
    // Map, Decoupling Calculator) to other agents.
    ...(isAcceleratorUser ? [{
      id: 'accelerator',
      label: 'Accelerator',
      items: [
        {
          id: 'accelerator-grant-access',
          label: 'Feature Release',
          icon: <VpnKeyIcon />,
          active: activeNavItem === 'accelerator-grant-access',
          onClick: () => {
            setActiveNavItem('accelerator-grant-access');
            setAcceleratorGrantOpen(true);
          },
        },
      ],
    }] : []),
    // `Project Head` — the modules for whoever runs a project: Head / Deputy Head
    // of Project, or the IC of a project with neither (hasVerifiableProjects /
    // leadsProjects), plus admins and Project Dept. Each entry keeps its own
    // guard and the server enforces them again.
    ...(isProjectHeadUser ? [{
      id: 'project-head',
      label: 'Project Head',
      items: [
        // Statistics — Project Activities (first tab) and the Shareable Links
        // analytics for one project the user heads.
        {
          id: 'project-head-statistics',
          label: 'Statistics',
          icon: <QueryStatsIcon />,
          active: activeNavItem === 'project-head-statistics',
          onClick: () => {
            setActiveNavItem('project-head-statistics');
            setProjectHeadStatisticsOpen(true);
          },
        },
        ...((isAdminUser || isProjectDeptUser || hasVerifiableProjects) ? [{
          id: 'project-verification',
          label: 'Project Verification',
          icon: <VerifiedUserIcon />,
          active: activeNavItem === 'project-verification',
          onClick: () => {
            setActiveNavItem('project-verification');
            setProjectVerificationInitialTab('mine');
            setProjectVerificationOpen(true);
          },
        }] : []),
        ...((projectActionAccess.isAdmin || projectActionAccess.leadsProjects) ? [projectActionNavItem] : []),
        ...((isAdminUser || isProjectDeptUser || hasVerifiableProjects) ? [{
          id: 'share-setup',
          label: 'Sharables Setup',
          icon: <ChatIcon />,
          active: activeNavItem === 'share-setup',
          onClick: () => {
            setActiveNavItem('share-setup');
            setManageProjectMessagesOpen(true);
          },
        }] : []),
      ],
    }] : []),
    // `Board` — admin-only for now; the situation-map endpoints are gated with
    // `requireAdmin` too.
    ...(isAdminUser ? [{
      id: 'board',
      label: 'Board',
      items: [
        {
          id: 'situation-map',
          label: 'Situation Map',
          icon: <MapIcon />,
          active: activeTabId === 'situation-map',
          onClick: () => {
            setActiveTabId('situation-map');
            setActiveClientId(null);
          },
        },
        {
          id: 'institution-power',
          label: 'Institution Power',
          icon: <AccountBalanceIcon />,
          active: activeNavItem === 'institution-power',
          onClick: () => {
            setActiveNavItem('institution-power');
            setInstitutionPowerOpen(true);
          },
        },
      ],
    }] : []),
    // The `Others` group is visible to every agent because it always
    // contains the Training entry. Items inside the group still have
    // their own role/eligibility guards.
    {
      id: 'others',
      label: 'Others',
      items: [
        // Core-team members who hold Project Action calls but lead no project
        // find it here; project leads have it under `Project Head`.
        ...((!projectActionAccess.isAdmin && !projectActionAccess.leadsProjects && projectActionAccess.hasTasks)
          ? [projectActionNavItem]
          : []),
        // "My Videos" — submitter management of podcast / training videos
        // (edit/delete). Admins, accelerators, and project ICs.
        ...(canAccessMyVideos ? [{
          id: 'my-podcasts',
          label: 'My Videos',
          icon: <OndemandVideoIcon />,
          active: activeNavItem === 'my-podcasts',
          onClick: () => {
            setActiveNavItem('my-podcasts');
            setMyPodcastsOpen(true);
          },
        }] : []),
        // Manage Videos — approve/reject queue. Admins and VIDEO-APPROVER.
        ...(canManageVideos ? [{
          id: 'manage-podcast-videos',
          label: 'Manage Videos',
          icon: <VideoLibraryIcon />,
          active: activeNavItem === 'manage-podcast-videos',
          onClick: () => {
            setActiveNavItem('manage-podcast-videos');
            setManagePodcastVideosOpen(true);
          },
        }] : []),
        // CPD Analytics — admin-only dashboard, also deep-linked via ?redirect=cpd.
        ...(isAdminUser ? [{
          id: 'cpd-analytics',
          label: 'CPD Analytics',
          icon: <QueryStatsIcon />,
          active: activeNavItem === 'cpd-analytics',
          onClick: () => {
            setActiveNavItem('cpd-analytics');
            setCpdAnalyticsOpen(true);
          },
        }] : []),
        ...(canAccessProjectEssentialsAnalytics ? [{
          id: 'project-essentials-analytics',
          label: 'Project Essentials Analytics',
          icon: <QueryStatsIcon />,
          active: activeNavItem === 'project-essentials-analytics',
          onClick: () => {
            setActiveNavItem('project-essentials-analytics');
            setProjectEssentialsAnalyticsOpen(true);
          },
        }] : []),
        {
          id: 'distinctive',
          label: 'Distinctives',
          icon: <CampaignIcon />,
          active: activeNavItem === 'distinctive',
          onClick: () => {
            setActiveNavItem('distinctive');
            setDistinctiveOpen(true);
          },
        },
        {
          id: 'register-for-training',
          label: 'Training',
          icon: <SchoolIcon />,
          active: activeNavItem === 'register-for-training',
          onClick: () => {
            const currentCea = userInfo?.CEANumber || getDevCea();
            logMenuClick('Training', currentCea);
            logRegisterForTrainingClick(currentCea);
            setActiveNavItem('register-for-training');
            setEventRegistrationOpen(true);
          },
        },
        ...(isTrainingTrainer
          ? [
              {
                id: 'trainer-manage-events',
                label: 'Manage Events',
                icon: <EventNoteIcon />,
                active: activeNavItem === 'trainer-manage-events',
                onClick: () => {
                  setActiveNavItem('trainer-manage-events');
                  setTrainerManageEventsOpen(true);
                },
              },
            ]
          : []),
        // Admins + the COMM-STRUCTURE role; the endpoint enforces the same gate.
        ...(canAccessCommissionStructure ? [{
          id: 'commission-structure',
          label: 'Commission Structure',
          icon: <PercentIcon />,
          active: activeNavItem === 'commission-structure',
          onClick: () => {
            const currentCea = userInfo?.CEANumber || getDevCea();
            logMenuClick('Commission Structure', currentCea);
            setActiveNavItem('commission-structure');
            setCommissionStructureOpen(true);
          },
        }] : []),
      ],
    },
    {
      id: 'disclaimer',
      label: 'Disclaimer',
      items: [
        {
          id: 'disclaimer-info',
          label: 'Disclaimer',
          icon: <InfoIcon />,
          active: false,
          onClick: () => {
            setDisclaimerOpen(true);
          },
        },
      ],
    },
  ];
  }, [
    activeNavItem,
    activeTabId,
    clientInterestsCount,
    isAdminUser,
    canAccessProjectEssentialsAnalytics,
    canAccessMyVideos,
    canManageVideos,
    isAcceleratorUser,
    isProjectDeptUser,
    canAccessSuccessCloser,
    isExternalUser,
    pendingManageUsersCount,
    hasVerifiableProjects,
    canAccessLeaderVerification,
    canAccessTeamCpd,
    canAccessTeamStatistics,
    isProjectHeadUser,
    projectActionAccess,
    canAccessCommissionStructure,
    canAccessSuperShowcase,
    canAccessSitemap3d,
    isTrainingTrainer,
    hasRecentPricePromo,
    canAccessPricePromo,
    canAccessPricePromoWatchlist,
    pricePromoWatchlistsWithNewMatches.length,
    hasUnacknowledgedPricePromoUpdates,
    acknowledgeCurrentPricePromoUpdates,
    superShowcases.length,
    unseenAnticipateIds,
    userInfo?.CEANumber,
    thumbsupGroupsByProject.length,
    thumbsupUnits.length,
    latestViewedThumbsupUnit,
    pricePromoTotalProjects,
    pricePromoUnits.length,
    pricePromoLatestUnits.length,
    pricePromoTopSavingUnits.length,
    selectedProject,
  ]);

  /**
   * The Project Research results card: the projects and units tables with
   * their column headers, sorting, per-column filters, column visibility and
   * PDF export. Rendered both on the Project Research tab and inside Super
   * Showcase, so the two can never drift apart.
   */
  // The Project Research search criteria card — on the tab, and behind the
  // Super Showcase results' Edit link.
  const renderMasterToolSearchCriteria = () => (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: 'var(--color-text-strong)' }}>Search Criteria</Typography>
        <Grid
          container
          spacing={2}
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, minmax(0, 1fr))',
              md: 'repeat(5, minmax(0, 1fr))',
              lg: 'repeat(5, minmax(0, 1fr))',
            },
            gap: { xs: 2, md: 1.25, lg: 2 },
            '& > .MuiGrid-item': {
              width: 'auto !important',
              maxWidth: 'none !important',
              minWidth: 0,
              padding: '0 !important',
            },
            // Keep the compact tablet grid usable for numeric ranges. In
            // particular, an 8-digit price must fit beside its Min/Max peer.
            '& .MuiOutlinedInput-input': {
              minWidth: 0,
              px: { md: 0.75, lg: 1.25 },
              fontSize: { md: '0.8rem', lg: '0.875rem' },
            },
            '& .MuiOutlinedInput-input::placeholder': {
              opacity: 1,
              fontSize: { md: '0.8rem', lg: '0.875rem' },
            },
          }}
        >
          {/* Price Range */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>
              Price ($)
              <Box component="span" sx={{ color: 'var(--color-warning-strong)', ml: 0.25 }}>*</Box>
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                size="small"
                placeholder="Min"
                type="text"
                autoComplete="off"
                inputProps={{ inputMode: 'decimal', autoComplete: 'off' }}
                value={formatThousandsInput(masterToolFilters.priceMin || '')}
                onChange={(e) => setMasterToolFilters(f => ({ ...f, priceMin: e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '') }))}
                sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }}
              />
              <TextField
                size="small"
                placeholder="Max"
                type="text"
                autoComplete="off"
                inputProps={{ inputMode: 'decimal', autoComplete: 'off' }}
                value={formatThousandsInput(masterToolFilters.priceMax || '')}
                onChange={(e) => setMasterToolFilters(f => ({ ...f, priceMax: e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '') }))}
                sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }}
              />
            </Box>
          </Grid>
          {/* PSF Range */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>PSF ($/sqft)</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                size="small"
                placeholder="Min"
                type="text"
                autoComplete="off"
                inputProps={{ inputMode: 'decimal', autoComplete: 'off' }}
                value={formatThousandsInput(masterToolFilters.psfMin || '')}
                onChange={(e) => setMasterToolFilters(f => ({ ...f, psfMin: e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '') }))}
                sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }}
              />
              <TextField
                size="small"
                placeholder="Max"
                type="text"
                autoComplete="off"
                inputProps={{ inputMode: 'decimal', autoComplete: 'off' }}
                value={formatThousandsInput(masterToolFilters.psfMax || '')}
                onChange={(e) => setMasterToolFilters(f => ({ ...f, psfMax: e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '') }))}
                sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }}
              />
            </Box>
          </Grid>
          {/* Size Range */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>Size (sqft)</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Min" value={masterToolFilters.sizeMin || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, sizeMin: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Max" value={masterToolFilters.sizeMax || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, sizeMax: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
            </Box>
          </Grid>
          {/* Bedroom Range */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>Bedroom</Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Min" value={masterToolFilters.bedroomMin || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, bedroomMin: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Max" value={masterToolFilters.bedroomMax || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, bedroomMax: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={Boolean(masterToolFilters.phOnly)}
                    onChange={(e) => setMasterToolFilters(f => ({ ...f, phOnly: e.target.checked }))}
                    sx={{ p: 0.5, color: 'rgba(var(--color-text-rgb), 0.5)', '&.Mui-checked': { color: 'var(--color-warning-strong)' } }}
                  />
                }
                label={<Typography variant="caption" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', whiteSpace: 'nowrap' }}>PH only</Typography>}
                title="Penthouse units only"
                sx={{ mr: 0, ml: 0 }}
              />
            </Box>
          </Grid>
          {/* Floor Level Range */}
          <Grid item xs={12} sm={6} md={3} sx={{ gridColumn: { md: 1 }, gridRow: { md: 2 } }}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>Floor Level</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Min" value={masterToolFilters.floorMin || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, floorMin: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Max" value={masterToolFilters.floorMax || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, floorMax: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
            </Box>
          </Grid>
          {/* Bath Range */}
          <Grid item xs={12} sm={6} md={3} sx={{ gridColumn: { md: 5 }, gridRow: { md: 1 } }}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>Bath</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Min" value={masterToolFilters.bathMin || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, bathMin: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Max" value={masterToolFilters.bathMax || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, bathMax: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
            </Box>
          </Grid>
          {/* District Multi-Select */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>District</Typography>
            <Autocomplete
              multiple
              disableCloseOnSelect
              size="small"
              options={masterToolDistrictOptions}
              value={(masterToolFilters.districts || [])
                .map((no) => masterToolDistrictOptions.find((d) => d.no === no))
                .filter((d): d is DistrictOption => Boolean(d))}
              onChange={(_, value) =>
                setMasterToolFilters((f) => ({
                  ...f,
                  districts: value.map((item) => item.no),
                }))
              }
              getOptionLabel={(opt) => {
                const option: DistrictOption =
                  typeof (opt as any)?.no === 'string'
                    ? (opt as DistrictOption)
                    : masterToolDistrictOptions.find((d) => d.no === String(opt)) || { no: String(opt), name: null, generalLocation: null };
                const name = option.name ?? option.generalLocation ?? '';
                return name || `D${option.no}`;
              }}
              isOptionEqualToValue={(option, value) => option.no === value.no}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoComplete="off"
                  inputProps={{ ...params.inputProps, autoComplete: 'off' }}
                  placeholder="Select districts"
                  sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }}
                />
              )}
              renderTags={(value, getTagProps) =>
                value.map((opt, idx) => {
                  const name = opt.name ?? opt.generalLocation ?? '';
                  const label = name || `D${opt.no}`;
                  return <Chip {...getTagProps({ index: idx })} key={opt.no} label={label} size="small" />;
                })
              }
            />
          </Grid>
          {/* Region Multi-Select */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>Region</Typography>
            <Autocomplete
              multiple
              disableCloseOnSelect
              size="small"
              options={['CCR', 'OCR', 'RCR']}
              value={masterToolFilters.regions || []}
              onChange={(_, value) => setMasterToolFilters(f => ({ ...f, regions: value }))}
              renderInput={(params) => <TextField {...params} autoComplete="off" inputProps={{ ...params.inputProps, autoComplete: 'off' }} placeholder="Select regions" sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />}
              renderTags={(value, getTagProps) => value.map((opt, idx) => <Chip {...getTagProps({ index: idx })} key={opt} label={opt} size="small" />)}
            />
          </Grid>
          {/* Tenure Multi-Select */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>Tenure</Typography>
            <Autocomplete
              multiple
              disableCloseOnSelect
              size="small"
              options={['99', '999-year leasehold', 'freehold']}
              value={masterToolFilters.tenure || []}
              onChange={(_, value) => setMasterToolFilters(f => ({ ...f, tenure: value }))}
              getOptionLabel={(opt) => (opt === '99' ? '99-year' : opt === 'freehold' ? 'Freehold' : '999-year')}
              renderInput={(params) => <TextField {...params} autoComplete="off" inputProps={{ ...params.inputProps, autoComplete: 'off' }} placeholder="Select tenure" sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />}
              renderTags={(value, getTagProps) => value.map((opt, idx) => <Chip {...getTagProps({ index: idx })} key={opt} label={opt === '99' ? '99-year' : opt === 'freehold' ? 'Freehold' : '999-year'} size="small" />)}
            />
          </Grid>
          {/* Project Category Multi-Select */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>Project Category</Typography>
            <Autocomplete
              multiple
              disableCloseOnSelect
              size="small"
              options={masterToolProjectCategoryList}
              getOptionLabel={(option) => option.name ?? option.id}
              value={masterToolProjectCategorySelections}
              onChange={(_, value) => setMasterToolFilters(f => ({ ...f, projectCategories: value.map((item) => item.id) }))}
              renderInput={(params) => <TextField {...params} autoComplete="off" inputProps={{ ...params.inputProps, autoComplete: 'off' }} placeholder="Select categories" sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />}
              renderTags={(value, getTagProps) => value.map((opt, idx) => <Chip {...getTagProps({ index: idx })} key={opt.id} label={opt.name ?? opt.id} size="small" />)}
            />
          </Grid>
          {/* TOP Year Range */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>TOP Year</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Min" value={masterToolFilters.topYearMin || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, topYearMin: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
              <TextField size="small" autoComplete="off" inputProps={{ autoComplete: 'off' }} placeholder="Max" value={masterToolFilters.topYearMax || ''} onChange={(e) => setMasterToolFilters(f => ({ ...f, topYearMax: e.target.value }))} sx={{ flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }} />
            </Box>
          </Grid>
          {/* Unit Type */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>Unit Type</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 40 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={Boolean(masterToolFilters.dualKeyOnly)}
                    onChange={(e) => setMasterToolFilters(f => ({ ...f, dualKeyOnly: e.target.checked }))}
                    sx={{ p: 0.5, color: 'rgba(var(--color-text-rgb), 0.5)', '&.Mui-checked': { color: 'var(--color-warning-strong)' } }}
                  />
                }
                label={<Typography variant="caption" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', whiteSpace: 'nowrap' }}>Dual Key</Typography>}
                title="Dual key units only"
                sx={{ mr: 0, ml: 0 }}
              />
            </Box>
          </Grid>
          {/* Reference Location (OneMap) */}
          <Grid item xs={12} sm={6} md={6} sx={{ gridColumn: { md: 'span 2' } }}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block', whiteSpace: 'nowrap' }}>Reference Project/Location</Typography>
            <Autocomplete
              size="small"
              options={masterToolLocationOptions}
              value={masterToolSelectedLocation}
              inputValue={masterToolLocationInput}
              loading={masterToolLocationSearching}
              filterOptions={(x) => x}
              getOptionLabel={(opt) => formatOnemapLocationLabel(opt)}
              isOptionEqualToValue={(a, b) =>
                a.SEARCHVAL === b.SEARCHVAL
                && a.LATITUDE === b.LATITUDE
                && a.LONGITUDE === b.LONGITUDE
              }
              onInputChange={(_, value, reason) => {
                if (reason !== 'input') return;
                setMasterToolLocationInput(value);
                if (!value.trim()) {
                  clearMasterToolLocationFilters();
                  return;
                }
                if (
                  masterToolSelectedLocation
                  && value !== formatOnemapLocationLabel(masterToolSelectedLocation)
                ) {
                  setMasterToolSelectedLocation(null);
                  setMasterToolFilters((f) => {
                    const { locationLat, locationLng, locationLabel, radiusKm, ...rest } = f;
                    return rest;
                  });
                }
              }}
              onChange={(_, value) => {
                if (!value) {
                  clearMasterToolLocationFilters();
                  return;
                }
                const coords = parseOnemapCoordinates(value);
                if (!coords) return;
                setMasterToolSelectedLocation(value);
                setMasterToolLocationInput(formatOnemapLocationLabel(value));
                setMasterToolFilters((f) => ({
                  ...f,
                  locationLat: String(coords.lat),
                  locationLng: String(coords.lng),
                  locationLabel: formatOnemapLocationLabel(value),
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoComplete="off"
                  inputProps={{ ...params.inputProps, autoComplete: 'off' }}
                  placeholder="Search address or place"
                  sx={{ '& .MuiOutlinedInput-root': { bgcolor: 'var(--color-surface)' } }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {masterToolLocationSearching ? <CircularProgress color="inherit" size={16} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          {/* Radius (km) */}
          <Grid item xs={12} sm={6} md={3} sx={{ gridColumn: { md: 5 }, gridRow: { md: 3 } }}>
            <Typography variant="caption" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, mb: 0.5, display: 'block' }}>Radius (km)</Typography>
            <TextField
              size="small"
              type="text"
              disabled={!masterToolSelectedLocation}
              autoComplete="off"
              inputProps={{ inputMode: 'decimal', autoComplete: 'off' }}
              placeholder="e.g. 5"
              value={masterToolFilters.radiusKm || ''}
              onChange={(e) => {
                const radiusKm = e.target.value.replace(/[^\d.]/g, '');
                setMasterToolFilters((f) => ({ ...f, radiusKm }));
              }}
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  bgcolor: 'var(--color-surface)',
                  ...(isMasterToolRadiusMissing
                    ? {
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-accent)',
                        borderWidth: 2,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-accent)',
                      },
                    }
                    : {}),
                },
              }}
            />
          </Grid>
        </Grid>
        <Typography variant="body2" sx={{ mt: 2, color: 'var(--color-warning-strong)', fontWeight: 600 }}>
          * Note: Normal Payment Scheme (NPS) price will be used as price search for Executive Condo
        </Typography>
        <Box sx={{ mt: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
          <Button
            variant="contained"
            onClick={handleMasterToolSearch}
            disabled={
              masterToolLoading
              || (Boolean(masterToolSelectedLocation)
                && !(Number.isFinite(Number(masterToolFilters.radiusKm ?? '')) && Number(masterToolFilters.radiusKm ?? '') > 0))
            }
            sx={{ bgcolor: 'var(--color-accent)', '&:hover': { bgcolor: 'var(--color-accent-hover)' } }}
          >
            {masterToolLoading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'SEARCH'}
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setMasterToolFilters({ priceMin: '1' });
              clearMasterToolLocationFilters();
              setMasterToolAmberwoodBedrooms([]);
              setMasterToolResults([]);
              setMasterToolUnits([]);
              setMasterToolTotalMatchedUnits(0);
              setMasterToolUnitPage(1);
              setMasterToolProjectPage(1);
              setSelectedMasterToolProjectKeys(new Set());
            }}
            sx={{ borderColor: 'var(--color-accent)', color: 'var(--color-accent)' }}
          >
            CLEAR
          </Button>
          <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', ml: 'auto' }}>
            {masterToolViewMode === 'project' ? `${masterToolResults.length} projects found` : `${masterToolTotalMatchedUnits} units found`}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );

  const renderMasterToolResults = () => (
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', mb: 2, gap: 1, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'var(--color-text-strong)' }}>Results</Typography>
                  </Box>
                  {masterToolViewMode === 'project' && (
                    <Typography variant="caption" sx={{ color: 'var(--color-warning-strong)', fontWeight: 600 }}>
                      * Note: Normal Payment Scheme (NPS) price will be used as price search for Executive Condo
                    </Typography>
                  )}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<PictureAsPdfIcon fontSize="small" />}
                      onClick={handleExportMasterToolPdf}
                      disabled={
                        masterToolLoading
                        || (masterToolViewMode === 'project' ? selectedMasterToolProjectRowsForExport.length === 0 : masterToolTotalMatchedUnits === 0)
                      }
                    >
                      Export PDF
                    </Button>
                    {masterToolViewMode === 'project' && selectedMasterToolProjectKeys.size > 0 && (
                      <Chip
                        label={`${selectedMasterToolProjectRowsForExport.length} selected for PDF`}
                        size="small"
                        onDelete={() => setSelectedMasterToolProjectKeys(new Set())}
                        sx={{
                          bgcolor: 'rgba(var(--color-accent-rgb, 232, 160, 70), 0.15)',
                          color: 'var(--color-accent)',
                          fontWeight: 600,
                        }}
                      />
                    )}
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
                  <ToggleButtonGroup size="small" exclusive value={masterToolViewMode} onChange={handleMasterToolViewModeChange}>
                    <ToggleButton value="project" sx={{ fontSize: '0.7rem', py: 0.5, color: 'var(--color-text-strong)', '&.Mui-selected': { bgcolor: 'rgba(var(--color-accent-rgb, 232, 160, 70), 0.15)', color: 'var(--color-accent)' } }}>
                      Project View ({masterToolProjectRowsForDisplay.length})
                    </ToggleButton>
                    <ToggleButton value="unit" sx={{ fontSize: '0.7rem', py: 0.5, color: 'var(--color-text-strong)', '&.Mui-selected': { bgcolor: 'rgba(var(--color-accent-rgb, 232, 160, 70), 0.15)', color: 'var(--color-accent)' } }}>
                      Unit View ({masterToolUnitViewCount})
                    </ToggleButton>
                  </ToggleButtonGroup>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                  {SHOW_PROJECT_RESEARCH_EXPORT_CSV && (
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<DownloadIcon fontSize="small" />}
                      onClick={handleExportMasterToolCsv}
                      disabled={masterToolLoading || (masterToolViewMode === 'project' ? masterToolProjectRowsForDisplay.length === 0 : masterToolTotalMatchedUnits === 0)}
                    >
                      Export CSV
                    </Button>
                  )}
                  {hasAnyMasterToolTableFilters && (
                    <Button
                      size="small"
                      onClick={handleClearMasterToolTableFilters}
                      sx={{ color: 'var(--color-text-muted)', '&:hover': { color: 'var(--color-accent)' } }}
                    >
                      Clear all filters
                    </Button>
                  )}
                  {masterToolViewMode === 'project' && masterToolResults.length > 0 && (
                    <ColumnVisibilityMenu
                      anchorEl={masterToolProjectColumnsAnchor}
                      columns={masterToolProjectColumnsForMenu}
                      getLabel={(column) => getMasterToolProjectColumnLabel(column as MasterToolProjectFilterSortColumnKey)}
                      onClose={() => setMasterToolProjectColumnsAnchor(null)}
                      onOpen={(event) => setMasterToolProjectColumnsAnchor(event.currentTarget)}
                      onPresetSelect={applyMasterToolProjectDetailsColumns}
                      presetLabel="PROJECT DETAILS ONLY"
                      presetChecked={isMasterToolProjectDetailsOnlySelected}
                      onReset={resetMasterToolProjectColumns}
                      onToggle={toggleMasterToolProjectColumn}
                      isColumnChecked={(column) => isMasterToolProjectColumnVisible(column as MasterToolProjectFilterSortColumnKey)}
                      visibility={masterToolProjectColumnVisibility}
                    />
                  )}
                  {masterToolViewMode === 'unit' && masterToolTotalMatchedUnits > 0 && (
                    <ColumnVisibilityMenu
                      anchorEl={masterToolUnitColumnsAnchor}
                      columns={masterToolUnitColumnsForMenu}
                      getLabel={(column) => getMasterToolUnitColumnLabel(column as MasterToolUnitColumnKey)}
                      onClose={() => setMasterToolUnitColumnsAnchor(null)}
                      onOpen={(event) => setMasterToolUnitColumnsAnchor(event.currentTarget)}
                      onReset={resetMasterToolUnitColumns}
                      onToggle={toggleMasterToolUnitColumn}
                      visibility={masterToolUnitColumnVisibility}
                    />
                  )}
                  </Box>
                </Box>
              </Box>
              {masterToolTableFilterSummaryParts.length > 0 && (
                <Box sx={{ mb: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                  <Typography variant="caption" sx={{ color: 'var(--color-accent)', fontWeight: 600, mr: 0.5 }}>
                    Filtered:
                  </Typography>
                  {masterToolTableFilterSummaryParts.map((part, index) => (
                    <Chip
                      key={`master-tool-filter-${index}-${part}`}
                      label={part}
                      size="small"
                      sx={{
                        bgcolor: 'rgba(255, 152, 0, 0.15)',
                        color: 'var(--color-accent)',
                        fontWeight: 500,
                        fontSize: '0.7rem',
                      }}
                    />
                  ))}
                </Box>
              )}
              {masterToolLoading && <LinearProgress sx={{ mb: 2, '& .MuiLinearProgress-bar': { bgcolor: 'var(--color-accent)' } }} />}

              <Dialog
                open={masterToolPdfWarningOpen}
                onClose={() => setMasterToolPdfWarningOpen(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                  sx: {
                    bgcolor: 'var(--color-surface)',
                    color: 'var(--color-text-strong)',
                    border: '1px solid rgba(var(--color-text-rgb), 0.08)',
                    boxShadow: '0 12px 32px rgba(var(--color-shadow-rgb), 0.35)',
                  },
                }}
              >
                <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 700 }}>
                  Continue PDF export?
                </DialogTitle>
                <DialogContent>
                  {masterToolPendingPdfExportMode === 'project' && (
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)', fontWeight: 600 }}>
                        Exporting {selectedMasterToolProjectRowsForExport.length} {selectedMasterToolProjectRowsForExport.length === 1 ? 'project' : 'projects'}.
                      </Typography>
                    </Box>
                  )}
                  {masterToolPdfWarningColumnCount > 15 && (
                    <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                      You currently have {masterToolPdfWarningColumnCount} visible columns. The PDF can still be generated, but some columns may be compressed and less readable. Do you want to continue?
                    </Typography>
                  )}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                  <Button
                    onClick={() => {
                      setMasterToolPdfWarningOpen(false);
                      setMasterToolPendingPdfExportMode(null);
                    }}
                    sx={{ color: 'var(--color-text-muted)' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={async () => {
                      if (!masterToolPendingPdfExportMode) return;
                      setMasterToolPdfWarningOpen(false);
                      const exportMode = masterToolPendingPdfExportMode;
                      setMasterToolPendingPdfExportMode(null);
                      await runMasterToolPdfExport(exportMode);
                    }}
                    sx={{ bgcolor: 'var(--color-accent)', '&:hover': { bgcolor: 'var(--color-accent-hover)' } }}
                  >
                    Continue
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={masterToolPdfExportOverMaxOpen}
                onClose={() => setMasterToolPdfExportOverMaxOpen(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                  sx: {
                    bgcolor: 'var(--color-surface)',
                    color: 'var(--color-text-strong)',
                    border: '1px solid rgba(var(--color-text-rgb), 0.08)',
                    boxShadow: '0 12px 32px rgba(var(--color-shadow-rgb), 0.35)',
                  },
                }}
              >
                <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 700 }}>
                  PDF export limit
                </DialogTitle>
                <DialogContent>
                  <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                    {masterToolViewMode === 'unit'
                      ? `Only the first ${PDF_EXPORT_MAX_RECORDS_BY_VIEW.unit.toLocaleString()} records will be included in the PDF export.`
                      : `No more than ${PDF_EXPORT_MAX_RECORDS_BY_VIEW.project.toLocaleString()} records can be included in a PDF export. Narrow your filters to reduce the result count, then try again.`}
                  </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                  {masterToolViewMode === 'unit' && (
                    <Button
                      onClick={() => setMasterToolPdfExportOverMaxOpen(false)}
                      sx={{ color: 'var(--color-text-muted)' }}
                    >
                      Cancel
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (masterToolViewMode === 'unit') {
                        void handleConfirmUnitPdfExportLimit();
                        return;
                      }
                      setMasterToolPdfExportOverMaxOpen(false);
                    }}
                    sx={{ bgcolor: 'var(--color-accent)', '&:hover': { bgcolor: 'var(--color-accent-hover)' } }}
                  >
                    {masterToolViewMode === 'unit' ? 'Export first 50' : 'OK'}
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={masterToolPdfExportLargeConfirmOpen}
                onClose={() => setMasterToolPdfExportLargeConfirmOpen(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                  sx: {
                    bgcolor: 'var(--color-surface)',
                    color: 'var(--color-text-strong)',
                    border: '1px solid rgba(var(--color-text-rgb), 0.08)',
                    boxShadow: '0 12px 32px rgba(var(--color-shadow-rgb), 0.35)',
                  },
                }}
              >
                <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 700 }}>
                  Large PDF export
                </DialogTitle>
                <DialogContent>
                  <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                    You are exporting more than {PDF_EXPORT_LARGE_THRESHOLD.toLocaleString()} records. You may export more than{' '}
                    {PDF_EXPORT_LARGE_THRESHOLD.toLocaleString()} records as PDF only once per calendar day. Continue?
                  </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                  <Button onClick={() => setMasterToolPdfExportLargeConfirmOpen(false)} sx={{ color: 'var(--color-text-muted)' }}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      void handleConfirmLargePdfExport();
                    }}
                    sx={{ bgcolor: 'var(--color-accent)', '&:hover': { bgcolor: 'var(--color-accent-hover)' } }}
                  >
                    Export PDF
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={masterToolPdfExportDailyUsedOpen}
                onClose={() => setMasterToolPdfExportDailyUsedOpen(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                  sx: {
                    bgcolor: 'var(--color-surface)',
                    color: 'var(--color-text-strong)',
                    border: '1px solid rgba(var(--color-text-rgb), 0.08)',
                    boxShadow: '0 12px 32px rgba(var(--color-shadow-rgb), 0.35)',
                  },
                }}
              >
                <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 700 }}>
                  Daily PDF limit reached
                </DialogTitle>
                <DialogContent>
                  <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                    You have already used your PDF export for result sets over {PDF_EXPORT_LARGE_THRESHOLD.toLocaleString()} records today. Try again tomorrow, or narrow your filters to{' '}
                    {PDF_EXPORT_LARGE_THRESHOLD.toLocaleString()} records or fewer.
                  </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                  <Button
                    variant="contained"
                    onClick={() => setMasterToolPdfExportDailyUsedOpen(false)}
                    sx={{ bgcolor: 'var(--color-accent)', '&:hover': { bgcolor: 'var(--color-accent-hover)' } }}
                  >
                    OK
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Master Tool Project View Table */}
              {masterToolViewMode === 'project' && masterToolResults.length > 0 && (
                <Box>
                  <TableContainer sx={{ maxHeight: 600, overflow: 'auto' }}>
                    <Table stickyHeader size="small" sx={{
                      '& .MuiTableCell-root': { py: 0.75, px: 1, fontSize: '0.8rem', borderColor: 'rgba(var(--color-text-rgb), 0.08)', color: 'var(--color-text-strong)' },
                      '& .MuiTableHead-root .MuiTableCell-root': { bgcolor: 'var(--color-surface-thead)', fontWeight: 600 },
                      ...masterToolProjectTableVisibilitySx,
                    }}>
                      <colgroup>
                        <col style={{ width: 48, minWidth: 48 }} />
                        <col data-column="projectName" style={{ width: 200, minWidth: 200 }} />
                        <col data-column="projectCategory" style={{ width: 140 }} />
                        {hasMasterToolReferenceLocation && <col data-column="referenceDistanceKm" style={{ width: 110 }} />}
                        <col data-column="matchedTotal" style={{ width: 90 }} />
                        {MASTER_TOOL_MATCHED_BR_BUCKETS.map((bucket) => {
                          if (!masterToolMatchedVisibleBrColumns[bucket]) return null;
                          const countColumn = MASTER_TOOL_MATCHED_COUNT_COLUMN_BY_BUCKET[bucket];
                          const fromColumn = MASTER_TOOL_MATCHED_FROM_COLUMN_BY_BUCKET[bucket];
  return (
                            <Fragment key={bucket}>
                              <col data-column={countColumn} style={{ width: 70 }} />
                              {isMasterToolProjectColumnVisible(fromColumn) && (
                                <col data-column={fromColumn} style={{ width: 90 }} />
                              )}
                            </Fragment>
                          );
                        })}
                        <col data-column="developer" style={{ width: 140 }} />
                        <col data-column="totalUnits" style={{ width: 100 }} />
                        <col data-column="soldUnits" style={{ width: 100 }} />
                        <col data-column="districtLocation" style={{ width: 180 }} />
                        <col data-column="district" style={{ width: 120 }} />
                        <col data-column="region" style={{ width: 120 }} />
                        <col data-column="nearestMrt" style={{ width: 160 }} />
                        <col data-column="walkingTimeToMrt" style={{ width: 110 }} />
                        <col data-column="tenure" style={{ width: 130 }} />
                        <col data-column="topDate" style={{ width: 120 }} />
                        <col data-column="completedDate" style={{ width: 130 }} />
                        {(['br1avail', 'br1price', 'br1psf', 'br2avail', 'br2price', 'br2psf', 'br3avail', 'br3price', 'br3psf', 'br4avail', 'br4price', 'br4psf', 'br5avail', 'br5price', 'br5psf', 'phavail', 'phprice', 'phpsf'] as const).map((column, i) => <col key={column} data-column={column} style={{ width: i % 3 === 1 ? 150 : 90 }} />)}
                      </colgroup>
                      <TableHead>
                        <TableRow>
                          <TableCell padding="checkbox" sx={{ position: 'sticky', left: 0, zIndex: 3, minWidth: 48, width: 48, bgcolor: 'var(--color-surface-thead)', borderRight: '1px solid rgba(var(--color-text-rgb), 0.1)' }}>
                            <Checkbox
                              size="small"
                              checked={areAllVisibleMasterToolProjectsSelected}
                              indeterminate={areSomeVisibleMasterToolProjectsSelected}
                              onChange={handleToggleAllVisibleMasterToolProjectSelection}
                              inputProps={{ 'aria-label': 'Select all visible projects for PDF export' }}
                              sx={{ color: 'var(--color-accent)', '&.Mui-checked': { color: 'var(--color-accent)' }, '&.MuiCheckbox-indeterminate': { color: 'var(--color-accent)' } }}
                            />
                          </TableCell>
                          <TableCell data-column="projectName" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', position: 'sticky', left: 48, zIndex: 2, minWidth: 200, width: 200, bgcolor: 'var(--color-surface-thead)', borderRight: '1px solid rgba(var(--color-text-rgb), 0.1)' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('projectName')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'projectName')} sx={getMasterToolProjectIconButtonSx('projectName')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('projectName'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="projectCategory" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 140 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('projectCategory')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'projectCategory')} sx={getMasterToolProjectIconButtonSx('projectCategory')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('projectCategory'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          {hasMasterToolReferenceLocation && (
                            <TableCell data-column="referenceDistanceKm" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 110 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                                {getMasterToolProjectColumnLabel('referenceDistanceKm')}
                                <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'referenceDistanceKm')} sx={getMasterToolProjectIconButtonSx('referenceDistanceKm')}>
                                  {renderSortIndicatorIcon(getMasterToolProjectSortDirection('referenceDistanceKm'))}
                                </IconButton>
                              </Box>
                            </TableCell>
                          )}
                          <TableCell data-column="matchedTotal" align="center" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 90 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                              Matched
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'matchedTotal')} sx={getMasterToolProjectIconButtonSx('matchedTotal')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('matchedTotal'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          {MASTER_TOOL_MATCHED_BR_BUCKETS.map((bucket) => {
                            if (!masterToolMatchedVisibleBrColumns[bucket]) return null;
                            const countColumn = MASTER_TOOL_MATCHED_COUNT_COLUMN_BY_BUCKET[bucket];
                            const fromColumn = MASTER_TOOL_MATCHED_FROM_COLUMN_BY_BUCKET[bucket];
                            const headerLabel = bucket === 'ph' ? 'PH' : `${bucket.replace('br', '')}BR`;
                            return (
                              <Fragment key={bucket}>
                                <TableCell data-column={countColumn} align="center" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 70 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                    {headerLabel}
                                    <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, countColumn)} sx={getMasterToolProjectIconButtonSx(countColumn)}>
                                      {renderSortIndicatorIcon(getMasterToolProjectSortDirection(countColumn))}
                                    </IconButton>
                                  </Box>
                                </TableCell>
                                {isMasterToolProjectColumnVisible(fromColumn) && (
                                  <TableCell data-column={fromColumn} align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 90 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                                      {getMasterToolProjectColumnLabel(fromColumn)}
                                      <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, fromColumn)} sx={getMasterToolProjectIconButtonSx(fromColumn)}>
                                        {renderSortIndicatorIcon(getMasterToolProjectSortDirection(fromColumn))}
                                      </IconButton>
                                    </Box>
                                  </TableCell>
                                )}
                              </Fragment>
                            );
                          })}
                          <TableCell data-column="developer" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('developer')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'developer')} sx={getMasterToolProjectIconButtonSx('developer')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('developer'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="totalUnits" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 100 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('totalUnits')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'totalUnits')} sx={getMasterToolProjectIconButtonSx('totalUnits')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('totalUnits'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="soldUnits" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 100 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('soldUnits')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'soldUnits')} sx={getMasterToolProjectIconButtonSx('soldUnits')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('soldUnits'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="districtLocation" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 180 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('districtLocation')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'districtLocation')} sx={getMasterToolProjectIconButtonSx('districtLocation')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('districtLocation'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="district" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('district')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'district')} sx={getMasterToolProjectIconButtonSx('district')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('district'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="region" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('region')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'region')} sx={getMasterToolProjectIconButtonSx('region')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('region'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="nearestMrt" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 140 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('nearestMrt')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'nearestMrt')} sx={getMasterToolProjectIconButtonSx('nearestMrt')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('nearestMrt'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="walkingTimeToMrt" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('walkingTimeToMrt')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'walkingTimeToMrt')} sx={getMasterToolProjectIconButtonSx('walkingTimeToMrt')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('walkingTimeToMrt'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="tenure" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('tenure')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'tenure')} sx={getMasterToolProjectIconButtonSx('tenure')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('tenure'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="topDate" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('topDate')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'topDate')} sx={getMasterToolProjectIconButtonSx('topDate')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('topDate'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell data-column="completedDate" sx={{ fontWeight: 600, minWidth: 120 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {getMasterToolProjectColumnLabel('completedDate')}
                              <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, 'completedDate')} sx={getMasterToolProjectIconButtonSx('completedDate')}>
                                {renderSortIndicatorIcon(getMasterToolProjectSortDirection('completedDate'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                          {[1, 2, 3, 4, 5, 'PH'].map((br) => (
                            <Fragment key={br}>
                              <TableCell data-column={br === 'PH' ? 'phavail' : `br${br}avail`} align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 90 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                                  {br === 'PH' ? 'PH Avail' : `${br}BR Avail`}
                                  <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, br === 'PH' ? 'phavail' : `br${br}avail` as MasterToolProjectFilterSortColumnKey)} sx={getMasterToolProjectIconButtonSx(br === 'PH' ? 'phavail' : `br${br}avail` as MasterToolProjectFilterSortColumnKey)}>
                                    {renderSortIndicatorIcon(getMasterToolProjectSortDirection(br === 'PH' ? 'phavail' : `br${br}avail` as MasterToolProjectFilterSortColumnKey))}
                                  </IconButton>
                                </Box>
                              </TableCell>
                              <TableCell data-column={br === 'PH' ? 'phprice' : `br${br}price`} align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 100 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                                  {br === 'PH' ? 'PH Price' : `${br}BR Price`}
                                  <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, br === 'PH' ? 'phprice' : `br${br}price` as MasterToolProjectFilterSortColumnKey)} sx={getMasterToolProjectIconButtonSx(br === 'PH' ? 'phprice' : `br${br}price` as MasterToolProjectFilterSortColumnKey)}>
                                    {renderSortIndicatorIcon(getMasterToolProjectSortDirection(br === 'PH' ? 'phprice' : `br${br}price` as MasterToolProjectFilterSortColumnKey))}
                                  </IconButton>
                                </Box>
                              </TableCell>
                              <TableCell data-column={br === 'PH' ? 'phpsf' : `br${br}psf`} align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 90 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                                  {br === 'PH' ? 'PH Psf' : `${br}BR Psf`}
                                  <IconButton size="small" onClick={(e) => handleMasterToolProjectOpenPopover(e, br === 'PH' ? 'phpsf' : `br${br}psf` as MasterToolProjectFilterSortColumnKey)} sx={getMasterToolProjectIconButtonSx(br === 'PH' ? 'phpsf' : `br${br}psf` as MasterToolProjectFilterSortColumnKey)}>
                                    {renderSortIndicatorIcon(getMasterToolProjectSortDirection(br === 'PH' ? 'phpsf' : `br${br}psf` as MasterToolProjectFilterSortColumnKey))}
                                  </IconButton>
                                </Box>
                              </TableCell>
                            </Fragment>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {masterToolProjectRowsForDisplay.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={MASTER_TOOL_PROJECT_VIEW_COLUMN_KEYS.length + 2 + masterToolProjectMatchedTableColumnCount + (hasMasterToolReferenceLocation ? 0 : -1)} align="center" sx={{ py: 4 }}>
                              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                No projects match the current filters.
                              </Typography>
                            </TableCell>
                          </TableRow>
                        ) : (
                          pagedMasterToolProjectRows.map((project) => {
                            const brKeys = ['br1', 'br2', 'br3', 'br4', 'br5', 'ph'] as const;
                            const projectNameTrim = (project.name ?? '').trim();
                            const matched = masterToolMatchedCountByProject.get(projectNameTrim) ?? { total: 0, br1: 0, br2: 0, br3: 0, br4: 0, br5: 0, ph: 0 };
                            const isThisProjectExpanded = masterToolProjectExpand?.projectName === projectNameTrim;
                            const projectSelectionKey = getMasterToolProjectSelectionKey(project);
                            const isProjectSelected = projectSelectionKey !== '' && selectedMasterToolProjectKeys.has(projectSelectionKey);
                            const masterToolProjectTableColSpan = MASTER_TOOL_PROJECT_VIEW_COLUMN_KEYS.length + 2 + masterToolProjectMatchedTableColumnCount + (hasMasterToolReferenceLocation ? 0 : -1);
                            const renderMatchedExpandCell = (
                              bucket: MasterToolProjectExpandBucket,
                              count: number | undefined,
                              dataColumn: string,
                            ) => {
                              const n = Number(count) || 0;
                              const isExpanded =
                                masterToolProjectExpand?.projectName === projectNameTrim &&
                                masterToolProjectExpand?.bucket === bucket;
                              if (n <= 0) {
                                return <TableCell data-column={dataColumn} align="center">-</TableCell>;
                              }
                              return (
                                <TableCell data-column={dataColumn} align="center">
                                  <Box
                                    component="button"
                                    type="button"
                                    onClick={(e) => handleMasterToolProjectExpandClick(e, projectNameTrim, bucket, n)}
                                    sx={{
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      gap: 0.25,
                                      justifyContent: 'center',
                                      m: 0,
                                      p: 0,
                                      minWidth: 0,
                                      border: 'none',
                                      background: 'transparent',
                                      cursor: 'pointer',
                                      color: 'var(--color-accent)',
                                      fontWeight: 600,
                                      font: 'inherit',
                                      textDecoration: 'underline dotted rgba(255, 152, 0, 0.55)',
                                      textUnderlineOffset: 3,
                                      '&:hover': { opacity: 0.92 },
                                    }}
                                  >
                                    {n}
                                    {isExpanded ? (
                                      <KeyboardArrowUpIcon sx={{ fontSize: '1rem' }} />
                                    ) : (
                                      <KeyboardArrowDownIcon sx={{ fontSize: '1rem' }} />
                                    )}
                                  </Box>
                                </TableCell>
                              );
                            };
                            return (
                              <Fragment key={project.id || project.name}>
                                <TableRow hover>
                                  <TableCell padding="checkbox" sx={{ position: 'sticky', left: 0, zIndex: 2, minWidth: 48, width: 48, borderRight: '1px solid rgba(var(--color-text-rgb), 0.1)', bgcolor: 'var(--color-surface)' }}>
                                    <Checkbox
                                      size="small"
                                      checked={isProjectSelected}
                                      onChange={() => handleToggleMasterToolProjectSelection(project)}
                                      inputProps={{ 'aria-label': `Select ${project.name ?? 'project'} for PDF export` }}
                                      sx={{ color: 'var(--color-accent)', '&.Mui-checked': { color: 'var(--color-accent)' } }}
                                    />
                                  </TableCell>
                                  <TableCell data-column="projectName" sx={{ fontWeight: 500, color: 'var(--color-text-strong)', position: 'sticky', left: 48, zIndex: 1, minWidth: 200, width: 200, borderRight: '1px solid rgba(var(--color-text-rgb), 0.1)', bgcolor: 'var(--color-surface)' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                      <Typography variant="body2" sx={{ color: 'var(--color-text-strong)' }}>
                                        {project.name}
                                      </Typography>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <IconButton
                                          size="small"
                                          onClick={() => project.name && handleOpenTowerView({ projectName: project.name, unitNumber: '', blockNumber: null, bedroom: 0, bathroom: 0, areaSqft: 0, price: 0, psf: 0, outlay: 0, installment: 0 } as ComparableUnit)}
                                          sx={getIconButtonSx()}
                                          title="View Tower View"
                                        >
                                          <ViewModuleIcon fontSize="small" />
                                        </IconButton>
                                      </Box>
                                    </Box>
                                  </TableCell>
                                  <TableCell data-column="projectCategory">{project.projectCategory ?? '-'}</TableCell>
                                  {hasMasterToolReferenceLocation && (
                                    <TableCell data-column="referenceDistanceKm" align="right">
                                      {project.distanceFromReferenceKm != null ? `${Number(project.distanceFromReferenceKm).toFixed(2)} km` : '-'}
                                    </TableCell>
                                  )}
                                  {renderMatchedExpandCell('total', matched.total, 'matchedTotal')}
                                  {MASTER_TOOL_MATCHED_BR_BUCKETS.map((bucket) => {
                                    if (!masterToolMatchedVisibleBrColumns[bucket]) return null;
                                    const countColumn = MASTER_TOOL_MATCHED_COUNT_COLUMN_BY_BUCKET[bucket];
                                    const fromColumn = MASTER_TOOL_MATCHED_FROM_COLUMN_BY_BUCKET[bucket];
                                    const lowestPrice = project.matchedLowestPriceByBedroom?.[bucket] ?? null;
                                    return (
                                      <Fragment key={bucket}>
                                        {renderMatchedExpandCell(bucket, matched[bucket], countColumn)}
                                        {isMasterToolProjectColumnVisible(fromColumn) && (
                                          <TableCell data-column={fromColumn} align="right">
                                            {formatMasterToolMatchedFromPrice(lowestPrice)}
                                          </TableCell>
                                        )}
                                      </Fragment>
                                    );
                                  })}
                                  <TableCell data-column="developer">{project.developer ?? '-'}</TableCell>
                                  <TableCell data-column="totalUnits" align="right">{project.totalUnits ?? '-'}</TableCell>
                                  <TableCell data-column="soldUnits" align="right">{project.soldUnits ?? '-'}</TableCell>
                                  <TableCell data-column="districtLocation">{project.districtLocation || (project.area || project.district ? [project.area, project.district].filter(Boolean).join(' / ') : '') || '-'}</TableCell>
                                  <TableCell data-column="district">{project.district ?? '-'}</TableCell>
                                  <TableCell data-column="region">{project.area ?? '-'}</TableCell>
                                  <TableCell data-column="nearestMrt">{project.nearestMrt ?? '-'}</TableCell>
                                  <TableCell data-column="walkingTimeToMrt" align="right">{project.walkingTimeToMrt != null ? `${project.walkingTimeToMrt} min` : '-'}</TableCell>
                                  <TableCell data-column="tenure">{project.tenure ?? '-'}</TableCell>
                                  <TableCell data-column="topDate" align="right">{project.topDate ?? '-'}</TableCell>
                                  <TableCell data-column="completedDate">{project.completedDate ? new Date(project.completedDate).toLocaleDateString('en-SG', { year: 'numeric', month: 'short' }) : '-'}</TableCell>
                                  {brKeys.map((brKey) => {
                                    const stats = project[brKey];
                                    return (
                                      <Fragment key={brKey}>
                                        <TableCell data-column={`${brKey}avail`} align="right">{stats?.availableUnits ?? '-'}</TableCell>
                                        <TableCell data-column={`${brKey}price`} align="right">{stats?.fromPrice != null ? `$${Number(stats.fromPrice).toLocaleString()}` : '-'}</TableCell>
                                        <TableCell data-column={`${brKey}psf`} align="right">{stats?.fromPsf != null ? `$${Number(stats.fromPsf).toLocaleString()}` : '-'}</TableCell>
                                      </Fragment>
                                    );
                                  })}
                                </TableRow>
                                {isThisProjectExpanded && (
                                  <TableRow>
                                    <TableCell
                                      colSpan={masterToolProjectTableColSpan}
                                      sx={{
                                        p: 0,
                                        borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)',
                                        bgcolor: 'rgba(var(--color-text-rgb), 0.03)',
                                      }}
                                    >
                                      <Collapse in timeout="auto" unmountOnExit>
                                        <Box sx={{ p: 2 }}>
                                          <Typography variant="caption" sx={{ display: 'block', mb: 1, color: 'rgba(var(--color-text-rgb), 0.65)', fontWeight: 600 }}>
                                            {masterToolProjectExpand?.bucket === 'total'
                                              ? 'Matched units (all)'
                                              : masterToolProjectExpand?.bucket === 'ph'
                                              ? 'Matched units (PH)'
                                              : `Matched units (${masterToolProjectExpand?.bucket.replace('br', '')}BR)`}
                                          </Typography>
                                          {masterToolProjectExpandLoading && (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                                              <CircularProgress size={28} />
                                            </Box>
                                          )}
                                          {masterToolProjectExpandError && (
                                            <Alert severity="error" sx={{ mb: 1 }}>
                                              {masterToolProjectExpandError}
                                            </Alert>
                                          )}
                                          {!masterToolProjectExpandLoading && !masterToolProjectExpandError && masterToolProjectExpandFilteredUnits.length === 0 && (
                                            <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                              No units in this group.
                                            </Typography>
                                          )}
                                          {!masterToolProjectExpandLoading && !masterToolProjectExpandError && masterToolProjectExpandFilteredUnits.length > 0 && (
                                            <Table size="small" sx={{ minWidth: 960, ...masterToolUnitTableVisibilitySx }}>
                                              <TableHead>
                                                <TableRow>
                                                  {masterToolUnitColumnsForMenu.filter((column) => isMasterToolUnitColumnVisible(column)).map((column) => (
                                                    <TableCell key={column} sx={{ fontWeight: 600, bgcolor: 'rgba(var(--color-text-rgb), 0.06)' }}>
                                                      {getMasterToolUnitColumnLabel(column)}
                                                    </TableCell>
                                                  ))}
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {masterToolProjectExpandFilteredUnits.map((unit) => (
                                                  <TableRow
                                                    key={`master-expand-${projectNameTrim}-${unit.id}`}
                                                    hover
                                                    onClick={(e) => {
                                                      if ((e.target as HTMLElement).closest('button')) return;
                                                      setMasterToolUnitRowMenuAnchor({
                                                        unit,
                                                        position: {
                                                          top: e.clientY,
                                                          left: e.clientX,
                                                        },
                                                      });
                                                    }}
                                                    sx={{ cursor: 'pointer' }}
                                                  >
                                                    {renderMasterToolExpandUnitRowCells(unit)}
                                                  </TableRow>
                                                ))}
                                              </TableBody>
                                            </Table>
                                          )}
                                        </Box>
                                      </Collapse>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </Fragment>
                            );
                          })
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {masterToolProjectRowsForDisplay.length > 0 && (
                    <TablePagination
                      component="div"
                      count={masterToolProjectRowsForDisplay.length}
                      page={Math.max(0, masterToolProjectPage - 1)}
                      onPageChange={(_, page) => setMasterToolProjectPage(page + 1)}
                      rowsPerPage={masterToolPageSize}
                      rowsPerPageOptions={[masterToolPageSize]}
                      labelRowsPerPage="Projects per page"
                    />
                  )}
                  <Popover
                    open={Boolean(masterToolPopoverAnchor)}
                    anchorEl={masterToolPopoverAnchor?.element}
                    onClose={handleMasterToolProjectClosePopover}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  >
                    {masterToolPopoverAnchor && (() => {
                      const column = masterToolPopoverAnchor.column as MasterToolProjectFilterSortColumnKey;
                      const categoryColumns: MasterToolProjectCategoryFilterKey[] = ['projectName', 'projectCategory', 'district', 'region', 'nearestMrt', 'tenure'];
                      const isCategoryColumn = categoryColumns.includes(column as MasterToolProjectCategoryFilterKey);
                      const isNumericColumn = MASTER_TOOL_PROJECT_VIEW_NUMERIC_COLUMNS.has(column);
                      const shouldFormatThousands = /(price|psf)$/i.test(column);
                      return (
                        <Box sx={{ p: 2, minWidth: 280 }}>
                          <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 1, color: 'var(--color-info)', fontWeight: 500 }}>
                              Sort
                            </Typography>
                            <ToggleButtonGroup
                              value={getMasterToolProjectSortDirection(column)}
                              exclusive
	                              onChange={(_, value) => {
	                                if (value !== null) {
	                                  logProjectResearchSortChanged({
	                                    viewMode: 'project',
	                                    column,
	                                    direction: value,
	                                    ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                  });
	                                  setMasterToolProjectSortConfig({ column, direction: value });
	                                }
	                              }}
                              fullWidth
                              sx={{
                                '& .MuiToggleButtonGroup-grouped': {
                                  border: '1px solid rgba(var(--color-shadow-rgb), 0.12)',
                                  '&:not(:first-of-type)': {
                                    borderLeft: '1px solid rgba(var(--color-shadow-rgb), 0.12)',
                                    marginLeft: 0,
                                  },
                                  '&.Mui-selected': {
                                    backgroundColor: 'var(--color-info)',
                                    color: 'var(--color-text-strong)',
                                  },
                                },
                              }}
                            >
                              <ToggleButton value="default" sx={{ flex: 1, py: 0.75 }}>Default</ToggleButton>
                              <ToggleButton value="asc" sx={{ flex: 1, py: 0.75 }}>Asc</ToggleButton>
                              <ToggleButton value="desc" sx={{ flex: 1, py: 0.75 }}>Desc</ToggleButton>
                            </ToggleButtonGroup>
                          </Box>

                          <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                              <Typography variant="body2" sx={{ color: 'var(--color-info)', fontWeight: 500, mr: 1 }}>
                                Filter
                              </Typography>
                              <FilterIcon sx={{ fontSize: 18, color: 'var(--color-info)' }} />
                            </Box>
                            {isCategoryColumn ? (
                              <Box>
                                {(() => {
                                  const key = column as MasterToolProjectCategoryFilterKey;
                                  const options = masterToolProjectCategoryOptions[key] ?? [];
                                  const selected = masterToolProjectCategoryFilters[key] ?? [];
                                  return (
                                    <Autocomplete
                                      multiple
                                      fullWidth
                                      size="small"
                                      disableCloseOnSelect
                                      options={options.length > 0 ? ['__SELECT_ALL__', ...options] : options}
                                      value={selected}
                                      filterOptions={(opts, state) => {
                                        const defaultFilterOptions = createFilterOptions<string>();
                                        const filtered = defaultFilterOptions(
                                          opts.filter((option) => option !== '__SELECT_ALL__'),
                                          state
                                        );
                                        return options.length > 0 ? ['__SELECT_ALL__', ...filtered] : filtered;
                                      }}
                                      onChange={(_, value) => {
                                        const hasSelectAll = value.includes('__SELECT_ALL__');
	                                        if (hasSelectAll) {
	                                          const next = selected.length === options.length ? [] : [...options];
	                                          logProjectResearchFilterChanged({
	                                            viewMode: 'project',
	                                            column: key,
	                                            filterType: 'category',
	                                            value: next,
	                                            ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                          });
	                                          setMasterToolProjectCategoryFilters((prev) => ({ ...prev, [key]: next }));
	                                          return;
	                                        }
	                                        logProjectResearchFilterChanged({
	                                          viewMode: 'project',
	                                          column: key,
	                                          filterType: 'category',
	                                          value,
	                                          ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                        });
	                                        setMasterToolProjectCategoryFilters((prev) => ({ ...prev, [key]: value }));
	                                      }}
                                      renderOption={(props, option) => {
                                        if (option === '__SELECT_ALL__') {
                                          const allSelected = selected.length === options.length && options.length > 0;
                                          const indeterminate = selected.length > 0 && selected.length < options.length;
                                          return (
                                            <li {...props}>
                                              <Checkbox checked={allSelected} indeterminate={indeterminate} sx={{ color: 'var(--color-accent)', '&.Mui-checked': { color: 'var(--color-accent)' } }} />
                                              <Typography component="span" sx={{ fontWeight: 600 }}>
                                                Select All
                                              </Typography>
                                            </li>
                                          );
                                        }
                                        const optionLabel =
                                          key === 'district' ? getDistrictFilterOptionLabel(option) : (option || '(empty)');
                                        return (
                                          <li {...props}>
                                            <Checkbox checked={selected.includes(option)} sx={{ color: 'var(--color-accent)', '&.Mui-checked': { color: 'var(--color-accent)' } }} />
                                            {optionLabel}
                                          </li>
                                        );
                                      }}
                                      renderTags={(value, getTagProps) => {
                                        const summary =
                                          value.length === 0 || value.length === options.length
                                            ? 'All'
                                            : `${value.length} selected`;
                                        return <Chip label={summary} size="small" {...getTagProps({ index: 0 })} />;
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={`Select ${getMasterToolProjectColumnLabel(column)}`}
                                          placeholder="Search..."
                                        />
                                      )}
                                    />
                                  );
                                })()}
                                <Button
                                  size="small"
                                  sx={{ mt: 1 }}
	                                  onClick={() => {
	                                    const key = column as MasterToolProjectCategoryFilterKey;
	                                    logProjectResearchFilterChanged({
	                                      viewMode: 'project',
	                                      column: key,
	                                      filterType: 'category',
	                                      value: [],
	                                      ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                    });
	                                    setMasterToolProjectCategoryFilters((prev) => ({ ...prev, [key]: [] }));
	                                  }}
                                  fullWidth
                                  disabled={!hasMasterToolProjectActiveFilter(column)}
                                >
                                  Clear Filter
                                </Button>
                              </Box>
                            ) : isNumericColumn ? (
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  type={shouldFormatThousands ? 'text' : 'number'}
                                  inputProps={shouldFormatThousands ? { inputMode: 'decimal' } : undefined}
                                  label="Min"
                                  value={shouldFormatThousands ? formatThousandsInput(masterToolProjectViewRangeFilters[column]?.min ?? '') : (masterToolProjectViewRangeFilters[column]?.min ?? '')}
                                  onChange={(e) => {
	                                    const nextValue = shouldFormatThousands
	                                      ? e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '')
	                                      : e.target.value;
	                                    logProjectResearchFilterChanged({
	                                      viewMode: 'project',
	                                      column,
	                                      filterType: 'range',
	                                      bound: 'min',
	                                      value: nextValue,
	                                      ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                    });
	                                    setMasterToolProjectViewRangeFilters((prev) => ({
	                                      ...prev,
	                                      [column]: { ...(prev[column] ?? { min: '', max: '' }), min: nextValue },
                                    }));
                                  }}
                                />
                                <TextField
                                  fullWidth
                                  size="small"
                                  type={shouldFormatThousands ? 'text' : 'number'}
                                  inputProps={shouldFormatThousands ? { inputMode: 'decimal' } : undefined}
                                  label="Max"
                                  value={shouldFormatThousands ? formatThousandsInput(masterToolProjectViewRangeFilters[column]?.max ?? '') : (masterToolProjectViewRangeFilters[column]?.max ?? '')}
                                  onChange={(e) => {
	                                    const nextValue = shouldFormatThousands
	                                      ? e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '')
	                                      : e.target.value;
	                                    logProjectResearchFilterChanged({
	                                      viewMode: 'project',
	                                      column,
	                                      filterType: 'range',
	                                      bound: 'max',
	                                      value: nextValue,
	                                      ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                    });
	                                    setMasterToolProjectViewRangeFilters((prev) => ({
	                                      ...prev,
	                                      [column]: { ...(prev[column] ?? { min: '', max: '' }), max: nextValue },
                                    }));
                                  }}
                                />
	                                <Button
	                                  size="small"
	                                  onClick={() => {
	                                    logProjectResearchFilterChanged({
	                                      viewMode: 'project',
	                                      column,
	                                      filterType: 'range',
	                                      value: '',
	                                      ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                    });
	                                    setMasterToolProjectViewRangeFilters((prev) => ({
	                                      ...prev,
	                                      [column]: { min: '', max: '' },
                                    }));
                                  }}
                                  fullWidth
                                  disabled={!hasMasterToolProjectActiveFilter(column)}
                                >
                                  Clear Filter
                                </Button>
                              </Box>
                            ) : (
                              <Box>
                                <TextField
                                  fullWidth
                                  size="small"
                                  placeholder={`Filter ${getMasterToolProjectColumnLabel(column)}`}
	                                  value={masterToolProjectViewFilters[column] ?? ''}
	                                  onChange={(e) => {
	                                    const value = e.target.value;
	                                    logProjectResearchFilterChanged({
	                                      viewMode: 'project',
	                                      column,
	                                      filterType: 'text',
	                                      value,
	                                      ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                    });
	                                    setMasterToolProjectViewFilters((prev) => ({ ...prev, [column]: value }));
	                                  }}
                                  InputProps={{
                                    endAdornment: hasMasterToolProjectActiveFilter(column) ? (
                                      <InputAdornment position="end">
	                                        <IconButton
	                                          size="small"
	                                          onClick={() => {
	                                            logProjectResearchFilterChanged({
	                                              viewMode: 'project',
	                                              column,
	                                              filterType: 'text',
	                                              value: '',
	                                              ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                            });
	                                            setMasterToolProjectViewFilters((prev) => ({ ...prev, [column]: '' }));
	                                          }}
	                                          sx={{ p: 0.5 }}
	                                        >
                                          <Typography variant="caption" sx={{ fontSize: 12 }}>✕</Typography>
                                        </IconButton>
                                      </InputAdornment>
                                    ) : undefined,
                                  }}
                                />
	                                <Button
	                                  size="small"
	                                  onClick={() => {
	                                    logProjectResearchFilterChanged({
	                                      viewMode: 'project',
	                                      column,
	                                      filterType: 'text',
	                                      value: '',
	                                      ceaNumber: userInfo?.CEANumber || getDevCea(),
	                                    });
	                                    setMasterToolProjectViewFilters((prev) => ({ ...prev, [column]: '' }));
	                                  }}
                                  sx={{ mt: 1 }}
                                  fullWidth
                                  disabled={!hasMasterToolProjectActiveFilter(column)}
                                >
                                  Clear Filter
                                </Button>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      );
                    })()}
                  </Popover>
                </Box>
              )}

              <Menu
                anchorReference="anchorPosition"
                anchorPosition={masterToolUnitRowMenuAnchor?.position}
                open={Boolean(masterToolUnitRowMenuAnchor)}
                onClose={() => setMasterToolUnitRowMenuAnchor(null)}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{ '& .MuiPaper-root': { bgcolor: 'var(--color-surface)', border: '1px solid rgba(var(--color-text-rgb), 0.12)' } }}
              >
                {masterToolUnitRowMenuAnchor && (
                  <>
                    <MenuItem disabled sx={{ opacity: 1 }}>
                      <ListItemText
                        primary={`Unit ${masterToolUnitRowMenuAnchor.unit.unitNumber}`}
                        secondary={masterToolUnitRowMenuAnchor.unit.projectName}
                        primaryTypographyProps={{ sx: { fontWeight: 700, color: 'var(--color-text-strong)' } }}
                        secondaryTypographyProps={{ sx: { color: 'var(--color-text-muted)' } }}
                      />
                    </MenuItem>
                    <Divider />
                    <MenuItem
                      onClick={() => {
                        if (!masterToolUnitRowMenuAnchor) return;
                        const u = { ...masterToolUnitRowMenuAnchor.unit, priceDiff: 0, priceDiffPercent: 0, psfDiff: 0, psfDiffPercent: 0, outlay: masterToolUnitRowMenuAnchor.unit.outlay, outlayDiff: 0, installment: masterToolUnitRowMenuAnchor.unit.installment, installmentDiff: 0 } as ComparableUnit;
                        handleOpenFloorPlan(u);
                        setMasterToolUnitRowMenuAnchor(null);
                      }}
                      disabled={!masterToolUnitRowMenuAnchor.unit.floorplan}
                    >
                      <ListItemIcon>
                        <ImageIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>View Floor Plan</ListItemText>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        if (!masterToolUnitRowMenuAnchor) return;
                        const u = { ...masterToolUnitRowMenuAnchor.unit, priceDiff: 0, priceDiffPercent: 0, psfDiff: 0, psfDiffPercent: 0, outlay: masterToolUnitRowMenuAnchor.unit.outlay, outlayDiff: 0, installment: masterToolUnitRowMenuAnchor.unit.installment, installmentDiff: 0 } as ComparableUnit;
                        handleAddToFloorPlanCompare(u);
                        setMasterToolUnitRowMenuAnchor(null);
                      }}
                      disabled={
                        !masterToolUnitRowMenuAnchor.unit.floorplan ||
                        (floorPlansToCompare.length >= 3 && !floorPlansToCompare.some((fp) => fp.unit.id === masterToolUnitRowMenuAnchor.unit.id))
                      }
                    >
                      <ListItemIcon>
                        <ShoppingCartIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>
                        {masterToolUnitRowMenuAnchor && floorPlansToCompare.some((fp) => fp.unit.id === masterToolUnitRowMenuAnchor.unit.id)
                          ? 'Remove from Compare'
                          : `Add to Compare (${floorPlansToCompare.length}/3)`}
                      </ListItemText>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        if (!masterToolUnitRowMenuAnchor) return;
                        handleShortlistAction({
                          unitId: masterToolUnitRowMenuAnchor.unit.id,
                          label: `${masterToolUnitRowMenuAnchor.unit.projectName} ${masterToolUnitRowMenuAnchor.unit.unitNumber}`,
                          floorplan: masterToolUnitRowMenuAnchor.unit.floorplan || null,
                        });
                        setMasterToolUnitRowMenuAnchor(null);
                      }}
                      disabled={shortlistUpdatingUnitId === masterToolUnitRowMenuAnchor.unit.id}
                    >
                      <ListItemIcon>
                        {shortlistByUnitId.has(masterToolUnitRowMenuAnchor.unit.id) ? (
                          <StarIcon fontSize="small" />
                        ) : (
                          <StarBorderIcon fontSize="small" />
                        )}
                      </ListItemIcon>
                      <ListItemText>
                        {shortlistByUnitId.has(masterToolUnitRowMenuAnchor.unit.id)
                          ? 'Remove from Shortlist'
                          : 'Add to Shortlist'}
                      </ListItemText>
                    </MenuItem>
                  </>
                )}
              </Menu>

              {/* Master Tool Unit View Table */}
              {masterToolViewMode === 'unit' && masterToolTotalMatchedUnits > 0 && (
                <Box>
                  <TableContainer sx={{ maxHeight: 600, overflow: 'auto' }}>
                    <Table stickyHeader size="small" sx={{
                      '& .MuiTableCell-root': { py: 0.75, px: 1, fontSize: '0.8rem', borderColor: 'rgba(var(--color-text-rgb), 0.08)', color: 'var(--color-text-strong)' },
                      '& .MuiTableHead-root .MuiTableCell-root': { bgcolor: 'var(--color-surface-thead)', fontWeight: 600 },
                      ...masterToolUnitTableVisibilitySx,
                    }}>
                      <TableHead>
                        <TableRow>
                        <TableCell data-column="projectName" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', position: 'sticky', left: 0, zIndex: 2, minWidth: 200, width: 200, bgcolor: 'var(--color-surface-thead)', borderRight: '1px solid rgba(var(--color-text-rgb), 0.1)' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('projectName')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'projectName')} sx={getMasterToolUnitIconButtonSx('projectName')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('projectName'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="projectCategory" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 140 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('projectCategory')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'projectCategory')} sx={getMasterToolUnitIconButtonSx('projectCategory')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('projectCategory'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="unitNumber" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 110 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('unitNumber')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'unitNumber')} sx={getMasterToolUnitIconButtonSx('unitNumber')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('unitNumber'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="blockNumber" align="center" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 90 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('blockNumber')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'blockNumber')} sx={getMasterToolUnitIconButtonSx('blockNumber')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('blockNumber'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="floor" align="center" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 70 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('floor')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'floor')} sx={getMasterToolUnitIconButtonSx('floor')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('floor'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="stack" align="center" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 70 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('stack')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'stack')} sx={getMasterToolUnitIconButtonSx('stack')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('stack'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="bedroom" align="center" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 60 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('bedroom')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'bedroom')} sx={getMasterToolUnitIconButtonSx('bedroom')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('bedroom'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="bathroom" align="center" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 60 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('bathroom')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'bathroom')} sx={getMasterToolUnitIconButtonSx('bathroom')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('bathroom'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="areaSqft" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 90 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('areaSqft')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'areaSqft')} sx={getMasterToolUnitIconButtonSx('areaSqft')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('areaSqft'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="price" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('price')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'price')} sx={getMasterToolUnitIconButtonSx('price')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('price'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        {hasMasterToolExecutiveCondo && (
                          <TableCell data-column="dps" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                              {getMasterToolUnitColumnLabel('dps')}
                              <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'dps')} sx={getMasterToolUnitIconButtonSx('dps')}>
                                {renderSortIndicatorIcon(getMasterToolUnitSortDirection('dps'))}
                              </IconButton>
                            </Box>
                          </TableCell>
                        )}
                        <TableCell data-column="psf" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 90 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('psf')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'psf')} sx={getMasterToolUnitIconButtonSx('psf')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('psf'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="outlay" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('outlay')}
                            <Tooltip title="How outlay is calculated">
                              <IconButton
                                size="small"
                                onClick={(e) => setOutlayInfoAnchor(e.currentTarget)}
                                sx={{
                                  ...getIconButtonSx(),
                                  color: 'var(--color-info)',
                                  '&:hover': { bgcolor: 'rgba(var(--color-info-rgb), 0.1)' },
                                }}
                              >
                                <HelpOutlineIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'outlay')} sx={getMasterToolUnitIconButtonSx('outlay')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('outlay'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="installment" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('installment')}
                            <Tooltip title="How installment is calculated">
                              <IconButton
                                size="small"
                                onClick={(e) => setInstallmentInfoAnchor(e.currentTarget)}
                                sx={{
                                  ...getIconButtonSx(),
                                  color: 'var(--color-info)',
                                  '&:hover': { bgcolor: 'rgba(var(--color-info-rgb), 0.1)' },
                                }}
                              >
                                <HelpOutlineIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'installment')} sx={getMasterToolUnitIconButtonSx('installment')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('installment'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="district" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('district')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'district')} sx={getMasterToolUnitIconButtonSx('district')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('district'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="districtLocation" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 180 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('districtLocation')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'districtLocation')} sx={getMasterToolUnitIconButtonSx('districtLocation')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('districtLocation'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="region" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('region')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'region')} sx={getMasterToolUnitIconButtonSx('region')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('region'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="nearestMrt" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 170 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('nearestMrt')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'nearestMrt')} sx={getMasterToolUnitIconButtonSx('nearestMrt')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('nearestMrt'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="walkingTimeToMrt" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 110 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('walkingTimeToMrt')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'walkingTimeToMrt')} sx={getMasterToolUnitIconButtonSx('walkingTimeToMrt')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('walkingTimeToMrt'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="tenure" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('tenure')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'tenure')} sx={getMasterToolUnitIconButtonSx('tenure')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('tenure'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell data-column="topYear" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 100 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                            {getMasterToolUnitColumnLabel('topYear')}
                            <IconButton size="small" onClick={(e) => handleMasterToolUnitOpenPopover(e, 'topYear')} sx={getMasterToolUnitIconButtonSx('topYear')}>
                              {renderSortIndicatorIcon(getMasterToolUnitSortDirection('topYear'))}
                            </IconButton>
                          </Box>
                        </TableCell>
                        
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredMasterToolUnits.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={hasMasterToolExecutiveCondo ? 21 : 20} align="center" sx={{ py: 4 }}>
                            <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                              No units match the current filters.
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        filteredMasterToolUnits.map((unit) => {
                          const projectDetails = getMasterToolUnitProjectDetails(unit);
                          const isExecutiveCondoUnit = projectDetails?.projectCategoryId === 'C1803'
                            || (projectDetails?.projectCategory ?? '').toLowerCase().includes('executive condo');
                          const mappedUnit = { ...unit, priceDiff: 0, priceDiffPercent: 0, psfDiff: 0, psfDiffPercent: 0, outlay: unit.outlay, outlayDiff: 0, installment: unit.installment, installmentDiff: 0 } as ComparableUnit;
                          return (
                            <TableRow
                              key={unit.id}
                              hover
                              onClick={(e) => {
                                if ((e.target as HTMLElement).closest('button')) return;
                                setMasterToolUnitRowMenuAnchor({
                                  unit,
                                  position: {
                                    top: e.clientY,
                                    left: e.clientX,
                                  },
                                });
                              }}
                              sx={{ cursor: 'pointer' }}
                            >
                            <TableCell data-column="projectName" sx={{ fontWeight: 500, color: 'var(--color-text-strong)', position: 'sticky', left: 0, zIndex: 1, minWidth: 200, width: 200, borderRight: '1px solid rgba(var(--color-text-rgb), 0.1)', bgcolor: 'var(--color-surface)' }}>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                  <Typography variant="body2" sx={{ color: 'var(--color-text-strong)' }}>
                                    {unit.projectName}
                                  </Typography>
                                  {referenceUnit && (referenceUnit.id === unit.id || (referenceUnit.projectName === unit.projectName && referenceUnit.unitNumber === unit.unitNumber)) && (
                                    <Tooltip title="Reference unit" arrow placement="top">
                                      <BookmarkIcon sx={{ fontSize: '0.9rem !important', color: '#1976d2', flexShrink: 0 }} />
                                    </Tooltip>
                                  )}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleOpenTowerView({ ...unit, priceDiff: 0, priceDiffPercent: 0, psfDiff: 0, psfDiffPercent: 0, outlay: unit.outlay, outlayDiff: 0, installment: unit.installment, installmentDiff: 0 } as ComparableUnit);
                                    }}
                                    sx={getIconButtonSx()}
                                    title="View Tower View"
                                  >
                                    <ViewModuleIcon fontSize="small" />
                                  </IconButton>
                                  {unit.floorplan && (
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleOpenFloorPlan(mappedUnit);
                                      }}
                                      sx={{ ...getIconButtonSx(), color: 'primary.main' }}
                                      title="View Floor Plan"
                                    >
                                      <ImageIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleShortlistAction({
                                        unitId: unit.id,
                                        label: `${unit.projectName} ${unit.unitNumber}`,
                                        floorplan: unit.floorplan || null,
                                      });
                                    }}
                                    disabled={shortlistUpdatingUnitId === unit.id}
                                    sx={{
                                      ...getIconButtonSx(),
                                      color: shortlistByUnitId.has(unit.id) ? 'var(--color-warning-strong)' : 'var(--color-text-strong)',
                                    }}
                                    title={shortlistByUnitId.has(unit.id) ? 'Remove from shortlist' : 'Add to shortlist'}
                                  >
                                    {shortlistByUnitId.has(unit.id) ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
                                  </IconButton>
                                </Box>
                              </Box>
                            </TableCell>
                            <TableCell data-column="projectCategory">{getMasterToolUnitProjectMeta(unit, 'projectCategory') || '-'}</TableCell>
                            <TableCell data-column="unitNumber">{unit.unitNumber}</TableCell>
                            <TableCell data-column="blockNumber" align="center">{formatBlockNumber(unit.blockNumber ?? null)}</TableCell>
                            <TableCell data-column="floor" align="center">{unit.computedFloor ?? '-'}</TableCell>
                            <TableCell data-column="stack" align="center">{unit.computedStack ?? '-'}</TableCell>
                            <TableCell data-column="bedroom" align="center">{unit.bedroom}</TableCell>
                            <TableCell data-column="bathroom" align="center">{unit.bathroom}</TableCell>
                            <TableCell data-column="areaSqft" align="right">{unit.areaSqft > 0 ? formatNumber(unit.areaSqft) : '-'}</TableCell>
                            <TableCell data-column="price" align="right">{unit.price > 0 ? formatCurrency(unit.price) : '-'}</TableCell>
                            {hasMasterToolExecutiveCondo && (
                              <TableCell data-column="dps" align="right">
                                {isExecutiveCondoUnit && unit.priceDps && unit.priceDps > 0 ? formatCurrency(unit.priceDps) : '-'}
                              </TableCell>
                            )}
                            <TableCell data-column="psf" align="right">{unit.psf > 0 ? formatCurrency(unit.psf) : '-'}</TableCell>
                            <TableCell data-column="outlay" align="right">
                              {unit.outlay > 0 ? (
                                <Tooltip
                                  title={getOutlayFormulaTooltip(unit.price, unit.outlay)}
                                  arrow
                                  placement="top"
                                  enterTouchDelay={0}
                                  leaveTouchDelay={3500}
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        bgcolor: 'rgba(60, 60, 60, 0.95)',
                                        maxWidth: 360,
                                        border: '1px solid rgba(255,255,255,0.12)',
                                        '& .MuiTypography-root': { color: '#fff' },
                                      },
                                    },
                                  }}
                                >
                                  <Typography component="span" variant="body2" sx={{ cursor: 'help', textDecoration: 'underline dotted rgba(var(--color-text-rgb), 0.45)', textUnderlineOffset: 3 }}>
                                    {formatCurrency(unit.outlay)}
                                  </Typography>
                                </Tooltip>
                              ) : '-'}
                            </TableCell>
                            <TableCell data-column="installment" align="right">
                              {unit.installment > 0 ? (
                                <Tooltip
                                  title={getInstallmentFormulaTooltip(unit.price, unit.installment)}
                                  arrow
                                  placement="top"
                                  enterTouchDelay={0}
                                  leaveTouchDelay={3500}
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        bgcolor: 'rgba(60, 60, 60, 0.95)',
                                        maxWidth: 360,
                                        border: '1px solid rgba(255,255,255,0.12)',
                                        '& .MuiTypography-root': { color: '#fff' },
                                      },
                                    },
                                  }}
                                >
                                  <Typography component="span" variant="body2" sx={{ cursor: 'help', textDecoration: 'underline dotted rgba(var(--color-text-rgb), 0.45)', textUnderlineOffset: 3 }}>
                                    {formatCurrency(unit.installment)}
                                  </Typography>
                                </Tooltip>
                              ) : '-'}
                            </TableCell>
                            <TableCell data-column="district">{getMasterToolUnitProjectMeta(unit, 'district') || '-'}</TableCell>
                            <TableCell data-column="districtLocation">{getMasterToolUnitProjectMeta(unit, 'districtLocation') || '-'}</TableCell>
                            <TableCell data-column="region">{getMasterToolUnitProjectMeta(unit, 'region') || '-'}</TableCell>
                            <TableCell data-column="nearestMrt">{getMasterToolUnitProjectMeta(unit, 'nearestMrt') || '-'}</TableCell>
                            <TableCell data-column="walkingTimeToMrt" align="right">
                              {getMasterToolUnitProjectMeta(unit, 'walkingTimeToMrt')
                                ? `${getMasterToolUnitProjectMeta(unit, 'walkingTimeToMrt')} min`
                                : '-'}
                            </TableCell>
                            <TableCell data-column="tenure">{getMasterToolUnitProjectMeta(unit, 'tenure') || '-'}</TableCell>
                            <TableCell data-column="topYear" align="right">{getMasterToolUnitProjectMeta(unit, 'topYear') || '-'}</TableCell>
                            </TableRow>
                          );
                        })
                      )}
                    </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    component="div"
                    count={masterToolTotalMatchedUnits}
                    page={Math.max(0, masterToolUnitPage - 1)}
                    onPageChange={(_, page) => setMasterToolUnitPage(page + 1)}
                    rowsPerPage={masterToolPageSize}
                    rowsPerPageOptions={[masterToolPageSize]}
                    labelRowsPerPage="Units per page"
                  />
                  <Popover
                    open={Boolean(masterToolUnitPopoverAnchor)}
                    anchorEl={masterToolUnitPopoverAnchor?.element}
                    onClose={handleMasterToolUnitClosePopover}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    {masterToolUnitPopoverAnchor && (
                      <Box sx={{ p: 2, minWidth: 280 }}>
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" sx={{ mb: 1, color: 'var(--color-info)', fontWeight: 500 }}>
                            Sort
                          </Typography>
                          <ToggleButtonGroup
                            value={getMasterToolUnitSortDirection(masterToolUnitPopoverAnchor.column)}
                            exclusive
                            onChange={(_, value) => {
                              if (value !== null) {
                                handleMasterToolUnitSortChange(masterToolUnitPopoverAnchor.column, value);
                              }
                            }}
                            fullWidth
                            sx={{
                              '& .MuiToggleButtonGroup-grouped': {
                                border: '1px solid rgba(var(--color-shadow-rgb), 0.12)',
                                '&:not(:first-of-type)': {
                                  borderLeft: '1px solid rgba(var(--color-shadow-rgb), 0.12)',
                                  marginLeft: 0,
                                },
                                '&.Mui-selected': {
                                  backgroundColor: 'var(--color-info)',
                                  color: 'var(--color-text-strong)',
                                  '&:hover': {
                                    backgroundColor: 'var(--color-info-strong)',
                                  },
                                },
                              },
                            }}
                          >
                            <ToggleButton value="default" sx={{ flex: 1, py: 0.75 }}>
                              Default
                            </ToggleButton>
                            <ToggleButton value="asc" sx={{ flex: 1, py: 0.75 }}>
                              Asc
                            </ToggleButton>
                            <ToggleButton value="desc" sx={{ flex: 1, py: 0.75 }}>
                              Desc
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </Box>

                        <Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="body2" sx={{ color: 'var(--color-info)', fontWeight: 500, mr: 1 }}>
                              Filter
                            </Typography>
                            <FilterIcon sx={{ fontSize: 18, color: 'var(--color-info)' }} />
                          </Box>
                          {(
                            masterToolUnitPopoverAnchor.column === 'floor' ||
                            masterToolUnitPopoverAnchor.column === 'stack' ||
                            masterToolUnitPopoverAnchor.column === 'bedroom' ||
                            masterToolUnitPopoverAnchor.column === 'bathroom' ||
                            masterToolUnitPopoverAnchor.column === 'areaSqft' ||
                            masterToolUnitPopoverAnchor.column === 'price' ||
                            masterToolUnitPopoverAnchor.column === 'dps' ||
                            masterToolUnitPopoverAnchor.column === 'psf' ||
                            masterToolUnitPopoverAnchor.column === 'outlay' ||
                            masterToolUnitPopoverAnchor.column === 'installment' ||
                            masterToolUnitPopoverAnchor.column === 'walkingTimeToMrt' ||
                            masterToolUnitPopoverAnchor.column === 'topYear'
                          ) ? (() => {
                            const rangeColumn = masterToolUnitPopoverAnchor.column as MasterToolUnitRangeKey;
                            const shouldFormatThousands = rangeColumn === 'price' || rangeColumn === 'dps' || rangeColumn === 'psf' || rangeColumn === 'outlay' || rangeColumn === 'installment';
                            return (
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  type={shouldFormatThousands ? 'text' : 'number'}
                                  inputProps={shouldFormatThousands ? { inputMode: 'decimal' } : undefined}
                                  label="Min"
                                  placeholder="Min"
                                  value={shouldFormatThousands ? formatThousandsInput(masterToolUnitRangeFilters[rangeColumn].min) : masterToolUnitRangeFilters[rangeColumn].min}
                                  onChange={(e) => handleMasterToolUnitRangeFilterChange(rangeColumn, 'min', shouldFormatThousands ? e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '') : e.target.value)}
                                  InputProps={{
                                    endAdornment: masterToolUnitRangeFilters[rangeColumn].min.trim() !== '' && (
                                      <InputAdornment position="end">
                                        <IconButton
                                          size="small"
                                          onClick={() => handleMasterToolUnitRangeFilterChange(rangeColumn, 'min', '')}
                                          sx={{ p: 0.5 }}
                                        >
                                          <Typography variant="caption" sx={{ fontSize: 12 }}>
                                            ✕
                                          </Typography>
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <TextField
                                  fullWidth
                                  size="small"
                                  type={shouldFormatThousands ? 'text' : 'number'}
                                  inputProps={shouldFormatThousands ? { inputMode: 'decimal' } : undefined}
                                  label="Max"
                                  placeholder="Max"
                                  value={shouldFormatThousands ? formatThousandsInput(masterToolUnitRangeFilters[rangeColumn].max) : masterToolUnitRangeFilters[rangeColumn].max}
                                  onChange={(e) => handleMasterToolUnitRangeFilterChange(rangeColumn, 'max', shouldFormatThousands ? e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '') : e.target.value)}
                                  InputProps={{
                                    endAdornment: masterToolUnitRangeFilters[rangeColumn].max.trim() !== '' && (
                                      <InputAdornment position="end">
                                        <IconButton
                                          size="small"
                                          onClick={() => handleMasterToolUnitRangeFilterChange(rangeColumn, 'max', '')}
                                          sx={{ p: 0.5 }}
                                        >
                                          <Typography variant="caption" sx={{ fontSize: 12 }}>
                                            ✕
                                          </Typography>
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                                <Button
                                  size="small"
                                  onClick={() => {
                                    handleMasterToolUnitRangeFilterChange(rangeColumn, 'min', '');
                                    handleMasterToolUnitRangeFilterChange(rangeColumn, 'max', '');
                                  }}
                                  sx={{ mt: 0.5 }}
                                  fullWidth
                                  disabled={!hasMasterToolUnitActiveFilter(masterToolUnitPopoverAnchor.column)}
                                >
                                  Clear Filter
                                </Button>
                              </Box>
                            );
                          })() : (
                            masterToolUnitPopoverAnchor.column === 'projectName' ||
                            masterToolUnitPopoverAnchor.column === 'projectCategory' ||
                            masterToolUnitPopoverAnchor.column === 'district' ||
                            masterToolUnitPopoverAnchor.column === 'region' ||
                            masterToolUnitPopoverAnchor.column === 'districtLocation' ||
                            masterToolUnitPopoverAnchor.column === 'nearestMrt' ||
                            masterToolUnitPopoverAnchor.column === 'tenure'
                          ) ? (
                            <Box>
                              <Autocomplete
                                multiple
                                fullWidth
                                size="small"
                                disableCloseOnSelect
                                options={(() => {
                                  const key = masterToolUnitPopoverAnchor.column as 'projectName' | 'projectCategory' | 'district' | 'region' | 'districtLocation' | 'nearestMrt' | 'tenure';
                                  const options = masterToolUnitCategoryOptions[key] ?? [];
                                  return options.length > 0 ? ['__SELECT_ALL__', ...options] : options;
                                })()}
                                value={masterToolUnitFilters[masterToolUnitPopoverAnchor.column] as string[]}
                                filterOptions={(opts, state) => {
                                  const defaultFilterOptions = createFilterOptions<string>();
                                  const filtered = defaultFilterOptions(
                                    opts.filter((option) => option !== '__SELECT_ALL__'),
                                    state
                                  );
                                  const key = masterToolUnitPopoverAnchor.column as 'projectName' | 'projectCategory' | 'district' | 'region' | 'districtLocation' | 'nearestMrt' | 'tenure';
                                  const options = masterToolUnitCategoryOptions[key] ?? [];
                                  return options.length > 0 ? ['__SELECT_ALL__', ...filtered] : filtered;
                                }}
                                onChange={(_, value) => {
                                  const column = masterToolUnitPopoverAnchor.column as 'projectName' | 'projectCategory' | 'district' | 'region' | 'districtLocation' | 'nearestMrt' | 'tenure';
                                  const options = masterToolUnitCategoryOptions[column] ?? [];
                                  const selected = (masterToolUnitFilters[column] as string[]) ?? [];
                                  const hasSelectAll = value.includes('__SELECT_ALL__');
                                  if (hasSelectAll) {
                                    handleMasterToolUnitFilterChange(column, selected.length === options.length ? [] : [...options]);
                                    return;
                                  }
                                  handleMasterToolUnitFilterChange(column, value);
                                }}
                                renderOption={(props, option) => {
                                  if (option === '__SELECT_ALL__') {
                                    const column = masterToolUnitPopoverAnchor.column as 'projectName' | 'projectCategory' | 'district' | 'region' | 'districtLocation' | 'nearestMrt' | 'tenure';
                                    const options = masterToolUnitCategoryOptions[column] ?? [];
                                    const selected = (masterToolUnitFilters[column] as string[]) ?? [];
                                    const allSelected = selected.length === options.length && options.length > 0;
                                    const indeterminate = selected.length > 0 && selected.length < options.length;
                                    return (
                                      <li {...props}>
                                        <Checkbox checked={allSelected} indeterminate={indeterminate} sx={{ color: 'var(--color-accent)', '&.Mui-checked': { color: 'var(--color-accent)' } }} />
                                        <Typography component="span" sx={{ fontWeight: 600 }}>
                                          Select All
                                        </Typography>
                                      </li>
                                    );
                                  }
                                  const selected = (masterToolUnitFilters[masterToolUnitPopoverAnchor.column] as string[]).includes(option);
                                  const optionLabel =
                                    masterToolUnitPopoverAnchor.column === 'district'
                                      ? getDistrictFilterOptionLabel(option)
                                      : option;
                                  return (
                                    <li {...props}>
                                      <Checkbox checked={selected} />
                                      {optionLabel}
                                    </li>
                                  );
                                }}
                                renderTags={(value, getTagProps) => {
                                  const column = masterToolUnitPopoverAnchor.column as 'projectName' | 'projectCategory' | 'district' | 'region' | 'districtLocation' | 'nearestMrt' | 'tenure';
                                  const options = masterToolUnitCategoryOptions[column] ?? [];
                                  const summary =
                                    value.length === 0
                                      ? 'All'
                                      : value.length === options.length
                                      ? 'All Selected'
                                      : `${value.length} selected`;
                                  return <Chip label={summary} size="small" {...getTagProps({ index: 0 })} />;
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={`Select ${getMasterToolUnitColumnLabel(masterToolUnitPopoverAnchor.column)}`}
                                    placeholder="Search"
                                  />
                                )}
                              />
                              <Button
                                size="small"
                                onClick={() => handleMasterToolUnitFilterChange(masterToolUnitPopoverAnchor.column, [])}
                                sx={{ mt: 1 }}
                                fullWidth
                                disabled={!hasMasterToolUnitActiveFilter(masterToolUnitPopoverAnchor.column)}
                              >
                                Clear Filter
                              </Button>
                            </Box>
                          ) : (
                            <Box>
                              <TextField
                                fullWidth
                                size="small"
                                placeholder={`Filter ${getMasterToolUnitColumnLabel(masterToolUnitPopoverAnchor.column)}`}
                                value={masterToolUnitFilters[masterToolUnitPopoverAnchor.column] as string}
                                onChange={(e) => handleMasterToolUnitFilterChange(masterToolUnitPopoverAnchor.column, e.target.value)}
                                InputProps={{
                                  endAdornment: hasMasterToolUnitActiveFilter(masterToolUnitPopoverAnchor.column) && (
                                    <InputAdornment position="end">
                                      <IconButton
                                        size="small"
                                        onClick={() => handleMasterToolUnitFilterChange(masterToolUnitPopoverAnchor.column, '')}
                                        sx={{ p: 0.5 }}
                                      >
                                        <Typography variant="caption" sx={{ fontSize: 12 }}>
                                          ✕
                                        </Typography>
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              <Button
                                size="small"
                                onClick={() => handleMasterToolUnitFilterChange(masterToolUnitPopoverAnchor.column, '')}
                                sx={{ mt: 1 }}
                                fullWidth
                                disabled={!hasMasterToolUnitActiveFilter(masterToolUnitPopoverAnchor.column)}
                              >
                                Clear Filter
                              </Button>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )}
                  </Popover>
                </Box>
              )}

              {!masterToolLoading && masterToolViewMode === 'project' && masterToolResults.length === 0 && (
                <Typography variant="body2" sx={{ textAlign: 'center', py: 4, color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  No projects found. Adjust your search criteria and try again.
                </Typography>
              )}
              {!masterToolLoading && masterToolViewMode === 'unit' && masterToolTotalMatchedUnits === 0 && (
                <Typography variant="body2" sx={{ textAlign: 'center', py: 4, color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  No units found. Adjust your search criteria and try again.
                </Typography>
              )}
            </CardContent>
          </Card>
  );

  const showShareFloatingAction = isAdminUser
    && (activeTabId === TOP_VIEWING_SITE_PLANS_TAB || activeTabId === 'master');
  const showCompareFloatingAction = activeTabId === TOP_VIEWING_SITE_PLANS_TAB
    ? topViewingFloorPlansToCompare.length > 0
    : floorPlansToCompare.length > 0;
  const compareFloatingStackIndex = showShareFloatingAction ? 1 : 0;
  const chatFloatingStackIndex = Number(showShareFloatingAction) + Number(showCompareFloatingAction);

  return (
    <Box
      sx={{
        height: '100vh',
        bgcolor: 'var(--color-bg)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {SHOW_AMBERWOOD_SPLASH && userSessionLoaded && userInfo?.CEANumber && !isExternalUser &&
        topViewingSitePlans.some((plan) => /amberwood/i.test(plan.projectName)) && (
          <AmberwoodSplash
            key={userInfo.CEANumber}
            projectId={amberwoodSitePlan?.projectId}
            autoShow={allowAmberwoodSplash}
            replayToken={amberwoodReplayToken}
            onOpenProject={openAmberwoodProject}
          />
        )}
      {SHOW_AMBERWOOD_SPLASH && isAdminUser && userSessionLoaded && userInfo?.CEANumber && !isExternalUser &&
        topViewingSitePlans.some((plan) => /amberwood/i.test(plan.projectName)) && (
          <Box
            component="button"
            type="button"
            aria-label="Replay Amberwood at Holland introduction"
            onClick={() => setAmberwoodReplayToken((token) => token + 1)}
            sx={{
              position: 'fixed',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1200,
              display: 'flex',
              alignItems: 'center',
              border: '1px solid rgba(215, 183, 118, 0.72)',
              borderRight: 0,
              borderRadius: '14px 0 0 14px',
              bgcolor: '#09231d',
              color: '#f4dfab',
              px: 1,
              py: 1.25,
              cursor: 'pointer',
              boxShadow: '-5px 8px 28px rgba(0, 0, 0, 0.32)',
              transition: 'padding .2s ease, background-color .2s ease',
              '&:hover': { bgcolor: '#123a2f', pr: 2 },
              '&:focus-visible': { outline: '2px solid #efcf83', outlineOffset: 2 },
            }}
          >
            <ApartmentIcon sx={{ fontSize: 20 }} />
          </Box>
        )}
      {fromProjectEssential ? null : (
        <AppHeader
          currentTheme={currentTheme}
          userInfo={userInfo}
          sidebarOpen={sidebarOpen}
          onSidebarToggle={() => setSidebarOpen(!sidebarOpen)}
          onThemeToggle={() => {
            const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';
            logMenuClick('Theme Settings', userInfo?.CEANumber || getDevCea());
            setTheme(nextTheme);
          }}
          onTrainingClick={() => {
            const currentCea = userInfo?.CEANumber || getDevCea();
            logRegisterForTrainingClick(currentCea);
            setEventRegistrationOpen(true);
          }}
          showTutorialButton={activeTabId === TOP_VIEWING_SITE_PLANS_TAB && Boolean(selectedTopViewingSitePlan)}
          onTutorialClick={() => setSitePlanTutorialOpen(true)}
          tutorialStatus={sitePlanTutorialStatus}
        />
      )}

      <SitePlanTutorial
        open={sitePlanTutorialOpen}
        onClose={() => setSitePlanTutorialOpen(false)}
        hasReferenceUnit={Boolean(topViewingReferenceUnit)}
      />

      <Box sx={{
        display: 'flex',
        flex: 1,
        mt: fromProjectEssential ? 0 : '64px',
        height: fromProjectEssential ? '100vh' : 'calc(100vh - 64px)',
        overflow: 'hidden',
      }}>
        {fromProjectEssential ? null : (
          <SidebarNavigation
            groups={navigationGroups}
            open={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
            onToggle={() => setSidebarOpen(!sidebarOpen)}
          />
        )}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 3 },
            bgcolor: 'var(--color-bg)',
            minWidth: 0, // Prevents overflow
            width: '100%',
            height: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',
            color: 'var(--color-text-strong)',
          }}
        >
          <Container maxWidth={false} disableGutters>

        <Dialog
          open={clientsDrawerOpen}
          onClose={() => setClientsDrawerOpen(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
            },
          }}
        >
          <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="h6" component="span" sx={{ color: 'inherit' }}>
                All Clients ({clientsTotal})
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={openClientCreator}
                  startIcon={<AddIcon />}
                >
                  Add Client
                </Button>
                <IconButton size="small" onClick={() => setClientsDrawerOpen(false)} sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: 'var(--color-surface)',
              borderColor: 'rgba(var(--color-text-rgb), 0.08)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              '& .MuiOutlinedInput-root': {
                color: 'rgba(var(--color-text-rgb), 0.9)',
                '& fieldset': { borderColor: 'rgba(var(--color-text-rgb), 0.23)' },
                '&:hover fieldset': { borderColor: 'rgba(var(--color-text-rgb), 0.4)' },
                '&.Mui-focused fieldset': { borderColor: 'var(--color-info-navy)' },
              },
              '& .MuiInputLabel-root': { color: 'rgba(var(--color-text-rgb), 0.7)' },
              '& .MuiInputBase-input::placeholder': { color: 'rgba(var(--color-text-rgb), 0.5)' },
              '& .MuiTableRow-root:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.05)' },
              '& .MuiTableCell-root': { color: 'rgba(var(--color-text-rgb), 0.9)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' },
              '& .MuiTypography-colorSecondary': { color: 'rgba(var(--color-text-rgb), 0.7)' },
              '& .MuiTablePagination-root': { color: 'rgba(var(--color-text-rgb), 0.9)' },
              '& .MuiTablePagination-selectIcon': { color: 'rgba(var(--color-text-rgb), 0.7)' },
            }}
          >
            {clientsLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            ) : clientsError ? (
              <Alert severity="error">{clientsError}</Alert>
            ) : (
              <>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search clients"
                      value={clientsSearch}
                      onChange={(e) => {
                        setClientsSearch(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      options={projects}
                      value={clientsProjectFilter || null}
                      onChange={(_, value) => {
                        setClientsProjectFilter(value ?? '');
                        setClientsPage(0);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} size="small" label="Filter by project" />
                      )}
                    />
                  </Grid>
                </Grid>
                <TableContainer sx={{ maxHeight: 'calc(90vh - 260px)' }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, minWidth: 140, backgroundColor: 'rgba(var(--color-shadow-rgb), 0.3)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} rowSpan={2}>Client</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 160, backgroundColor: 'rgba(var(--color-shadow-rgb), 0.3)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} rowSpan={2}>Project</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 120, backgroundColor: 'rgba(var(--color-shadow-rgb), 0.3)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} rowSpan={2}>EOI No / Ballot No</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 90, backgroundColor: 'rgba(var(--color-shadow-rgb), 0.3)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} rowSpan={2}>Q No</TableCell>
                        <TableCell sx={{ fontWeight: 600, textAlign: 'center', backgroundColor: 'rgba(var(--color-sheet-rgb), 0.35)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} colSpan={3}>Imported From Sheet</TableCell>
                        <TableCell sx={{ fontWeight: 600, textAlign: 'center', backgroundColor: 'rgba(var(--color-picker-rgb), 0.35)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} colSpan={3}>Picker</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 120, backgroundColor: 'rgba(var(--color-shadow-rgb), 0.3)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} rowSpan={2}>Notes</TableCell>
                        <TableCell sx={{ fontWeight: 600, width: 130, backgroundColor: 'rgba(var(--color-shadow-rgb), 0.3)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} rowSpan={2} align="center">Action</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, minWidth: 110, backgroundColor: 'rgba(var(--color-sheet-rgb), 0.25)', color: 'rgba(var(--color-text-rgb), 0.9)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>Choice Unit 1</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 110, backgroundColor: 'rgba(var(--color-sheet-rgb), 0.25)', color: 'rgba(var(--color-text-rgb), 0.9)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>Choice Unit 2</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 110, backgroundColor: 'rgba(var(--color-sheet-rgb), 0.25)', color: 'rgba(var(--color-text-rgb), 0.9)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>Choice Unit 3</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 110, backgroundColor: 'rgba(var(--color-picker-rgb), 0.25)', color: 'rgba(var(--color-text-rgb), 0.9)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>Choice Unit 1</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 110, backgroundColor: 'rgba(var(--color-picker-rgb), 0.25)', color: 'rgba(var(--color-text-rgb), 0.9)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>Choice Unit 2</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 110, backgroundColor: 'rgba(var(--color-picker-rgb), 0.25)', color: 'rgba(var(--color-text-rgb), 0.9)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>Choice Unit 3</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {clients.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={12} align="center" sx={{ py: 4 }}>
                          <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                            No clients found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      clients.map((client) => {
                        const projectName = client.projectName || client.choiceUnits?.[0]?.projectName || 'N/A';
                        
                        // Separate units by type
                        const sheetUnits = client.choiceUnits
                          ?.filter((unit) => unit.type === 'SHEET')
                          .sort((a, b) => (a.seq || 0) - (b.seq || 0))
                          .slice(0, 3) || [];
                        const pickerUnits = client.choiceUnits
                          ?.filter((unit) => unit.type === 'PICKER')
                          .sort((a, b) => (a.seq || 0) - (b.seq || 0))
                          .slice(0, 3) || [];
                        
                        const sheetUnit1 = sheetUnits[0];
                        const sheetUnit2 = sheetUnits[1];
                        const sheetUnit3 = sheetUnits[2];
                        const pickerUnit1 = pickerUnits[0];
                        const pickerUnit2 = pickerUnits[1];
                        const pickerUnit3 = pickerUnits[2];
                        
                        return (
                          <TableRow key={client.id} hover>
                            <TableCell>
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                {client.name || '-'}
                              </Typography>
                              {client.phone && (
                                <Typography variant="caption" color="text.secondary" display="block">
                                  {client.phone}
                                </Typography>
                              )}
                              {client.email && (
                                <Typography variant="caption" color="text.secondary" display="block">
                                  {client.email}
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">{projectName}</Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" color="text.secondary">
                                {client.eoiNo || client.ballotNo 
                                  ? `${client.eoiNo || ''}${client.eoiNo && client.ballotNo ? ' / ' : ''}${client.ballotNo || ''}`
                                  : '-'
                                }
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" color="text.secondary">
                                {client.queueNo || '-'}
                              </Typography>
                            </TableCell>
                            {/* Sheet Units */}
                            <TableCell sx={{ backgroundColor: 'rgba(var(--color-sheet-rgb), 0.2)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
                              {sheetUnit1 ? (
                                <Chip
                                  label={`${sheetUnit1.unitNumber}${sheetUnit1.status ? ` • ${sheetUnit1.status}` : ''}`}
                                  size="small"
                                  color={getUnitStatusColor(sheetUnit1.status)}
                                  variant={['sold', 'unavailable'].includes((sheetUnit1.status || '').toLowerCase()) ? 'filled' : 'outlined'}
                                  onClick={() => {
                                    openClientTab(client, sheetUnit1);
                                    setClientsDrawerOpen(false);
                                  }}
                                  sx={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell sx={{ backgroundColor: 'rgba(var(--color-sheet-rgb), 0.2)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
                              {sheetUnit2 ? (
                                <Chip
                                  label={`${sheetUnit2.unitNumber}${sheetUnit2.status ? ` • ${sheetUnit2.status}` : ''}`}
                                  size="small"
                                  color={getUnitStatusColor(sheetUnit2.status)}
                                  variant={['sold', 'unavailable'].includes((sheetUnit2.status || '').toLowerCase()) ? 'filled' : 'outlined'}
                                  onClick={() => {
                                    openClientTab(client, sheetUnit2);
                                    setClientsDrawerOpen(false);
                                  }}
                                  sx={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell sx={{ backgroundColor: 'rgba(var(--color-sheet-rgb), 0.2)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
                              {sheetUnit3 ? (
                                <Chip
                                  label={`${sheetUnit3.unitNumber}${sheetUnit3.status ? ` • ${sheetUnit3.status}` : ''}`}
                                  size="small"
                                  color={getUnitStatusColor(sheetUnit3.status)}
                                  variant={['sold', 'unavailable'].includes((sheetUnit3.status || '').toLowerCase()) ? 'filled' : 'outlined'}
                                  onClick={() => {
                                    openClientTab(client, sheetUnit3);
                                    setClientsDrawerOpen(false);
                                  }}
                                  sx={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            {/* Picker Units */}
                            <TableCell sx={{ backgroundColor: 'rgba(var(--color-picker-rgb), 0.2)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
                              {pickerUnit1 ? (
                                <Chip
                                  label={`${pickerUnit1.unitNumber}${pickerUnit1.status ? ` • ${pickerUnit1.status}` : ''}`}
                                  size="small"
                                  color={getUnitStatusColor(pickerUnit1.status)}
                                  variant={['sold', 'unavailable'].includes((pickerUnit1.status || '').toLowerCase()) ? 'filled' : 'outlined'}
                                  onClick={() => {
                                    openClientTab(client, pickerUnit1);
                                    setClientsDrawerOpen(false);
                                  }}
                                  sx={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell sx={{ backgroundColor: 'rgba(var(--color-picker-rgb), 0.2)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
                              {pickerUnit2 ? (
                                <Chip
                                  label={`${pickerUnit2.unitNumber}${pickerUnit2.status ? ` • ${pickerUnit2.status}` : ''}`}
                                  size="small"
                                  color={getUnitStatusColor(pickerUnit2.status)}
                                  variant={['sold', 'unavailable'].includes((pickerUnit2.status || '').toLowerCase()) ? 'filled' : 'outlined'}
                                  onClick={() => {
                                    openClientTab(client, pickerUnit2);
                                    setClientsDrawerOpen(false);
                                  }}
                                  sx={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell sx={{ backgroundColor: 'rgba(var(--color-picker-rgb), 0.2)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
                              {pickerUnit3 ? (
                                <Chip
                                  label={`${pickerUnit3.unitNumber}${pickerUnit3.status ? ` • ${pickerUnit3.status}` : ''}`}
                                  size="small"
                                  color={getUnitStatusColor(pickerUnit3.status)}
                                  variant={['sold', 'unavailable'].includes((pickerUnit3.status || '').toLowerCase()) ? 'filled' : 'outlined'}
                                  onClick={() => {
                                    openClientTab(client, pickerUnit3);
                                    setClientsDrawerOpen(false);
                                  }}
                                  sx={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              {client.notes ? (
                                <Tooltip title={client.notes}>
                                  <Typography variant="body2" color="text.secondary" sx={{ 
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: 150
                                  }}>
                                    {client.notes}
                                  </Typography>
                                </Tooltip>
                              ) : (
                                <Typography variant="body2" color="text.secondary">-</Typography>
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <Stack direction="row" spacing={1} justifyContent="center">
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={() => {
                                    openClientTab(client);
                                    setClientsDrawerOpen(false);
                                  }}
                                >
                                  View
                                </Button>
                                <IconButton
                                  size="small"
                                  onClick={() => openClientEditor(client)}
                                  aria-label="Edit client"
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                  <TablePagination
                    component="div"
                    count={clientsTotal}
                    page={clientsPage}
                    onPageChange={(_, newPage) => setClientsPage(newPage)}
                    rowsPerPage={clientsPageSize}
                    onRowsPerPageChange={(event) => {
                      setClientsPageSize(parseInt(event.target.value, 10));
                      setClientsPage(0);
                    }}
                    rowsPerPageOptions={[10, 20, 30]}
                  />
                </Box>
              </>
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Typography variant="caption" sx={{ mr: 'auto', ml: 2, color: 'rgba(var(--color-text-rgb), 0.7)' }}>
              Sheet choices are locked. Up to three additional choice units are editable.
            </Typography>
            <Button onClick={() => setClientsDrawerOpen(false)} sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={clientEditOpen}
          onClose={closeClientEditor}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Edit Client</DialogTitle>
          <DialogContent dividers>
            {clientEditError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {clientEditError}
              </Alert>
            )}
            {clientEditTarget ? (
              <Stack spacing={2}>
                <TextField
                  label="Client Name"
                  value={clientEditForm.name}
                  onChange={(e) => setClientEditForm((prev) => ({ ...prev, name: e.target.value }))}
                  fullWidth
                />
                <TextField
                  label="Mobile"
                  value={clientEditForm.phone}
                  onChange={(e) => setClientEditForm((prev) => ({ ...prev, phone: e.target.value }))}
                  fullWidth
                />
                <TextField
                  label="Remarks"
                  value={clientEditForm.notes}
                  onChange={(e) => setClientEditForm((prev) => ({ ...prev, notes: e.target.value }))}
                  fullWidth
                  multiline
                  minRows={2}
                />
                <Divider />
                <Typography variant="subtitle2">Queue Details</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="EOI No"
                      value={clientEditTarget.eoiNo || ''}
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Ballot No"
                      value={clientEditTarget.ballotNo || ''}
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Queue No"
                      value={clientEditTarget.queueNo || ''}
                      fullWidth
                      disabled
                    />
                  </Grid>
                </Grid>
                <Divider />
                <Typography variant="subtitle2">Sheet Choices (Locked)</Typography>
                <Grid container spacing={2}>
                  {[1, 2].map((seq) => {
                    const choice = clientEditTarget.choiceUnits?.find((unit) => unit.seq === seq);
                    return (
                      <Grid item xs={12} sm={6} key={`sheet-choice-${seq}`}>
                        <TextField
                          label={`Choice ${seq}`}
                          value={choice?.unitNumber || ''}
                          fullWidth
                          disabled
                        />
                      </Grid>
                    );
                  })}
                </Grid>
                <Divider />
                <Typography variant="subtitle2">Additional Choices (Editable)</Typography>
                <Grid container spacing={2}>
                  {clientEditForm.pickerChoices.map((value, index) => (
                    <Grid item xs={12} sm={4} key={`picker-choice-${index}`}>
                      <Autocomplete
                        options={clientEditUnits}
                        value={value || null}
                        onChange={(_, newValue) =>
                          setClientEditForm((prev) => {
                            const nextChoices = [...prev.pickerChoices];
                            nextChoices[index] = newValue || '';
                            return { ...prev, pickerChoices: nextChoices };
                          })
                        }
                        loading={clientEditUnitsLoading}
                        freeSolo
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={`Choice ${index + 3}`}
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                Client data not available.
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={closeClientEditor} disabled={clientEditSaving}>
              Cancel
            </Button>
            <Button onClick={handleSaveClientEdit} variant="contained" disabled={clientEditSaving}>
              {clientEditSaving ? 'Saving...' : 'Save'}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={clientCreateOpen}
          onClose={closeClientCreator}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Create New Client</DialogTitle>
          <DialogContent dividers>
            {clientCreateError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {clientCreateError}
              </Alert>
            )}
            <Stack spacing={2}>
              <Autocomplete
                options={projects}
                value={clientCreateForm.projectId || null}
                onChange={(_, value) => {
                  setClientCreateForm((prev) => ({ ...prev, projectId: value || '' }));
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Project" required fullWidth />
                )}
              />
              <TextField
                label="Client Name"
                value={clientCreateForm.name}
                onChange={(e) => setClientCreateForm((prev) => ({ ...prev, name: e.target.value }))}
                fullWidth
              />
              <TextField
                label="Mobile"
                value={clientCreateForm.phone}
                onChange={(e) => setClientCreateForm((prev) => ({ ...prev, phone: e.target.value }))}
                fullWidth
              />
              <TextField
                label="Remarks"
                value={clientCreateForm.notes}
                onChange={(e) => setClientCreateForm((prev) => ({ ...prev, notes: e.target.value }))}
                fullWidth
                multiline
                minRows={2}
              />
              <Divider />
              <Typography variant="subtitle2">Queue Details</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="EOI No"
                    value={clientCreateForm.eoiNo}
                    onChange={(e) => setClientCreateForm((prev) => ({ ...prev, eoiNo: e.target.value }))}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Ballot No"
                    value={clientCreateForm.ballotNo}
                    onChange={(e) => setClientCreateForm((prev) => ({ ...prev, ballotNo: e.target.value }))}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Queue No"
                    value={clientCreateForm.queueNo}
                    onChange={(e) => setClientCreateForm((prev) => ({ ...prev, queueNo: e.target.value }))}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Divider />
              <Typography variant="subtitle2">Additional Choices</Typography>
              <Grid container spacing={2}>
                {clientCreateForm.pickerChoices.map((value, index) => (
                  <Grid item xs={12} sm={4} key={`create-picker-choice-${index}`}>
                    <Autocomplete
                      options={clientCreateUnits}
                      value={value || null}
                      onChange={(_, newValue) =>
                        setClientCreateForm((prev) => {
                          const nextChoices = [...prev.pickerChoices];
                          nextChoices[index] = newValue || '';
                          return { ...prev, pickerChoices: nextChoices };
                        })
                      }
                      loading={clientCreateUnitsLoading}
                      disabled={!clientCreateForm.projectId}
                      freeSolo
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={`Choice ${index + 3}`}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeClientCreator} disabled={clientCreateSaving}>
              Cancel
            </Button>
            <Button onClick={handleSaveClientCreate} variant="contained" disabled={clientCreateSaving}>
              {clientCreateSaving ? 'Creating...' : 'Create'}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={shortlistDialogOpen}
          onClose={() => setShortlistDialogOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
            },
          }}
        >
          <DialogTitle sx={{ pb: 1.5, color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
              <Box>
                <Typography variant="h5" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                  Shortlisted Units
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  {shortlistItems.length} saved unit{shortlistItems.length === 1 ? '' : 's'}
                </Typography>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, bgcolor: 'var(--color-surface)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', color: 'rgba(var(--color-text-rgb), 0.9)' }}>
            {shortlistLoading && <LinearProgress sx={{ mb: 2 }} />}
            {shortlistError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {shortlistError}
              </Alert>
            )}
            {shortlistItems.length === 0 && !shortlistLoading ? (
              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                No shortlisted units yet
              </Typography>
            ) : (
              <Stack spacing={1.5}>
                {shortlistItems.map((item) => {
                  const isLiveData = item.unitStatusSource === 'live' || item.priceSource === 'live';
                  const detailParts = [
                    item.blockNumber ? `Block ${item.blockNumber}` : null,
                    item.bedroom !== null ? `${item.bedroom} BR` : null,
                    item.bathroom !== null ? `${item.bathroom} BA` : null,
                    item.areaSqft !== null ? `${formatNumber(item.areaSqft)} sqft` : null,
                    item.price !== null ? formatCurrency(item.price) : null,
                  ].filter(Boolean);
                  return (
                    <Card
                      key={item.id}
                      variant="outlined"
                      sx={{
                        borderRadius: 2.5,
                        borderColor: 'rgba(var(--color-text-rgb), 0.15)',
                        backgroundColor: 'rgba(var(--color-shadow-rgb), 0.2)',
                        boxShadow: 'none',
                      }}
                    >
                      <Box
                        sx={{
                          position: 'relative',
                          display: 'grid',
                          gridTemplateColumns: { xs: '1fr', sm: '140px 1fr' },
                          gap: 1.5,
                          p: 1.5,
                        }}
                      >
                        <IconButton
                          size="small"
                          onClick={() => handleRequestShortlistDelete(item)}
                          sx={{
                            position: 'absolute',
                            top: 6,
                            right: 6,
                            bgcolor: 'rgba(var(--color-shadow-rgb), 0.4)',
                            color: 'rgba(var(--color-text-rgb), 0.9)',
                            '&:hover': {
                              bgcolor: 'rgba(var(--color-danger-rgb), 0.4)',
                            },
                          }}
                          aria-label="Remove from shortlist"
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                        <Box
                          sx={{
                            borderRadius: 2,
                            overflow: 'hidden',
                            bgcolor: 'rgba(var(--color-shadow-rgb), 0.3)',
                            border: '1px solid rgba(var(--color-text-rgb), 0.15)',
                            minHeight: 96,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {item.floorplan ? (
                            <Box
                              component="img"
                              src={item.floorplan}
                              alt={`${item.unitNumber || 'Unit'} floor plan`}
                              sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                            />
                          ) : (
                            <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                              No floor plan
                            </Typography>
                          )}
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                              <Typography variant="subtitle1" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                                {item.projectName || item.projectId || 'Project'} {item.unitNumber || ''}
                              </Typography>
                              {isLiveData && (
                                <Box
                                  sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    px: 0.75,
                                    py: 0.1,
                                    borderRadius: 999,
                                    bgcolor: 'rgba(var(--color-danger-rgb), 0.18)',
                                    color: 'var(--color-danger)',
                                    fontSize: '0.62rem',
                                    fontWeight: 800,
                                    letterSpacing: '0.12em',
                                    textTransform: 'uppercase',
                                    animation: 'liveBlink 1.3s ease-in-out infinite',
                                    '@keyframes liveBlink': {
                                      '0%': { opacity: 0.35, transform: 'scale(0.98)' },
                                      '50%': { opacity: 1, transform: 'scale(1.02)' },
                                      '100%': { opacity: 0.35, transform: 'scale(0.98)' },
                                    },
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 6,
                                      height: 6,
                                      borderRadius: '50%',
                                      bgcolor: 'var(--color-danger)',
                                      boxShadow: '0 0 6px rgba(var(--color-danger-rgb), 0.8)',
                                    }}
                                  />
                                  Live
                                </Box>
                              )}
                              {item.unitStatus && (
                                <Chip
                                  label={item.unitStatus}
                                  size="small"
                                  color={getUnitStatusColor(item.unitStatus)}
                                />
                              )}
                            </Box>
                            <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                              {detailParts.length > 0 ? detailParts.join(' • ') : 'No details available'}
                            </Typography>
                          </Box>
                          <Stack direction="row" spacing={0.75} sx={{ mt: 0.75 }}>
                          <Tooltip title="Buyer Interest">
                              <Box
                                onClick={() => handleOpenShortlistAction(item, 'interest')}
                                sx={{
                                  display: 'flex',
                                  gap: 0.4,
                                  cursor: 'pointer',
                                  alignItems: 'center',
                                }}
                              >
                                {[0, 1, 2, 3].map((barIndex) => (
                                  <Box
                                    key={barIndex}
                                    sx={{
                                      width: 10,
                                      height: 8,
                                      borderRadius: 999,
                                      bgcolor: barIndex < 3 ? 'var(--color-danger)' : 'var(--color-neutral)',
                                    }}
                                  />
                                ))}
                              </Box>
                            </Tooltip>
                            <Tooltip title="Tower View">
                              <IconButton
                                size="small"
                                onClick={() => handleOpenShortlistAction(item, 'tower')}
                                sx={{
                                  color: 'rgba(var(--color-text-rgb), 0.9)',
                                  bgcolor: 'rgba(var(--color-sheet-rgb), 0.4)',
                                  '&:hover': {
                                    bgcolor: 'rgba(var(--color-sheet-rgb), 0.6)',
                                  },
                                }}
                                aria-label="Tower View"
                              >
                                <ViewModuleIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Site Plan">
                              <IconButton
                                size="small"
                                onClick={() => handleOpenShortlistAction(item, 'siteplan')}
                                sx={{
                                  color: 'rgba(var(--color-text-rgb), 0.9)',
                                  bgcolor: 'rgba(var(--color-sheet-rgb), 0.4)',
                                  '&:hover': {
                                    bgcolor: 'rgba(var(--color-sheet-rgb), 0.6)',
                                  },
                                }}
                                aria-label="Site Plan"
                              >
                                <ImageIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                         
                            {!isExternalUser && (
                              <Tooltip title="View in Find Comparable Tool">
                                <IconButton
                                  size="small"
                                  onClick={() => handleOpenShortlistAction(item, 'view')}
                                  sx={{
                                    color: 'rgba(var(--color-text-rgb), 0.9)',
                                    bgcolor: 'rgba(var(--color-sheet-rgb), 0.4)',
                                    '&:hover': {
                                      bgcolor: 'rgba(var(--color-sheet-rgb), 0.6)',
                                    },
                                  }}
                                  aria-label="View in Find Comparable Tool"
                                >
                                  <VisibilityIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Stack>
                          {item.remark ? (
                            <Box
                              sx={{
                                bgcolor: 'rgba(var(--color-sheet-rgb), 0.25)',
                                borderRadius: 1.5,
                                p: 0.75,
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                <Typography variant="caption" sx={{ display: 'block', color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                  Remark
                                </Typography>
                                <Button
                                  size="small"
                                  startIcon={<EditIcon fontSize="small" />}
                                  onClick={() => openShortlistRemarkDialog({
                                    mode: 'edit',
                                    itemId: item.id,
                                    unitId: item.unitId ?? null,
                                    label: `${item.projectName || item.projectId || 'Project'} ${item.unitNumber || ''}`,
                                    floorplan: item.floorplan ?? null,
                                    remark: item.remark ?? '',
                                  })}
                                  sx={{ textTransform: 'none', fontWeight: 600, color: 'rgba(var(--color-text-rgb), 0.9)' }}
                                >
                                  Edit
                                </Button>
                              </Box>
                              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>
                                {item.remark}
                              </Typography>
                            </Box>
                          ) : (
                            <Button
                              size="small"
                              startIcon={<EditIcon fontSize="small" />}
                              onClick={() => openShortlistRemarkDialog({
                                mode: 'edit',
                                itemId: item.id,
                                unitId: item.unitId ?? null,
                                label: `${item.projectName || item.projectId || 'Project'} ${item.unitNumber || ''}`,
                                floorplan: item.floorplan ?? null,
                                remark: '',
                              })}
                              sx={{ alignSelf: 'flex-start', textTransform: 'none', fontWeight: 600, color: 'rgba(var(--color-text-rgb), 0.9)' }}
                            >
                              Add remark
                            </Button>
                          )}
                        </Box>
                      </Box>
                    </Card>
                  );
                })}
              </Stack>
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Button onClick={() => setShortlistDialogOpen(false)} sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={thumbsupDialogOpen}
          onClose={() => {
            setThumbsupDialogOpen(false);
            setThumbsupProjectSearch('');
          }}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
            },
          }}
        >
          <DialogTitle sx={{ pb: 1.5, color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ThumbUpIcon sx={{ color: 'var(--color-success)' }} />
              <Box>
                <Typography variant="h5" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                  Thumbsup Units
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  Higher floor. Lower price
                </Typography>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, bgcolor: 'var(--color-surface)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', color: 'rgba(var(--color-text-rgb), 0.9)' }}>
            <ThumbsupHowItWorksBanner
              onOpen={(origin) => {
                setThumbsupIntroOrigin(origin);
                setThumbsupIntroOpen(true);
              }}
            />
            {thumbsupLoading && <LinearProgress sx={{ mb: 2 }} />}
            {thumbsupError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {thumbsupError}
              </Alert>
            )}
            <Typography variant="body2" sx={{ mb: 1, color: 'rgba(var(--color-text-rgb), 0.7)' }}>
              {thumbsupProjectSearch.trim()
                ? `${thumbsupFilteredProjectGroups.length} project${thumbsupFilteredProjectGroups.length === 1 ? '' : 's'} match${thumbsupFilteredProjectGroups.length === 1 ? 'es' : ''} · ${thumbsupGroupsByProject.length} total`
                : `${thumbsupGroupsByProject.length} project${thumbsupGroupsByProject.length === 1 ? '' : 's'} with top-value units`}
            </Typography>
            {latestViewedThumbsupUnit && (
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="overline"
                  sx={{ color: 'rgba(var(--color-text-rgb), 0.55)', letterSpacing: 0.8 }}
                >
                  Last Viewed
                </Typography>
                <Card
                  variant="outlined"
                  sx={{
                    mt: 0.75,
                    borderRadius: 2,
                    borderColor: 'rgba(var(--color-text-rgb), 0.12)',
                    backgroundColor: 'rgba(var(--color-shadow-rgb), 0.25)',
                    boxShadow: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      borderColor: 'var(--color-info-navy)',
                      backgroundColor: 'rgba(var(--color-sheet-rgb), 0.35)',
                    },
                  }}
                  onClick={() => handleThumbsupUnitClick(latestViewedThumbsupUnit, 'thumbsup_last_viewed')}
                >
                  <Box sx={{ p: 1.25, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                        {latestViewedThumbsupUnit.projectName}
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                        Unit {latestViewedThumbsupUnit.UnitNumber} &middot; {latestViewedThumbsupUnit.bedroomNumber}BR &middot; {formatThumbsupUnitSqft(latestViewedThumbsupUnit.size)}
                      </Typography>
                    </Box>
                    <Chip
                      icon={<ThumbUpIcon sx={{ fontSize: 14 }} />}
                      label={`${latestViewedThumbsupUnit.thumbsupCount}`}
                      size="small"
                      sx={{
                        bgcolor: 'rgba(var(--color-success-rgb, 76, 175, 80), 0.15)',
                        color: 'var(--color-success)',
                        fontWeight: 700,
                        flexShrink: 0,
                      }}
                    />
                  </Box>
                </Card>
              </Box>
            )}
            <TextField
              fullWidth
              size="small"
              placeholder="Search by project name"
              value={thumbsupProjectSearch}
              onChange={(e) => setThumbsupProjectSearch(e.target.value)}
              sx={{ mb: 1.5, mt: 0.5 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: 20, color: 'rgba(var(--color-text-rgb), 0.45)' }} />
                  </InputAdornment>
                ),
              }}
            />
            {thumbsupBedroomOptions.length > 0 && (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mb: 2 }}>
                <Chip
                  label="All"
                  size="small"
                  clickable
                  onClick={() => setThumbsupBedroomFilter([])}
                  variant={thumbsupBedroomFilter.length === 0 ? 'filled' : 'outlined'}
                  sx={{
                    fontWeight: 600,
                    bgcolor: thumbsupBedroomFilter.length === 0 ? 'var(--color-info-navy)' : 'transparent',
                    color: thumbsupBedroomFilter.length === 0 ? '#fff' : 'rgba(var(--color-text-rgb), 0.85)',
                    borderColor: 'rgba(var(--color-text-rgb), 0.25)',
                  }}
                />
                {thumbsupBedroomOptions.map((bed) => {
                  const active = thumbsupBedroomFilter.includes(bed);
                  return (
                    <Chip
                      key={bed}
                      label={`${bed}BR`}
                      size="small"
                      clickable
                      onClick={() => setThumbsupBedroomFilter((prev) => prev.includes(bed) ? prev.filter((b) => b !== bed) : [...prev, bed])}
                      variant={active ? 'filled' : 'outlined'}
                      sx={{
                        fontWeight: 600,
                        bgcolor: active ? 'var(--color-info-navy)' : 'transparent',
                        color: active ? '#fff' : 'rgba(var(--color-text-rgb), 0.85)',
                        borderColor: 'rgba(var(--color-text-rgb), 0.25)',
                      }}
                    />
                  );
                })}
              </Box>
            )}
            {thumbsupUnits.length === 0 && !thumbsupLoading ? (
              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                No thumbsup units found
              </Typography>
            ) : thumbsupFilteredProjectGroups.length === 0 ? (
              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                {thumbsupBedroomFilter.length > 0 && !thumbsupProjectSearch.trim()
                  ? 'No projects match your filters'
                  : 'No projects match your search'}
              </Typography>
            ) : (
              <Stack spacing={1}>
                {thumbsupFilteredProjectGroups.map((group) => (
                  <Accordion
                    key={group.projectId}
                    disableGutters
                    sx={{
                      borderRadius: 2.5,
                      border: '1px solid rgba(var(--color-text-rgb), 0.15)',
                      bgcolor: 'rgba(var(--color-shadow-rgb), 0.2)',
                      '&:before': { display: 'none' },
                      overflow: 'hidden',
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: 'var(--color-text-strong)' }} />}
                      sx={{
                        px: 1.5,
                        py: 1,
                        minHeight: 48,
                        '& .MuiAccordionSummary-content': { my: 1, alignItems: 'center' },
                        '&:hover': { bgcolor: 'rgba(var(--color-sheet-rgb), 0.25)' },
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 1, gap: 1, minWidth: 0 }}>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                            <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                              {group.projectName}
                            </Typography>
                            {group.isLive === 1 && (
                              <Chip
                                label="LIVE"
                                size="small"
                                sx={{
                                  height: 18,
                                  fontSize: 10,
                                  fontWeight: 700,
                                  bgcolor: 'rgba(244, 67, 54, 0.15)',
                                  color: '#f44336',
                                  flexShrink: 0,
                                }}
                              />
                            )}
                          </Box>
                          <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.55)', display: 'block' }}>
                            {group.units.length} top-value unit{group.units.length === 1 ? '' : 's'}
                          </Typography>
                        </Box>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ px: 1.5, pt: 0, pb: 1.5, bgcolor: 'rgba(var(--color-shadow-rgb), 0.12)' }}>
                      <Stack spacing={1}>
                        {group.units.map((item) => (
                          <Card
                            key={`${item.ProjectId}-${item.id}`}
                            variant="outlined"
                            sx={{
                              borderRadius: 2,
                              borderColor: 'rgba(var(--color-text-rgb), 0.12)',
                              backgroundColor: 'rgba(var(--color-shadow-rgb), 0.25)',
                              boxShadow: 'none',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                borderColor: 'var(--color-info-navy)',
                                backgroundColor: 'rgba(var(--color-sheet-rgb), 0.35)',
                              },
                            }}
                            onClick={() => handleThumbsupUnitClick(item)}
                          >
                            <Box sx={{ p: 1.25, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                              <Box sx={{ minWidth: 0 }}>
                                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                                  Unit {item.UnitNumber} &middot; {item.bedroomNumber}BR &middot; {formatThumbsupUnitSqft(item.size)}
                                </Typography>
                              </Box>
                              <Chip
                                icon={<ThumbUpIcon sx={{ fontSize: 14 }} />}
                                label={`${item.thumbsupCount}`}
                                size="small"
                                sx={{
                                  bgcolor: 'rgba(var(--color-success-rgb, 76, 175, 80), 0.15)',
                                  color: 'var(--color-success)',
                                  fontWeight: 700,
                                  flexShrink: 0,
                                }}
                              />
                            </Box>
                          </Card>
                        ))}
                      </Stack>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Stack>
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Button
              onClick={() => {
                setThumbsupDialogOpen(false);
                setThumbsupProjectSearch('');
              }}
              sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <ThumbsupHowItWorksOverlay
          open={thumbsupIntroOpen}
          origin={thumbsupIntroOrigin}
          onClose={() => setThumbsupIntroOpen(false)}
        />

        <Dialog
          open={pricePromoDialogOpen}
          onClose={() => {
            setPricePromoDialogOpen(false);
            setPricePromoProjectSearch('');
          }}
          maxWidth={pricePromoViewMode === 'table' ? 'lg' : 'sm'}
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
            },
          }}
        >
          <DialogTitle sx={{ pb: 1.5, color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                <LocalOfferIcon sx={{ color: 'var(--color-success)' }} />
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="h5" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                    Price Promo Units
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                    {pricePromoProjectSearch.trim()
                      ? `${pricePromoAllGroups.length} project${pricePromoAllGroups.length === 1 ? '' : 's'} match${pricePromoAllGroups.length === 1 ? 'es' : ''} · ${pricePromoTotalProjects} total`
                      : `${pricePromoTotalProjects} project${pricePromoTotalProjects === 1 ? '' : 's'} with price promo units`}
                  </Typography>
                </Box>
              </Box>
              {canUsePricePromoShareTools && (
                <ToggleButtonGroup
                  value={pricePromoViewMode}
                  exclusive
                  size="small"
                  onChange={(_, value) => { if (value !== null) setPricePromoViewMode(value); }}
                  sx={{
                    '& .MuiToggleButton-root': {
                      px: 1.5,
                      py: 0.5,
                      textTransform: 'none',
                      color: 'rgba(var(--color-text-rgb), 0.75)',
                      borderColor: 'rgba(var(--color-text-rgb), 0.2)',
                      '&.Mui-selected': {
                        bgcolor: 'var(--color-info-navy)',
                        color: '#fff',
                        '&:hover': { bgcolor: 'var(--color-info-navy)' },
                      },
                    },
                  }}
                >
                  <ToggleButton value="tab">
                    <ViewModuleIcon fontSize="small" sx={{ mr: 0.5 }} />
                    Tab
                  </ToggleButton>
                  <ToggleButton value="table">
                    <TableRowsIcon fontSize="small" sx={{ mr: 0.5 }} />
                    Table
                  </ToggleButton>
                </ToggleButtonGroup>
              )}
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, bgcolor: 'var(--color-surface)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', color: 'rgba(var(--color-text-rgb), 0.9)' }}>
            {pricePromoLoading && <LinearProgress sx={{ mb: 2 }} />}
            {pricePromoError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {pricePromoError}
              </Alert>
            )}
            <Autocomplete
              freeSolo
              fullWidth
              size="small"
              options={pricePromoAutocompleteOptions}
              value={pricePromoProjectSearch}
              onInputChange={(_e, value) => setPricePromoProjectSearch(value)}
              sx={{ mb: 1.5, mt: 0.5 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search by project name"
                  name={`price-promo-search-${Math.random().toString(36).slice(2, 10)}`}
                  type="search"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 20, color: 'rgba(var(--color-text-rgb), 0.45)' }} />
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'off',
                    autoCorrect: 'off',
                    autoCapitalize: 'off',
                    spellCheck: false,
                    'data-lpignore': 'true',
                    'data-form-type': 'other',
                    'data-1p-ignore': 'true',
                  }}
                />
              )}
            />
            {(pricePromoBedroomOptions.length > 0 || pricePromoHasPenthouse) && (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 0.75, mb: 2 }}>
                <Chip
                  label="All"
                  size="small"
                  clickable
                  onClick={() => setPricePromoBedroomFilter([])}
                  variant={pricePromoBedroomFilter.length === 0 ? 'filled' : 'outlined'}
                  sx={{
                    fontWeight: 600,
                    bgcolor: pricePromoBedroomFilter.length === 0 ? 'var(--color-info-navy)' : 'transparent',
                    color: pricePromoBedroomFilter.length === 0 ? '#fff' : 'rgba(var(--color-text-rgb), 0.85)',
                    borderColor: 'rgba(var(--color-text-rgb), 0.25)',
                  }}
                />
                {pricePromoBedroomOptions.map((bed) => {
                  const active = pricePromoBedroomFilter.includes(bed);
                  return (
                    <Chip
                      key={bed}
                      label={`${bed}BR`}
                      size="small"
                      clickable
                      onClick={() => setPricePromoBedroomFilter((prev) => prev.includes(bed) ? prev.filter((b) => b !== bed) : [...prev, bed])}
                      variant={active ? 'filled' : 'outlined'}
                      sx={{
                        fontWeight: 600,
                        bgcolor: active ? 'var(--color-info-navy)' : 'transparent',
                        color: active ? '#fff' : 'rgba(var(--color-text-rgb), 0.85)',
                        borderColor: 'rgba(var(--color-text-rgb), 0.25)',
                      }}
                    />
                  );
                })}
                {pricePromoHasPenthouse && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={pricePromoPhOnly}
                        onChange={(e) => setPricePromoPhOnly(e.target.checked)}
                        sx={{ py: 0, color: 'rgba(var(--color-text-rgb), 0.5)', '&.Mui-checked': { color: 'var(--color-accent)' } }}
                      />
                    }
                    label="PH only"
                    sx={{
                      ml: 0.25,
                      mr: 0,
                      '& .MuiFormControlLabel-label': { fontSize: 13, fontWeight: 600, color: 'rgba(var(--color-text-rgb), 0.85)' },
                    }}
                  />
                )}
              </Box>
            )}
            {pricePromoUnits.length === 0 && !pricePromoLoading ? (
              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                No price promo units found
              </Typography>
            ) : pricePromoViewMode === 'table' ? (
              <PricePromoTableView
                units={pricePromoTableUnits}
                formatCurrency={formatCurrency}
                formatSqft={formatThumbsupUnitSqft}
                onUnitClick={handlePricePromoUnitClick}
                onPriceClick={(unit) => handleOpenPriceChart(unit.id, 'price', true, 'price_promo_table', unit.bedroomNumber)}
                isAdmin={isAdminUser}
                revealedUnitIds={pricePromoRevealedUnitIds}
                revealsRemaining={pricePromoRevealState?.remaining ?? 0}
                revealLimit={pricePromoRevealState?.limit ?? 0}
                revealsLoaded={pricePromoRevealState !== null}
                onRevealUnit={handlePricePromoReveal}
              />
            ) : (
              <Stack spacing={2}>
                {/* Latest Price Promo (last 14 days) */}
                <Box
                  sx={{
                    borderRadius: 2.5,
                    border: '2px solid #f44336',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    onClick={() => setPricePromoLatestExpanded((v) => !v)}
                    sx={{
                      px: 1.5,
                      py: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                      cursor: 'pointer',
                      bgcolor: 'rgba(244, 67, 54, 0.08)',
                      '&:hover': { bgcolor: 'rgba(244, 67, 54, 0.14)' },
                    }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: '#f44336' }}>
                        Latest Price Promo (last 14 days)
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)', display: 'block' }}>
                        {pricePromoLatestGroups.length} project{pricePromoLatestGroups.length === 1 ? '' : 's'}
                      </Typography>
                    </Box>
                    <ExpandMoreIcon
                      sx={{
                        color: '#f44336',
                        transform: pricePromoLatestExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease',
                      }}
                    />
                  </Box>
                  <Collapse in={pricePromoLatestExpanded} timeout="auto" unmountOnExit>
                    <Box sx={{ px: 1.25, py: 1.25, bgcolor: 'rgba(244, 67, 54, 0.04)' }}>
                      {pricePromoLatestGroups.length === 0 ? (
                        <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                          No price promo units in the last 14 days.
                        </Typography>
                      ) : (
                        <Stack spacing={1}>
                          {pricePromoLatestGroups.map((group) => (
                            <Accordion
                              key={`latest-${group.projectId}`}
                              disableGutters
                              sx={{
                                borderRadius: 2,
                                border: '1px solid rgba(var(--color-text-rgb), 0.15)',
                                bgcolor: 'rgba(var(--color-shadow-rgb), 0.2)',
                                '&:before': { display: 'none' },
                                overflow: 'hidden',
                              }}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ color: 'var(--color-text-strong)' }} />}
                                sx={{
                                  px: 1.5,
                                  py: 1,
                                  minHeight: 48,
                                  '& .MuiAccordionSummary-content': { my: 1, alignItems: 'center' },
                                  '&:hover': { bgcolor: 'rgba(var(--color-sheet-rgb), 0.25)' },
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 1, gap: 1, minWidth: 0 }}>
                                  <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                                        {group.projectName}
                                      </Typography>
                                      {group.isLive === 1 && (
                                        <Chip
                                          label="LIVE"
                                          size="small"
                                          sx={{
                                            height: 18,
                                            fontSize: 10,
                                            fontWeight: 700,
                                            bgcolor: 'rgba(244, 67, 54, 0.15)',
                                            color: '#f44336',
                                            flexShrink: 0,
                                          }}
                                        />
                                      )}
                                    </Box>
                                    <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.55)', display: 'block' }}>
                                      {group.units.length} unit{group.units.length === 1 ? '' : 's'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails sx={{ px: 1.5, pt: 0, pb: 1.5, bgcolor: 'rgba(var(--color-shadow-rgb), 0.12)' }}>
                                <Stack spacing={1}>
                                  {group.units.map((item) => {
                                    const isBest = pricePromoBestByStackBedroom.has(item.id);
                                    return (
                                      <Card
                                        key={`latest-${item.ProjectId}-${item.id}`}
                                        variant="outlined"
                                        sx={{
                                          borderRadius: 2,
                                          border: isBest ? '2px solid var(--color-success)' : '1px solid rgba(var(--color-text-rgb), 0.12)',
                                          backgroundColor: 'rgba(var(--color-shadow-rgb), 0.25)',
                                          boxShadow: 'none',
                                          cursor: 'pointer',
                                          transition: 'all 0.2s ease',
                                          '&:hover': {
                                            borderColor: isBest ? 'var(--color-success)' : 'var(--color-info-navy)',
                                            backgroundColor: 'rgba(var(--color-sheet-rgb), 0.35)',
                                          },
                                        }}
                                        onClick={() => handlePricePromoUnitClick(item, 'price_promo_units', 'latest')}
                                      >
                                        <Box sx={{ p: 1.25, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                                          <Box sx={{ minWidth: 0 }}>
                                            <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                                              Unit {item.UnitNumber} &middot; {pricePromoBedroomLabel(item)} &middot; {formatThumbsupUnitSqft(item.size)}
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: 'var(--color-success)', fontWeight: 600, display: 'block' }}>
                                              {item.priceChange < 0 ? '-' : ''}${Math.abs(item.priceChange).toLocaleString()}
                                              {item.priceChangePercent ? ` (${item.priceChangePercent.toFixed(1)}%)` : ''}
                                            </Typography>
                                            {item.priceChangeAt && (
                                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.5)', display: 'block' }}>
                                                {formatPricePromoDate(item.priceChangeAt)}
                                              </Typography>
                                            )}
                                          </Box>
                                          <PricePromoPriceButton
                                            priceLabel={`$${Math.round(item.price).toLocaleString()}`}
                                            onClick={() => handleOpenPriceChart(item.id, 'price', true, 'price_promo_latest', item.bedroomNumber)}
                                            onShareClick={canUsePricePromoShareTools
                                              ? () => handleOpenPriceChart(item.id, 'price', true, 'price_promo_latest_share', item.bedroomNumber, 'share')
                                              : undefined}
                                          />
                                        </Box>
                                      </Card>
                                    );
                                  })}
                                </Stack>
                              </AccordionDetails>
                            </Accordion>
                          ))}
                        </Stack>
                      )}
                    </Box>
                  </Collapse>
                </Box>

                {/* Top 5 Saving */}
                <Box
                  sx={{
                    borderRadius: 2.5,
                    border: '2px solid #ed6c02',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    onClick={() => setPricePromoTopSavingExpanded((v) => !v)}
                    sx={{
                      px: 1.5,
                      py: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                      cursor: 'pointer',
                      bgcolor: 'rgba(237, 108, 2, 0.08)',
                      '&:hover': { bgcolor: 'rgba(237, 108, 2, 0.14)' },
                    }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: '#ed6c02' }}>
                        Top 5 Saving
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)', display: 'block' }}>
                        {pricePromoTopSavingGroups.reduce((s, g) => s + g.units.length, 0)} unit{pricePromoTopSavingGroups.reduce((s, g) => s + g.units.length, 0) === 1 ? '' : 's'}
                      </Typography>
                    </Box>
                    <ExpandMoreIcon
                      sx={{
                        color: '#ed6c02',
                        transform: pricePromoTopSavingExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease',
                      }}
                    />
                  </Box>
                  <Collapse in={pricePromoTopSavingExpanded} timeout="auto" unmountOnExit>
                    <Box sx={{ px: 1.25, py: 1.25, bgcolor: 'rgba(237, 108, 2, 0.04)' }}>
                      {pricePromoTopSavingGroups.length === 0 ? (
                        <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                          No price promo units match your filters.
                        </Typography>
                      ) : (
                        <Stack spacing={1}>
                          {pricePromoTopSavingGroups.map((group) => {
                            const isMulti = group.units.length > 1;
                            const isGroupOpen = pricePromoTopSavingGroupExpanded.has(group.key);

                            if (!isMulti) {
                              const item = group.units[0];
                              const isBest = pricePromoBestByStackBedroom.has(item.id);
                              return (
                                <Card
                                  key={`top-${group.key}`}
                                  variant="outlined"
                                  sx={{
                                    borderRadius: 2,
                                    border: isBest ? '2px solid var(--color-success)' : '1px solid rgba(var(--color-text-rgb), 0.12)',
                                    backgroundColor: 'rgba(var(--color-shadow-rgb), 0.25)',
                                    boxShadow: 'none',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                      borderColor: isBest ? 'var(--color-success)' : 'var(--color-info-navy)',
                                      backgroundColor: 'rgba(var(--color-sheet-rgb), 0.35)',
                                    },
                                  }}
                                  onClick={() => handlePricePromoUnitClick(item, 'price_promo_units', 'top_saving')}
                                >
                                  <Box sx={{ p: 1.25, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                                    <Box sx={{ minWidth: 0 }}>
                                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                                        {item.projectName}
                                      </Typography>
                                      <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                                        Unit {item.UnitNumber} &middot; {pricePromoBedroomLabel(item)} &middot; {formatThumbsupUnitSqft(item.size)}
                                      </Typography>
                                      <Typography variant="caption" sx={{ color: 'var(--color-success)', fontWeight: 600, display: 'block' }}>
                                        {item.priceChange < 0 ? '-' : ''}${Math.abs(item.priceChange).toLocaleString()}
                                        {item.priceChangePercent ? ` (${item.priceChangePercent.toFixed(1)}%)` : ''}
                                      </Typography>
                                      {item.priceChangeAt && (
                                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.5)', display: 'block' }}>
                                          {formatPricePromoDate(item.priceChangeAt)}
                                        </Typography>
                                      )}
                                    </Box>
                                    <PricePromoPriceButton
                                      priceLabel={`$${Math.round(item.price).toLocaleString()}`}
                                      onClick={() => handleOpenPriceChart(item.id, 'price', true, 'price_promo_top_saving', item.bedroomNumber)}
                                      onShareClick={canUsePricePromoShareTools
                                        ? () => handleOpenPriceChart(item.id, 'price', true, 'price_promo_top_saving_share', item.bedroomNumber, 'share')
                                        : undefined}
                                    />
                                  </Box>
                                </Card>
                              );
                            }

                            const anyBest = group.units.some((u: PricePromoUnit) => pricePromoBestByStackBedroom.has(u.id));
                            return (
                              <Card
                                key={`top-${group.key}`}
                                variant="outlined"
                                sx={{
                                  borderRadius: 2,
                                  border: anyBest ? '2px solid var(--color-success)' : '1px solid rgba(var(--color-text-rgb), 0.12)',
                                  backgroundColor: 'rgba(var(--color-shadow-rgb), 0.25)',
                                  boxShadow: 'none',
                                  overflow: 'hidden',
                                }}
                              >
                                <Box
                                  sx={{
                                    p: 1.25,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 2,
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                    '&:hover': { backgroundColor: 'rgba(var(--color-sheet-rgb), 0.35)' },
                                  }}
                                  onClick={() => setPricePromoTopSavingGroupExpanded((prev) => {
                                    const next = new Set(prev);
                                    if (next.has(group.key)) next.delete(group.key); else next.add(group.key);
                                    return next;
                                  })}
                                >
                                  <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                                        {group.projectName}
                                      </Typography>
                                      <Chip
                                        label={`${group.units.length} units`}
                                        size="small"
                                        sx={{
                                          height: 18,
                                          fontSize: '0.65rem',
                                          fontWeight: 700,
                                          bgcolor: 'rgba(var(--color-success-rgb, 76, 175, 80), 0.15)',
                                          color: 'var(--color-success)',
                                        }}
                                      />
                                    </Box>
                                    <Typography variant="caption" sx={{ color: 'var(--color-success)', fontWeight: 600, display: 'block' }}>
                                      {group.priceChange < 0 ? '-' : ''}${Math.abs(group.priceChange).toLocaleString()}
                                      {group.priceChangePercent ? ` (${group.priceChangePercent.toFixed(1)}%)` : ''}
                                    </Typography>
                                    {group.priceChangeAt && (
                                      <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.5)', display: 'block' }}>
                                        {formatPricePromoDate(group.priceChangeAt)}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5, flexShrink: 0 }}>
                                    <Chip
                                      icon={<LocalOfferIcon sx={{ fontSize: 14 }} />}
                                      label="PRICE PROMO"
                                      size="small"
                                      sx={{
                                        bgcolor: 'rgba(var(--color-success-rgb, 76, 175, 80), 0.15)',
                                        color: 'var(--color-success)',
                                        fontWeight: 700,
                                      }}
                                    />
                                    <ExpandMoreIcon
                                      sx={{
                                        color: 'rgba(var(--color-text-rgb), 0.5)',
                                        fontSize: 18,
                                        transform: isGroupOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.2s ease',
                                      }}
                                    />
                                  </Box>
                                </Box>
                                <Collapse in={isGroupOpen} timeout="auto" unmountOnExit>
                                  <Box sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
                                    {group.units.map((item: PricePromoUnit, idx: number) => (
                                      <Box
                                        key={item.id}
                                        onClick={() => handlePricePromoUnitClick(item, 'price_promo_units', 'top_saving')}
                                        sx={{
                                          px: 1.25,
                                          py: 0.75,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: 2,
                                          cursor: 'pointer',
                                          borderTop: idx > 0 ? '1px solid rgba(var(--color-text-rgb), 0.06)' : 'none',
                                          '&:hover': { bgcolor: 'rgba(var(--color-sheet-rgb), 0.35)' },
                                        }}
                                      >
                                        <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                                          Unit {item.UnitNumber} &middot; {pricePromoBedroomLabel(item)} &middot; {formatThumbsupUnitSqft(item.size)}
                                        </Typography>
                                        <PricePromoPriceButton
                                          priceLabel={`$${Math.round(item.price).toLocaleString()}`}
                                          showChip={false}
                                          onClick={() => handleOpenPriceChart(item.id, 'price', true, 'price_promo_top_saving', item.bedroomNumber)}
                                          onShareClick={canUsePricePromoShareTools
                                            ? () => handleOpenPriceChart(item.id, 'price', true, 'price_promo_top_saving_share', item.bedroomNumber, 'share')
                                            : undefined}
                                        />
                                      </Box>
                                    ))}
                                  </Box>
                                </Collapse>
                              </Card>
                            );
                          })}
                        </Stack>
                      )}
                    </Box>
                  </Collapse>
                </Box>

                {/* All Price Promo */}
                <Box
                  sx={{
                    borderRadius: 2.5,
                    border: '1px solid rgba(var(--color-text-rgb), 0.15)',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    onClick={() => setPricePromoAllExpanded((v) => !v)}
                    sx={{
                      px: 1.5,
                      py: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1,
                      cursor: 'pointer',
                      bgcolor: 'rgba(var(--color-shadow-rgb), 0.2)',
                      '&:hover': { bgcolor: 'rgba(var(--color-sheet-rgb), 0.25)' },
                    }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                        All Price Promo
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)', display: 'block' }}>
                        {pricePromoAllGroups.length} project{pricePromoAllGroups.length === 1 ? '' : 's'}
                      </Typography>
                    </Box>
                    <ExpandMoreIcon
                      sx={{
                        color: 'var(--color-text-strong)',
                        transform: pricePromoAllExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease',
                      }}
                    />
                  </Box>
                  <Collapse in={pricePromoAllExpanded} timeout="auto" unmountOnExit>
                    <Box sx={{ px: 1.25, py: 1.25 }}>
                      {pricePromoAllGroups.length === 0 ? (
                        <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                          No projects match your filters.
                        </Typography>
                      ) : (
                        <Stack spacing={1}>
                          {pricePromoAllGroups.map((group) => (
                            <Accordion
                              key={`all-${group.projectId}`}
                              disableGutters
                              sx={{
                                borderRadius: 2,
                                border: '1px solid rgba(var(--color-text-rgb), 0.15)',
                                bgcolor: 'rgba(var(--color-shadow-rgb), 0.2)',
                                '&:before': { display: 'none' },
                                overflow: 'hidden',
                              }}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ color: 'var(--color-text-strong)' }} />}
                                sx={{
                                  px: 1.5,
                                  py: 1,
                                  minHeight: 48,
                                  '& .MuiAccordionSummary-content': { my: 1, alignItems: 'center' },
                                  '&:hover': { bgcolor: 'rgba(var(--color-sheet-rgb), 0.25)' },
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 1, gap: 1, minWidth: 0 }}>
                                  <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                      <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'var(--color-text-strong)' }}>
                                        {group.projectName}
                                      </Typography>
                                      {group.isLive === 1 && (
                                        <Chip
                                          label="LIVE"
                                          size="small"
                                          sx={{
                                            height: 18,
                                            fontSize: 10,
                                            fontWeight: 700,
                                            bgcolor: 'rgba(244, 67, 54, 0.15)',
                                            color: '#f44336',
                                            flexShrink: 0,
                                          }}
                                        />
                                      )}
                                    </Box>
                                    <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.55)', display: 'block' }}>
                                      {group.units.length} price promo unit{group.units.length === 1 ? '' : 's'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails sx={{ px: 1.5, pt: 0, pb: 1.5, bgcolor: 'rgba(var(--color-shadow-rgb), 0.12)' }}>
                                <Stack spacing={1}>
                                  {group.units.map((item) => {
                                    const isBest = pricePromoBestByStackBedroom.has(item.id);
                                    return (
                                      <Card
                                        key={`all-${item.ProjectId}-${item.id}`}
                                        variant="outlined"
                                        sx={{
                                          borderRadius: 2,
                                          border: isBest ? '2px solid var(--color-success)' : '1px solid rgba(var(--color-text-rgb), 0.12)',
                                          backgroundColor: 'rgba(var(--color-shadow-rgb), 0.25)',
                                          boxShadow: 'none',
                                          cursor: 'pointer',
                                          transition: 'all 0.2s ease',
                                          '&:hover': {
                                            borderColor: isBest ? 'var(--color-success)' : 'var(--color-info-navy)',
                                            backgroundColor: 'rgba(var(--color-sheet-rgb), 0.35)',
                                          },
                                        }}
                                        onClick={() => handlePricePromoUnitClick(item, 'price_promo_units', 'all')}
                                      >
                                        <Box sx={{ p: 1.25, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                                          <Box sx={{ minWidth: 0 }}>
                                            <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.85)' }}>
                                              Unit {item.UnitNumber} &middot; {pricePromoBedroomLabel(item)} &middot; {formatThumbsupUnitSqft(item.size)}
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: 'var(--color-success)', fontWeight: 600, display: 'block' }}>
                                              {item.priceChange < 0 ? '-' : ''}${Math.abs(item.priceChange).toLocaleString()}
                                              {item.priceChangePercent ? ` (${item.priceChangePercent.toFixed(1)}%)` : ''}
                                            </Typography>
                                            {item.priceChangeAt && (
                                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.5)', display: 'block' }}>
                                                {formatPricePromoDate(item.priceChangeAt)}
                                              </Typography>
                                            )}
                                          </Box>
                                          <PricePromoPriceButton
                                            priceLabel={`$${Math.round(item.price).toLocaleString()}`}
                                            onClick={() => handleOpenPriceChart(item.id, 'price', true, 'price_promo_all', item.bedroomNumber)}
                                            onShareClick={canUsePricePromoShareTools
                                              ? () => handleOpenPriceChart(item.id, 'price', true, 'price_promo_all_share', item.bedroomNumber, 'share')
                                              : undefined}
                                          />
                                        </Box>
                                      </Card>
                                    );
                                  })}
                                </Stack>
                              </AccordionDetails>
                            </Accordion>
                          ))}
                        </Stack>
                      )}
                    </Box>
                  </Collapse>
                </Box>
              </Stack>
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)', gap: 1, justifyContent: 'space-between' }}>
            {canUsePricePromoShareTools ? (
              <Button
                onClick={() => setBestPricePromoOpen(true)}
                disabled={bestPricePromoRows.length === 0}
                variant="contained"
                startIcon={<IosShareIcon />}
                sx={{
                  bgcolor: 'var(--color-info-navy)',
                  color: '#fff',
                  fontWeight: 700,
                  textTransform: 'none',
                  '&:hover': { bgcolor: 'var(--color-info-navy)', filter: 'brightness(1.15)' },
                }}
              >
                Share Best Promo
              </Button>
            ) : (
              <Box />
            )}
            <Button
              onClick={() => {
                setPricePromoDialogOpen(false);
                setPricePromoProjectSearch('');
                setPricePromoBedroomFilter([]);
              }}
              sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <BestPricePromoShareDialog
          open={bestPricePromoOpen}
          onClose={() => setBestPricePromoOpen(false)}
          rows={bestPricePromoRows}
          agentLine={promoAgentLine}
          agencyLine={PROMO_AGENCY_LINE}
          filterNote={bestPricePromoFilterNote}
          ceaNumber={userInfo?.CEANumber}
        />

        <PricePromoWatchlistDialog
          open={pricePromoWatchlistDialogOpen}
          onClose={() => setPricePromoWatchlistDialogOpen(false)}
          tab={pricePromoWatchlistTab}
          onTabChange={setPricePromoWatchlistTab}
          anticipate={{
            items: anticipatePromos,
            loading: anticipatePromosLoading,
            error: anticipatePromosError,
            canCreate: anticipateCanCreate,
            manageableProjects: anticipateManageableProjects,
            unseenIds: unseenAnticipateIds,
            defaultInterest: {
              cea: userInfo?.CEANumber || '',
              name: userInfo?.Name || '',
              mobile: userInfo?.Mobile || '',
            },
            onCreate: handleAnticipateCreate,
            onUpdate: handleAnticipateUpdate,
            onTakeDown: handleAnticipateTakeDown,
            onRegisterInterest: handleAnticipateRegisterInterest,
            onFetchInterests: handleFetchAnticipateInterests,
            onViewed: handleAnticipateViewed,
          }}
          anticipateNewCount={unseenAnticipateIds.size}
          units={pricePromoUnits}
          watchlists={pricePromoWatchlists}
          loading={pricePromoWatchlistLoading}
          error={pricePromoWatchlistError}
          limit={10}
          newMatchWatchlistIds={pricePromoWatchlistNewMatchIds}
          onCreate={handlePricePromoWatchlistCreate}
          onUpdate={handlePricePromoWatchlistUpdate}
          onDelete={handlePricePromoWatchlistDelete}
          onMarkSeen={handlePricePromoWatchlistSeen}
          formatSqft={formatThumbsupUnitSqft}
          onUnitClick={(unit) => {
            setPricePromoWatchlistDialogOpen(false);
            handlePricePromoUnitClick(unit, 'price_promo_watchlist');
          }}
          onPriceClick={(unit) => handleOpenPriceChart(unit.id, 'price', true, 'price_promo_watchlist', unit.bedroomNumber)}
        />

        <SuperShowcaseDialog
          open={superShowcaseDialogOpen}
          onClose={() => setSuperShowcaseDialogOpen(false)}
          showcases={superShowcases}
          loading={superShowcasesLoading}
          error={superShowcasesError}
          onRefresh={fetchSuperShowcases}
          onHotspotAction={handleSuperShowcaseHotspot}
          onProjectResearchOpenChange={setSuperShowcaseResultsOpen}
          initialShowcaseId={initialShowcaseId}
          onInitialShowcaseHandled={clearInitialShowcaseId}
          onShowcaseShared={(showcase, method, source) => logSuperShowcaseShared({
            showcaseId: showcase.id,
            title: showcase.title,
            method,
            source,
            ceaNumber: userInfo?.CEANumber || getDevCea(),
          })}
          renderProjectResearchCriteria={renderMasterToolSearchCriteria}
          projectResearchFilters={masterToolFilters}
          renderProjectResearchResults={() => (
            masterToolLoading || masterToolResults.length > 0 || masterToolTotalMatchedUnits > 0
              ? renderMasterToolResults()
              : (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'var(--color-text-strong)' }}>
                    Nothing matches this area right now
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'var(--color-text-muted)' }}>
                    Inventory moves daily — it is worth checking back.
                  </Typography>
                </Box>
              )
          )}
          onShowcaseViewed={(showcase) => logSuperShowcaseViewed({
            showcaseId: showcase.id,
            title: showcase.title,
            hotspotCount: showcase.hotspots.length,
            ceaNumber: userInfo?.CEANumber || getDevCea(),
          })}
        />
        <RegionMarketComparisonDialog
          open={regionMarket != null}
          region={regionMarket}
          onClose={() => setRegionMarket(null)}
        />

        {canAccessSitemap3d && (
          <Sitemap3dDialog
            open={sitemap3dDialogOpen}
            onClose={() => setSitemap3dDialogOpen(false)}
            canView3d={canAccessSitePlan3d}
            canView3dSun={canAccessSitePlan3dSun}
            isAdminUser={isAdminUser}
          />
        )}

        {isAdminUser && (
          <Dialog
            open={institutionPowerOpen}
            onClose={() => setInstitutionPowerOpen(false)}
            maxWidth="lg"
            fullWidth
          >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              Institution Power
              <IconButton onClick={() => setInstitutionPowerOpen(false)} size="small">
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Box
                component="img"
                src={INSTITUTION_POWER_IMAGE_URL}
                alt="Huttons Institution Power"
                sx={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </DialogContent>
          </Dialog>
        )}

        {isAdminUser && manage3dSitemapOpen && (
          <Manage3dSitemapDialog
            open={manage3dSitemapOpen}
            onClose={() => setManage3dSitemapOpen(false)}
          />
        )}

        {isAdminUser && manageDroneViewOpen && (
          <ManageDroneViewDialog
            open={manageDroneViewOpen}
            onClose={() => setManageDroneViewOpen(false)}
          />
        )}

        {manageFloorPlanNorthOpen && isAdminUser && (
          <ManageFloorPlanNorthDialog
            open={manageFloorPlanNorthOpen}
            onClose={() => setManageFloorPlanNorthOpen(false)}
          />
        )}

        {isAdminUser && (
          <ManageSuperShowcaseDialog
            open={manageSuperShowcaseOpen}
            onClose={() => setManageSuperShowcaseOpen(false)}
            districtOptions={masterToolDistrictOptions}
            projectCategoryOptions={masterToolProjectCategoryList}
            onShowcasesChanged={fetchSuperShowcases}
          />
        )}

        <Dialog
          open={shortlistRemarkOpen}
          onClose={resetShortlistRemarkDialog}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
            },
          }}
        >
          <DialogTitle sx={{ pb: 1, color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
            <Typography variant="h6" fontWeight={700} sx={{ color: 'inherit' }}>
              {shortlistRemarkMode === 'edit' ? 'Edit Remark' : 'Add to Shortlist'}
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
              {shortlistRemarkUnitLabel}
            </Typography>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: 'var(--color-surface)',
              borderColor: 'rgba(var(--color-text-rgb), 0.08)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              '& .MuiOutlinedInput-root': {
                color: 'rgba(var(--color-text-rgb), 0.9)',
                '& fieldset': { borderColor: 'rgba(var(--color-text-rgb), 0.23)' },
                '&:hover fieldset': { borderColor: 'rgba(var(--color-text-rgb), 0.4)' },
                '&.Mui-focused fieldset': { borderColor: 'var(--color-info-navy)' },
              },
              '& .MuiInputLabel-root': { color: 'rgba(var(--color-text-rgb), 0.7)' },
            }}
          >
            {shortlistRemarkUnitFloorplan && (
              <Box
                component="img"
                src={shortlistRemarkUnitFloorplan}
                alt={`${shortlistRemarkUnitLabel} floor plan`}
                sx={{
                  width: '100%',
                  height: 160,
                  objectFit: 'cover',
                  borderRadius: 2,
                  mb: 2,
                  border: '1px solid rgba(var(--color-text-rgb), 0.15)',
                }}
              />
            )}
            <TextField
              label="Remark (optional)"
              placeholder="Add a quick note for this unit"
              multiline
              minRows={3}
              fullWidth
              value={shortlistRemarkText}
              onChange={(e) => setShortlistRemarkText(e.target.value)}
            />
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Button onClick={resetShortlistRemarkDialog} sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleConfirmShortlistRemark}
              disabled={(shortlistRemarkMode === 'add' && !shortlistRemarkUnitId) ||
                (shortlistRemarkMode === 'edit' && !shortlistRemarkItemId) ||
                shortlistUpdatingUnitId === shortlistRemarkUnitId}
            >
              {shortlistRemarkMode === 'edit' ? 'Save Changes' : 'Save to Shortlist'}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={shortlistDeleteConfirmOpen}
          onClose={handleCancelShortlistDelete}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: 3 } }}
        >
          <DialogTitle sx={{ pb: 1 }}>
            <Typography variant="h6" fontWeight={700}>
              Remove from Shortlist?
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {shortlistDeleteTarget
                ? `${shortlistDeleteTarget.projectName || shortlistDeleteTarget.projectId || 'Project'} ${shortlistDeleteTarget.unitNumber || ''}`
                : 'Selected unit'}
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="body2" color="text.secondary">
              This will remove the unit from your shortlist. You can add it again anytime.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancelShortlistDelete}>Cancel</Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleConfirmShortlistDelete}
            >
              Remove
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={heatBarInfoOpen}
          onClose={() => setHeatBarInfoOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Buyer Interest Heat Bar</DialogTitle>
          <DialogContent dividers>
            <Typography variant="body2" sx={{ mb: 2 }}>
              The heat bar shows how strong buyer interest is for this unit, based on percentile ranking:
            </Typography>
            <Stack spacing={1.5}>
              <Typography variant="body2">
                4 bars: Top 25% of buyer interest for its unit.
              </Typography>
              <Typography variant="body2">
                3 bars: Around the 50th percentile (middle of the pack).
              </Typography>
              <Typography variant="body2">
                2 bars: Bottom 25% of buyer interest.
              </Typography>
              <Typography variant="body2">
                No red bars: No recorded interest for this unit.
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setHeatBarInfoOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={financialParametersOpen}
          onClose={() => setFinancialParametersOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
            },
          }}
        >
          <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
            Financial Parameters
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: 'var(--color-surface)',
              borderColor: 'rgba(var(--color-text-rgb), 0.08)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              '& .MuiOutlinedInput-root': {
                color: 'rgba(var(--color-text-rgb), 0.9)',
                '& fieldset': { borderColor: 'rgba(var(--color-text-rgb), 0.23)' },
                '&:hover fieldset': { borderColor: 'rgba(var(--color-text-rgb), 0.4)' },
                '&.Mui-focused fieldset': { borderColor: 'var(--color-info-navy)' },
              },
              '& .MuiInputLabel-root': { color: 'rgba(var(--color-text-rgb), 0.7)' },
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Loan to Value (%)"
                  type="number"
                  value={loanToValueInput}
                  onChange={(e) => setLoanToValueInput(e.target.value)}
                  onBlur={() => {
                    const trimmed = loanToValueInput.trim();
                    if (trimmed === '') {
                      setLoanToValue(75);
                      setLoanToValueInput('75');
                      return;
                    }
                    const parsed = parseFloat(trimmed);
                    if (!Number.isFinite(parsed)) {
                      setLoanToValueInput(String(loanToValue));
                      return;
                    }
                    const clamped = Math.max(0, Math.min(100, parsed));
                    setLoanToValue(clamped);
                    setLoanToValueInput(String(clamped));
                  }}
                  inputProps={{ min: 0, max: 100 }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Loan Tenure (Years)"
                  type="number"
                  value={tenureYearsInput}
                  onChange={(e) => setTenureYearsInput(e.target.value)}
                  onBlur={() => {
                    const trimmedValue = tenureYearsInput.trim();
                    if (trimmedValue === '') {
                      setTenureYears(30);
                      setTenureYearsInput('30');
                      return;
                    }
                    const parsedValue = parseInt(trimmedValue, 10);
                    if (!Number.isFinite(parsedValue)) {
                      setTenureYearsInput(String(tenureYears));
                      return;
                    }
                    const normalizedValue = Math.max(1, parsedValue);
                    setTenureYears(normalizedValue);
                    setTenureYearsInput(String(normalizedValue));
                  }}
                  inputProps={{ min: 1 }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="BUC Interest (%)"
                  type="number"
                  value={interestRateInput}
                  onChange={(e) => {
                    setInterestRateInput(e.target.value);
                  }}
                  onBlur={() => {
                    const trimmedValue = interestRateInput.trim();
                    if (trimmedValue === '') {
                      setInterestRate(1.55);
                      setInterestRateInput('1.55');
                      return;
                    }

                    const parsedValue = Number(trimmedValue);
                    if (!Number.isFinite(parsedValue)) {
                      setInterestRateInput(String(interestRate));
                      return;
                    }

                    const normalizedValue = Math.max(0, parsedValue);
                    setInterestRate(normalizedValue);
                    setInterestRateInput(String(normalizedValue));
                  }}
                  inputProps={{ min: 0, step: 0.01 }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => {
                    // Apply modal financial params to state so comparison outlay/installment update
                    const ltvTrimmed = loanToValueInput.trim();
                    const ltv = ltvTrimmed === '' ? 75 : Math.max(0, Math.min(100, parseFloat(ltvTrimmed) || 75));
                    setLoanToValue(ltv);
                    setLoanToValueInput(String(ltv));

                    const tenureTrimmed = tenureYearsInput.trim();
                    const tenure = tenureTrimmed === '' ? 30 : Math.max(1, parseInt(tenureTrimmed, 10) || 30);
                    setTenureYears(tenure);
                    setTenureYearsInput(String(tenure));

                    const rateTrimmed = interestRateInput.trim();
                    const rate = rateTrimmed === '' ? 1.55 : Math.max(0, parseFloat(rateTrimmed) || 1.55);
                    setInterestRate(rate);
                    setInterestRateInput(String(rate));

                    void handleSearch();
                  }}
                  disabled={loading}
                  sx={{ py: 1.5, borderColor: 'rgba(var(--color-text-rgb), 0.5)', color: 'rgba(var(--color-text-rgb), 0.9)' }}
                >
                  Recalculate
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Button onClick={() => setFinancialParametersOpen(false)} sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={projectSyncSettingsOpen}
          onClose={() => setProjectSyncSettingsOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
            },
          }}
        >
          <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="h6" component="span" sx={{ color: 'inherit' }}>
                Project Sync Setting
              </Typography>
              <IconButton size="small" onClick={() => setProjectSyncSettingsOpen(false)} sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: 'var(--color-surface)',
              borderColor: 'rgba(var(--color-text-rgb), 0.08)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              '& .MuiOutlinedInput-root': {
                color: 'rgba(var(--color-text-rgb), 0.9)',
                '& fieldset': { borderColor: 'rgba(var(--color-text-rgb), 0.23)' },
                '&:hover fieldset': { borderColor: 'rgba(var(--color-text-rgb), 0.4)' },
                '&.Mui-focused fieldset': { borderColor: 'var(--color-info-navy)' },
              },
              '& .MuiInputLabel-root': { color: 'rgba(var(--color-text-rgb), 0.7)' },
              '& .MuiInputBase-input::placeholder': { color: 'rgba(var(--color-text-rgb), 0.5)' },
              '& .MuiTableRow-root:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.05)' },
              '& .MuiTableCell-root': { color: 'rgba(var(--color-text-rgb), 0.9)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' },
              '& .MuiTableHead-root .MuiTableCell-head': { zIndex: 2 },
              '& .MuiTablePagination-root': { color: 'rgba(var(--color-text-rgb), 0.9)' },
              '& .MuiTablePagination-selectIcon': { color: 'rgba(var(--color-text-rgb), 0.7)' },
            }}
          >
            {projectSyncSettingsLoading && <LinearProgress sx={{ mb: 2, '& .MuiLinearProgress-bar': { bgcolor: 'var(--color-info-navy)' }, bgcolor: 'rgba(var(--color-text-rgb), 0.1)' }} />}
            {projectSyncSettingsError && (
              <Alert severity="error" sx={{ mb: 2, bgcolor: 'rgba(var(--color-danger-rgb), 0.15)', color: 'var(--color-chart-2-soft)' }}>
                {projectSyncSettingsError}
              </Alert>
            )}
            <TextField
              fullWidth
              size="small"
              label="Search projects"
              value={projectSyncSettingsQuery}
              onChange={(e) => {
                setProjectSyncSettingsQuery(e.target.value);
                setProjectSyncSettingsPage(0); // Reset to first page when searching
              }}
              sx={{ mb: 2 }}
            />
            {projectSyncSettingsItems.length === 0 && !projectSyncSettingsLoading ? (
              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                No projects available.
              </Typography>
            ) : (
              <>
                <TableContainer sx={{ maxHeight: 'calc(90vh - 320px)' }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, minWidth: 200, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }}>Project Name</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 300, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }}>Spreadsheet ID</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 320, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }}>Price Matrix Sheet ID</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 320, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }}>Index Sheet ID</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 100, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }} align="center">Live status</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 220, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }} align="center">Action</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 180, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }} align="center">Upcoming</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 120, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }} align="center">Show Price Promo</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 120, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }} align="center">Show Facing</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 140, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }} align="center">Show Price in Tower View</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 140, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }} align="center">Show PSF in Tower View</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 120, backgroundColor: 'var(--color-surface)', color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }} align="center">Show VVIP Price</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredAndPaginatedItems.paginated.map((item) => (
                        <TableRow key={item.projectId} hover>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'rgba(var(--color-text-rgb), 0.9)' }}>
                              {item.projectName || item.projectId}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <TextField
                                size="small"
                                fullWidth
                                value={projectSyncSheetIds.has(item.projectId) ? (projectSyncSheetIds.get(item.projectId) || '') : (item.sheetId || '')}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setProjectSyncSheetIds((prev) => {
                                    const next = new Map(prev);
                                    next.set(item.projectId, value);
                                    return next;
                                  });
                                }}
                                placeholder="Enter spreadsheet ID"
                                sx={{ minWidth: 0 }}
                              />
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleProjectSyncSheetConfigSave(
                                  item.projectId,
                                  projectSyncSheetIds.has(item.projectId) ? (projectSyncSheetIds.get(item.projectId) || null) : (item.sheetId || null),
                                  projectSyncPriceMatrixSheetIds.has(item.projectId)
                                    ? (projectSyncPriceMatrixSheetIds.get(item.projectId) || null)
                                    : (item.priceMatrixSheetId || null),
                                  projectSyncIndexSheetIds.has(item.projectId)
                                    ? (projectSyncIndexSheetIds.get(item.projectId) || null)
                                    : (item.indexSheetId || null)
                                )}
                                disabled={projectSyncSettingsSavingId === item.projectId}
                                sx={{ flexShrink: 0, borderColor: 'rgba(var(--color-text-rgb), 0.5)', color: 'rgba(var(--color-text-rgb), 0.9)' }}
                              >
                                {projectSyncSettingsSavingId === item.projectId ? 'Saving...' : 'Save'}
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <TextField
                                size="small"
                                fullWidth
                                value={
                                  projectSyncPriceMatrixSheetIds.has(item.projectId)
                                    ? (projectSyncPriceMatrixSheetIds.get(item.projectId) || '')
                                    : (item.priceMatrixSheetId || '')
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setProjectSyncPriceMatrixSheetIds((prev) => {
                                    const next = new Map(prev);
                                    next.set(item.projectId, value);
                                    return next;
                                  });
                                }}
                                placeholder="Enter price matrix sheet ID"
                                sx={{ minWidth: 0 }}
                              />
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleProjectSyncSheetConfigSave(
                                  item.projectId,
                                  projectSyncSheetIds.has(item.projectId) ? (projectSyncSheetIds.get(item.projectId) || null) : (item.sheetId || null),
                                  projectSyncPriceMatrixSheetIds.has(item.projectId)
                                    ? (projectSyncPriceMatrixSheetIds.get(item.projectId) || null)
                                    : (item.priceMatrixSheetId || null),
                                  projectSyncIndexSheetIds.has(item.projectId)
                                    ? (projectSyncIndexSheetIds.get(item.projectId) || null)
                                    : (item.indexSheetId || null)
                                )}
                                disabled={projectSyncSettingsSavingId === item.projectId}
                                sx={{ flexShrink: 0, borderColor: 'rgba(var(--color-text-rgb), 0.5)', color: 'rgba(var(--color-text-rgb), 0.9)' }}
                              >
                                {projectSyncSettingsSavingId === item.projectId ? 'Saving...' : 'Save'}
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <TextField
                                size="small"
                                fullWidth
                                value={
                                  projectSyncIndexSheetIds.has(item.projectId)
                                    ? (projectSyncIndexSheetIds.get(item.projectId) || '')
                                    : (item.indexSheetId || '')
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setProjectSyncIndexSheetIds((prev) => {
                                    const next = new Map(prev);
                                    next.set(item.projectId, value);
                                    return next;
                                  });
                                }}
                                placeholder="Enter index sheet ID"
                                sx={{ minWidth: 0 }}
                              />
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleProjectSyncSheetConfigSave(
                                  item.projectId,
                                  projectSyncSheetIds.has(item.projectId) ? (projectSyncSheetIds.get(item.projectId) || null) : (item.sheetId || null),
                                  projectSyncPriceMatrixSheetIds.has(item.projectId)
                                    ? (projectSyncPriceMatrixSheetIds.get(item.projectId) || null)
                                    : (item.priceMatrixSheetId || null),
                                  projectSyncIndexSheetIds.has(item.projectId)
                                    ? (projectSyncIndexSheetIds.get(item.projectId) || null)
                                    : (item.indexSheetId || null)
                                )}
                                disabled={projectSyncSettingsSavingId === item.projectId}
                                sx={{ flexShrink: 0, borderColor: 'rgba(var(--color-text-rgb), 0.5)', color: 'rgba(var(--color-text-rgb), 0.9)' }}
                              >
                                {projectSyncSettingsSavingId === item.projectId ? 'Saving...' : 'Save'}
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell align="center">
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                              <Switch
                                checked={item.liveStatus === true}
                                onChange={(e) => handleProjectSyncLiveStatusToggle(item.projectId, e.target.checked)}
                                disabled={projectSyncSettingsLiveStatusSavingId === item.projectId}
                                size="small"
                                sx={{
                                  '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--color-accent)' },
                                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: 'rgba(var(--color-accent-rgb), 0.5)' },
                                  '& .MuiSwitch-track': { bgcolor: 'rgba(var(--color-text-rgb), 0.2)' },
                                  '& .MuiSwitch-thumb': { color: 'rgba(var(--color-text-rgb), 0.9)' },
                                }}
                              />
                              {projectSyncSettingsLiveStatusSavingId === item.projectId && (
                                <CircularProgress size={18} sx={{ position: 'absolute', top: '50%', left: '50%', mt: '-9px', ml: '-9px', color: 'var(--color-accent)' }} />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell align="center">
                            <Stack direction="row" spacing={1} justifyContent="center" alignItems="stretch" flexWrap="nowrap">
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleProjectSyncImport(item.projectId)}
                                disabled={projectSyncSettingsImportingId === item.projectId || !item.sheetId}
                                sx={{
                                  flexDirection: 'column',
                                  py: 0.5,
                                  '& .MuiButton-label': { flexDirection: 'column', alignItems: 'center' },
                                }}
                              >
                                <span>{projectSyncSettingsImportingId === item.projectId ? 'Importing...' : 'Import Client'}</span>
                                {item.importChoiceUnitAt && (
                                  <Typography component="span" sx={{ fontSize: '0.65rem', opacity: 0.9, lineHeight: 1.2 }}>
                                    {new Date(item.importChoiceUnitAt).toLocaleString()}
                                  </Typography>
                                )}
                              </Button>
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleProjectSyncImportPrice(item.projectId)}
                                disabled={projectSyncSettingsImportingPriceId === item.projectId || !item.sheetId}
                                sx={{
                                  flexDirection: 'column',
                                  py: 0.5,
                                  bgcolor: 'var(--color-warning)',
                                  color: '#fff',
                                  '& .MuiButton-label': { flexDirection: 'column', alignItems: 'center' },
                                  '&:hover': { bgcolor: 'var(--color-warning-strong)', color: '#fff' },
                                  '&.Mui-disabled': { bgcolor: 'rgba(var(--color-warning-rgb), 0.35)', color: 'rgba(255,255,255,0.7)' },
                                }}
                              >
                                <span>{projectSyncSettingsImportingPriceId === item.projectId ? 'Importing...' : 'Import Price'}</span>
                                {item.importPriceAt && (
                                  <Typography component="span" sx={{ fontSize: '0.65rem', opacity: 0.9, lineHeight: 1.2 }}>
                                    {new Date(item.importPriceAt).toLocaleString()}
                                  </Typography>
                                )}
                              </Button>
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleProjectSyncImportMaster(item.projectId)}
                                disabled={projectSyncSettingsImportingMasterId === item.projectId || !item.sheetId}
                                sx={{
                                  flexDirection: 'column',
                                  py: 0.5,
                                  bgcolor: 'var(--color-accent)',
                                  color: '#fff',
                                  '& .MuiButton-label': { flexDirection: 'column', alignItems: 'center' },
                                  '&:hover': { bgcolor: 'var(--color-accent-strong)', color: '#fff' },
                                  '&.Mui-disabled': { bgcolor: 'rgba(var(--color-accent-rgb), 0.35)', color: 'rgba(255,255,255,0.7)' },
                                }}
                              >
                                <span>{projectSyncSettingsImportingMasterId === item.projectId ? 'Importing...' : 'Import Master Sheet'}</span>
                                {item.importMasterAt && (
                                  <Typography component="span" sx={{ fontSize: '0.65rem', opacity: 0.9, lineHeight: 1.2 }}>
                                    {new Date(item.importMasterAt).toLocaleString()}
                                  </Typography>
                                )}
                              </Button>
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleProjectSyncImportIndex(item.projectId)}
                                disabled={projectSyncSettingsImportingIndexId === item.projectId || !item.indexSheetId}
                                sx={{
                                  flexDirection: 'column',
                                  py: 0.5,
                                  bgcolor: 'var(--color-info-navy)',
                                  color: '#fff',
                                  '& .MuiButton-label': { flexDirection: 'column', alignItems: 'center' },
                                  '&:hover': { bgcolor: 'var(--color-info-navy)', color: '#fff', filter: 'brightness(1.1)' },
                                  '&.Mui-disabled': { bgcolor: 'rgba(var(--color-text-rgb), 0.2)', color: 'rgba(255,255,255,0.7)' },
                                }}
                              >
                                <span>{projectSyncSettingsImportingIndexId === item.projectId ? 'Importing...' : 'Import Index Sheet'}</span>
                                {item.importIndexAt && (
                                  <Typography component="span" sx={{ fontSize: '0.65rem', opacity: 0.9, lineHeight: 1.2 }}>
                                    {new Date(item.importIndexAt).toLocaleString()}
                                  </Typography>
                                )}
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell align="center">
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                              <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                <Switch
                                  checked={projectSyncUpcoming.has(item.projectId) ? projectSyncUpcoming.get(item.projectId)! : (item.upcoming === true)}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setProjectSyncUpcoming((prev) => {
                                      const next = new Map(prev);
                                      next.set(item.projectId, checked);
                                      return next;
                                    });
                                    const seqVal = projectSyncUpcomingSeq.has(item.projectId) ? projectSyncUpcomingSeq.get(item.projectId)! : (item.upcomingSeq != null ? String(item.upcomingSeq) : '');
                                    const seqNum = seqVal.trim() === '' ? null : parseInt(seqVal, 10);
                                    handleProjectSyncUpcomingSave(item.projectId, checked, Number.isFinite(seqNum) ? seqNum : null);
                                  }}
                                  disabled={projectSyncSettingsUpcomingSavingId === item.projectId}
                                  size="small"
                                  sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--color-accent)' },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: 'rgba(var(--color-accent-rgb), 0.5)' },
                                    '& .MuiSwitch-track': { bgcolor: 'rgba(var(--color-text-rgb), 0.2)' },
                                    '& .MuiSwitch-thumb': { color: 'rgba(var(--color-text-rgb), 0.9)' },
                                  }}
                                />
                                {projectSyncSettingsUpcomingSavingId === item.projectId && (
                                  <CircularProgress size={18} sx={{ position: 'absolute', top: '50%', left: '50%', mt: '-9px', ml: '-9px', color: 'var(--color-accent)' }} />
                                )}
                              </Box>
                              <TextField
                                size="small"
                                type="number"
                                value={projectSyncUpcomingSeq.has(item.projectId) ? projectSyncUpcomingSeq.get(item.projectId)! : (item.upcomingSeq != null ? String(item.upcomingSeq) : '')}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setProjectSyncUpcomingSeq((prev) => {
                                    const next = new Map(prev);
                                    next.set(item.projectId, value);
                                    return next;
                                  });
                                }}
                                onBlur={() => {
                                  const seqVal = projectSyncUpcomingSeq.has(item.projectId) ? projectSyncUpcomingSeq.get(item.projectId)! : (item.upcomingSeq != null ? String(item.upcomingSeq) : '');
                                  const seqNum = seqVal.trim() === '' ? null : parseInt(seqVal, 10);
                                  const upcoming = projectSyncUpcoming.has(item.projectId) ? projectSyncUpcoming.get(item.projectId)! : (item.upcoming === true);
                                  handleProjectSyncUpcomingSave(item.projectId, upcoming, Number.isFinite(seqNum) ? seqNum : null);
                                }}
                                placeholder="Seq"
                                sx={{ width: 72, minWidth: 72 }}
                                inputProps={{ min: 0, step: 1 }}
                              />
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                  const upcoming = projectSyncUpcoming.has(item.projectId) ? projectSyncUpcoming.get(item.projectId)! : (item.upcoming === true);
                                  const seqVal = projectSyncUpcomingSeq.has(item.projectId) ? projectSyncUpcomingSeq.get(item.projectId)! : (item.upcomingSeq != null ? String(item.upcomingSeq) : '');
                                  const seqNum = seqVal.trim() === '' ? null : parseInt(seqVal, 10);
                                  handleProjectSyncUpcomingSave(item.projectId, upcoming, Number.isFinite(seqNum) ? seqNum : null);
                                }}
                                disabled={projectSyncSettingsUpcomingSavingId === item.projectId}
                                sx={{ flexShrink: 0, borderColor: 'rgba(var(--color-text-rgb), 0.5)', color: 'rgba(var(--color-text-rgb), 0.9)' }}
                              >
                                {projectSyncSettingsUpcomingSavingId === item.projectId ? 'Saving...' : 'Save'}
                              </Button>
                            </Stack>
                          </TableCell>
                          <TableCell align="center">
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                              <Switch
                                checked={item.showPricePromo !== false}
                                onChange={(e) => handleProjectSyncShowPricePromoToggle(item.projectId, e.target.checked)}
                                disabled={projectSyncSettingsShowPricePromoSavingId === item.projectId}
                                size="small"
                                sx={{
                                  '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--color-accent)' },
                                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: 'rgba(var(--color-accent-rgb), 0.5)' },
                                  '& .MuiSwitch-track': { bgcolor: 'rgba(var(--color-text-rgb), 0.2)' },
                                  '& .MuiSwitch-thumb': { color: 'rgba(var(--color-text-rgb), 0.9)' },
                                }}
                              />
                              {projectSyncSettingsShowPricePromoSavingId === item.projectId && (
                                <CircularProgress size={18} sx={{ position: 'absolute', top: '50%', left: '50%', mt: '-9px', ml: '-9px', color: 'var(--color-accent)' }} />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell align="center">
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                              <Switch
                                checked={item.showFacing === true}
                                onChange={(e) => handleProjectSyncShowFacingToggle(item.projectId, e.target.checked)}
                                disabled={projectSyncSettingsShowFacingSavingId === item.projectId}
                                size="small"
                                sx={{
                                  '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--color-accent)' },
                                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: 'rgba(var(--color-accent-rgb), 0.5)' },
                                  '& .MuiSwitch-track': { bgcolor: 'rgba(var(--color-text-rgb), 0.2)' },
                                  '& .MuiSwitch-thumb': { color: 'rgba(var(--color-text-rgb), 0.9)' },
                                }}
                              />
                              {projectSyncSettingsShowFacingSavingId === item.projectId && (
                                <CircularProgress size={18} sx={{ position: 'absolute', top: '50%', left: '50%', mt: '-9px', ml: '-9px', color: 'var(--color-accent)' }} />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell align="center">
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                              <Switch
                                checked={item.showPriceInTowerView !== false}
                                onChange={(e) => handleProjectSyncShowPriceInTowerViewToggle(item.projectId, e.target.checked)}
                                disabled={projectSyncSettingsShowPriceInTowerViewSavingId === item.projectId}
                                size="small"
                                sx={{
                                  '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--color-accent)' },
                                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: 'rgba(var(--color-accent-rgb), 0.5)' },
                                  '& .MuiSwitch-track': { bgcolor: 'rgba(var(--color-text-rgb), 0.2)' },
                                  '& .MuiSwitch-thumb': { color: 'rgba(var(--color-text-rgb), 0.9)' },
                                }}
                              />
                              {projectSyncSettingsShowPriceInTowerViewSavingId === item.projectId && (
                                <CircularProgress size={18} sx={{ position: 'absolute', top: '50%', left: '50%', mt: '-9px', ml: '-9px', color: 'var(--color-accent)' }} />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell align="center">
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                              <Switch
                                checked={item.showPsfInTowerView !== false}
                                onChange={(e) => handleProjectSyncShowPsfInTowerViewToggle(item.projectId, e.target.checked)}
                                disabled={projectSyncSettingsShowPsfInTowerViewSavingId === item.projectId}
                                size="small"
                                sx={{
                                  '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--color-accent)' },
                                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: 'rgba(var(--color-accent-rgb), 0.5)' },
                                  '& .MuiSwitch-track': { bgcolor: 'rgba(var(--color-text-rgb), 0.2)' },
                                  '& .MuiSwitch-thumb': { color: 'rgba(var(--color-text-rgb), 0.9)' },
                                }}
                              />
                              {projectSyncSettingsShowPsfInTowerViewSavingId === item.projectId && (
                                <CircularProgress size={18} sx={{ position: 'absolute', top: '50%', left: '50%', mt: '-9px', ml: '-9px', color: 'var(--color-accent)' }} />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell align="center">
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                              <Switch
                                checked={item.showVVIPPrice === true}
                                onChange={(e) => handleProjectSyncShowVVIPPriceToggle(item.projectId, e.target.checked)}
                                disabled={projectSyncSettingsShowVVIPPriceSavingId === item.projectId}
                                size="small"
                                sx={{
                                  '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--color-accent)' },
                                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: 'rgba(var(--color-accent-rgb), 0.5)' },
                                  '& .MuiSwitch-track': { bgcolor: 'rgba(var(--color-text-rgb), 0.2)' },
                                  '& .MuiSwitch-thumb': { color: 'rgba(var(--color-text-rgb), 0.9)' },
                                }}
                              />
                              {projectSyncSettingsShowVVIPPriceSavingId === item.projectId && (
                                <CircularProgress size={18} sx={{ position: 'absolute', top: '50%', left: '50%', mt: '-9px', ml: '-9px', color: 'var(--color-accent)' }} />
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  component="div"
                  count={filteredAndPaginatedItems.filtered.length}
                  page={projectSyncSettingsPage}
                  onPageChange={(_, newPage) => setProjectSyncSettingsPage(newPage)}
                  rowsPerPage={projectSyncSettingsRowsPerPage}
                  onRowsPerPageChange={(e) => {
                    setProjectSyncSettingsRowsPerPage(parseInt(e.target.value, 10));
                    setProjectSyncSettingsPage(0);
                  }}
                  rowsPerPageOptions={[25, 50, 100, 200]}
                  labelRowsPerPage="Rows per page:"
                  sx={{ color: 'rgba(var(--color-text-rgb), 0.9)', '& .MuiTablePagination-select, & .MuiTablePagination-displayedRows': { color: 'rgba(var(--color-text-rgb), 0.9)' }, '& .MuiIconButton-root': { color: 'rgba(var(--color-text-rgb), 0.7)' } }}
                />
              </>
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Button onClick={() => setProjectSyncSettingsOpen(false)} sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Manage Users Dialog */}
        <Dialog
          open={manageUsersOpen}
          onClose={() => setManageUsersOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              bgcolor: 'var(--color-surface)',
              color: 'var(--color-text-strong)',
              minHeight: '60vh',
            },
          }}
        >
          <DialogTitle sx={{ borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            Manage Users
          </DialogTitle>
          <DialogContent sx={{
            bgcolor: 'var(--color-surface)',
            '& .MuiTableCell-root': { color: 'rgba(var(--color-text-rgb), 0.9)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' },
            '& .MuiTableHead-root .MuiTableCell-head': { zIndex: 2 },
            '& .MuiTablePagination-root': { color: 'rgba(var(--color-text-rgb), 0.9)' },
            '& .MuiTablePagination-selectIcon': { color: 'rgba(var(--color-text-rgb), 0.7)' },
          }}>
            {manageUsersLoading && <LinearProgress sx={{ mb: 2, '& .MuiLinearProgress-bar': { bgcolor: 'var(--color-info-navy)' }, bgcolor: 'rgba(var(--color-text-rgb), 0.1)' }} />}
            {manageUsersError && (
              <Alert severity="error" onClose={() => setManageUsersError(null)} sx={{ mb: 2, bgcolor: 'rgba(var(--color-danger-rgb), 0.15)', color: 'var(--color-chart-2-soft)' }}>
                {manageUsersError}
              </Alert>
            )}
            {manageUsersSuccess && (
              <Alert severity="success" onClose={() => setManageUsersSuccess(null)} sx={{ mb: 2 }}>
                {manageUsersSuccess}
              </Alert>
            )}

            {/* Add User Section */}
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2, mt: 1 }}>
              <TextField
                size="small"
                label="CEA Number"
                value={manageUsersAddCea}
                onChange={(e) => setManageUsersAddCea(e.target.value)}
                sx={{ flex: 1 }}
              />
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Role</InputLabel>
                <Select
                  value={manageUsersAddRole}
                  label="Role"
                  onChange={(e) => setManageUsersAddRole(e.target.value)}
                >
                  <MenuItem value="AGENT">AGENT</MenuItem>
                  <MenuItem value="ADMIN">ADMIN</MenuItem>
                  <MenuItem value="ACCELERATOR">ACCELERATOR</MenuItem>
                  <MenuItem value="PROJECT-DEPT">PROJECT-DEPT</MenuItem>
                  <MenuItem value="PICKER-NEARBY-DEAL">PICKER-NEARBY-DEAL</MenuItem>
                  <MenuItem value="AGENT-PRICEPROMO">AGENT-PRICEPROMO</MenuItem>
                  <MenuItem value="SUPER-RATIO">SUPER-RATIO</MenuItem>
                  <MenuItem value="SUPER-MAP">SUPER-MAP</MenuItem>
                  <MenuItem value="MAP-3D">MAP-3D</MenuItem>
                  <MenuItem value="MAP-3DS">MAP-3DS</MenuItem>
                  <MenuItem value="MAP-3DS-THOMSON">MAP-3DS-THOMSON</MenuItem>
                  <MenuItem value="COMM-STRUCTURE">COMM-STRUCTURE</MenuItem>
                  <MenuItem value="ESSENTIAL-ANALYTICS">ESSENTIAL-ANALYTICS</MenuItem>
                  <MenuItem value="VIDEO-APPROVER">VIDEO-APPROVER</MenuItem>
                  <MenuItem value="VIDEO-UPLOADER">VIDEO-UPLOADER</MenuItem>
                </Select>
              </FormControl>
              <Button
                variant="contained"
                size="small"
                onClick={handleAddUser}
                disabled={manageUsersAdding || !manageUsersAddCea.trim()}
                sx={{ bgcolor: 'var(--color-accent)', '&:hover': { bgcolor: 'var(--color-accent-strong)' } }}
              >
                {manageUsersAdding ? 'Adding...' : 'Add User'}
              </Button>
            </Stack>

            <Divider sx={{ mb: 2, borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} />

            {/* Search */}
            <TextField
              fullWidth
              size="small"
              label="Search users"
              value={manageUsersQuery}
              onChange={(e) => {
                setManageUsersQuery(e.target.value);
                setManageUsersPage(0);
              }}
              sx={{ mb: 2 }}
            />

            <Tabs
              value={manageUsersTab}
              onChange={(_, value) => {
                setManageUsersTab(value as ManageUsersTab);
                setManageUsersPage(0);
              }}
              variant="fullWidth"
              sx={{
                mb: 2,
                minHeight: 40,
                borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)',
                '& .MuiTabs-indicator': { backgroundColor: 'var(--color-accent)' },
              }}
            >
              <Tab
                value="pending"
                label={`Pending (${manageUsersBuckets.pending.length})`}
                sx={{ minHeight: 40, color: 'rgba(var(--color-text-rgb), 0.7)', '&.Mui-selected': { color: 'var(--color-accent)' } }}
              />
              <Tab
                value="approved"
                label={`Approved (${manageUsersBuckets.approved.length})`}
                sx={{ minHeight: 40, color: 'rgba(var(--color-text-rgb), 0.7)', '&.Mui-selected': { color: 'var(--color-accent)' } }}
              />
              <Tab
                value="rejected_rejoined"
                label={`Rejected - Rejoined (${manageUsersBuckets.rejected_rejoined.length})`}
                sx={{ minHeight: 40, color: 'rgba(var(--color-text-rgb), 0.7)', '&.Mui-selected': { color: 'var(--color-accent)' } }}
              />
              <Tab
                value="rejected_never"
                label={`Rejected - Never Back (${manageUsersBuckets.rejected_never.length})`}
                sx={{ minHeight: 40, color: 'rgba(var(--color-text-rgb), 0.7)', '&.Mui-selected': { color: 'var(--color-accent)' } }}
              />
            </Tabs>

            {filteredManageUsers.filtered.length === 0 && !manageUsersLoading ? (
              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                No users found in this tab.
              </Typography>
            ) : (
              <>
                <TableContainer>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ bgcolor: 'var(--color-surface)', fontWeight: 'bold' }}>CEA Number</TableCell>
                        <TableCell sx={{ bgcolor: 'var(--color-surface)', fontWeight: 'bold' }}>Name</TableCell>
                        <TableCell sx={{ bgcolor: 'var(--color-surface)', fontWeight: 'bold' }}>Role</TableCell>
                        <TableCell sx={{ bgcolor: 'var(--color-surface)', fontWeight: 'bold' }}>Review</TableCell>
                        <TableCell sx={{ bgcolor: 'var(--color-surface)', fontWeight: 'bold' }}>Created</TableCell>
                        <TableCell sx={{ bgcolor: 'var(--color-surface)', fontWeight: 'bold' }} align="center">Screenshot</TableCell>
                        <TableCell sx={{ bgcolor: 'var(--color-surface)', fontWeight: 'bold' }} align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredManageUsers.paginated.map((user) => (
                        <TableRow key={user.id}>
                          <TableCell>{user.ceaNumber}</TableCell>
                          <TableCell>{user.name || '-'}</TableCell>
                          <TableCell>
                            <Chip
                              label={user.role}
                              size="small"
                              sx={{
                                bgcolor: user.role.toUpperCase() === 'ADMIN'
                                  ? 'rgba(var(--color-accent-rgb), 0.2)'
                                  : 'rgba(var(--color-text-rgb), 0.1)',
                                color: user.role.toUpperCase() === 'ADMIN'
                                  ? 'var(--color-accent)'
                                  : 'rgba(var(--color-text-rgb), 0.8)',
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Stack spacing={0.5} alignItems="flex-start">
                              <Chip
                                label={user.reviewStatus === 'approved' ? 'Approved' : user.reviewStatus === 'rejected' ? 'Rejected' : 'Pending'}
                                size="small"
                                sx={{
                                  bgcolor: user.reviewStatus === 'approved'
                                    ? 'rgba(var(--color-success-rgb), 0.18)'
                                    : user.reviewStatus === 'rejected'
                                      ? 'rgba(var(--color-danger-rgb), 0.18)'
                                      : 'rgba(var(--color-warning-rgb), 0.18)',
                                  color: user.reviewStatus === 'approved'
                                    ? 'var(--color-success)'
                                    : user.reviewStatus === 'rejected'
                                      ? 'var(--color-danger)'
                                      : 'var(--color-warning-strong)',
                                }}
                              />
                              {user.reviewedAt && (
                                <Typography variant="caption">{new Date(user.reviewedAt).toLocaleString()}</Typography>
                              )}
                            </Stack>
                          </TableCell>
                          <TableCell>{user.createdAt ? new Date(user.createdAt).toLocaleDateString() : '-'}</TableCell>
                          <TableCell align="center">
                            <Stack direction="row" spacing={1} justifyContent="center">
                              {user.imgUrl && (
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={() => setManageUsersScreenshotUser(user)}
                                  sx={{ borderColor: 'rgba(var(--color-text-rgb), 0.3)', color: 'rgba(var(--color-text-rgb), 0.9)', fontSize: '0.75rem' }}
                                >
                                  Screenshot
                                </Button>
                              )}
                              {user.reviewStatus === 'pending' && (
                                <>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    color="success"
                                    onClick={() => handleReviewUser(user.ceaNumber, true)}
                                    disabled={manageUsersReviewingCea === user.ceaNumber}
                                    sx={{ fontSize: '0.75rem' }}
                                  >
                                    {manageUsersReviewingCea === user.ceaNumber ? 'Approving...' : 'Approve'}
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    color="warning"
                                    onClick={() => handleReviewUser(user.ceaNumber, false)}
                                    disabled={manageUsersReviewingCea === user.ceaNumber || user.ceaNumber === userInfo?.CEANumber}
                                    sx={{ fontSize: '0.75rem' }}
                                  >
                                    {manageUsersReviewingCea === user.ceaNumber ? 'Rejecting...' : 'Reject'}
                                  </Button>
                                </>
                              )}
                            </Stack>
                          </TableCell>
                          <TableCell align="center">
                            {user.reviewStatus === 'rejected' ? (
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.55)' }}>
                                No actions
                              </Typography>
                            ) : (
                              <Stack direction="row" spacing={1} justifyContent="center">
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={() => handleLogoutUser(user.ceaNumber)}
                                  disabled={manageUsersLoggingOutCea === user.ceaNumber || manageUsersReviewingCea === user.ceaNumber || user.ceaNumber === userInfo?.CEANumber}
                                  sx={{ borderColor: 'rgba(var(--color-text-rgb), 0.3)', color: 'rgba(var(--color-text-rgb), 0.9)', fontSize: '0.75rem' }}
                                >
                                  {manageUsersLoggingOutCea === user.ceaNumber ? 'Logging out...' : 'Logout'}
                                </Button>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  color="error"
                                  onClick={() => handleRevokeUser(user.ceaNumber)}
                                  disabled={manageUsersRevokingCea === user.ceaNumber || manageUsersReviewingCea === user.ceaNumber || user.ceaNumber === userInfo?.CEANumber}
                                  sx={{ fontSize: '0.75rem' }}
                                >
                                  {manageUsersRevokingCea === user.ceaNumber ? 'Revoking...' : 'Revoke'}
                                </Button>
                              </Stack>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  component="div"
                  count={filteredManageUsers.filtered.length}
                  page={manageUsersPage}
                  onPageChange={(_, newPage) => setManageUsersPage(newPage)}
                  rowsPerPage={manageUsersRowsPerPage}
                  onRowsPerPageChange={(e) => {
                    setManageUsersRowsPerPage(parseInt(e.target.value, 10));
                    setManageUsersPage(0);
                  }}
                  rowsPerPageOptions={[25, 50, 100]}
                  labelRowsPerPage="Rows per page:"
                  sx={{ color: 'rgba(var(--color-text-rgb), 0.9)', '& .MuiTablePagination-select, & .MuiTablePagination-displayedRows': { color: 'rgba(var(--color-text-rgb), 0.9)' }, '& .MuiIconButton-root': { color: 'rgba(var(--color-text-rgb), 0.7)' } }}
                />
              </>
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Button onClick={() => setManageUsersOpen(false)} sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Screenshot Preview Dialog */}
        <Dialog
          open={!!manageUsersScreenshotUser}
          onClose={() => setManageUsersScreenshotUser(null)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              bgcolor: 'var(--color-surface)',
              color: 'var(--color-text-strong)',
            },
          }}
        >
          <DialogTitle sx={{ borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            Screenshot {manageUsersScreenshotUser ? `- ${manageUsersScreenshotUser.ceaNumber} ${manageUsersScreenshotUser.name ? `(${manageUsersScreenshotUser.name})` : ''}` : ''}
          </DialogTitle>
          <DialogContent sx={{ bgcolor: 'var(--color-surface)', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 320 }}>
            {manageUsersScreenshotUser?.imgUrl && (
              <Box
                component="img"
                src={manageUsersScreenshotUser.imgUrl}
                alt={`Screenshot for ${manageUsersScreenshotUser.ceaNumber}`}
                sx={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
              />
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)', gap: 1 }}>
            <Button onClick={() => setManageUsersScreenshotUser(null)} sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>
              Close
            </Button>
            {manageUsersScreenshotUser?.reviewStatus === 'pending' && (
              <>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={async () => {
                    if (!manageUsersScreenshotUser) return;
                    await handleReviewUser(manageUsersScreenshotUser.ceaNumber, true);
                    setManageUsersScreenshotUser(null);
                  }}
                  disabled={manageUsersReviewingCea === manageUsersScreenshotUser.ceaNumber}
                  sx={{ fontSize: '0.875rem' }}
                >
                  {manageUsersReviewingCea === manageUsersScreenshotUser?.ceaNumber ? 'Approving...' : 'Approve'}
                </Button>
                <Button
                  variant="outlined"
                  color="warning"
                  onClick={async () => {
                    if (!manageUsersScreenshotUser) return;
                    await handleReviewUser(manageUsersScreenshotUser.ceaNumber, false);
                    setManageUsersScreenshotUser(null);
                  }}
                  disabled={manageUsersReviewingCea === manageUsersScreenshotUser.ceaNumber || manageUsersScreenshotUser.ceaNumber === userInfo?.CEANumber}
                  sx={{ fontSize: '0.875rem' }}
                >
                  {manageUsersReviewingCea === manageUsersScreenshotUser?.ceaNumber ? 'Rejecting...' : 'Reject'}
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>

        {!fromProjectEssential && (
          <Paper
            sx={{
              mb: 3,
              bgcolor: 'var(--color-surface)',
              boxShadow: '0 2px 8px rgba(var(--color-shadow-rgb), 0.3)',
              borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)',
            }}
          >
            <Tabs
              value={activeTabId}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                '& .MuiTabs-indicator': { backgroundColor: 'var(--color-accent)' },
                '& .MuiTabs-scrollButtons': { color: 'var(--color-text-strong)' },
                '& .MuiTabs-flexContainer': { gap: 0 },
              }}
            >
              {toolTabs.map((tab) => {
                const isClientTab = tab.id !== 'generic' && tab.id !== 'master' && tab.id !== 'map-research' && tab.id !== 'success-closer' && tab.id !== MY_SHARABLE_LINKS_TAB && tab.id !== TOP_VIEWING_SITE_PLANS_TAB && tab.id !== MARKETING_MATERIALS_TAB && tab.id !== PODCAST_VIDEOS_TAB;
                return (
                  <Tab
                    key={tab.id}
                    value={tab.id}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: 'inherit' }}>
                          {tab.label}
                        </Typography>
                        {isClientTab && (
                          <IconButton
                            size="small"
                            onClick={(event) => {
                              event.stopPropagation();
                              closeClientTab(tab.id);
                            }}
                            sx={{ ml: -0.5, color: 'inherit' }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                    }
                    sx={{
                      minHeight: 48,
                      color: 'rgba(var(--color-text-rgb), 0.7)',
                      '&.Mui-selected': { color: 'var(--color-accent)' },
                    }}
                  />
                );
              })}
            </Tabs>
          </Paper>
        )}

        {activeClient && (
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {activeClient.name}
                  </Typography>
                  {(activeClient.email || activeClient.phone) && (
                    <Typography variant="body2" color="text.secondary">
                      {activeClient.email ?? ''}{activeClient.email && activeClient.phone ? ' • ' : ''}{activeClient.phone ?? ''}
                    </Typography>
                  )}
                </Box>
                {/* <Button
                  variant="outlined"
                  size="small"
                  onClick={() => setClientsDrawerOpen(true)}
                >
                  View All Clients
                </Button> */}
              </Box>
              {activeClient.notes && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {activeClient.notes}
                </Typography>
              )}
              <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                {(activeClient.eoiNo || activeClient.ballotNo || activeClient.queueNo) && (
                  <>
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block">
                      EOI No
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {activeClient.eoiNo || '-'}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block">
                      Ballot No
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {activeClient.ballotNo || '-'}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block">
                      Queue No
                    </Typography>
                    <Typography variant="body2" fontWeight={600}>
                      {activeClient.queueNo || '-'}
                    </Typography>
                  </Box>
                  </>
                )}
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={() => openClientEditor(activeClient)}
                  sx={{ ml: 'auto' }}
                >
                  Edit Client
                </Button>
              </Box>
              {/* {activeClient.choiceUnits?.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Choice Units
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Select a choice unit below.
                  </Typography>
                </Box>
              )} */}
            </CardContent>
          </Card>
        )}

        {/* Search Section */}
        {!activeClient && activeTabId === 'generic' && (
          <InputSection
            projects={projects}
            selectedProject={selectedProject}
            unitNumber={unitNumber}
            projectUnits={projectUnits}
            projectUnitsLoading={projectUnitsLoading}
            onProjectChange={(value) => {
              setSelectedProject(value ?? '');
              setUnitNumber('');
              setProjectUnits([]);
            }}
            onUnitNumberChange={(value) => {
              const nextUnit = value ?? '';
              setUnitNumber(nextUnit);
              if (!selectedProject || !nextUnit.trim()) return;
              void handleSearchWithParams(selectedProject, nextUnit.trim());
            }}
          />
        )}

        {showTopViewingDetailInGeneric && (
          <TopViewingSitePlanDetail
            key={topViewingDetailEntrySignature ?? 'generic-top-viewing'}
            onAISummaryClick={topViewingComparableUnits.length > 0 ? generateAISummary : undefined}
            onExportProjectReport={isExternalUser ? undefined : handleExportProjectReport}
            hideShortlist={isExternalUser}
            ceaNumber={userInfo?.CEANumber || getDevCea()}
            topViewingSitePlans={genericTopViewingSitePlans}
            selectedTopViewingSitePlan={genericSelectedTopViewingSitePlan}
            handleSelectTopViewingSitePlan={handleGenericTopViewingSelect}
            setSelectedTopViewingSitePlan={setGenericSelectedTopViewingSitePlan}
            projectDetails={projectDetails}
            referenceUnit={referenceUnit}
            selectedProject={selectedProject}
            projectDetailsLoading={projectDetailsLoading}
            projectSectionExpanded={projectSectionExpanded}
            setProjectSectionExpanded={setProjectSectionExpanded}
            projectDetailsTab={projectDetailsTab}
            setProjectDetailsTab={setProjectDetailsTab}
            fetchAmenities={fetchAmenities}
            fetchProjectMembers={fetchProjectMembers}
            amenitiesRadius={amenitiesRadius}
            setAmenitiesRadius={setAmenitiesRadius}
            selectedAmenityTypes={selectedAmenityTypes}
            setSelectedAmenityTypes={setSelectedAmenityTypes}
            amenitiesLoading={amenitiesLoading}
            amenitiesData={amenitiesData}
            fetchDemandSupply={fetchDemandSupply}
            demandSupplyRadius={demandSupplyRadius}
            demandSupplyMinRadius={demandSupplyMinRadius}
            onDemandSupplyRadiusChange={handleDemandSupplyRadiusChange}
            demandSupplyNationwide={demandSupplyNationwide}
            onDemandSupplyNationwideChange={handleDemandSupplyNationwideChange}
            demandSupplyData={demandSupplyData}
            demandSupplyLoading={demandSupplyLoading}
            selectedDemandSupplyTypes={selectedDemandSupplyTypes}
            setSelectedDemandSupplyTypes={setSelectedDemandSupplyTypes}
                projectMembersLoading={projectMembersLoading}
                projectMembers={projectMembers}
                canViewProjectMembers={!isExternalUser}
                onMemberTap={handleProjectMemberTap}
                disableSetReferenceAction={isExternalUser}
                disableAddToCompareAction={isExternalUser}
                isAdminUser={isAdminUser}
                isProjectDeptUser={isProjectDeptUser}
                userRoles={normalizedUserRoles}
                canAccessSuperRatio={canAccessSuperRatio}
                canCreateShareLink={canAccessSharableLinks}
                canAccessNearbyDeal={canAccessNearbyDeal}
                canAccessSitePlan3d={canAccessSitePlan3d}
                canAccessSitePlan3dSun={canAccessSitePlan3dSun}
                priceMatrixSimulationSession={activePriceMatrixSimulationSession}
                priceMatrixSimulationLoading={priceMatrixSimulationLoadingProjectId === projectDetails?.id}
                priceMatrixSimulationRefreshing={priceMatrixSimulationRefreshingProjectId === projectDetails?.id}
                priceMatrixSimulationError={priceMatrixSimulationError}
                onLoadPriceMatrixSimulation={handleLoadPriceMatrixSimulation}
                onRefreshPriceMatrixSimulation={handleRefreshPriceMatrixSimulation}
                onTogglePriceMatrixSimulationSync={handleTogglePriceMatrixSimulationSync}
                onSetPriceMatrixSimulationStatus={handleSetPriceMatrixSimulationStatus}
                onApplyPriceMatrixSimulationStatuses={handleApplyPriceMatrixSimulationStatuses}
                onCancelPriceMatrixSimulation={handleCancelPriceMatrixSimulation}
                getPhotoUrl={getPhotoUrl}
            shouldShowSitePlanButton={shouldShowSitePlanButton}
            handleOpenSitePlan={handleOpenSitePlan}
            handleOpenTowerView={handleOpenTowerView}
            sitePlanData={sitePlanData}
            sitePlanLoading={sitePlanLoading}
            sitePlanShowPoints={sitePlanShowPoints}
            setSitePlanShowPoints={setSitePlanShowPoints}
            sitePlanShowHeatMap={sitePlanShowHeatMap}
            setSitePlanShowHeatMap={setSitePlanShowHeatMap}
            sitePlanBedroomFilter={sitePlanBedroomFilter}
            setSitePlanBedroomFilter={setSitePlanBedroomFilter}
            sitePlanUnitTypeFilter={sitePlanUnitTypeFilter}
            sitePlanUnitTypeFilterForMatching={sitePlanUnitTypeFilterExpanded}
            sitePlanUnitTypeFilterExpandedUnitTypes={sitePlanUnitTypeFilterExpandedUnitTypes}
            setSitePlanUnitTypeFilter={setSitePlanUnitTypeFilter}
            sitePlanUnitTypes={sitePlanUnitTypesForBedroomFilter}
            sitePlanBlinkingStacks={sitePlanBlinkingStacks}
            sitePlanStackSoldPercentages={effectiveSitePlanStackSoldPercentages}
            sitePlanProjectName={sitePlanProjectName}
            handleOpenStackAnalysis={handleOpenStackAnalysis}
            isMobileSitePlan={isMobileSitePlan}
            sitePlanDotSize={sitePlanDotSize}
            sitePlanDotBorder={sitePlanDotBorder}
            sitePlanDotShadow={sitePlanDotShadow}
            sitePlanDotFontSize={sitePlanDotFontSize}
            shouldHideNonMatchingSitePlanStack={shouldHideNonMatchingSitePlanStack}
            getHeatMapColor={getHeatMapColor}
            normalizeStackKey={normalizeStackKey}
            sitePlanMenuOpen={sitePlanMenuOpen}
            setSitePlanMenuOpen={setSitePlanMenuOpen}
            sitePlanStackBedrooms={sitePlanStackBedrooms}
            sitePlanStackFilter={sitePlanStackFilter}
            setSitePlanStackFilter={setSitePlanStackFilter}
            sitePlanStacksOptions={sitePlanStacksOptions}
            topViewingTowerZoom={topViewingTowerZoom}
            setTopViewingTowerZoom={setTopViewingTowerZoom}
            topViewingTowerDisplayOptions={topViewingTowerDisplayOptions}
            setTopViewingTowerDisplayOptions={setTopViewingTowerDisplayOptions}
            showPsfColumnByDefault={topViewingShowPsfColumnByDefault}
            topViewingTowerBedroomColor={topViewingTowerBedroomColor}
            setTopViewingTowerBedroomColor={setTopViewingTowerBedroomColor}
            towerViewData={towerViewData}
            towerViewUnits={effectiveTowerViewUnits}
            towerViewUnitTypes={towerViewUnitTypes}
            topViewingBestPxBedroomSitePlan={topViewingBestPxBedroomSitePlan}
            topViewingBestByUnitTypeData={topViewingBestByUnitTypeForDisplay}
            topViewingBestByUnitTypeLoading={topViewingBestByUnitTypeForDisplayLoading}
            isTopViewingIndicativeBeforeLaunch={isTopViewingIndicativeBeforeLaunch}
            topViewingFilteredAvailableUnits={topViewingFilteredAvailableUnits}
            topViewingDetailedAvailableUnits={topViewingDetailedAvailableUnits}
            topViewingSortedUnits={topViewingSortedUnits}
            topViewingSortConfig={topViewingSortConfig}
            topViewingPopoverAnchor={topViewingPopoverAnchor}
            topViewingAvailableUnitFilters={topViewingAvailableUnitFilters}
            setTopViewingAvailableUnitFilters={setTopViewingAvailableUnitFilters}
            topViewingUnitMenuAnchor={topViewingUnitMenuAnchor}
            setTopViewingUnitMenuAnchor={setTopViewingUnitMenuAnchor}
            handleTopViewingOpenPopover={handleTopViewingOpenPopover}
            handleTopViewingClosePopover={handleTopViewingClosePopover}
            handleTopViewingSortChange={handleTopViewingSortChange}
            handleTopViewingFilterChange={handleTopViewingFilterChange}
            handleTopViewingRangeFilterChange={(col, bound, val) => handleTopViewingRangeFilterChange(col as Parameters<typeof handleTopViewingRangeFilterChange>[0], bound, val)}
            hasTopViewingActiveFilter={hasTopViewingActiveFilter}
            getTopViewingSortDirection={getTopViewingSortDirection}
            topViewingAvailableUnitsViewMode={topViewingAvailableUnitsViewMode}
            setTopViewingAvailableUnitsViewMode={setTopViewingAvailableUnitsViewMode}
            topViewingCompViewMode={topViewingCompViewMode}
            setTopViewingCompViewMode={setTopViewingCompViewMode}
            topViewingFloorPlanOpen={topViewingFloorPlanOpen}
            setTopViewingFloorPlanOpen={setTopViewingFloorPlanOpen}
            topViewingFloorPlanUrl={topViewingFloorPlanUrl}
            setTopViewingFloorPlanUrl={setTopViewingFloorPlanUrl}
            topViewingFloorPlanLoading={topViewingFloorPlanLoading}
            topViewingFloorPlanUnit={topViewingFloorPlanUnit}
            topViewingReferenceUnit={topViewingReferenceUnit}
            setTopViewingReferenceUnit={setTopViewingReferenceUnit}
            topViewingBlinkerChoiceUnit={topViewingBlinkerChoiceUnit}
            setTopViewingBlinkerChoiceUnit={setTopViewingBlinkerChoiceUnit}
            topViewingBlinkerMinTolerance={topViewingBlinkerMinTolerance}
            setTopViewingBlinkerMinTolerance={setTopViewingBlinkerMinTolerance}
            setTopViewingBlinkerMinPriceOverride={setTopViewingBlinkerMinPriceOverride}
            topViewingBlinkerTolerance={topViewingBlinkerTolerance}
            setTopViewingBlinkerTolerance={setTopViewingBlinkerTolerance}
            setTopViewingBlinkerMaxPriceOverride={setTopViewingBlinkerMaxPriceOverride}
            topViewingBlinkerSuperUpgrade={topViewingBlinkerSuperUpgrade}
            setTopViewingBlinkerSuperUpgrade={setTopViewingBlinkerSuperUpgrade}
            topViewingBlinkerRange={topViewingBlinkerRange}
            handleTopViewingIndicativeReference={handleTopViewingIndicativeReference}
            handleTopViewingGuesstimationReference={handleTopViewingGuesstimationReference}
            topViewingComparableUnits={topViewingComparableUnits}
            topViewingComparableUnitsLoading={topViewingComparableUnitsLoading}
            topViewingAreaTolerance={topViewingAreaTolerance}
            setTopViewingAreaTolerance={setTopViewingAreaTolerance}
            topViewingToleranceSliderValue={topViewingToleranceSliderValue}
            setTopViewingToleranceSliderValue={setTopViewingToleranceSliderValue}
            topViewingToleranceModalOpen={topViewingToleranceModalOpen}
            setTopViewingToleranceModalOpen={setTopViewingToleranceModalOpen}
            topViewingComparableSectionOpen={topViewingComparableSectionOpen}
            setTopViewingComparableSectionOpen={setTopViewingComparableSectionOpen}
            topViewingCompFilters={topViewingCompFilters}
            setTopViewingCompFilters={setTopViewingCompFilters}
            topViewingCompRangeFilters={topViewingCompRangeFilters}
            topViewingCompRangeFiltersApplied={debouncedTopViewingCompRangeFilters}
            setTopViewingCompRangeFilters={(v) => setTopViewingCompRangeFilters(v as Parameters<typeof setTopViewingCompRangeFilters>[0])}
            topViewingCompPopoverAnchor={topViewingCompPopoverAnchor}
            topViewingThumbsUpFilterActive={topViewingThumbsUpFilterActive}
            setTopViewingThumbsUpFilterActive={setTopViewingThumbsUpFilterActive}
            topViewingCompSortConfig={topViewingCompSortConfig}
            setTopViewingCompSortConfig={setTopViewingCompSortConfig}
            topViewingFloorPlansToCompare={topViewingFloorPlansToCompare}
            setTopViewingFloorPlansToCompare={setTopViewingFloorPlansToCompare}
            topViewingComparableSectionRef={topViewingComparableSectionRef}
            topViewingTowerViewSectionRef={topViewingTowerViewSectionRef}
            topViewingThumbsUpLegendAnchor={topViewingThumbsUpLegendAnchor}
            setTopViewingThumbsUpLegendAnchor={setTopViewingThumbsUpLegendAnchor}
            handleTopViewingCompOpenPopover={handleTopViewingCompOpenPopover}
            handleTopViewingCompClosePopover={handleTopViewingCompClosePopover}
            handleTopViewingCompFilterChange={(col, val) => handleTopViewingCompFilterChange(col as Parameters<typeof handleTopViewingCompFilterChange>[0], val)}
            handleTopViewingCompRangeFilterChange={(col, bound, val) => handleTopViewingCompRangeFilterChange(col as Parameters<typeof handleTopViewingCompRangeFilterChange>[0], bound as 'min' | 'max', val)}
            handleTopViewingCompSort={handleTopViewingCompSort}
            hasTopViewingCompActiveFilter={hasTopViewingCompActiveFilter}
            getTopViewingCompColumnLabel={getTopViewingCompColumnLabel}
            topViewingFilteredComparableUnits={topViewingFilteredComparableUnits}
            topViewingComparableResultProjectNames={topViewingComparableResultProjectNames}
            topViewingComparableResultProjectCategories={topViewingComparableResultProjectCategories}
            topViewingComparableResultUnitTypeDescriptions={topViewingComparableResultUnitTypeDescriptions}
            handleTopViewingAddToUnitCompare={handleTopViewingAddToUnitCompare}
            analyticsCea={userInfo?.CEANumber || getDevCea()}
            topViewingBudgetSectionOpen={topViewingBudgetSectionOpen}
            setTopViewingBudgetSectionOpen={setTopViewingBudgetSectionOpen}
            topViewingBudgetTolerance={topViewingBudgetTolerance}
            setTopViewingBudgetTolerance={setTopViewingBudgetTolerance}
            topViewingBudgetSliderValue={topViewingBudgetSliderValue}
            setTopViewingBudgetSliderValue={setTopViewingBudgetSliderValue}
            topViewingBudgetUnitsLoading={topViewingBudgetUnitsLoading}
            topViewingBudgetUnitsError={topViewingBudgetUnitsError}
            topViewingBudgetRange={topViewingBudgetRange}
            topViewingBudgetSearchRange={topViewingBudgetSearchRange}
            handleTopViewingBudgetSearchRangeChange={handleTopViewingBudgetSearchRangeChange}
            topViewingBudgetViewMode={topViewingBudgetViewMode}
            setTopViewingBudgetViewMode={setTopViewingBudgetViewMode}
            topViewingBudgetRegionTab={topViewingBudgetRegionTab}
            setTopViewingBudgetRegionTab={setTopViewingBudgetRegionTab}
            topViewingBudgetSortedUnits={topViewingBudgetSortedUnits}
            topViewingBudgetPopoverAnchor={topViewingBudgetPopoverAnchor}
            topViewingBudgetSortConfig={topViewingBudgetSortConfig}
            topViewingBudgetFilters={topViewingBudgetFilters}
            topViewingBudgetExclusionFilters={topViewingBudgetExclusionFilters}
            topViewingBudgetUniqueFilterOptions={topViewingBudgetUniqueFilterOptions}
            handleTopViewingBudgetExclusionFilterChange={handleTopViewingBudgetExclusionFilterChange}
            handleTopViewingBudgetExclusionFilterSet={handleTopViewingBudgetExclusionFilterSet}
            topViewingBudgetRangeFilters={topViewingBudgetRangeFilters}
            topViewingOutlayInfoAnchor={topViewingOutlayInfoAnchor}
            setTopViewingOutlayInfoAnchor={setTopViewingOutlayInfoAnchor}
            topViewingInstallmentInfoAnchor={topViewingInstallmentInfoAnchor}
            setTopViewingInstallmentInfoAnchor={setTopViewingInstallmentInfoAnchor}
            handleTopViewingBudgetOpenPopover={handleTopViewingBudgetOpenPopover}
            handleTopViewingBudgetClosePopover={handleTopViewingBudgetClosePopover}
            handleTopViewingBudgetFilterChange={(col, val) => handleTopViewingBudgetFilterChange(col as Parameters<typeof handleTopViewingBudgetFilterChange>[0], val)}
            handleTopViewingBudgetRangeFilterChange={(col, bound, val) => handleTopViewingBudgetRangeFilterChange(col as Parameters<typeof handleTopViewingBudgetRangeFilterChange>[0], bound, val)}
            handleTopViewingBudgetSortChange={handleTopViewingBudgetSortChange}
            getTopViewingBudgetSortDirection={getTopViewingBudgetSortDirection}
            hasTopViewingBudgetActiveFilter={hasTopViewingBudgetActiveFilter}
            getTopViewingBudgetIconButtonSx={getTopViewingBudgetIconButtonSx}
            handleTopViewingBudgetClearFilters={handleTopViewingBudgetClearFilters}
            getBudgetProjectCellValue={(projectName, key) => getBudgetProjectCellValue(projectName, key as Parameters<typeof getBudgetProjectCellValue>[1])}
            topViewingBudgetProjectsForView={topViewingBudgetProjectsForView}
            onOpenBudgetInProjectResearch={handleOpenBudgetInProjectResearch}
            topViewingBudgetNearbyRadiusKm={topViewingBudgetNearbyRadiusKm}
            setTopViewingBudgetNearbyRadiusKm={setTopViewingBudgetNearbyRadiusKm}
            topViewingBudgetShowReferenceProjectUnits={topViewingBudgetShowReferenceProjectUnits}
            setTopViewingBudgetShowReferenceProjectUnits={setTopViewingBudgetShowReferenceProjectUnits}
            handleTopViewingUnitMenuViewFloorPlan={(unit) => {
              setTopViewingUnitMenuAnchor(null);
              const mapped = toTopViewingComparableUnit(unit);
              handleOpenFloorPlan(mapped);
            }}
            handleTopViewingUnitMenuSetReference={handleTopViewingSetReferenceFromMenu}
            handleTopViewingUnitMenuSetBlinkerChoice={handleTopViewingSetBlinkerChoiceFromMenu}
            handleTopViewingUnitMenuToggleCompare={(unit) => {
              if (isExternalUser) {
                setTopViewingUnitMenuAnchor(null);
                return;
              }
              handleTopViewingAddToUnitCompare(unit);
              setTopViewingUnitMenuAnchor(null);
            }}
            formatCurrency={formatCurrency}
            formatNumber={formatNumber}
            getAreaRangeLabel={getAreaRangeLabel}
            getOutlayFormulaTooltip={getOutlayFormulaTooltip}
            getInstallmentFormulaTooltip={getInstallmentFormulaTooltip}
            onOpenFinancialParameters={() => setFinancialParametersOpen(true)}
            onOpenNpsInfo={() => setNpsDpsInfoDialog('nps')}
            onOpenDpsInfo={() => setNpsDpsInfoDialog('dps')}
            currentInterestRate={interestRate}
            loanToValue={loanToValue}
            getIconButtonSx={getIconButtonSx}
            qualifiesForThumbsUp={topViewingQualifiesForThumbsUp}
            getTopViewingDistanceFromReference={getTopViewingDistanceFromReference}
            projectDetailsMap={projectDetailsMap}
            projectViewPopoverAnchor={projectViewPopoverAnchor}
            setProjectViewPopoverAnchor={setProjectViewPopoverAnchor}
            projectViewFilters={projectViewFilters}
            setProjectViewFilters={setProjectViewFilters}
            projectViewRangeFilters={projectViewRangeFilters}
            setProjectViewRangeFilters={setProjectViewRangeFilters}
            projectViewDistrictFilter={projectViewDistrictFilter}
            setProjectViewDistrictFilter={setProjectViewDistrictFilter}
            projectViewDistrictOptions={PROJECT_VIEW_DISTRICT_OPTIONS}
            projectViewNumericColumns={PROJECT_VIEW_NUMERIC_COLUMNS}
            formatBlockNumber={formatBlockNumber}
            normalizeBedroomValue={normalizeBedroomValue}
            handleOpenSitePlanForProject={handleOpenSitePlanForProject}
            handleOpenFloorPlan={handleOpenFloorPlan}
            onOpenFloorPlanCompare={handleOpenTopViewingFloorPlanCompare}
            handleOpenPriceChart={handleOpenPriceChart}
            handleShortlistAction={handleShortlistAction}
            setPricePromoInfoOpen={setPricePromoInfoOpen}
            getPriceDiffColor={getPriceDiffColor}
            parseUnitNumber={parseUnitNumber}
            shortlistByUnitId={shortlistByUnitId}
            shortlistUpdatingUnitId={shortlistUpdatingUnitId}
            topViewingProjectsForProjectView={topViewingProjectsForProjectView}
            topViewingFilteredProjectsForView={topViewingFilteredProjectsForView}
            PROJECT_VIEW_COLUMN_KEYS={PROJECT_VIEW_COLUMN_KEYS}
            setProjectDetailsMap={setProjectDetailsMap}
            nearbyThumbsupGroups={thumbsupGroupsByProject}
            nearbyPricePromoGroups={pricePromoAllProjectGroups}
            pricePromoBestByStackBedroom={pricePromoBestByStackBedroom}
            pricePromoUnitIds={pricePromoUnitIds}
            handleThumbsupUnitClick={handleThumbsupUnitClick}
            handlePricePromoUnitClick={handlePricePromoUnitClick}
            formatThumbsupUnitSqft={formatThumbsupUnitSqft}
            formatPricePromoDate={formatPricePromoDate}
          />
        )}

        {/* Map Research Tab — admins + ACCELERATORs + SUPER-MAP role; all projects plotted on an interactive Singapore map */}
        {activeTabId === 'map-research' && canAccessSuperMap && (
          <MapResearchTab
            pricePromoGroups={pricePromoAllProjectGroups}
            thumbsupGroups={thumbsupGroupsByProject}
            canFilterPricePromo={canAccessPricePromo || canAccessNearbyDeal}
            canFilterThumbsup={!isExternalUser}
            canUseSuperRatio={canAccessSuperRatio}
            onViewProject={handleMapResearchViewProject}
            onPricePromoUnitClick={(unit) => {
              void handleOpenPriceChart(unit.id, 'price', true, 'map_research', unit.bedroomNumber);
            }}
            onThumbsupUnitClick={(unit) => {
              void handleThumbsupUnitClick(unit, 'map_research');
            }}
          />
        )}

        {/* Success Closer Tab (ADMIN and ACCELERATOR) */}
        {activeTabId === 'success-closer' && canAccessSuccessCloser && (
          <SuccessCloserTab
            currentUser={userInfo ? { Id: userInfo.CEANumber || '', Name: userInfo.Name, CEANumber: userInfo.CEANumber, Mobile: userInfo.Mobile, Email: userInfo.Email, Photo: userInfo.Photo } : null}
            autoOpenTransactions={autoOpenTransactions}
            searchQuery={successCloserSearch}
            highlightCea={highlightCea}
            isAdmin={isAdminUser}
          />
        )}

        {/* My Shareable Links — consumer-facing links whose leads land in Super Connector */}
        {activeTabId === MY_SHARABLE_LINKS_TAB && canAccessSharableLinks && (
          <MySharableLinksTab
            distinctiveValues={{
              // Same footer lines as the Distinctives gallery.
              agentLine: [userInfo?.Name, userInfo?.CEANumber, userInfo?.Mobile || userInfo?.Email]
                .map((part) => (part || '').trim())
                .filter(Boolean)
                .join(' · '),
              agencyLine: 'Huttons Asia Pte Ltd · L3008899K',
            }}
            autoOpenIntro={sharableIntroAutoOpen}
            onIntroAutoOpened={() => setSharableIntroAutoOpen(false)}
          />
        )}

        {/* Marketing Materials Tab — admins / Project Dept, plus project leads
            (Head / Deputy Head, or IC when the project has no Head) */}
        {activeTabId === MARKETING_MATERIALS_TAB && canAccessProjectMaterials && (
          <MarketingMaterialsTab analyticsCea={userInfo?.CEANumber || getDevCea()} />
        )}

        {/* Podcast Videos Tab — available to all Super Picker users; Add Video is role-gated inside */}
        {activeTabId === PODCAST_VIDEOS_TAB && (
          <PodcastVideosTab
            analyticsCea={userInfo?.CEANumber || getDevCea()}
            isAdmin={isAdminUser}
            isAccelerator={isAcceleratorUser}
            isVideoUploader={isVideoUploader}
          />
        )}

        {/* Situation Map Tab — admin-only, matching the sidebar gate */}
        {isAdminUser && activeTabId === 'situation-map' && (
          <SituationMapTab />
        )}

        {/* Master Tool Filter Section */}
        {activeTabId === 'master' && !activeClient && (
          renderMasterToolSearchCriteria()
        )}

        {activeTabId === 'master' && !activeClient && !superShowcaseResultsOpen && !isExternalUser && amberwoodSitePlan
          && masterToolAmberwoodBedrooms.length > 0 && !amberwoodBannerDismissed && (
          <AmberwoodResearchBanner
            bedrooms={masterToolAmberwoodBedrooms}
            onOpen={openAmberwoodProject}
            onDismiss={dismissAmberwoodBanner}
          />
        )}

        {/* Master Tool Results */}
        {activeTabId === 'master' && !activeClient && !superShowcaseResultsOpen && (masterToolResults.length > 0 || masterToolTotalMatchedUnits > 0 || masterToolLoading) && renderMasterToolResults()}

        {error && activeTabId !== 'master' && activeTabId !== TOP_VIEWING_SITE_PLANS_TAB && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {/* Reference Unit Card */}
        {referenceUnit && activeTabId !== 'master' && activeTabId !== TOP_VIEWING_SITE_PLANS_TAB && !showTopViewingDetailInGeneric && (
          <ReferenceUnitCard 
            referenceUnit={referenceUnit}
            isExecutiveCondo={referenceProjectDetailsForCard?.projectCategoryId === 'C1803'}
            isShortlisted={isReferenceShortlisted}
            shortlistUpdating={shortlistUpdatingUnitId === referenceUnit.id}
            onShortlistClick={isExternalUser ? undefined : () => handleShortlistAction({
              unitId: referenceUnit.id,
              label: `${referenceUnit.projectName} ${referenceUnit.unitNumber}`,
              floorplan: referenceUnit.floorplan || null,
            })}
            onAISummaryClick={generateAISummary}
            onSettingsClick={() => setProjectSyncSettingsOpen(true)}
            onInterestClick={() => setHeatBarInfoOpen(true)}
            onFloorPlanClick={(unit) => handleOpenFloorPlan(unit)}
            onTowerViewClick={(unit) => handleOpenTowerView(unit)}
          />
        )}

        {/* Project Details Section */}
        {(projectDetails || referenceUnit) &&
          activeTabId !== 'master' &&
          activeTabId !== TOP_VIEWING_SITE_PLANS_TAB &&
          !showTopViewingDetailInGeneric && (
          <Card sx={{ mb: 4, bgcolor: 'var(--color-surface)', boxShadow: '0 2px 8px rgba(var(--color-shadow-rgb), 0.3)' }}>
            <Accordion 
              expanded={projectSectionExpanded} 
              onChange={(_, expanded) => setProjectSectionExpanded(expanded)}
              sx={{
                bgcolor: 'var(--color-surface)',
                '&:before': {
                  display: 'none',
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: 'var(--color-text-strong)' }} />}
                sx={{
                  px: 3,
                  py: 2,
                  bgcolor: 'var(--color-surface)',
                  '&:hover': {
                    bgcolor: 'rgba(var(--color-text-rgb), 0.05)',
                  },
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                  <LocationOnIcon sx={{ color: 'var(--color-accent)' }} />
                  <Typography variant="h6" sx={{ fontWeight: 600, color: 'var(--color-text-strong)' }}>
                    {projectDetails?.name || referenceUnit?.projectName || selectedProject || 'Project Information'}
                  </Typography>
                  {projectDetailsLoading && (
                    <CircularProgress size={20} sx={{ ml: 'auto', color: 'var(--color-accent)' }} />
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0, bgcolor: 'var(--color-surface)' }}>
                <Box sx={{ p: 3, bgcolor: 'var(--color-surface)' }}>
                  {projectDetailsLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                      <CircularProgress />
                    </Box>
                  ) : projectDetails ? (
                    <Grid container spacing={3}>
                      {/* Left Side - Info with Tabs */}
                      <Grid item xs={12} md={projectDetailsTab === 'members' && !isExternalUser ? 12 : (projectDetailsTab === 'files' ? 12 : 6)}>
                        <Tabs
                          value={projectDetailsTab}
                          onChange={(_, newValue) => {
                            setProjectDetailsTab(newValue);
                            // Fetch amenities when switching to the Amenities tab (Super Ratio
                            // loads via the auto-fetch effect keyed on the tab)
                            if (newValue === 'amenities' && projectDetails.name && projectDetails.mapLatitude && projectDetails.mapLongitude) {
                              fetchAmenities(projectDetails.name, amenitiesRadius);
                            }
                            // Fetch project members when switching to members tab
                            if (newValue === 'members' && projectDetails.id && !isExternalUser) {
                              fetchProjectMembers(projectDetails.id);
                            }
                            // Fetch every Files-tab data source in parallel
                            // when the tab is opened. Factsheet + brochure come
                            // from ProjectMedia (legacy single-row endpoints).
                            // EDMs and eBooks come from the project-essential
                            // join tables (EDMProject / ProjectLauncherProject)
                            // and are returned as flat arrays per project.
                            // Each promise is `.catch()`-guarded so a single
                            // failing source doesn't blank the whole tab.
                            if (newValue === 'files' && projectDetails.id) {
                              setFilesLoading(true);
                              setFilesFactsheetData(null);
                              setFilesBrochureData(null);
                              setFilesEdms([]);
                              setFilesEbooks([]);
                              Promise.all([
                                api.getProjectFactsheet(projectDetails.id).then((d) => d).catch(() => null),
                                api.getProjectBrochure(projectDetails.id).then((d) => d).catch(() => null),
                                api.getProjectEdms(projectDetails.id).then((d) => d.items).catch(() => [] as ProjectEdmFile[]),
                                api.getProjectEbooks(projectDetails.id).then((d) => d.items).catch(() => [] as ProjectEbookFile[]),
                              ]).then(([factsheet, brochure, edms, ebooks]) => {
                                setFilesFactsheetData(factsheet);
                                setFilesBrochureData(brochure);
                                setFilesEdms(edms);
                                setFilesEbooks(ebooks);
                                setFilesLoading(false);
                              }).catch(() => setFilesLoading(false));
                            }
                          }}
                          sx={{ 
                            mb: 2,
                            '& .MuiTab-root': {
                              color: 'rgba(var(--color-text-rgb), 0.7)',
                              '&.Mui-selected': {
                                color: 'var(--color-accent)',
                              },
                            },
                            '& .MuiTabs-indicator': {
                              bgcolor: 'var(--color-accent)',
                            },
                          }}
                        >
                          <Tab label="Details" value="details" />
                          <Tab label="Amenities" value="amenities" />
                          {canAccessSuperRatio && (
                            <Tab
                              value="superRatio"
                              /* Anchors the ribbon to the tab's top-left padding, above the
                                 label rather than across it. */
                              sx={{ position: 'relative', overflow: 'visible' }}
                              label={
                                <>
                                  Super Ratio
                                  <NewBadge sx={TAB_NEW_BADGE_SX} />
                                </>
                              }
                            />
                          )}
                          <Tab label="Files" value="files" />
                          {!isExternalUser && <Tab label="Project Members" value="members" />}
                        </Tabs>
                        
                        <Box
                          sx={{
                            maxHeight: 'calc(100vh - 400px)',
                            overflowY: 'auto',
                            pr: 1,
                            '& .MuiTypography-root': {
                              color: 'var(--color-text-strong)',
                            },
                            '& .MuiTypography-caption': {
                              color: 'rgba(var(--color-text-rgb), 0.7)',
                            },
                          }}
                        >
                        {projectDetailsTab === 'details' ? (
                          <Grid container spacing={2}>
                            {projectDetails.liveStatusEnabled && (
                              <Grid item xs={12}>
                                <Box
                                  sx={{
                                    p: 1.5,
                                    borderRadius: 2,
                                    bgcolor: 'rgba(var(--color-accent-rgb), 0.1)',
                                    border: '1px solid rgba(var(--color-accent-rgb), 0.3)',
                                  }}
                                >
                                  <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                    Live status
                                  </Typography>
                                  <Typography variant="body2" fontWeight={600} sx={{ color: 'var(--color-text-strong)' }}>
                                    {projectDetails.liveStatusUpdatedAt
                                      ? `Last updated ${new Date(projectDetails.liveStatusUpdatedAt).toLocaleString()}`
                                      : 'No updates yet'}
                                  </Typography>
                                </Box>
                              </Grid>
                            )}
                            {projectDetails.name && (
                              <Grid item xs={12}>
                                <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                  Name
                                </Typography>
                                <Typography variant="body1" fontWeight="medium" sx={{ color: 'var(--color-text-strong)' }}>
                                  {projectDetails.name}
                                </Typography>
                              </Grid>
                            )}
                            {projectDetails.developer && (
                              <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                  Developer
                                </Typography>
                                <Typography variant="body1" fontWeight="medium">
                                  {projectDetails.developer}
                                </Typography>
                              </Grid>
                            )}
                            {projectDetails.tenure && (
                              <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                  Tenure
                                </Typography>
                                <Typography variant="body1" fontWeight="medium">
                                  {projectDetails.tenure}
                                </Typography>
                              </Grid>
                            )}
                            {projectDetails.totalUnits && (
                              <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                  Total Units
                                </Typography>
                                <Typography variant="body1" fontWeight="medium">
                                  {projectDetails.totalUnits}
                                </Typography>
                              </Grid>
                            )}
                            {projectDetails.completedDate && (
                              <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                  Completed Date
                                </Typography>
                                <Typography variant="body1" fontWeight="medium">
                                  {new Date(projectDetails.completedDate).toLocaleDateString()}
                                </Typography>
                              </Grid>
                            )}
                            {projectDetails.area && (
                              <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                  Area
                                </Typography>
                                <Typography variant="body1" fontWeight="medium">
                                  {projectDetails.area}
                                </Typography>
                              </Grid>
                            )}
                            {projectDetails.district && (
                              <Grid item xs={12} sm={6}>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                  District
                                </Typography>
                                <Typography variant="body1" fontWeight="medium">
                                  {projectDetails.district}
                                </Typography>
                              </Grid>
                            )}
                            {projectDetails.address && (
                              <Grid item xs={12}>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                  Address
                                </Typography>
                                <Typography variant="body1" fontWeight="medium">
                                  {projectDetails.address}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                        ) : canAccessSuperRatio && projectDetailsTab === 'superRatio' ? (
                              <DemandSupplyPanel
                                data={demandSupplyData}
                                loading={demandSupplyLoading}
                                radius={demandSupplyRadius}
                            minRadius={demandSupplyMinRadius}
                            onRadiusChange={handleDemandSupplyRadiusChange}
                            nationwide={demandSupplyNationwide}
                            onNationwideChange={handleDemandSupplyNationwideChange}
                                selectedTypes={selectedDemandSupplyTypes}
                                setSelectedTypes={setSelectedDemandSupplyTypes}
                              />
                        ) : projectDetailsTab === 'amenities' ? (
                            <Box>
                            {/* Radius Selector */}
                            <Box sx={{ mb: 3 }}>
                              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Search Radius
                              </Typography>
                              <ToggleButtonGroup
                                value={amenitiesRadius}
                                exclusive
                                onChange={(_, newRadius) => {
                                  if (newRadius !== null && projectDetails.name && projectDetails.mapLatitude && projectDetails.mapLongitude) {
                                    setAmenitiesRadius(newRadius);
                                    fetchAmenities(projectDetails.name, newRadius);
                                  }
                                }}
                                size="small"
                              >
                                <ToggleButton value={500}>500m</ToggleButton>
                                <ToggleButton value={1000}>1km</ToggleButton>
                                <ToggleButton value={2000}>2km</ToggleButton>
                              </ToggleButtonGroup>
                            </Box>

                            {/* Amenity Type Filters */}
                            <Box sx={{ mb: 3 }}>
                              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Show Amenities
                              </Typography>
                              <FormGroup row>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedAmenityTypes.mrtLrt}
                                      onChange={(e) =>
                                        setSelectedAmenityTypes((prev) => ({
                                          ...prev,
                                          mrtLrt: e.target.checked,
                                        }))
                                      }
                                      size="small"
                                    />
                                  }
                                  label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                      <Box
                                        sx={{
                                          width: 12,
                                          height: 12,
                                          backgroundColor: 'var(--color-danger)',
                                          borderRadius: '2px',
                                          border: '1px solid rgba(var(--color-shadow-rgb), 0.1)',
                                        }}
                                      />
                                      <Typography variant="body2">MRT/LRT</Typography>
                                    </Box>
                                  }
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedAmenityTypes.schools}
                                      onChange={(e) =>
                                        setSelectedAmenityTypes((prev) => ({
                                          ...prev,
                                          schools: e.target.checked,
                                        }))
                                      }
                                      size="small"
                                    />
                                  }
                                  label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                      <Box
                                        sx={{
                                          width: 12,
                                          height: 12,
                                          backgroundColor: 'var(--color-success)',
                                          borderRadius: '2px',
                                          border: '1px solid rgba(var(--color-shadow-rgb), 0.1)',
                                        }}
                                      />
                                      <Typography variant="body2">Schools</Typography>
                                    </Box>
                                  }
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedAmenityTypes.supermarkets}
                                      onChange={(e) =>
                                        setSelectedAmenityTypes((prev) => ({
                                          ...prev,
                                          supermarkets: e.target.checked,
                                        }))
                                      }
                                      size="small"
                                    />
                                  }
                                  label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                      <Box
                                        sx={{
                                          width: 12,
                                          height: 12,
                                          backgroundColor: 'var(--color-warning)',
                                          borderRadius: '2px',
                                          border: '1px solid rgba(var(--color-shadow-rgb), 0.1)',
                                        }}
                                      />
                                      <Typography variant="body2">Supermarkets</Typography>
                                    </Box>
                                  }
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedAmenityTypes.preschools}
                                      onChange={(e) =>
                                        setSelectedAmenityTypes((prev) => ({
                                          ...prev,
                                          preschools: e.target.checked,
                                        }))
                                      }
                                      size="small"
                                    />
                                  }
                                  label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                      <Box
                                        sx={{
                                          width: 12,
                                          height: 12,
                                          backgroundColor: 'var(--color-secondary)',
                                          borderRadius: '2px',
                                          border: '1px solid rgba(var(--color-shadow-rgb), 0.1)',
                                        }}
                                      />
                                      <Typography variant="body2">Preschools</Typography>
                                    </Box>
                                  }
                                />
                              </FormGroup>
                            </Box>
                            
                            {amenitiesLoading ? (
                              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                                <CircularProgress />
                              </Box>
                            ) : amenitiesData ? (
                              <Box>
                                {/* MRT/LRT */}
                                {selectedAmenityTypes.mrtLrt && (
                                  <>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, mt: 2 }}>
                                      <Box
                                        sx={{
                                          width: 16,
                                          height: 16,
                                          backgroundColor: 'var(--color-danger)',
                                          borderRadius: '2px',
                                          border: '1px solid rgba(var(--color-shadow-rgb), 0.1)',
                                        }}
                                      />
                                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        MRT/LRT ({amenitiesData.amenities.mrtLrt.length})
                                      </Typography>
                                    </Box>
                                    {amenitiesData.amenities.mrtLrt.length > 0 ? (
                                  <Box sx={{ mb: 3 }}>
                                    {amenitiesData.amenities.mrtLrt.map((station) => (
                                      <Card key={station.id} sx={{ mb: 1 }}>
                                        <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                                          <Typography variant="body2" fontWeight="medium">
                                            {station.name}
                                          </Typography>
                                          <Typography variant="caption" color="text.secondary">
                                            {station.mrtLine ? `${station.mrtLine} • ${Math.round(station.distance)}m away` : `${Math.round(station.distance)}m away`}
                                          </Typography>
                                        </CardContent>
                                      </Card>
                                    ))}
                                  </Box>
                                ) : (
                                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                        No MRT/LRT stations found within {amenitiesRadius}m
                                      </Typography>
                                    )}
                                  </>
                                )}
                                
                                {/* Schools */}
                                {selectedAmenityTypes.schools && (
                                  <>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                      <Box
                                        sx={{
                                          width: 16,
                                          height: 16,
                                          backgroundColor: 'var(--color-success)',
                                          borderRadius: '2px',
                                          border: '1px solid rgba(var(--color-shadow-rgb), 0.1)',
                                        }}
                                      />
                                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        Schools ({amenitiesData.amenities.schools.length})
                                      </Typography>
                                    </Box>
                                    {amenitiesData.amenities.schools.length > 0 ? (
                                  <Box sx={{ mb: 3 }}>
                                    {amenitiesData.amenities.schools.map((school) => (
                                      <Card key={school.id} sx={{ mb: 1 }}>
                                        <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                                          <Typography variant="body2" fontWeight="medium">
                                            {school.name}
                                          </Typography>
                                          <Typography variant="caption" color="text.secondary">
                                            {school.type ? `${school.type}${school.category ? ` - ${school.category}` : ''} • ${Math.round(school.distance)}m away` : `${Math.round(school.distance)}m away`}
                                          </Typography>
                                        </CardContent>
                                      </Card>
                                    ))}
                                  </Box>
                                ) : (
                                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                        No schools found within {amenitiesRadius}m
                                      </Typography>
                                    )}
                                  </>
                                )}
                                
                                {/* Preschools */}
                                {selectedAmenityTypes.preschools && (
                                  <>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                      <Box
                                        sx={{
                                          width: 16,
                                          height: 16,
                                          backgroundColor: 'var(--color-secondary)',
                                          borderRadius: '2px',
                                          border: '1px solid rgba(var(--color-shadow-rgb), 0.1)',
                                        }}
                                      />
                                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        Preschools ({amenitiesData.amenities.preschools.length})
                                      </Typography>
                                    </Box>
                                    {amenitiesData.amenities.preschools.length > 0 ? (
                                  <Box sx={{ mb: 3 }}>
                                    {amenitiesData.amenities.preschools.map((preschool) => (
                                      <Card key={preschool.id} sx={{ mb: 1 }}>
                                        <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                                          <Typography variant="body2" fontWeight="medium">
                                            {preschool.name}
                                          </Typography>
                                          <Typography variant="caption" color="text.secondary">
                                            {preschool.type ? `${preschool.type}${preschool.category ? ` - ${preschool.category}` : ''} • ${Math.round(preschool.distance)}m away` : `${Math.round(preschool.distance)}m away`}
                                          </Typography>
                                        </CardContent>
                                      </Card>
                                    ))}
                                  </Box>
                                ) : (
                                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                        No preschools found within {amenitiesRadius}m
                                      </Typography>
                                    )}
                                  </>
                                )}
                                
                                {/* Supermarkets */}
                                {selectedAmenityTypes.supermarkets && (
                                  <>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                      <Box
                                        sx={{
                                          width: 16,
                                          height: 16,
                                          backgroundColor: 'var(--color-warning)',
                                          borderRadius: '2px',
                                          border: '1px solid rgba(var(--color-shadow-rgb), 0.1)',
                                        }}
                                      />
                                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        Supermarkets ({amenitiesData.amenities.supermarkets.length})
                                      </Typography>
                                    </Box>
                                    {amenitiesData.amenities.supermarkets.length > 0 ? (
                                  <Box sx={{ mb: 3 }}>
                                    {amenitiesData.amenities.supermarkets.map((amenity) => (
                                      <Card key={amenity.id} sx={{ mb: 1 }}>
                                        <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                                          <Typography variant="body2" fontWeight="medium">
                                            {amenity.name}
                                          </Typography>
                                          <Typography variant="caption" color="text.secondary">
                                            {amenity.address ? `${amenity.address} • ${Math.round(amenity.distance)}m away` : `${Math.round(amenity.distance)}m away`}
                                          </Typography>
                                        </CardContent>
                                      </Card>
                                    ))}
                                  </Box>
                                ) : (
                                      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                        No supermarkets found within {amenitiesRadius}m
                                      </Typography>
                                    )}
                                  </>
                                )}
                              </Box>
                            ) : (
                              <Typography variant="body2" color="text.secondary">
                                Click on a radius to load amenities
                              </Typography>
                            )}
                          </Box>
                        ) : projectDetailsTab === 'files' ? (
                          <Box>
                            {filesLoading ? (
                              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                                <CircularProgress />
                              </Box>
                            ) : (
                              (() => {
                                // ── Files tab body ──
                                // Builds three `DownloadFileRow` groups
                                // (Project Documents / EDMs / eBooks) from the
                                // four data sources fetched on tab open. Each
                                // row is rendered via the shared
                                // `DownloadFileRow` visual (matches the
                                // project-essential surface), which already
                                // handles preview-on-click for PDFs/images
                                // and a Download / Share affordance per row.
                                const slugifyForFile = (raw: string, fallback: string) =>
                                  raw.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || fallback;

                                // ── Factsheet / Brochure → ProjectMedia legacy rows ──
                                // The portal stores a single canonical asset per
                                // type. We mirror the original "prefer the
                                // PDF, fall back to the largest image" heuristic
                                // from the old ListItem-based renderer so the
                                // download behaves identically.
                                const buildMediaRow = (
                                  data: ProjectFactsheet | ProjectBrochure | null,
                                  displayName: 'Factsheet' | 'Brochure',
                                  baseFallback: 'factsheet' | 'brochure',
                                ): (DownloadFileRowProps & { id: string }) | null => {
                                  if (!data) return null;
                                  const mediaUrl = data.url?.trim() ?? '';
                                  const imageUrl = data.imageLarge || data.imageMedium || data.imageSmall || null;
                                  const type = (data.type ?? '').toLowerCase();
                                            const isPdf = mediaUrl.toLowerCase().endsWith('.pdf') || type === 'pdf';
                                            const downloadUrl = isPdf ? mediaUrl : (imageUrl || mediaUrl);
                                  if (!downloadUrl) return null;
                                            const ext = downloadUrl.toLowerCase().endsWith('.pdf') ? 'pdf' : 'jpg';
                                  const safeBaseName = slugifyForFile(projectDetails?.name || baseFallback, baseFallback);
                                  return {
                                    id: baseFallback,
                                    filename: `${safeBaseName}-${baseFallback}.${ext}`,
                                    displayName,
                                    subtitle: data.description || `Project ${baseFallback}`,
                                    url: downloadUrl,
                                    // Image preview wins over PDF first-page
                                    // rasterisation when ProjectMedia gives
                                    // us a curated thumbnail.
                                    previewImage: imageUrl,
                                    uploadedAt: data.updatedAt,
                                  };
                                };

                                const documentRows: Array<DownloadFileRowProps & { id: string }> = [];
                                const factsheetRow = buildMediaRow(filesFactsheetData, 'Factsheet', 'factsheet');
                                const brochureRow = buildMediaRow(filesBrochureData, 'Brochure', 'brochure');
                                if (factsheetRow) documentRows.push(factsheetRow);
                                if (brochureRow) documentRows.push(brochureRow);

                                // ── EDMs (EDMProject join table) ──
                                // The backend already supplies a portal
                                // filename, with-agent download URL and the
                                // EDM.Thumbnail cover so we just shuttle
                                // them through unchanged.
                                const edmRows: Array<DownloadFileRowProps & { id: string }> = filesEdms.map((edm) => ({
                                  id: `edm:${edm.id}`,
                                  filename: edm.filename || `${slugifyForFile(edm.title, 'edm')}.pdf`,
                                  displayName: edm.title,
                                  subtitle: edm.category ? `EDM · ${edm.category}` : 'EDM',
                                  url: edm.url && edm.url !== '#' ? edm.url : null,
                                  urlPublic: edm.urlPublic,
                                  previewImage: edm.cover,
                                  uploadedAt: edm.createdAt,
                                }));

                                // ── eBooks (ProjectLauncherProject join table) ──
                                // ProjectLauncher rows publish a single
                                // canonical PDF; the launcher has no
                                // thumbnail column so the row falls back to
                                // the PDF first-page render inside
                                // `FilePreviewThumbnail`.
                                const ebookRows: Array<DownloadFileRowProps & { id: string }> = filesEbooks.map((ebook) => ({
                                  id: `ebook:${ebook.id}`,
                                  filename: `${slugifyForFile(ebook.title || ebook.id, 'ebook')}.pdf`,
                                  displayName: ebook.title,
                                  subtitle: ebook.type ? `eBook · ${ebook.type}` : 'eBook',
                                  url: ebook.url,
                                  uploadedAt: ebook.createdAt,
                                }));

                                const totalRows = documentRows.length + edmRows.length + ebookRows.length;
                                if (totalRows === 0) {
                                  return (
                                    <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                                      No files available for this project.
                                    </Typography>
                                  );
                                }

                                const renderSection = (
                                  label: string,
                                  rows: Array<DownloadFileRowProps & { id: string }>,
                                ) => {
                                  if (rows.length === 0) return null;
                                  return (
                                    <Box sx={{ mb: 3 }}>
                                      <Typography
                                        variant="overline"
                                        sx={{
                                          display: 'block',
                                          mb: 1,
                                          color: 'var(--color-text-muted, rgba(0,0,0,0.6))',
                                          fontWeight: 700,
                                          letterSpacing: '0.06em',
                                        }}
                                      >
                                        {label} ({rows.length})
                                      </Typography>
                                      <Box
                                        sx={{
                                          display: 'grid',
                                          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
                                          gap: { xs: 1, sm: 1.25 },
                                        }}
                                      >
                                        {rows.map(({ id, ...rowProps }) => (
                                          <DownloadFileRow key={id} {...rowProps} />
                                        ))}
                                      </Box>
                                    </Box>
                                  );
                                };

                                return (
                                  <Box>
                                    {renderSection('Project Documents', documentRows)}
                                    {renderSection('EDMs', edmRows)}
                                    {renderSection('eBooks', ebookRows)}
                                  </Box>
                                );
                              })()
                            )}
                          </Box>
                        ) : (
                          !isExternalUser && projectDetailsTab === 'members' ? (
                            <Box>
                              {projectMembersLoading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                                  <CircularProgress />
                                </Box>
                              ) : projectMembers && projectMembers.members.length > 0 ? (
                                <Box>
                                  {projectMembers.members.map((roleGroup, roleIndex) => {
                                    const showTaggers = roleGroup.members.some((member) => member.taggers && member.taggers.length > 0);

                                    return (
                                      <Box key={roleIndex} sx={{ mb: 3 }}>
                                        <Typography
                                          variant="subtitle1"
                                          sx={{
                                            fontWeight: 600,
                                            mb: 1.5,
                                            pb: 1,
                                            borderBottom: '1px solid',
                                            borderColor: 'divider',
                                          }}
                                        >
                                          {roleGroup.role}
                                        </Typography>
                                        <TableContainer sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                                          <Table size="small">
                                            <TableHead>
                                              <TableRow>
                                                <TableCell sx={{ fontWeight: 600 }}>Agent</TableCell>
                                                <TableCell sx={{ fontWeight: 600, width: 140 }}>CEA</TableCell>
                                                <TableCell sx={{ fontWeight: 600, width: 160 }}>Mobile</TableCell>
                                                {showTaggers && (
                                                  <TableCell sx={{ fontWeight: 600 }}>Taggers</TableCell>
                                                )}
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {roleGroup.members.map((member, memberIndex) => (
                                                <TableRow key={memberIndex} hover>
                                                  <TableCell>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                      <Avatar
                                                        src={getPhotoUrl(member.photo)}
                                                        sx={{ width: 40, height: 40, bgcolor: 'primary.main', fontSize: '0.85rem' }}
                                                      >
                                                        {(member.name || 'N/A')
                                                          .split(' ')
                                                          .map((part) => part[0])
                                                          .slice(0, 2)
                                                          .join('')
                                                          .toUpperCase()}
                                                      </Avatar>
                                                      <Box>
                                                        <Typography variant="body2" fontWeight="medium">
                                                          {member.name || 'N/A'}
                                                        </Typography>
                                                        <Typography variant="caption" color="text.secondary">
                                                          {roleGroup.role}
                                                        </Typography>
                                                      </Box>
                                                    </Box>
                                                  </TableCell>
                                                  <TableCell>
                                                    <Typography variant="body2" color="text.secondary">
                                                      {member.ceaNumber || 'N/A'}
                                                    </Typography>
                                                  </TableCell>
                                                  <TableCell>
                                                    <Typography variant="body2" color="text.secondary">
                                                      {member.mobile || 'N/A'}
                                                    </Typography>
                                                  </TableCell>
                                                  {showTaggers && (
                                                    <TableCell>
                                                      {member.taggers && member.taggers.length > 0 ? (
                                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                          {member.taggers.map((tagger, taggerIndex) => (
                                                            <Box key={taggerIndex} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                              <Avatar
                                                                src={getPhotoUrl(tagger.photo)}
                                                                sx={{ width: 28, height: 28, bgcolor: 'primary.light', fontSize: '0.75rem' }}
                                                              >
                                                                {(tagger.name || 'N/A')
                                                                  .split(' ')
                                                                  .map((part) => part[0])
                                                                  .slice(0, 2)
                                                                  .join('')
                                                                  .toUpperCase()}
                                                              </Avatar>
                                                              <Box>
                                                                <Typography variant="caption" fontWeight="medium" display="block">
                                                                  {tagger.name || 'N/A'}
                                                                </Typography>
                                                                <Typography variant="caption" color="text.secondary">
                                                                  CEA: {tagger.ceaNumber || 'N/A'}
                                                                </Typography>
                                                              </Box>
                                                            </Box>
                                                          ))}
                                                        </Box>
                                                      ) : (
                                                        <Typography variant="caption" color="text.secondary">
                                                          -
                                                        </Typography>
                                                      )}
                                                    </TableCell>
                                                  )}
                                                </TableRow>
                                              ))}
                                            </TableBody>
                                          </Table>
                                        </TableContainer>
                                      </Box>
                                    );
                                  })}
                                </Box>
                              ) : (
                                <Typography variant="body2" color="text.secondary">
                                  No project members found
                                </Typography>
                              )}
                            </Box>
                          ) : null
                        )}
                        </Box>
                      </Grid>
                      {/* Right Side - Map */}
                      {(projectDetailsTab !== 'members' || isExternalUser) && projectDetailsTab !== 'files' && (
                        <Grid item xs={12} md={6}>
                          {projectDetails.mapLatitude && projectDetails.mapLongitude ? (
                            <Box
                              sx={{
                                width: '100%',
                                height: '100%',
                                minHeight: 400,
                                borderRadius: 1,
                                overflow: 'hidden',
                                border: '1px solid',
                                borderColor: 'divider',
                                position: 'relative',
                              }}
                            >
                              {canAccessSuperRatio && projectDetailsTab === 'superRatio' ? (
                                <DemandSupplyMap
                                  latitude={projectDetails.mapLatitude}
                                  longitude={projectDetails.mapLongitude}
                                  data={demandSupplyData}
                                  radius={demandSupplyRadius}
                                  minRadius={demandSupplyMinRadius}
                                  nationwide={demandSupplyNationwide}
                                  selectedTypes={selectedDemandSupplyTypes}
                                />
                              ) : (
                                <ProjectMap
                                  latitude={projectDetails.mapLatitude}
                                  longitude={projectDetails.mapLongitude}
                                  tab={projectDetailsTab}
                                  amenitiesData={amenitiesData}
                                  radius={amenitiesRadius}
                                  selectedAmenityTypes={selectedAmenityTypes}
                                />
                              )}
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                width: '100%',
                                height: '100%',
                                minHeight: 400,
                                borderRadius: 1,
                                border: '1px solid',
                                borderColor: 'divider',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: 'grey.100',
                              }}
                            >
                              <Typography variant="body2" color="text.secondary">
                                Map location not available
                              </Typography>
                            </Box>
                          )}
                        </Grid>
                      )}
                    </Grid>
                  ) : (
                    <Box sx={{ py: 2 }}>
                      <Typography variant="body2" color="text.secondary" align="center">
                        Loading project details...
                      </Typography>
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}

        {liveUpdateBannerDetails && !(
          (activeTabId === TOP_VIEWING_SITE_PLANS_TAB && Boolean(selectedTopViewingSitePlan))
          || showTopViewingDetailInGeneric
        ) && (
          <Box sx={{ mb: 4 }}>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'center',
                gap: 1.5,
                px: 2,
                py: 1.5,
                borderRadius: 2,
                border: '1px solid var(--color-danger)',
                bgcolor: 'rgba(var(--color-danger-rgb), 0.08)',
              }}
            >
              {liveUpdateIndicator}
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                Last updated at {formatLiveStatusTimestamp(liveUpdateTimestamp)}.
              </Typography>
            </Box>
          </Box>
        )}

        {activeTabId === TOP_VIEWING_SITE_PLANS_TAB && !activeClient && (
          <Box sx={{ mb: 4 }}>
            {(topViewingSitePlansLoading || topViewingSitePlanContentLoading) && (
              <LinearProgress sx={{ mb: 2 }} />
            )}
            {topViewingSitePlansError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {topViewingSitePlansError}
              </Alert>
            )}

            {!selectedTopViewingSitePlan ? (
              fromProjectEssential ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                  <LinearProgress sx={{ width: '40%' }} />
                </Box>
              ) : (
              /* Card Grid Landing Page */
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                  <Typography variant="h5" sx={{ fontWeight: 600, color: 'var(--color-text-strong)' }}>
                    Select a Site Plan to View
                  </Typography>
                  <TextField
                    size="small"
                    placeholder="Search site plans..."
                    value={topViewingSitePlanSearch}
                    onChange={(e) => setTopViewingSitePlanSearch(e.target.value)}
                    sx={{ minWidth: 260 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: 'rgba(var(--color-text-rgb), 0.5)' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                {filteredUpcomingSitePlans.length > 0 && (
                  <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: 'var(--color-accent)' }}>
                      Upcoming
                    </Typography>
                    <Grid container spacing={3}>
                      {filteredUpcomingSitePlans.map((sitePlan) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={sitePlan.projectId}>
                          <Card
                            sx={{
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              position: 'relative',
                              overflow: 'hidden',
                              ...(sitePlan.upcoming && {
                                border: 'none',
                                '&::before': {
                                  content: '""',
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  width: 'max(200%, 600px)',
                                  height: 'max(200%, 600px)',
                                  transform: 'translate(-50%, -50%)',
                                  zIndex: 0,
                                  background: 'conic-gradient(from 0deg, var(--color-accent), transparent 20%, transparent 80%, var(--color-accent))',
                                  animation: 'runningBorder 3s linear infinite',
                                },
                                '&::after': {
                                  content: '""',
                                  position: 'absolute',
                                  inset: '2.5px',
                                  zIndex: 0,
                                  borderRadius: 'inherit',
                                  background:
                                    currentTheme === 'light'
                                      ? 'var(--color-surface, #ffffff)'
                                      : 'var(--color-bg-card, #1e1e1e)',
                                },
                                '& > *': {
                                  position: 'relative',
                                  zIndex: 1,
                                },
                                '@keyframes runningBorder': {
                                  from: { transform: 'translate(-50%, -50%) rotate(0deg)' },
                                  to: { transform: 'translate(-50%, -50%) rotate(360deg)' },
                                },
                              }),
                              '&:hover': {
                                transform: 'translateY(-8px)',
                                boxShadow: sitePlan.upcoming
                                  ? '0 8px 24px rgba(var(--color-shadow-rgb), 0.3), 0 0 20px rgba(var(--color-accent-rgb, 255,152,0), 0.5)'
                                  : '0 8px 24px rgba(var(--color-shadow-rgb), 0.3)',
                              },
                            }}
                            onClick={() => handleSelectTopViewingSitePlan(sitePlan.projectName)}
                          >
                            {sitePlan.upcoming && (
                              <Box
                                sx={{
                                  '&&': { position: 'absolute' },
                                  top: 0,
                                  left: 0,
                                  zIndex: 2,
                                  width: 110,
                                  height: 110,
                                  overflow: 'hidden',
                                  pointerEvents: 'none',
                                  '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    borderStyle: 'solid',
                                    borderWidth: '6px',
                                    borderColor: 'color-mix(in srgb, var(--color-accent) 70%, #000) transparent transparent color-mix(in srgb, var(--color-accent) 70%, #000)',
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: 18,
                                    left: -28,
                                    width: 140,
                                    textAlign: 'center',
                                    transform: 'rotate(-45deg)',
                                    bgcolor: 'var(--color-accent)',
                                    color: '#fff',
                                    fontSize: '0.75rem',
                                    fontWeight: 700,
                                    letterSpacing: '0.08em',
                                    py: 0.6,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                    background: 'linear-gradient(135deg, color-mix(in srgb, var(--color-accent) 85%, #fff) 0%, var(--color-accent) 50%, color-mix(in srgb, var(--color-accent) 85%, #000) 100%)',
                                    overflow: 'hidden',
                                    '&::after': {
                                      content: '""',
                                      position: 'absolute',
                                      top: 0,
                                      left: '-100%',
                                      width: '100%',
                                      height: '100%',
                                      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
                                      animation: 'ribbonShimmer 3s ease-in-out infinite',
                                    },
                                    '@keyframes ribbonShimmer': {
                                      '0%': { left: '-100%' },
                                      '50%, 100%': { left: '100%' },
                                    },
                                  }}
                                >
                                  UPCOMING
                                </Box>
                              </Box>
                            )}
                            <SitePlanCardThumbnail sitePlan={sitePlan} upcoming={Boolean(sitePlan.upcoming)} />
                            <CardContent sx={{ position: 'relative' }}>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5, color: 'var(--color-text-strong)' }}>
                                {sitePlan.projectName}
                              </Typography>
                              {(sitePlan.district || sitePlan.topDate || sitePlan.area) && (
                                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', mb: 0.5 }}>
                                  {[
                                    sitePlan.district ? `${sitePlan.district}` : null,
                                    sitePlan.topDate ? `TOP: ${sitePlan.topDate}` : null,
                                    sitePlan.area || null,
                                  ]
                                    .filter(Boolean)
                                    .join(' • ')}
                                </Typography>
                              )}
                              {sitePlan.location && (
                                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                  {sitePlan.location}
                                </Typography>
                              )}
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}
                {paginatedRegularSitePlans.length > 0 && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: 'var(--color-text-strong)' }}>
                      {topViewingSecondarySectionTitle}
                    </Typography>
                    <Grid container spacing={3}>
                      {paginatedRegularSitePlans.map((sitePlan) => {
                        const rankTheme = sitePlan.weeklyRank === 1
                          ? {
                              trophy: '#f4c84f',
                              text: '#3f2a00',
                              glow: 'rgba(255, 198, 74, 0.5)',
                            }
                          : sitePlan.weeklyRank === 2
                          ? {
                              trophy: '#d3dceb',
                              text: '#1f2b3a',
                              glow: 'rgba(182, 198, 219, 0.48)',
                            }
                          : {
                              trophy: '#cf9164',
                              text: '#3f2110',
                              glow: 'rgba(206, 137, 84, 0.5)',
                            };

                        return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={sitePlan.projectId}>
                          <Card
                            sx={{
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              position: 'relative',
                              overflow: 'hidden',
                              '&:hover': {
                                transform: 'translateY(-8px)',
                                boxShadow: '0 8px 24px rgba(var(--color-shadow-rgb), 0.3)',
                              },
                            }}
                            onClick={() => handleSelectTopViewingSitePlan(sitePlan.projectName)}
                          >
                            {topViewingHasWeeklySales &&
                              sitePlan.weeklyRank != null &&
                              sitePlan.weeklyRank > 0 &&
                              sitePlan.weeklyRank <= 3 && (
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: -6,
                                    right: 16,
                                    zIndex: 4,
                                    pointerEvents: 'none',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    filter: `drop-shadow(0 2px 6px ${rankTheme.glow})`,
                                  }}
                                >
                                  {/* Ribbon */}
                                  <Box
                                    sx={{
                                      width: 44,
                                      height: 28,
                                      background: `linear-gradient(180deg, ${rankTheme.trophy} 0%, ${rankTheme.trophy}dd 100%)`,
                                      clipPath: 'polygon(0 0, 100% 0, 100% 100%, 50% 75%, 0 100%)',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      pt: '2px',
                                    }}
                                  />
                                  {/* Medal circle */}
                                  <Box
                                    sx={{
                                      position: 'relative',
                                      width: 48,
                                      height: 48,
                                      borderRadius: '50%',
                                      background: `radial-gradient(circle at 35% 35%, ${rankTheme.trophy}, ${rankTheme.trophy}bb)`,
                                      border: `3px solid ${rankTheme.trophy}`,
                                      boxShadow: `0 0 16px ${rankTheme.glow}, inset 0 -2px 6px rgba(0,0,0,0.2)`,
                                      display: 'grid',
                                      placeItems: 'center',
                                      mt: '-6px',
                                      overflow: 'hidden',
                                      '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: '-20%',
                                        left: '-140%',
                                        width: '60%',
                                        height: '140%',
                                        background: 'linear-gradient(110deg, transparent, rgba(255,255,255,0.6), transparent)',
                                        transform: 'skewX(-20deg)',
                                        animation: 'medalSweep 3s ease-in-out infinite',
                                      },
                                      '@keyframes medalSweep': {
                                        '0%': { left: '-140%' },
                                        '40%, 100%': { left: '140%' },
                                      },
                                    }}
                                  >
                                    <Box
                                      component="span"
                                      sx={{
                                        fontSize: '1.25rem',
                                        fontWeight: 900,
                                        color: rankTheme.text,
                                        textShadow: '0 1px 2px rgba(255,255,255,0.4)',
                                        lineHeight: 1,
                                      }}
                                    >
                                      {sitePlan.weeklyRank}
                                    </Box>
                                  </Box>
                                </Box>
                              )}
                            <SitePlanCardThumbnail sitePlan={sitePlan} />
                            <CardContent sx={{ position: 'relative' }}>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5, color: 'var(--color-text-strong)' }}>
                                {sitePlan.projectName}
                              </Typography>
                              {(sitePlan.district || sitePlan.topDate || sitePlan.area) && (
                                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', mb: 0.5 }}>
                                  {[
                                    sitePlan.district ? `${sitePlan.district}` : null,
                                    sitePlan.topDate ? `TOP: ${sitePlan.topDate}` : null,
                                    sitePlan.area || null,
                                  ]
                                    .filter(Boolean)
                                    .join(' • ')}
                                </Typography>
                              )}
                              {sitePlan.location && (
                                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                  {sitePlan.location}
                                </Typography>
                              )}
                            </CardContent>
                          </Card>
                        </Grid>
                      )})}
                    </Grid>
                  </Box>
                )}
                {totalSitePlanPages > 1 && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination
                      count={totalSitePlanPages}
                      page={topViewingSitePlanPage}
                      onChange={(_, page) => setTopViewingSitePlanPage(page)}
                      color="primary"
                      shape="rounded"
                    />
                  </Box>
                )}
                {filteredTopViewingSitePlans.length === 0 && topViewingSitePlanSearchDebounced && (
                  <Typography sx={{ textAlign: 'center', mt: 4, color: 'rgba(var(--color-text-rgb), 0.5)' }}>
                    No site plans found matching "{topViewingSitePlanSearchDebounced}"
                  </Typography>
                )}
              </Box>
              )
            ) : (
              <>
                <TopViewingSitePlanDetail
                key={topViewingDetailEntrySignature ?? 'top-viewing'}
                onAISummaryClick={topViewingComparableUnits.length > 0 ? generateTopViewingAISummary : undefined}
                ceaNumber={userInfo?.CEANumber || getDevCea()}
                isPdfCapturing={isPdfCapturingTowerView}
                onExportProjectReport={isExternalUser ? undefined : handleExportProjectReport}
                hideShortlist={isExternalUser}
                topViewingSitePlans={topViewingSitePlans}
                selectedTopViewingSitePlan={selectedTopViewingSitePlan}
                handleSelectTopViewingSitePlan={handleSelectTopViewingSitePlan}
                setSelectedTopViewingSitePlan={handleClearTopViewingSitePlan}
                fromProjectEssential={fromProjectEssential}
                onBackToProjectEssential={fromProjectEssential ? handleBackToProjectEssential : undefined}
                projectDetails={projectDetails}
                referenceUnit={referenceUnit}
                selectedProject={selectedProject}
                projectDetailsLoading={projectDetailsLoading}
                projectSectionExpanded={projectSectionExpanded}
                setProjectSectionExpanded={setProjectSectionExpanded}
                projectDetailsTab={projectDetailsTab}
                setProjectDetailsTab={setProjectDetailsTab}
                fetchAmenities={fetchAmenities}
                fetchProjectMembers={fetchProjectMembers}
                amenitiesRadius={amenitiesRadius}
                setAmenitiesRadius={setAmenitiesRadius}
                selectedAmenityTypes={selectedAmenityTypes}
                setSelectedAmenityTypes={setSelectedAmenityTypes}
                amenitiesLoading={amenitiesLoading}
                amenitiesData={amenitiesData}
                fetchDemandSupply={fetchDemandSupply}
                demandSupplyRadius={demandSupplyRadius}
                demandSupplyMinRadius={demandSupplyMinRadius}
                onDemandSupplyRadiusChange={handleDemandSupplyRadiusChange}
                demandSupplyNationwide={demandSupplyNationwide}
                onDemandSupplyNationwideChange={handleDemandSupplyNationwideChange}
                demandSupplyData={demandSupplyData}
                demandSupplyLoading={demandSupplyLoading}
                selectedDemandSupplyTypes={selectedDemandSupplyTypes}
                setSelectedDemandSupplyTypes={setSelectedDemandSupplyTypes}
            projectMembersLoading={projectMembersLoading}
            projectMembers={projectMembers}
            canViewProjectMembers={!isExternalUser}
            onMemberTap={handleProjectMemberTap}
            disableSetReferenceAction={isExternalUser}
            disableAddToCompareAction={isExternalUser}
            isAdminUser={isAdminUser}
            isProjectDeptUser={isProjectDeptUser}
            userRoles={normalizedUserRoles}
            canAccessSuperRatio={canAccessSuperRatio}
            canCreateShareLink={canAccessSharableLinks}
            canAccessNearbyDeal={canAccessNearbyDeal}
            canAccessSitePlan3d={canAccessSitePlan3d}
            canAccessSitePlan3dSun={canAccessSitePlan3dSun}
            priceMatrixSimulationSession={activePriceMatrixSimulationSession}
            priceMatrixSimulationLoading={priceMatrixSimulationLoadingProjectId === projectDetails?.id}
            priceMatrixSimulationRefreshing={priceMatrixSimulationRefreshingProjectId === projectDetails?.id}
            priceMatrixSimulationError={priceMatrixSimulationError}
            onLoadPriceMatrixSimulation={handleLoadPriceMatrixSimulation}
            onRefreshPriceMatrixSimulation={handleRefreshPriceMatrixSimulation}
            onTogglePriceMatrixSimulationSync={handleTogglePriceMatrixSimulationSync}
            onSetPriceMatrixSimulationStatus={handleSetPriceMatrixSimulationStatus}
            onApplyPriceMatrixSimulationStatuses={handleApplyPriceMatrixSimulationStatuses}
            onCancelPriceMatrixSimulation={handleCancelPriceMatrixSimulation}
            getPhotoUrl={getPhotoUrl}
                shouldShowSitePlanButton={shouldShowSitePlanButton}
                handleOpenSitePlan={handleOpenSitePlan}
                handleOpenTowerView={handleOpenTowerView}
                sitePlanData={sitePlanData}
                sitePlanLoading={sitePlanLoading}
                sitePlanShowPoints={sitePlanShowPoints}
                setSitePlanShowPoints={setSitePlanShowPoints}
                sitePlanShowHeatMap={sitePlanShowHeatMap}
                setSitePlanShowHeatMap={setSitePlanShowHeatMap}
                sitePlanBedroomFilter={sitePlanBedroomFilter}
                setSitePlanBedroomFilter={setSitePlanBedroomFilter}
                sitePlanUnitTypeFilter={sitePlanUnitTypeFilter}
                sitePlanUnitTypeFilterForMatching={sitePlanUnitTypeFilterExpanded}
                sitePlanUnitTypeFilterExpandedUnitTypes={sitePlanUnitTypeFilterExpandedUnitTypes}
                setSitePlanUnitTypeFilter={setSitePlanUnitTypeFilter}
                sitePlanUnitTypes={sitePlanUnitTypesForBedroomFilter}
                sitePlanBlinkingStacks={sitePlanBlinkingStacks}
                sitePlanStackSoldPercentages={effectiveSitePlanStackSoldPercentages}
                sitePlanProjectName={sitePlanProjectName}
                handleOpenStackAnalysis={handleOpenStackAnalysis}
                isMobileSitePlan={isMobileSitePlan}
                sitePlanDotSize={sitePlanDotSize}
                sitePlanDotBorder={sitePlanDotBorder}
                sitePlanDotShadow={sitePlanDotShadow}
                sitePlanDotFontSize={sitePlanDotFontSize}
                shouldHideNonMatchingSitePlanStack={shouldHideNonMatchingSitePlanStack}
                getHeatMapColor={getHeatMapColor}
                normalizeStackKey={normalizeStackKey}
                sitePlanMenuOpen={sitePlanMenuOpen}
                setSitePlanMenuOpen={setSitePlanMenuOpen}
                sitePlanStackBedrooms={sitePlanStackBedrooms}
                sitePlanStackFilter={sitePlanStackFilter}
                setSitePlanStackFilter={setSitePlanStackFilter}
                sitePlanStacksOptions={sitePlanStacksOptions}
                topViewingTowerZoom={topViewingTowerZoom}
                setTopViewingTowerZoom={setTopViewingTowerZoom}
                topViewingTowerDisplayOptions={topViewingTowerDisplayOptions}
                setTopViewingTowerDisplayOptions={setTopViewingTowerDisplayOptions}
                showPsfColumnByDefault={topViewingShowPsfColumnByDefault}
                topViewingTowerBedroomColor={topViewingTowerBedroomColor}
                setTopViewingTowerBedroomColor={setTopViewingTowerBedroomColor}
                towerViewData={towerViewData}
                towerViewUnits={effectiveTowerViewUnits}
                towerViewUnitTypes={towerViewUnitTypes}
                topViewingBestPxBedroomSitePlan={topViewingBestPxBedroomSitePlan}
                topViewingBestByUnitTypeData={topViewingBestByUnitTypeForDisplay}
                topViewingBestByUnitTypeLoading={topViewingBestByUnitTypeForDisplayLoading}
                isTopViewingIndicativeBeforeLaunch={isTopViewingIndicativeBeforeLaunch}
                topViewingFilteredAvailableUnits={topViewingFilteredAvailableUnits}
                topViewingDetailedAvailableUnits={topViewingDetailedAvailableUnits}
                topViewingSortedUnits={topViewingSortedUnits}
                topViewingSortConfig={topViewingSortConfig}
                topViewingPopoverAnchor={topViewingPopoverAnchor}
                topViewingAvailableUnitFilters={topViewingAvailableUnitFilters}
                setTopViewingAvailableUnitFilters={setTopViewingAvailableUnitFilters}
                topViewingUnitMenuAnchor={topViewingUnitMenuAnchor}
                setTopViewingUnitMenuAnchor={setTopViewingUnitMenuAnchor}
                handleTopViewingOpenPopover={handleTopViewingOpenPopover}
                handleTopViewingClosePopover={handleTopViewingClosePopover}
                handleTopViewingSortChange={handleTopViewingSortChange}
                handleTopViewingFilterChange={handleTopViewingFilterChange}
                handleTopViewingRangeFilterChange={(col, bound, val) => handleTopViewingRangeFilterChange(col as Parameters<typeof handleTopViewingRangeFilterChange>[0], bound, val)}
                hasTopViewingActiveFilter={hasTopViewingActiveFilter}
                getTopViewingSortDirection={getTopViewingSortDirection}
                topViewingAvailableUnitsViewMode={topViewingAvailableUnitsViewMode}
                setTopViewingAvailableUnitsViewMode={setTopViewingAvailableUnitsViewMode}
                topViewingCompViewMode={topViewingCompViewMode}
                setTopViewingCompViewMode={setTopViewingCompViewMode}
            topViewingFloorPlanOpen={topViewingFloorPlanOpen}
            setTopViewingFloorPlanOpen={setTopViewingFloorPlanOpen}
            topViewingFloorPlanUrl={topViewingFloorPlanUrl}
            setTopViewingFloorPlanUrl={setTopViewingFloorPlanUrl}
            topViewingFloorPlanLoading={topViewingFloorPlanLoading}
            topViewingFloorPlanUnit={topViewingFloorPlanUnit}
                topViewingReferenceUnit={topViewingReferenceUnit}
                setTopViewingReferenceUnit={setTopViewingReferenceUnit}
                topViewingBlinkerChoiceUnit={topViewingBlinkerChoiceUnit}
                setTopViewingBlinkerChoiceUnit={setTopViewingBlinkerChoiceUnit}
                topViewingBlinkerMinTolerance={topViewingBlinkerMinTolerance}
                setTopViewingBlinkerMinTolerance={setTopViewingBlinkerMinTolerance}
                setTopViewingBlinkerMinPriceOverride={setTopViewingBlinkerMinPriceOverride}
                topViewingBlinkerTolerance={topViewingBlinkerTolerance}
                setTopViewingBlinkerTolerance={setTopViewingBlinkerTolerance}
                setTopViewingBlinkerMaxPriceOverride={setTopViewingBlinkerMaxPriceOverride}
                topViewingBlinkerSuperUpgrade={topViewingBlinkerSuperUpgrade}
                setTopViewingBlinkerSuperUpgrade={setTopViewingBlinkerSuperUpgrade}
                topViewingBlinkerRange={topViewingBlinkerRange}
                handleTopViewingIndicativeReference={handleTopViewingIndicativeReference}
                handleTopViewingGuesstimationReference={handleTopViewingGuesstimationReference}
                topViewingComparableUnits={topViewingComparableUnits}
                topViewingComparableUnitsLoading={topViewingComparableUnitsLoading}
                topViewingAreaTolerance={topViewingAreaTolerance}
                setTopViewingAreaTolerance={setTopViewingAreaTolerance}
                topViewingToleranceSliderValue={topViewingToleranceSliderValue}
                setTopViewingToleranceSliderValue={setTopViewingToleranceSliderValue}
                topViewingToleranceModalOpen={topViewingToleranceModalOpen}
                setTopViewingToleranceModalOpen={setTopViewingToleranceModalOpen}
                topViewingComparableSectionOpen={topViewingComparableSectionOpen}
                setTopViewingComparableSectionOpen={setTopViewingComparableSectionOpen}
                topViewingCompFilters={topViewingCompFilters}
                setTopViewingCompFilters={setTopViewingCompFilters}
                topViewingCompRangeFilters={topViewingCompRangeFilters}
                topViewingCompRangeFiltersApplied={debouncedTopViewingCompRangeFilters}
                setTopViewingCompRangeFilters={(v) => setTopViewingCompRangeFilters(v as Parameters<typeof setTopViewingCompRangeFilters>[0])}
                topViewingCompPopoverAnchor={topViewingCompPopoverAnchor}
                topViewingThumbsUpFilterActive={topViewingThumbsUpFilterActive}
                setTopViewingThumbsUpFilterActive={setTopViewingThumbsUpFilterActive}
                topViewingCompSortConfig={topViewingCompSortConfig}
                setTopViewingCompSortConfig={setTopViewingCompSortConfig}
                topViewingFloorPlansToCompare={topViewingFloorPlansToCompare}
                setTopViewingFloorPlansToCompare={setTopViewingFloorPlansToCompare}
                topViewingComparableSectionRef={topViewingComparableSectionRef}
                topViewingTowerViewSectionRef={topViewingTowerViewSectionRef}
                topViewingThumbsUpLegendAnchor={topViewingThumbsUpLegendAnchor}
                setTopViewingThumbsUpLegendAnchor={setTopViewingThumbsUpLegendAnchor}
                handleTopViewingCompOpenPopover={handleTopViewingCompOpenPopover}
                handleTopViewingCompClosePopover={handleTopViewingCompClosePopover}
                handleTopViewingCompFilterChange={(col, val) => handleTopViewingCompFilterChange(col as Parameters<typeof handleTopViewingCompFilterChange>[0], val)}
                handleTopViewingCompRangeFilterChange={(col, bound, val) => handleTopViewingCompRangeFilterChange(col as Parameters<typeof handleTopViewingCompRangeFilterChange>[0], bound as 'min' | 'max', val)}
                handleTopViewingCompSort={handleTopViewingCompSort}
                hasTopViewingCompActiveFilter={hasTopViewingCompActiveFilter}
                getTopViewingCompColumnLabel={getTopViewingCompColumnLabel}
                topViewingFilteredComparableUnits={topViewingFilteredComparableUnits}
                topViewingComparableResultProjectNames={topViewingComparableResultProjectNames}
                topViewingComparableResultProjectCategories={topViewingComparableResultProjectCategories}
                topViewingComparableResultUnitTypeDescriptions={topViewingComparableResultUnitTypeDescriptions}
                handleTopViewingAddToUnitCompare={handleTopViewingAddToUnitCompare}
                analyticsCea={userInfo?.CEANumber || getDevCea()}
                topViewingBudgetSectionOpen={topViewingBudgetSectionOpen}
                setTopViewingBudgetSectionOpen={setTopViewingBudgetSectionOpen}
                topViewingBudgetTolerance={topViewingBudgetTolerance}
                setTopViewingBudgetTolerance={setTopViewingBudgetTolerance}
                topViewingBudgetSliderValue={topViewingBudgetSliderValue}
                setTopViewingBudgetSliderValue={setTopViewingBudgetSliderValue}
                topViewingBudgetUnitsLoading={topViewingBudgetUnitsLoading}
                topViewingBudgetUnitsError={topViewingBudgetUnitsError}
                topViewingBudgetRange={topViewingBudgetRange}
                topViewingBudgetSearchRange={topViewingBudgetSearchRange}
                handleTopViewingBudgetSearchRangeChange={handleTopViewingBudgetSearchRangeChange}
                topViewingBudgetViewMode={topViewingBudgetViewMode}
                setTopViewingBudgetViewMode={setTopViewingBudgetViewMode}
                topViewingBudgetRegionTab={topViewingBudgetRegionTab}
                setTopViewingBudgetRegionTab={setTopViewingBudgetRegionTab}
                topViewingBudgetSortedUnits={topViewingBudgetSortedUnits}
                topViewingBudgetPopoverAnchor={topViewingBudgetPopoverAnchor}
                topViewingBudgetSortConfig={topViewingBudgetSortConfig}
                topViewingBudgetFilters={topViewingBudgetFilters}
                topViewingBudgetExclusionFilters={topViewingBudgetExclusionFilters}
                topViewingBudgetUniqueFilterOptions={topViewingBudgetUniqueFilterOptions}
                handleTopViewingBudgetExclusionFilterChange={handleTopViewingBudgetExclusionFilterChange}
            handleTopViewingBudgetExclusionFilterSet={handleTopViewingBudgetExclusionFilterSet}
                topViewingBudgetRangeFilters={topViewingBudgetRangeFilters}
                topViewingOutlayInfoAnchor={topViewingOutlayInfoAnchor}
                setTopViewingOutlayInfoAnchor={setTopViewingOutlayInfoAnchor}
                topViewingInstallmentInfoAnchor={topViewingInstallmentInfoAnchor}
                setTopViewingInstallmentInfoAnchor={setTopViewingInstallmentInfoAnchor}
                handleTopViewingBudgetOpenPopover={handleTopViewingBudgetOpenPopover}
                handleTopViewingBudgetClosePopover={handleTopViewingBudgetClosePopover}
                handleTopViewingBudgetFilterChange={(col, val) => handleTopViewingBudgetFilterChange(col as Parameters<typeof handleTopViewingBudgetFilterChange>[0], val)}
                handleTopViewingBudgetRangeFilterChange={(col, bound, val) => handleTopViewingBudgetRangeFilterChange(col as Parameters<typeof handleTopViewingBudgetRangeFilterChange>[0], bound, val)}
                handleTopViewingBudgetSortChange={handleTopViewingBudgetSortChange}
                getTopViewingBudgetSortDirection={getTopViewingBudgetSortDirection}
                hasTopViewingBudgetActiveFilter={hasTopViewingBudgetActiveFilter}
                getTopViewingBudgetIconButtonSx={getTopViewingBudgetIconButtonSx}
                handleTopViewingBudgetClearFilters={handleTopViewingBudgetClearFilters}
                getBudgetProjectCellValue={(projectName, key) => getBudgetProjectCellValue(projectName, key as Parameters<typeof getBudgetProjectCellValue>[1])}
                topViewingBudgetProjectsForView={topViewingBudgetProjectsForView}
                onOpenBudgetInProjectResearch={handleOpenBudgetInProjectResearch}
                topViewingBudgetNearbyRadiusKm={topViewingBudgetNearbyRadiusKm}
                setTopViewingBudgetNearbyRadiusKm={setTopViewingBudgetNearbyRadiusKm}
                topViewingBudgetShowReferenceProjectUnits={topViewingBudgetShowReferenceProjectUnits}
                setTopViewingBudgetShowReferenceProjectUnits={setTopViewingBudgetShowReferenceProjectUnits}
            handleTopViewingUnitMenuViewFloorPlan={(unit) => {
              setTopViewingUnitMenuAnchor(null);
              const mapped = toTopViewingComparableUnit(unit);
              handleOpenFloorPlan(mapped);
            }}
                handleTopViewingUnitMenuSetReference={handleTopViewingSetReferenceFromMenu}
                handleTopViewingUnitMenuSetBlinkerChoice={handleTopViewingSetBlinkerChoiceFromMenu}
                handleTopViewingUnitMenuToggleCompare={(unit) => {
                  if (isExternalUser) {
                    setTopViewingUnitMenuAnchor(null);
                    return;
                  }
                  handleTopViewingAddToUnitCompare(unit);
                  setTopViewingUnitMenuAnchor(null);
                }}
                formatCurrency={formatCurrency}
                formatNumber={formatNumber}
                getAreaRangeLabel={getAreaRangeLabel}
                getOutlayFormulaTooltip={getOutlayFormulaTooltip}
                getInstallmentFormulaTooltip={getInstallmentFormulaTooltip}
                onOpenFinancialParameters={() => setFinancialParametersOpen(true)}
                onOpenNpsInfo={() => setNpsDpsInfoDialog('nps')}
                onOpenDpsInfo={() => setNpsDpsInfoDialog('dps')}
                currentInterestRate={interestRate}
                loanToValue={loanToValue}
                getIconButtonSx={getIconButtonSx}
                qualifiesForThumbsUp={topViewingQualifiesForThumbsUp}
                getTopViewingDistanceFromReference={getTopViewingDistanceFromReference}
                projectDetailsMap={projectDetailsMap}
                projectViewPopoverAnchor={projectViewPopoverAnchor}
                setProjectViewPopoverAnchor={setProjectViewPopoverAnchor}
                projectViewFilters={projectViewFilters}
                setProjectViewFilters={setProjectViewFilters}
                projectViewRangeFilters={projectViewRangeFilters}
                setProjectViewRangeFilters={setProjectViewRangeFilters}
                projectViewDistrictFilter={projectViewDistrictFilter}
                setProjectViewDistrictFilter={setProjectViewDistrictFilter}
                projectViewDistrictOptions={PROJECT_VIEW_DISTRICT_OPTIONS}
                projectViewNumericColumns={PROJECT_VIEW_NUMERIC_COLUMNS}
                formatBlockNumber={formatBlockNumber}
                normalizeBedroomValue={normalizeBedroomValue}
                handleOpenSitePlanForProject={handleOpenSitePlanForProject}
                handleOpenFloorPlan={handleOpenFloorPlan}
                onOpenFloorPlanCompare={handleOpenTopViewingFloorPlanCompare}
                handleOpenPriceChart={handleOpenPriceChart}
                handleShortlistAction={handleShortlistAction}
                setPricePromoInfoOpen={setPricePromoInfoOpen}
                getPriceDiffColor={getPriceDiffColor}
                parseUnitNumber={parseUnitNumber}
                shortlistByUnitId={shortlistByUnitId}
                shortlistUpdatingUnitId={shortlistUpdatingUnitId}
                topViewingProjectsForProjectView={topViewingProjectsForProjectView}
                topViewingFilteredProjectsForView={topViewingFilteredProjectsForView}
                PROJECT_VIEW_COLUMN_KEYS={PROJECT_VIEW_COLUMN_KEYS}
                setProjectDetailsMap={setProjectDetailsMap}
                nearbyThumbsupGroups={thumbsupGroupsByProject}
                nearbyPricePromoGroups={pricePromoAllProjectGroups}
                pricePromoBestByStackBedroom={pricePromoBestByStackBedroom}
                pricePromoUnitIds={pricePromoUnitIds}
                handleThumbsupUnitClick={handleThumbsupUnitClick}
                handlePricePromoUnitClick={handlePricePromoUnitClick}
                formatThumbsupUnitSqft={formatThumbsupUnitSqft}
                formatPricePromoDate={formatPricePromoDate}
              />
              </>
            )}
          </Box>
        )}

        {activeClient && activeClient.choiceUnits?.length > 0 && (
          <Box ref={choiceTabsRef} sx={{ mb: 4, position: 'relative', mt: 1 }}>
            {/* Group labels - positioned absolutely to span tab groups */}
            {(() => {
              const sheetIndices: number[] = [];
              const pickerIndices: number[] = [];
              activeClient.choiceUnits.forEach((unit, index) => {
                if (unit.type === 'SHEET') {
                  sheetIndices.push(index);
                } else if (unit.type === 'PICKER') {
                  pickerIndices.push(index);
                }
              });
              
              return (
                <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 24, zIndex: 1, pointerEvents: 'none' }}>
                  {sheetIndices.length > 0 && sheetHeaderStyle && (
                    <Box
                      sx={{
                        position: 'absolute',
                        left: `${sheetHeaderStyle.left}px`,
                        top: 0,
                        height: 24,
                        width: `${sheetHeaderStyle.width}px`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 1,
                        backgroundColor: 'rgba(var(--color-info-rgb), 0.15)',
                        borderRadius: '4px',
                        border: '1px solid',
                        borderColor: 'rgba(var(--color-info-rgb), 0.3)',
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: 600,
                          color: 'var(--color-info-soft-text)',
                          fontSize: '10px',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Imported From Sheet ({sheetIndices.length})
                      </Typography>
                    </Box>
                  )}
                  {pickerIndices.length > 0 && pickerHeaderStyle && (
                    <Box
                      sx={{
                        position: 'absolute',
                        left: `${pickerHeaderStyle.left}px`,
                        top: 0,
                        height: 24,
                        width: `${pickerHeaderStyle.width}px`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 1,
                        backgroundColor: 'rgba(var(--color-secondary-rgb), 0.15)',
                        borderRadius: '4px',
                        border: '1px solid',
                        borderColor: 'rgba(var(--color-secondary-rgb), 0.3)',
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: 600,
                          color: 'secondary.main',
                          fontSize: '10px',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Picker ({pickerIndices.length})
                      </Typography>
                    </Box>
                  )}
                </Box>
              );
            })()}
            
            <Box sx={{ pt: 3 }}>
              <Tabs
              value={choiceUnitTabIndex}
              onChange={(_, newValue) => {
                setChoiceUnitTabIndex(newValue);
                const unit = activeClient.choiceUnits[newValue];
                if (unit) {
                  openClientTab(activeClient, unit);
                }
              }}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                mb: 0,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontWeight: 600,
                  minHeight: 48,
                  paddingX: 3,
                  paddingY: 1.5,
                  borderRadius: '12px 12px 0 0',
                  color: 'rgba(var(--color-text-rgb), 0.85)',
                  bgcolor: 'var(--color-surface-elevated)',
                  transition: 'all 0.2s ease',
                  position: 'relative',
                  overflow: 'hidden',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '2px',
                    backgroundColor: 'transparent',
                    transition: 'background-color 0.2s ease',
                  },
                },
                '& .MuiTab-root.Mui-selected': {
                  color: 'var(--color-accent)',
                  bgcolor: 'var(--color-surface-elevated-strong)',
                  '&::after': {
                    backgroundColor: 'var(--color-accent)',
                  },
                },
              }}
            >
                {activeClient.choiceUnits.map((unit, index) => {
                  const isSold = unit.status?.toUpperCase() === 'SOLD';
                  const isSheet = unit.type === 'SHEET';
                  const isPicker = unit.type === 'PICKER';
                  const prevUnit = index > 0 ? activeClient.choiceUnits[index - 1] : null;
                  const showDivider = prevUnit && prevUnit.type !== unit.type;
                  
                  return (
                    <Tab
                      key={`${activeClient.id}-${unit.projectName}-${unit.unitNumber}-${index}`}
                      label={
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.2, color: 'inherit' }}>
                              Choice {index + 1}
                            </Typography>
                            {isSheet && (
                              <Chip
                                label="Sheet"
                                size="small"
                                sx={{
                                  height: 16,
                                  fontSize: '8px',
                                  fontWeight: 600,
                                  backgroundColor: 'rgba(var(--color-info-rgb), 0.2)',
                                  color: 'primary.main',
                                  '& .MuiChip-label': {
                                    padding: '0 4px',
                                  },
                                }}
                              />
                            )}
                            {isPicker && (
                              <Chip
                                label="Picker"
                                size="small"
                                sx={{
                                  height: 16,
                                  fontSize: '8px',
                                  fontWeight: 600,
                                  backgroundColor: 'rgba(var(--color-secondary-rgb), 0.2)',
                                  color: 'secondary.main',
                                  '& .MuiChip-label': {
                                    padding: '0 4px',
                                  },
                                }}
                              />
                            )}
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                            <Typography variant="caption" sx={{ fontWeight: 500, lineHeight: 1.2, color: 'inherit' }}>
                              {unit.unitNumber || 'N/A'}
                            </Typography>
                            {isSold && (
                              <Chip
                                label="SOLD"
                                size="small"
                                sx={{
                                  height: 18,
                                  fontSize: '9px',
                                  fontWeight: 700,
                                  backgroundColor: 'var(--color-danger)',
                                  color: 'var(--color-white)',
                                  '& .MuiChip-label': {
                                    padding: '0 6px',
                                  },
                                }}
                              />
                            )}
                          </Box>
                        </Box>
                      }
                      sx={{
                        bgcolor: isSheet ? 'rgba(var(--color-info-rgb), 0.18)' : isPicker ? 'rgba(var(--color-secondary-rgb), 0.18)' : 'var(--color-surface-elevated)',
                        borderLeft: showDivider ? '3px solid' : 'none',
                        borderColor: showDivider ? (isSheet ? 'rgba(var(--color-info-rgb), 0.4)' : 'rgba(var(--color-secondary-rgb), 0.4)') : 'transparent',
                        ml: showDivider ? 0.5 : 0,
                        color: 'rgba(var(--color-text-rgb), 0.7)',
                        '&.Mui-selected': {
                          bgcolor: 'var(--color-surface-elevated-strong)',
                          color: 'var(--color-accent)',
                          '&::after': {
                            backgroundColor: 'var(--color-accent)',
                          },
                        },
                      }}
                    />
                  );
                })}
              </Tabs>
            </Box>
            <Box
              sx={{
                bgcolor: 'background.paper',
                borderRadius: '0 0 8px 8px',
                border: '1px solid',
                borderColor: 'divider',
                borderTop: 'none',
                boxShadow: '0 2px 8px rgba(var(--color-shadow-rgb), 0.08)',
                mt: '-1px',
              }}
            >
              {/* {activeClient.choiceUnits[choiceUnitTabIndex] && (
                <Box sx={{ p: 2.5, borderBottom: referenceUnit ? '1px solid' : 'none', borderColor: 'divider' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography variant="body2" fontWeight={500} color="text.primary">
                      {activeClient.choiceUnits[choiceUnitTabIndex].projectName}
                    </Typography>
                    {activeClient.choiceUnits[choiceUnitTabIndex].status && (
                      <Chip
                        label={activeClient.choiceUnits[choiceUnitTabIndex].status}
                        size="small"
                        color={getUnitStatusColor(activeClient.choiceUnits[choiceUnitTabIndex].status)}
                      />
                    )}
                  </Box>
                </Box>
              )} */}
            </Box>
          </Box>
        )}

        {/* Comparable Units Section - Show for both generic tool and client tabs */}
        {referenceUnit && activeTabId !== 'master' && activeTabId !== TOP_VIEWING_SITE_PLANS_TAB && !showTopViewingDetailInGeneric && (
          <Box ref={referenceUnitCardRef}>
            <Card sx={{ mb: 4 }}>
                <Box sx={{ p: 3, bgcolor: 'var(--color-surface)' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: viewMode === 'unit' && areaTolerancePercent > 0 ? 1 : 2, flexWrap: 'wrap', gap: 1 }}>
              {viewMode === 'unit' ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.25 }}>
                  <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', gap: 0.5 }}>
                    <Typography variant="h6" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, letterSpacing: '-0.02em' }}>
                      Best-matched {referenceUnit?.bedroom}-Bedroom units
                    </Typography>
                    <Typography
                      component="span"
                      onClick={() => {
                        setSizeToleranceSliderValue(areaTolerancePercent);
                        setSizeToleranceModalOpen(true);
                      }}
                      sx={{
                        color: 'var(--color-accent)',
                        fontWeight: 600,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        textUnderlineOffset: 3,
                        '&:hover': { color: 'var(--color-accent-strong)' },
                      }}
                    >
                      ({referenceUnit?.areaSqft != null ? Math.round(referenceUnit.areaSqft).toLocaleString() : '—'} sqft{areaTolerancePercent > 0 ? ` ±${areaTolerancePercent}%` : ''})
                    </Typography>
                    <Typography variant="h6" sx={{ color: 'var(--color-text-strong)', fontWeight: 600, letterSpacing: '-0.02em' }}>
                      {' '}you may consider
                    </Typography>
                  </Box>
                  {areaTolerancePercent > 0 && referenceUnit?.areaSqft != null && (
                    <Typography variant="caption" sx={{ color: 'var(--color-text-muted)', display: 'block' }}>
                      Current size range: {getAreaRangeLabel(referenceUnit.areaSqft, areaTolerancePercent) ?? '—'}
                    </Typography>
                  )}
                </Box>
              ) : (
                <Typography variant="h6" sx={{ color: 'var(--color-text-strong)' }}>
                  {viewMode === 'bestPxBedroom'
                    ? `Best price by bedroom type – ${referenceUnit?.projectName ?? ''}`
                    : 'Project Comparison View'}
                </Typography>
              )}
              <ToggleButtonGroup
                value={viewMode}
                exclusive
                onChange={(e, newMode) => {
                  if (newMode !== null) {
                    setViewMode(newMode);
                  }
                }}
                size="small"
                sx={{
                  '& .MuiToggleButton-root': {
                    color: 'var(--color-text-strong)',
                    borderColor: 'rgba(var(--color-text-rgb), 0.3)',
                    '&.Mui-selected': {
                      bgcolor: 'var(--color-accent)',
                      color: 'var(--color-text-inverse)',
                      '&:hover': {
                        bgcolor: 'var(--color-accent-strong)',
                      },
                    },
                    '&:hover': {
                      bgcolor: 'rgba(var(--color-text-rgb), 0.1)',
                    },
                  },
                }}
              >
                <ToggleButton value="unit">Unit View</ToggleButton>
                <ToggleButton value="bestPxBedroom">Best PX BEDROOM TYPE</ToggleButton>
                <ToggleButton value="project">Project View</ToggleButton>
              </ToggleButtonGroup>
              <IconButton
                size="small"
                onClick={() => setComparableSectionOpen((prev) => !prev)}
                sx={{ border: '1px solid rgba(var(--color-text-rgb), 0.2)' }}
                title={comparableSectionOpen ? 'Collapse' : 'Expand'}
              >
                <ExpandMoreIcon
                  sx={{
                    transform: comparableSectionOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease',
                  }}
                />
              </IconButton>
                  </Box>

                  <Collapse in={comparableSectionOpen} timeout="auto" unmountOnExit>

                  <Box
                    sx={{
                      width: '100%',
                      overflowX: 'auto',
                      '&::-webkit-scrollbar': {
                        height: 8,
                      },
                      '&::-webkit-scrollbar-track': {
                        bgcolor: 'rgba(var(--color-text-rgb), 0.05)',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        bgcolor: 'rgba(var(--color-text-rgb), 0.2)',
                        borderRadius: 1,
                        '&:hover': {
                          bgcolor: 'rgba(var(--color-text-rgb), 0.3)',
                        },
                      },
                    }}
                  >
                  <TableContainer sx={{ bgcolor: 'transparent' }}>
              {viewMode === 'bestPxBedroom' ? (
                <Box sx={{ width: '100%' }}>
                  {!bestByUnitTypeLoading && bestByUnitTypeData && (bestByUnitTypeData.unitTypes?.length ?? 0) > 0 && (
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="subtitle2" sx={{ color: 'var(--color-heading)', fontWeight: 600, mb: 1 }}>
                        Cheapest unit by type
                      </Typography>
                      <TableContainer sx={{ border: '1px solid rgba(var(--color-text-rgb), 0.1)', borderRadius: 1, mb: 2 }}>
                        <Table size="small" sx={{ '& .MuiTableCell-root': { py: 0.75, px: 1.5, color: 'var(--color-text-strong)', borderColor: 'rgba(var(--color-text-rgb), 0.1)', fontSize: '0.8rem' }, '& .MuiTableHead-root .MuiTableCell-root': { bgcolor: 'var(--color-surface-elevated)', color: 'var(--color-heading)', fontWeight: 600 } }}>
                          <TableHead>
                            <TableRow>
                              <TableCell>Unit type</TableCell>
                              <TableCell>Unit no</TableCell>
                              <TableCell align="right">Area (sqft)</TableCell>
                              <TableCell align="right">Price ($)</TableCell>
                              {bestPxShowPsfColumns && <TableCell align="right">PSF</TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(bestByUnitTypeData.unitTypes ?? [])
                              .filter((row) => row.units.length > 0)
                              .map((row) => {
                                const cheapest = row.units[0];
                                return (
                                  <TableRow key={row.id} hover>
                                    <TableCell sx={{ fontWeight: 500 }}>{(row.description ?? row.unitType) || 'Unit type'}</TableCell>
                                    <TableCell>{cheapest.unitNumber}</TableCell>
                                    <TableCell align="right">{cheapest.totalAreaSqft != null ? formatNumber(cheapest.totalAreaSqft) : '-'}</TableCell>
                                    <TableCell align="right">{cheapest.sellingPrice != null ? formatCurrency(cheapest.sellingPrice) : '-'}</TableCell>
                                    {bestPxShowPsfColumns && (
                                      <TableCell align="right">{cheapest.psf != null ? `${formatCurrency(cheapest.psf)} PSF` : '-'}</TableCell>
                                    )}
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  )}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: 2,
                    alignItems: 'flex-start',
                  }}
                >
                  <Box
                    sx={{
                      flex: { md: '1 1 65%' },
                      width: '100%',
                      display: 'grid',
                      gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
                      gap: 2,
                      minWidth: 0,
                    }}
                  >
                    {bestByUnitTypeLoading ? (
                      <Box sx={{ gridColumn: '1 / -1', py: 4, display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress sx={{ color: 'var(--color-accent)' }} />
                      </Box>
                    ) : bestByUnitTypeData?.unitTypes?.length ? (
                      bestByUnitTypeData.unitTypes.map((row) => (
                        <Box key={row.id} sx={{ border: '1px solid rgba(var(--color-text-rgb), 0.1)', borderRadius: 1, overflow: 'hidden' }}>
                          <Typography variant="subtitle2" sx={{ px: 1.5, py: 1, bgcolor: 'var(--color-surface-elevated)', color: 'var(--color-heading)', fontWeight: 600 }}>
                            {(row.description ?? row.unitType) || 'Unit type'}
                          </Typography>
                        <Table
                          size="small"
                          sx={{
                            '& .MuiTableCell-root': {
                              py: 0.75,
                              px: 1,
                              color: 'var(--color-text-strong)',
                              borderColor: 'rgba(var(--color-text-rgb), 0.1)',
                              fontSize: '0.8rem',
                            },
                            '& .MuiTableHead-root .MuiTableCell-root': {
                              bgcolor: 'var(--color-surface-elevated)',
                              color: 'var(--color-heading)',
                              fontWeight: 600,
                            },
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell>UNIT NO</TableCell>
                              <TableCell>BEDRM TYPE</TableCell>
                              <TableCell>TYPE</TableCell>
                              <TableCell align="right">AREA (SQ FT)</TableCell>
                              <TableCell align="right">PRICE ($)</TableCell>
                              {bestPxShowPsfColumns && <TableCell align="right">PSF</TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {row.units.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={bestPxShowPsfColumns ? 6 : 5} align="center" sx={{ py: 2 }}>
                                  No units
                                </TableCell>
                              </TableRow>
                            ) : (
                              row.units.map((u, idx) => (
                                <TableRow key={`${row.id}-${u.unitNumber}-${idx}`} hover>
                                  <TableCell>{u.unitNumber}</TableCell>
                                  <TableCell>{row.description ?? row.unitType}</TableCell>
                                  <TableCell>{u.type ?? '-'}</TableCell>
                                  <TableCell align="right">{u.totalAreaSqft != null ? formatNumber(u.totalAreaSqft) : '-'}</TableCell>
                                  <TableCell align="right">{u.sellingPrice != null ? formatCurrency(u.sellingPrice) : '-'}</TableCell>
                                  {bestPxShowPsfColumns && (
                                    <TableCell align="right">{u.psf != null ? `${formatCurrency(u.psf)} PSF` : '-'}</TableCell>
                                  )}
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                        </Box>
                      ))
                    ) : (
                      <Box sx={{ gridColumn: '1 / -1', py: 4, color: 'var(--color-text-muted)', textAlign: 'center' }}>
                        <Typography variant="body2">No unit types for this project.</Typography>
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      flex: { md: '0 0 33%' },
                      width: '100%',
                      minWidth: 0,
                      position: { md: 'sticky' },
                      top: { md: 16 },
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ color: 'var(--color-heading)', mb: 1 }}>
                      Site map
                    </Typography>
                    {bestPxBedroomSitePlan?.imageUrl ? (
                      <Box
                        component="img"
                        src={bestPxBedroomSitePlan.imageUrl}
                        alt="Site plan"
                        sx={{
                          width: '100%',
                          height: 'auto',
                          maxHeight: { md: 400 },
                          objectFit: 'contain',
                          borderRadius: 1,
                          border: '1px solid rgba(var(--color-text-rgb), 0.1)',
                        }}
                      />
                    ) : (
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => referenceUnit?.projectName && handleOpenSitePlanForProject(referenceUnit.projectName)}
                        sx={{ color: 'var(--color-accent)', borderColor: 'rgba(var(--color-accent-rgb), 0.5)' }}
                      >
                        View site map
                      </Button>
                    )}
                  </Box>
                </Box>
                </Box>
              ) : viewMode === 'unit' ? (
                <Table 
                  size="small" 
                  sx={{ 
                    '& .MuiTableCell-root': { 
                      py: 1,
                      color: 'var(--color-table-text)',
                      borderColor: 'rgba(var(--color-text-rgb), 0.1)',
                    },
                    '& .MuiTableHead-root .MuiTableCell-root': {
                      bgcolor: 'var(--color-surface-elevated)',
                      color: 'var(--color-heading)',
                      fontWeight: 600,
                    },
                    '& .MuiTableBody-root .MuiTableRow-root': {
                      bgcolor: 'var(--color-surface)',
                      '&:hover': {
                        bgcolor: 'rgba(var(--color-text-rgb), 0.05)',
                      },
                      '&:nth-of-type(even)': {
                        bgcolor: 'rgba(var(--color-text-rgb), 0.02)',
                      },
                    },
                  }}
                >
                  <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox" sx={{ width: 48 }}>
                      <Checkbox
                        indeterminate={floorPlansToCompare.length > 0 && floorPlansToCompare.length < comparableUnits.filter(u => u.floorplan).length}
                        checked={comparableUnits.length > 0 && floorPlansToCompare.length === comparableUnits.filter(u => u.floorplan).length && floorPlansToCompare.length > 0}
                        onChange={(e) => {
                          if (e.target.checked) {
                            // Select all units with floor plans (max 2)
                            const unitsWithFloorPlans = comparableUnits.filter(u => u.floorplan).slice(0, 2);
                            setFloorPlansToCompare(unitsWithFloorPlans.map(unit => ({
                              unit,
                              imageUrl: unit.floorplan!,
                            })));
                          } else {
                            // Deselect all
                            setFloorPlansToCompare([]);
                          }
                        }}
                        disabled={comparableUnits.filter(u => u.floorplan).length === 0}
                        sx={{
                          color: 'var(--color-text-strong)',
                          '&.Mui-checked': {
                            color: 'var(--color-accent)',
                          },
                          '&.MuiCheckbox-indeterminate': {
                            color: 'var(--color-accent)',
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {getColumnLabel('projectName')}
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'projectName')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('projectName'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ width: 100, minWidth: 100, maxWidth: 100, px: 0.5, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        {getColumnLabel('unitNumber')}
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'unitNumber')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('unitNumber'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ width: 80, minWidth: 80, maxWidth: 80, px: 0.5, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        {getColumnLabel('blockNumber')}
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'blockNumber')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('blockNumber'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ width: 70, minWidth: 70, maxWidth: 70, px: 0.5, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        {getColumnLabel('floor')}
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'floor')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('floor'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ width: 70, minWidth: 70, maxWidth: 70, px: 0.5, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        {getColumnLabel('stack')}
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'stack')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('stack'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ width: 70, minWidth: 70, maxWidth: 70, px: 0.5, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        {getColumnLabel('bedroom')}
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'bedroom')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('bedroom'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ width: 60, minWidth: 60, maxWidth: 60, px: 0.5, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        {getColumnLabel('bathroom')}
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'bathroom')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('bathroom'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ width: 80, minWidth: 80, maxWidth: 80, px: 0.5, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        {getColumnLabel('areaSqft')}
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'areaSqft')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('areaSqft'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="right" sx={{ width: 160, minWidth: 160, maxWidth: 160, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                        {getColumnLabel('price')}
                        <Tooltip title="Click to see thumbs up criteria">
                          <IconButton
                            size="small"
                            onClick={(e) => setThumbsUpLegendAnchor(e.currentTarget)}
                            sx={{
                              ...getIconButtonSx(),
                              color: 'var(--color-info)',
                              '&:hover': {
                                bgcolor: 'rgba(var(--color-info-rgb), 0.1)',
                              },
                            }}
                          >
                            <HelpOutlineIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={thumbsUpFilterActive ? "Show all units" : "Show only thumbs up units"}>
                          <IconButton
                            size="small"
                            onClick={() => setThumbsUpFilterActive(!thumbsUpFilterActive)}
                            sx={{
                              ...getIconButtonSx(),
                              ...(thumbsUpFilterActive && {
                                color: 'var(--color-success)',
                                bgcolor: 'rgba(var(--color-success-rgb), 0.1)',
                              }),
                            }}
                          >
                            <ThumbUpIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'price')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('price'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="right" sx={{ pr: 1.5 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                        {getColumnLabel('psf')}
                        <Tooltip title="Click to see thumbs up criteria">
                          <IconButton
                            size="small"
                            onClick={(e) => setThumbsUpLegendAnchor(e.currentTarget)}
                            sx={{
                              ...getIconButtonSx(),
                              color: 'var(--color-info)',
                              '&:hover': {
                                bgcolor: 'rgba(var(--color-info-rgb), 0.1)',
                              },
                            }}
                          >
                            <HelpOutlineIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={thumbsUpFilterActive ? "Show all units" : "Show only thumbs up units"}>
                          <IconButton
                            size="small"
                            onClick={() => setThumbsUpFilterActive(!thumbsUpFilterActive)}
                            sx={{
                              ...getIconButtonSx(),
                              ...(thumbsUpFilterActive && {
                                color: 'var(--color-success)',
                                bgcolor: 'rgba(var(--color-success-rgb), 0.1)',
                              }),
                            }}
                          >
                            <ThumbUpIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'psf')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('psf'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="right" sx={{ width: 120, minWidth: 120, maxWidth: 120, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                        {getColumnLabel('outlay')}
                        <Tooltip title="How outlay is calculated">
                          <IconButton
                            size="small"
                            onClick={(e) => setOutlayInfoAnchor(e.currentTarget)}
                            sx={{
                              ...getIconButtonSx(),
                              color: 'var(--color-info)',
                              '&:hover': {
                                bgcolor: 'rgba(var(--color-info-rgb), 0.1)',
                              },
                            }}
                          >
                            <HelpOutlineIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'outlay')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('outlay'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="right" sx={{ width: 100, minWidth: 100, maxWidth: 100, pr: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                        {getColumnLabel('installment')}
                        <Tooltip title="How installment is calculated">
                          <IconButton
                            size="small"
                            onClick={(e) => setInstallmentInfoAnchor(e.currentTarget)}
                            sx={{
                              ...getIconButtonSx(),
                              color: 'var(--color-info)',
                              '&:hover': {
                                bgcolor: 'rgba(var(--color-info-rgb), 0.1)',
                              },
                            }}
                          >
                            <HelpOutlineIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'installment')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('installment'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                    <TableCell align="right">
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                        {getColumnLabel('distance')}
                        <IconButton
                          size="small"
                          onClick={(e) => handleOpenPopover(e, 'distance')}
                          sx={getIconButtonSx()}
                        >
                          {renderSortIndicatorIcon(getCurrentSortDirection('distance'))}
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {comparableUnits.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={13} align="center" sx={{ py: 4, color: 'var(--color-text-strong)' }}>
                        <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                          No comparable units found matching the filter criteria.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    comparableUnits.map((unit, index) => {
                      const parsed = parseUnitNumber(unit.unitNumber);
                      const isSelected = floorPlansToCompare.some(fp => fp.unit.id === unit.id);
                      const hasHighestDrop = unit.hasHighestPriceDrop;
                      const isPricePromo = hasHighestDrop || (unit.priceChange ?? 0) < 0 || pricePromoUnitIds.has(unit.id);
                      const heatBarCount = index === 0 ? 4 : index === 1 ? 1 : 0;
                      const isShortlisted = shortlistByUnitId.has(unit.id);
                      return (
                        <TableRow 
                          key={unit.id} 
                          hover
                          sx={{
                            ...(hasHighestDrop && {
                              border: '2px solid',
                              borderColor: 'error.main',
                              animation: 'blinkBorder 1s ease-in-out infinite',
                              '@keyframes blinkBorder': {
                                '0%, 100%': { borderColor: 'error.main' },
                                '50%': { borderColor: 'transparent' },
                              },
                            }),
                          }}
                        >
                          <TableCell 
                            padding="checkbox"
                          >
                            <Checkbox
                              checked={isSelected}
                              onChange={() => handleAddToUnitCompare(unit)}
                              disabled={(!isSelected && floorPlansToCompare.length >= 3) || !unit.floorplan}
                              title={!unit.floorplan ? 'No floor plan available' : ''}
                              sx={{
                                color: 'var(--color-text-strong)',
                                '&.Mui-checked': {
                                  color: 'var(--color-accent)',
                                },
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                <Typography variant="body2" sx={{ color: 'var(--color-text-strong)' }}>{unit.projectName}</Typography>
                                {referenceUnit && (referenceUnit.id === unit.id || (referenceUnit.projectName === unit.projectName && referenceUnit.unitNumber === unit.unitNumber)) && (
                                  <Tooltip title="Reference unit" arrow placement="top">
                                    <BookmarkIcon sx={{ fontSize: '0.9rem !important', color: '#1976d2', flexShrink: 0 }} />
                                  </Tooltip>
                                )}
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <Box
                                  onClick={() => setHeatBarInfoOpen(true)}
                                  sx={{
                                    display: 'flex',
                                    gap: 0.4,
                                    cursor: 'pointer',
                                    alignItems: 'center',
                                  }}
                                >
                                  {[0, 1, 2, 3].map((barIndex) => (
                                    <Box
                                      key={barIndex}
                                      sx={{
                                        width: 10,
                                        height: 8,
                                        borderRadius: 999,
                                        bgcolor: barIndex < heatBarCount ? 'var(--color-danger)' : 'var(--color-neutral)',
                                      }}
                                    />
                                  ))}
                                </Box>
                                <IconButton
                                  size="small"
                                  onClick={() => handleOpenTowerView(unit)}
                                  sx={getIconButtonSx()}
                                  title="View Tower View"
                                >
                                  <ViewModuleIcon fontSize="small" />
                                </IconButton>
                                {unit.floorplan && (
                                  <IconButton
                                    size="small"
                                    onClick={() => handleOpenFloorPlan(unit)}
                                    sx={{
                                      ...getIconButtonSx(),
                                      color: 'primary.main',
                                    }}
                                    title="View Floor Plan"
                                  >
                                    <ImageIcon fontSize="small" />
                                  </IconButton>
                                )}
                                <IconButton
                                  size="small"
                                  onClick={() => handleShortlistAction({
                                    unitId: unit.id,
                                    label: `${unit.projectName} ${unit.unitNumber}`,
                                    floorplan: unit.floorplan || null,
                                  })}
                                  disabled={shortlistUpdatingUnitId === unit.id}
                                  sx={{
                                    ...getIconButtonSx(),
                                    color: isShortlisted ? 'var(--color-warning-strong)' : 'var(--color-text-strong)',
                                  }}
                                  title={isShortlisted ? 'Remove from shortlist' : 'Add to shortlist'}
                                >
                                  {isShortlisted ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
                                </IconButton>
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell align="center" sx={{ width: 100, minWidth: 100, maxWidth: 100, px: 0.5, pr: 1, color: 'var(--color-text-strong)' }}>
                            {unit.unitNumber}
                          </TableCell>
                          <TableCell align="center" sx={{ width: 80, minWidth: 80, maxWidth: 80, px: 0.5, pr: 1, color: 'var(--color-text-strong)' }}>
                            {formatBlockNumber(unit.blockNumber || null)}
                          </TableCell>
                          <TableCell align="center" sx={{ width: 70, minWidth: 70, maxWidth: 70, px: 0.5, pr: 1, color: 'var(--color-text-strong)' }}>
                            {parsed.floor !== null ? parsed.floor : '-'}
                          </TableCell>
                          <TableCell align="center" sx={{ width: 70, minWidth: 70, maxWidth: 70, px: 0.5, pr: 1, color: 'var(--color-text-strong)' }}>
                            {parsed.stack !== null ? parsed.stack : '-'}
                          </TableCell>
                          <TableCell align="center" sx={{ width: 70, minWidth: 70, maxWidth: 70, px: 0.5, pr: 1, color: 'var(--color-text-strong)' }}>
                            {unit.bedroom}
                          </TableCell>
                          <TableCell align="center" sx={{ width: 60, minWidth: 60, maxWidth: 60, px: 0.5, color: 'var(--color-text-strong)' }}>
                            {unit.bathroom}
                          </TableCell>
                          <TableCell align="center" sx={{ width: 80, minWidth: 80, maxWidth: 80, px: 0.5, color: 'var(--color-text-strong)' }}>
                            {formatNumber(unit.areaSqft)}
                          </TableCell>
                      <TableCell align="right" sx={{ width: 160, minWidth: 160, maxWidth: 160, pr: 1, color: 'var(--color-text-strong)' }}>
                        <Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5, flexWrap: 'wrap' }}>
                            <Typography
                              variant="body2"
                              component={hasHighestDrop ? 'span' : 'div'}
                              onClick={hasHighestDrop ? () => handleOpenPriceChart(unit.id, 'price', true, 'unit_grid_price_drop', unit.bedroom) : undefined}
                              sx={{
                                color: isPricePromo ? 'var(--color-success)' : 'var(--color-text-strong)',
                                ...(hasHighestDrop && {
                                  cursor: 'pointer',
                                  textDecoration: 'underline',
                                  '&:hover': {
                                    opacity: 0.7,
                                  },
                                }),
                              }}
                            >
                              {formatCurrency(unit.price)}
                            </Typography>
                            {hasHighestDrop && (
                              <Chip
                                label="PRICE PROMO"
                                size="small"
                                onClick={() => setPricePromoInfoOpen(true)}
                                sx={{
                                  height: 20,
                                  fontSize: '0.65rem',
                                  fontWeight: 'bold',
                                  bgcolor: 'var(--color-success)',
                                  color: '#0f2a1d',
                                  cursor: 'pointer',
                                }}
                              />
                            )}
                            {unit.priceChangePercent !== undefined && unit.priceChangePercent !== null && (
                              <Typography
                                variant="caption"
                                component="span"
                                sx={{
                                  color: 'var(--color-text-strong)',
                                  fontWeight: 'medium',
                                }}
                              >
                                ({unit.priceChangePercent >= 0 ? '+' : ''}{formatNumber(unit.priceChangePercent, 1)}%)
                              </Typography>
                            )}
                            {qualifiesForThumbsUp(unit) && (
                              <ThumbUpIcon sx={{ fontSize: 16, color: 'var(--color-success)' }} />
                            )}
                          </Box>
                          <Typography
                            variant="caption"
                            sx={{
                              color: getPriceDiffColor(unit.priceDiff),
                              fontWeight: 'medium',
                            }}
                          >
                            {unit.priceDiff >= 0 ? '+' : ''}
                            {formatCurrency(unit.priceDiff)} ({unit.priceDiffPercent >= 0 ? '+' : ''}
                            {formatNumber(unit.priceDiffPercent, 1)}%)
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="right" sx={{ color: 'var(--color-text-strong)' }}>
                        <Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                            <Typography
                              variant="body2"
                              component={hasHighestDrop ? 'span' : 'div'}
                              onClick={hasHighestDrop ? () => handleOpenPriceChart(unit.id, 'psf', true, 'unit_grid_price_drop', unit.bedroom) : undefined}
                              sx={{
                                color: 'var(--color-text-strong)',
                                ...(hasHighestDrop && {
                                  cursor: 'pointer',
                                  textDecoration: 'underline',
                                  '&:hover': {
                                    opacity: 0.7,
                                  },
                                }),
                              }}
                            >
                              {formatCurrency(unit.psf)}
                            </Typography>
                            {unit.psfChangePercent !== undefined && unit.psfChangePercent !== null && (
                              <Typography
                                variant="caption"
                                component="span"
                                sx={{
                                  color: 'var(--color-text-strong)',
                                  fontWeight: 'medium',
                                }}
                              >
                                ({unit.psfChangePercent >= 0 ? '+' : ''}{formatNumber(unit.psfChangePercent, 1)}%)
                              </Typography>
                            )}
                            {qualifiesForThumbsUp(unit) && (
                              <ThumbUpIcon sx={{ fontSize: 16, color: 'var(--color-success)' }} />
                            )}
                          </Box>
                          <Typography
                            variant="caption"
                            sx={{
                              color: getPriceDiffColor(unit.psfDiff),
                              fontWeight: 'medium',
                            }}
                          >
                            {unit.psfDiff >= 0 ? '+' : ''}
                            {formatCurrency(unit.psfDiff)} psf ({unit.psfDiffPercent >= 0 ? '+' : ''}
                            {formatNumber(unit.psfDiffPercent, 1)}%)
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          width: 120,
                          minWidth: 120,
                          maxWidth: 120,
                          pr: 1,
                          color: 'var(--color-text-strong)',
                          cursor: unit.outlay > 0 ? 'pointer' : 'default',
                        }}
                        onClick={(event) => {
                          if (unit.outlay <= 0) return;
                          openComparableUnitFormulaPopover(event, getOutlayFormulaTooltip(unit.price, unit.outlay));
                        }}
                      >
                        <Box>
                          {unit.outlay > 0 ? (
                            <Typography
                              component="span"
                              variant="body2"
                              sx={{
                                color: 'var(--color-text-strong)',
                                cursor: 'pointer',
                                textDecoration: 'underline dotted rgba(var(--color-text-rgb), 0.45)',
                                textUnderlineOffset: 3,
                              }}
                            >
                              {formatCurrency(unit.outlay)}
                            </Typography>
                          ) : (
                            '-'
                          )}
                          <Typography
                            variant="caption"
                            sx={{
                              display: 'block',
                              mt: 0.25,
                              color: getPriceDiffColor(unit.outlayDiff),
                              fontWeight: 'medium',
                            }}
                          >
                            {unit.outlayDiff >= 0 ? '+' : ''}
                            {formatCurrency(unit.outlayDiff)}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          width: 100,
                          minWidth: 100,
                          maxWidth: 100,
                          pr: 1,
                          color: 'var(--color-text-strong)',
                          cursor: unit.installment > 0 ? 'pointer' : 'default',
                        }}
                        onClick={(event) => {
                          if (unit.installment <= 0) return;
                          openComparableUnitFormulaPopover(event, getInstallmentFormulaTooltip(unit.price, unit.installment));
                        }}
                      >
                        <Box>
                          {unit.installment > 0 ? (
                            <Typography
                              component="span"
                              variant="body2"
                              sx={{
                                color: 'var(--color-text-strong)',
                                cursor: 'pointer',
                                textDecoration: 'underline dotted rgba(var(--color-text-rgb), 0.45)',
                                textUnderlineOffset: 3,
                              }}
                            >
                              {formatCurrency(unit.installment)}
                            </Typography>
                          ) : (
                            '-'
                          )}
                          <Typography
                            variant="caption"
                            sx={{
                              display: 'block',
                              mt: 0.25,
                              color: getPriceDiffColor(unit.installmentDiff),
                              fontWeight: 'medium',
                            }}
                          >
                            {unit.installmentDiff >= 0 ? '+' : ''}
                            {formatCurrency(unit.installmentDiff)}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="right" sx={{ color: 'var(--color-text-strong)' }}>
                        {(() => {
                          const distance = getDistanceFromReference(unit.projectName);
                          return distance !== null ? (
                            <Typography variant="body2" sx={{ color: 'var(--color-text-strong)' }}>
                              {formatNumber(distance, 2)} km
                            </Typography>
                          ) : (
                            <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                              -
                            </Typography>
                          );
                        })()}
                      </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
              ) : (
              <Table
                sx={{
                  tableLayout: 'fixed',
                  width: 3610,
                  minWidth: 3610,
                  '& .MuiTableCell-root': {
                    color: 'var(--color-text-strong)',
                    borderColor: 'rgba(var(--color-text-rgb), 0.1)',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    boxSizing: 'border-box',
                  },
                  '& .MuiTableCell-root[data-show-full-value]': {
                    overflow: 'visible',
                    textOverflow: 'clip',
                  },
                  '& .MuiTableHead-root .MuiTableCell-root': {
                    bgcolor: 'var(--color-surface-thead)',
                    color: 'var(--color-text-strong)',
                    fontWeight: 600,
                  },
                  '& .MuiTableBody-root .MuiTableRow-root': {
                    bgcolor: 'var(--color-surface)',
                    '&:hover': {
                      bgcolor: 'rgba(var(--color-text-rgb), 0.05)',
                      '& .sticky-cell': {
                        bgcolor: 'var(--color-surface-row-hover)',
                      },
                    },
                    '&:nth-of-type(even)': {
                      bgcolor: 'rgba(var(--color-text-rgb), 0.02)',
                      '& .sticky-cell': {
                        bgcolor: 'var(--color-surface-row-alt)',
                      },
                    },
                    '&:nth-of-type(even):hover': {
                      '& .sticky-cell': {
                        bgcolor: 'var(--color-surface-row-hover)',
                      },
                    },
                  },
                }}
              >
                <colgroup>
                  <col style={{ width: 200, minWidth: 200 }} />
                  <col style={{ width: 100, minWidth: 100 }} />
                  <col style={{ width: 140 }} />
                  <col style={{ width: 140 }} />
                  <col style={{ width: 100 }} />
                  <col style={{ width: 100 }} />
                  <col style={{ width: 180 }} />
                  <col style={{ width: 120 }} />
                  <col style={{ width: 120 }} />
                  <col style={{ width: 160 }} />
                  <col style={{ width: 110 }} />
                  <col style={{ width: 130 }} />
                  <col style={{ width: 120 }} />
                  <col style={{ width: 130 }} />
                  {[...Array(18)].map((_, i) => <col key={i} style={{ width: i % 3 === 1 ? 150 : 90 }} />)}
                  <col style={{ width: 120 }} />
                </colgroup>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', position: 'sticky', left: 0, zIndex: 2, minWidth: 200, width: 200, bgcolor: 'var(--color-surface-thead)', borderRight: '1px solid rgba(var(--color-text-rgb), 0.1)' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        Project Name
                        <IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'projectName' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton>
                      </Box>
                    </TableCell>
                    <TableCell data-column="psf" align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 100 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                        Distance
                        <IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'distance' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 140 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>Project Category<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'projectCategory' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>Developer<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'developer' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box>
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 100 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>Total Units<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'totalUnits' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 100 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>Sold Units<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'soldUnits' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 180 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>District/Location<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'districtLocation' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>District<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'district' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>Region<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'region' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 140 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>Nearest Mrt<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'nearestMrt' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>Walking Time<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'walkingTimeToMrt' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>Tenure<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'tenure' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    <TableCell sx={{ fontWeight: 600, minWidth: 120 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>Completed Date<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: 'completedDate' })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                    {[1, 2, 3, 4, 5, 'PH'].map((br) => (
                      <Fragment key={br}>
                        <TableCell align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 90 }}><Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>{br === 'PH' ? 'PH' : `${br}BR`} Avail<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: br === 'PH' ? 'phavail' : `br${br}avail` })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 100 }}><Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>{br === 'PH' ? 'PH' : `${br}BR`} Price<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: br === 'PH' ? 'phprice' : `br${br}price` })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 90 }}><Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>{br === 'PH' ? 'PH' : `${br}BR`} Psf<IconButton size="small" onClick={(e) => setProjectViewPopoverAnchor({ element: e.currentTarget, column: br === 'PH' ? 'phpsf' : `br${br}psf` })} sx={{ p: 0.5, color: 'var(--color-text-strong)', '&:hover': { bgcolor: 'rgba(var(--color-text-rgb), 0.1)', color: 'var(--color-accent)' } }}><MenuIcon fontSize="small" /></IconButton></Box></TableCell>
                      </Fragment>
                    ))}
                    <TableCell sx={{ fontWeight: 600, color: 'var(--color-text-strong)', minWidth: 120 }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {uniqueProjectsFromUnits.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={33} align="center" sx={{ py: 4 }}>
                        <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                          No projects available. Please search for comparable units first.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : filteredProjectsForView.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={33} align="center" sx={{ py: 4 }}>
                        <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                          No projects match the current filters.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredProjectsForView.map((projectName) => {
                      const details = projectDetailsMap.get(projectName);
                      const stickyCellSx = { bgcolor: 'var(--color-surface)' };
                      const brKeys = ['br1', 'br2', 'br3', 'br4', 'br5', 'ph'] as const;
                      return (
                        <TableRow key={projectName} hover>
                          <TableCell className="sticky-cell" sx={{ fontWeight: 500, color: 'var(--color-text-strong)', position: 'sticky', left: 0, zIndex: 1, minWidth: 200, width: 200, borderRight: '1px solid rgba(var(--color-text-rgb), 0.1)', ...stickyCellSx }}>{projectName}</TableCell>
                          <TableCell align="right" sx={{ color: 'var(--color-text-strong)', minWidth: 100 }}>
                            {(() => {
                              const distance = getDistanceFromReference(projectName);
                              return distance !== null ? (
                                <Typography variant="body2" sx={{ color: 'var(--color-text-strong)' }}>
                                  {formatNumber(distance, 2)} km
                                </Typography>
                              ) : (
                                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                  -
                                </Typography>
                              );
                            })()}
                          </TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>{details?.projectCategory ?? '-'}</TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>{details?.developer ?? '-'}</TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>{details?.totalUnits ?? '-'}</TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>{details?.soldUnits ?? '-'}</TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>{details?.districtLocation || (details?.area || details?.district ? [details.area, details.district].filter(Boolean).join(' / ') : '') || '-'}</TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>{details?.district ?? '-'}</TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>{details?.area ?? '-'}</TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>{details?.nearestMrt ?? '-'}</TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>
                            {details?.walkingTimeToMrt != null ? `${details.walkingTimeToMrt} min` : '-'}
                          </TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>{details?.tenure ?? '-'}</TableCell>
                          <TableCell sx={{ color: 'var(--color-text-strong)' }}>
                            {details?.completedDate
                              ? new Date(details.completedDate).toLocaleDateString('en-SG', {
                                  year: 'numeric',
                                  month: 'short',
                                  day: 'numeric',
                                })
                              : '-'}
                          </TableCell>
                          {brKeys.map((key) => {
                            const br = details?.[key];
                            return (
                              <Fragment key={key}>
                                <TableCell align="right" sx={{ color: 'var(--color-text-strong)' }}>
                                  {br?.availableUnits ?? '-'}
                                </TableCell>
                                <TableCell align="right" data-show-full-value sx={{ color: 'var(--color-text-strong)', whiteSpace: 'nowrap', minWidth: 140 }}>
                                  {br?.fromPrice != null ? formatCurrency(br.fromPrice) : '-'}
                                </TableCell>
                                <TableCell align="right" data-show-full-value sx={{ color: 'var(--color-text-strong)', whiteSpace: 'nowrap', minWidth: 100 }}>
                                  {br?.fromPsf != null ? formatCurrency(br.fromPsf) : '-'}
                                </TableCell>
                              </Fragment>
                            );
                          })}
                          <TableCell>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={async () => {
                                try {
                                  setSitePlanLoading(true);
                                  setSitePlanOpen(true);
                                  const { sitePlan } = await fetchSitePlan(projectName);
                                  setSitePlanData(sitePlan);
                                } catch (err) {
                                  console.error('Failed to fetch site plan:', err);
                                  setSitePlanData(null);
                                } finally {
                                  setSitePlanLoading(false);
                                }
                              }}
                            >
                              View Site Plan
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
              )}
                  </TableContainer>
                  </Box>
                  </Collapse>

                  {/* Project View column filter popover (Unit View style: min/max for numeric) */}
                  <Popover
                    open={Boolean(projectViewPopoverAnchor)}
                    anchorEl={projectViewPopoverAnchor?.element}
                    onClose={() => setProjectViewPopoverAnchor(null)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  >
                    <Box sx={{ p: 2, minWidth: 220 }}>
                      {projectViewPopoverAnchor && (
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" sx={{ mb: 1, color: 'var(--color-info)', fontWeight: 500 }}>
                            Sort
                          </Typography>
                          <ToggleButtonGroup
                            value={getProjectViewSortDirection(projectViewPopoverAnchor.column)}
                            exclusive
                            onChange={(_, value) => {
                              if (value === null || !projectViewPopoverAnchor) return;
                              const nextDirection = value as SortDirection;
                              if (nextDirection === 'default') {
                                setProjectViewSortConfig({ column: null, direction: 'default' });
                              } else {
                                setProjectViewSortConfig({ column: projectViewPopoverAnchor.column, direction: nextDirection });
                              }
                            }}
                            fullWidth
                            sx={{
                              '& .MuiToggleButtonGroup-grouped': {
                                border: '1px solid rgba(var(--color-shadow-rgb), 0.12)',
                                '&:not(:first-of-type)': {
                                  borderLeft: '1px solid rgba(var(--color-shadow-rgb), 0.12)',
                                  marginLeft: 0,
                                },
                                '&.Mui-selected': {
                                  backgroundColor: 'var(--color-info)',
                                  color: 'var(--color-text-strong)',
                                  '&:hover': {
                                    backgroundColor: 'var(--color-info-strong)',
                                  },
                                },
                              },
                            }}
                          >
                            <ToggleButton value="default" sx={{ flex: 1, py: 0.75 }}>Default</ToggleButton>
                            <ToggleButton value="asc" sx={{ flex: 1, py: 0.75 }}>Asc</ToggleButton>
                            <ToggleButton value="desc" sx={{ flex: 1, py: 0.75 }}>Desc</ToggleButton>
                          </ToggleButtonGroup>
                        </Box>
                      )}
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <FilterIcon sx={{ color: 'var(--color-info)', mr: 1, fontSize: 18 }} />
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Filter {projectViewPopoverAnchor?.column?.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase())}</Typography>
                      </Box>
                      {projectViewPopoverAnchor && projectViewPopoverAnchor.column === 'districtLocation' ? (
                        <Box>
                          <Autocomplete
                            multiple
                            size="small"
                            options={PROJECT_VIEW_DISTRICT_OPTIONS}
                            value={projectViewDistrictFilter}
                            onChange={(_, value) => setProjectViewDistrictFilter(value)}
                            renderInput={(params) => <TextField {...params} label="District" placeholder="District 1–28" />}
                          />
                          <Button size="small" sx={{ mt: 1 }} onClick={() => { setProjectViewDistrictFilter([]); setProjectViewPopoverAnchor(null); }}>Clear</Button>
                        </Box>
                      ) : projectViewPopoverAnchor && PROJECT_VIEW_NUMERIC_COLUMNS.has(projectViewPopoverAnchor.column) ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <TextField
                            fullWidth
                            size="small"
                            type={projectViewPopoverAnchor.column.includes('price') || projectViewPopoverAnchor.column.includes('psf') ? 'text' : 'number'}
                            inputProps={projectViewPopoverAnchor.column.includes('price') || projectViewPopoverAnchor.column.includes('psf') ? { inputMode: 'decimal' } : undefined}
                            label="Min"
                            placeholder="Min"
                            value={
                              projectViewPopoverAnchor.column.includes('price') || projectViewPopoverAnchor.column.includes('psf')
                                ? formatThousandsInput(projectViewRangeFilters[projectViewPopoverAnchor.column]?.min ?? '')
                                : (projectViewRangeFilters[projectViewPopoverAnchor.column]?.min ?? '')
                            }
                            onChange={(e) => {
                              const nextValue = projectViewPopoverAnchor.column.includes('price') || projectViewPopoverAnchor.column.includes('psf')
                                ? e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '')
                                : e.target.value;
                              setProjectViewRangeFilters((f) => ({ ...f, [projectViewPopoverAnchor.column]: { ...(f[projectViewPopoverAnchor.column] ?? { min: '', max: '' }), min: nextValue } }));
                            }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            type={projectViewPopoverAnchor.column.includes('price') || projectViewPopoverAnchor.column.includes('psf') ? 'text' : 'number'}
                            inputProps={projectViewPopoverAnchor.column.includes('price') || projectViewPopoverAnchor.column.includes('psf') ? { inputMode: 'decimal' } : undefined}
                            label="Max"
                            placeholder="Max"
                            value={
                              projectViewPopoverAnchor.column.includes('price') || projectViewPopoverAnchor.column.includes('psf')
                                ? formatThousandsInput(projectViewRangeFilters[projectViewPopoverAnchor.column]?.max ?? '')
                                : (projectViewRangeFilters[projectViewPopoverAnchor.column]?.max ?? '')
                            }
                            onChange={(e) => {
                              const nextValue = projectViewPopoverAnchor.column.includes('price') || projectViewPopoverAnchor.column.includes('psf')
                                ? e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '')
                                : e.target.value;
                              setProjectViewRangeFilters((f) => ({ ...f, [projectViewPopoverAnchor.column]: { ...(f[projectViewPopoverAnchor.column] ?? { min: '', max: '' }), max: nextValue } }));
                            }}
                          />
                          <Button
                            size="small"
                            onClick={() => {
                              if (projectViewPopoverAnchor) setProjectViewRangeFilters((f) => ({ ...f, [projectViewPopoverAnchor.column]: { min: '', max: '' } }));
                              setProjectViewPopoverAnchor(null);
                            }}
                          >
                            Clear
                          </Button>
                        </Box>
                      ) : (
                        <Box>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder={`Filter ${projectViewPopoverAnchor?.column ?? ''}`}
                            value={projectViewFilters[projectViewPopoverAnchor?.column ?? ''] ?? ''}
                            onChange={(e) => projectViewPopoverAnchor && setProjectViewFilters((f) => ({ ...f, [projectViewPopoverAnchor.column]: e.target.value }))}
                          />
                          <Button size="small" sx={{ mt: 1 }} onClick={() => { if (projectViewPopoverAnchor) setProjectViewFilters((f) => ({ ...f, [projectViewPopoverAnchor.column]: '' })); setProjectViewPopoverAnchor(null); }}>Clear</Button>
                        </Box>
                      )}
                    </Box>
                  </Popover>

                  {/* Thumbs Up Legend Popover */}
                  <Popover
              open={Boolean(thumbsUpLegendAnchor)}
              anchorEl={thumbsUpLegendAnchor}
              onClose={() => setThumbsUpLegendAnchor(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <Box sx={{ p: 3, maxWidth: 400 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <ThumbUpIcon sx={{ color: 'var(--color-success)', mr: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Thumbs Up Criteria
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                  A unit receives a thumbs up icon based on floor comparison:
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ p: 2, bgcolor: 'success.light', borderRadius: 1, mb: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                      If Lower Floor:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2, mb: 0 }}>
                      <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                        Must have <strong>bigger size</strong>
                      </Typography>
                      <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                        Must have <strong>lower PSF</strong>
                      </Typography>
                      <Typography component="li" variant="body2">
                        Must have <strong>lower price</strong>
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ p: 2, bgcolor: 'info.light', borderRadius: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                      If Higher Floor:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2, mb: 0 }}>
                      <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                        Can have <strong>same size or bigger size</strong>
                      </Typography>
                      <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                        Must have <strong>lower PSF</strong>
                      </Typography>
                      <Typography component="li" variant="body2">
                        Must have <strong>lower price</strong>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  fullWidth
                  onClick={() => setThumbsUpLegendAnchor(null)}
                >
                  Got it
                </Button>
              </Box>
            </Popover>

            <Popover
              open={Boolean(comparableUnitFormulaAnchor)}
              anchorEl={comparableUnitFormulaAnchor?.element ?? null}
              onClose={closeComparableUnitFormulaPopover}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              disableRestoreFocus
              PaperProps={{
                sx: {
                  bgcolor: 'rgba(60, 60, 60, 0.95)',
                  maxWidth: 360,
                  border: '1px solid rgba(255,255,255,0.12)',
                  p: 2,
                  '& .MuiTypography-root': { color: '#fff' },
                },
              }}
            >
              <Box onClick={(event) => event.stopPropagation()}>
                {comparableUnitFormulaAnchor?.content}
              </Box>
            </Popover>

            {/* Outlay Info Popover */}
            <Popover
              open={Boolean(outlayInfoAnchor)}
              anchorEl={outlayInfoAnchor}
              onClose={() => setOutlayInfoAnchor(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <Box sx={{ p: 3, maxWidth: 400 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <HelpOutlineIcon sx={{ color: 'var(--color-info)', mr: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Outlay Calculation
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                  Outlay represents the total upfront cash required for a property purchase, including down payment and stamp duty.
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ p: 2, bgcolor: 'info.light', borderRadius: 1, mb: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                      Formula:
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.95rem' }}>
                      Outlay = Down Payment + BSD
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1.5, fontSize: '0.85rem' }}>
                      Where:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2, mb: 0, mt: 0.5 }}>
                      <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                        <strong>Down Payment</strong> = Price × (100% − LTV%) = Price × {100 - Math.round(loanToValue)}%
                      </Typography>
                      <Typography component="li" variant="body2">
                        <strong>BSD</strong> = Buyer&apos;s Stamp Duty (calculated on tiered rates)
                      </Typography>
                    </Box>
                  </Box>
                    <Box sx={{ p: 2, bgcolor: 'success.light', borderRadius: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                        BSD Tiered Rates:
                      </Typography>
                      <Box component="ul" sx={{ pl: 2, mb: 0 }}>
                        <Typography component="li" variant="body2" sx={{ mb: 0.5, fontSize: '0.85rem' }}>
                          First $180,000: <strong>1%</strong>
                        </Typography>
                        <Typography component="li" variant="body2" sx={{ mb: 0.5, fontSize: '0.85rem' }}>
                          Next $180,000: <strong>2%</strong>
                        </Typography>
                        <Typography component="li" variant="body2" sx={{ mb: 0.5, fontSize: '0.85rem' }}>
                          Next $640,000: <strong>3%</strong>
                        </Typography>
                        <Typography component="li" variant="body2" sx={{ mb: 0.5, fontSize: '0.85rem' }}>
                          Next $500,000: <strong>4%</strong>
                        </Typography>
                        <Typography component="li" variant="body2" sx={{ mb: 0.5, fontSize: '0.85rem' }}>
                          Next $1,500,000: <strong>5%</strong>
                        </Typography>
                        <Typography component="li" variant="body2" sx={{ fontSize: '0.85rem' }}>
                          Remaining amount: <strong>6%</strong>
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                <Box sx={{ p: 2, bgcolor: 'warning.light', borderRadius: 1, mb: 2 }}>
                  <Typography variant="caption" sx={{ fontStyle: 'italic', display: 'block' }}>
                    <strong>Note:</strong> This is an estimate. Actual outlay may vary based on additional fees, legal costs, and other transaction expenses.
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  fullWidth
                  onClick={() => setOutlayInfoAnchor(null)}
                >
                  Got it
                </Button>
              </Box>
            </Popover>

            {/* Installment Info Popover */}
            <Popover
              open={Boolean(installmentInfoAnchor)}
              anchorEl={installmentInfoAnchor}
              onClose={() => setInstallmentInfoAnchor(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <Box sx={{ p: 3, maxWidth: 420 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <HelpOutlineIcon sx={{ color: 'var(--color-info)', mr: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Installment Calculation
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                  Monthly installment is calculated using PMT with loan amount, monthly interest rate and tenure.
                </Typography>
                <Box sx={{ p: 2, bgcolor: 'info.light', borderRadius: 1, mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                    Formula:
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.95rem' }}>
                    Installment = PMT(Loan Amount, Monthly Rate, Months)
                  </Typography>
                  <Box component="ul" sx={{ pl: 2, mb: 0, mt: 1 }}>
                    <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                      <strong>Loan Amount</strong> = Price × {formatNumber(loanToValue, 0)}%
                    </Typography>
                    <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                      <strong>Current Interest</strong> = {formatNumber(interestRate, 2)}% p.a.
                    </Typography>
                    <Typography component="li" variant="body2">
                      <strong>Tenure</strong> = {tenureYears} years ({tenureYears * 12} months)
                    </Typography>
                  </Box>
                </Box>
                <Button
                  variant="text"
                  fullWidth
                  sx={{ mb: 1, textDecoration: 'underline' }}
                  onClick={() => {
                    setInstallmentInfoAnchor(null);
                    setFinancialParametersOpen(true);
                  }}
                >
                  Edit In Financial Parameters
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  fullWidth
                  onClick={() => setInstallmentInfoAnchor(null)}
                >
                  Got it
                </Button>
              </Box>
            </Popover>

            {/* NPS / DPS Info Dialog */}
            <Dialog
              open={npsDpsInfoDialog !== null}
              onClose={() => setNpsDpsInfoDialog(null)}
              maxWidth="sm"
              fullWidth
              PaperProps={{
                sx: {
                  bgcolor: 'var(--color-bg)',
                  color: 'var(--color-text-strong)',
                },
              }}
            >
              <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
                {npsDpsInfoDialog === 'nps' ? 'Normal Payment Scheme (NPS)' : 'Deferred Payment Scheme (DPS)'}
              </DialogTitle>
              <DialogContent sx={{ pt: 2, mt: 1 }}>
                {npsDpsInfoDialog === 'nps' && (
                  <>
                    <Typography variant="body2" sx={{ color: 'var(--color-text-strong)', lineHeight: 1.8, mb: 2 }}>
                      <strong>Normal Payment Scheme (NPS)</strong>, also called the Progressive Payment Scheme, structures payments to align with construction milestones.
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'var(--color-text-strong)', lineHeight: 1.8, mb: 2 }}>
                      Buyers pay in stages: 5% booking fee upfront, 15% upon signing the Sales and Purchase Agreement, then progressive payments at foundation completion, framework completion, and other construction stages. The final portions are due at Temporary Occupation Permit (TOP) and Certificate of Statutory Completion (CSC).
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'var(--color-text-muted)', lineHeight: 1.8 }}>
                      NPS typically reflects the standard purchase price and spreads the financial commitment over the construction period.
                    </Typography>
                  </>
                )}
                {npsDpsInfoDialog === 'dps' && (
                  <>
                    <Typography variant="body2" sx={{ color: 'var(--color-text-strong)', lineHeight: 1.8, mb: 2 }}>
                      <strong>Deferred Payment Scheme (DPS)</strong> allows buyers to defer most payments until the project is completed.
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'var(--color-text-strong)', lineHeight: 1.8, mb: 2 }}>
                      After the initial 5% booking fee and 15% upon signing the Sales and Purchase Agreement (20% total upfront), the bulk of remaining payments is deferred until TOP, with the final 15% due at CSC. This eases immediate financial burden and suits buyers awaiting property sales or preferring minimal outflow during construction.
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'var(--color-text-muted)', lineHeight: 1.8 }}>
                      DPS typically incurs a 3–4% premium on the purchase price to cover developer financing costs.
                    </Typography>
                  </>
                )}
              </DialogContent>
              <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', px: 3, py: 1.5 }}>
                <Button onClick={() => setNpsDpsInfoDialog(null)} sx={{ color: 'var(--color-accent)' }}>Close</Button>
              </DialogActions>
            </Dialog>

            {/* Sort/Filter Popover */}
            <Popover
              open={Boolean(popoverAnchor)}
              anchorEl={popoverAnchor?.element}
              onClose={handleClosePopover}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              {popoverAnchor && (
                <Box sx={{ p: 2, minWidth: 280 }}>
                  {/* Sort Section */}
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" sx={{ mb: 1, color: 'var(--color-info)', fontWeight: 500 }}>
                      Sort
                    </Typography>
                    <ToggleButtonGroup
                      value={getCurrentSortDirection(popoverAnchor.column)}
                      exclusive
                      onChange={(_, value) => {
                        if (value !== null) {
                          handleSortChange(popoverAnchor.column, value);
                        }
                      }}
                      fullWidth
                      sx={{
                        '& .MuiToggleButtonGroup-grouped': {
                          border: '1px solid rgba(var(--color-shadow-rgb), 0.12)',
                          '&:not(:first-of-type)': {
                            borderLeft: '1px solid rgba(var(--color-shadow-rgb), 0.12)',
                            marginLeft: 0,
                          },
                          '&.Mui-selected': {
                            backgroundColor: 'var(--color-info)',
                            color: 'var(--color-text-strong)',
                            '&:hover': {
                              backgroundColor: 'var(--color-info-strong)',
                            },
                          },
                        },
                      }}
                    >
                      <ToggleButton value="default" sx={{ flex: 1, py: 0.75 }}>
                        Default
                      </ToggleButton>
                      <ToggleButton value="asc" sx={{ flex: 1, py: 0.75 }}>
                        Asc
                      </ToggleButton>
                      <ToggleButton value="desc" sx={{ flex: 1, py: 0.75 }}>
                        Desc
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>

                  {/* Filter Section */}
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Typography variant="body2" sx={{ color: 'var(--color-info)', fontWeight: 500, mr: 1 }}>
                        Filter
                      </Typography>
                      <FilterIcon sx={{ fontSize: 18, color: 'var(--color-info)' }} />
                    </Box>
                    {(popoverAnchor.column === 'floor' || 
                      popoverAnchor.column === 'stack' || 
                      popoverAnchor.column === 'bedroom' || 
                      popoverAnchor.column === 'bathroom' || 
                      popoverAnchor.column === 'areaSqft' || 
                      popoverAnchor.column === 'price' || 
                      popoverAnchor.column === 'psf' || 
                      popoverAnchor.column === 'outlay' || 
                      popoverAnchor.column === 'installment' ||
                      popoverAnchor.column === 'distance') ? (() => {
                      const rangeColumn = popoverAnchor.column as 'floor' | 'stack' | 'bedroom' | 'bathroom' | 'areaSqft' | 'price' | 'psf' | 'outlay' | 'installment' | 'distance';
                      const shouldFormatThousands = rangeColumn === 'price' || rangeColumn === 'psf';
                      return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <TextField
                            fullWidth
                            size="small"
                            type={shouldFormatThousands ? 'text' : 'number'}
                            inputProps={shouldFormatThousands ? { inputMode: 'decimal' } : undefined}
                            label="Min"
                            placeholder="Min"
                            value={shouldFormatThousands ? formatThousandsInput(rangeFilters[rangeColumn].min) : rangeFilters[rangeColumn].min}
                            onChange={(e) => handleRangeFilterChange(rangeColumn, 'min', shouldFormatThousands ? e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '') : e.target.value)}
                            InputProps={{
                              endAdornment: rangeFilters[rangeColumn].min.trim() !== '' && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleRangeFilterChange(rangeColumn, 'min', '')}
                                    sx={{ p: 0.5 }}
                                  >
                                    <Typography variant="caption" sx={{ fontSize: 12 }}>
                                      ✕
                                    </Typography>
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            type={shouldFormatThousands ? 'text' : 'number'}
                            inputProps={shouldFormatThousands ? { inputMode: 'decimal' } : undefined}
                            label="Max"
                            placeholder="Max"
                            value={shouldFormatThousands ? formatThousandsInput(rangeFilters[rangeColumn].max) : rangeFilters[rangeColumn].max}
                            onChange={(e) => handleRangeFilterChange(rangeColumn, 'max', shouldFormatThousands ? e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '') : e.target.value)}
                            InputProps={{
                              endAdornment: rangeFilters[rangeColumn].max.trim() !== '' && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleRangeFilterChange(rangeColumn, 'max', '')}
                                    sx={{ p: 0.5 }}
                                  >
                                    <Typography variant="caption" sx={{ fontSize: 12 }}>
                                      ✕
                                    </Typography>
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <Button
                            size="small"
                            onClick={() => {
                              handleRangeFilterChange(rangeColumn, 'min', '');
                              handleRangeFilterChange(rangeColumn, 'max', '');
                            }}
                            sx={{ mt: 0.5 }}
                            disabled={!hasActiveFilter(popoverAnchor.column)}
                          >
                            Clear Filter
                          </Button>
                        </Box>
                      );
                    })() : popoverAnchor.column === 'projectName' ? (
                      <Box>
                        {referenceUnit?.projectName ? (
                          <TextField
                            fullWidth
                            size="small"
                            label="Project"
                            value={referenceUnit.projectName}
                            disabled
                            helperText="Best matches are limited to the reference project."
                          />
                        ) : (
                          <Autocomplete
                            multiple
                            fullWidth
                            size="small"
                            disableCloseOnSelect
                            options={comparableResultProjectNames.length > 0 ? ['__SELECT_ALL__', ...comparableResultProjectNames] : comparableResultProjectNames}
                            value={projectFilterValues}
                            filterOptions={(options, state) => {
                              const filtered = projectFilterOptions(
                                options.filter((option) => option !== '__SELECT_ALL__'),
                                state
                              );
                              return comparableResultProjectNames.length > 0 ? ['__SELECT_ALL__', ...filtered] : filtered;
                            }}
                            onChange={(_, value) => {
                              const hasSelectAll = value.includes('__SELECT_ALL__');
                              if (hasSelectAll) {
                                if (projectFilterValues.length === comparableResultProjectNames.length) {
                                  handleFilterChange('projectName', []);
                                } else {
                                  handleFilterChange('projectName', [...comparableResultProjectNames]);
                                }
                                return;
                              }

                              handleFilterChange('projectName', value);
                            }}
                            renderOption={(props, option) => {
                              if (option === '__SELECT_ALL__') {
                                const allSelected = projectFilterValues.length === comparableResultProjectNames.length && comparableResultProjectNames.length > 0;
                                const indeterminate =
                                  projectFilterValues.length > 0 && projectFilterValues.length < comparableResultProjectNames.length;
                                return (
                                  <li {...props}>
                                    <Checkbox checked={allSelected} indeterminate={indeterminate} />
                                    <Typography component="span" sx={{ fontWeight: 600 }}>
                                      Select All
                                    </Typography>
                                  </li>
                                );
                              }

                              const isSelected = projectFilterValues.includes(option);
                              return (
                                <li {...props}>
                                  <Checkbox checked={isSelected} />
                                  {option}
                                </li>
                              );
                            }}
                            renderTags={(value, getTagProps) => {
                              const summary =
                                value.length === 0
                                  ? 'All Projects'
                                  : value.length === comparableResultProjectNames.length
                                  ? 'All Selected'
                                  : `${value.length} selected`;
                              return <Chip label={summary} size="small" {...getTagProps({ index: 0 })} />;
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Projects"
                                placeholder="Search projects"
                              />
                            )}
                          />
                        )}
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1.25 }}>
                          <Typography variant="caption" sx={{ color: 'var(--color-text-muted)', fontWeight: 600 }}>
                            Distance (km)
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            type="number"
                            label="Min distance"
                            placeholder="Min"
                            value={rangeFilters.distance.min}
                            onChange={(e) => handleProjectDistanceFilterChange('min', e.target.value)}
                            InputProps={{
                              endAdornment: rangeFilters.distance.min.trim() !== '' && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleProjectDistanceFilterChange('min', '')}
                                    sx={{ p: 0.5 }}
                                  >
                                    <Typography variant="caption" sx={{ fontSize: 12 }}>
                                      ✕
                                    </Typography>
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            type="number"
                            label="Max distance"
                            placeholder="Max"
                            value={rangeFilters.distance.max}
                            onChange={(e) => handleProjectDistanceFilterChange('max', e.target.value)}
                            InputProps={{
                              endAdornment: rangeFilters.distance.max.trim() !== '' && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleProjectDistanceFilterChange('max', '')}
                                    sx={{ p: 0.5 }}
                                  >
                                    <Typography variant="caption" sx={{ fontSize: 12 }}>
                                      ✕
                                    </Typography>
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                        <Button
                          size="small"
                          onClick={() => {
                            if (!referenceUnit?.projectName) {
                              handleFilterChange('projectName', [...comparableResultProjectNames]);
                            }
                            handleRangeFilterChange('distance', 'min', '');
                            handleRangeFilterChange('distance', 'max', '');
                          }}
                          sx={{ mt: 1 }}
                          fullWidth
                          disabled={
                            referenceUnit?.projectName
                              ? !hasActiveFilter('distance')
                              : !(hasActiveFilter('projectName') || hasActiveFilter('distance'))
                          }
                        >
                          {referenceUnit?.projectName ? 'Clear distance filter' : 'Clear Filter (Show All)'}
                        </Button>
                      </Box>
                    ) : (
                      <Box>
                        <TextField
                          fullWidth
                          size="small"
                          placeholder={`Filter ${getColumnLabel(popoverAnchor.column)}`}
                          value={filters[popoverAnchor.column] as string}
                          onChange={(e) => handleFilterChange(popoverAnchor.column, e.target.value)}
                          InputProps={{
                            endAdornment: hasActiveFilter(popoverAnchor.column) && (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  onClick={() => handleFilterChange(popoverAnchor.column, '')}
                                  sx={{ p: 0.5 }}
                                >
                                  <Typography variant="caption" sx={{ fontSize: 12 }}>
                                    ✕
                                  </Typography>
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <Button
                          size="small"
                          onClick={() => handleFilterChange(popoverAnchor.column, '')}
                          sx={{ mt: 1 }}
                          fullWidth
                          disabled={!hasActiveFilter(popoverAnchor.column)}
                        >
                          Clear Filter
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
                  </Popover>

            {/* Size tolerance modal – adjust ±% for comparable unit area */}
            <Dialog
              open={sizeToleranceModalOpen}
              onClose={() => setSizeToleranceModalOpen(false)}
              maxWidth="xs"
              fullWidth
              PaperProps={{
                sx: {
                  bgcolor: 'var(--color-surface)',
                  color: 'var(--color-text-strong)',
                  border: '1px solid rgba(var(--color-text-rgb), 0.12)',
                },
              }}
            >
              <DialogTitle sx={{ fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
                Size tolerance
              </DialogTitle>
              <DialogContent sx={{ pt: 2 }}>
                <Typography variant="body2" sx={{ color: 'var(--color-text-muted)', mb: 2 }}>
                  Include comparable units whose area is within ±{sizeToleranceSliderValue}% of the reference unit ({referenceUnit?.areaSqft != null ? Math.round(referenceUnit.areaSqft).toLocaleString() : '—'} sqft). Drag the slider left for exact size only, or right to allow a wider range.
                </Typography>
                <Box sx={{ px: 1 }}>
                  <Typography variant="caption" sx={{ color: 'var(--color-text-muted)' }}>
                    ±{sizeToleranceSliderValue}%
                  </Typography>
                  {referenceUnit?.areaSqft != null && (
                    <Typography variant="caption" sx={{ color: 'var(--color-text-muted)', display: 'block', mb: 0.5 }}>
                      Current range: {getAreaRangeLabel(referenceUnit.areaSqft, sizeToleranceSliderValue) ?? '—'}
                    </Typography>
                  )}
                  <Slider
                    value={sizeToleranceSliderValue}
                    onChange={(_, value) => setSizeToleranceSliderValue(Array.isArray(value) ? value[0] : value)}
                    min={0}
                    max={50}
                    step={1}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(v) => `±${v}%`}
                    sx={{
                      color: 'var(--color-accent)',
                      mt: 0.5,
                      '& .MuiSlider-thumb': { bgcolor: 'var(--color-accent)' },
                      '& .MuiSlider-rail': { opacity: 0.4 },
                    }}
                  />
                </Box>
              </DialogContent>
              <DialogActions sx={{ px: 2, pb: 2, pt: 0, gap: 1 }}>
                <Button onClick={() => setSizeToleranceModalOpen(false)} sx={{ color: 'var(--color-text-strong)' }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    setSizeToleranceModalOpen(false);
                    if (referenceUnit) {
                      await handleSearchWithParams(
                        referenceUnit.projectName,
                        referenceUnit.unitNumber,
                        activeTabId,
                        referenceUnit.id,
                        sizeToleranceSliderValue
                      );
                    }
                  }}
                  sx={{ bgcolor: 'var(--color-accent)', color: 'var(--color-text-inverse)', '&:hover': { bgcolor: 'var(--color-accent-strong)' } }}
                >
                  Apply
                </Button>
              </DialogActions>
            </Dialog>
            </Box>
          </Card>
          </Box>
        )}

        {/* Tower View Modal */}
        <Dialog
          open={towerViewOpen}
          onClose={handleCloseTowerView}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              height: '90vh',
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: isMobile ? 'none' : '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
              // Touch optimizations
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'rgba(0,0,0,0.1)',
              // Disable hover on mobile
              ...(isMobile && {
                '*:hover': {
                  backgroundColor: 'inherit !important',
                },
              }),
            },
          }}
        >
          <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                  <Typography variant="h6" sx={{ color: 'inherit' }}>
                    Tower View - {towerProjectName}
                  </Typography>
                  {towerProjectDetails?.liveStatusEnabled && liveUpdateIndicator}
                </Box>
                {towerProjectDetails?.liveStatusEnabled && (
                  <Typography
                    variant="caption"
                    sx={{ display: 'block', mt: 0.5, whiteSpace: 'nowrap', color: 'rgba(var(--color-text-rgb), 0.7)' }}
                  >
                    Last updated at {formatLiveStatusTimestamp(liveUpdateTimestamp ?? towerProjectDetails.liveStatusUpdatedAt)}.
                  </Typography>
                )}
                {!towerViewIsolatedFromMain && towerViewDataForDialog.blockNumbers.length > 0 && (
                  <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                    {selectedBlock === TOWER_VIEW_ALL_TAB ? 'All blocks' : formatBlockNumber(selectedBlock || towerViewDataForDialog.blockNumbers[0] || null)}
                  </Typography>
                )}
              </Box>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                {/* Zoom Controls */}
                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', border: '1px solid rgba(var(--color-text-rgb), 0.2)', borderRadius: 1 }}>
                  <IconButton
                    size="small"
                    onClick={() => {
                      const container = towerZoomContainerRef.current;
                      if (container) {
                        const { scrollLeft, scrollTop } = container;
                        const newZoom = Math.max(0.5, towerZoom - 0.1);
                        setTowerZoom(newZoom);
                        // Preserve scroll position after zoom
                        setTimeout(() => {
                          container.scrollLeft = scrollLeft * (newZoom / towerZoom);
                          container.scrollTop = scrollTop * (newZoom / towerZoom);
                        }, 150);
                      } else {
                        setTowerZoom(Math.max(0.5, towerZoom - 0.1));
                      }
                    }}
                    onTouchEnd={(e) => {
                      e.preventDefault();
                      const container = towerZoomContainerRef.current;
                      if (container) {
                        const { scrollLeft, scrollTop } = container;
                        const newZoom = Math.max(0.5, towerZoom - 0.1);
                        setTowerZoom(newZoom);
                        setTimeout(() => {
                          container.scrollLeft = scrollLeft * (newZoom / towerZoom);
                          container.scrollTop = scrollTop * (newZoom / towerZoom);
                        }, 150);
                      } else {
                        setTowerZoom(Math.max(0.5, towerZoom - 0.1));
                      }
                    }}
                    disabled={towerZoom <= 0.5}
                    sx={{
                      minWidth: 44,
                      minHeight: 44,
                      color: 'rgba(var(--color-text-rgb), 0.9)',
                      touchAction: 'manipulation',
                      '&:active': {
                        backgroundColor: 'rgba(0,0,0,0.12)',
                        transform: 'scale(0.95)',
                      },
                    }}
                  >
                    <ZoomOutIcon fontSize="small" />
                  </IconButton>
                  <Typography variant="caption" sx={{ px: 1, minWidth: 50, textAlign: 'center', color: 'rgba(var(--color-text-rgb), 0.9)' }}>
                    {Math.round(towerZoom * 100)}%
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => {
                      const container = towerZoomContainerRef.current;
                      if (container) {
                        const { scrollLeft, scrollTop } = container;
                        const newZoom = Math.min(2, towerZoom + 0.1);
                        setTowerZoom(newZoom);
                        // Preserve scroll position after zoom
                        setTimeout(() => {
                          container.scrollLeft = scrollLeft * (newZoom / towerZoom);
                          container.scrollTop = scrollTop * (newZoom / towerZoom);
                        }, 150);
                      } else {
                        setTowerZoom(Math.min(2, towerZoom + 0.1));
                      }
                    }}
                    onTouchEnd={(e) => {
                      e.preventDefault();
                      const container = towerZoomContainerRef.current;
                      if (container) {
                        const { scrollLeft, scrollTop } = container;
                        const newZoom = Math.min(2, towerZoom + 0.1);
                        setTowerZoom(newZoom);
                        setTimeout(() => {
                          container.scrollLeft = scrollLeft * (newZoom / towerZoom);
                          container.scrollTop = scrollTop * (newZoom / towerZoom);
                        }, 150);
                      } else {
                        setTowerZoom(Math.min(2, towerZoom + 0.1));
                      }
                    }}
                    disabled={towerZoom >= 2}
                    sx={{
                      minWidth: 44,
                      minHeight: 44,
                      color: 'rgba(var(--color-text-rgb), 0.9)',
                      touchAction: 'manipulation',
                      '&:active': {
                        backgroundColor: 'rgba(0,0,0,0.12)',
                        transform: 'scale(0.95)',
                      },
                    }}
                  >
                    <ZoomInIcon fontSize="small" />
                  </IconButton>
                </Box>
                <IconButton
                  {...towerViewCloseHandlers}
                  size="small"
                  sx={{
                    ...towerViewCloseHandlers.sx,
                    minWidth: 44,
                    minHeight: 44,
                    padding: 1.5,
                    color: 'rgba(var(--color-text-rgb), 0.9)',
                    '&:active': {
                      backgroundColor: 'rgba(0,0,0,0.12)',
                      transform: 'scale(0.95)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 0, overflow: 'hidden', position: 'relative', display: 'flex', flexDirection: 'column', bgcolor: 'var(--color-surface)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
            {towerViewUnitsLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {/* Block Tabs: All Blocks | BLK 51 | BLK 53 ... (hidden when isolated from Project Research - just show all blocks) */}
                {!towerViewIsolatedFromMain && towerViewDataForDialog.blockNumbers.length > 0 && (
                  <Box sx={{ borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', overflowX: 'auto', bgcolor: 'rgba(var(--color-shadow-rgb), 0.2)', flexShrink: 0 }}>
                    <Tabs
                      value={selectedBlock ?? towerViewDataForDialog.blockNumbers[0] ?? TOWER_VIEW_ALL_TAB}
                      onChange={(_, value) => setSelectedBlock(value === TOWER_VIEW_ALL_TAB ? TOWER_VIEW_ALL_TAB : value)}
                      variant="scrollable"
                      scrollButtons="auto"
                      sx={{
                        minHeight: { xs: 48, sm: 48 },
                        '& .MuiTab-root': {
                          minHeight: { xs: 48, sm: 48 },
                          fontSize: { xs: '0.875rem', sm: '0.875rem' },
                          px: { xs: 1.5, sm: 2 },
                          fontWeight: 600,
                          color: 'rgba(var(--color-text-rgb), 0.7)',
                        },
                        '& .Mui-selected': {
                          color: 'var(--color-accent)',
                        },
                        '& .MuiTabs-indicator': { backgroundColor: 'var(--color-accent)' },
                      }}
                    >
                      <Tab label="All Blocks" value={TOWER_VIEW_ALL_TAB} />
                      {towerViewDataForDialog.blockNumbers.map((block) => (
                        <Tab key={block} label={formatBlockNumber(block)} value={block} />
                      ))}
                    </Tabs>
                  </Box>
                )}
                {/* Bedroom / Unit Type filter bar (non-All tabs only) */}
                {towerViewDataForDialog.blockNumbers.length > 0 && selectedBlock !== TOWER_VIEW_ALL_TAB && (
                  <Box sx={{ px: 2, py: 1, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center', bgcolor: 'rgba(var(--color-text-rgb), 0.04)' }}>
                    <FormControl size="small" sx={{ minWidth: 140 }}>
                      <InputLabel id="tower-view-bedroom-filter-label-tab" sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Bedroom</InputLabel>
                      <Select
                        labelId="tower-view-bedroom-filter-label-tab"
                        multiple
                        value={towerViewBedroomFilter}
                        onChange={(e) => {
                          const values = (e.target.value as Array<string | number>)
                            .map((v) => Number(v))
                            .filter((v) => Number.isFinite(v));
                          setTowerViewBedroomFilter(values);
                          if (!towerViewIsolatedFromMain) {
                            setSitePlanBedroomFilter(values);
                            updateBlinkingStacks(values, towerViewUnitTypeFilter);
                          }
                        }}
                        label="Bedroom"
                        renderValue={(selected) => selected.length === 0 ? 'All' : selected.map((n) => n === PENTHOUSE_FILTER_VALUE ? 'PH' : `${n} BR`).join(', ')}
                        sx={{
                          color: 'rgba(var(--color-text-rgb), 0.9)',
                          fontSize: '0.8rem',
                          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(var(--color-text-rgb), 0.23)' },
                          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(var(--color-text-rgb), 0.4)' },
                        }}
                      >
                        {towerViewBedroomFilterOptionsForDialog.map((n) => (
                          <MenuItem key={n} value={n}>
                            <Checkbox size="small" checked={towerViewBedroomFilter.indexOf(n) > -1} sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', p: 0.5, mr: 1 }} />
                            {n === PENTHOUSE_FILTER_VALUE ? 'Penthouse' : `${n} BR`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {towerViewUnitTypesForDialogFiltered.length > 0 && (
                      <FormControl size="small" sx={{ minWidth: 160 }}>
                        <InputLabel id="tower-view-unittype-filter-label-tab" sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Type</InputLabel>
                        <Select
                          labelId="tower-view-unittype-filter-label-tab"
                          multiple
                          value={towerViewUnitTypeFilter}
                          onChange={(e) => {
                            const values = e.target.value as string[];
                            setTowerViewUnitTypeFilter(values);
                            if (!towerViewIsolatedFromMain) {
                              updateBlinkingStacks(towerViewBedroomFilter, values);
                            }
                          }}
                          label="Type"
                          renderValue={(selected) => selected.length === 0 ? 'All' : selected.join(', ')}
                          sx={{
                            color: 'rgba(var(--color-text-rgb), 0.9)',
                            fontSize: '0.8rem',
                            '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(var(--color-text-rgb), 0.23)' },
                            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(var(--color-text-rgb), 0.4)' },
                          }}
                        >
                          {towerViewUnitTypesForDialogFiltered.map((ut) => (
                            <MenuItem key={ut} value={ut}>
                              <Checkbox size="small" checked={towerViewUnitTypeFilter.indexOf(ut) > -1} sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', p: 0.5, mr: 1 }} />
                              {ut}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Box>
                )}

                {/* Tower Grid with Zoom */}
                {towerViewDataForDialog.blockNumbers.length > 0 ? (
                  <Box
                    ref={towerZoomContainerRef}
                    sx={{
                      overflow: 'auto',
                      height: 'calc(90vh - 190px)',
                      position: 'relative',
                      touchAction: 'pan-x pan-y',
                      zoom: towerZoom,
                    }}
                    onWheel={(e) => {
                      if (e.ctrlKey || e.metaKey) {
                        e.preventDefault();
                        const delta = e.deltaY > 0 ? -0.05 : 0.05;
                        setTowerZoom((prev) => {
                          const newZoom = Math.max(0.5, Math.min(2, prev + delta));
                          return newZoom;
                        });
                      }
                    }}
                  >
                  {selectedBlock === TOWER_VIEW_ALL_TAB ? (
                    /* All blocks: Site map on top + tower view below */
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      {/* Site Map Section */}
                      {towerViewSitePlanForDialog && (
                        <Box sx={{ p: 2, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'rgba(var(--color-text-rgb), 0.02)' }}>
                          <TransformWrapper
                            initialScale={0.8}
                            minScale={0.5}
                            maxScale={4}
                            centerOnInit={true}
                            limitToBounds={false}
                            centerZoomedOut={true}
                            disablePadding={false}
                            wheel={{ step: 0.05 }}
                            pinch={{ step: 5 }}
                            doubleClick={{ disabled: false, step: 0.7 }}
                            panning={{ disabled: false, velocityDisabled: true }}
                          >
                            {({ zoomIn, zoomOut, resetTransform }) => (
                              <>
                                <TransformComponent
                                  wrapperStyle={{ width: '100%', height: '50vh', overflow: 'hidden' }}
                                  contentStyle={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                    <Box
                                      component="img"
                                      src={towerViewSitePlanForDialog.imageUrl}
                                      alt="Site Plan"
                                      sx={{ maxWidth: '100%', maxHeight: '50vh', width: 'auto', height: 'auto', display: 'block', objectFit: 'contain' }}
                                    />
                                    {/* Stack overlays (clickable to open analysis) */}
                                    {sitePlanShowPoints && towerViewSitePlanForDialog.blocks.filter(block => block.stack && block.facing).map((stack, idx) => {
                                      const bounds = towerViewSitePlanForDialog.bounds;
                                      const left = bounds ? bounds.x + (stack.x / 100) * bounds.width : stack.x;
                                      const top = bounds ? bounds.y + (stack.y / 100) * bounds.height : stack.y;
                                      const width = bounds ? (stack.width / 100) * bounds.width : stack.width;
                                      const height = bounds ? (stack.height / 100) * bounds.height : stack.height;

                                      // Normalize stack number for comparison (ensure consistent format)
                                      const normalizedStackNum = normalizeStackKey(stack.stack);
                                      if (towerViewSelectedStackKey && normalizedStackNum !== towerViewSelectedStackKey) {
                                        return null;
                                      }
                                      // Hide non-matching stacks when filter active (works for both isolated and shared tower view)
                                      const hasTowerFilter = towerViewBedroomFilter.length > 0 || towerViewUnitTypeFilter.length > 0;
                                      const shouldHideStack = towerViewIsolatedFromMain
                                        ? (hasTowerFilter && !(sitePlanBlinkingStacks.has(normalizedStackNum ?? '') || (stack.blockNumber && sitePlanBlinkingStacks.has(`${(stack.blockNumber ?? '').replace(/\D/g, '')}-${normalizedStackNum}`))))
                                        : shouldHideNonMatchingSitePlanStack(stack.stack, stack.blockNumber);
                                      if (shouldHideStack) {
                                        return null;
                                      }

                                      const isBlinking = Boolean(
                                        normalizedStackNum && (
                                          sitePlanBlinkingStacks.has(normalizedStackNum) ||
                                          normalizedStackNum === towerViewSelectedStackKey
                                        )
                                      );

                                      // Get heat map color if enabled
                                      let dotColor = 'var(--color-success)';
                                      let labelBgColor = 'rgba(var(--color-success-rgb), 0.9)';
                                      let labelColor = 'var(--color-white)';
                                      let borderColor = sitePlanDotBorder;
                                      if (sitePlanShowHeatMap && stack.stack) {
                                        const soldPercentage =
                                          towerViewStackSoldPercentagesForDialog.get(normalizedStackNum ?? '')
                                          ?? towerViewStackSoldPercentagesForDialog.get(`${(stack.blockNumber ?? '').replace(/\D/g, '')}-${normalizedStackNum}`)
                                          ?? towerViewStackSoldPercentagesForDialog.get(String(stack.stack))
                                          ?? 0;
                                        const heatColor = getHeatMapColor(soldPercentage);
                                        dotColor = heatColor;
                                        labelBgColor = heatColor;
                                        if (soldPercentage === 100) {
                                          labelColor = 'var(--color-black)';
                                          borderColor = '2px solid var(--color-black)';
                                        }
                                      }

                                      return (
                                        <Box
                                          key={`stack-${stack.stack}-${stack.facing}-${idx}`}
                                          onClick={() => {
                                            if (stack.stack && towerViewStackAnalysisProjectName) {
                                              handleOpenStackAnalysis(towerViewStackAnalysisProjectName, stack.stack);
                                            }
                                          }}
                                          sx={{
                                            position: 'absolute',
                                            left: `${left}%`,
                                            top: `${top}%`,
                                            width: `${width}%`,
                                            height: `${height}%`,
                                            cursor: 'pointer',
                                            '@keyframes sitePlanBlink': {
                                              '0%, 100%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' },
                                              '50%': { opacity: 0.3, transform: 'translate(-50%, -50%) scale(1.3)' },
                                            },
                                            '&::before': {
                                              content: `"${stack.stack}"`,
                                              position: 'absolute',
                                              left: '50%',
                                              top: '50%',
                                              transform: 'translate(-50%, -50%)',
                                              width: `${sitePlanDotSize}px`,
                                              height: `${sitePlanDotSize}px`,
                                              borderRadius: '50%',
                                              backgroundColor: dotColor,
                                              border: borderColor,
                                              boxShadow: sitePlanDotShadow,
                                              zIndex: 10,
                                              animation: isBlinking ? 'sitePlanBlink 0.5s ease-in-out infinite' : 'none',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              fontSize: sitePlanDotFontSize,
                                              fontWeight: 'bold',
                                              color: labelColor,
                                              textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
                                            },
                                          }}
                                        />
                                      );
                                    })}
                                  </Box>
                                </TransformComponent>

                                {/* Floating menu button (hidden when isolated from Project Research) */}
                                {!towerViewIsolatedFromMain && (
                                  <>
                                    <Fab
                                      color="primary"
                                      size="medium"
                                      onClick={() => setTowerViewSiteMapMenuOpen(!towerViewSiteMapMenuOpen)}
                                      sx={{
                                        position: 'absolute',
                                        top: 16,
                                        right: 16,
                                        zIndex: 1000,
                                      }}
                                    >
                                      <TuneIcon />
                                    </Fab>

                                {/* Floating menu panel */}
                                {towerViewSiteMapMenuOpen && (
                                  <Paper
                                    sx={{
                                      position: 'absolute',
                                      top: 80,
                                      right: 16,
                                      zIndex: 1000,
                                      p: 2,
                                      minWidth: 280,
                                      maxWidth: 320,
                                      maxHeight: 'calc(50vh - 100px)',
                                      overflowY: 'auto',
                                      bgcolor: 'var(--color-surface)',
                                      border: '1px solid rgba(var(--color-text-rgb), 0.08)',
                                      boxShadow: '0 4px 12px rgba(var(--color-shadow-rgb), 0.3)',
                                    }}
                                  >
                                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: 'var(--color-text-strong)' }}>
                                      Site Plan Controls
                                    </Typography>

                                    {/* Show/Hide Points Toggle */}
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          checked={sitePlanShowPoints}
                                          onChange={(e) => setSitePlanShowPoints(e.target.checked)}
                                          color="primary"
                                        />
                                      }
                                      label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <LayersIcon fontSize="small" />
                                          <Typography variant="body2">Show Points</Typography>
                                        </Box>
                                      }
                                      sx={{ mb: 2, width: '100%', m: 0 }}
                                    />

                                    {/* Show Sold Heat Map Toggle */}
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          checked={sitePlanShowHeatMap}
                                          onChange={(e) => setSitePlanShowHeatMap(e.target.checked)}
                                          color="primary"
                                        />
                                      }
                                      label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <ThermostatIcon fontSize="small" />
                                          <Typography variant="body2">Show Sold Heat Map</Typography>
                                        </Box>
                                      }
                                      sx={{ mb: 2, width: '100%', m: 0 }}
                                    />

                                    <Divider sx={{ my: 2, borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} />

                                    {/* Filter by Bedroom - Collapsible */}
                                    <Accordion
                                      defaultExpanded
                                      sx={{
                                        mb: 1,
                                        bgcolor: 'transparent',
                                        boxShadow: 'none',
                                        '&:before': { display: 'none' },
                                        '& .MuiAccordionSummary-root': {
                                          minHeight: '36px',
                                          p: 0,
                                        },
                                        '& .MuiAccordionDetails-root': {
                                          p: 0,
                                          pt: 1,
                                        },
                                      }}
                                    >
                                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <BedIcon fontSize="small" />
                                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            Filter by Bedroom
                                          </Typography>
                                        </Box>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <FormGroup>
                                          {towerViewBedroomFilterOptionsForDialog.map((bedroom) => (
                                            <FormControlLabel
                                              key={bedroom}
                                              control={
                                                <Checkbox
                                                  checked={towerViewBedroomFilter.includes(bedroom)}
                                                  onChange={(e) => {
                                                    const newFilter = e.target.checked
                                                      ? [...towerViewBedroomFilter, bedroom]
                                                      : towerViewBedroomFilter.filter(b => b !== bedroom);
                                                    setTowerViewBedroomFilter(newFilter);
                                                    if (!towerViewIsolatedFromMain) {
                                                      setSitePlanBedroomFilter(newFilter);
                                                      updateBlinkingStacks(newFilter, towerViewUnitTypeFilter);
                                                    }
                                                  }}
                                                  size="small"
                                                />
                                              }
                                              label={bedroom === PENTHOUSE_FILTER_VALUE ? 'Penthouse' : `${bedroom} Bedroom`}
                                            sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
                                          />
                                          ))}
                                        </FormGroup>
                                      </AccordionDetails>
                                    </Accordion>

                                    {/* Filter by Unit Type - Collapsible */}
                                    <Accordion
                                      defaultExpanded
                                      sx={{
                                        mb: 2,
                                        bgcolor: 'transparent',
                                        boxShadow: 'none',
                                        '&:before': { display: 'none' },
                                        '& .MuiAccordionSummary-root': {
                                          minHeight: '36px',
                                          p: 0,
                                        },
                                        '& .MuiAccordionDetails-root': {
                                          p: 0,
                                          pt: 1,
                                        },
                                      }}
                                    >
                                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <ViewModuleIcon fontSize="small" />
                                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            Filter by Unit Type
                                          </Typography>
                                        </Box>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <FormGroup>
                                          {towerViewUnitTypesForDialogFiltered.map(unitType => (
                                            <FormControlLabel
                                              key={unitType}
                                              control={
                                                <Checkbox
                                                  checked={towerViewUnitTypeFilter.includes(unitType)}
                                                  onChange={(e) => {
                                                    const newFilter = e.target.checked
                                                      ? [...towerViewUnitTypeFilter, unitType]
                                                      : towerViewUnitTypeFilter.filter(ut => ut !== unitType);
                                                    setTowerViewUnitTypeFilter(newFilter);
                                                    if (!towerViewIsolatedFromMain) {
                                                      updateBlinkingStacks(towerViewBedroomFilter, newFilter);
                                                    }
                                                  }}
                                                  size="small"
                                                />
                                              }
                                              label={
                                                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                                  {unitType}
                                                </Typography>
                                              }
                                              sx={{ alignItems: 'flex-start', mb: 0.5 }}
                                            />
                                          ))}
                                        </FormGroup>
                                      </AccordionDetails>
                                    </Accordion>

                                    {/* Zoom Controls */}
                                    <Divider sx={{ my: 2, borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} />
                                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                                      <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<ZoomInIcon />}
                                        onClick={() => zoomIn()}
                                        onTouchEnd={(e) => {
                                          e.preventDefault();
                                          zoomIn();
                                        }}
                                        sx={{
                                          flex: 1,
                                          minHeight: 44,
                                          touchAction: 'manipulation',
                                          '&:active': {
                                            transform: 'scale(0.98)',
                                          },
                                        }}
                                      >
                                        Zoom In
                                      </Button>
                                      <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<ZoomOutIcon />}
                                        onClick={() => zoomOut()}
                                        onTouchEnd={(e) => {
                                          e.preventDefault();
                                          zoomOut();
                                        }}
                                        sx={{
                                          flex: 1,
                                          minHeight: 44,
                                          touchAction: 'manipulation',
                                          '&:active': {
                                            transform: 'scale(0.98)',
                                          },
                                        }}
                                      >
                                        Zoom Out
                                      </Button>
                                    </Box>
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      onClick={() => resetTransform()}
                                      onTouchEnd={(e) => {
                                        e.preventDefault();
                                        resetTransform();
                                      }}
                                      fullWidth
                                      sx={{
                                        mt: 1,
                                        minHeight: 44,
                                        touchAction: 'manipulation',
                                        '&:active': {
                                          transform: 'scale(0.98)',
                                        },
                                      }}
                                    >
                                      Reset View
                                    </Button>
                                  </Paper>
                                )}
                              </>
                            )}
                            </>
                          )}
                          </TransformWrapper>
                          {/* Site plan controls at bottom (same layout as top view site plan) */}
                          <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'center' }}>
                            <FormControlLabel
                              control={<Switch checked={sitePlanShowPoints} onChange={(e) => setSitePlanShowPoints(e.target.checked)} color="primary" size="small" />}
                              label={<Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Show points</Typography>}
                            />
                            <FormControlLabel
                              control={<Switch checked={sitePlanShowHeatMap} onChange={(e) => setSitePlanShowHeatMap(e.target.checked)} color="primary" size="small" />}
                              label={<Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Sold heat map</Typography>}
                            />
                            <FormControl size="small" sx={{ minWidth: 160 }}>
                              <InputLabel id="tower-view-siteplan-bedroom-label" sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Bedroom</InputLabel>
                              <Select
                                labelId="tower-view-siteplan-bedroom-label"
                                multiple
                                value={towerViewBedroomFilter.length === 0 ? [ANY_FILTER_VALUE] : towerViewBedroomFilter}
                                onChange={(e) => {
                                  const values = e.target.value as Array<string | number>;
                                  if (values.includes(ANY_FILTER_VALUE)) {
                                    const withoutAny = values.filter((v) => v !== ANY_FILTER_VALUE);
                                    const newFilter = towerViewBedroomFilter.length > 0
                                      ? []
                                      : withoutAny.map((v) => Number(v)).filter((v) => Number.isFinite(v));
                                    setTowerViewBedroomFilter(newFilter);
                                    if (!towerViewIsolatedFromMain) {
                                      setSitePlanBedroomFilter(newFilter);
                                      updateBlinkingStacks(newFilter, towerViewUnitTypeFilter);
                                    }
                                  } else {
                                    const newFilter = values.map((v) => Number(v)).filter((v) => Number.isFinite(v));
                                    setTowerViewBedroomFilter(newFilter);
                                    if (!towerViewIsolatedFromMain) {
                                      setSitePlanBedroomFilter(newFilter);
                                      updateBlinkingStacks(newFilter, towerViewUnitTypeFilter);
                                    }
                                  }
                                }}
                                label="Bedroom"
                                renderValue={(selected) => {
                                  const filtered = (selected as Array<string | number>).filter((v) => v !== ANY_FILTER_VALUE);
                                  return filtered.length === 0 ? 'Any' : filtered.map((value) => value === PENTHOUSE_FILTER_VALUE ? 'PH' : `${value}BR`).join(', ');
                                }}
                                sx={{
                                  color: 'rgba(var(--color-text-rgb), 0.9)',
                                  fontSize: '0.8rem',
                                  '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(var(--color-text-rgb), 0.23)' },
                                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(var(--color-text-rgb), 0.4)' },
                                }}
                              >
                                <MenuItem value={ANY_FILTER_VALUE}>Any</MenuItem>
                                {towerViewBedroomFilterOptionsForDialog.map((n) => (
                                  <MenuItem key={n} value={n}>{n === PENTHOUSE_FILTER_VALUE ? 'Penthouse' : `${n} Bedroom`}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            {towerViewUnitTypesForDialogFiltered.length > 0 && (
                              <FormControl size="small" sx={{ minWidth: 160 }}>
                                <InputLabel id="tower-view-siteplan-unittype-label" sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Unit Type</InputLabel>
                                <Select
                                  labelId="tower-view-siteplan-unittype-label"
                                  multiple
                                  value={towerViewUnitTypeFilter.length === 0 ? [ANY_FILTER_VALUE] : towerViewUnitTypeFilter}
                                  onChange={(e) => {
                                    const values = e.target.value as Array<string | number>;
                                    if (values.includes(ANY_FILTER_VALUE)) {
                                      const withoutAny = values.filter((v) => v !== ANY_FILTER_VALUE);
                                      const newFilter = towerViewUnitTypeFilter.length > 0
                                        ? []
                                        : (withoutAny as string[]);
                                      setTowerViewUnitTypeFilter(newFilter);
                                      if (!towerViewIsolatedFromMain) {
                                        updateBlinkingStacks(towerViewBedroomFilter, newFilter);
                                      }
                                    } else {
                                      const newFilter = values as string[];
                                      setTowerViewUnitTypeFilter(newFilter);
                                      if (!towerViewIsolatedFromMain) {
                                        updateBlinkingStacks(towerViewBedroomFilter, newFilter);
                                      }
                                    }
                                  }}
                                  label="Unit Type"
                                  renderValue={(selected) => {
                                    const filtered = (selected as Array<string | number>).filter((v) => v !== ANY_FILTER_VALUE);
                                    return filtered.length === 0 ? 'Any' : filtered.join(', ');
                                  }}
                                  sx={{
                                    color: 'rgba(var(--color-text-rgb), 0.9)',
                                    fontSize: '0.8rem',
                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(var(--color-text-rgb), 0.23)' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(var(--color-text-rgb), 0.4)' },
                                  }}
                                >
                                  <MenuItem value={ANY_FILTER_VALUE}>Any</MenuItem>
                                  {towerViewUnitTypesForDialogFiltered.map((ut) => (
                                    <MenuItem key={ut} value={ut}>{ut}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            )}
                            {Array.from(towerViewStackSoldPercentagesForDialog.values()).some((v) => v === 100) && (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 'auto' }}>
                                <Box
                                  sx={{
                                    width: 18,
                                    height: 18,
                                    borderRadius: '50%',
                                    backgroundColor: '#ff4d4f',
                                    border: '2px solid var(--color-black)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.65rem',
                                    fontWeight: 'bold',
                                    color: 'var(--color-black)',
                                  }}
                                >
                                  #
                                </Box>
                                <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                  Stack is fully sold(black label & border)
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      )}

                      {/* Tower View Controls - above tower grid (Bedroom color, display options only; Bedroom/Unit Type filters are in site plan section above) */}
                      <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'center', bgcolor: 'rgba(var(--color-text-rgb), 0.04)' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'var(--color-text-strong)', mr: 1 }}>All Blocks Tower View</Typography>
                        <FormControlLabel
                          control={<Switch checked={towerViewBedroomColor} onChange={(e) => setTowerViewBedroomColor(e.target.checked)} color="primary" size="small" />}
                          label={<Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Bedroom color</Typography>}
                          sx={{ mr: 1 }}
                        />
                        {towerViewBedroomColor && towerViewBedroomFilterOptionsForDialog.length > 0 && (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, mr: 1 }}>
                            {towerViewBedroomFilterOptionsForDialog.map((br) => (
                              <Box key={br} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Box sx={{ width: 14, height: 14, borderRadius: '3px', bgcolor: getTowerViewBedroomColor(br), border: '1px solid rgba(255,255,255,0.5)' }} />
                                <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                  {br === PENTHOUSE_FILTER_VALUE ? 'PH' : `${br}BR`}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        )}
                        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                          <Box sx={{ minWidth: 90 }}>
                            <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', display: 'block', mb: 0.25 }}>Show all attributes</Typography>
                            <Switch
                              checked={towerViewAllDisplayOptions.length === TOWER_VIEW_DISPLAY_OPTIONS.length}
                              onChange={(e) => setTowerViewAllDisplayOptions(e.target.checked ? [...TOWER_VIEW_DISPLAY_OPTIONS] : [])}
                              size="small"
                            />
                          </Box>
                          <FormControl size="small" sx={{ minWidth: 220 }}>
                            <InputLabel id="tower-view-display-options-label" sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>Show</InputLabel>
                            <Select
                              labelId="tower-view-display-options-label"
                              multiple
                              value={towerViewAllDisplayOptions}
                              onChange={(e) => setTowerViewAllDisplayOptions((e.target.value as TowerViewDisplayOption[]))}
                              label="Show"
                              renderValue={(selected) => (selected.length === 0 ? 'Unit no. only' : selected.map((k) => ({ bedroom: 'Bedroom type', price: 'SOLD / price', psf: 'PSF', size: 'Size' }[k])).join(', '))}
                              sx={{ color: 'rgba(var(--color-text-rgb), 0.9)', fontSize: '0.8rem', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(var(--color-text-rgb), 0.23)' } }}
                            >
                              <MenuItem value="bedroom"><Checkbox size="small" checked={towerViewAllDisplayOptions.indexOf('bedroom') > -1} sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', p: 0.5, mr: 1 }} />Show bedroom type</MenuItem>
                              <MenuItem value="price"><Checkbox size="small" checked={towerViewAllDisplayOptions.indexOf('price') > -1} sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', p: 0.5, mr: 1 }} />Show price</MenuItem>
                              <MenuItem value="psf"><Checkbox size="small" checked={towerViewAllDisplayOptions.indexOf('psf') > -1} sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', p: 0.5, mr: 1 }} />Show PSF</MenuItem>
                              <MenuItem value="size"><Checkbox size="small" checked={towerViewAllDisplayOptions.indexOf('size') > -1} sx={{ color: 'rgba(var(--color-text-rgb), 0.7)', p: 0.5, mr: 1 }} />Show size</MenuItem>
                            </Select>
                          </FormControl>
                          <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', border: '1px solid rgba(var(--color-text-rgb), 0.2)', borderRadius: 1 }}>
                            <IconButton size="small" onClick={() => setTowerZoom((prev) => Math.max(0.5, prev - 0.1))} disabled={towerZoom <= 0.5}>
                              <ZoomOutIcon fontSize="small" />
                            </IconButton>
                            <Typography variant="caption" sx={{ minWidth: 44, textAlign: 'center' }}>{Math.round(towerZoom * 100)}%</Typography>
                            <IconButton size="small" onClick={() => setTowerZoom((prev) => Math.min(2, prev + 0.1))} disabled={towerZoom >= 2}>
                              <ZoomInIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </Box>
                      </Box>

                      {/* Tower View Grid Section */}
                      <Box sx={{ p: 2, display: 'flex', flexWrap: 'wrap', gap: 3, alignItems: 'flex-start' }}>
                      {towerViewDataForDialog.blockNumbers.map((block) => {
                        const blockData = towerViewDataForDialog.blocks.get(block);
                        if (!blockData || blockData.floors.length === 0 || blockData.stacks.length === 0) return null;
                        const hasBedroomFilter = towerViewBedroomFilter.length > 0;
                        const hasUnitTypeFilter = towerViewUnitTypeFilter.length > 0;
                        const hasAnyFilter = hasBedroomFilter || hasUnitTypeFilter;
                        // Helper: does a unit match the active filters?
                        const unitMatchesFilter = (u: TowerViewUnit | ComparableUnit | undefined): boolean => {
                          if (!u) return false;
                          if (!hasAnyFilter) return true;
                          const bed = 'bedroom' in u ? normalizeBedroomValue(u.bedroom) : null;
                          const uType = 'unitType' in u ? (u as TowerViewUnit).unitType : null;
                          if (hasBedroomFilter) {
                            const unitIsPenthouse = isPenthouseUnit(u as TowerViewUnit);
                            const matchesBedroom = towerViewBedroomFilter.some((filterValue) => {
                              if (filterValue === PENTHOUSE_FILTER_VALUE) return unitIsPenthouse;
                              return !unitIsPenthouse && bed != null && bed === filterValue;
                            });
                            if (!matchesBedroom) return false;
                          }
                          if (hasUnitTypeFilter && (!uType || !towerViewUnitTypeFilter.includes(uType))) return false;
                          return true;
                        };
                        // When filter active, only show stacks that have at least one matching unit
                        const visibleStacks = hasAnyFilter
                          ? blockData.stacks.filter((stack: number) => blockData.floors.some((floor: number) => unitMatchesFilter(blockData.grid.get(`${floor}-${stack}`))))
                          : blockData.stacks;
                        if (hasAnyFilter && visibleStacks.length === 0) return null;
                        const allTabCompact = towerViewAllDisplayOptions.length === 0;
                        const showAllTabSize = towerViewAllDisplayOptions.includes('size');
                        const cellSize = allTabCompact ? 36 : (showAllTabSize && (towerViewAllDisplayOptions.includes('price') || towerViewAllDisplayOptions.includes('psf')) ? 72 : showAllTabSize ? 64 : 56);
                        const cellGap = allTabCompact ? 0.15 : 0.25;
                        const cellPadding = allTabCompact ? 0.2 : 0.4;
                        const unitFontSize = allTabCompact ? '0.55rem' : '0.6rem';
                        return (
                          <Box key={block} sx={{ flexShrink: 0 }}>
                            <Box sx={{ bgcolor: 'var(--color-accent)', color: 'var(--color-text-inverse)', px: 1.5, py: 0.75, fontWeight: 700, fontSize: '0.8rem', textAlign: 'center' }}>
                              {formatBlockNumber(block).toUpperCase().replace(/^BLOCK /i, 'BLK ')}
                            </Box>
                            <Box sx={{ display: 'grid', gridTemplateColumns: `auto repeat(${visibleStacks.length}, ${cellSize}px)`, gap: cellGap, width: 'fit-content', bgcolor: 'rgba(var(--color-shadow-rgb), 0.2)' }}>
                              <Box sx={{ p: allTabCompact ? 0.35 : 0.5, fontWeight: 'bold', bgcolor: 'rgba(var(--color-text-rgb), 0.15)', fontSize: allTabCompact ? '0.55rem' : '0.6rem', color: 'var(--color-text-strong)', borderRight: '1px solid rgba(var(--color-text-rgb), 0.08)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)' }} />
                              {visibleStacks.map((s: number) => {
                                const stackUnits = blockData.floors
                                  .map((f) => blockData.grid.get(`${f}-${s}`) as TowerViewUnit | ComparableUnit | undefined)
                                  .filter((u): u is TowerViewUnit | ComparableUnit => !!u);
                                const seen = new Set<string>();
                                const entries: Array<{ bedroom: number | null; unitType: string; size: number | null }> = [];
                                for (const u of stackUnits) {
                                  const br = 'bedroom' in u ? normalizeBedroomValue(u.bedroom) : null;
                                  const ut = (u as TowerViewUnit).unitType ?? '';
                                  const sz = 'areaSqft' in u ? (u as TowerViewUnit).areaSqft : null;
                                  const key = `${br ?? ''}-${ut}-${sz ?? ''}`;
                                  if (seen.has(key)) continue;
                                  seen.add(key);
                                  entries.push({ bedroom: br, unitType: ut, size: sz });
                                }
                                const line = entries.length > 0
                                  ? entries.map((e) => {
                                      const brStr = e.bedroom != null ? `${e.bedroom} BR` : '';
                                      const typeStr = e.unitType ? e.unitType : '';
                                      const sizeStr = e.size != null && Number.isFinite(e.size) ? `${e.size} sqft` : '';
                                      return [brStr, typeStr, sizeStr].filter(Boolean).join(' / ');
                                    }).join(' • ')
                                  : '-';
                                const stackAnalysisStackNumber = String(s).padStart(2, '0');
                                const canOpenStackAnalysis = Boolean(towerViewStackAnalysisProjectName);
                                const openStackAnalysis = () => {
                                  if (!canOpenStackAnalysis) return;
                                  handleOpenStackAnalysis(towerViewStackAnalysisProjectName, stackAnalysisStackNumber);
                                };
                                return (
                                  <Box
                                    key={s}
                                    onClick={openStackAnalysis}
                                    role={canOpenStackAnalysis ? 'button' : undefined}
                                    tabIndex={canOpenStackAnalysis ? 0 : undefined}
                                    onKeyDown={(event) => {
                                      if (!canOpenStackAnalysis) return;
                                      if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        openStackAnalysis();
                                      }
                                    }}
                                    sx={{
                                      p: allTabCompact ? 0.35 : 0.5,
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      bgcolor: 'rgba(var(--color-text-rgb), 0.15)',
                                      fontSize: allTabCompact ? '0.5rem' : '0.55rem',
                                      color: 'var(--color-text-strong)',
                                      borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'center',
                                      lineHeight: 1.15,
                                      cursor: canOpenStackAnalysis ? 'pointer' : 'default',
                                      userSelect: canOpenStackAnalysis ? 'none' : 'auto',
                                      '&:hover': canOpenStackAnalysis ? { bgcolor: 'rgba(var(--color-accent-rgb), 0.28)' } : undefined,
                                      '&:focus-visible': canOpenStackAnalysis ? { outline: '2px solid var(--color-accent)', outlineOffset: '-2px' } : undefined,
                                    }}
                                  >
                                    <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 700 }}>{s.toString().padStart(2, '0')}</Typography>
                                    {!allTabCompact && line !== '-' && (
                                      <Typography component="span" sx={{ fontSize: '0.5rem', fontWeight: 500, opacity: 0.9 }}>{line}</Typography>
                                    )}
                                  </Box>
                                );
                              })}
                              {blockData.floors.map((floor: number) => (
                                <React.Fragment key={`all-floor-${block}-${floor}`}>
                                  <Box sx={{ p: allTabCompact ? 0.35 : 0.5, fontWeight: 'bold', bgcolor: 'rgba(var(--color-text-rgb), 0.12)', fontSize: allTabCompact ? '0.55rem' : '0.6rem', color: 'var(--color-text-strong)', borderRight: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
                                    {formatTowerFloorLabel(floor)}
                                  </Box>
                                  {visibleStacks.map((stack: number) => {
                                    const unit = blockData.grid.get(`${floor}-${stack}`);
                                    const isSold = unit?.unitStatus === 'SOLD';
                                    const isNotReleased = isUnitStatusNotReleased(unit?.unitStatus);
                                    const unitPrice = unit && 'price' in unit ? unit.price : 0;
                                    const unitBedroom = unit && 'bedroom' in unit ? normalizeBedroomValue(unit.bedroom) : null;
                                    const bedroomForColor = unit && isPenthouseUnit(unit as { unitTypeDescription?: string | null; unitType?: string | null }) ? PENTHOUSE_FILTER_VALUE : unitBedroom;
                                    const unitNumber = unit && 'unitNumber' in unit ? unit.unitNumber : '';
                                    const unitFloorplan = unit && 'floorplan' in unit ? (unit as TowerViewUnit | ComparableUnit).floorplan : null;
                                    const isInterestMap = towerViewAllMapMode === 'interest';
                                    const interestPercent = isInterestMap ? getMockInterestPercent(unit ?? null, floor, stack, blockData.floors, blockData.stacks, block) : 0;
                                    const interestBg = isInterestMap ? getInterestHeatColor(interestPercent) : undefined;
                                    // Unit does not match filter — show blank cell (stack is visible because other floors match)
                                    const filteredOut = hasAnyFilter && !unitMatchesFilter(unit);
                                    const cellBg = filteredOut ? 'rgba(var(--color-text-rgb), 0.04)' : (isInterestMap ? interestBg : (isSold ? 'var(--color-danger)' : (towerViewBedroomColor ? getTowerViewBedroomColor(bedroomForColor) : 'rgba(var(--color-shadow-rgb), 0.2)')));
                                    const cellBorder = filteredOut ? 'rgba(var(--color-text-rgb), 0.08)' : (isInterestMap ? 'rgba(0,0,0,0.12)' : (isSold ? 'var(--color-danger)' : (towerViewBedroomColor ? 'rgba(255,255,255,0.5)' : 'rgba(var(--color-text-rgb), 0.15)')));
                                    const isLightThemeActive = currentTheme === 'light';
                                    const bedroomColorTextDark = isLightThemeActive && towerViewBedroomColor && !isSold && !isInterestMap;
                                    const textColor = isInterestMap ? '#000' : (isSold ? '#fff' : (towerViewBedroomColor ? (bedroomColorTextDark ? 'rgba(15, 23, 42, 0.95)' : 'var(--color-text-inverse)') : 'rgba(var(--color-text-rgb), 0.95)'));
                                    const textColorSecondary = isInterestMap ? 'rgba(0,0,0,0.75)' : (isSold ? 'rgba(255,255,255,0.9)' : (towerViewBedroomColor ? (bedroomColorTextDark ? 'rgba(15, 23, 42, 0.75)' : 'rgba(255,255,255,0.9)') : 'rgba(var(--color-text-rgb), 0.7)'));
                                    const interestTextShadow = isInterestMap ? '0 0 1px #fff, 0 0 2px #fff' : undefined;
                                    return (
                                      <Box
                                        key={`all-unit-${block}-${floor}-${stack}`}
                                        onClick={() => {
                                          if (unit && !filteredOut) {
                                            handleOpenTowerViewFloorPlan(unit as TowerViewUnit | ComparableUnit);
                                          }
                                        }}
                                        sx={{
                                          width: cellSize,
                                          height: cellSize,
                                          p: cellPadding,
                                          border: '1px solid',
                                          borderColor: cellBorder,
                                          borderRadius: allTabCompact ? 0.15 : 0.25,
                                          bgcolor: cellBg,
                                          display: 'flex',
                                          flexDirection: 'column',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          cursor: filteredOut ? 'default' : (unitFloorplan ? 'pointer' : 'default'),
                                          '&:hover': filteredOut ? {} : (unitFloorplan ? { boxShadow: 1 } : {}),
                                        }}
                                      >
                                        {unit && !filteredOut ? (
                                          <>
                                            <Typography sx={{ fontSize: unitFontSize, fontWeight: 600, color: textColor, ...(interestTextShadow ? { textShadow: interestTextShadow } : {}) }}>{unitNumber}</Typography>
                                            {towerViewAllDisplayOptions.includes('bedroom') && (
                                              (() => {
                                                const unitTypeStr = (unit as TowerViewUnit).unitType ? String((unit as TowerViewUnit).unitType).replace(/Bedroom/gi, 'BR') : '';
                                                return (
                                                  <Typography sx={{ fontSize: '0.55rem', color: textColorSecondary }}>
                                                    {unitBedroom != null ? `${unitBedroom}BR${unitTypeStr ? ` / ${unitTypeStr}` : ''}` : '-'}
                                                  </Typography>
                                                );
                                              })()
                                            )}
                                            {towerViewAllDisplayOptions.includes('price') && !isInterestMap && (
                                              isSold ? (
                                                <Typography sx={{ fontSize: '0.55rem', fontWeight: 700, color: '#fff' }}>SOLD</Typography>
                                              ) : isNotReleased ? (
                                                <Typography sx={{ fontSize: '0.5rem', color: 'rgba(var(--color-text-rgb), 0.9)' }}>-</Typography>
                                              ) : unitPrice > 0 ? (
                                                <Typography sx={{ fontSize: '0.5rem', color: 'rgba(var(--color-text-rgb), 0.9)' }}>{formatCurrency(unitPrice)}</Typography>
                                              ) : null
                                            )}
                                            {towerViewAllDisplayOptions.includes('psf') && !isInterestMap && (
                                              (() => {
                                                const unitPsf = unit && 'psf' in unit ? (unit as TowerViewUnit | ComparableUnit).psf : 0;
                                                if (isNotReleased) {
                                                  return <Typography sx={{ fontSize: '0.5rem', color: textColorSecondary }}>-</Typography>;
                                                }
                                                return unitPsf > 0 ? (
                                                  <Typography sx={{ fontSize: '0.5rem', color: textColorSecondary }}>{formatNumber(unitPsf, 0)} psf</Typography>
                                                ) : null;
                                              })()
                                            )}
                                            {towerViewAllDisplayOptions.includes('size') && !isInterestMap && (
                                              (() => {
                                                const unitArea = unit && 'areaSqft' in unit ? (unit as TowerViewUnit | ComparableUnit).areaSqft : 0;
                                                return unitArea > 0 ? (
                                                  <Typography sx={{ fontSize: '0.5rem', color: textColorSecondary }}>{formatNumber(unitArea, 0)} sqft</Typography>
                                                ) : null;
                                              })()
                                            )}
                                          </>
                                        ) : (
                                          <Typography sx={{ fontSize: '0.5rem', color: 'rgba(var(--color-text-rgb), 0.4)' }}>–</Typography>
                                        )}
                                      </Box>
                                    );
                                  })}
                                </React.Fragment>
                              ))}
                            </Box>
                          </Box>
                        );
                      })}
                      </Box>
                    </Box>
                  ) : (() => {
                    const currentBlock = selectedBlock || towerViewDataForDialog.blockNumbers[0] || '';
                    const blockData = towerViewDataForDialog.blocks.get(currentBlock);
                    
                    if (!blockData || blockData.floors.length === 0 || blockData.stacks.length === 0) {
                      return (
                        <Box sx={{ p: 4, textAlign: 'center' }}>
                          <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                            No units available for this block.
                          </Typography>
                        </Box>
                      );
                    }
                    
                    return (
                      <Box sx={{ p: 2, width: 'fit-content', height: 'fit-content' }}>
                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: `auto repeat(${blockData.stacks.length}, 100px)`,
                            gap: 0.5,
                            width: 'fit-content',
                          }}
                        >
                          {/* Header row with stack labels - sticky so it stays visible when scrolling (no transform on ancestor) */}
                          <Box sx={{ 
                            position: 'sticky', 
                            left: 0, 
                            top: 0,
                            zIndex: 10, 
                            bgcolor: 'var(--color-surface)',
                            boxShadow: '0 1px 0 rgba(var(--color-text-rgb), 0.08)',
                            p: 0.75, 
                            fontWeight: 'bold', 
                            color: 'var(--color-text-strong)', 
                            fontSize: '0.75rem',
                            borderRight: '1px solid rgba(var(--color-text-rgb), 0.08)',
                            borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)',
                          }}>
                            FLOOR
                          </Box>
                          {blockData.stacks.map((stack: number) => {
                            const stackAnalysisStackNumber = String(stack).padStart(2, '0');
                            const canOpenStackAnalysis = Boolean(towerViewStackAnalysisProjectName);
                            const openStackAnalysis = () => {
                              if (!canOpenStackAnalysis) return;
                              handleOpenStackAnalysis(towerViewStackAnalysisProjectName, stackAnalysisStackNumber);
                            };
                            return (
                            <Box
                              key={`header-${stack}`}
                              onClick={openStackAnalysis}
                              role={canOpenStackAnalysis ? 'button' : undefined}
                              tabIndex={canOpenStackAnalysis ? 0 : undefined}
                              onKeyDown={(event) => {
                                if (!canOpenStackAnalysis) return;
                                if (event.key === 'Enter' || event.key === ' ') {
                                  event.preventDefault();
                                  openStackAnalysis();
                                }
                              }}
                              sx={{
                                p: 0.75,
                                textAlign: 'center',
                                fontWeight: 'bold',
                                bgcolor: 'var(--color-surface)',
                                boxShadow: '0 1px 0 rgba(var(--color-text-rgb), 0.08)',
                                position: 'sticky',
                                top: 0,
                                zIndex: 9,
                                color: 'var(--color-text-strong)',
                                fontSize: '0.75rem',
                                borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)',
                                cursor: canOpenStackAnalysis ? 'pointer' : 'default',
                                userSelect: canOpenStackAnalysis ? 'none' : 'auto',
                                '&:hover': canOpenStackAnalysis ? { bgcolor: 'rgba(var(--color-accent-rgb), 0.25)' } : undefined,
                                '&:focus-visible': canOpenStackAnalysis ? { outline: '2px solid var(--color-accent)', outlineOffset: '-2px' } : undefined,
                              }}
                            >
                              STACK {stack.toString().padStart(2, '0')}
                            </Box>
                            );
                          })}

                          {/* Unit grid rows */}
                          {blockData.floors.map((floor: number) => (
                            <React.Fragment key={`floor-${floor}`}>
                              {/* Floor label */}
                              <Box
                                sx={{
                                  position: 'sticky',
                                  left: 0,
                                  zIndex: 8,
                                  bgcolor: 'var(--color-surface)',
                                  p: 0.75,
                                  fontWeight: 'bold',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: 'var(--color-text-strong)',
                                  fontSize: '0.75rem',
                                  borderRight: '1px solid rgba(var(--color-text-rgb), 0.08)',
                                }}
                              >
                                FLOOR {formatTowerFloorLabel(floor)}
                              </Box>

                              {/* Unit cells for this floor */}
                              {blockData.stacks.map((stack: number) => {
                                const unit = blockData.grid.get(`${floor}-${stack}`);
                                const isSold = unit?.unitStatus === 'SOLD';
                                const isNotReleased = isUnitStatusNotReleased(unit?.unitStatus);
                                const isSelected =
                                  selectedUnitForTowerView &&
                                  parseUnitNumber(selectedUnitForTowerView.unitNumber).floor === floor &&
                                  parseUnitNumber(selectedUnitForTowerView.unitNumber).stack === stack;
                                
                                // Handle both TowerViewUnit and ComparableUnit types
                                const unitPrice = unit && 'price' in unit ? unit.price : 0;
                                const unitBedroom = unit && 'bedroom' in unit ? normalizeBedroomValue(unit.bedroom) : null;
                                const unitAreaSqft = unit && 'areaSqft' in unit ? unit.areaSqft : 0;
                                const unitNumber = unit && 'unitNumber' in unit ? unit.unitNumber : '';
                                const isBestBuy = unit && 'isBestBuy' in unit ? (unit as TowerViewUnit).isBestBuy : false;

                                // Get floorplan if available (for TowerViewUnit or ComparableUnit)
                                const unitFloorplan = unit && 'floorplan' in unit ? (unit as TowerViewUnit | ComparableUnit).floorplan : null;
                                // Bedroom / unit type filter
                                const hasAnyFilter = towerViewBedroomFilter.length > 0 || towerViewUnitTypeFilter.length > 0;
                                const filteredOut = unit != null && hasAnyFilter && (
                                  (towerViewBedroomFilter.length > 0 && !towerViewBedroomFilter.some((filterValue) => {
                                    const unitIsPenthouse = isPenthouseUnit(unit as TowerViewUnit);
                                    if (filterValue === PENTHOUSE_FILTER_VALUE) return unitIsPenthouse;
                                    return !unitIsPenthouse && unitBedroom != null && unitBedroom === filterValue;
                                  })) ||
                                  (towerViewUnitTypeFilter.length > 0 && !towerViewUnitTypeFilter.includes((unit as TowerViewUnit).unitType || ''))
                                );

                                return (
                                  <Box
                                    key={`unit-${floor}-${stack}`}
                                    id={`tower-unit-${floor}-${stack}`}
                                    onClick={() => {
                                      if (unit && !filteredOut) {
                                        // Convert to ComparableUnit format if needed
                                        const unitForFloorPlan: TowerViewUnit | ComparableUnit = unit as TowerViewUnit | ComparableUnit;
                                        handleOpenTowerViewFloorPlan(unitForFloorPlan);
                                      }
                                    }}
                                    sx={{
                                      width: '100px',
                                      height: '100px',
                                      aspectRatio: 1,
                                      p: 0.75,
                                      border: '1px solid',
                                      borderColor: filteredOut
                                        ? 'rgba(var(--color-text-rgb), 0.08)'
                                        : isSold
                                        ? 'var(--color-danger)'
                                        : isSelected
                                        ? 'var(--color-accent)'
                                        : 'rgba(var(--color-text-rgb), 0.15)',
                                      borderRadius: 0.5,
                                      bgcolor: filteredOut
                                        ? 'rgba(var(--color-text-rgb), 0.04)'
                                        : isSold
                                        ? 'var(--color-danger)'
                                        : isSelected
                                        ? 'rgba(var(--color-accent-rgb), 0.2)'
                                        : 'rgba(var(--color-shadow-rgb), 0.2)',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 0.25,
                                      transition: 'all 0.2s',
                                      boxSizing: 'border-box',
                                      opacity: filteredOut ? 0.3 : 1,
                                      cursor: filteredOut ? 'default' : (unitFloorplan ? 'pointer' : 'default'),
                                      '&:hover': filteredOut ? {} : {
                                        boxShadow: unitFloorplan ? 2 : 0,
                                        transform: unitFloorplan ? 'translateY(-1px)' : 'none',
                                      },
                                    }}
                                  >
                                    {unit ? (
                                      <>
                                        <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '0.7rem', color: isSold ? '#fff' : 'rgba(var(--color-text-rgb), 0.95)' }}>
                                          {unitNumber}
                                        </Typography>
                                        <Typography variant="caption" sx={{ fontSize: '0.65rem', color: isSold ? 'rgba(255,255,255,0.9)' : 'rgba(var(--color-text-rgb), 0.7)' }}>
                                          {unitBedroom != null ? `${unitBedroom}BR${(unit as TowerViewUnit).unitType ? ` / ${(unit as TowerViewUnit).unitType}` : ''}` : '-'}
                                        </Typography>
                                        <Typography variant="caption" sx={{ fontSize: '0.65rem', color: isSold ? 'rgba(255,255,255,0.85)' : 'rgba(var(--color-text-rgb), 0.9)' }}>
                                          {formatNumber(unitAreaSqft)} sqft
                                        </Typography>
                                        {isSold ? (
                                          <Typography
                                            variant="caption"
                                            sx={{
                                              color: '#fff',
                                              fontWeight: 'bold',
                                              mt: 'auto',
                                              fontSize: '0.7rem',
                                            }}
                                          >
                                            SOLD
                                          </Typography>
                                        ) : isNotReleased ? (
                                          <Typography
                                            variant="caption"
                                            fontWeight="medium"
                                            sx={{
                                              color: 'rgba(var(--color-text-rgb), 0.9)',
                                              mt: 'auto',
                                              fontSize: '0.65rem',
                                            }}
                                          >
                                            -
                                          </Typography>
                                        ) : (
                                          <>
                                            {isBestBuy && (
                                              <Chip
                                                label="PRICE PROMO"
                                                size="small"
                                                onClick={() => setPricePromoInfoOpen(true)}
                                                sx={{
                                                  height: 16,
                                                  fontSize: '0.6rem',
                                                  fontWeight: 'bold',
                                                  bgcolor: 'var(--color-success)',
                                                  color: '#0f2a1d',
                                                  mt: 'auto',
                                                  mb: 0.25,
                                                  cursor: 'pointer',
                                                }}
                                              />
                                            )}
                                            {unitPrice > 0 ? (
                                              <Typography variant="caption" fontWeight="medium" sx={{ fontSize: '0.65rem', color: 'rgba(var(--color-text-rgb), 0.9)' }}>
                                                {formatCurrency(unitPrice)}
                                              </Typography>
                                            ) : (
                                              <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                                                N/A
                                              </Typography>
                                            )}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          height: '100%',
                                          color: 'rgba(var(--color-text-rgb), 0.4)',
                                        }}
                                      >
                                        <Typography variant="caption" sx={{ fontSize: '0.65rem' }}>N/A</Typography>
                                      </Box>
                                    )}
                                  </Box>
                                );
                              })}
                            </React.Fragment>
                          ))}
                        </Box>
                      </Box>
                    );
                  })()}
                  </Box>
                ) : (
                  <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                      No units available for tower view.
                    </Typography>
                  </Box>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Button
              {...towerViewCloseHandlers}
              sx={{
                ...towerViewCloseHandlers.sx,
                minHeight: 44,
                px: 3,
                color: 'rgba(var(--color-text-rgb), 0.9)',
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Tower View Floor Plan Dialog */}
        <Dialog
          open={towerViewFloorPlanOpen}
          onClose={handleCloseTowerViewFloorPlan}
          fullScreen={isMobile}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: isMobile ? '100dvh' : '90vh',
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: isMobile ? 'none' : '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
              // Touch optimizations
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'rgba(0,0,0,0.1)',
              // Disable hover on mobile
              ...(isMobile && {
                '*:hover': {
                  backgroundColor: 'inherit !important',
                },
              }),
            },
          }}
        >
          <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1, flexWrap: 'nowrap' }}>
              <Typography variant={isMobile ? 'subtitle1' : 'h6'} sx={{ color: 'inherit', pr: 1 }}>
                Floor Plan - {selectedTowerViewUnitForFloorPlan?.projectName} {selectedTowerViewUnitForFloorPlan?.unitNumber}
              </Typography>
              {(canAccessFloorPlan3d || canAccessFloorPlan3dSun) && selectedTowerViewUnitForFloorPlan?.floorplan && (
                <ToggleButtonGroup size="small" exclusive value={floorPlanViewMode}
                  onChange={(_, value) => value && selectFloorPlanViewMode(value, selectedTowerViewUnitForFloorPlan)}
                  sx={{ ml: 'auto', mr: 1, '& .MuiToggleButton-root': { px: 1.5, py: 0.25, fontSize: '0.75rem', fontWeight: 600, lineHeight: 1.6 } }}>
                  <ToggleButton value="2d">2D</ToggleButton>
                  {canAccessFloorPlan3d && <ToggleButton value="3d">3D</ToggleButton>}
                  {canAccessFloorPlan3dSun && <ToggleButton value="3ds">3DS</ToggleButton>}
                </ToggleButtonGroup>
              )}
              <IconButton
                {...towerViewFloorPlanCloseHandlers}
                size="small"
                sx={{
                  ...towerViewFloorPlanCloseHandlers.sx,
                  minWidth: 44,
                  minHeight: 44,
                  padding: 1.5,
                  color: 'rgba(var(--color-text-rgb), 0.9)',
                  '&:active': {
                    backgroundColor: 'rgba(0,0,0,0.12)',
                    transform: 'scale(0.95)',
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: isMobile ? 1.5 : 2, overflow: 'auto', maxHeight: isMobile ? 'none' : '80vh', bgcolor: 'var(--color-surface)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
            {towerViewFloorPlanRefreshing ? (
              <Box sx={{ minHeight: isMobile ? '45vh' : '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                <CircularProgress size={28} />
                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  Refreshing latest unit details...
                </Typography>
              </Box>
            ) : selectedTowerViewUnitForFloorPlan && selectedTowerViewUnitForFloorPlan.floorplan ? (
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, alignItems: 'flex-start' }}>
                {floorPlanViewMode !== '2d' ? (
                  <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
                    <React.Suspense fallback={<Box sx={{ minHeight: isMobile ? '45vh' : '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress size={28} /></Box>}>
                      <SolarFloorPlan key={`${selectedTowerViewUnitForFloorPlan.id}-${selectedTowerViewUnitForFloorPlan.floorplan}-${floorPlanViewMode}`}
                        unitId={selectedTowerViewUnitForFloorPlan.id} imageUrl={selectedTowerViewUnitForFloorPlan.floorplan}
                        unitLabel={floorPlanUnitLabel(selectedTowerViewUnitForFloorPlan)}
                        sunlight={floorPlanViewMode === '3ds'} canCalibrateNorth={isAdminUser}
                        onFallback={() => setFloorPlanViewMode('2d')} />
                    </React.Suspense>
                  </Box>
                ) : (
                <Box sx={{ flex: 1, minWidth: 0, width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <TransformWrapper
                    initialScale={1}
                    minScale={0.8}
                    maxScale={5}
                    centerOnInit
                    limitToBounds={false}
                    centerZoomedOut
                    wheel={{ step: 0.08 }}
                    pinch={{ step: 5 }}
                    doubleClick={{ step: 0.8 }}
                    panning={{ disabled: false, velocityDisabled: true }}
                  >
                    {({ zoomIn, zoomOut, resetTransform }) => (
                      <Box sx={{ width: '100%', position: 'relative' }}>
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            zIndex: 2,
                            display: 'flex',
                            gap: 0.5,
                            p: 0.5,
                            borderRadius: 1,
                            bgcolor: 'rgba(var(--color-shadow-rgb), 0.45)',
                            backdropFilter: 'blur(8px)',
                          }}
                        >
                          <IconButton size="small" onClick={() => zoomOut()} sx={{ color: 'var(--color-text-strong)' }}>
                            <ZoomOutIcon fontSize="small" />
                          </IconButton>
                          <IconButton size="small" onClick={() => zoomIn()} sx={{ color: 'var(--color-text-strong)' }}>
                            <ZoomInIcon fontSize="small" />
                          </IconButton>
                          <Button size="small" onClick={() => resetTransform()} sx={{ minWidth: 0, px: 1, color: 'var(--color-text-strong)' }}>
                            Reset
                          </Button>
                        </Box>
                        <TransformComponent
                          wrapperStyle={{
                            width: '100%',
                            height: isMobile ? '45vh' : '70vh',
                            overflow: 'hidden',
                            borderRadius: '8px',
                          }}
                          contentStyle={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Box
                              component="img"
                              src={selectedTowerViewUnitForFloorPlan.floorplan ?? undefined}
                              alt={`Floor plan for ${selectedTowerViewUnitForFloorPlan.projectName} ${selectedTowerViewUnitForFloorPlan.unitNumber}`}
                              sx={{
                                display: 'block',
                                width: '100%',
                                height: '100%',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                                borderRadius: 1,
                                boxShadow: 2,
                              }}
                              onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                                const target = e.target as HTMLImageElement;
                                target.style.display = 'none';
                                const errorBox = target.nextElementSibling as HTMLElement;
                                if (errorBox) errorBox.style.display = 'block';
                              }}
                            />
                            <Box
                              sx={{
                                display: 'none',
                                p: 3,
                                textAlign: 'center',
                                border: '1px dashed rgba(var(--color-text-rgb), 0.2)',
                                borderRadius: 1,
                                bgcolor: 'rgba(var(--color-shadow-rgb), 0.3)',
                              }}
                            >
                              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.8)' }}>
                                Unable to load floor plan image.
                              </Typography>
                              <Typography variant="caption" sx={{ mt: 1, display: 'block', color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                                URL: {selectedTowerViewUnitForFloorPlan.floorplan}
                              </Typography>
                            </Box>
                          </Box>
                        </TransformComponent>
                      </Box>
                    )}
                  </TransformWrapper>
                </Box>
                )}
                {(() => {
                  const unit = selectedTowerViewUnitForFloorPlan;
                  const npsPrice = unit.priceNps ?? unit.price ?? 0;
                  const dpsPrice = unit.priceDps ?? 0;
                  const npsPsf = unit.psfNps ?? unit.psf ?? 0;
                  const dpsPsf = unit.psfDps ?? 0;
                  const isEc = projectDetailsMap.get(unit.projectName)?.projectCategoryId === 'C1803'
                    || dpsPrice > 0
                    || dpsPsf > 0;
                  return (
                    <Box
                      sx={{
                        width: { xs: '100%', sm: 280 },
                        minWidth: { xs: 0, sm: 240 },
                        borderLeft: { xs: 'none', sm: '1px solid rgba(var(--color-text-rgb), 0.12)' },
                        borderTop: { xs: '1px solid rgba(var(--color-text-rgb), 0.12)', sm: 'none' },
                        pl: { xs: 0, sm: 2 },
                        pt: { xs: 2, sm: 0 },
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Unit Info</Typography>
                      <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr', rowGap: 0.6, columnGap: 1 }}>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Status</Typography>
                        <Typography variant="caption">{unit.unitStatus ?? '-'}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Project</Typography>
                        <Typography variant="caption">{unit.projectName}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Unit</Typography>
                        <Typography variant="caption">{unit.unitNumber}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Block</Typography>
                        <Typography variant="caption">{unit.blockNumber ? formatBlockNumber(unit.blockNumber) : '-'}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Bedroom</Typography>
                        <Typography variant="caption">{unit.bedroom}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Bathroom</Typography>
                        <Typography variant="caption">{unit.bathroom ?? '-'}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Area</Typography>
                        <Typography variant="caption">{unit.areaSqft ? `${formatNumber(unit.areaSqft)} sqft` : '-'}</Typography>
                        {unit.unitStatus?.toString().toLowerCase() === 'sold' || isUnitStatusNotReleased(unit.unitStatus)
                          ? null
                          : isEc ? (
                            <>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>NPS</Typography>
                              <Typography variant="caption">{npsPrice > 0 ? formatCurrency(npsPrice) : '-'}</Typography>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>NPS PSF</Typography>
                              <Typography variant="caption">{npsPsf > 0 ? formatCurrency(npsPsf) : '-'}</Typography>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>DPS</Typography>
                              <Typography variant="caption">{dpsPrice > 0 ? formatCurrency(dpsPrice) : '-'}</Typography>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>DPS PSF</Typography>
                              <Typography variant="caption">{dpsPsf > 0 ? formatCurrency(dpsPsf) : '-'}</Typography>
                            </>
                          ) : (
                            <>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Price</Typography>
                              <Typography variant="caption">{npsPrice > 0 ? formatCurrency(npsPrice) : '-'}</Typography>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>PSF</Typography>
                              <Typography variant="caption">{npsPsf > 0 ? formatCurrency(npsPsf) : '-'}</Typography>
                            </>
                          )}
                      </Box>
                    </Box>
                  );
                })()}
              </Box>
            ) : (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  No floor plan available for this unit.
                </Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)', px: isMobile ? 1.5 : 2, py: isMobile ? 1.5 : 1, gap: 1, flexWrap: 'wrap', justifyContent: isMobile ? 'stretch' : 'flex-end' }}>
            <Button
              {...towerViewFloorPlanCloseHandlers}
              sx={{
                ...towerViewFloorPlanCloseHandlers.sx,
                minHeight: 44,
                px: 3,
                width: isMobile ? '100%' : 'auto',
                color: 'rgba(var(--color-text-rgb), 0.9)',
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              Close
            </Button>
            {selectedTowerViewUnitForFloorPlan && selectedTowerViewUnitForFloorPlan.floorplan && !towerViewFloorPlanRefreshing && (
              <Button
                variant="contained"
                onClick={() => {
                  // Convert TowerViewUnit to ComparableUnit format for comparison
                  const unitForCompare: ComparableUnit | ReferenceUnit = {
                    id: selectedTowerViewUnitForFloorPlan.id,
                    projectName: selectedTowerViewUnitForFloorPlan.projectName,
                    unitNumber: selectedTowerViewUnitForFloorPlan.unitNumber,
                    blockNumber: selectedTowerViewUnitForFloorPlan.blockNumber || null,
                    bedroom: selectedTowerViewUnitForFloorPlan.bedroom,
                    bathroom: selectedTowerViewUnitForFloorPlan.bathroom || 0,
                    areaSqft: selectedTowerViewUnitForFloorPlan.areaSqft,
                    price: selectedTowerViewUnitForFloorPlan.price,
                    priceDiff: 0,
                    priceDiffPercent: 0,
                    psf: selectedTowerViewUnitForFloorPlan.psf,
                    psfDiff: 0,
                    psfDiffPercent: 0,
                    outlay: 0,
                    outlayDiff: 0,
                    installment: 0,
                    installmentDiff: 0,
                    unitStatus: selectedTowerViewUnitForFloorPlan.unitStatus || null,
                    floorplan: selectedTowerViewUnitForFloorPlan.floorplan || null,
                  };
                  handleAddToUnitCompare(unitForCompare);
                  setTowerViewFloorPlanOpen(false);
                }}
                onTouchEnd={(e) => {
                  e.preventDefault();
                  if (floorPlansToCompare.length >= 3 && !floorPlansToCompare.some(fp => fp.unit.id === selectedTowerViewUnitForFloorPlan.id)) return;
                  const unitForCompare: ComparableUnit | ReferenceUnit = {
                    id: selectedTowerViewUnitForFloorPlan.id,
                    projectName: selectedTowerViewUnitForFloorPlan.projectName,
                    unitNumber: selectedTowerViewUnitForFloorPlan.unitNumber,
                    blockNumber: selectedTowerViewUnitForFloorPlan.blockNumber || null,
                    bedroom: selectedTowerViewUnitForFloorPlan.bedroom,
                    bathroom: selectedTowerViewUnitForFloorPlan.bathroom || 0,
                    areaSqft: selectedTowerViewUnitForFloorPlan.areaSqft,
                    price: selectedTowerViewUnitForFloorPlan.price,
                    priceDiff: 0,
                    priceDiffPercent: 0,
                    psf: selectedTowerViewUnitForFloorPlan.psf,
                    psfDiff: 0,
                    psfDiffPercent: 0,
                    outlay: 0,
                    outlayDiff: 0,
                    installment: 0,
                    installmentDiff: 0,
                    unitStatus: selectedTowerViewUnitForFloorPlan.unitStatus || null,
                    floorplan: selectedTowerViewUnitForFloorPlan.floorplan || null,
                  };
                  handleAddToUnitCompare(unitForCompare);
                  setTowerViewFloorPlanOpen(false);
                }}
                disabled={
                  isExternalUser ||
                  (floorPlansToCompare.length >= 3 &&
                    !floorPlansToCompare.some(fp => fp.unit.id === selectedTowerViewUnitForFloorPlan.id))
                }
                sx={{
                  minHeight: 44,
                  width: isMobile ? '100%' : 'auto',
                  touchAction: 'manipulation',
                  '&:active': {
                    transform: 'scale(0.98)',
                  },
                }}
              >
                {isExternalUser
                  ? 'Add to Compare'
                  : floorPlansToCompare.some(fp => fp.unit.id === selectedTowerViewUnitForFloorPlan.id)
                    ? 'Remove from Compare'
                    : floorPlansToCompare.length >= 3
                      ? 'Compare Full (3/3)'
                      : `Add to Compare (${floorPlansToCompare.length}/3)`}
              </Button>
            )}
          </DialogActions>
        </Dialog>

        {/* Site Plan Loading Dialog */}
        <Dialog open={sitePlanLoading} maxWidth="xs" fullWidth>
          <DialogContent sx={{ py: 3 }}>
            <LinearProgress />
          </DialogContent>
        </Dialog>

        {/* Site Plan Modal */}
        <Dialog
          open={sitePlanOpen}
          onClose={handleCloseSitePlan}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '95vh',
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: isMobile ? 'none' : '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
              // Touch optimizations
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'rgba(0,0,0,0.1)',
              // Disable hover on mobile
              ...(isMobile && {
                '*:hover': {
                  backgroundColor: 'inherit !important',
                },
              }),
            },
          }}
        >
          <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
              <Typography variant="h6" sx={{ color: 'inherit' }}>
                Site Plan - {selectedProject || referenceUnit?.projectName}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {isAdminUser && (
                  <Tooltip title="Manage Project">
                    <IconButton
                      onClick={() => {
                        const projectName = selectedProject || referenceUnit?.projectName || '';
                        setActiveNavItem('manage-site-map');
                        setManageSiteMapInitialProject(projectName);
                        setManageSiteMapOpen(true);
                      }}
                      size="small"
                      sx={{
                        bgcolor: 'var(--color-accent)',
                        color: 'var(--color-text-inverse)',
                        '&:hover': {
                          bgcolor: 'var(--color-accent-strong)',
                        },
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                )}
                <IconButton
                  {...sitePlanCloseHandlers}
                  size="small"
                  sx={{
                    ...sitePlanCloseHandlers.sx,
                    minWidth: 44,
                    minHeight: 44,
                    padding: 1.5,
                    color: 'rgba(var(--color-text-rgb), 0.9)',
                    '&:active': {
                      backgroundColor: 'rgba(0,0,0,0.12)',
                      transform: 'scale(0.95)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 0, overflow: 'hidden', position: 'relative', bgcolor: 'var(--color-surface)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
            {sitePlanData ? (
              <TransformWrapper
                initialScale={1}
                minScale={0.5}
                maxScale={4}
                centerOnInit={true}
                limitToBounds={false}
                centerZoomedOut={true}
                disablePadding={false}
                wheel={{
                  step: 0.05,
                }}
                pinch={{
                  step: 5,
                }}
                doubleClick={{
                  disabled: false,
                  step: 0.7,
                }}
                panning={{
                  disabled: false,
                  velocityDisabled: true,
                }}
                alignmentAnimation={{
                  disabled: false,
                  sizeX: 0,
                  sizeY: 0,
                }}
              >
                {({ zoomIn, zoomOut, resetTransform }) => (
                  <>
                    <TransformComponent
                      wrapperStyle={{ width: '100%', height: '80vh', overflow: 'hidden' }}
                      contentStyle={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                      <Box
                        sx={{
                          position: 'relative',
                          display: 'inline-block',
                        }}
                      >
                <Box
                  component="img"
                  src={sitePlanData.imageUrl}
                  alt="Site Plan"
                  sx={{
                    maxWidth: '100%',
                    maxHeight: '80vh',
                    width: 'auto',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                  }}
                />
                {/* Debug: site plan bounds */}
                {sitePlanData.bounds && (
                  <Box
                    sx={{
                      position: 'absolute',
                      left: `${sitePlanData.bounds.x}%`,
                      top: `${sitePlanData.bounds.y}%`,
                      width: `${sitePlanData.bounds.width}%`,
                      height: `${sitePlanData.bounds.height}%`,
                      border: '2px dashed var(--color-warning)',
                      boxSizing: 'border-box',
                      zIndex: 5,
                      pointerEvents: 'none',
                    }}
                  />
                )}
                {/* Clickable block overlays */}
                {sitePlanShowPoints && sitePlanData.blocks.filter(block => block.blockNumber).map((block) => {
                  const bounds = sitePlanData.bounds;
                  const left = bounds ? bounds.x + (block.x / 100) * bounds.width : block.x;
                  const top = bounds ? bounds.y + (block.y / 100) * bounds.height : block.y;
                  const width = bounds ? (block.width / 100) * bounds.width : block.width;
                  const height = bounds ? (block.height / 100) * bounds.height : block.height;

                  return (
                  <Box
                    key={block.blockNumber}
                    onClick={() => block.blockNumber && handleOpenTowerViewFromBlock(block.blockNumber)}
                    sx={{
                      position: 'absolute',
                      left: `${left}%`,
                      top: `${top}%`,
                      width: `${width}%`,
                      height: `${height}%`,
                      cursor: 'pointer',
                      '&:hover': {
                        opacity: 0.8,
                        '&::before': {
                          transform: 'translate(-50%, -50%) scale(1.2)',
                        },
                      },
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: 'var(--color-danger)',
                        border: '2px solid var(--color-white)',
                        boxShadow: '0 2px 4px rgba(var(--color-shadow-rgb), 0.3)',
                        zIndex: 10,
                        transition: 'transform 0.2s',
                      },
                      '&::after': {
                        content: `"${block.blockNumber}"`,
                        position: 'absolute',
                        left: '50%',
                        top: 'calc(50% + 15px)',
                        transform: 'translateX(-50%)',
                        backgroundColor: 'rgba(var(--color-text-rgb), 0.9)',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        color: 'var(--color-text-on-light)',
                        whiteSpace: 'nowrap',
                        zIndex: 10,
                        pointerEvents: 'none',
                      },
                    }}
                  />
                );
                })}
                {/* Stack overlays (clickable to open analysis) */}
                {sitePlanShowPoints && sitePlanData.blocks.filter(block => block.stack && block.facing).map((stack, idx) => {
                  const bounds = sitePlanData.bounds;
                  const left = bounds ? bounds.x + (stack.x / 100) * bounds.width : stack.x;
                  const top = bounds ? bounds.y + (stack.y / 100) * bounds.height : stack.y;
                  const width = bounds ? (stack.width / 100) * bounds.width : stack.width;
                  const height = bounds ? (stack.height / 100) * bounds.height : stack.height;

                  // Normalize stack number for comparison (ensure consistent format)
                  const normalizedStackNum = normalizeStackKey(stack.stack);
                  if (shouldHideNonMatchingSitePlanStack(stack.stack, stack.blockNumber)) {
                    return null;
                  }
                  const isBlinking = normalizedStackNum && sitePlanBlinkingStacks.has(normalizedStackNum);

                  // Get heat map color if enabled
                  let dotColor = 'var(--color-success)';
                  let labelBgColor = 'rgba(var(--color-success-rgb), 0.9)';
                  let labelColor = 'var(--color-white)';
                  let borderColor = sitePlanDotBorder;
                  if (sitePlanShowHeatMap && stack.stack) {
                    const soldPercentage =
                      sitePlanStackSoldPercentages.get(normalizedStackNum)
                      ?? sitePlanStackSoldPercentages.get(String(stack.stack))
                      ?? 0;
                    const heatColor = getHeatMapColor(soldPercentage);
                    dotColor = heatColor;
                    labelBgColor = heatColor;
                    if (soldPercentage === 100) {
                      labelColor = 'var(--color-black)';
                      borderColor = '2px solid var(--color-black)';
                    }
                  }

                  return (
                  <Box
                    key={`stack-${stack.stack}-${stack.facing}-${idx}`}
                    onClick={() => {
                      if (stack.stack && sitePlanProjectName) {
                        handleOpenStackAnalysis(sitePlanProjectName, stack.stack, stack.blockNumber);
                      }
                    }}
                    sx={{
                      position: 'absolute',
                      left: `${left}%`,
                      top: `${top}%`,
                      width: `${width}%`,
                      height: `${height}%`,
                      cursor: 'pointer',
                      '@keyframes sitePlanBlink': {
                        '0%, 100%': {
                          opacity: 1,
                          transform: 'translate(-50%, -50%) scale(1)',
                        },
                        '50%': {
                          opacity: 0.3,
                          transform: 'translate(-50%, -50%) scale(1.3)',
                        },
                      },
                      '&::before': {
                        content: `"${stack.stack}"`,
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: `${sitePlanDotSize}px`,
                        height: `${sitePlanDotSize}px`,
                        borderRadius: '50%',
                        backgroundColor: dotColor,
                        border: borderColor,
                        boxShadow: sitePlanDotShadow,
                        zIndex: 10,
                        animation: isBlinking ? 'sitePlanBlink 0.5s ease-in-out infinite' : 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: sitePlanDotFontSize,
                        fontWeight: 'bold',
                        color: labelColor,
                        textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
                      },
                    }}
                  />
                );
                })}
                      </Box>
                    </TransformComponent>

                    {/* Floating menu button */}
                    <Fab
                      color="primary"
                      size="medium"
                      onClick={() => setSitePlanMenuOpen(!sitePlanMenuOpen)}
                      sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        zIndex: 1000,
                      }}
                    >
                      <TuneIcon />
                    </Fab>

                    {/* Floating menu panel */}
                    {sitePlanMenuOpen && (
                      <Paper
                        sx={{
                          position: 'absolute',
                          top: 80,
                          right: 16,
                          zIndex: 1000,
                          p: 2,
                          minWidth: 280,
                          maxWidth: 320,
                          maxHeight: 'calc(80vh - 100px)',
                          overflowY: 'auto',
                          bgcolor: 'var(--color-surface)',
                          border: '1px solid rgba(var(--color-text-rgb), 0.08)',
                          boxShadow: '0 4px 12px rgba(var(--color-shadow-rgb), 0.3)',
                        }}
                      >
                        <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: 'var(--color-text-strong)' }}>
                          Site Plan Controls
                        </Typography>

                        {/* Show/Hide Points Toggle */}
                        <FormControlLabel
                          control={
                            <Switch
                              checked={sitePlanShowPoints}
                              onChange={(e) => setSitePlanShowPoints(e.target.checked)}
                              color="primary"
                            />
                          }
                          label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <LayersIcon fontSize="small" />
                              <Typography variant="body2">Show Points</Typography>
                            </Box>
                          }
                          sx={{ mb: 2, width: '100%', m: 0 }}
                        />

                        {/* Show Sold Heat Map Toggle */}
                        <FormControlLabel
                          control={
                            <Switch
                              checked={sitePlanShowHeatMap}
                              onChange={(e) => setSitePlanShowHeatMap(e.target.checked)}
                              color="primary"
                            />
                          }
                          label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <ThermostatIcon fontSize="small" />
                              <Typography variant="body2">Show Sold Heat Map</Typography>
                            </Box>
                          }
                          sx={{ mb: 2, width: '100%', m: 0 }}
                        />

                        <Divider sx={{ my: 2, borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} />

                        {/* Filter by Bedroom - Collapsible */}
                        <Accordion
                          defaultExpanded
                          sx={{
                            mb: 1,
                            bgcolor: 'transparent',
                            boxShadow: 'none',
                            '&:before': { display: 'none' },
                            '& .MuiAccordionSummary-root': {
                              minHeight: '36px',
                              p: 0,
                            },
                            '& .MuiAccordionDetails-root': {
                              p: 0,
                              pt: 1,
                            },
                          }}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <BedIcon fontSize="small" />
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                Filter by Bedroom
                              </Typography>
                            </Box>
                          </AccordionSummary>
                          <AccordionDetails>
                            <FormGroup>
                              {sitePlanBedroomFilterOptions.map((bedroom) => (
                                <FormControlLabel
                                  key={bedroom}
                                  control={
                                    <Checkbox
                                      checked={sitePlanBedroomFilter.includes(bedroom)}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSitePlanBedroomFilter(prev => [...prev, bedroom]);
                                        } else {
                                          setSitePlanBedroomFilter(prev => prev.filter(b => b !== bedroom));
                                        }
                                      }}
                                      size="small"
                                    />
                                  }
                                  label={bedroom === PENTHOUSE_FILTER_VALUE ? 'Penthouse' : `${bedroom} Bedroom`}
                                  sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }}
                                />
                              ))}
                            </FormGroup>
                          </AccordionDetails>
                        </Accordion>

                        {/* Filter by Unit Type - Collapsible */}
                        <Accordion
                          defaultExpanded
                          sx={{
                            mb: 2,
                            bgcolor: 'transparent',
                            boxShadow: 'none',
                            '&:before': { display: 'none' },
                            '& .MuiAccordionSummary-root': {
                              minHeight: '36px',
                              p: 0,
                            },
                            '& .MuiAccordionDetails-root': {
                              p: 0,
                              pt: 1,
                            },
                          }}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <ViewModuleIcon fontSize="small" />
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                Filter by Unit Type
                              </Typography>
                            </Box>
                          </AccordionSummary>
                          <AccordionDetails>
                            <FormGroup>
                              {sitePlanUnitTypesForBedroomFilter.map(unitType => (
                                <FormControlLabel
                                  key={unitType.id}
                                  control={
                                    <Checkbox
                                      checked={sitePlanUnitTypeFilter.includes(unitType.id)}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSitePlanUnitTypeFilter(prev => [...prev, unitType.id]);
                                        } else {
                                          setSitePlanUnitTypeFilter(prev => prev.filter(ut => ut !== unitType.id));
                                        }
                                      }}
                                      size="small"
                                    />
                                  }
                                  label={
                                    <Box>
                                      <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                        {unitType.description || unitType.unitType}
                                      </Typography>
                                      {unitType.description && (
                                        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                                          {unitType.description}
                                        </Typography>
                                      )}
                                    </Box>
                                  }
                                  sx={{ alignItems: 'flex-start', mb: 0.5 }}
                                />
                              ))}
                            </FormGroup>
                          </AccordionDetails>
                        </Accordion>

                        {/* Zoom Controls */}
                        <Divider sx={{ my: 2, borderColor: 'rgba(var(--color-text-rgb), 0.08)' }} />
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<ZoomInIcon />}
                            onClick={() => zoomIn()}
                            onTouchEnd={(e) => {
                              e.preventDefault();
                              zoomIn();
                            }}
                            sx={{
                              flex: 1,
                              minHeight: 44,
                              touchAction: 'manipulation',
                              '&:active': {
                                transform: 'scale(0.98)',
                              },
                            }}
                          >
                            Zoom In
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<ZoomOutIcon />}
                            onClick={() => zoomOut()}
                            onTouchEnd={(e) => {
                              e.preventDefault();
                              zoomOut();
                            }}
                            sx={{
                              flex: 1,
                              minHeight: 44,
                              touchAction: 'manipulation',
                              '&:active': {
                                transform: 'scale(0.98)',
                              },
                            }}
                          >
                            Zoom Out
                          </Button>
                        </Box>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => resetTransform()}
                          onTouchEnd={(e) => {
                            e.preventDefault();
                            resetTransform();
                          }}
                          fullWidth
                          sx={{
                            mt: 1,
                            minHeight: 44,
                            touchAction: 'manipulation',
                            '&:active': {
                              transform: 'scale(0.98)',
                            },
                          }}
                        >
                          Reset View
                        </Button>
                      </Paper>
                    )}
                  </>
                )}
              </TransformWrapper>
            ) : (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  Site plan not available for this project.
                </Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Button
              {...sitePlanCloseHandlers}
              sx={{
                ...sitePlanCloseHandlers.sx,
                minHeight: 44,
                px: 3,
                color: 'rgba(var(--color-text-rgb), 0.9)',
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Stack Analysis Dialog */}
        <Dialog
          open={stackAnalysisOpen}
          onClose={handleCloseStackAnalysis}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: isMobile ? 'none' : '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
              // Touch optimization
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'rgba(0,0,0,0.1)',
              // Disable hover states on mobile
              ...(isMobile && {
                '*:hover': {
                  backgroundColor: 'inherit !important',
                },
              }),
            },
          }}
        >
          <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" sx={{ color: 'inherit' }}>
                Stack Analysis {stackAnalysisData && `- Stack ${stackAnalysisData.stackNumber}`}
              </Typography>
              <IconButton
                {...stackAnalysisCloseHandlers}
                size="small"
                sx={{
                  ...stackAnalysisCloseHandlers.sx,
                  minWidth: 44,
                  minHeight: 44,
                  padding: 1.5,
                  color: 'rgba(var(--color-text-rgb), 0.9)',
                  '&:active': {
                    backgroundColor: 'rgba(0,0,0,0.12)',
                    transform: 'scale(0.95)',
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 3, overflow: 'auto', maxHeight: '75vh', bgcolor: 'var(--color-surface)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
            {stackAnalysisLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <CircularProgress />
              </Box>
            ) : stackAnalysisData ? (
              <Grid container spacing={2}>
                {/* Stack Info Header - Full Width */}
                <Grid item xs={12}>
                  <Paper sx={{ p: 1.5, bgcolor: 'rgba(var(--color-primary-rgb), 0.05)', border: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>Stack Number</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>{stackAnalysisData.stackNumber}</Typography>
                      </Grid>
                     
                      {(isAdminUser || stackAnalysisData.canViewFacing) && (
                      <Grid item xs={4}>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>Facing</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>{stackAnalysisData.facing || 'Unknown'}</Typography>
                      </Grid>
                      )}
                      
                      <Grid item xs={4}>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>Total Units</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>{stackAnalysisData.totalUnits}</Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>

                {/* Availability Section - Left: Pie Chart, Right: Breakdowns */}
                <Grid item xs={12} md={8}>
                  <Grid container spacing={2}>
                    {/* Pie Chart - Left */}
                    <Grid item xs={12} md={5}>
                      <Paper sx={{ p: 2, bgcolor: 'var(--color-surface)', border: '1px solid rgba(var(--color-text-rgb), 0.08)', height: '100%' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                          Availability Status
                        </Typography>
                        <Box sx={{ width: '100%', height: 220 }}>
                          {(() => {
                            const availableCount = Number(stackAnalysisData.availableUnits) || 0;
                            const soldCount = Number(stackAnalysisData.soldUnits) || 0;
                            const total = availableCount + soldCount;

                            if (total === 0) {
                              return (
                                <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                                    No availability data
                                  </Typography>
                                </Box>
                              );
                            }

                            const availabilityPieData = [
                              { name: 'Available', value: availableCount, fill: '#4caf50' },
                              { name: 'Sold', value: soldCount, fill: '#f44336' },
                            ];

                            return (
                              <ResponsiveContainer width="100%" height="100%">
                                <PieChart margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
                                  <Pie
                                    data={availabilityPieData}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={38}
                                    outerRadius={62}
                                    dataKey="value"
                                    labelLine={false}
                                    label={(entry: any) => {
                                      const percent = ((entry.value / total) * 100).toFixed(0);
                                      return `${entry.name}: ${percent}%`;
                                    }}
                                    isAnimationActive={false}
                                  >
                                    {availabilityPieData.map((entry, index) => (
                                      <Cell key={`cell-${index}`} fill={entry.fill} />
                                    ))}
                                  </Pie>
                                  <RechartsTooltip
                                    contentStyle={{
                                      backgroundColor: 'rgba(30, 30, 30, 0.95)',
                                      border: '1px solid rgba(255, 255, 255, 0.2)',
                                      borderRadius: '6px',
                                      padding: '8px 12px',
                                    }}
                                    itemStyle={{
                                      color: '#ffffff',
                                      fontWeight: 600,
                                    }}
                                    labelStyle={{
                                      color: '#ffffff',
                                      fontWeight: 600,
                                    }}
                                  />
                                </PieChart>
                              </ResponsiveContainer>
                            );
                          })()}
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 1 }}>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="h5" sx={{ fontWeight: 600, color: '#4caf50' }}>
                              {stackAnalysisData.availableUnits}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                              Available
                            </Typography>
                          </Box>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="h5" sx={{ fontWeight: 600, color: '#f44336' }}>
                              {stackAnalysisData.soldUnits}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                              Sold
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>

                    {/* Breakdowns - Right */}
                    <Grid item xs={12} md={7}>
                      <Box sx={{ position: 'relative', height: '100%' }}>
                        {stackAnalysisIsGuesstimated && (
                          <Box
                            sx={{
                              position: 'absolute',
                              inset: 0,
                              pointerEvents: 'none',
                              overflow: 'hidden',
                              zIndex: 1,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            {[...Array(9)].map((_, i) => (
                              <Typography
                                key={i}
                                sx={{
                                  position: 'absolute',
                                  left: `${(i % 3) * 35}%`,
                                  top: `${Math.floor(i / 3) * 35}%`,
                                  transform: 'rotate(-22deg)',
                                  fontWeight: 700,
                                  fontSize: '0.95rem',
                                  color: 'var(--color-text-strong)',
                                  opacity: 0.12,
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                GUESS-TIMATED PRICE
                              </Typography>
                            ))}
                          </Box>
                        )}
                        <Paper sx={{ p: 2, bgcolor: 'var(--color-surface)', border: '1px solid rgba(var(--color-text-rgb), 0.08)', height: '100%' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                          Breakdown by Bedroom
                        </Typography>
                        <TableContainer sx={{ mb: 2 }}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ py: 0.5 }}>Bedroom</TableCell>
                                <TableCell align="right" sx={{ py: 0.5 }}>Available</TableCell>
                                <TableCell align="right" sx={{ py: 0.5 }}>Sold</TableCell>
                                <TableCell align="right" sx={{ py: 0.5 }}>Total</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {Object.entries(stackAnalysisData.bedroomBreakdown).map(([bedroom, data]: [string, any]) => (
                                <TableRow key={bedroom}>
                                  <TableCell sx={{ py: 0.5 }}>{bedroom === '6' ? 'Penthouse' : `${bedroom} BR`}</TableCell>
                                  <TableCell align="right" sx={{ py: 0.5 }}>{data.available}</TableCell>
                                  <TableCell align="right" sx={{ py: 0.5 }}>{data.sold}</TableCell>
                                  <TableCell align="right" sx={{ py: 0.5 }}>{data.available + data.sold}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                          Breakdown by Unit Type
                        </Typography>
                        <TableContainer>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ py: 0.5 }}>Unit Type</TableCell>
                                <TableCell align="right" sx={{ py: 0.5 }}>Available</TableCell>
                                <TableCell align="right" sx={{ py: 0.5 }}>Sold</TableCell>
                                <TableCell align="right" sx={{ py: 0.5 }}>Total</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {Object.entries(stackAnalysisData.unitTypeBreakdown).map(([unitType, data]: [string, any]) => (
                                <TableRow key={unitType}>
                                  <TableCell sx={{ py: 0.5 }}>{unitType}</TableCell>
                                  <TableCell align="right" sx={{ py: 0.5 }}>{data.available}</TableCell>
                                  <TableCell align="right" sx={{ py: 0.5 }}>{data.sold}</TableCell>
                                  <TableCell align="right" sx={{ py: 0.5 }}>{data.available + data.sold}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Paper>
                      </Box>
                    </Grid>
                  </Grid>

                  {/* Price Premium Chart */}

                  {/* Price Premium Chart */}
                  <Box sx={{ position: 'relative', mt: 2 }}>
                    {stackAnalysisIsGuesstimated && (
                      <Box
                        sx={{
                          position: 'absolute',
                          inset: 0,
                          pointerEvents: 'none',
                          overflow: 'hidden',
                          zIndex: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {[...Array(9)].map((_, i) => (
                          <Typography
                            key={i}
                            sx={{
                              position: 'absolute',
                              left: `${(i % 3) * 35}%`,
                              top: `${Math.floor(i / 3) * 35}%`,
                              transform: 'rotate(-22deg)',
                              fontWeight: 700,
                              fontSize: '0.95rem',
                              color: 'var(--color-text-strong)',
                              opacity: 0.12,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            GUESS-TIMATED PRICE
                          </Typography>
                        ))}
                      </Box>
                    )}
                  <Paper sx={{ p: 2, bgcolor: 'var(--color-surface)', border: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
                      Floor Price & Premium Trend (Based on Available Units)
                    </Typography>
                    {(() => {
                      const hasValidChartPrice = (price: unknown): boolean => {
                        const numericPrice = typeof price === 'number' ? price : parseFloat(String(price));
                        return Number.isFinite(numericPrice) && numericPrice > 0;
                      };

                      const availableUnits = stackAnalysisUnitsWithSimulation.filter((unit: any) => unit.status?.toLowerCase() !== 'sold' && !isUnitStatusNotReleased(unit.status));

                      // Count available units with a real price only
                      const availableUnitsWithPrice = stackAnalysisUnitsWithSimulation.filter((unit: any) => (
                        unit.status?.toLowerCase() !== 'sold'
                        && !isUnitStatusNotReleased(unit.status)
                        && hasValidChartPrice(unit.price)
                      ));
                      const hasEnoughData = availableUnitsWithPrice.length >= 2;

                      if (!hasEnoughData) {
                        return (
                          <Box sx={{ height: 250, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                              {availableUnits.length === 0
                                ? 'All units sold - no price trend available'
                                : availableUnitsWithPrice.length === 0
                                  ? 'No priced available units to show on the trend graph'
                                : 'Insufficient priced data - need at least 2 available units with prices to show trend'}
                            </Typography>
                          </Box>
                        );
                      }

                      return stackAnalysisUnitsWithSimulation.length > 0 ? (
                        <Box sx={{ height: isMobileSitePlan ? 260 : 300 }}>
                          <ResponsiveContainer width="100%" height="100%">
                            {(() => {
                              // Group all units by floor (no bedroom breakdown), excluding sold units
                              const floorPrices: { [floor: string]: number[] } = {};

                              stackAnalysisUnitsWithSimulation.forEach((unit: any) => {
                                // Skip sold and not-released units (no pricing surfaced)
                                const isSold = unit.status?.toLowerCase() === 'sold';
                                const isNotReleased = isUnitStatusNotReleased(unit.status);
                                if (!isSold && !isNotReleased && unit.floorNumber && hasValidChartPrice(unit.price)) {
                                  const floor = unit.floorNumber;
                                  const price = parseFloat(unit.price);
                                  if (!floorPrices[floor]) {
                                    floorPrices[floor] = [];
                                  }
                                  floorPrices[floor].push(price);
                                }
                              });

                              // Calculate average price per floor and premium
                              const floors = Object.keys(floorPrices).sort((a, b) => {
                                const floorA = parseInt(a) || 0;
                                const floorB = parseInt(b) || 0;
                                return floorA - floorB;
                              });

                              let previousAvgPrice: number | null = null;
                              let previousFloor: number | null = null;
                              const floorData = floors.map(floor => {
                                const floorNum = parseInt(floor) || 0;
                                const prices = floorPrices[floor];
                                const avgPrice = prices.reduce((sum, p) => sum + p, 0) / prices.length;
                                const premium = previousAvgPrice !== null ? avgPrice - previousAvgPrice : null;

                                // Detect floor gap: avg premium = (price - prevPrice) / floorDiff when there's a gap
                                const floorDiff = previousFloor !== null ? floorNum - previousFloor : 1;
                                const avgPremium = premium !== null && floorDiff > 1
                                  ? Math.round(premium / floorDiff)
                                  : null;

                                previousAvgPrice = avgPrice;
                                previousFloor = floorNum;

                                return {
                                  floor,
                                  avgPrice: Math.round(avgPrice),
                                  premium: premium !== null ? Math.round(premium) : null,
                                  avgPremium: avgPremium ?? undefined,
                                  floorDiff: floorDiff > 1 ? floorDiff : undefined,
                                };
                              });

                              const priceValues = floorData.map((row) => row.avgPrice).filter((value) => Number.isFinite(value));
                              const premiumValues = floorData
                                .map((row) => row.premium)
                                .filter((value): value is number => value !== null && Number.isFinite(value));
                              const priceLineData = floorData.filter((row) => Number.isFinite(row.avgPrice));
                              const premiumLineData = floorData.filter((row) => typeof row.premium === 'number' && Number.isFinite(row.premium));

                              const priceAxisDomain: [number, number] | ['auto', 'auto'] = (() => {
                                if (priceValues.length === 0) {
                                  return ['auto', 'auto'];
                                }

                                const min = Math.min(...priceValues);
                                const max = Math.max(...priceValues);

                                if (!Number.isFinite(min) || !Number.isFinite(max) || min === max) {
                                  return ['auto', 'auto'];
                                }

                                const padding = (max - min) * 0.05;
                                return [min - padding, max + padding];
                              })();

                              const premiumAxisDomain: [number, number] | ['auto', 'auto'] = (() => {
                                if (floorData.length < 2 || premiumValues.length === 0) {
                                  return ['auto', 'auto'];
                                }

                                const priceMin = Array.isArray(priceAxisDomain) && typeof priceAxisDomain[0] === 'number'
                                  ? priceAxisDomain[0]
                                  : Math.min(...priceValues);
                                const priceMax = Array.isArray(priceAxisDomain) && typeof priceAxisDomain[1] === 'number'
                                  ? priceAxisDomain[1]
                                  : Math.max(...priceValues);
                                const priceRange = priceMax - priceMin;

                                if (!Number.isFinite(priceRange) || priceRange <= 0) {
                                  return ['auto', 'auto'];
                                }

                                const preferredIndex = floorData.length > 1
                                  && typeof floorData[1]?.premium === 'number'
                                  && Number.isFinite(floorData[1]?.premium)
                                  ? 1
                                  : floorData.findIndex((row) => typeof row.premium === 'number' && Number.isFinite(row.premium));

                                if (preferredIndex < 0) {
                                  return ['auto', 'auto'];
                                }

                                const priceSecond = floorData[preferredIndex]?.avgPrice;
                                const premiumSecond = floorData[preferredIndex]?.premium;

                                if (!Number.isFinite(priceSecond) || typeof premiumSecond !== 'number' || !Number.isFinite(premiumSecond)) {
                                  return ['auto', 'auto'];
                                }

                                const targetRatio = (priceSecond - priceMin) / priceRange;

                                if (!Number.isFinite(targetRatio) || targetRatio <= 0 || targetRatio >= 1) {
                                  return ['auto', 'auto'];
                                }

                                const premiumMin = Math.min(...premiumValues);
                                const premiumMax = Math.max(...premiumValues);

                                const minRangeFromMin = (premiumSecond - premiumMin) / targetRatio;
                                const minRangeFromMax = (premiumMax - premiumSecond) / (1 - targetRatio);
                                const requiredRange = Math.max(minRangeFromMin, minRangeFromMax);

                                if (!Number.isFinite(requiredRange) || requiredRange <= 0) {
                                  return ['auto', 'auto'];
                                }

                                const rightMin = premiumSecond - targetRatio * requiredRange;
                                const rightMax = rightMin + requiredRange;

                                return [rightMin, rightMax];
                              })();

                              const formatPremiumTick = (value: number | null | undefined) => {
                                if (value === null || value === undefined || !Number.isFinite(value)) {
                                  return '0';
                                }

                                const domainRange = Array.isArray(premiumAxisDomain)
                                  && typeof premiumAxisDomain[0] === 'number'
                                  && typeof premiumAxisDomain[1] === 'number'
                                  ? Math.abs(premiumAxisDomain[1] - premiumAxisDomain[0])
                                  : (premiumValues.length ? Math.max(...premiumValues) - Math.min(...premiumValues) : 0);

                                const useDecimal = Number.isFinite(domainRange) && domainRange > 0 && domainRange <= 2000;
                                const kValue = value / 1000;

                                return `$${kValue.toFixed(useDecimal ? 1 : 0)}k`;
                              };
                              const isLightTheme = currentTheme === 'light';
                              const axisTextColor = isLightTheme ? '#1f2937' : '#e5e7eb';
                              const axisLineColor = isLightTheme ? '#6b7280' : '#94a3b8';
                              const chartGridColor = isLightTheme ? '#e5e7eb' : '#334155';

                              return (
                                <LineChart
                                  data={floorData}
                                  margin={isMobileSitePlan ? { top: 8, right: 12, left: 12, bottom: 40 } : { top: 5, right: 130, left: 80, bottom: 60 }}
                                >
                            <CartesianGrid strokeDasharray="3 3" stroke={chartGridColor} />
                            <XAxis
                              dataKey="floor"
                              allowDuplicatedCategory={false}
                              label={isMobileSitePlan ? undefined : {
                                value: 'Floor',
                                position: 'bottom',
                                offset: 5,
                                style: { fill: axisTextColor, fontSize: '14px', fontWeight: 600 }
                              }}
                              stroke={axisLineColor}
                              tick={{ fontSize: isMobileSitePlan ? 10 : 12, fill: axisTextColor }}
                              height={isMobileSitePlan ? 40 : 60}
                            />
                            <YAxis
                              yAxisId="left"
                              domain={priceAxisDomain}
                              label={isMobileSitePlan ? undefined : {
                                value: 'Price ($)',
                                angle: -90,
                                position: 'insideLeft',
                                offset: 15,
                                style: { fill: axisTextColor, fontSize: '14px', fontWeight: 600 }
                              }}
                              stroke={axisLineColor}
                              tick={{ fontSize: isMobileSitePlan ? 10 : 12, fill: axisTextColor }}
                              tickFormatter={(value) => {
                                const mil = value / 1000000;
                                const formatted = mil.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
                                return `$${formatted}M`;
                              }}
                              width={isMobileSitePlan ? 42 : 80}
                            />
                            <YAxis
                              yAxisId="right"
                              domain={premiumAxisDomain}
                              orientation="right"
                              label={isMobileSitePlan ? undefined : {
                                value: 'Premium ($)',
                                angle: 90,
                                position: 'insideRight',
                                offset: 8,
                                style: { fill: axisTextColor, fontSize: '14px', fontWeight: 600 }
                              }}
                              stroke={axisLineColor}
                              tick={{ fontSize: isMobileSitePlan ? 10 : 12, fill: axisTextColor }}
                              tickFormatter={formatPremiumTick}
                              width={isMobileSitePlan ? 42 : 95}
                            />
                            <RechartsTooltip
                              contentStyle={{
                                backgroundColor: '#000',
                                border: '1px solid rgba(var(--color-text-rgb), 0.2)',
                                borderRadius: '4px',
                              }}
                              content={({ active, payload }) => {
                                if (!active || !payload?.length) return null;
                                const row = payload[0]?.payload as { floor: string; avgPrice?: number; premium?: number; avgPremium?: number; floorDiff?: number };
                                if (!row) return null;
                                return (
                                  <Box sx={{ p: 1, minWidth: 140, bgcolor: '#000' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                                      Floor {row.floor}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#2196f3' }}>
                                      Price : ${(row.avgPrice ?? 0).toLocaleString()}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#ff9800' }}>
                                      Premium : ${(row.premium ?? 0).toLocaleString()}
                                    </Typography>
                                    {row.avgPremium != null && row.floorDiff != null && (
                                      <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.8)', mt: 0.5, fontStyle: 'italic' }}>
                                        Avg Premium : ${row.avgPremium.toLocaleString()}/floor (over {row.floorDiff} floors)
                                      </Typography>
                                    )}
                                  </Box>
                                );
                              }}
                            />
                            <RechartsLegend
                              wrapperStyle={{ fontSize: isMobileSitePlan ? '10px' : '12px', paddingTop: '10px' }}
                              verticalAlign="bottom"
                              height={isMobileSitePlan ? 28 : 36}
                              iconSize={isMobileSitePlan ? 10 : 14}
                            />
                            <Line
                              data={priceLineData}
                              yAxisId="left"
                              type="linear"
                              dataKey="avgPrice"
                              stroke="#2196f3"
                              strokeWidth={2}
                              name="Price"
                              dot={{ r: isMobileSitePlan ? 2 : 4 }}
                              activeDot={{ r: isMobileSitePlan ? 4 : 6 }}
                              connectNulls
                              isAnimationActive={false}
                            />
                            <Line
                              data={premiumLineData}
                              yAxisId="right"
                              type="linear"
                              dataKey="premium"
                              stroke="#ff9800"
                              strokeWidth={2}
                              name="Premium"
                              dot={{ r: isMobileSitePlan ? 2 : 4 }}
                              activeDot={{ r: isMobileSitePlan ? 4 : 6 }}
                              connectNulls
                              isAnimationActive={false}
                            />
                          </LineChart>
                              );
                            })()}
                        </ResponsiveContainer>
                        <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'rgba(var(--color-text-rgb), 0.6)', textAlign: 'center' }}>
                          Premium = Price difference from the floor below
                        </Typography>
                      </Box>
                    ) : (
                      <Box sx={{ height: 250, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                          No price data available
                        </Typography>
                      </Box>
                    );
                    })()}
                  </Paper>
                  </Box>
                </Grid>

                {/* Right Column - Tower View */}
                <Grid item xs={12} md={4}>
                  <Box sx={{ position: 'relative' }}>
                    {stackAnalysisIsGuesstimated && (
                      <Box
                        sx={{
                          position: 'absolute',
                          inset: 0,
                          pointerEvents: 'none',
                          overflow: 'hidden',
                          zIndex: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {[...Array(9)].map((_, i) => (
                          <Typography
                            key={i}
                            sx={{
                              position: 'absolute',
                              left: `${(i % 3) * 35}%`,
                              top: `${Math.floor(i / 3) * 35}%`,
                              transform: 'rotate(-22deg)',
                              fontWeight: 700,
                              fontSize: '0.95rem',
                              color: 'var(--color-text-strong)',
                              opacity: 0.12,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            GUESS-TIMATED PRICE
                          </Typography>
                        ))}
                      </Box>
                    )}
                  <Paper sx={{ p: 2, bgcolor: 'var(--color-surface)', border: '1px solid rgba(var(--color-text-rgb), 0.08)', position: 'sticky', top: 0, maxHeight: '80vh', overflowY: 'auto' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
                      Stack Tower View
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column-reverse', gap: 0.5 }}>
                      {(() => {
                        // Group units by floor
                        const unitsByFloor: { [floor: string]: typeof stackAnalysisUnitsWithSimulation } = {};
                        stackAnalysisUnitsWithSimulation.forEach((unit: any) => {
                          const floor = unit.floorNumber || 'Unknown';
                          if (!unitsByFloor[floor]) {
                            unitsByFloor[floor] = [];
                          }
                          unitsByFloor[floor].push(unit);
                        });

                        // Sort floors
                        const floors = Object.keys(unitsByFloor).sort((a, b) => {
                          const floorA = parseInt(a) || 0;
                          const floorB = parseInt(b) || 0;
                          return floorA - floorB;
                        });

                        const formatPriceInMillions = (price: number | null | undefined): string => {
                          if (typeof price !== 'number' || !Number.isFinite(price) || price <= 0) {
                            return 'N/A';
                          }
                          const mil = price / 1_000_000;
                          const formatted = mil.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
                          return `$${formatted}M`;
                        };

                        return floors.map(floor => (
                          <Box
                            key={floor}
                            sx={{
                              display: 'flex',
                              alignItems: 'stretch',
                              gap: 0.5,
                              mb: 0.5,
                            }}
                          >
                            <Box sx={{ minWidth: 35, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(var(--color-text-rgb), 0.05)', borderRadius: 0.5, px: 0.5 }}>
                              <Typography variant="caption" sx={{ fontWeight: 600, color: 'rgba(var(--color-text-rgb), 0.7)', fontSize: '0.7rem' }}>
                                {floor}F
                              </Typography>
                            </Box>
                            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                              {unitsByFloor[floor].map((unit: any) => {
                                const isSold = unit.status?.toLowerCase() === 'sold';
                                const isNotReleased = isUnitStatusNotReleased(unit.status);
                                const isExecutiveCondoStack = stackAnalysisData?.isExecutiveCondo === true;
                                const bedroomType = unit.bedroomNumber ? (unit.bedroomNumber === 6 ? 'PH' : `${unit.bedroomNumber}BR`) : '';
                                const npsPriceLabel = formatPriceInMillions(unit.price);
                                const npsPsfLabel = unit.pricePSF ? `$${Math.round(unit.pricePSF)}/sqft` : 'N/A';
                                const dpsPriceLabel = formatPriceInMillions(unit.priceDps);
                                const dpsPsfValue = unit.priceDps && unit.size ? unit.priceDps / unit.size : null;
                                const dpsPsfLabel = dpsPsfValue ? `$${Math.round(dpsPsfValue)}/sqft` : 'N/A';

                                // Touch-optimized handler
                                const handleUnitInteraction = (event: React.MouseEvent | React.TouchEvent) => {
                                  if (event.type === 'touchend') {
                                    event.preventDefault();
                                  }
                                  setStackAnalysisUnitMenuAnchor({ element: event.currentTarget as HTMLElement, unit });
                                };

                                return (
                                  <Box
                                    key={unit.id}
                                    onClick={handleUnitInteraction}
                                    onTouchEnd={handleUnitInteraction}
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      bgcolor: isSold ? 'rgba(244, 67, 54, 0.15)' : 'rgba(76, 175, 80, 0.15)',
                                      border: `1px solid ${isSold ? '#f44336' : '#4caf50'}`,
                                      borderRadius: 0.5,
                                      minHeight: 44,
                                      px: 1.5,
                                      py: 1,
                                      cursor: 'pointer',
                                      touchAction: 'manipulation',
                                      userSelect: 'none',
                                      WebkitUserSelect: 'none',
                                      WebkitTapHighlightColor: 'rgba(0,0,0,0.1)',
                                      transition: 'all 0.15s',
                                      '&:hover': isMobile ? {} : {
                                        bgcolor: isSold ? 'rgba(244, 67, 54, 0.25)' : 'rgba(76, 175, 80, 0.25)',
                                        transform: 'translateX(2px)',
                                      },
                                      '&:active': {
                                        bgcolor: isSold ? 'rgba(244, 67, 54, 0.35)' : 'rgba(76, 175, 80, 0.35)',
                                        transform: 'scale(0.98)',
                                      },
                                    }}
                                  >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 65 }}>
                                      <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '0.7rem', color: 'rgba(var(--color-text-rgb), 0.9)' }}>
                                        {unit.unitNumber || '?'}
                                      </Typography>
                                      {bedroomType && (
                                        <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'rgba(var(--color-text-rgb), 0.6)', fontWeight: 500 }}>
                                          ({bedroomType})
                                        </Typography>
                                      )}
                                    </Box>
                                    {isSold ? (
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 600, color: '#f44336' }}>
                                        SOLD
                                      </Typography>
                                    ) : isNotReleased ? (
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'rgba(var(--color-text-rgb), 0.8)' }}>
                                        -
                                      </Typography>
                                    ) : (
                                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.2 }}>
                                        {isExecutiveCondoStack ? (
                                          <>
                                            <Box sx={{ display: 'flex', gap: 0.8, alignItems: 'center' }}>
                                              <Typography variant="caption" sx={{ fontSize: '0.68rem', color: 'rgba(var(--color-text-rgb), 0.85)', fontWeight: 700 }}>
                                                NPS
                                              </Typography>
                                              <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'rgba(var(--color-text-rgb), 0.8)' }}>
                                                {npsPriceLabel}
                                              </Typography>
                                              <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                                {npsPsfLabel}
                                              </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', gap: 0.8, alignItems: 'center' }}>
                                              <Typography variant="caption" sx={{ fontSize: '0.68rem', color: 'rgba(var(--color-text-rgb), 0.85)', fontWeight: 700 }}>
                                                DPS
                                              </Typography>
                                              <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'rgba(var(--color-text-rgb), 0.8)' }}>
                                                {dpsPriceLabel}
                                              </Typography>
                                              <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                                {dpsPsfLabel}
                                              </Typography>
                                            </Box>
                                          </>
                                        ) : (
                                          <Box sx={{ display: 'flex', gap: 0.8, alignItems: 'center' }}>
                                            <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'rgba(var(--color-text-rgb), 0.8)' }}>
                                              {npsPriceLabel}
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                                              {npsPsfLabel}
                                            </Typography>
                                          </Box>
                                        )}
                                      </Box>
                                    )}
                                    <Box
                                      sx={{
                                        width: 6,
                                        height: 6,
                                        borderRadius: '50%',
                                        bgcolor: isSold ? '#f44336' : '#4caf50',
                                      }}
                                    />
                                  </Box>
                                );
                              })}
                            </Box>
                          </Box>
                        ));
                      })()}
                    </Box>
                    <Box sx={{ mt: 2, p: 1, bgcolor: 'rgba(var(--color-text-rgb), 0.05)', borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, mb: 0.5, fontSize: '0.7rem' }}>
                        Legend:
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Box sx={{ width: 12, height: 12, bgcolor: '#4caf50', borderRadius: 0.5 }} />
                          <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>Available</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Box sx={{ width: 12, height: 12, bgcolor: '#f44336', borderRadius: 0.5 }} />
                          <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>Sold</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  Failed to load stack analysis data.
                </Typography>
              </Box>
            )}
          </DialogContent>
          <Menu
            anchorEl={stackAnalysisUnitMenuAnchor?.element}
            open={Boolean(stackAnalysisUnitMenuAnchor)}
            onClose={() => setStackAnalysisUnitMenuAnchor(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem disabled sx={{ opacity: 1 }}>
              <ListItemText
                primary={`Unit ${stackAnalysisUnitMenuAnchor?.unit?.unitNumber ?? '-'}`}
                secondary={stackAnalysisUnitMenuAnchor?.unit?.projectName ?? ''}
                primaryTypographyProps={{ sx: { fontWeight: 700, color: 'var(--color-text-strong)' } }}
                secondaryTypographyProps={{ sx: { color: 'var(--color-text-muted)' } }}
              />
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleStackAnalysisViewFloorPlan}>
              <ListItemIcon>
                <ImageIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>View Floor Plan</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={() => { void handleStackAnalysisSetReferenceUnit(); }}
              disabled={
                stackAnalysisSetReferenceLoading ||
                isExternalUser ||
                Boolean(getUnitReferenceDisabledReason(stackAnalysisUnitMenuAnchor?.unit))
              }
            >
              <ListItemIcon>
                <BookmarkIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  stackAnalysisSetReferenceLoading
                    ? 'Setting reference...'
                    : (isExternalUser
                      ? 'Set as Reference Unit'
                      : (getUnitReferenceDisabledReason(stackAnalysisUnitMenuAnchor?.unit)?.main ?? 'Set as Reference Unit'))
                }
                secondary={
                  stackAnalysisSetReferenceLoading
                    ? undefined
                    : isExternalUser
                      ? '*Not available for external users'
                      : getUnitReferenceDisabledReason(stackAnalysisUnitMenuAnchor?.unit)?.sub
                }
                secondaryTypographyProps={{ variant: 'caption' }}
              />
            </MenuItem>
            <MenuItem
              disabled={
                isExternalUser ||
                !stackAnalysisUnitMenuAnchor?.unit?.floorplan ||
                (topViewingFloorPlansToCompare.length >= 3 &&
                  !topViewingFloorPlansToCompare.some((fp) => fp.unit.id === stackAnalysisUnitMenuAnchor?.unit?.id))
              }
              onClick={() => {
                if (!stackAnalysisUnitMenuAnchor?.unit) return;
                handleTopViewingAddToUnitCompare(stackAnalysisUnitMenuAnchor.unit as TowerViewUnit | ComparableUnit);
                setStackAnalysisUnitMenuAnchor(null);
              }}
            >
              <ListItemIcon>
                <ShoppingCartIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                {isExternalUser
                  ? 'Add to Compare'
                  : stackAnalysisUnitMenuAnchor &&
                    topViewingFloorPlansToCompare.some((fp) => fp.unit.id === stackAnalysisUnitMenuAnchor.unit.id)
                    ? 'Remove from Compare'
                    : `Add to Compare (${topViewingFloorPlansToCompare.length}/3)`}
              </ListItemText>
            </MenuItem>
          </Menu>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)' }}>
            <Button
              {...stackAnalysisCloseHandlers}
              sx={{
                ...stackAnalysisCloseHandlers.sx,
                minHeight: 44,
                px: 3,
                color: 'rgba(var(--color-text-rgb), 0.9)',
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Floor Plan Modal */}
        <Dialog
          open={floorPlanOpen}
          onClose={handleCloseFloorPlan}
          fullScreen={isMobile}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: isMobile ? '100dvh' : '90vh',
              bgcolor: 'var(--color-surface)',
              color: 'rgba(var(--color-text-rgb), 0.9)',
              boxShadow: isMobile ? 'none' : '0 4px 24px rgba(var(--color-shadow-rgb), 0.4)',
              border: '1px solid rgba(var(--color-text-rgb), 0.08)',
            },
          }}
        >
          <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
              <Typography variant={isMobile ? 'subtitle1' : 'h6'} sx={{ color: 'inherit', pr: 1 }}>
                Floor Plan - {selectedUnitForFloorPlan?.projectName} {selectedUnitForFloorPlan?.unitNumber}
              </Typography>
              {(canAccessFloorPlan3d || canAccessFloorPlan3dSun) && selectedUnitForFloorPlan?.floorplan && (
                <ToggleButtonGroup size="small" exclusive value={floorPlanViewMode}
                  onChange={(_, value) => value && selectFloorPlanViewMode(value, selectedUnitForFloorPlan)}
                  sx={{ ml: 'auto', mr: 1, '& .MuiToggleButton-root': { px: 1.5, py: 0.25, fontSize: '0.75rem', fontWeight: 600, lineHeight: 1.6 } }}>
                  <ToggleButton value="2d">2D</ToggleButton>
                  {canAccessFloorPlan3d && <ToggleButton value="3d">3D</ToggleButton>}
                  {canAccessFloorPlan3dSun && <ToggleButton value="3ds">3DS</ToggleButton>}
                </ToggleButtonGroup>
              )}
              <IconButton onClick={handleCloseFloorPlan} size="small" sx={{ color: 'rgba(var(--color-text-rgb), 0.9)' }}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: isMobile ? 1.5 : 2, overflow: 'auto', maxHeight: isMobile ? 'none' : '80vh', bgcolor: 'var(--color-surface)', borderColor: 'rgba(var(--color-text-rgb), 0.08)' }}>
            {floorPlanRefreshing ? (
              <Box sx={{ minHeight: isMobile ? '45vh' : '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                <CircularProgress size={28} />
                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  Refreshing latest unit details...
                </Typography>
              </Box>
            ) : selectedUnitForFloorPlan?.floorplan ? (
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, alignItems: 'flex-start' }}>
                {floorPlanViewMode !== '2d' ? (
                  <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
                    <React.Suspense fallback={<Box sx={{ minHeight: isMobile ? '45vh' : '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress size={28} /></Box>}>
                      <SolarFloorPlan key={`${selectedUnitForFloorPlan.id}-${selectedUnitForFloorPlan.floorplan}-${floorPlanViewMode}`}
                        unitId={selectedUnitForFloorPlan.id} imageUrl={selectedUnitForFloorPlan.floorplan}
                        unitLabel={floorPlanUnitLabel(selectedUnitForFloorPlan)}
                        sunlight={floorPlanViewMode === '3ds'} canCalibrateNorth={isAdminUser}
                        onFallback={() => setFloorPlanViewMode('2d')} />
                    </React.Suspense>
                  </Box>
                ) : (
                <Box sx={{ flex: 1, minWidth: 0, width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <TransformWrapper
                    initialScale={1}
                    minScale={0.8}
                    maxScale={5}
                    centerOnInit
                    limitToBounds={false}
                    centerZoomedOut
                    wheel={{ step: 0.08 }}
                    pinch={{ step: 5 }}
                    doubleClick={{ step: 0.8 }}
                    panning={{ disabled: false, velocityDisabled: true }}
                  >
                    {({ zoomIn, zoomOut, resetTransform }) => (
                      <Box sx={{ width: '100%', position: 'relative' }}>
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            zIndex: 2,
                            display: 'flex',
                            gap: 0.5,
                            p: 0.5,
                            borderRadius: 1,
                            bgcolor: 'rgba(var(--color-shadow-rgb), 0.45)',
                            backdropFilter: 'blur(8px)',
                          }}
                        >
                          <IconButton size="small" onClick={() => zoomOut()} sx={{ color: 'var(--color-text-strong)' }}>
                            <ZoomOutIcon fontSize="small" />
                          </IconButton>
                          <IconButton size="small" onClick={() => zoomIn()} sx={{ color: 'var(--color-text-strong)' }}>
                            <ZoomInIcon fontSize="small" />
                          </IconButton>
                          <Button size="small" onClick={() => resetTransform()} sx={{ minWidth: 0, px: 1, color: 'var(--color-text-strong)' }}>
                            Reset
                          </Button>
                        </Box>
                        <TransformComponent
                          wrapperStyle={{
                            width: '100%',
                            height: isMobile ? '45vh' : '70vh',
                            overflow: 'hidden',
                            borderRadius: '8px',
                          }}
                          contentStyle={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Box
                              component="img"
                              src={selectedUnitForFloorPlan.floorplan ?? undefined}
                              alt={`Floor plan for ${selectedUnitForFloorPlan.projectName} ${selectedUnitForFloorPlan.unitNumber}`}
                              sx={{
                                display: 'block',
                                width: '100%',
                                height: '100%',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                                borderRadius: 1,
                                boxShadow: 2,
                              }}
                              onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                                const target = e.target as HTMLImageElement;
                                target.style.display = 'none';
                                const errorBox = target.nextElementSibling as HTMLElement;
                                if (errorBox) errorBox.style.display = 'block';
                              }}
                            />
                            <Box
                              sx={{
                                display: 'none',
                                p: 3,
                                textAlign: 'center',
                                border: '1px dashed rgba(var(--color-text-rgb), 0.2)',
                                borderRadius: 1,
                                bgcolor: 'rgba(var(--color-shadow-rgb), 0.3)',
                              }}
                            >
                              <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.8)' }}>
                                Unable to load floor plan image.
                              </Typography>
                              <Typography variant="caption" sx={{ mt: 1, display: 'block', color: 'rgba(var(--color-text-rgb), 0.6)' }}>
                                URL: {selectedUnitForFloorPlan.floorplan}
                              </Typography>
                            </Box>
                          </Box>
                        </TransformComponent>
                      </Box>
                    )}
                  </TransformWrapper>
                </Box>
                )}
                {(() => {
                  const unit = selectedUnitForFloorPlan;
                  const npsPrice = unit.priceNps ?? unit.price ?? 0;
                  const dpsPrice = unit.priceDps ?? 0;
                  const npsPsf = unit.psfNps ?? unit.psf ?? 0;
                  const dpsPsf = unit.psfDps ?? 0;
                  const isEc = projectDetailsMap.get(unit.projectName)?.projectCategoryId === 'C1803'
                    || dpsPrice > 0
                    || dpsPsf > 0;
                  return (
                    <Box
                      sx={{
                        width: { xs: '100%', sm: 280 },
                        minWidth: { xs: 0, sm: 240 },
                        borderLeft: { xs: 'none', sm: '1px solid rgba(var(--color-text-rgb), 0.12)' },
                        borderTop: { xs: '1px solid rgba(var(--color-text-rgb), 0.12)', sm: 'none' },
                        pl: { xs: 0, sm: 2 },
                        pt: { xs: 2, sm: 0 },
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Unit Info</Typography>
                      <Box sx={{ display: 'grid', gridTemplateColumns: '120px 1fr', rowGap: 0.6, columnGap: 1 }}>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Status</Typography>
                        <Typography variant="caption">{unit.unitStatus ?? '-'}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Project</Typography>
                        <Typography variant="caption">{unit.projectName}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Unit</Typography>
                        <Typography variant="caption">{unit.unitNumber}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Block</Typography>
                        <Typography variant="caption">{unit.blockNumber ? formatBlockNumber(unit.blockNumber) : '-'}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Bedroom</Typography>
                        <Typography variant="caption">{unit.bedroom}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Bathroom</Typography>
                        <Typography variant="caption">{unit.bathroom ?? '-'}</Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Area</Typography>
                        <Typography variant="caption">{unit.areaSqft ? `${formatNumber(unit.areaSqft)} sqft` : '-'}</Typography>
                        {unit.unitStatus?.toString().toLowerCase() === 'sold' || isUnitStatusNotReleased(unit.unitStatus)
                          ? null
                          : isEc ? (
                            <>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>NPS</Typography>
                              <Typography variant="caption">{npsPrice > 0 ? formatCurrency(npsPrice) : '-'}</Typography>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>NPS PSF</Typography>
                              <Typography variant="caption">{npsPsf > 0 ? formatCurrency(npsPsf) : '-'}</Typography>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>DPS</Typography>
                              <Typography variant="caption">{dpsPrice > 0 ? formatCurrency(dpsPrice) : '-'}</Typography>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>DPS PSF</Typography>
                              <Typography variant="caption">{dpsPsf > 0 ? formatCurrency(dpsPsf) : '-'}</Typography>
                            </>
                          ) : (
                            <>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>Price</Typography>
                              <Typography variant="caption">{npsPrice > 0 ? formatCurrency(npsPrice) : '-'}</Typography>
                              <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>PSF</Typography>
                              <Typography variant="caption">{npsPsf > 0 ? formatCurrency(npsPsf) : '-'}</Typography>
                            </>
                          )}
                      </Box>
                    </Box>
                  );
                })()}
              </Box>
            ) : (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.7)' }}>
                  No floor plan available for this unit.
                </Typography>
              </Box>
            )}
          </DialogContent>
          {(() => {
            const isTopViewing = activeTabId === TOP_VIEWING_SITE_PLANS_TAB || showTopViewingDetailInGeneric;
            const compareList = isTopViewing ? topViewingFloorPlansToCompare : floorPlansToCompare;
            const isInCompare = compareList.some(fp => fp.unit.id === selectedUnitForFloorPlan?.id);
            return (
              <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', bgcolor: 'var(--color-surface)', px: isMobile ? 1.5 : 2, py: isMobile ? 1.5 : 1, gap: 1, flexWrap: 'wrap', justifyContent: isMobile ? 'stretch' : 'flex-end' }}>
                <Button onClick={handleCloseFloorPlan} sx={{ color: 'rgba(var(--color-text-rgb), 0.9)', width: isMobile ? '100%' : 'auto' }}>Close</Button>
                {selectedUnitForFloorPlan?.floorplan && !floorPlanRefreshing && (
                  <>
                    <Button
                      variant="outlined"
                      startIcon={<PictureAsPdfIcon />}
                      onClick={async () => {
                        if (!selectedUnitForFloorPlan) return;
                        const pd = projectDetailsMap.get(selectedUnitForFloorPlan.projectName) || projectDetails;
                        const dpsPrice = (selectedUnitForFloorPlan as any).priceDps ?? 0;
                        const dpsPsf = (selectedUnitForFloorPlan as any).psfDps ?? 0;
                        const ecFlag = pd?.projectCategoryId === 'C1803' || dpsPrice > 0 || dpsPsf > 0;
                        try {
                          await generateUnitFloorPlanPdf(selectedUnitForFloorPlan, pd || null, userInfo, ecFlag);
                        } catch (err) {
                          console.error('Failed to export unit floor plan PDF:', err);
                        }
                      }}
                      sx={{ borderColor: 'rgba(var(--color-text-rgb), 0.5)', color: 'rgba(var(--color-text-rgb), 0.9)', width: isMobile ? '100%' : 'auto' }}
                    >
                      Export PDF
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        if (!selectedUnitForFloorPlan) return;
                        if (isTopViewing) {
                          handleTopViewingAddToUnitCompare(selectedUnitForFloorPlan as TowerViewUnit | ComparableUnit);
                        } else {
                          handleAddToFloorPlanCompare(selectedUnitForFloorPlan);
                        }
                      }}
                      disabled={isExternalUser || (compareList.length >= 3 && !isInCompare)}
                      sx={{ borderColor: 'rgba(var(--color-text-rgb), 0.5)', color: 'rgba(var(--color-text-rgb), 0.9)', width: isMobile ? '100%' : 'auto' }}
                    >
                      {isExternalUser
                        ? 'Add to Compare'
                        : isInCompare
                          ? 'Remove from Compare'
                          : compareList.length >= 3
                            ? 'Compare Full (3/3)'
                            : `Add to Compare (${compareList.length}/3)`}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        if (isTopViewing) {
                          handleOpenTopViewingFloorPlanCompare();
                        } else {
                          handleOpenFloorPlanCompare();
                        }
                      }}
                      disabled={compareList.length === 0}
                      sx={{ width: isMobile ? '100%' : 'auto' }}
                    >
                      View Compare Cart
                    </Button>
                  </>
                )}
              </DialogActions>
            );
          })()}
        </Dialog>

        {/* Floor Plan Comparison Visualizer */}
        <Dialog
          open={floorPlanCompareOpen}
          onClose={handleCloseFloorPlanCompare}
          fullScreen={isMobile}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: isMobile ? '100dvh' : '95vh',
              overflowX: 'hidden',
              width: '100%',
              maxWidth: isMobile ? '100%' : undefined,
            },
          }}
        >
          <DialogTitle sx={{ px: isMobile ? 1.5 : 3, py: isMobile ? 1.25 : 2 }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                minWidth: 0,
                width: '100%',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, minWidth: 0 }}>
                <Typography
                  variant={isMobile ? 'subtitle1' : 'h6'}
                  sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', pr: 1 }}
                >
                  {compareVisualizerMode === 'siteplan' ? 'Site Plan Comparison Visualizer' : 'Floor Plan Comparison Visualizer'}
                </Typography>
                <IconButton onClick={handleCloseFloorPlanCompare} size="small" sx={{ flexShrink: 0 }}>
                  <CloseIcon />
                </IconButton>
              </Box>
              {((!compareExpandedView && compareVisualizerMode === 'floorplan') ||
                compareVisualizerMode === 'siteplan' ||
                isMobile) && (
              <Box
                sx={{
                  display: 'flex',
                  gap: 0.75,
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  minWidth: 0,
                  width: '100%',
                  justifyContent: isMobile ? 'flex-start' : 'flex-end',
                }}
              >
                {!compareExpandedView && compareVisualizerMode === 'floorplan' && (
                  <>
                    <Button size="small" variant="outlined" onClick={() => setCompareFloorPlanZoom((z) => Math.max(1, z - 0.1))}>
                      -
                    </Button>
                    <Typography variant="caption" sx={{ minWidth: 40, textAlign: 'center' }}>
                      {Math.round(compareFloorPlanZoom * 100)}%
                    </Typography>
                    <Button size="small" variant="outlined" onClick={() => setCompareFloorPlanZoom((z) => Math.min(3, z + 0.1))}>
                      +
                    </Button>
                    <Button size="small" variant="text" onClick={() => setCompareFloorPlanZoom(1)}>
                      Reset
                    </Button>
                  </>
                )}
                {compareVisualizerMode === 'siteplan' && (
                  <FormControlLabel
                    sx={{ ml: 0, mr: 0 }}
                    control={
                      <Switch
                        size="small"
                        checked={compareShowSitePlanPoints}
                        onChange={(e) => setCompareShowSitePlanPoints(e.target.checked)}
                      />
                    }
                    label={
                      <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        Show Points
                      </Typography>
                    }
                  />
                )}
                {/* Mobile: chips above the pencil. Desktop/tablet table view: chips here. */}
                {isMobile &&
                  compareDialogFloorPlans.map((fp, index) => (
                    <Chip
                      key={fp.unit.id}
                      label={`${fp.unit.projectName} ${fp.unit.unitNumber}`}
                      onDelete={() => {
                        if (compareDialogSource === 'topViewing') {
                          setTopViewingFloorPlansToCompare((prev) => prev.filter((item) => item.unit.id !== fp.unit.id));
                        } else {
                          handleRemoveFromFloorPlanCompare(fp.unit.id);
                        }
                      }}
                      color={index === 0 ? 'primary' : 'secondary'}
                      size="small"
                      sx={{ maxWidth: '100%' }}
                    />
                  ))}
                {!isMobile &&
                  !compareExpandedView &&
                  compareVisualizerMode === 'floorplan' &&
                  compareDialogFloorPlans.map((fp, index) => (
                    <Chip
                      key={fp.unit.id}
                      label={`${fp.unit.projectName} ${fp.unit.unitNumber}`}
                      onDelete={() => {
                        if (compareDialogSource === 'topViewing') {
                          setTopViewingFloorPlansToCompare((prev) => prev.filter((item) => item.unit.id !== fp.unit.id));
                        } else {
                          handleRemoveFromFloorPlanCompare(fp.unit.id);
                        }
                      }}
                      color={index === 0 ? 'primary' : 'secondary'}
                      size="small"
                      sx={{ maxWidth: 220 }}
                    />
                  ))}
              </Box>
              )}
              {(compareExpandedView || compareVisualizerMode === 'siteplan') && (
                <Box
                  sx={{
                    display: 'flex',
                    gap: 0.75,
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    minWidth: 0,
                    width: '100%',
                    justifyContent: isMobile ? 'flex-start' : 'flex-end',
                    overflowX: 'auto',
                  }}
                >
                  {!isMobile &&
                    compareDialogFloorPlans.map((fp, index) => (
                      <Chip
                        key={fp.unit.id}
                        label={`${fp.unit.projectName} ${fp.unit.unitNumber}`}
                        onDelete={() => {
                          if (compareDialogSource === 'topViewing') {
                            setTopViewingFloorPlansToCompare((prev) => prev.filter((item) => item.unit.id !== fp.unit.id));
                          } else {
                            handleRemoveFromFloorPlanCompare(fp.unit.id);
                          }
                        }}
                        color={index === 0 ? 'primary' : 'secondary'}
                        size="small"
                        sx={{ maxWidth: 220, flexShrink: 0 }}
                      />
                    ))}
                  <Box sx={{ flexShrink: 0 }}>
                    <DrawingToolbar
                      toolbarState={drawToolbarState}
                      onToolbarStateChange={setDrawToolbarState}
                      onUndo={handleDrawUndo}
                      onClearAll={handleDrawClearAll}
                      hasStrokes={Boolean(compareFocusedUnitId && drawingStates[getDrawingKey(compareFocusedUnitId)]?.strokes.length)}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: isMobile ? 1.5 : 2, overflow: 'auto', maxHeight: isMobile ? 'none' : '85vh', overflowX: 'hidden' }}>
            {compareDialogFloorPlans.length === 0 ? (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                  No floor plans selected for comparison. Add floor plans from the floor plan dialog.
                </Typography>
              </Box>
            ) : (
              compareVisualizerMode === 'siteplan' ? (
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: compareQuickRefSideBySide
                      ? (compareQuickReferenceOpen ? 'minmax(0, 1fr) 200px' : 'minmax(0, 1fr) 36px')
                      : '1fr',
                    gap: 2,
                    alignItems: 'start',
                  }}
                >
                  <Box sx={{ overflowX: compareTripleColumnFit ? 'hidden' : 'auto', minWidth: 0, width: '100%' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 1.5,
                        width: '100%',
                        minWidth: compareTripleColumnFit ? 0 : Math.max(820, compareDialogFloorPlans.length * 420),
                        alignItems: 'stretch',
                      }}
                    >
                      {compareDialogFloorPlans.map((fp, index) => {
                        const isFocused = fp.unit.id === compareFocusedUnitId;
                        const projectName = fp.unit.projectName;
                        const projectSitePlan = compareSitePlansByProject.get(projectName);
                        const hasFetchedSitePlan = compareSitePlansByProject.has(projectName);
                        const marker = getCompareSitePlanMarker(projectSitePlan, fp.unit);
                        const markerElementId = marker ? getCompareSitePlanMarkerElementId(fp.unit.id) : null;
                        const markerFocusKey = marker
                          ? [
                              markerElementId,
                              projectSitePlan?.imageUrl,
                              marker.left,
                              marker.top,
                              marker.width,
                              marker.height,
                              compareSitePlanRotations[fp.unit.id] ?? 0,
                            ].join(':')
                          : '';

                        return (
                          <Box
                            key={`cmp-siteplan-${fp.unit.id}`}
                            sx={{
                              flex: '1 1 0',
                              minWidth: compareTripleColumnFit ? 0 : 380,
                              maxWidth: compareTripleColumnFit ? '100%' : undefined,
                              border: '1px solid rgba(var(--color-text-rgb), 0.2)',
                              borderRadius: 1,
                              overflow: 'hidden',
                              bgcolor: 'rgba(var(--color-text-rgb), 0.02)',
                              boxShadow: isFocused ? '0 0 0 2px rgba(var(--color-accent-rgb), 0.6)' : 'none',
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1, py: 0.5, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }}>
                              <Typography variant="caption" sx={{ fontWeight: 700 }}>
                                {fp.unit.projectName} {fp.unit.unitNumber}
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 0.25, alignItems: 'center' }}>
                                <Tooltip title="Mirror flip">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleFlipComparePlan(fp.unit.id, 'siteplan')}
                                    color={compareSitePlanFlips[fp.unit.id] ? 'primary' : 'default'}
                                  >
                                    <FlipIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Rotate left">
                                  <IconButton size="small" onClick={() => handleRotateComparePlan(fp.unit.id, 'siteplan', 'ccw')}>
                                    <RotateLeftIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Rotate right">
                                  <IconButton size="small" onClick={() => handleRotateComparePlan(fp.unit.id, 'siteplan', 'cw')}>
                                    <RotateRightIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <IconButton size="small" onClick={() => moveCompareFloorPlan(index, Math.max(0, index - 1), true)} disabled={index === 0}>
                                  <ArrowBackIcon fontSize="small" />
                                </IconButton>
                                <IconButton size="small" onClick={() => moveCompareFloorPlan(index, Math.min(compareDialogFloorPlans.length - 1, index + 1), true)} disabled={index === compareDialogFloorPlans.length - 1}>
                                  <ArrowForwardIcon fontSize="small" />
                                </IconButton>
                              </Box>
                            </Box>
                            <Box
                              data-pdf-capture={`compare-siteplan-${index}`}
                              onClick={() => setCompareFocusedUnitId(fp.unit.id)}
                              sx={{
                                height: '58vh',
                                minHeight: 360,
                                p: 0.5,
                                cursor: 'grab',
                                bgcolor: 'rgba(var(--color-text-rgb), 0.04)',
                                overflow: 'hidden',
                              }}
                            >
                              {!hasFetchedSitePlan && compareSitePlansLoading ? (
                                <CircularProgress size={26} />
                              ) : !projectSitePlan?.imageUrl ? (
                                <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.75)', textAlign: 'center' }}>
                                  No site plan available for this project.
                                </Typography>
                              ) : (
                                <TransformWrapper
                                  initialScale={1}
                                  minScale={0.8}
                                  maxScale={8}
                                  centerOnInit
                                  limitToBounds={false}
                                  wheel={{ step: 0.08 }}
                                  pinch={{ step: 5 }}
                                  doubleClick={{ step: 0.8 }}
                                  panning={{ disabled: drawToolbarState.isDrawMode, velocityDisabled: true }}
                                >
                                  {({ zoomToElement }) => (
                                    <>
                                      {markerElementId && (
                                        <CompareSitePlanAutoFocus
                                          enabled={floorPlanCompareOpen && compareVisualizerMode === 'siteplan' && compareShowSitePlanPoints}
                                          markerElementId={markerElementId}
                                          focusKey={markerFocusKey}
                                          zoomToElement={zoomToElement}
                                        />
                                      )}
                                      <TransformComponent
                                        wrapperStyle={{ width: '100%', height: '100%' }}
                                        contentStyle={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                      >
                                        <Box
                                          sx={{
                                            position: 'relative',
                                            display: 'block',
                                            width: '100%',
                                            ...(() => {
                                              // Flip outermost (screen space), rotation innermost:
                                              // `scaleX(-1) rotate(deg)` — matches DrawableFloorPlan's coord inversion.
                                              const flip = (compareSitePlanFlips[fp.unit.id] ?? false) ? 'scaleX(-1)' : '';
                                              const rot = (compareSitePlanRotations[fp.unit.id] ?? 0)
                                                ? `rotate(${compareSitePlanRotations[fp.unit.id] ?? 0}deg)`
                                                : '';
                                              const transform = [flip, rot].filter(Boolean).join(' ');
                                              return transform ? { transform, transformOrigin: 'center center' } : {};
                                            })(),
                                          }}
                                        >
                                          <DrawableFloorPlan
                                            imageUrl={projectSitePlan.imageUrl}
                                            alt={`${projectName} site plan`}
                                            unitId={fp.unit.id}
                                            isDrawMode={drawToolbarState.isDrawMode}
                                            activeColor={drawToolbarState.activeColor}
                                            lineWidth={drawToolbarState.lineWidth}
                                            activeTool={drawToolbarState.activeTool}
                                            strokes={drawingStates[`siteplan:${fp.unit.id}`]?.strokes ?? []}
                                            onStrokesChange={handleDrawStrokesChange}
                                            rotationDegrees={compareSitePlanRotations[fp.unit.id] ?? 0}
                                            rotationAppliedByParent
                                            flipHorizontal={compareSitePlanFlips[fp.unit.id] ?? false}
                                            flipAppliedByParent
                                          />
                                          {compareShowSitePlanPoints && marker && (
                                            <Box
                                              id={markerElementId ?? undefined}
                                              sx={{
                                                position: 'absolute',
                                                left: `${marker.left}%`,
                                                top: `${marker.top}%`,
                                                width: `${marker.width}%`,
                                                height: `${marker.height}%`,
                                                pointerEvents: 'none',
                                                '@keyframes compareSitePlanBlink': {
                                                  '0%, 100%': {
                                                    opacity: 1,
                                                    transform: 'translate(-50%, -50%) scale(1)',
                                                  },
                                                  '50%': {
                                                    opacity: 0.3,
                                                    transform: 'translate(-50%, -50%) scale(1.3)',
                                                  },
                                                },
                                                '&::before': {
                                                  content: `"${marker.label}"`,
                                                  position: 'absolute',
                                                  left: '50%',
                                                  top: '50%',
                                                  transform: 'translate(-50%, -50%)',
                                                  width: `${sitePlanDotSize}px`,
                                                  height: `${sitePlanDotSize}px`,
                                                  borderRadius: '50%',
                                                  backgroundColor: 'var(--color-success)',
                                                  border: sitePlanDotBorder,
                                                  boxShadow: sitePlanDotShadow,
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  fontSize: sitePlanDotFontSize,
                                                  fontWeight: 'bold',
                                                  color: 'var(--color-white)',
                                                  textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
                                                  animation: 'compareSitePlanBlink 0.5s ease-in-out infinite',
                                                },
                                              }}
                                            />
                                          )}
                                          {compareShowSitePlanPoints && !marker && (
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                position: 'absolute',
                                                left: 8,
                                                bottom: 8,
                                                px: 0.75,
                                                py: 0.25,
                                                borderRadius: 0.75,
                                                bgcolor: 'rgba(var(--color-shadow-rgb), 0.65)',
                                                color: 'var(--color-white)',
                                              }}
                                            >
                                              Stack marker not found
                                            </Typography>
                                          )}
                                        </Box>
                                      </TransformComponent>
                                    </>
                                  )}
                                </TransformWrapper>
                              )}
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      border: '1px solid rgba(var(--color-text-rgb), 0.12)',
                      borderRadius: 1,
                      p: compareQuickReferenceOpen ? 1.25 : 0.5,
                      maxHeight: compareQuickRefSideBySide ? '74vh' : 'none',
                      overflowY: 'auto',
                      bgcolor: 'rgba(var(--color-text-rgb), 0.02)',
                      overflowX: compareQuickRefSideBySide ? 'hidden' : 'auto',
                      width: '100%',
                    }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: compareQuickReferenceOpen ? 'space-between' : 'center', alignItems: 'center', mb: compareQuickReferenceOpen ? 1 : 0 }}>
                      {compareQuickReferenceOpen && (
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                          Quick Reference
                        </Typography>
                      )}
                      <Tooltip title={compareQuickReferenceOpen ? 'Hide Quick Reference' : 'Show Quick Reference'}>
                        <IconButton size="small" onClick={() => setCompareQuickReferenceOpen((prev) => !prev)}>
                          {compareQuickReferenceOpen ? <ChevronRightIcon fontSize="small" /> : <ChevronLeftIcon fontSize="small" />}
                        </IconButton>
                      </Tooltip>
                    </Box>
                    {compareQuickReferenceOpen && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: compareQuickRefSideBySide ? 'column' : 'row',
                          gap: 1,
                          alignItems: 'stretch',
                          overflowX: compareQuickRefSideBySide ? 'visible' : 'auto',
                        }}
                      >
                        {compareDialogFloorPlans.map((fp) => (
                          <Box
                            key={`cmp-site-ref-${fp.unit.id}`}
                            onClick={() => setCompareFocusedUnitId(fp.unit.id)}
                            sx={{
                              flex: compareQuickRefSideBySide ? 'none' : '0 0 auto',
                              width: compareQuickRefSideBySide ? 'auto' : 148,
                              p: 0.85,
                              borderRadius: 1,
                              border: '1px solid rgba(var(--color-text-rgb), 0.14)',
                              cursor: 'pointer',
                              bgcolor: fp.unit.id === compareFocusedUnitId ? 'rgba(var(--color-accent-rgb), 0.14)' : 'transparent',
                            }}
                          >
                            <Typography variant="caption" sx={{ fontWeight: 700, display: 'block', mb: 0.5 }}>
                              {fp.unit.unitNumber}
                            </Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>Price: {getCompareRowDisplayValue(fp, 'price')}</Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>PSF: {getCompareRowDisplayValue(fp, 'psf')}</Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>
                              Outlay: {(() => {
                                const price = (fp.unit as any).priceNps ?? fp.unit.price ?? 0;
                                const outlay = price != null && price > 0 ? calculateOutlay(price, loanToValue / 100) : 0;
                                return outlay > 0 ? (
                                  <Tooltip title={getOutlayFormulaTooltip(price, outlay)}>
                                    <Box component="span" sx={{ cursor: 'help' }}>{getCompareRowDisplayValue(fp, 'outlay')}</Box>
                                  </Tooltip>
                                ) : getCompareRowDisplayValue(fp, 'outlay');
                              })()}
                            </Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>
                              Installment: {(() => {
                                const price = (fp.unit as any).priceNps ?? fp.unit.price ?? 0;
                                const installment = price != null && price > 0 ? calculateInstallment(price, loanToValue / 100, tenureYears, interestRate / 100) : 0;
                                return installment > 0 ? (
                                  <Tooltip title={getInstallmentFormulaTooltip(price, installment)}>
                                    <Box component="span" sx={{ cursor: 'help' }}>{getCompareRowDisplayValue(fp, 'installment')}</Box>
                                  </Tooltip>
                                ) : getCompareRowDisplayValue(fp, 'installment');
                              })()}
                            </Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>Area: {getCompareRowDisplayValue(fp, 'areaSqft')}</Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>Bedroom: {getCompareRowDisplayValue(fp, 'bedroom')}</Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>Bathroom: {getCompareRowDisplayValue(fp, 'bathroom')}</Typography>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                </Box>
              ) : compareExpandedView ? (
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: compareQuickRefSideBySide
                      ? (compareQuickReferenceOpen ? 'minmax(0, 1fr) 200px' : 'minmax(0, 1fr) 36px')
                      : '1fr',
                    gap: 2,
                    alignItems: 'start',
                  }}
                >
                  <Box sx={{ overflowX: compareTripleColumnFit ? 'hidden' : 'auto', minWidth: 0, width: '100%' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 1.5,
                        width: '100%',
                        minWidth: compareTripleColumnFit ? 0 : Math.max(820, compareDialogFloorPlans.length * 420),
                        alignItems: 'stretch',
                      }}
                    >
                      {compareDialogFloorPlans.map((fp, index) => {
                        const isFocused = fp.unit.id === compareFocusedUnitId;
                        return (
                          <Box
                            key={`cmp-expanded-${fp.unit.id}`}
                            sx={{
                              flex: '1 1 0',
                              minWidth: compareTripleColumnFit ? 0 : 380,
                              maxWidth: compareTripleColumnFit ? '100%' : undefined,
                              border: '1px solid rgba(var(--color-text-rgb), 0.2)',
                              borderRadius: 1,
                              overflow: 'hidden',
                              bgcolor: 'rgba(var(--color-text-rgb), 0.02)',
                              boxShadow: isFocused ? '0 0 0 2px rgba(var(--color-accent-rgb), 0.6)' : 'none',
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1, py: 0.5, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }}>
                              <Typography variant="caption" sx={{ fontWeight: 700 }}>
                                {fp.unit.projectName} {fp.unit.unitNumber}
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 0.25, alignItems: 'center' }}>
                                <Tooltip title="Mirror flip">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleFlipComparePlan(fp.unit.id, 'floorplan')}
                                    color={compareFloorPlanFlips[fp.unit.id] ? 'primary' : 'default'}
                                  >
                                    <FlipIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Rotate left">
                                  <IconButton size="small" onClick={() => handleRotateComparePlan(fp.unit.id, 'floorplan', 'ccw')}>
                                    <RotateLeftIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Rotate right">
                                  <IconButton size="small" onClick={() => handleRotateComparePlan(fp.unit.id, 'floorplan', 'cw')}>
                                    <RotateRightIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <IconButton size="small" onClick={() => moveCompareFloorPlan(index, Math.max(0, index - 1), true)} disabled={index === 0}>
                                  <ArrowBackIcon fontSize="small" />
                                </IconButton>
                                <IconButton size="small" onClick={() => moveCompareFloorPlan(index, Math.min(compareDialogFloorPlans.length - 1, index + 1), true)} disabled={index === compareDialogFloorPlans.length - 1}>
                                  <ArrowForwardIcon fontSize="small" />
                                </IconButton>
                              </Box>
                            </Box>
                            <Box
                              data-pdf-capture={`compare-floorplan-${index}`}
                              onClick={() => setCompareFocusedUnitId(fp.unit.id)}
                              sx={{
                                height: '58vh',
                                minHeight: 360,
                                p: 0.5,
                                cursor: 'grab',
                                bgcolor: 'rgba(var(--color-text-rgb), 0.04)',
                                overflow: 'hidden',
                              }}
                            >
                              {fp.imageUrl ? (
                                <TransformWrapper
                                  initialScale={1}
                                  minScale={0.8}
                                  maxScale={8}
                                  centerOnInit
                                  limitToBounds={false}
                                  wheel={{ step: 0.08 }}
                                  pinch={{ step: 5 }}
                                  doubleClick={{ step: 0.8 }}
                                  panning={{ disabled: drawToolbarState.isDrawMode, velocityDisabled: true }}
                                >
                                  <TransformComponent
                                    wrapperStyle={{ width: '100%', height: '100%' }}
                                    contentStyle={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                  >
                                    <DrawableFloorPlan
                                      imageUrl={fp.imageUrl}
                                      alt={`${fp.unit.projectName} ${fp.unit.unitNumber}`}
                                      unitId={fp.unit.id}
                                      isDrawMode={drawToolbarState.isDrawMode}
                                      activeColor={drawToolbarState.activeColor}
                                      lineWidth={drawToolbarState.lineWidth}
                                      activeTool={drawToolbarState.activeTool}
                                      strokes={drawingStates[`floorplan:${fp.unit.id}`]?.strokes ?? []}
                                      onStrokesChange={handleDrawStrokesChange}
                                      rotationDegrees={compareFloorPlanRotations[fp.unit.id] ?? 0}
                                      flipHorizontal={compareFloorPlanFlips[fp.unit.id] ?? false}
                                    />
                                  </TransformComponent>
                                </TransformWrapper>
                              ) : (
                                <Typography variant="caption">No image</Typography>
                              )}
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      border: '1px solid rgba(var(--color-text-rgb), 0.12)',
                      borderRadius: 1,
                      p: compareQuickReferenceOpen ? 1.25 : 0.5,
                      maxHeight: compareQuickRefSideBySide ? '74vh' : 'none',
                      overflowY: 'auto',
                      bgcolor: 'rgba(var(--color-text-rgb), 0.02)',
                      overflowX: compareQuickRefSideBySide ? 'hidden' : 'auto',
                      width: '100%',
                    }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: compareQuickReferenceOpen ? 'space-between' : 'center', alignItems: 'center', mb: compareQuickReferenceOpen ? 1 : 0 }}>
                      {compareQuickReferenceOpen && (
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                          Quick Reference
                        </Typography>
                      )}
                      <Tooltip title={compareQuickReferenceOpen ? 'Hide Quick Reference' : 'Show Quick Reference'}>
                        <IconButton size="small" onClick={() => setCompareQuickReferenceOpen((prev) => !prev)}>
                          {compareQuickReferenceOpen ? <ChevronRightIcon fontSize="small" /> : <ChevronLeftIcon fontSize="small" />}
                        </IconButton>
                      </Tooltip>
                    </Box>
                    {compareQuickReferenceOpen && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: compareQuickRefSideBySide ? 'column' : 'row',
                          gap: 1,
                          alignItems: 'stretch',
                          overflowX: compareQuickRefSideBySide ? 'visible' : 'auto',
                        }}
                      >
                        {compareDialogFloorPlans.map((fp) => (
                          <Box
                            key={`cmp-ref-${fp.unit.id}`}
                            onClick={() => setCompareFocusedUnitId(fp.unit.id)}
                            sx={{
                              flex: compareQuickRefSideBySide ? 'none' : '0 0 auto',
                              width: compareQuickRefSideBySide ? 'auto' : 148,
                              p: 0.85,
                              borderRadius: 1,
                              border: '1px solid rgba(var(--color-text-rgb), 0.14)',
                              cursor: 'pointer',
                              bgcolor: fp.unit.id === compareFocusedUnitId ? 'rgba(var(--color-accent-rgb), 0.14)' : 'transparent',
                            }}
                          >
                            <Typography variant="caption" sx={{ fontWeight: 700, display: 'block', mb: 0.5 }}>
                              {fp.unit.unitNumber}
                            </Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>Price: {getCompareRowDisplayValue(fp, 'price')}</Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>PSF: {getCompareRowDisplayValue(fp, 'psf')}</Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>
                              Outlay: {(() => {
                                const price = (fp.unit as any).priceNps ?? fp.unit.price ?? 0;
                                const outlay = price != null && price > 0 ? calculateOutlay(price, loanToValue / 100) : 0;
                                return outlay > 0 ? (
                                  <Tooltip title={getOutlayFormulaTooltip(price, outlay)}>
                                    <Box component="span" sx={{ cursor: 'help' }}>{getCompareRowDisplayValue(fp, 'outlay')}</Box>
                                  </Tooltip>
                                ) : getCompareRowDisplayValue(fp, 'outlay');
                              })()}
                            </Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>
                              Installment: {(() => {
                                const price = (fp.unit as any).priceNps ?? fp.unit.price ?? 0;
                                const installment = price != null && price > 0 ? calculateInstallment(price, loanToValue / 100, tenureYears, interestRate / 100) : 0;
                                return installment > 0 ? (
                                  <Tooltip title={getInstallmentFormulaTooltip(price, installment)}>
                                    <Box component="span" sx={{ cursor: 'help' }}>{getCompareRowDisplayValue(fp, 'installment')}</Box>
                                  </Tooltip>
                                ) : getCompareRowDisplayValue(fp, 'installment');
                              })()}
                            </Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>Area: {getCompareRowDisplayValue(fp, 'areaSqft')}</Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>Bedroom: {getCompareRowDisplayValue(fp, 'bedroom')}</Typography>
                            <Typography variant="caption" sx={{ display: 'block' }}>Bathroom: {getCompareRowDisplayValue(fp, 'bathroom')}</Typography>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                </Box>
              ) : (
              (() => {
                const compareOverviewRows: Array<{ label: string; key: string }> = [
                  { label: 'Price', key: 'price' },
                  { label: 'PSF', key: 'psf' },
                  { label: 'Outlay', key: 'outlay' },
                  { label: 'Installment', key: 'installment' },
                  { label: 'Area', key: 'areaSqft' },
                  { label: 'Bedroom', key: 'bedroom' },
                  { label: 'Bathroom', key: 'bathroom' },
                  { label: 'Block', key: 'block' },
                  { label: 'Floor', key: 'floor' },
                  { label: 'Stack', key: 'stack' },
                ];
                const getCompareOverviewValue = (fp: (typeof compareDialogFloorPlans)[number], key: string): number | string => {
                  const unit = fp.unit;
                  const unitStatus = (unit as { unitStatus?: string | null }).unitStatus;
                  const isPriceHidden = unitStatus?.toString().toLowerCase() === 'sold' || isUnitStatusNotReleased(unitStatus);
                  const parsed = parseUnitNumber(unit.unitNumber);
                  switch (key) {
                    case 'price': return isPriceHidden ? 0 : (unit.price ?? 0);
                    case 'psf': return isPriceHidden ? 0 : (unit.psf ?? (unit as any).pricePSF ?? (unit.price && unit.areaSqft ? unit.price / unit.areaSqft : (unit.price && (unit as any).size ? unit.price / (unit as any).size : 0)));
                    case 'outlay': return isPriceHidden ? 0 : (unit.price != null && unit.price > 0 ? calculateOutlay(unit.price, loanToValue / 100) : 0);
                    case 'installment': return isPriceHidden ? 0 : (unit.price != null && unit.price > 0 ? calculateInstallment(unit.price, loanToValue / 100, tenureYears, interestRate / 100) : 0);
                    case 'areaSqft': return unit.areaSqft ?? (unit as any).size ?? 0;
                    case 'bedroom': return unit.bedroom ?? (unit as any).bedroomNumber ?? 0;
                    case 'bathroom': return unit.bathroom ?? (unit as any).bathroomNumber ?? 0;
                    case 'block': return unit.blockNumber || '-';
                    case 'floor': return parsed.floor ?? '-';
                    case 'stack': return parsed.stack ?? '-';
                    default: return '-';
                  }
                };
                const compareOverviewBestByKey = new Map<string, number>();
                compareOverviewRows.forEach((row) => {
                  const isNumeric = ['price', 'psf', 'outlay', 'installment', 'areaSqft', 'bedroom', 'bathroom'].includes(row.key);
                  const isFloorRow = row.key === 'floor';
                  const isBiggerBetter = row.key === 'areaSqft' || row.key === 'bedroom' || row.key === 'bathroom' || isFloorRow;
                  if (!isNumeric && !isFloorRow) return;
                  const values = compareDialogFloorPlans
                    .map((fp) => getCompareOverviewValue(fp, row.key))
                    .filter((v): v is number => typeof v === 'number' && Number.isFinite(v) && (isFloorRow || v > 0));
                  if (values.length === 0) return;
                  compareOverviewBestByKey.set(row.key, isBiggerBetter ? Math.max(...values) : Math.min(...values));
                });
                const formatCompareOverviewDisplay = (key: string, value: number | string): string => {
                  if (key === 'price' || key === 'psf' || key === 'outlay' || key === 'installment') {
                    return typeof value === 'number' && value > 0 ? formatCurrency(value) : '-';
                  }
                  if (key === 'areaSqft') {
                    return typeof value === 'number' && value > 0 ? `${formatNumber(value)} sqft` : '-';
                  }
                  return String(value);
                };

                if (isMobile) {
                  const mobileColumnCount = compareDialogFloorPlans.length;
                  return (
                    <Box sx={{ overflowX: 'auto', width: '100%', minWidth: 0, WebkitOverflowScrolling: 'touch' }}>
                      <Box
                        sx={{
                          display: 'grid',
                          gridTemplateColumns: `72px repeat(${mobileColumnCount}, minmax(132px, 1fr))`,
                          minWidth: Math.max(320, 72 + mobileColumnCount * 132),
                          border: '1px solid rgba(var(--color-text-rgb), 0.12)',
                          borderRadius: 1.5,
                          overflow: 'hidden',
                        }}
                      >
                        <Box
                          sx={{
                            position: 'sticky',
                            left: 0,
                            zIndex: 2,
                            bgcolor: 'var(--color-surface)',
                            borderRight: '1px solid rgba(var(--color-text-rgb), 0.12)',
                          }}
                        />
                        {compareDialogFloorPlans.map((fp, index) => (
                          <Box
                            key={`cmp-mobile-head-${fp.unit.id}`}
                            sx={{
                              p: 1,
                              borderRight: '1px solid rgba(var(--color-text-rgb), 0.12)',
                              ...getCompareColumnSx(index),
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                              <Box sx={{ display: 'flex', gap: 0 }}>
                                <IconButton
                                  size="small"
                                  onClick={() => moveCompareFloorPlan(index, Math.max(0, index - 1), true)}
                                  disabled={index === 0}
                                  sx={{ p: 0.25 }}
                                >
                                  <ArrowBackIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() => moveCompareFloorPlan(index, Math.min(compareDialogFloorPlans.length - 1, index + 1), true)}
                                  disabled={index === compareDialogFloorPlans.length - 1}
                                  sx={{ p: 0.25 }}
                                >
                                  <ArrowForwardIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                              </Box>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  if (compareDialogSource === 'topViewing') {
                                    setTopViewingFloorPlansToCompare((prev) => prev.filter((item) => item.unit.id !== fp.unit.id));
                                  } else {
                                    handleRemoveFromFloorPlanCompare(fp.unit.id);
                                  }
                                }}
                                sx={{ p: 0.25 }}
                              >
                                <CloseIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </Box>
                            <Box
                              sx={{
                                height: 110,
                                borderRadius: 1,
                                overflow: 'hidden',
                                bgcolor: 'rgba(var(--color-text-rgb), 0.06)',
                                mb: 0.75,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                p: 0.5,
                              }}
                              onClick={() => {
                                setCompareFocusedUnitId(fp.unit.id);
                                setCompareExpandedView(true);
                              }}
                            >
                              {fp.imageUrl ? (
                                <Box
                                  component="img"
                                  src={fp.imageUrl}
                                  alt={`${fp.unit.projectName} ${fp.unit.unitNumber}`}
                                  sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    transform: `scale(${compareFloorPlanZoom})`,
                                    transformOrigin: 'center center',
                                    transition: 'transform 0.15s ease',
                                  }}
                                />
                              ) : (
                                <Typography variant="caption">No image</Typography>
                              )}
                            </Box>
                            <Typography
                              variant="caption"
                              sx={{
                                fontWeight: 700,
                                textAlign: 'center',
                                display: 'block',
                                lineHeight: 1.2,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {fp.unit.projectName}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 700, textAlign: 'center', lineHeight: 1.2 }}>
                              {fp.unit.unitNumber}
                            </Typography>
                            {fp.unit.unitStatus?.toString().toLowerCase() === 'sold' ? (
                              <Typography component="span" sx={{ display: 'block', textAlign: 'center', fontSize: '0.65em', color: 'var(--color-danger)', fontWeight: 700 }}>
                                SOLD
                              </Typography>
                            ) : null}
                          </Box>
                        ))}

                        <Box
                          sx={{
                            gridColumn: `1 / span ${mobileColumnCount + 1}`,
                            px: 1,
                            py: 0.75,
                            bgcolor: 'rgba(var(--color-text-rgb), 0.08)',
                            borderTop: '1px solid rgba(var(--color-text-rgb), 0.12)',
                            borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)',
                          }}
                        >
                          <Typography variant="caption" sx={{ fontWeight: 700, letterSpacing: 0.4 }}>
                            OVERVIEW
                          </Typography>
                        </Box>

                        {compareOverviewRows.map((row) => {
                          const values = compareDialogFloorPlans.map((fp) => getCompareOverviewValue(fp, row.key));
                          const best = compareOverviewBestByKey.get(row.key);
                          return (
                            <React.Fragment key={`cmp-mobile-row-${row.key}`}>
                              <Box
                                sx={{
                                  position: 'sticky',
                                  left: 0,
                                  zIndex: 1,
                                  px: 0.75,
                                  py: 1,
                                  bgcolor: 'rgba(var(--color-text-rgb), 0.05)',
                                  borderTop: '1px solid rgba(var(--color-text-rgb), 0.12)',
                                  borderRight: '1px solid rgba(var(--color-text-rgb), 0.12)',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Typography variant="caption" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                                  {row.label}
                                </Typography>
                              </Box>
                              {values.map((value, idx) => {
                                const isBest = typeof value === 'number' && best != null && value === best;
                                const displayValue = formatCompareOverviewDisplay(row.key, value);
                                return (
                                  <Box
                                    key={`cmp-mobile-row-${row.key}-${idx}`}
                                    sx={{
                                      px: 0.75,
                                      py: 1,
                                      borderTop: '1px solid rgba(var(--color-text-rgb), 0.12)',
                                      borderRight: '1px solid rgba(var(--color-text-rgb), 0.12)',
                                      textAlign: 'center',
                                      ...getCompareColumnSx(idx),
                                    }}
                                  >
                                    {(row.key === 'outlay' || row.key === 'installment') && typeof value === 'number' && value > 0 ? (
                                      <Tooltip
                                        arrow
                                        title={
                                          row.key === 'outlay'
                                            ? getOutlayFormulaTooltip(compareDialogFloorPlans[idx]?.unit?.price ?? 0, value)
                                            : getInstallmentFormulaTooltip(compareDialogFloorPlans[idx]?.unit?.price ?? 0, value)
                                        }
                                      >
                                        <Typography
                                          component="span"
                                          variant="caption"
                                          sx={{
                                            fontWeight: isBest ? 700 : 500,
                                            color: isBest ? 'var(--color-price-decrease)' : 'var(--color-text-strong)',
                                            cursor: 'help',
                                            borderBottom: '1px dotted rgba(var(--color-text-rgb), 0.5)',
                                            lineHeight: 1.2,
                                          }}
                                        >
                                          {displayValue}
                                        </Typography>
                                      </Tooltip>
                                    ) : (
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          fontWeight: isBest ? 700 : 500,
                                          color: isBest ? 'var(--color-price-decrease)' : 'var(--color-text-strong)',
                                          lineHeight: 1.2,
                                        }}
                                      >
                                        {displayValue}
                                      </Typography>
                                    )}
                                  </Box>
                                );
                              })}
                            </React.Fragment>
                          );
                        })}
                      </Box>
                    </Box>
                  );
                }

                return (
              <Box sx={{ overflowX: compareTripleColumnFit ? 'hidden' : 'auto', width: '100%', minWidth: 0 }}>
                <Box
                  sx={{
                    width: '100%',
                    minWidth: compareTripleColumnFit ? 0 : Math.max(760, compareDialogFloorPlans.length * 260 + 220),
                  }}
                >
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: `220px repeat(${compareDialogFloorPlans.length}, minmax(0, 1fr))`,
                      border: '1px solid rgba(var(--color-text-rgb), 0.12)',
                      borderRadius: 1,
                      overflow: 'hidden',
                    }}
                  >
                    <Box sx={{ bgcolor: 'rgba(var(--color-text-rgb), 0.04)', borderRight: '1px solid rgba(var(--color-text-rgb), 0.12)' }} />
                    {compareDialogFloorPlans.map((fp, index) => (
                      <Box
                        key={`cmp-head-${fp.unit.id}`}
                        draggable
                        onDragStart={(e) => {
                          compareDragIndexRef.current = index;
                          setCompareDragActiveIndex(index);
                          const dragImage = buildCompareDragImage(fp);
                          if (dragImage) {
                            e.dataTransfer.setDragImage(dragImage, dragImage.offsetWidth / 2, 20);
                          }
                          e.dataTransfer.effectAllowed = 'move';
                        }}
                        onDragEnd={() => {
                          compareDragIndexRef.current = null;
                          setCompareDragActiveIndex(null);
                          setCompareDragOverIndex(null);
                          cleanupCompareDragImage();
                        }}
                        onDragOver={(e) => e.preventDefault()}
                        onDragEnter={() => setCompareDragOverIndex(index)}
                        onDrop={(e) => {
                          e.preventDefault();
                          const fromIndex = compareDragIndexRef.current;
                          if (fromIndex == null) return;
                          moveCompareFloorPlan(fromIndex, index);
                          compareDragIndexRef.current = null;
                          setCompareDragActiveIndex(null);
                          setCompareDragOverIndex(null);
                          cleanupCompareDragImage();
                        }}
                        sx={{
                          p: 2,
                          borderRight: '1px solid rgba(var(--color-text-rgb), 0.12)',
                          cursor: 'grab',
                          ...getCompareColumnSx(index),
                        }}
                      >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Box sx={{ display: 'flex', gap: 0.5 }}>
                            <IconButton
                              size="small"
                              onClick={() => moveCompareFloorPlan(index, Math.max(0, index - 1), true)}
                              disabled={index === 0}
                            >
                              <ArrowBackIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => moveCompareFloorPlan(index, Math.min(compareDialogFloorPlans.length - 1, index + 1), true)}
                              disabled={index === compareDialogFloorPlans.length - 1}
                            >
                              <ArrowForwardIcon fontSize="small" />
                            </IconButton>
                          </Box>
                          <IconButton
                            size="small"
                            onClick={() => {
                              if (compareDialogSource === 'topViewing') {
                                setTopViewingFloorPlansToCompare((prev) => prev.filter((item) => item.unit.id !== fp.unit.id));
                              } else {
                                handleRemoveFromFloorPlanCompare(fp.unit.id);
                              }
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                        <Box
                          sx={{
                            height: 140,
                            borderRadius: 1,
                            overflow: 'hidden',
                            bgcolor: 'rgba(var(--color-text-rgb), 0.06)',
                            mb: 1.5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 1,
                          }}
                          onClick={() => {
                            setCompareFocusedUnitId(fp.unit.id);
                            setCompareExpandedView(true);
                          }}
                        >
                          {fp.imageUrl ? (
                            <Box
                              component="img"
                              src={fp.imageUrl}
                              alt={`${fp.unit.projectName} ${fp.unit.unitNumber}`}
                              sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                maxWidth: '100%',
                                maxHeight: '100%',
                                transform: `scale(${compareFloorPlanZoom})`,
                                transformOrigin: 'center center',
                                transition: 'transform 0.15s ease',
                              }}
                            />
                          ) : (
                            <Typography variant="caption">No image</Typography>
                          )}
                        </Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, textAlign: 'center' }}>
                          {fp.unit.projectName}
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25 }}>
                          <Typography variant="h6" sx={{ fontWeight: 700, textAlign: 'center' }}>
                            {fp.unit.unitNumber}
                          </Typography>
                          {fp.unit.unitStatus?.toString().toLowerCase() === 'sold' ? (
                            <Typography component="span" sx={{ fontSize: '0.75em', color: 'var(--color-danger)', fontWeight: 700 }}>SOLD</Typography>
                          ) : null}
                        </Box>
                      </Box>
                    ))}

                    <Box sx={{ gridColumn: `1 / span ${compareDialogFloorPlans.length + 1}`, p: 1.5, bgcolor: 'rgba(var(--color-text-rgb), 0.08)', borderTop: '1px solid rgba(var(--color-text-rgb), 0.12)', borderBottom: '1px solid rgba(var(--color-text-rgb), 0.12)' }}>
                      <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: 0.3 }}>OVERVIEW</Typography>
                    </Box>

                    {compareOverviewRows.map((row) => {
                      const values = compareDialogFloorPlans.map((fp) => getCompareOverviewValue(fp, row.key));
                      const best = compareOverviewBestByKey.get(row.key);

                      return (
                        <React.Fragment key={`cmp-row-${row.key}`}>
                          <Box sx={{ p: 1.5, bgcolor: 'rgba(var(--color-text-rgb), 0.05)', borderTop: '1px solid rgba(var(--color-text-rgb), 0.12)', fontWeight: 600 }}>
                            {row.label}
                          </Box>
                          {values.map((value, idx) => {
                            const isBest = typeof value === 'number' && best != null && value === best;
                            const displayValue = formatCompareOverviewDisplay(row.key, value);
                            return (
                              <Box
                                key={`cmp-row-${row.key}-${idx}`}
                                draggable
                                onDragStart={(e) => {
                                  compareDragIndexRef.current = idx;
                                  setCompareDragActiveIndex(idx);
                                  const dragFp = compareDialogFloorPlans[idx];
                                  if (dragFp) {
                                    const dragImage = buildCompareDragImage(dragFp);
                                    if (dragImage) {
                                      e.dataTransfer.setDragImage(dragImage, dragImage.offsetWidth / 2, 20);
                                    }
                                  }
                                  e.dataTransfer.effectAllowed = 'move';
                                }}
                                onDragOver={(e) => e.preventDefault()}
                                onDragEnter={() => setCompareDragOverIndex(idx)}
                                onDrop={(e) => {
                                  e.preventDefault();
                                  const fromIndex = compareDragIndexRef.current;
                                  if (fromIndex == null) return;
                                  moveCompareFloorPlan(fromIndex, idx);
                                  compareDragIndexRef.current = null;
                                  setCompareDragActiveIndex(null);
                                  setCompareDragOverIndex(null);
                                  cleanupCompareDragImage();
                                }}
                                onDragEnd={() => {
                                  compareDragIndexRef.current = null;
                                  setCompareDragActiveIndex(null);
                                  setCompareDragOverIndex(null);
                                  cleanupCompareDragImage();
                                }}
                                sx={{
                                  p: 1.5,
                                  borderTop: '1px solid rgba(var(--color-text-rgb), 0.12)',
                                  borderRight: '1px solid rgba(var(--color-text-rgb), 0.12)',
                                  textAlign: 'center',
                                  fontWeight: isBest ? 700 : 500,
                                  color: isBest ? 'var(--color-price-decrease)' : 'var(--color-text-strong)',
                                  cursor: 'grab',
                                  ...getCompareColumnSx(idx),
                                }}
                              >
                                {(row.key === 'outlay' || row.key === 'installment') && typeof value === 'number' && value > 0 ? (
                                  <Tooltip
                                    arrow
                                    title={
                                      row.key === 'outlay'
                                        ? getOutlayFormulaTooltip(compareDialogFloorPlans[idx]?.unit?.price ?? 0, value)
                                        : getInstallmentFormulaTooltip(compareDialogFloorPlans[idx]?.unit?.price ?? 0, value)
                                    }
                                  >
                                    <Box component="span" sx={{ cursor: 'help', borderBottom: '1px dotted rgba(var(--color-text-rgb), 0.5)' }}>{displayValue}</Box>
                                  </Tooltip>
                                ) : (
                                  displayValue
                                )}
                              </Box>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}
                  </Box>
                </Box>
              </Box>
                );
              })()
              )
            )}
          </DialogContent>
          <DialogActions
            sx={{
              px: isMobile ? 1.5 : 2,
              py: isMobile ? 1.25 : 1,
              flexDirection: isMobile ? 'column' : 'row',
              flexWrap: 'nowrap',
              gap: 1,
              justifyContent: isMobile ? 'stretch' : 'flex-start',
              alignItems: isMobile ? 'stretch' : 'center',
              overflowX: isMobile ? undefined : 'auto',
            }}
          >
            {isMobile ? (
              <>
                {(compareExpandedView || compareVisualizerMode === 'siteplan') && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <ToggleButtonGroup
                      value={compareVisualizerMode}
                      exclusive
                      onChange={(_, value) => {
                        if (value != null) handleCompareVisualizerModeChange(value);
                      }}
                      size="small"
                      sx={{
                        '& .MuiToggleButton-root': { px: 1.2, textTransform: 'none' },
                      }}
                    >
                      <ToggleButton value="floorplan">Floor Plan</ToggleButton>
                      <ToggleButton value="siteplan">Site Plan</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                )}
                <Box sx={{ display: 'flex', gap: 1, width: '100%', '& > *': { flex: '1 1 0', minWidth: 0 } }}>
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={compareExportingPdf ? <CircularProgress size={14} /> : <PictureAsPdfIcon />}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={(e) => setCompareExportMenuAnchor(e.currentTarget)}
                    disabled={compareDialogFloorPlans.length === 0 || compareExportingPdf}
                  >
                    Export PDF
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      if (compareDialogSource === 'topViewing') {
                        setTopViewingFloorPlansToCompare([]);
                      } else {
                        setFloorPlansToCompare([]);
                      }
                    }}
                  >
                    Clear All
                  </Button>
                </Box>
                <Button
                  size="small"
                  fullWidth
                  variant={compareExpandedView || compareVisualizerMode === 'siteplan' ? 'contained' : 'outlined'}
                  onClick={() => {
                    if (compareVisualizerMode === 'siteplan') {
                      setCompareVisualizerMode('floorplan');
                      setCompareExpandedView(false);
                      return;
                    }
                    setCompareExpandedView((prev) => !prev);
                  }}
                >
                  {compareExpandedView || compareVisualizerMode === 'siteplan' ? 'Table View' : 'Expanded Compare'}
                </Button>
                <Button size="small" fullWidth onClick={handleCloseFloorPlanCompare} variant="contained">
                  Close
                </Button>
              </>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  gap: 1,
                  flexWrap: 'nowrap',
                  minWidth: 0,
                }}
              >
                <Box sx={{ flexShrink: 0 }}>
                  <Button
                    size="small"
                    variant={compareExpandedView || compareVisualizerMode === 'siteplan' ? 'contained' : 'outlined'}
                    onClick={() => {
                      if (compareVisualizerMode === 'siteplan') {
                        setCompareVisualizerMode('floorplan');
                        setCompareExpandedView(false);
                        return;
                      }
                      setCompareExpandedView((prev) => !prev);
                    }}
                    sx={{ whiteSpace: 'nowrap' }}
                  >
                    {compareExpandedView || compareVisualizerMode === 'siteplan' ? 'Table View' : 'Expanded Compare'}
                  </Button>
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    minWidth: 0,
                    px: 0.5,
                  }}
                >
                  {(compareExpandedView || compareVisualizerMode === 'siteplan') && (
                    <ToggleButtonGroup
                      value={compareVisualizerMode}
                      exclusive
                      onChange={(_, value) => {
                        if (value != null) handleCompareVisualizerModeChange(value);
                      }}
                      size="small"
                      sx={{
                        flexShrink: 0,
                        '& .MuiToggleButton-root': { px: 1.2, textTransform: 'none' },
                      }}
                    >
                      <ToggleButton value="floorplan">Floor Plan</ToggleButton>
                      <ToggleButton value="siteplan">Site Plan</ToggleButton>
                    </ToggleButtonGroup>
                  )}
                </Box>
                <Box
                  sx={{
                    flexShrink: 0,
                    display: 'flex',
                    flexWrap: 'nowrap',
                    gap: 1,
                    alignItems: 'center',
                  }}
                >
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={compareExportingPdf ? <CircularProgress size={14} /> : <PictureAsPdfIcon />}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={(e) => setCompareExportMenuAnchor(e.currentTarget)}
                    disabled={compareDialogFloorPlans.length === 0 || compareExportingPdf}
                    sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                  >
                    Export PDF
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      if (compareDialogSource === 'topViewing') {
                        setTopViewingFloorPlansToCompare([]);
                      } else {
                        setFloorPlansToCompare([]);
                      }
                    }}
                    sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                  >
                    Clear All
                  </Button>
                  <Button
                    size="small"
                    onClick={handleCloseFloorPlanCompare}
                    variant="contained"
                    sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                  >
                    Close
                  </Button>
                </Box>
              </Box>
            )}
          </DialogActions>
          <Menu
            anchorEl={compareExportMenuAnchor}
            open={Boolean(compareExportMenuAnchor)}
            onClose={() => setCompareExportMenuAnchor(null)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          >
            <MenuItem onClick={() => exportComparePdf('floorplan')}>Floor Plan</MenuItem>
            <MenuItem onClick={() => exportComparePdf('siteplan')}>Site Plan</MenuItem>
            <MenuItem onClick={() => exportComparePdf('both')}>Floor Plan + Site Plan</MenuItem>
          </Menu>
        </Dialog>

        {/* LLM Settings Popover */}
        <Popover
          open={Boolean(llmSettingsAnchor)}
          anchorEl={llmSettingsAnchor}
          onClose={() => setLlmSettingsAnchor(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <Box sx={{ p: 2, minWidth: 250 }}>
            <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600 }}>
              Select LLM(s) for Analysis
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
              Multiple selections allowed
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedLLMs.includes('LLM')}
                    onChange={() => handleLLMChange('LLM')}
                  />
                }
                label={
                  <Box>
                    <Typography variant="body2">LLM</Typography>
                    <Typography variant="caption" color="text.secondary">(Default)</Typography>
                  </Box>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedLLMs.includes('ChatGPT')}
                    onChange={() => handleLLMChange('ChatGPT')}
                    disabled
                  />
                }
                label={
                  <Box>
                    <Typography variant="body2">ChatGPT</Typography>
                    <Typography variant="caption" color="text.secondary">(TBC)</Typography>
                  </Box>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedLLMs.includes('DeepSeek')}
                    onChange={() => handleLLMChange('DeepSeek')}
                    disabled
                  />
                }
                label={
                  <Box>
                    <Typography variant="body2">DeepSeek</Typography>
                    <Typography variant="caption" color="text.secondary">(TBC)</Typography>
                  </Box>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedLLMs.includes('Claude')}
                    onChange={() => handleLLMChange('Claude')}
                    disabled
                  />
                }
                label={
                  <Box>
                    <Typography variant="body2">Claude</Typography>
                    <Typography variant="caption" color="text.secondary">(TBC)</Typography>
                  </Box>
                }
              />
            </FormGroup>
          </Box>
        </Popover>

        {/* Footer - Disclaimer & Powered by Transformation Office */}
        <Box
          sx={{
            mt: 6,
            pt: 3,
            borderTop: '1px solid',
            borderColor: 'divider',
            textAlign: 'center',
          }}
        >
          <Typography variant="caption" sx={{ color: 'rgba(var(--color-text-rgb), 0.5)', fontStyle: 'italic', display: 'block', mb: 1, px: 2, lineHeight: 1.6, whiteSpace: 'pre-line' }}>
            {(() => {
              const d = disclaimerTimestamp;
              const dd = String(d.getDate()).padStart(2, '0');
              const mm = String(d.getMonth() + 1).padStart(2, '0');
              const yyyy = d.getFullYear();
              const hours = d.getHours();
              const mins = String(d.getMinutes()).padStart(2, '0');
              const ampm = hours >= 12 ? 'PM' : 'AM';
              const hours12 = hours % 12 || 12;
              const asOfStr = `${dd}/${mm}/${yyyy}, ${hours12}:${mins} ${ampm}`;
              return `Disclaimer: SUPER Picker is intended solely as a research and analytical support tool to assist agents in evaluating project information.
Information and materials as of ${asOfStr}. Subject to change without prior notice. Users are advised to verify all information and confirm the latest selling price with the respective Project IC.`;
            })()}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Powered by Huttons Projects & Transformation Office
          </Typography>
        </Box>

        {/* AI Summary Report Modal */}
        <Dialog
          open={aiSummaryOpen}
          onClose={handleCloseAISummary}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              maxHeight: '95vh',
            },
          }}
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <AutoAwesomeIcon sx={{ color: 'primary.main' }} />
                <Typography variant="h6">SMART AI Summary Report</Typography>
              </Box>
              <IconButton onClick={handleCloseAISummary} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ overflow: 'auto', maxHeight: '80vh', p: 3 }}>
            {aiSummaryData && aiSummaryData.stats && (
              <Box>
                {/* Disclaimer */}
                <Alert severity="warning" sx={{ mb: 3 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    ⚠️ Disclaimer
                  </Typography>
                  <Typography variant="body2">
                    * This is just an AI generated view, and does not represent a professional advisor view. Please consult your advisor accordingly.
                  </Typography>
                </Alert>

                {/* LLM Information */}
                {aiSummaryData.stats.selectedLLMs && aiSummaryData.stats.selectedLLMs.length > 0 && (
                  <Box sx={{ mb: 3, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                      Generated by:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      {aiSummaryData.stats.selectedLLMs.map((llm: string) => (
                        <Chip
                          key={llm}
                          label={llm === 'LLM' ? 'LLM (Default)' : llm}
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      ))}
                    </Box>
                  </Box>
                )}

                {/* Header Section */}
                <Box sx={{ mb: 4, textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}>
                    Expert Market Analysis Report
                  </Typography>
                  <Typography variant="h6" color="text.secondary">
                    {aiSummaryData.stats.referenceUnit.projectName} {aiSummaryData.stats.referenceUnit.unitNumber}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5, mb: 1 }}>
                    Analysis within same project (excluding sold units)
                  </Typography>
                  <Chip
                    label={`${aiSummaryData.stats.pricePosition} TIER`}
                    color={aiSummaryData.stats.pricePosition === 'LOW' ? 'success' : aiSummaryData.stats.pricePosition === 'HIGH' ? 'error' : 'warning'}
                    sx={{ mt: 1, fontWeight: 600 }}
                  />
                </Box>

                {/* Key Statistics Cards */}
                <Grid container spacing={2} sx={{ mb: 4 }}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', textAlign: 'center', p: 2 }}>
                      <Typography variant="caption" sx={{ opacity: 0.9 }}>Price Position</Typography>
                      <Typography variant="h5" sx={{ fontWeight: 700, mt: 1 }}>
                        {aiSummaryData.stats.pricePercentile.toFixed(1)}%
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.9, mt: 0.5 }}>
                        {aiSummaryData.stats.pricePosition} Tier
                      </Typography>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ bgcolor: 'success.light', color: 'success.contrastText', textAlign: 'center', p: 2 }}>
                      <Typography variant="caption" sx={{ opacity: 0.9 }}>Less Expensive</Typography>
                      <Typography variant="h5" sx={{ fontWeight: 700, mt: 1 }}>
                        {aiSummaryData.stats.lessExpensive}
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.9, mt: 0.5 }}>
                        Units
                      </Typography>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ bgcolor: 'error.light', color: 'error.contrastText', textAlign: 'center', p: 2 }}>
                      <Typography variant="caption" sx={{ opacity: 0.9 }}>More Expensive</Typography>
                      <Typography variant="h5" sx={{ fontWeight: 700, mt: 1 }}>
                        {aiSummaryData.stats.moreExpensive}
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.9, mt: 0.5 }}>
                        Units
                      </Typography>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ bgcolor: 'info.light', color: 'info.contrastText', textAlign: 'center', p: 2 }}>
                      <Typography variant="caption" sx={{ opacity: 0.9 }}>Total Comparables</Typography>
                      <Typography variant="h5" sx={{ fontWeight: 700, mt: 1 }}>
                        {aiSummaryData.stats.totalComparables}
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.9, mt: 0.5 }}>
                        Units Analyzed
                      </Typography>
                    </Card>
                  </Grid>
                </Grid>

                {/* Spider Web Radar Chart */}
                <Card sx={{ mb: 4, p: 3 }}>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Multi-Metric Comparison (Spider Web)
                  </Typography>
                  <ResponsiveContainer width="100%" height={400}>
                    <RadarChart data={aiSummaryData.radarData}>
                      <PolarGrid />
                      <PolarAngleAxis dataKey="metric" tick={{ fill: 'text.primary' }} />
                      <PolarRadiusAxis angle={90} domain={[0, 100]} />
                      <Radar
                        name="Reference Unit"
                        dataKey="reference"
                        stroke="var(--color-chart-1)"
                        fill="var(--color-chart-1)"
                        fillOpacity={0.6}
                      />
                      <Radar
                        name="Market Median"
                        dataKey="median"
                        stroke="var(--color-chart-2)"
                        fill="var(--color-chart-2)"
                        fillOpacity={0.4}
                      />
                      <RechartsLegend />
                      <RechartsTooltip />
                    </RadarChart>
                  </ResponsiveContainer>
                </Card>

                {/* Statistical Comparison Bar Charts */}
                <Card sx={{ mb: 4, p: 3 }}>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Statistical Comparison: Low | Median | High | Reference Unit
                  </Typography>
                  <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={aiSummaryData.barData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis tickFormatter={(value) => formatCurrency(value)} />
                      <RechartsTooltip formatter={(value: number) => formatCurrency(value)} />
                      <RechartsLegend />
                      <Bar dataKey="Low" fill="var(--color-success)" name="Low" />
                      <Bar dataKey="Median" fill="var(--color-warning)" name="Median" />
                      <Bar dataKey="High" fill="var(--color-danger)" name="High" />
                      <Bar dataKey="Reference" fill="var(--color-chart-1)" name="Reference Unit" />
                    </BarChart>
                  </ResponsiveContainer>
                </Card>

                {/* Detailed Statistics Table */}
                <Card sx={{ mb: 4, p: 3 }}>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Market Statistics Summary
                  </Typography>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Metric</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600, color: 'success.main' }}>Low</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600, color: 'warning.main' }}>Median</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600, color: 'error.main' }}>High</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600, color: 'primary.main' }}>Reference Unit</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Price</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.minPrice)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.medianPrice)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.maxPrice)}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
                            {formatCurrency(aiSummaryData.stats.refPrice)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>PSF</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.minPSF)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.medianPSF)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.maxPSF)}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
                            {formatCurrency(aiSummaryData.stats.refPSF)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              Outlay
                              <Tooltip title="How outlay is calculated">
                                <IconButton
                                  size="small"
                                  onClick={(e) => setOutlayInfoAnchor(e.currentTarget)}
                                  sx={getIconButtonSx()}
                                >
                                  <HelpOutlineIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.minOutlay)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.medianOutlay)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.maxOutlay)}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
                            {formatCurrency(aiSummaryData.stats.refOutlay)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Installment</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.minInstallment)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.medianInstallment)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.maxInstallment)}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
                            {formatCurrency(aiSummaryData.stats.refInstallment)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>

                {/* Pros and Cons */}
                <Grid container spacing={3} sx={{ mb: 4 }}>
                  <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3, bgcolor: 'success.light', color: 'success.contrastText' }}>
                      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                        ✅ Strengths
                      </Typography>
                      {aiSummaryData.stats.pros.map((pro: string, idx: number) => (
                        <Typography key={idx} sx={{ mb: 1, pl: 2 }}>
                          • {pro}
                        </Typography>
                      ))}
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3, bgcolor: 'error.light', color: 'error.contrastText' }}>
                      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                        ⚠️ Considerations
                      </Typography>
                      {aiSummaryData.stats.cons.map((con: string, idx: number) => (
                        <Typography key={idx} sx={{ mb: 1, pl: 2 }}>
                          • {con}
                        </Typography>
                      ))}
                    </Card>
                  </Grid>
                </Grid>

                {/* Reference Unit and Thumbs Up Units Table */}
                <Card sx={{ mb: 4, p: 3 }}>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Reference Unit & Thumbs Up Units Comparison
                  </Typography>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Project</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Floor</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Stack</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Bedroom</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Bathroom</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Area (sqft)</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600 }}>Price</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600 }}>PSF</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600 }}>Outlay</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600 }}>Installment</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* Reference Unit Row */}
                        <TableRow sx={{ bgcolor: 'primary.light', '& .MuiTableCell-root': { color: 'primary.contrastText', fontWeight: 600 } }}>
                          <TableCell>{aiSummaryData.stats.referenceUnit.projectName}</TableCell>
                          <TableCell>
                            {parseUnitNumber(aiSummaryData.stats.referenceUnit.unitNumber).floor !== null 
                              ? parseUnitNumber(aiSummaryData.stats.referenceUnit.unitNumber).floor 
                              : '-'}
                          </TableCell>
                          <TableCell>
                            {parseUnitNumber(aiSummaryData.stats.referenceUnit.unitNumber).stack !== null 
                              ? parseUnitNumber(aiSummaryData.stats.referenceUnit.unitNumber).stack 
                              : '-'}
                          </TableCell>
                          <TableCell>{aiSummaryData.stats.referenceUnit.bedroom}</TableCell>
                          <TableCell>{aiSummaryData.stats.referenceUnit.bathroom}</TableCell>
                          <TableCell>{formatNumber(aiSummaryData.stats.referenceUnit.areaSqft)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.refPrice)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.refPSF)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.refOutlay)}</TableCell>
                          <TableCell align="right">{formatCurrency(aiSummaryData.stats.refInstallment)}</TableCell>
                        </TableRow>
                        {/* Thumbs Up Units Rows */}
                        {aiSummaryData.stats.thumbsUpUnits && aiSummaryData.stats.thumbsUpUnits.length > 0 ? (
                          aiSummaryData.stats.thumbsUpUnits.map((item: any, idx: number) => {
                            const unitParsed = parseUnitNumber(item.unit.unitNumber);
                            return (
                              <TableRow 
                                key={idx} 
                                sx={{ 
                                  bgcolor: 'success.light',
                                  '& .MuiTableCell-root': { color: 'success.contrastText' }
                                }}
                              >
                                <TableCell>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    {item.unit.projectName}
                                    <ThumbUpIcon sx={{ fontSize: 16 }} />
                                  </Box>
                                </TableCell>
                                <TableCell>{unitParsed.floor !== null ? unitParsed.floor : '-'}</TableCell>
                                <TableCell>{unitParsed.stack !== null ? unitParsed.stack : '-'}</TableCell>
                                <TableCell>{item.unit.bedroom}</TableCell>
                                <TableCell>{item.unit.bathroom}</TableCell>
                                <TableCell>{formatNumber(item.unit.areaSqft)}</TableCell>
                                <TableCell align="right">
                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                                    {formatCurrency(item.unit.price)}
                                    <ThumbUpIcon sx={{ fontSize: 16 }} />
                                  </Box>
                                </TableCell>
                                <TableCell align="right">
                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5 }}>
                                    {formatCurrency(item.unit.psf)}
                                    <ThumbUpIcon sx={{ fontSize: 16 }} />
                                  </Box>
                                </TableCell>
                                <TableCell align="right">{formatCurrency(item.unit.outlay)}</TableCell>
                                <TableCell align="right">{formatCurrency(item.unit.installment)}</TableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableRow>
                            <TableCell colSpan={10} align="center" sx={{ py: 2 }}>
                              <Typography variant="body2" color="text.secondary">
                                No thumbs up units found
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>

                {/* Thumbs Up Units Section */}
                {aiSummaryData.stats.thumbsUpUnits && aiSummaryData.stats.thumbsUpUnits.length > 0 && (
                  <Card sx={{ mb: 4, p: 3, bgcolor: 'success.light', color: 'success.contrastText' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                      <ThumbUpIcon sx={{ fontSize: 28 }} />
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Thumbs Up Units (Better Deals)
                      </Typography>
                    </Box>
                    
                    <Box sx={{ mb: 3, p: 2, bgcolor: 'rgba(var(--color-text-rgb), 0.2)', borderRadius: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                        Reference Unit Details:
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" sx={{ opacity: 0.9 }}>Unit</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {aiSummaryData.stats.referenceUnit.unitNumber}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" sx={{ opacity: 0.9 }}>Floor</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {parseUnitNumber(aiSummaryData.stats.referenceUnit.unitNumber).floor !== null 
                              ? parseUnitNumber(aiSummaryData.stats.referenceUnit.unitNumber).floor 
                              : 'N/A'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" sx={{ opacity: 0.9 }}>Size</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {formatNumber(aiSummaryData.stats.referenceUnit.areaSqft)} sqft
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" sx={{ opacity: 0.9 }}>Price</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {formatCurrency(aiSummaryData.stats.refPrice)}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" sx={{ opacity: 0.9 }}>PSF</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {formatCurrency(aiSummaryData.stats.refPSF)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    <Typography variant="body2" sx={{ mb: 2 }}>
                      The following {aiSummaryData.stats.thumbsUpUnits.length} unit(s) offer better value:
                    </Typography>

                    {aiSummaryData.stats.thumbsUpUnits.map((item: any, idx: number) => {
                      const unitParsed = parseUnitNumber(item.unit.unitNumber);
                      return (
                        <Card key={idx} sx={{ mb: 2, p: 2, bgcolor: 'rgba(var(--color-text-rgb), 0.15)' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <ThumbUpIcon sx={{ fontSize: 20 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                              {item.unit.projectName} {item.unit.unitNumber}
                            </Typography>
                          </Box>
                          <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" sx={{ opacity: 0.9 }}>Floor</Typography>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {unitParsed.floor !== null ? unitParsed.floor : 'N/A'}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" sx={{ opacity: 0.9 }}>Size</Typography>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {formatNumber(item.unit.areaSqft)} sqft
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" sx={{ opacity: 0.9 }}>Price</Typography>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {formatCurrency(item.unit.price)}
                              </Typography>
                              <Typography variant="caption" sx={{ fontSize: '0.7rem', opacity: 0.8 }}>
                                ({formatCurrency(item.priceSavings)} less)
                              </Typography>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" sx={{ opacity: 0.9 }}>PSF</Typography>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {formatCurrency(item.unit.psf)}
                              </Typography>
                              <Typography variant="caption" sx={{ fontSize: '0.7rem', opacity: 0.8 }}>
                                ({formatCurrency(item.psfSavings)} less)
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                                Why it's better: {item.reasons.join(', ')}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Card>
                      );
                    })}
                  </Card>
                )}

                {aiSummaryData.stats.thumbsUpUnits && aiSummaryData.stats.thumbsUpUnits.length === 0 && (
                  <Card sx={{ mb: 4, p: 3, bgcolor: 'action.hover' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <ThumbUpIcon sx={{ fontSize: 28, color: 'text.secondary' }} />
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Thumbs Up Units (Better Deals)
                      </Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      No units found that offer better value than the reference unit based on the criteria:
                    </Typography>
                    <Typography variant="body2" component="div" sx={{ mb: 2 }}>
                      <ul style={{ margin: 0, paddingLeft: 20 }}>
                        <li>Lower PSF AND lower price than reference</li>
                        <li>Higher floor OR bigger size than reference</li>
                      </ul>
                    </Typography>
                    <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                        Reference Unit Details:
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" color="text.secondary">Unit</Typography>
                          <Typography variant="body2">{aiSummaryData.stats.referenceUnit.unitNumber}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" color="text.secondary">Floor</Typography>
                          <Typography variant="body2">
                            {parseUnitNumber(aiSummaryData.stats.referenceUnit.unitNumber).floor !== null 
                              ? parseUnitNumber(aiSummaryData.stats.referenceUnit.unitNumber).floor 
                              : 'N/A'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" color="text.secondary">Size</Typography>
                          <Typography variant="body2">{formatNumber(aiSummaryData.stats.referenceUnit.areaSqft)} sqft</Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" color="text.secondary">Price</Typography>
                          <Typography variant="body2">{formatCurrency(aiSummaryData.stats.refPrice)}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                          <Typography variant="caption" color="text.secondary">PSF</Typography>
                          <Typography variant="body2">{formatCurrency(aiSummaryData.stats.refPSF)}</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Card>
                )}

                {/* Expert Recommendation */}
                <Card sx={{ p: 3, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    💡 Expert Recommendation
                  </Typography>
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    {aiSummaryData.stats.refPrice <= aiSummaryData.stats.medianPrice
                      ? '✅ STRONG VALUE PROPOSITION - This unit offers competitive pricing relative to the market. The below-median price point presents an attractive opportunity for value-conscious buyers.'
                      : aiSummaryData.stats.refPrice > aiSummaryData.stats.medianPrice && aiSummaryData.stats.lessExpensive > 0
                      ? '⚠️ PREMIUM PRICING - While priced above the median, this unit may offer superior location, views, or other premium features. Consider negotiating or comparing specific unit attributes.'
                      : '📊 MARKET ALIGNED - Pricing is consistent with market expectations. Evaluate based on specific preferences and unit characteristics.'}
                  </Typography>
                </Card>

                {/* Footer Disclaimer */}
                <Alert severity="warning" sx={{ mt: 4 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    ⚠️ Disclaimer
                  </Typography>
                  <Typography variant="body2">
                    * This is just an AI generated view, and does not represent a professional advisor view. Please consult your advisor accordingly.
                  </Typography>
                </Alert>

                {/* Footer */}
                <Box sx={{ mt: 3, textAlign: 'center' }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    Report generated on {new Date().toLocaleDateString('en-SG', { year: 'numeric', month: 'long', day: 'numeric' })}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                    Analysis based on {aiSummaryData.stats.totalComparables} comparable units within the same project (excluding sold units)
                  </Typography>
                </Box>
              </Box>
            )}
            {aiSummaryReport && !aiSummaryData && (() => {
              const lines = aiSummaryReport.split('\n');
              let inTable = false;
              let tableRows: string[] = [];
              
              return (
                <Box sx={{ p: 2 }}>
                  {lines.map((line, idx) => {
                    // Handle table start
                    if (line.startsWith('|') && line.includes('Metric')) {
                      inTable = true;
                      tableRows = [line];
                      return null;
                    }
                    
                    // Handle table rows
                    if (inTable && line.startsWith('|') && !line.includes('---')) {
                      tableRows.push(line);
                      return null;
                    }
                    
                    // Handle table end
                    if (inTable && (!line.startsWith('|') || line.includes('---'))) {
                      inTable = false;
                      const rowsToRender = [...tableRows];
                      tableRows = [];
                      
                      if (rowsToRender.length > 0) {
                        return (
                          <Box key={`table-${idx}`} component="table" sx={{ width: '100%', borderCollapse: 'collapse', mb: 2, mt: 1 }}>
                            <tbody>
                              {rowsToRender.map((row, rowIdx) => {
                                const cells = row.split('|').filter(c => c.trim() !== '').map(c => c.trim().replace(/\*\*/g, ''));
                                const isHeader = rowIdx === 0;
                                return (
                                  <Box key={rowIdx} component="tr" sx={{ display: 'table-row' }}>
                                    {cells.map((cell, cellIdx) => (
                                      <Box
                                        key={cellIdx}
                                        component={isHeader ? "th" : "td"}
                                        sx={{
                                          display: 'table-cell',
                                          border: '1px solid',
                                          borderColor: 'divider',
                                          padding: '10px',
                                          fontWeight: isHeader || cellIdx === 0 ? 600 : 400,
                                          backgroundColor: isHeader ? 'action.hover' : 'transparent',
                                        }}
                                      >
                                        {cell}
                                      </Box>
                                    ))}
                                  </Box>
                                );
                              })}
                            </tbody>
                          </Box>
                        );
                      }
                    }
                    
                    // Skip empty lines
                    if (line.trim() === '') {
                      return <Box key={idx} sx={{ mb: 1 }} />;
                    }
                    
                    // H1 Headers
                    if (line.startsWith('# ')) {
                      return (
                        <Typography key={idx} variant="h4" component="h1" sx={{ fontWeight: 700, color: 'primary.main', mb: 2, mt: idx === 0 ? 0 : 3 }}>
                          {line.replace('# ', '')}
                        </Typography>
                      );
                    }
                    
                    // H2 Headers
                    if (line.startsWith('## ')) {
                      return (
                        <Typography key={idx} variant="h5" component="h2" sx={{ fontWeight: 600, mb: 1.5, mt: 3, borderBottom: '2px solid', borderColor: 'divider', pb: 1 }}>
                          {line.replace('## ', '')}
                        </Typography>
                      );
                    }
                    
                    // H3 Headers
                    if (line.startsWith('### ')) {
                      return (
                        <Typography key={idx} variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1, mt: 2 }}>
                          {line.replace('### ', '')}
                        </Typography>
                      );
                    }
                    
                    // Horizontal rule
                    if (line.trim() === '---') {
                      return <Box key={idx} sx={{ borderTop: '2px solid', borderColor: 'divider', my: 2 }} />;
                    }
                    
                    // Bullet points
                    if (line.startsWith('- ')) {
                      return (
                        <Typography key={idx} component="li" sx={{ mb: 0.8, ml: 2, display: 'list-item' }}>
                          {line.replace('- ', '')}
                        </Typography>
                      );
                    }
                    
                    // Numbered list
                    if (/^\d+\./.test(line.trim())) {
                      return (
                        <Typography key={idx} component="li" sx={{ mb: 0.8, ml: 2, display: 'list-item', listStyleType: 'decimal' }}>
                          {line.replace(/^\d+\.\s*/, '')}
                        </Typography>
                      );
                    }
                    
                    // Italic footer text
                    if (line.startsWith('*')) {
                      return (
                        <Typography key={idx} variant="caption" color="text.secondary" sx={{ fontStyle: 'italic', display: 'block', mt: 2 }}>
                          {line}
                        </Typography>
                      );
                    }
                    
                    // Regular paragraph
                    return (
                      <Typography key={idx} component="p" sx={{ mb: 1.5, lineHeight: 1.7 }}>
                        {line}
                      </Typography>
                    );
                  })}
                  {/* Render any remaining table */}
                  {inTable && tableRows.length > 0 && (
                    <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse', mb: 2, mt: 1 }}>
                      <tbody>
                        {tableRows.map((row, rowIdx) => {
                          const cells = row.split('|').filter(c => c.trim() !== '').map(c => c.trim().replace(/\*\*/g, ''));
                          const isHeader = rowIdx === 0;
                          return (
                            <Box key={rowIdx} component="tr" sx={{ display: 'table-row' }}>
                              {cells.map((cell, cellIdx) => (
                                <Box
                                  key={cellIdx}
                                  component={isHeader ? "th" : "td"}
                                  sx={{
                                    display: 'table-cell',
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    padding: '10px',
                                    fontWeight: isHeader || cellIdx === 0 ? 600 : 400,
                                    backgroundColor: isHeader ? 'action.hover' : 'transparent',
                                  }}
                                >
                                  {cell}
                                </Box>
                              ))}
                            </Box>
                          );
                        })}
                      </tbody>
                    </Box>
                  )}
                </Box>
              );
            })()}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAISummary}>Close</Button>
            <Button
              variant="contained"
              onClick={async () => {
                if (aiSummaryData && referenceUnit) {
                  try {
                    console.log('Generating PDF with data:', { 
                      hasStats: !!aiSummaryData.stats,
                      hasBarData: !!aiSummaryData.barData,
                      hasRadarData: !!aiSummaryData.radarData,
                      userInfo 
                    });
                    await generatePDFReport(aiSummaryData, userInfo);
                  } catch (error) {
                    console.error('Failed to generate PDF:', error);
                    console.error('Error details:', error instanceof Error ? error.message : String(error));
                    alert(`Failed to generate PDF report: ${error instanceof Error ? error.message : 'Unknown error'}. Please check console for details.`);
                  }
                } else {
                  alert('Missing data: Please ensure AI summary data is available.');
                }
              }}
            >
              Download Report (PDF)
            </Button>
          </DialogActions>
        </Dialog>

        {/* Disclaimer Dialog */}
        <Dialog
          open={disclaimerOpen}
          onClose={() => setDisclaimerOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              bgcolor: 'var(--color-bg)',
              color: 'var(--color-text-strong)',
            },
          }}
        >
          <DialogTitle sx={{ color: 'var(--color-text-strong)', fontWeight: 600, borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)', pb: 1.5 }}>
            Disclaimer
          </DialogTitle>
          <DialogContent sx={{ pt: 2, mt: 1 }}>
            <Typography variant="body2" sx={{ color: 'var(--color-text-strong)', lineHeight: 1.8, whiteSpace: 'pre-line' }}>
              {(() => {
                const d = disclaimerTimestamp;
                const dd = String(d.getDate()).padStart(2, '0');
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const yyyy = d.getFullYear();
                const hours = d.getHours();
                const mins = String(d.getMinutes()).padStart(2, '0');
                const ampm = hours >= 12 ? 'PM' : 'AM';
                const hours12 = hours % 12 || 12;
                const asOfStr = `${dd}/${mm}/${yyyy}, ${hours12}:${mins} ${ampm}`;
                return `Disclaimer: SUPER Picker is intended solely as a research and analytical support tool to assist agents in evaluating project information.
Information and materials as of ${asOfStr}. Subject to change without prior notice. Users are advised to verify all information and confirm the latest selling price with the respective Project IC.`;
              })()}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)', px: 3, py: 1.5 }}>
            <Button onClick={() => setDisclaimerOpen(false)} sx={{ color: 'var(--color-accent)' }}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Floating Comparison Basket */}
        {/*
         * Stack the compare FAB above the Share action when it is visible.
         * Mobile and tablet reserve the bottom slot for the host app's +/-
         * control; desktop keeps the normal 24px inset. Each subsequent FAB
         * is lifted by its 56px height plus a 12px gap.
         */}
        {activeTabId !== TOP_VIEWING_SITE_PLANS_TAB && floorPlansToCompare.length > 0 && (
          <Fab
            color="primary"
            aria-label="compare units"
            onClick={handleOpenFloorPlanCompare}
            sx={{
              position: 'fixed',
              bottom: {
                xs: 56 + (compareFloatingStackIndex * 68),
                md: 24 + (compareFloatingStackIndex * 68),
              },
              right: { xs: 16, sm: 24 },
              zIndex: 1000,
              ...CART_FAB_GLOW_SX,
            }}
          >
            <Badge badgeContent={floorPlansToCompare.length} color="error">
              <ShoppingCartIcon />
            </Badge>
          </Fab>
        )}
        {activeTabId === TOP_VIEWING_SITE_PLANS_TAB && topViewingFloorPlansToCompare.length > 0 && (
          <Fab
            color="primary"
            aria-label="compare units top viewing"
            onClick={handleOpenTopViewingFloorPlanCompare}
            sx={{
              position: 'fixed',
              // Same lift as the non-tab cart above — keeps the
              // compare FAB visible above the share FAB on the
              // Top Viewing Site Plans tab.
              bottom: {
                xs: 56 + (compareFloatingStackIndex * 68),
                md: 24 + (compareFloatingStackIndex * 68),
              },
              right: { xs: 16, sm: 24 },
              zIndex: 1000,
              ...CART_FAB_GLOW_SX,
            }}
          >
            <Badge badgeContent={topViewingFloorPlansToCompare.length} color="error">
              <ShoppingCartIcon />
            </Badge>
          </Fab>
        )}

        {/* PDF Export Loading Backdrop */}
        <Backdrop
          open={exportingPdf}
          sx={{ zIndex: 9999, color: '#fff', flexDirection: 'column', gap: 2 }}
        >
          <CircularProgress color="inherit" />
          <Typography variant="h6">Generating PDF Report...</Typography>
        </Backdrop>

        {/* Price History Chart Dialog */}
        <Dialog
          open={priceChartOpen}
          onClose={handleClosePriceChart}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6">
                Price History
              </Typography>
              <IconButton onClick={handleClosePriceChart} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            {priceChartLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            ) : priceChartData && priceChartData.history.length > 0 ? (
              <Box>
                <Tabs
                  value={priceDialogTab}
                  onChange={(_, value) => {
                    setPriceDialogTab(value);
                    if (value !== 'share') setPriceChartType(value);
                  }}
                  sx={{ mb: 2 }}
                >
                  <Tab label="Price" value="price" />
                  <Tab label="PSF" value="psf" />
                  {canUsePricePromoShareTools && <Tab label="Share" value="share" />}
                </Tabs>
                {priceDialogTab === 'share' && canUsePricePromoShareTools ? (
                  (() => {
                    const history = priceChartData.history;
                    const sorted = [...history].sort(
                      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
                    );
                    const startPrice = sorted[0].price;
                    const endPrice = sorted[sorted.length - 1].price;
                    // Bare savings amount (no " OFF" suffix) — the promo designs
                    // supply the "OFF"/"SAVINGS" wording around this figure.
                    const discount = formatSavingCompact(Math.abs(startPrice - endPrice));
                    const bedroomLabel =
                      priceChartBedroom == null
                        ? 'EXCLUSIVE UNIT'
                        : priceChartBedroom === 0
                          ? 'STUDIO'
                          : `${priceChartBedroom} BEDROOM`;
                    // Standardized promo branding — shared with the Best Price Promo
                    // sheet (see promoAgentLine / PROMO_AGENCY_LINE).
                    const agentLine = promoAgentLine;
                    const agencyLine = PROMO_AGENCY_LINE;
                    const slug = (s: string) =>
                      (s || '').replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, '').toLowerCase();
                    const fileName =
                      `price-promo-${slug(priceChartData.projectName)}-${slug(priceChartData.unitNumber)}`.replace(
                        /-+$/,
                        '',
                      ) || 'price-promo';
                    return (
                      <PricePromoShareTab
                        values={{
                          bedroomLabel,
                          promoPrice: formatCurrency(endPrice),
                          originalPrice: formatCurrency(startPrice),
                          discount,
                          agentLine,
                          agencyLine,
                        }}
                        fileName={fileName}
                      />
                    );
                  })()
                ) : (
                  <>
                {(() => {
                  const history = priceChartData.history;
                  if (history.length < 2) return null;
                  const sorted = [...history].sort(
                    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
                  );
                  const firstPoint = sorted[0];
                  const lastPoint = sorted[sorted.length - 1];
                  const isPrice = priceChartType === 'price';
                  const startValue = isPrice ? firstPoint.price : firstPoint.pricePSF;
                  const endValue = isPrice ? lastPoint.price : lastPoint.pricePSF;
                  const diff = startValue - endValue;
                  if (!startValue || diff === 0) return null;
                  const pct = (diff / startValue) * 100;
                  const isSaving = diff > 0;
                  const absDiff = Math.abs(diff);
                  const absPct = Math.abs(pct);
                  const fmtValue = (v: number) =>
                    isPrice
                      ? formatCurrency(v)
                      : `$${v.toLocaleString('en-SG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${' / sqft'}`;
                  const successRgb = 'var(--color-success-rgb, 76, 175, 80)';
                  const warningRgb = 'var(--color-warning-rgb, 255, 152, 0)';
                  const accentRgb = isSaving ? successRgb : warningRgb;
                  const accentColor = isSaving ? 'var(--color-success)' : 'var(--color-warning)';
                  return (
                    <Box
                      sx={{
                        mb: 2.5,
                        p: 2.5,
                        borderRadius: 2,
                        border: `1px solid rgba(${accentRgb}, 0.35)`,
                        background: `linear-gradient(135deg, rgba(${accentRgb}, 0.18) 0%, rgba(${accentRgb}, 0.06) 100%)`,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        flexWrap: 'wrap',
                      }}
                    >
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: `rgba(${accentRgb}, 0.2)`,
                          color: accentColor,
                          flexShrink: 0,
                        }}
                      >
                        {isSaving ? (
                          <SavingsIcon sx={{ fontSize: 32 }} />
                        ) : (
                          <TrendingUpIcon sx={{ fontSize: 32 }} />
                        )}
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        {priceChartData?.projectName && (
                          <Typography variant="subtitle2" fontWeight={700} sx={{ color: 'var(--color-text-strong)', lineHeight: 1.2, mb: 1 }}>
                            {priceChartData.projectName}{priceChartData.unitNumber ? ` - ${priceChartData.unitNumber}` : ''}
                          </Typography>
                        )}
                        <Typography
                          variant="caption"
                          sx={{
                            textTransform: 'uppercase',
                            letterSpacing: 1,
                            fontWeight: 600,
                            color: accentColor,
                            display: 'block',
                            lineHeight: 1.2,
                          }}
                        >
                          {isSaving
                            ? isPrice
                              ? 'You Save'
                              : 'PSF Reduction'
                            : isPrice
                              ? 'Price Increase'
                              : 'PSF Increase'}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap', mt: 0.5 }}>
                          <Typography
                            variant="h4"
                            sx={{ fontWeight: 700, color: accentColor, lineHeight: 1.1 }}
                          >
                            {isPrice ? formatCurrency(absDiff) : fmtValue(absDiff)}
                          </Typography>
                          <Box
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 0.5,
                              px: 1,
                              py: 0.25,
                              borderRadius: 1,
                              bgcolor: `rgba(${accentRgb}, 0.25)`,
                              color: accentColor,
                              fontWeight: 700,
                              fontSize: '0.85rem',
                            }}
                          >
                            {isSaving ? (
                              <TrendingDownIcon sx={{ fontSize: 16 }} />
                            ) : (
                              <TrendingUpIcon sx={{ fontSize: 16 }} />
                            )}
                            {absPct.toFixed(1)}%
                          </Box>
                        </Box>
                        <Typography
                          variant="body2"
                          sx={{ mt: 0.75, color: 'var(--color-text-secondary, rgba(255,255,255,0.7))' }}
                        >
                          From <strong>{fmtValue(startValue)}</strong> → <strong>{fmtValue(endValue)}</strong>
                        </Typography>
                      </Box>
                    </Box>
                  );
                })()}
                <ResponsiveContainer width="100%" height={400}>
                  {(() => {
                    const chartData = priceChartData.history.map(h => ({
                      // The OtherPrice1 "listed price" point has no real date.
                      date: h.isListedPrice
                        ? 'Listed Date'
                        : new Date(h.date).toLocaleDateString('en-SG', { month: 'short', day: 'numeric', year: 'numeric' }),
                      value: priceChartType === 'price' ? h.price : h.pricePSF,
                      fullDate: new Date(h.date),
                    }));
                    // Calculate Y-axis domain with tight padding to show trend
                    const values = chartData.map(d => d.value);
                    const minDataValue = values.length > 0 ? Math.min(...values) : 0;
                    const maxDataValue = values.length > 0 ? Math.max(...values) : 0;
                    const range = maxDataValue - minDataValue;
                    const padding = range === 0 ? Math.max(1, maxDataValue * 0.01) : range * 0.05;
                    const minValue = Math.max(0, minDataValue - padding);
                    const maxValue = maxDataValue + padding;
                    const domainRange = maxValue - minValue;
                    
                    // Calculate precision needed based on domain range
                    // Recharts typically shows ~5-7 ticks, so estimate tick interval
                    const estimatedTickCount = 5;
                    const estimatedTickInterval = domainRange / estimatedTickCount;
                    
                    // Determine decimal places needed for millions format
                    // Compare tick interval against the minimum displayed value to determine
                    // how many decimals are needed so adjacent ticks look distinct
                    let decimalsForMillions = 0;
                    if (maxValue >= 1000000) {
                        const tickIntervalInMillions = estimatedTickInterval / 1000000;
                        const minValueInMillions = minValue / 1000000;
                        // Need enough decimals so that adjacent ticks don't round to the same label
                        // e.g. ticks at 4.698M and 4.802M both round to "$5M" with 0 decimals
                        if (tickIntervalInMillions < 0.001) {
                            decimalsForMillions = 3;
                        } else if (tickIntervalInMillions < 0.01) {
                            decimalsForMillions = 3;
                        } else if (tickIntervalInMillions < 0.1) {
                            decimalsForMillions = 2;
                        } else if (tickIntervalInMillions < 0.5 || minValueInMillions % 1 > 0.05) {
                            // Range is moderate but min value is not near a whole million boundary
                            decimalsForMillions = 1;
                        } else {
                            decimalsForMillions = 0;
                        }
                    }
                    
                    // Format Y-axis labels more compactly
                    const formatYAxisLabel = (value: number) => {
                      if (priceChartType === 'price') {
                        // For price, use abbreviated format with adaptive precision
                        if (value >= 1000000) {
                          return `$${(value / 1000000).toFixed(decimalsForMillions)}M`;
                        } else if (value >= 1000) {
                          return `$${(value / 1000).toFixed(0)}K`;
                        }
                        return formatCurrency(value);
                      } else {
                        // For PSF, use shorter format with adaptive precision
                        const psfTickInterval = estimatedTickInterval;
                        let psfDecimals = 0;
                        if (psfTickInterval < 1) {
                          psfDecimals = 2;
                        } else if (psfTickInterval < 10) {
                          psfDecimals = 1;
                        }
                        return `$${value.toFixed(psfDecimals).toLocaleString()}`;
                      }
                    };
                    
                    return (
                      <LineChart 
                        data={chartData}
                        margin={{ top: 5, right: 20, left: 20, bottom: 60 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis 
                          dataKey="date" 
                          angle={-45}
                          textAnchor="end"
                          height={80}
                        />
                        <YAxis 
                          domain={[minValue, maxValue]}
                          tickFormatter={formatYAxisLabel}
                          width={80}
                        />
                        <RechartsTooltip 
                          formatter={(value: number) => formatCurrency(value)}
                          labelFormatter={(label) => `Date: ${label}`}
                        />
                        <RechartsLegend />
                        <Line 
                          type="monotone" 
                          dataKey="value" 
                          stroke={priceChartType === 'price' ? 'var(--color-info)' : 'var(--color-success)'} 
                          strokeWidth={2}
                          dot={{ r: 4 }}
                          name={priceChartType === 'price' ? 'Price' : 'PSF'}
                          isAnimationActive={false}
                        />
                      </LineChart>
                    );
                  })()}
                </ResponsiveContainer>
                  </>
                )}
              </Box>
            ) : (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                  No price history available for this unit.
                </Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClosePriceChart}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Price Promo Info Dialog */}
        <Dialog
          open={pricePromoInfoOpen}
          onClose={() => setPricePromoInfoOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6">What is Price Promo?</Typography>
              <IconButton onClick={() => setPricePromoInfoOpen(false)} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Price Promo highlights units with the biggest recent price reduction on each stack.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                It helps you spot listings that have dropped the most compared to their previous price, indicating a stronger discount.
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Note: This badge is based on the latest pricing history available and may change as prices update.
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPricePromoInfoOpen(false)} variant="contained">
              Got it
            </Button>
          </DialogActions>
        </Dialog>

        <ManageSiteMapDialog
          open={manageSiteMapOpen}
          onClose={() => setManageSiteMapOpen(false)}
          projects={projects}
          initialProjectName={manageSiteMapInitialProject}
          resolveProjectIdByName={resolveProjectIdByName}
          fetchSitePlan={fetchSitePlan}
          onCoordinatesSaved={handleSitePlanCoordinatesSaved}
        />

        {isAdminUser && (
          <AgentAchievementsDialog
            open={agentAchievementsOpen}
            onClose={() => setAgentAchievementsOpen(false)}
          />
        )}
        <AnalyticsDashboardDialog
          open={analyticsDashboardOpen}
          onClose={() => setAnalyticsDashboardOpen(false)}
        />

        {canAccessProjectEssentialsAnalytics && (
          <ProjectEssentialsAnalyticsDialog
            open={projectEssentialsAnalyticsOpen}
            onClose={() => setProjectEssentialsAnalyticsOpen(false)}
          />
        )}

        {isAdminUser && (
          <CommunicationTrackingDialog
            open={communicationTrackingOpen}
            onClose={() => setCommunicationTrackingOpen(false)}
          />
        )}

        {isAdminUser && (
          <ManageEventsDialog
            open={categorizeEventsOpen}
            onClose={() => setCategorizeEventsOpen(false)}
          />
        )}

        {isTrainingTrainer && (
          <TrainerManageEventsDialog
            open={trainerManageEventsOpen}
            onClose={() => setTrainerManageEventsOpen(false)}
          />
        )}

        {isAdminUser && (
          <ManageShareLinksDialog
            open={manageShareLinksOpen}
            onClose={() => setManageShareLinksOpen(false)}
          />
        )}

        {!isExternalUser && (
          <ManageShareLinksDialog
            open={myShareLinksOpen}
            onClose={() => setMyShareLinksOpen(false)}
            mode="mine"
          />
        )}

        {attendanceMarkState && (
          <Dialog
            open={attendanceMarkState.open}
            onClose={clearAttendanceMarkDialog}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle sx={{ fontWeight: 600 }}>
              Attendance Tracker
            </DialogTitle>
            <DialogContent dividers sx={{ py: 3 }}>
              {targetEventDetails && (
                <Box
                  sx={{
                    mb: 3,
                    p: 2,
                    borderRadius: 2,
                    bgcolor: 'action.hover',
                    border: '1px solid',
                    borderColor: 'divider',
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom sx={{ color: 'text.primary' }}>
                    {targetEventDetails.name}
                  </Typography>
                  <Stack spacing={1} sx={{ mt: 1 }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Typography variant="caption" fontWeight="bold" sx={{ color: 'text.secondary', minWidth: 60 }}>
                        Date/Time:
                      </Typography>
                      <Typography variant="caption" sx={{ color: 'text.primary' }}>
                        {formatEventDateRange(targetEventDetails.startDate, targetEventDetails.endDate)}
                      </Typography>
                    </Box>
                    {targetEventDetails.venue && (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Typography variant="caption" fontWeight="bold" sx={{ color: 'text.secondary', minWidth: 60 }}>
                          Venue:
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'text.primary' }}>
                          {targetEventDetails.venue}
                        </Typography>
                      </Box>
                    )}
                  </Stack>
                </Box>
              )}

              {attendanceMarkState.loading && (
                <Stack spacing={2} alignItems="center" justifyContent="center">
                  <CircularProgress size={40} />
                  <Typography variant="body2" color="text.secondary" align="center">
                    {targetEventDetails?.locationRequired === true
                      ? 'Verifying location and marking your attendance...'
                      : 'Marking your attendance...'}
                  </Typography>
                </Stack>
              )}

              {attendanceMarkState.error && (
                <Stack spacing={2} alignItems="center">
                  <Alert severity="error" sx={{ width: '100%' }}>
                    {attendanceMarkState.error}
                  </Alert>
                  {!attendanceMarkState.error.includes('expired') && (
                  <Button
                    variant="contained"
                    onClick={() =>
                      triggerAutoAttendance(attendanceMarkState.token, attendanceMarkState.eventId)
                    }
                    fullWidth
                  >
                    Try Again
                  </Button>
                  )}
                </Stack>
              )}

              {attendanceMarkState.successMessage && (
                <Stack spacing={2} alignItems="center">
                  <Alert severity="success" sx={{ width: '100%' }}>
                    {attendanceMarkState.successMessage}
                  </Alert>
                  <Typography variant="body2" color="text.secondary" align="center">
                    You can close this tab now.
                  </Typography>
                </Stack>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={clearAttendanceMarkDialog}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}

        <EventRegistrationDialog
          open={eventRegistrationOpen}
          onClose={() => setEventRegistrationOpen(false)}
          category="Super Picker"
          title="Super Picker Training and Registration"
          ceaNumber={userInfo?.CEANumber || getDevCea()}
          initialTab={autoOpenTrainingReviews ? 'registered' : 'all'}
          initialEventId={autoOpenTrainingEventId}
          emptyMessage="No Super Picker events available for registration."
        />

        {projectVerificationOpen && (
          <ProjectVerificationDialog
            open={projectVerificationOpen}
            onClose={() => setProjectVerificationOpen(false)}
            isAdmin={isAdminUser || isProjectDeptUser}
            initialTab={projectVerificationInitialTab}
          />
        )}

        {projectActionOpen && (
          <ProjectActionDialog
            open
            onClose={() => setProjectActionOpen(false)}
            isAdmin={projectActionAccess.isAdmin}
            leadsProjects={projectActionAccess.leadsProjects}
          />
        )}

        {canAccessCommissionStructure && commissionStructureOpen && (
          <CommissionStructureDialog
            open={commissionStructureOpen}
            onClose={() => {
              setCommissionStructureOpen(false);
              setActiveNavItem(activeTabId);
            }}
            sitePlanOrder={topViewingSitePlanOrder}
            onOpenProject={handleCommissionStructureViewProject}
            isAdmin={isAdminUser}
          />
        )}


        {manageProjectMessagesOpen && (isAdminUser || isProjectDeptUser || hasVerifiableProjects) && (
          <ManageProjectMessagesDialog
            open={manageProjectMessagesOpen}
            onClose={() => setManageProjectMessagesOpen(false)}
          />
        )}

        {myPodcastsOpen && canAccessMyVideos && (
          <MyPodcastsDialog
            open={myPodcastsOpen}
            onClose={() => setMyPodcastsOpen(false)}
            isAdmin={isAdminUser}
            isAccelerator={isAcceleratorUser}
            isVideoUploader={isVideoUploader}
          />
        )}

        {managePodcastVideosOpen && canManageVideos && (
          <ManagePodcastVideosDialog
            open={managePodcastVideosOpen}
            onClose={() => setManagePodcastVideosOpen(false)}
            isAdmin={isAdminUser}
          />
        )}

        {acceleratorGrantOpen && (
          <AcceleratorGrantAccessDialog
            open={acceleratorGrantOpen}
            onClose={() => setAcceleratorGrantOpen(false)}
          />
        )}

        {leaderVerificationOpen && (
          <LeaderVerificationDialog
            open={leaderVerificationOpen}
            onClose={() => setLeaderVerificationOpen(false)}
            isLeader={canAccessLeaderVerification}
            isAdmin={isAdminUser}
            initialTab={leaderVerificationInitialTab}
          />
        )}

        {cpdAnalyticsOpen && (
          <CpdAnalyticsDialog
            open={cpdAnalyticsOpen}
            onClose={() => setCpdAnalyticsOpen(false)}
            isAdmin={isAdminUser}
          />
        )}

        {teamCpdOpen && (
          <TeamCpdDialog
            open={teamCpdOpen}
            onClose={() => setTeamCpdOpen(false)}
            isAdmin={isAdminUser}
          />
        )}

        {leaderStatisticsOpen && (
          <LeaderStatisticsDialog
            open={leaderStatisticsOpen}
            onClose={() => setLeaderStatisticsOpen(false)}
            isAdmin={isAdminUser}
          />
        )}

        {projectHeadStatisticsOpen && (
          <ProjectHeadStatisticsDialog
            open={projectHeadStatisticsOpen}
            onClose={() => setProjectHeadStatisticsOpen(false)}
            isAdmin={isAdminUser}
          />
        )}

        {distinctiveOpen && (
          <DistinctiveDialog
            open={distinctiveOpen}
            onClose={() => setDistinctiveOpen(false)}
            user={{
              name: userInfo?.Name || '',
              mobile: userInfo?.Mobile || '',
              email: userInfo?.Email || '',
              cea: userInfo?.CEANumber || '',
            }}
            values={{
              // Standardized branding:
              //   line 1: <agent name> · <CEA> · <mobile>
              //   line 2: Huttons Asia Pte Ltd · L3008899K
              // Missing fields drop out cleanly rather than leaving " ·  · " gaps.
              // NB: the Price Promo share footer uses a labelled variant of line 1
              // ("Name: … · CEA Registration Number: … · Contact Number: …").
              agentLine: [
                userInfo?.Name,
                userInfo?.CEANumber,
                userInfo?.Mobile || userInfo?.Email,
              ]
                .map((part) => (part || '').trim())
                .filter(Boolean)
                .join(' · '),
              agencyLine: 'Huttons Asia Pte Ltd · L3008899K',
            }}
          />
        )}

        {canManageConnectorSchedule && (
          <ManageConnectorScheduleDialog
            open={manageConnectorScheduleOpen}
            onClose={() => setManageConnectorScheduleOpen(false)}
          />
        )}

        <LiveQueuePill summary={liveQueueProjectName ? liveQueueSummary : null} />

        {/*
          Share FAB — context-aware. Resolves to:
            - PICKER_PROJECT_DETAILS (with `projectDetails.id`) when an agent has
              drilled into a project from the Site Plans tab.
            - PICKER_SITE_PLANS on the Site Plans index.
            - PICKER_PROJECT_RESEARCH on the Project Research tab.
            - hidden on Find Comparable / Success Closer / client tabs.
          See `ShareExternalUserFab` for the dialog behaviour.
        */}
        {(() => {
          // Share FAB is admin-only for now.
          if (!isAdminUser) return null;
          if (activeTabId === TOP_VIEWING_SITE_PLANS_TAB) {
            if (selectedTopViewingSitePlan && projectDetails?.id) {
              return (
                <ShareExternalUserFab
                  module="PICKER_PROJECT_DETAILS"
                  projectId={projectDetails.id}
                  subjectLabel={projectDetails.name || selectedTopViewingSitePlan}
                />
              );
            }
            return <ShareExternalUserFab module="PICKER_SITE_PLANS" subjectLabel="Site Plans" />;
          }
          if (activeTabId === 'master') {
            return <ShareExternalUserFab module="PICKER_PROJECT_RESEARCH" subjectLabel="Project Research" />;
          }
          return null;
        })()}

        {/* Super Picker AI assistant — admins only (requireSuperPickerChatAccess
            enforces the same rule server-side). Sits above the compare + share
            FABs. Result cards deep-link into the same project detail page as
            Map Research. */}
        {isAdminUser && (
          <SuperPickerChatFab
            stackIndex={chatFloatingStackIndex}
            onOpenProject={(projectId) => { void handleMapResearchViewProject(projectId); }}
          />
        )}

          </Container>
        </Box>
      </Box>
    </Box>
  );
}
